// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/eduvibe-font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/remixicon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/animation.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/slicktheme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg/breadcrumb-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bg/home-one-testimonial.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/bg/home-one-instructor.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/bg/home-one-blog.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/bg/home-two-about-us.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/bg/home-two-events.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/bg/home-two-testimonial.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/bg/home-two-blog.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/bg/home-three-course.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/bg/video-home-3-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/bg/home-three-testimonial.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/bg/home-three-newsletter.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/bg/home-four-courses.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/bg/home-four-video.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/bg/home-four-instructor.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/bg/home-four-blog.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/bg/404.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/bg/coming-soon.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/bg/home-five-courses.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/bg/home-five-hiw.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/bg/home-five-blog.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/bg/about-us-one-team.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/bg/about-us-two-team-team.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/team/border-shape.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/bg/home-one-service.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/bg/about-us-two-service.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/shape/arrow-down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/shape/arrow-top.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/icons/arrow-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/bg/home-two-cta.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/bg/newsletter-home-4-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/shapes/mask-shape-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../images/bg/about-us-two-countdown.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/shape/shape-57.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../images/bg/pricing-plan.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../images/bg/bg-image-28.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/bg/home-one-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../images/bg/home-two-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/bg/home-three-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/bg/home-four-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/bg/home-five-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/bg/landing-page-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/bg/landing-page-courses.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/bg/landing-page-innerpages.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/flashcards.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**************************************
    Default Styles
***************************************/
/*-- Variables --*/
:root {
  --color-primary: rgb(60, 93, 173);
  --color-secondary: #f86f03;
  --color-secondary-alt: #fff6f4;
  --color-tertiary: #ffa41b;
  --color-tertiary-2: #7152e9;
  --color-dark: #231f40;
  --color-body: #6f6b80;
  --color-heading: #231f40;
  --color-white: #ffffff;
  --color-shape: #eeeeee;
  --color-shade: #f5f5f5;
  --color-border: #eeeeee;
  --color-black: #000000;
  --color-blackest: #0f0f11;
  --color-extra01: #666666;
  --color-extra02: #606770;
  --color-extra03: #fbfbfd;
  --color-extra04: #1a1a1a;
  --color-extra05: #242424;
  --color-extra06: #dbf1c0;
  --color-extra07: #c6ece8;
  --color-extra08: #c3ecce;
  --color-success: #3eb75e;
  --color-danger: #ff0003;
  --color-warning: #ff8f3c;
  --color-info: #1ba2db;
  --color-facebook: #3b5997;
  --color-twitter: #1ba1f2;
  --color-youtube: #ed4141;
  --color-linkedin: #0077b5;
  --color-pinterest: #e60022;
  --color-instagram: #c231a1;
  --color-vimeo: #00adef;
  --color-twitch: #6441a3;
  --color-discord: #7289da;
  --border-width: 2px;
  --radius-small: 5px;
  --radius: 10px;
  --radius-big: 16px;
  --p-light: 300;
  --p-regular: 400;
  --p-medium: 500;
  --p-semi-bold: 600;
  --p-bold: 700;
  --p-extra-bold: 800;
  --p-black: 900;
  --shadow-primary: 0px 8px 30px rgba(0, 0, 0, 0.04);
  --shadow-light: 1px 1px 6px rgba(0, 0, 0, 0.25);
  --shadow-lighter: 4px 4px 20px 20px rgba(0, 0, 0, 0.01);
  --transition: 0.3s;
  --transition-transform: transform 0.65s cubic-bezier(0.23, 1, 0.32, 1);
  --font-size-b1: 18px;
  --font-size-b2: 16px;
  --font-size-b3: 14px;
  --font-size-b4: 12px;
  --line-height-b1: 1.67;
  --line-height-b2: 1.63;
  --line-height-b3: 1.6;
  --line-height-b4: 1.3;
  --h1: 72px;
  --h2: 68px;
  --h3: 40px;
  --h4: 32px;
  --h5: 24px;
  --h6: 20px;
  --h1-lineHeight: 1.25;
  --h2-lineHeight: 1.24;
  --h3-lineHeight: 1.4;
  --h4-lineHeight: 1.38;
  --h5-lineHeight: 1.5;
  --h6-lineHeight: 1.6;
}

/**
 * Reset Styels
 */
* {
  box-sizing: border-box;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden] {
  display: none;
}

a {
  color: var(--color-heading);
  text-decoration: none;
  outline: none;
}

a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
  color: var(--color-primary);
}

a:focus {
  outline: none;
}

address {
  margin: 0 0 24px;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

mark {
  background: var(--color-primary);
  color: #ffffff;
}

code,
kbd,
pre,
samp {
  font-size: var(--font-size-b3);
  hyphens: none;
  color: var(--color-primary);
}

kbd,
ins {
  color: #ffffff;
}

pre,
pre.wp-block-code {
  font-size: 15px !important;
  margin: 40px 0 !important;
  overflow: auto;
  padding: 20px !important;
  white-space: pre !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  color: var(--color-body) !important;
  background: var(--color-light);
  border-radius: 4px;
}

small {
  font-size: smaller;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

dl {
  margin-top: 0;
  margin-bottom: 10px;
}

dd {
  margin: 0 15px 15px;
}

dt {
  font-weight: bold;
  color: var(--color-heading);
}

menu,
ol,
ul {
  margin: 16px 0;
  padding: 0 0 0 40px;
}

nav ul,
nav ol {
  list-style: none;
  list-style-image: none;
}

li > ul,
li > ol {
  margin: 0;
}

ol ul {
  margin-bottom: 0;
}

img {
  -ms-interpolation-mode: bicubic;
  border: 0;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

form {
  margin: 0;
}

fieldset {
  border: 1px solid var(--color-border);
  margin: 0 2px;
  min-width: inherit;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
  white-space: normal;
}

button,
input,
select,
textarea {
  font-size: 100%;
  margin: 0;
  max-width: 100%;
  vertical-align: baseline;
}

button,
input {
  line-height: normal;
}

button,
html input[type=button],
input[type=reset],
input[type=submit] {
  appearance: button;
  cursor: pointer;
}

button[disabled],
input[disabled] {
  cursor: default;
}

input[type=checkbox],
input[type=radio] {
  padding: 0;
}

input[type=search] {
  appearance: textfield;
  appearance: textfield;
  padding-right: 2px;
  width: 270px;
}

input[type=search]::-webkit-search-decoration {
  appearance: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
}

caption,
th,
td {
  font-weight: normal;
}

table thead th {
  font-weight: 700;
}

td,
.wp-block-calendar tfoot td {
  border: 1px solid var(--color-border);
  padding: 7px 10px;
}

del {
  color: #333;
}

ins {
  background: rgba(56, 88, 246, 0.6);
  text-decoration: none;
  padding: 0 5px;
}

hr {
  background-size: 4px 4px;
  border: 0;
  height: 1px;
  margin: 0 0 24px;
  opacity: 0.6;
}

table a,
table a:link,
table a:visited {
  text-decoration: underline;
}

dt {
  font-weight: bold;
  margin-bottom: 10px;
}

dd {
  margin: 0 15px 15px;
}

caption {
  caption-side: top;
}

kbd {
  background: var(--heading-color);
}

dfn,
cite,
em {
  font-style: italic;
}

/* BlockQuote  */
blockquote,
q {
  hyphens: none;
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

blockquote {
  font-size: var(--font-size-b1);
  font-style: italic;
  font-weight: var(--p-light);
  margin: 24px 40px;
}

blockquote blockquote {
  margin-right: 0;
}

blockquote cite,
blockquote small {
  font-size: var(--font-size-b3);
  font-weight: normal;
}

blockquote strong,
blockquote b {
  font-weight: 700;
}

/**
 * Typography
 */
* {
  box-sizing: border-box;
}

html {
  margin: 0;
  padding: 0;
  font-size: 10px;
}

body {
  overflow-x: hidden;
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-body);
  font-weight: 500;
  background-color: var(--color-white);
  margin: 0;
  padding: 0;
}
body.modal-open {
  padding: 0 !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
address,
p,
pre,
blockquote,
menu,
ol,
ul,
table,
hr {
  margin: 0;
  margin-bottom: 20px;
}

.display-one {
  font-size: 112px;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  word-break: break-word;
  line-height: 1.4074;
  color: var(--color-heading);
}

h1,
.h1 {
  font-size: var(--h1);
  line-height: var(--h1-lineHeight);
}

h2,
.h2 {
  font-size: var(--h2);
  line-height: var(--h2-lineHeight);
}

h3,
.h3 {
  font-size: var(--h3);
  line-height: var(--h3-lineHeight);
}

h4,
.h4 {
  font-size: var(--h4);
  line-height: var(--h4-lineHeight);
}

h5,
.h5 {
  font-size: var(--h5);
  line-height: var(--h5-lineHeight);
}

h6,
.h6 {
  font-size: var(--h6);
  line-height: var(--h6-lineHeight);
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a,
.h1 a,
.h2 a,
.h3 a,
.h4 a,
.h5 a,
.h6 a {
  color: inherit;
  transition: 0.5s;
}

a {
  color: var(--color-heading);
  transition: 0.3s;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  h1,
  .h1 {
    font-size: 38px;
  }
  h2,
  .h2 {
    font-size: 32px;
  }
  h3,
  .h3 {
    font-size: 28px;
  }
  h4,
  .h4 {
    font-size: 24px;
  }
}
@media only screen and (max-width: 767px) {
  h1,
  .h1 {
    font-size: 34px;
  }
  h2,
  .h2 {
    font-size: 28px;
  }
  h3,
  .h3 {
    font-size: 24px;
  }
  h4,
  .h4 {
    font-size: 20px;
  }
}
h1,
.h1,
h2,
.h2,
h3,
.h3 {
  font-weight: var(--p-extra-bold);
}

h4,
.h4 {
  font-weight: var(--p-bold);
}

h5,
.h5 {
  font-weight: var(--p-bold);
}

h6,
.h6 {
  font-weight: var(--p-bold);
}

p {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  font-weight: 500;
  color: var(--color-body);
  margin: 0 0 30px;
}
@media only screen and (max-width: 767px) {
  p {
    margin: 0 0 20px;
    font-size: var(--font-size-b2);
    line-height: var(--line-height-b2);
  }
}
p.has-large-font-size {
  line-height: 1.5;
  font-size: 36px;
}
p.has-medium-font-size {
  font-size: 24px;
  line-height: 36px;
}
p.has-small-font-size {
  font-size: 13px;
}
p.has-very-light-gray-color {
  color: var(--color-white);
}
p.has-background {
  padding: 20px 30px;
}
p.b1 {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
}
p.b2 {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
}
p.b3 {
  font-size: var(--font-size-b3);
  line-height: var(--line-height-b3);
}
p.b4 {
  font-size: var(--font-size-b4);
  line-height: var(--line-height-b4);
}

.b1 {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
}

.b2 {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
}

.b3 {
  font-size: var(--font-size-b3);
  line-height: var(--line-height-b3);
}

.b4 {
  font-size: var(--font-size-b4);
  line-height: var(--line-height-b4);
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 0 40px;
  width: 100%;
}

table a,
table a:link,
table a:visited {
  text-decoration: none;
}

cite,
.wp-block-pullquote cite,
.wp-block-pullquote.is-style-solid-color blockquote cite,
.wp-block-quote cite {
  color: var(--color-heading);
}

/*---------------------------
	List Style 
---------------------------*/
ul,
ol {
  padding-left: 18px;
}

ul {
  list-style: square;
  margin-bottom: 30px;
  padding-left: 20px;
}
ul.liststyle.bullet li {
  font-size: 18px;
  line-height: 30px;
  color: var(--color-body);
  position: relative;
  padding-left: 30px;
}
@media only screen and (max-width: 767px) {
  ul.liststyle.bullet li {
    padding-left: 19px;
  }
}
ul.liststyle.bullet li::before {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: var(--color-body);
  left: 0;
  top: 10px;
}
ul.liststyle.bullet li + li {
  margin-top: 8px;
}
ul li {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  margin-top: 10px;
  margin-bottom: 10px;
  color: var(--color-body);
  font-weight: 500;
}
ul li a {
  text-decoration: none;
  color: var(--color-body);
}
ul li a:hover {
  color: var(--color-primary);
}
ul ul {
  margin-bottom: 0;
}

ol {
  margin-bottom: 30px;
}
ol li {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  color: var(--color-gray);
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 400;
}
ol li a {
  color: var(--heading-color);
  text-decoration: none;
}
ol li a:hover {
  color: var(--color-primary);
}
ol ul {
  padding-left: 30px;
}

hr {
  display: block;
  height: 0;
  margin: 15px 0;
  border-top: 1px solid var(--color-border);
  background: transparent;
}

kbd {
  background: var(--color-primary);
}

/*=====================
All Extend Here
=======================*/
.color-primary {
  color: var(--color-primary) !important;
}

.color-secondary {
  color: var(--color-secondary) !important;
}

.color-tertiary {
  color: var(--color-tertiary) !important;
}

.color-heading {
  color: var(--color-heading) !important;
}

.color-body {
  color: var(--color-body) !important;
}

.color-dark {
  color: var(--color-dark) !important;
}

[data-overlay]:before {
  background: var(--color-primary);
}

/* Radius */
.radius, .post-scale {
  border-radius: var(--radius);
}

.radius-big {
  border-radius: var(--radius-big);
}

/* Font Weight */
.w-300 {
  font-weight: 300 !important;
}

.w-400 {
  font-weight: 400 !important;
}

.w-500 {
  font-weight: 500 !important;
}

.w-600 {
  font-weight: 600 !important;
}

.w-700 {
  font-weight: 700 !important;
}

.w-800 {
  font-weight: 800 !important;
}

.w-900 {
  font-weight: 900 !important;
}

/* Shadows */
.shadow-primary {
  box-shadow: var(--shadow-primary);
}

.shadow-light {
  box-shadow: var(--shadow-light);
}

.shadow-lighter {
  box-shadow: var(--shadow-lighter);
}

/*=============== Style Css =============*/
.footer-style-default .information-list, .cart-summary .cart-summary-inner, .edu-product-details-style .content .product-feature, .eduvibe-widget-details .widget-content ul, .banner-style-4 .social-text-share, .column-gallery, .list-style-2, .list-style-1, .blog-main-content .gallery, .edu-blog-widget-2.widget-categories .category-list, .edu-blog-widget.widget-categories .category-list, .blog-meta, .brand-list, .product .inner .thumbnail .product-hover-info ul, .pricing-table .pricing-body .list-item, .pricing-billing-duration ul, .edu-accordion-02 .edu-accordion-body ul, .edu-event .event-meta, .edu-rating.rating-default .rating {
  padding: 0;
  margin: 0;
  list-style: none;
}

.mainmenu-nav .mainmenu li.has-droupdown .submenu li a, .form-group textarea, .form-group input, #scrollUp, ul li a, ol li a {
  transition: var(--transition);
}

.bg-image, .bgImagePosition {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

/*----------------------
    Animation Css  
-----------------------*/
.post-scale {
  overflow: hidden;
}
.post-scale img {
  transition: 0.5s;
}
.post-scale:hover img {
  transform: scale(1.1);
}

@keyframes line1 {
  0% {
    opacity: 1;
    bottom: 0;
  }
  30% {
    bottom: 30%;
  }
  50% {
    bottom: 50%;
  }
  70% {
    bottom: 70%;
  }
  100% {
    bottom: 100%;
    opacity: 0.5;
  }
}
@keyframes bounceSlide {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
.bounce-slide {
  animation-duration: 4s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-name: bounceSlide;
}

@keyframes line5 {
  0% {
    opacity: 1;
    bottom: 400px;
  }
  50% {
    bottom: 50%;
  }
  100% {
    bottom: 100%;
    opacity: 0.5;
  }
}
@keyframes line2 {
  0% {
    opacity: 1;
    top: 0;
  }
  30% {
    bottom: 30%;
  }
  50% {
    bottom: 50%;
  }
  70% {
    bottom: 70%;
  }
  100% {
    top: 100%;
    opacity: 0.5;
  }
}
@keyframes line3 {
  0% {
    opacity: 1;
    top: 500px;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 100%;
    opacity: 0.5;
  }
}
@keyframes line4 {
  0% {
    opacity: 1;
    top: 300px;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 100%;
    opacity: 0.5;
  }
}
@keyframes customOne {
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  to {
    transform: scale(1);
  }
}
@keyframes customTwo {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(100px, 0px);
  }
  100% {
    transform: translate(50px, 50px);
  }
}
.customOne {
  animation: customOne 2s infinite;
}

/* ------------------------
    Custom Animation 01 
----------------------------*/
@keyframes headerSlideDown {
  0% {
    margin-top: -100px;
  }
  to {
    margin-top: 0;
  }
}
/*------------------------
	slidefadeinup
--------------------------*/
@keyframes slideFadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 20%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.slideFadeInUp {
  animation-name: slideFadeInUp;
}

/* -----------------------------------
    Custom Animation For All Page
---------------------------------------*/
@keyframes moveVertical {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*--------------------------------
Scroll Down Button Animation  
----------------------------------*/
@keyframes scrollDown {
  0% {
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(10px);
    opacity: 0;
  }
}
/*==============================
 *  Utilities
=================================*/
/*------------------------------------- 

font-family: 'Urbanist', sans-serif;

--------------------------------------*/
@media only screen and (max-width: 767px) {
  .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    padding-right: 15px;
    padding-left: 15px;
  }
}

iframe {
  width: 100%;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

.fix {
  overflow: hidden;
}

.slick-initialized .slick-slide {
  margin-bottom: 0;
}

.edu-line-separator {
  position: relative;
}
.edu-line-separator::after {
  position: absolute;
  content: "";
  background: #EBE7E5;
  width: 1170px;
  height: 1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media only screen and (max-width: 1199px) {
  .edu-line-separator::after {
    width: 100%;
  }
}

/*===============================
    Background Color 
=================================*/
.bg-color-primary {
  background-color: var(--color-primary);
}

.bg-color-secondary {
  background-color: var(--color-secondary);
}

.bg-color-secondary-alt {
  background-color: var(--color-secondary-alt);
}

.bg-color-tertiary {
  background-color: var(--color-tertiary);
}

.bg-color-grey {
  background-color: #F0F2F5;
}

.bg-color-white {
  background-color: #FFFFFF;
}

.bg-color-black {
  background-color: #1A1A1A;
}

.bg-color-grey {
  background-color: #E5E5E5;
}

.bg-color-extra03 {
  background-color: var(--color-extra03);
}

.bg-color-lessdark {
  background-color: var(--color-lessdark);
}

.bg-color-2 {
  backdrop-filter: saturate(180%) blur(8px);
  background-color: var(--color-darker);
  background-image: linear-gradient(180deg, var(--color-black), transparent);
}

/*===========================
    Background Image 
=============================*/
.bg-image_fixed {
  background-attachment: fixed !important;
}

/* Height and width */
.fullscreen {
  min-height: 100vh;
  width: 100%;
}

/*===================
Custom Row
======================*/
.row--0 {
  margin-left: 0px;
  margin-right: 0px;
}
.row--0 > [class*=col] {
  padding-left: 0px;
  padding-right: 0px;
}

.row--5 {
  margin-left: -5px;
  margin-right: -5px;
}
.row--5 > [class*=col] {
  padding-left: 5px;
  padding-right: 5px;
}

.row--10 {
  margin-left: -10px;
  margin-right: -10px;
}
.row--10 > [class*=col] {
  padding-left: 10px;
  padding-right: 10px;
}

.row--15 {
  margin-left: -15px;
  margin-right: -15px;
}
.row--15 > [class*=col] {
  padding-left: 15px;
  padding-right: 15px;
}

.row--20 {
  margin-left: -20px;
  margin-right: -20px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--20 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--20 > [class*=col], .row--20 > [class*=col-] {
  padding-left: 20px;
  padding-right: 20px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--25 {
  margin-left: -25px;
  margin-right: -25px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--25 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--25 > [class*=col], .row--25 > [class*=col-] {
  padding-left: 25px;
  padding-right: 25px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--30 {
  margin-left: -30px;
  margin-right: -30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--30 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--30 > [class*=col], .row--30 > [class*=col-] {
  padding-left: 30px;
  padding-right: 30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--35 {
  margin-left: -35px;
  margin-right: -35px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--35 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--35 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--35 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--35 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--35 > [class*=col], .row--35 > [class*=col-] {
  padding-left: 35px;
  padding-right: 35px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--35 > [class*=col], .row--35 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--35 > [class*=col], .row--35 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--35 > [class*=col], .row--35 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--35 > [class*=col], .row--35 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--40 {
  margin-left: -40px;
  margin-right: -40px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--40 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--40 > [class*=col], .row--40 > [class*=col-] {
  padding-left: 40px;
  padding-right: 40px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--45 {
  margin-left: -45px;
  margin-right: -45px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--45 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--45 > [class*=col], .row--45 > [class*=col-] {
  padding-left: 45px;
  padding-right: 45px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--50 {
  margin-left: -50px;
  margin-right: -50px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--50 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--50 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--50 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--50 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--50 > [class*=col], .row--50 > [class*=col-] {
  padding-left: 50px;
  padding-right: 50px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--50 > [class*=col], .row--50 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--50 > [class*=col], .row--50 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--50 > [class*=col], .row--50 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--50 > [class*=col], .row--50 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--60 {
  margin-left: -60px;
  margin-right: -60px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--60 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--60 > [class*=col], .row--60 > [class*=col-] {
  padding-left: 60px;
  padding-right: 60px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

/*===========================
    Input Placeholder
=============================*/
input:-moz-placeholder,
textarea:-moz-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input::-moz-placeholder,
textarea::-moz-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

/*=============================
	Overlay styles 
==============================*/
[data-overlay],
[data-black-overlay],
[data-white-overlay] {
  position: relative;
}

[data-overlay] > div,
[data-overlay] > *,
[data-black-overlay] > div,
[data-black-overlay] > *,
[data-white-overlay] > div,
[data-white-overlay] > * {
  position: relative;
  z-index: 2;
}

[data-overlay]:before,
[data-black-overlay]:before,
[data-white-overlay]:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
}

[data-black-overlay]:before {
  background-color: #000000;
}

[data-white-overlay]:before {
  background-color: #ffffff;
}

[data-overlay="1"]:before,
[data-black-overlay="1"]:before,
[data-white-overlay="1"]:before {
  opacity: 0.1;
}

[data-overlay="2"]:before,
[data-black-overlay="2"]:before,
[data-white-overlay="2"]:before {
  opacity: 0.2;
}

[data-overlay="3"]:before,
[data-black-overlay="3"]:before,
[data-white-overlay="3"]:before {
  opacity: 0.3;
}

[data-overlay="4"]:before,
[data-black-overlay="4"]:before,
[data-white-overlay="4"]:before {
  opacity: 0.4;
}

[data-overlay="5"]:before,
[data-black-overlay="5"]:before,
[data-white-overlay="5"]:before {
  opacity: 0.5;
}

[data-overlay="6"]:before,
[data-black-overlay="6"]:before,
[data-white-overlay="6"]:before {
  opacity: 0.6;
}

[data-overlay="7"]:before,
[data-black-overlay="7"]:before,
[data-white-overlay="7"]:before {
  opacity: 0.7;
}

[data-overlay="8"]:before,
[data-black-overlay="8"]:before,
[data-white-overlay="8"]:before {
  opacity: 0.8;
}

[data-overlay="9"]:before,
[data-black-overlay="9"]:before,
[data-white-overlay="9"]:before {
  opacity: 0.9;
}

[data-overlay="10"]:before,
[data-black-overlay="10"]:before,
[data-white-overlay="10"]:before {
  opacity: 1;
}

/*------------------------------
    Scroll Up 
--------------------------------*/
#scrollUp {
  width: 70px;
  height: 80px;
  right: 100px;
  bottom: 60px;
  text-align: center;
  z-index: 9811 !important;
  text-decoration: none;
  background: #fff;
  line-height: 80px;
  color: #757589;
  font-size: 15px;
  font-weight: 400;
  display: inline-block;
  background: #ffffff;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  #scrollUp {
    right: 20px;
    bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  #scrollUp {
    right: 20px;
    bottom: 40px;
  }
}
#scrollUp::before {
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  background: rgba(0, 2, 72, 0.1);
  content: "";
  position: absolute;
  z-index: -1;
  transform-style: preserve-3d;
  transform: rotateY(-10deg);
  filter: blur(50px);
}
#scrollUp::after {
  background: #ffffff;
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform-style: preserve-3d;
  transform: rotateY(-10deg);
}
@media only screen and (max-width: 767px) {
  #scrollUp {
    right: 20px;
    bottom: 30px;
    width: 50px;
    height: 60px;
    line-height: 60px;
  }
}
#scrollUp span.text {
  position: relative;
  display: inline-block;
  margin-top: 7px;
}
@media only screen and (max-width: 767px) {
  #scrollUp span.text {
    margin-top: 3px;
  }
}
#scrollUp span.text::after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 7px 5px;
  border-color: transparent transparent var(--color-primary) transparent;
  position: absolute;
  content: "";
  left: 50%;
  top: 21%;
  transform: translateX(-50%);
}
#scrollUp:hover span.text {
  color: var(--color-primary);
}

/*--------------------
    Contact Form 
----------------------*/
.form-message {
  margin-bottom: 0;
  text-align: center;
}
.form-message.error {
  margin-top: 20px;
  color: #f80707;
}
.form-message.success {
  margin-top: 20px;
  color: #0d8d2d;
}

/*=========================
    Section Separation 
==========================*/
.mt_dec--30 {
  margin-top: -30px;
}

.mt_dec--20 {
  margin-top: -20px;
}

.edu-section-gap {
  padding: 130px 0 !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-section-gap {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-section-gap {
    padding: 80px 0 !important;
  }
}
.edu-section-gap.slider-dots {
  padding: 130px 0 205px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-section-gap.slider-dots {
    padding: 80px 0 130px !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-section-gap.slider-dots {
    padding: 80px 0 130px !important;
  }
}

.edu-section-gapBottom {
  padding-bottom: 130px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-section-gapBottom {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-section-gapBottom {
    padding-bottom: 80px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pb--165,
  .pb--85 {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .pb--165,
  .pb--85 {
    padding-bottom: 80px !important;
  }
}

.edu-section-gapTop {
  padding-top: 130px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-section-gapTop {
    padding-top: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-section-gapTop {
    padding-top: 80px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ptb--120 {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .ptb--120 {
    padding: 60px 0 !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pb--165,
  .pb--120,
  .pb--85,
  .pb--165 {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .pb--165,
  .pb--120,
  .pb--85,
  .pb--165 {
    padding-bottom: 60px !important;
  }
}

@media only screen and (max-width: 767px) {
  .pb--70 {
    padding-bottom: 60px !important;
  }
}

.pl--0 {
  padding-left: 0 !important;
}

.pr--0 {
  padding-right: 0 !important;
}

.pt--0 {
  padding-top: 0 !important;
}

.pb--0 {
  padding-bottom: 0 !important;
}

.mr--0 {
  margin-right: 0 !important;
}

.ml--0 {
  margin-left: 0 !important;
}

.mt--0 {
  margin-top: 0 !important;
}

.mb--0 {
  margin-bottom: 0 !important;
}

.pt--260 {
  padding-top: 260px !important;
}

.pt--250 {
  padding-top: 250px !important;
}

.pb--240 {
  padding-bottom: 240px !important;
}

.pb--220 {
  padding-bottom: 220px !important;
}

.plr--270 {
  padding: 0 270px !important;
}

.plr--300 {
  padding: 0 300px !important;
}

.plr--340 {
  padding: 0 340px !important;
}

.ptb--300 {
  padding: 300px 0 !important;
}

.ptb--340 {
  padding: 340px 0 !important;
}

.ptb--450 {
  padding: 450px 0 !important;
}

.plr_dec--15 {
  margin: 0 -15px !important;
}

.pt--300 {
  padding-top: 300px !important;
}

.ptb--5 {
  padding: 5px 0 !important;
}

.plr--5 {
  padding: 0 5px !important;
}

.pt--5 {
  padding-top: 5px !important;
}

.pb--5 {
  padding-bottom: 5px !important;
}

.pl--5 {
  padding-left: 5px !important;
}

.pr--5 {
  padding-right: 5px !important;
}

.mt--5 {
  margin-top: 5px !important;
}

.mb--5 {
  margin-bottom: 5px !important;
}

.mr--5 {
  margin-right: 5px !important;
}

.ml--5 {
  margin-left: 5px !important;
}

.ptb--10 {
  padding: 10px 0 !important;
}

.plr--10 {
  padding: 0 10px !important;
}

.pt--10 {
  padding-top: 10px !important;
}

.pb--10 {
  padding-bottom: 10px !important;
}

.pl--10 {
  padding-left: 10px !important;
}

.pr--10 {
  padding-right: 10px !important;
}

.mt--10 {
  margin-top: 10px !important;
}

.mb--10 {
  margin-bottom: 10px !important;
}

.mr--10 {
  margin-right: 10px !important;
}

.ml--10 {
  margin-left: 10px !important;
}

.ptb--15 {
  padding: 15px 0 !important;
}

.plr--15 {
  padding: 0 15px !important;
}

.pt--15 {
  padding-top: 15px !important;
}

.pb--15 {
  padding-bottom: 15px !important;
}

.pl--15 {
  padding-left: 15px !important;
}

.pr--15 {
  padding-right: 15px !important;
}

.mt--15 {
  margin-top: 15px !important;
}

.mb--15 {
  margin-bottom: 15px !important;
}

.mr--15 {
  margin-right: 15px !important;
}

.ml--15 {
  margin-left: 15px !important;
}

.ptb--20 {
  padding: 20px 0 !important;
}

.plr--20 {
  padding: 0 20px !important;
}

.pt--20 {
  padding-top: 20px !important;
}

.pb--20 {
  padding-bottom: 20px !important;
}

.pl--20 {
  padding-left: 20px !important;
}

.pr--20 {
  padding-right: 20px !important;
}

.mt--20 {
  margin-top: 20px !important;
}

.mb--20 {
  margin-bottom: 20px !important;
}

.mr--20 {
  margin-right: 20px !important;
}

.ml--20 {
  margin-left: 20px !important;
}

.ptb--25 {
  padding: 25px 0 !important;
}

.plr--25 {
  padding: 0 25px !important;
}

.pt--25 {
  padding-top: 25px !important;
}

.pb--25 {
  padding-bottom: 25px !important;
}

.pl--25 {
  padding-left: 25px !important;
}

.pr--25 {
  padding-right: 25px !important;
}

.mt--25 {
  margin-top: 25px !important;
}

.mb--25 {
  margin-bottom: 25px !important;
}

.mr--25 {
  margin-right: 25px !important;
}

.ml--25 {
  margin-left: 25px !important;
}

.ptb--30 {
  padding: 30px 0 !important;
}

.plr--30 {
  padding: 0 30px !important;
}

.pt--30 {
  padding-top: 30px !important;
}

.pb--30 {
  padding-bottom: 30px !important;
}

.pl--30 {
  padding-left: 30px !important;
}

.pr--30 {
  padding-right: 30px !important;
}

.mt--30 {
  margin-top: 30px !important;
}

.mb--30 {
  margin-bottom: 30px !important;
}

.mr--30 {
  margin-right: 30px !important;
}

.ml--30 {
  margin-left: 30px !important;
}

.ptb--35 {
  padding: 35px 0 !important;
}

.plr--35 {
  padding: 0 35px !important;
}

.pt--35 {
  padding-top: 35px !important;
}

.pb--35 {
  padding-bottom: 35px !important;
}

.pl--35 {
  padding-left: 35px !important;
}

.pr--35 {
  padding-right: 35px !important;
}

.mt--35 {
  margin-top: 35px !important;
}

.mb--35 {
  margin-bottom: 35px !important;
}

.mr--35 {
  margin-right: 35px !important;
}

.ml--35 {
  margin-left: 35px !important;
}

.ptb--40 {
  padding: 40px 0 !important;
}

.plr--40 {
  padding: 0 40px !important;
}

.pt--40 {
  padding-top: 40px !important;
}

.pb--40 {
  padding-bottom: 40px !important;
}

.pl--40 {
  padding-left: 40px !important;
}

.pr--40 {
  padding-right: 40px !important;
}

.mt--40 {
  margin-top: 40px !important;
}

.mb--40 {
  margin-bottom: 40px !important;
}

.mr--40 {
  margin-right: 40px !important;
}

.ml--40 {
  margin-left: 40px !important;
}

.ptb--45 {
  padding: 45px 0 !important;
}

.plr--45 {
  padding: 0 45px !important;
}

.pt--45 {
  padding-top: 45px !important;
}

.pb--45 {
  padding-bottom: 45px !important;
}

.pl--45 {
  padding-left: 45px !important;
}

.pr--45 {
  padding-right: 45px !important;
}

.mt--45 {
  margin-top: 45px !important;
}

.mb--45 {
  margin-bottom: 45px !important;
}

.mr--45 {
  margin-right: 45px !important;
}

.ml--45 {
  margin-left: 45px !important;
}

.ptb--50 {
  padding: 50px 0 !important;
}

.plr--50 {
  padding: 0 50px !important;
}

.pt--50 {
  padding-top: 50px !important;
}

.pb--50 {
  padding-bottom: 50px !important;
}

.pl--50 {
  padding-left: 50px !important;
}

.pr--50 {
  padding-right: 50px !important;
}

.mt--50 {
  margin-top: 50px !important;
}

.mb--50 {
  margin-bottom: 50px !important;
}

.mr--50 {
  margin-right: 50px !important;
}

.ml--50 {
  margin-left: 50px !important;
}

.ptb--55 {
  padding: 55px 0 !important;
}

.plr--55 {
  padding: 0 55px !important;
}

.pt--55 {
  padding-top: 55px !important;
}

.pb--55 {
  padding-bottom: 55px !important;
}

.pl--55 {
  padding-left: 55px !important;
}

.pr--55 {
  padding-right: 55px !important;
}

.mt--55 {
  margin-top: 55px !important;
}

.mb--55 {
  margin-bottom: 55px !important;
}

.mr--55 {
  margin-right: 55px !important;
}

.ml--55 {
  margin-left: 55px !important;
}

.ptb--60 {
  padding: 60px 0 !important;
}

.plr--60 {
  padding: 0 60px !important;
}

.pt--60 {
  padding-top: 60px !important;
}

.pb--60 {
  padding-bottom: 60px !important;
}

.pl--60 {
  padding-left: 60px !important;
}

.pr--60 {
  padding-right: 60px !important;
}

.mt--60 {
  margin-top: 60px !important;
}

.mb--60 {
  margin-bottom: 60px !important;
}

.mr--60 {
  margin-right: 60px !important;
}

.ml--60 {
  margin-left: 60px !important;
}

.ptb--65 {
  padding: 65px 0 !important;
}

.plr--65 {
  padding: 0 65px !important;
}

.pt--65 {
  padding-top: 65px !important;
}

.pb--65 {
  padding-bottom: 65px !important;
}

.pl--65 {
  padding-left: 65px !important;
}

.pr--65 {
  padding-right: 65px !important;
}

.mt--65 {
  margin-top: 65px !important;
}

.mb--65 {
  margin-bottom: 65px !important;
}

.mr--65 {
  margin-right: 65px !important;
}

.ml--65 {
  margin-left: 65px !important;
}

.ptb--70 {
  padding: 70px 0 !important;
}

.plr--70 {
  padding: 0 70px !important;
}

.pt--70 {
  padding-top: 70px !important;
}

.pb--70 {
  padding-bottom: 70px !important;
}

.pl--70 {
  padding-left: 70px !important;
}

.pr--70 {
  padding-right: 70px !important;
}

.mt--70 {
  margin-top: 70px !important;
}

.mb--70 {
  margin-bottom: 70px !important;
}

.mr--70 {
  margin-right: 70px !important;
}

.ml--70 {
  margin-left: 70px !important;
}

.ptb--75 {
  padding: 75px 0 !important;
}

.plr--75 {
  padding: 0 75px !important;
}

.pt--75 {
  padding-top: 75px !important;
}

.pb--75 {
  padding-bottom: 75px !important;
}

.pl--75 {
  padding-left: 75px !important;
}

.pr--75 {
  padding-right: 75px !important;
}

.mt--75 {
  margin-top: 75px !important;
}

.mb--75 {
  margin-bottom: 75px !important;
}

.mr--75 {
  margin-right: 75px !important;
}

.ml--75 {
  margin-left: 75px !important;
}

.ptb--80 {
  padding: 80px 0 !important;
}

.plr--80 {
  padding: 0 80px !important;
}

.pt--80 {
  padding-top: 80px !important;
}

.pb--80 {
  padding-bottom: 80px !important;
}

.pl--80 {
  padding-left: 80px !important;
}

.pr--80 {
  padding-right: 80px !important;
}

.mt--80 {
  margin-top: 80px !important;
}

.mb--80 {
  margin-bottom: 80px !important;
}

.mr--80 {
  margin-right: 80px !important;
}

.ml--80 {
  margin-left: 80px !important;
}

.ptb--85 {
  padding: 85px 0 !important;
}

.plr--85 {
  padding: 0 85px !important;
}

.pt--85 {
  padding-top: 85px !important;
}

.pb--85 {
  padding-bottom: 85px !important;
}

.pl--85 {
  padding-left: 85px !important;
}

.pr--85 {
  padding-right: 85px !important;
}

.mt--85 {
  margin-top: 85px !important;
}

.mb--85 {
  margin-bottom: 85px !important;
}

.mr--85 {
  margin-right: 85px !important;
}

.ml--85 {
  margin-left: 85px !important;
}

.ptb--90 {
  padding: 90px 0 !important;
}

.plr--90 {
  padding: 0 90px !important;
}

.pt--90 {
  padding-top: 90px !important;
}

.pb--90 {
  padding-bottom: 90px !important;
}

.pl--90 {
  padding-left: 90px !important;
}

.pr--90 {
  padding-right: 90px !important;
}

.mt--90 {
  margin-top: 90px !important;
}

.mb--90 {
  margin-bottom: 90px !important;
}

.mr--90 {
  margin-right: 90px !important;
}

.ml--90 {
  margin-left: 90px !important;
}

.ptb--95 {
  padding: 95px 0 !important;
}

.plr--95 {
  padding: 0 95px !important;
}

.pt--95 {
  padding-top: 95px !important;
}

.pb--95 {
  padding-bottom: 95px !important;
}

.pl--95 {
  padding-left: 95px !important;
}

.pr--95 {
  padding-right: 95px !important;
}

.mt--95 {
  margin-top: 95px !important;
}

.mb--95 {
  margin-bottom: 95px !important;
}

.mr--95 {
  margin-right: 95px !important;
}

.ml--95 {
  margin-left: 95px !important;
}

.ptb--100 {
  padding: 100px 0 !important;
}

.plr--100 {
  padding: 0 100px !important;
}

.pt--100 {
  padding-top: 100px !important;
}

.pb--100 {
  padding-bottom: 100px !important;
}

.pl--100 {
  padding-left: 100px !important;
}

.pr--100 {
  padding-right: 100px !important;
}

.mt--100 {
  margin-top: 100px !important;
}

.mb--100 {
  margin-bottom: 100px !important;
}

.mr--100 {
  margin-right: 100px !important;
}

.ml--100 {
  margin-left: 100px !important;
}

.ptb--105 {
  padding: 105px 0 !important;
}

.plr--105 {
  padding: 0 105px !important;
}

.pt--105 {
  padding-top: 105px !important;
}

.pb--105 {
  padding-bottom: 105px !important;
}

.pl--105 {
  padding-left: 105px !important;
}

.pr--105 {
  padding-right: 105px !important;
}

.mt--105 {
  margin-top: 105px !important;
}

.mb--105 {
  margin-bottom: 105px !important;
}

.mr--105 {
  margin-right: 105px !important;
}

.ml--105 {
  margin-left: 105px !important;
}

.ptb--110 {
  padding: 110px 0 !important;
}

.plr--110 {
  padding: 0 110px !important;
}

.pt--110 {
  padding-top: 110px !important;
}

.pb--110 {
  padding-bottom: 110px !important;
}

.pl--110 {
  padding-left: 110px !important;
}

.pr--110 {
  padding-right: 110px !important;
}

.mt--110 {
  margin-top: 110px !important;
}

.mb--110 {
  margin-bottom: 110px !important;
}

.mr--110 {
  margin-right: 110px !important;
}

.ml--110 {
  margin-left: 110px !important;
}

.ptb--115 {
  padding: 115px 0 !important;
}

.plr--115 {
  padding: 0 115px !important;
}

.pt--115 {
  padding-top: 115px !important;
}

.pb--115 {
  padding-bottom: 115px !important;
}

.pl--115 {
  padding-left: 115px !important;
}

.pr--115 {
  padding-right: 115px !important;
}

.mt--115 {
  margin-top: 115px !important;
}

.mb--115 {
  margin-bottom: 115px !important;
}

.mr--115 {
  margin-right: 115px !important;
}

.ml--115 {
  margin-left: 115px !important;
}

.ptb--120 {
  padding: 120px 0 !important;
}

.plr--120 {
  padding: 0 120px !important;
}

.pt--120 {
  padding-top: 120px !important;
}

.pb--120 {
  padding-bottom: 120px !important;
}

.pl--120 {
  padding-left: 120px !important;
}

.pr--120 {
  padding-right: 120px !important;
}

.mt--120 {
  margin-top: 120px !important;
}

.mb--120 {
  margin-bottom: 120px !important;
}

.mr--120 {
  margin-right: 120px !important;
}

.ml--120 {
  margin-left: 120px !important;
}

.ptb--125 {
  padding: 125px 0 !important;
}

.plr--125 {
  padding: 0 125px !important;
}

.pt--125 {
  padding-top: 125px !important;
}

.pb--125 {
  padding-bottom: 125px !important;
}

.pl--125 {
  padding-left: 125px !important;
}

.pr--125 {
  padding-right: 125px !important;
}

.mt--125 {
  margin-top: 125px !important;
}

.mb--125 {
  margin-bottom: 125px !important;
}

.mr--125 {
  margin-right: 125px !important;
}

.ml--125 {
  margin-left: 125px !important;
}

.ptb--130 {
  padding: 130px 0 !important;
}

.plr--130 {
  padding: 0 130px !important;
}

.pt--130 {
  padding-top: 130px !important;
}

.pb--130 {
  padding-bottom: 130px !important;
}

.pl--130 {
  padding-left: 130px !important;
}

.pr--130 {
  padding-right: 130px !important;
}

.mt--130 {
  margin-top: 130px !important;
}

.mb--130 {
  margin-bottom: 130px !important;
}

.mr--130 {
  margin-right: 130px !important;
}

.ml--130 {
  margin-left: 130px !important;
}

.ptb--135 {
  padding: 135px 0 !important;
}

.plr--135 {
  padding: 0 135px !important;
}

.pt--135 {
  padding-top: 135px !important;
}

.pb--135 {
  padding-bottom: 135px !important;
}

.pl--135 {
  padding-left: 135px !important;
}

.pr--135 {
  padding-right: 135px !important;
}

.mt--135 {
  margin-top: 135px !important;
}

.mb--135 {
  margin-bottom: 135px !important;
}

.mr--135 {
  margin-right: 135px !important;
}

.ml--135 {
  margin-left: 135px !important;
}

.ptb--140 {
  padding: 140px 0 !important;
}

.plr--140 {
  padding: 0 140px !important;
}

.pt--140 {
  padding-top: 140px !important;
}

.pb--140 {
  padding-bottom: 140px !important;
}

.pl--140 {
  padding-left: 140px !important;
}

.pr--140 {
  padding-right: 140px !important;
}

.mt--140 {
  margin-top: 140px !important;
}

.mb--140 {
  margin-bottom: 140px !important;
}

.mr--140 {
  margin-right: 140px !important;
}

.ml--140 {
  margin-left: 140px !important;
}

.ptb--145 {
  padding: 145px 0 !important;
}

.plr--145 {
  padding: 0 145px !important;
}

.pt--145 {
  padding-top: 145px !important;
}

.pb--145 {
  padding-bottom: 145px !important;
}

.pl--145 {
  padding-left: 145px !important;
}

.pr--145 {
  padding-right: 145px !important;
}

.mt--145 {
  margin-top: 145px !important;
}

.mb--145 {
  margin-bottom: 145px !important;
}

.mr--145 {
  margin-right: 145px !important;
}

.ml--145 {
  margin-left: 145px !important;
}

.ptb--150 {
  padding: 150px 0 !important;
}

.plr--150 {
  padding: 0 150px !important;
}

.pt--150 {
  padding-top: 150px !important;
}

.pb--150 {
  padding-bottom: 150px !important;
}

.pl--150 {
  padding-left: 150px !important;
}

.pr--150 {
  padding-right: 150px !important;
}

.mt--150 {
  margin-top: 150px !important;
}

.mb--150 {
  margin-bottom: 150px !important;
}

.mr--150 {
  margin-right: 150px !important;
}

.ml--150 {
  margin-left: 150px !important;
}

.ptb--155 {
  padding: 155px 0 !important;
}

.plr--155 {
  padding: 0 155px !important;
}

.pt--155 {
  padding-top: 155px !important;
}

.pb--155 {
  padding-bottom: 155px !important;
}

.pl--155 {
  padding-left: 155px !important;
}

.pr--155 {
  padding-right: 155px !important;
}

.mt--155 {
  margin-top: 155px !important;
}

.mb--155 {
  margin-bottom: 155px !important;
}

.mr--155 {
  margin-right: 155px !important;
}

.ml--155 {
  margin-left: 155px !important;
}

.ptb--160 {
  padding: 160px 0 !important;
}

.plr--160 {
  padding: 0 160px !important;
}

.pt--160 {
  padding-top: 160px !important;
}

.pb--160 {
  padding-bottom: 160px !important;
}

.pl--160 {
  padding-left: 160px !important;
}

.pr--160 {
  padding-right: 160px !important;
}

.mt--160 {
  margin-top: 160px !important;
}

.mb--160 {
  margin-bottom: 160px !important;
}

.mr--160 {
  margin-right: 160px !important;
}

.ml--160 {
  margin-left: 160px !important;
}

.ptb--165 {
  padding: 165px 0 !important;
}

.plr--165 {
  padding: 0 165px !important;
}

.pt--165 {
  padding-top: 165px !important;
}

.pb--165 {
  padding-bottom: 165px !important;
}

.pl--165 {
  padding-left: 165px !important;
}

.pr--165 {
  padding-right: 165px !important;
}

.mt--165 {
  margin-top: 165px !important;
}

.mb--165 {
  margin-bottom: 165px !important;
}

.mr--165 {
  margin-right: 165px !important;
}

.ml--165 {
  margin-left: 165px !important;
}

.ptb--170 {
  padding: 170px 0 !important;
}

.plr--170 {
  padding: 0 170px !important;
}

.pt--170 {
  padding-top: 170px !important;
}

.pb--170 {
  padding-bottom: 170px !important;
}

.pl--170 {
  padding-left: 170px !important;
}

.pr--170 {
  padding-right: 170px !important;
}

.mt--170 {
  margin-top: 170px !important;
}

.mb--170 {
  margin-bottom: 170px !important;
}

.mr--170 {
  margin-right: 170px !important;
}

.ml--170 {
  margin-left: 170px !important;
}

.ptb--175 {
  padding: 175px 0 !important;
}

.plr--175 {
  padding: 0 175px !important;
}

.pt--175 {
  padding-top: 175px !important;
}

.pb--175 {
  padding-bottom: 175px !important;
}

.pl--175 {
  padding-left: 175px !important;
}

.pr--175 {
  padding-right: 175px !important;
}

.mt--175 {
  margin-top: 175px !important;
}

.mb--175 {
  margin-bottom: 175px !important;
}

.mr--175 {
  margin-right: 175px !important;
}

.ml--175 {
  margin-left: 175px !important;
}

.ptb--180 {
  padding: 180px 0 !important;
}

.plr--180 {
  padding: 0 180px !important;
}

.pt--180 {
  padding-top: 180px !important;
}

.pb--180 {
  padding-bottom: 180px !important;
}

.pl--180 {
  padding-left: 180px !important;
}

.pr--180 {
  padding-right: 180px !important;
}

.mt--180 {
  margin-top: 180px !important;
}

.mb--180 {
  margin-bottom: 180px !important;
}

.mr--180 {
  margin-right: 180px !important;
}

.ml--180 {
  margin-left: 180px !important;
}

.ptb--185 {
  padding: 185px 0 !important;
}

.plr--185 {
  padding: 0 185px !important;
}

.pt--185 {
  padding-top: 185px !important;
}

.pb--185 {
  padding-bottom: 185px !important;
}

.pl--185 {
  padding-left: 185px !important;
}

.pr--185 {
  padding-right: 185px !important;
}

.mt--185 {
  margin-top: 185px !important;
}

.mb--185 {
  margin-bottom: 185px !important;
}

.mr--185 {
  margin-right: 185px !important;
}

.ml--185 {
  margin-left: 185px !important;
}

.ptb--190 {
  padding: 190px 0 !important;
}

.plr--190 {
  padding: 0 190px !important;
}

.pt--190 {
  padding-top: 190px !important;
}

.pb--190 {
  padding-bottom: 190px !important;
}

.pl--190 {
  padding-left: 190px !important;
}

.pr--190 {
  padding-right: 190px !important;
}

.mt--190 {
  margin-top: 190px !important;
}

.mb--190 {
  margin-bottom: 190px !important;
}

.mr--190 {
  margin-right: 190px !important;
}

.ml--190 {
  margin-left: 190px !important;
}

.ptb--195 {
  padding: 195px 0 !important;
}

.plr--195 {
  padding: 0 195px !important;
}

.pt--195 {
  padding-top: 195px !important;
}

.pb--195 {
  padding-bottom: 195px !important;
}

.pl--195 {
  padding-left: 195px !important;
}

.pr--195 {
  padding-right: 195px !important;
}

.mt--195 {
  margin-top: 195px !important;
}

.mb--195 {
  margin-bottom: 195px !important;
}

.mr--195 {
  margin-right: 195px !important;
}

.ml--195 {
  margin-left: 195px !important;
}

.ptb--200 {
  padding: 200px 0 !important;
}

.plr--200 {
  padding: 0 200px !important;
}

.pt--200 {
  padding-top: 200px !important;
}

.pb--200 {
  padding-bottom: 200px !important;
}

.pl--200 {
  padding-left: 200px !important;
}

.pr--200 {
  padding-right: 200px !important;
}

.mt--200 {
  margin-top: 200px !important;
}

.mb--200 {
  margin-bottom: 200px !important;
}

.mr--200 {
  margin-right: 200px !important;
}

.ml--200 {
  margin-left: 200px !important;
}

@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .ptb_lp--5 {
    padding: 5px 0 !important;
  }
  .plr_lp--5 {
    padding: 0 5px !important;
  }
  .pt_lp--5 {
    padding-top: 5px !important;
  }
  .pb_lp--5 {
    padding-bottom: 5px !important;
  }
  .pl_lp--5 {
    padding-left: 5px !important;
  }
  .pr_lp--5 {
    padding-right: 5px !important;
  }
  .mt_lp--5 {
    margin-top: 5px !important;
  }
  .mb_lp--5 {
    margin-bottom: 5px !important;
  }
  .ptb_lp--10 {
    padding: 10px 0 !important;
  }
  .plr_lp--10 {
    padding: 0 10px !important;
  }
  .pt_lp--10 {
    padding-top: 10px !important;
  }
  .pb_lp--10 {
    padding-bottom: 10px !important;
  }
  .pl_lp--10 {
    padding-left: 10px !important;
  }
  .pr_lp--10 {
    padding-right: 10px !important;
  }
  .mt_lp--10 {
    margin-top: 10px !important;
  }
  .mb_lp--10 {
    margin-bottom: 10px !important;
  }
  .ptb_lp--15 {
    padding: 15px 0 !important;
  }
  .plr_lp--15 {
    padding: 0 15px !important;
  }
  .pt_lp--15 {
    padding-top: 15px !important;
  }
  .pb_lp--15 {
    padding-bottom: 15px !important;
  }
  .pl_lp--15 {
    padding-left: 15px !important;
  }
  .pr_lp--15 {
    padding-right: 15px !important;
  }
  .mt_lp--15 {
    margin-top: 15px !important;
  }
  .mb_lp--15 {
    margin-bottom: 15px !important;
  }
  .ptb_lp--20 {
    padding: 20px 0 !important;
  }
  .plr_lp--20 {
    padding: 0 20px !important;
  }
  .pt_lp--20 {
    padding-top: 20px !important;
  }
  .pb_lp--20 {
    padding-bottom: 20px !important;
  }
  .pl_lp--20 {
    padding-left: 20px !important;
  }
  .pr_lp--20 {
    padding-right: 20px !important;
  }
  .mt_lp--20 {
    margin-top: 20px !important;
  }
  .mb_lp--20 {
    margin-bottom: 20px !important;
  }
  .ptb_lp--25 {
    padding: 25px 0 !important;
  }
  .plr_lp--25 {
    padding: 0 25px !important;
  }
  .pt_lp--25 {
    padding-top: 25px !important;
  }
  .pb_lp--25 {
    padding-bottom: 25px !important;
  }
  .pl_lp--25 {
    padding-left: 25px !important;
  }
  .pr_lp--25 {
    padding-right: 25px !important;
  }
  .mt_lp--25 {
    margin-top: 25px !important;
  }
  .mb_lp--25 {
    margin-bottom: 25px !important;
  }
  .ptb_lp--30 {
    padding: 30px 0 !important;
  }
  .plr_lp--30 {
    padding: 0 30px !important;
  }
  .pt_lp--30 {
    padding-top: 30px !important;
  }
  .pb_lp--30 {
    padding-bottom: 30px !important;
  }
  .pl_lp--30 {
    padding-left: 30px !important;
  }
  .pr_lp--30 {
    padding-right: 30px !important;
  }
  .mt_lp--30 {
    margin-top: 30px !important;
  }
  .mb_lp--30 {
    margin-bottom: 30px !important;
  }
  .ptb_lp--35 {
    padding: 35px 0 !important;
  }
  .plr_lp--35 {
    padding: 0 35px !important;
  }
  .pt_lp--35 {
    padding-top: 35px !important;
  }
  .pb_lp--35 {
    padding-bottom: 35px !important;
  }
  .pl_lp--35 {
    padding-left: 35px !important;
  }
  .pr_lp--35 {
    padding-right: 35px !important;
  }
  .mt_lp--35 {
    margin-top: 35px !important;
  }
  .mb_lp--35 {
    margin-bottom: 35px !important;
  }
  .ptb_lp--40 {
    padding: 40px 0 !important;
  }
  .plr_lp--40 {
    padding: 0 40px !important;
  }
  .pt_lp--40 {
    padding-top: 40px !important;
  }
  .pb_lp--40 {
    padding-bottom: 40px !important;
  }
  .pl_lp--40 {
    padding-left: 40px !important;
  }
  .pr_lp--40 {
    padding-right: 40px !important;
  }
  .mt_lp--40 {
    margin-top: 40px !important;
  }
  .mb_lp--40 {
    margin-bottom: 40px !important;
  }
  .ptb_lp--45 {
    padding: 45px 0 !important;
  }
  .plr_lp--45 {
    padding: 0 45px !important;
  }
  .pt_lp--45 {
    padding-top: 45px !important;
  }
  .pb_lp--45 {
    padding-bottom: 45px !important;
  }
  .pl_lp--45 {
    padding-left: 45px !important;
  }
  .pr_lp--45 {
    padding-right: 45px !important;
  }
  .mt_lp--45 {
    margin-top: 45px !important;
  }
  .mb_lp--45 {
    margin-bottom: 45px !important;
  }
  .ptb_lp--50 {
    padding: 50px 0 !important;
  }
  .plr_lp--50 {
    padding: 0 50px !important;
  }
  .pt_lp--50 {
    padding-top: 50px !important;
  }
  .pb_lp--50 {
    padding-bottom: 50px !important;
  }
  .pl_lp--50 {
    padding-left: 50px !important;
  }
  .pr_lp--50 {
    padding-right: 50px !important;
  }
  .mt_lp--50 {
    margin-top: 50px !important;
  }
  .mb_lp--50 {
    margin-bottom: 50px !important;
  }
  .ptb_lp--55 {
    padding: 55px 0 !important;
  }
  .plr_lp--55 {
    padding: 0 55px !important;
  }
  .pt_lp--55 {
    padding-top: 55px !important;
  }
  .pb_lp--55 {
    padding-bottom: 55px !important;
  }
  .pl_lp--55 {
    padding-left: 55px !important;
  }
  .pr_lp--55 {
    padding-right: 55px !important;
  }
  .mt_lp--55 {
    margin-top: 55px !important;
  }
  .mb_lp--55 {
    margin-bottom: 55px !important;
  }
  .ptb_lp--60 {
    padding: 60px 0 !important;
  }
  .plr_lp--60 {
    padding: 0 60px !important;
  }
  .pt_lp--60 {
    padding-top: 60px !important;
  }
  .pb_lp--60 {
    padding-bottom: 60px !important;
  }
  .pl_lp--60 {
    padding-left: 60px !important;
  }
  .pr_lp--60 {
    padding-right: 60px !important;
  }
  .mt_lp--60 {
    margin-top: 60px !important;
  }
  .mb_lp--60 {
    margin-bottom: 60px !important;
  }
  .ptb_lp--65 {
    padding: 65px 0 !important;
  }
  .plr_lp--65 {
    padding: 0 65px !important;
  }
  .pt_lp--65 {
    padding-top: 65px !important;
  }
  .pb_lp--65 {
    padding-bottom: 65px !important;
  }
  .pl_lp--65 {
    padding-left: 65px !important;
  }
  .pr_lp--65 {
    padding-right: 65px !important;
  }
  .mt_lp--65 {
    margin-top: 65px !important;
  }
  .mb_lp--65 {
    margin-bottom: 65px !important;
  }
  .ptb_lp--70 {
    padding: 70px 0 !important;
  }
  .plr_lp--70 {
    padding: 0 70px !important;
  }
  .pt_lp--70 {
    padding-top: 70px !important;
  }
  .pb_lp--70 {
    padding-bottom: 70px !important;
  }
  .pl_lp--70 {
    padding-left: 70px !important;
  }
  .pr_lp--70 {
    padding-right: 70px !important;
  }
  .mt_lp--70 {
    margin-top: 70px !important;
  }
  .mb_lp--70 {
    margin-bottom: 70px !important;
  }
  .ptb_lp--75 {
    padding: 75px 0 !important;
  }
  .plr_lp--75 {
    padding: 0 75px !important;
  }
  .pt_lp--75 {
    padding-top: 75px !important;
  }
  .pb_lp--75 {
    padding-bottom: 75px !important;
  }
  .pl_lp--75 {
    padding-left: 75px !important;
  }
  .pr_lp--75 {
    padding-right: 75px !important;
  }
  .mt_lp--75 {
    margin-top: 75px !important;
  }
  .mb_lp--75 {
    margin-bottom: 75px !important;
  }
  .ptb_lp--80 {
    padding: 80px 0 !important;
  }
  .plr_lp--80 {
    padding: 0 80px !important;
  }
  .pt_lp--80 {
    padding-top: 80px !important;
  }
  .pb_lp--80 {
    padding-bottom: 80px !important;
  }
  .pl_lp--80 {
    padding-left: 80px !important;
  }
  .pr_lp--80 {
    padding-right: 80px !important;
  }
  .mt_lp--80 {
    margin-top: 80px !important;
  }
  .mb_lp--80 {
    margin-bottom: 80px !important;
  }
  .ptb_lp--85 {
    padding: 85px 0 !important;
  }
  .plr_lp--85 {
    padding: 0 85px !important;
  }
  .pt_lp--85 {
    padding-top: 85px !important;
  }
  .pb_lp--85 {
    padding-bottom: 85px !important;
  }
  .pl_lp--85 {
    padding-left: 85px !important;
  }
  .pr_lp--85 {
    padding-right: 85px !important;
  }
  .mt_lp--85 {
    margin-top: 85px !important;
  }
  .mb_lp--85 {
    margin-bottom: 85px !important;
  }
  .ptb_lp--90 {
    padding: 90px 0 !important;
  }
  .plr_lp--90 {
    padding: 0 90px !important;
  }
  .pt_lp--90 {
    padding-top: 90px !important;
  }
  .pb_lp--90 {
    padding-bottom: 90px !important;
  }
  .pl_lp--90 {
    padding-left: 90px !important;
  }
  .pr_lp--90 {
    padding-right: 90px !important;
  }
  .mt_lp--90 {
    margin-top: 90px !important;
  }
  .mb_lp--90 {
    margin-bottom: 90px !important;
  }
  .ptb_lp--95 {
    padding: 95px 0 !important;
  }
  .plr_lp--95 {
    padding: 0 95px !important;
  }
  .pt_lp--95 {
    padding-top: 95px !important;
  }
  .pb_lp--95 {
    padding-bottom: 95px !important;
  }
  .pl_lp--95 {
    padding-left: 95px !important;
  }
  .pr_lp--95 {
    padding-right: 95px !important;
  }
  .mt_lp--95 {
    margin-top: 95px !important;
  }
  .mb_lp--95 {
    margin-bottom: 95px !important;
  }
  .ptb_lp--100 {
    padding: 100px 0 !important;
  }
  .plr_lp--100 {
    padding: 0 100px !important;
  }
  .pt_lp--100 {
    padding-top: 100px !important;
  }
  .pb_lp--100 {
    padding-bottom: 100px !important;
  }
  .pl_lp--100 {
    padding-left: 100px !important;
  }
  .pr_lp--100 {
    padding-right: 100px !important;
  }
  .mt_lp--100 {
    margin-top: 100px !important;
  }
  .mb_lp--100 {
    margin-bottom: 100px !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .ptb_lg--5 {
    padding: 5px 0 !important;
  }
  .plr_lg--5 {
    padding: 0 5px !important;
  }
  .pt_lg--5 {
    padding-top: 5px !important;
  }
  .pb_lg--5 {
    padding-bottom: 5px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--5 {
    padding-right: 5px !important;
  }
  .pl_lg--5 {
    padding-left: 5px !important;
  }
  .pr_lg--5 {
    padding-right: 5px !important;
  }
  .mt_lg--5 {
    margin-top: 5px !important;
  }
  .mb_lg--5 {
    margin-bottom: 5px !important;
  }
  .ml_lg--5 {
    margin-left: 5px !important;
  }
  .ptb_lg--10 {
    padding: 10px 0 !important;
  }
  .plr_lg--10 {
    padding: 0 10px !important;
  }
  .pt_lg--10 {
    padding-top: 10px !important;
  }
  .pb_lg--10 {
    padding-bottom: 10px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--10 {
    padding-right: 10px !important;
  }
  .pl_lg--10 {
    padding-left: 10px !important;
  }
  .pr_lg--10 {
    padding-right: 10px !important;
  }
  .mt_lg--10 {
    margin-top: 10px !important;
  }
  .mb_lg--10 {
    margin-bottom: 10px !important;
  }
  .ml_lg--10 {
    margin-left: 10px !important;
  }
  .ptb_lg--15 {
    padding: 15px 0 !important;
  }
  .plr_lg--15 {
    padding: 0 15px !important;
  }
  .pt_lg--15 {
    padding-top: 15px !important;
  }
  .pb_lg--15 {
    padding-bottom: 15px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--15 {
    padding-right: 15px !important;
  }
  .pl_lg--15 {
    padding-left: 15px !important;
  }
  .pr_lg--15 {
    padding-right: 15px !important;
  }
  .mt_lg--15 {
    margin-top: 15px !important;
  }
  .mb_lg--15 {
    margin-bottom: 15px !important;
  }
  .ml_lg--15 {
    margin-left: 15px !important;
  }
  .ptb_lg--20 {
    padding: 20px 0 !important;
  }
  .plr_lg--20 {
    padding: 0 20px !important;
  }
  .pt_lg--20 {
    padding-top: 20px !important;
  }
  .pb_lg--20 {
    padding-bottom: 20px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--20 {
    padding-right: 20px !important;
  }
  .pl_lg--20 {
    padding-left: 20px !important;
  }
  .pr_lg--20 {
    padding-right: 20px !important;
  }
  .mt_lg--20 {
    margin-top: 20px !important;
  }
  .mb_lg--20 {
    margin-bottom: 20px !important;
  }
  .ml_lg--20 {
    margin-left: 20px !important;
  }
  .ptb_lg--25 {
    padding: 25px 0 !important;
  }
  .plr_lg--25 {
    padding: 0 25px !important;
  }
  .pt_lg--25 {
    padding-top: 25px !important;
  }
  .pb_lg--25 {
    padding-bottom: 25px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--25 {
    padding-right: 25px !important;
  }
  .pl_lg--25 {
    padding-left: 25px !important;
  }
  .pr_lg--25 {
    padding-right: 25px !important;
  }
  .mt_lg--25 {
    margin-top: 25px !important;
  }
  .mb_lg--25 {
    margin-bottom: 25px !important;
  }
  .ml_lg--25 {
    margin-left: 25px !important;
  }
  .ptb_lg--30 {
    padding: 30px 0 !important;
  }
  .plr_lg--30 {
    padding: 0 30px !important;
  }
  .pt_lg--30 {
    padding-top: 30px !important;
  }
  .pb_lg--30 {
    padding-bottom: 30px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--30 {
    padding-right: 30px !important;
  }
  .pl_lg--30 {
    padding-left: 30px !important;
  }
  .pr_lg--30 {
    padding-right: 30px !important;
  }
  .mt_lg--30 {
    margin-top: 30px !important;
  }
  .mb_lg--30 {
    margin-bottom: 30px !important;
  }
  .ml_lg--30 {
    margin-left: 30px !important;
  }
  .ptb_lg--35 {
    padding: 35px 0 !important;
  }
  .plr_lg--35 {
    padding: 0 35px !important;
  }
  .pt_lg--35 {
    padding-top: 35px !important;
  }
  .pb_lg--35 {
    padding-bottom: 35px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--35 {
    padding-right: 35px !important;
  }
  .pl_lg--35 {
    padding-left: 35px !important;
  }
  .pr_lg--35 {
    padding-right: 35px !important;
  }
  .mt_lg--35 {
    margin-top: 35px !important;
  }
  .mb_lg--35 {
    margin-bottom: 35px !important;
  }
  .ml_lg--35 {
    margin-left: 35px !important;
  }
  .ptb_lg--40 {
    padding: 40px 0 !important;
  }
  .plr_lg--40 {
    padding: 0 40px !important;
  }
  .pt_lg--40 {
    padding-top: 40px !important;
  }
  .pb_lg--40 {
    padding-bottom: 40px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--40 {
    padding-right: 40px !important;
  }
  .pl_lg--40 {
    padding-left: 40px !important;
  }
  .pr_lg--40 {
    padding-right: 40px !important;
  }
  .mt_lg--40 {
    margin-top: 40px !important;
  }
  .mb_lg--40 {
    margin-bottom: 40px !important;
  }
  .ml_lg--40 {
    margin-left: 40px !important;
  }
  .ptb_lg--45 {
    padding: 45px 0 !important;
  }
  .plr_lg--45 {
    padding: 0 45px !important;
  }
  .pt_lg--45 {
    padding-top: 45px !important;
  }
  .pb_lg--45 {
    padding-bottom: 45px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--45 {
    padding-right: 45px !important;
  }
  .pl_lg--45 {
    padding-left: 45px !important;
  }
  .pr_lg--45 {
    padding-right: 45px !important;
  }
  .mt_lg--45 {
    margin-top: 45px !important;
  }
  .mb_lg--45 {
    margin-bottom: 45px !important;
  }
  .ml_lg--45 {
    margin-left: 45px !important;
  }
  .ptb_lg--50 {
    padding: 50px 0 !important;
  }
  .plr_lg--50 {
    padding: 0 50px !important;
  }
  .pt_lg--50 {
    padding-top: 50px !important;
  }
  .pb_lg--50 {
    padding-bottom: 50px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--50 {
    padding-right: 50px !important;
  }
  .pl_lg--50 {
    padding-left: 50px !important;
  }
  .pr_lg--50 {
    padding-right: 50px !important;
  }
  .mt_lg--50 {
    margin-top: 50px !important;
  }
  .mb_lg--50 {
    margin-bottom: 50px !important;
  }
  .ml_lg--50 {
    margin-left: 50px !important;
  }
  .ptb_lg--55 {
    padding: 55px 0 !important;
  }
  .plr_lg--55 {
    padding: 0 55px !important;
  }
  .pt_lg--55 {
    padding-top: 55px !important;
  }
  .pb_lg--55 {
    padding-bottom: 55px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--55 {
    padding-right: 55px !important;
  }
  .pl_lg--55 {
    padding-left: 55px !important;
  }
  .pr_lg--55 {
    padding-right: 55px !important;
  }
  .mt_lg--55 {
    margin-top: 55px !important;
  }
  .mb_lg--55 {
    margin-bottom: 55px !important;
  }
  .ml_lg--55 {
    margin-left: 55px !important;
  }
  .ptb_lg--60 {
    padding: 60px 0 !important;
  }
  .plr_lg--60 {
    padding: 0 60px !important;
  }
  .pt_lg--60 {
    padding-top: 60px !important;
  }
  .pb_lg--60 {
    padding-bottom: 60px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--60 {
    padding-right: 60px !important;
  }
  .pl_lg--60 {
    padding-left: 60px !important;
  }
  .pr_lg--60 {
    padding-right: 60px !important;
  }
  .mt_lg--60 {
    margin-top: 60px !important;
  }
  .mb_lg--60 {
    margin-bottom: 60px !important;
  }
  .ml_lg--60 {
    margin-left: 60px !important;
  }
  .ptb_lg--65 {
    padding: 65px 0 !important;
  }
  .plr_lg--65 {
    padding: 0 65px !important;
  }
  .pt_lg--65 {
    padding-top: 65px !important;
  }
  .pb_lg--65 {
    padding-bottom: 65px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--65 {
    padding-right: 65px !important;
  }
  .pl_lg--65 {
    padding-left: 65px !important;
  }
  .pr_lg--65 {
    padding-right: 65px !important;
  }
  .mt_lg--65 {
    margin-top: 65px !important;
  }
  .mb_lg--65 {
    margin-bottom: 65px !important;
  }
  .ml_lg--65 {
    margin-left: 65px !important;
  }
  .ptb_lg--70 {
    padding: 70px 0 !important;
  }
  .plr_lg--70 {
    padding: 0 70px !important;
  }
  .pt_lg--70 {
    padding-top: 70px !important;
  }
  .pb_lg--70 {
    padding-bottom: 70px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--70 {
    padding-right: 70px !important;
  }
  .pl_lg--70 {
    padding-left: 70px !important;
  }
  .pr_lg--70 {
    padding-right: 70px !important;
  }
  .mt_lg--70 {
    margin-top: 70px !important;
  }
  .mb_lg--70 {
    margin-bottom: 70px !important;
  }
  .ml_lg--70 {
    margin-left: 70px !important;
  }
  .ptb_lg--75 {
    padding: 75px 0 !important;
  }
  .plr_lg--75 {
    padding: 0 75px !important;
  }
  .pt_lg--75 {
    padding-top: 75px !important;
  }
  .pb_lg--75 {
    padding-bottom: 75px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--75 {
    padding-right: 75px !important;
  }
  .pl_lg--75 {
    padding-left: 75px !important;
  }
  .pr_lg--75 {
    padding-right: 75px !important;
  }
  .mt_lg--75 {
    margin-top: 75px !important;
  }
  .mb_lg--75 {
    margin-bottom: 75px !important;
  }
  .ml_lg--75 {
    margin-left: 75px !important;
  }
  .ptb_lg--80 {
    padding: 80px 0 !important;
  }
  .plr_lg--80 {
    padding: 0 80px !important;
  }
  .pt_lg--80 {
    padding-top: 80px !important;
  }
  .pb_lg--80 {
    padding-bottom: 80px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--80 {
    padding-right: 80px !important;
  }
  .pl_lg--80 {
    padding-left: 80px !important;
  }
  .pr_lg--80 {
    padding-right: 80px !important;
  }
  .mt_lg--80 {
    margin-top: 80px !important;
  }
  .mb_lg--80 {
    margin-bottom: 80px !important;
  }
  .ml_lg--80 {
    margin-left: 80px !important;
  }
  .ptb_lg--85 {
    padding: 85px 0 !important;
  }
  .plr_lg--85 {
    padding: 0 85px !important;
  }
  .pt_lg--85 {
    padding-top: 85px !important;
  }
  .pb_lg--85 {
    padding-bottom: 85px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--85 {
    padding-right: 85px !important;
  }
  .pl_lg--85 {
    padding-left: 85px !important;
  }
  .pr_lg--85 {
    padding-right: 85px !important;
  }
  .mt_lg--85 {
    margin-top: 85px !important;
  }
  .mb_lg--85 {
    margin-bottom: 85px !important;
  }
  .ml_lg--85 {
    margin-left: 85px !important;
  }
  .ptb_lg--90 {
    padding: 90px 0 !important;
  }
  .plr_lg--90 {
    padding: 0 90px !important;
  }
  .pt_lg--90 {
    padding-top: 90px !important;
  }
  .pb_lg--90 {
    padding-bottom: 90px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--90 {
    padding-right: 90px !important;
  }
  .pl_lg--90 {
    padding-left: 90px !important;
  }
  .pr_lg--90 {
    padding-right: 90px !important;
  }
  .mt_lg--90 {
    margin-top: 90px !important;
  }
  .mb_lg--90 {
    margin-bottom: 90px !important;
  }
  .ml_lg--90 {
    margin-left: 90px !important;
  }
  .ptb_lg--95 {
    padding: 95px 0 !important;
  }
  .plr_lg--95 {
    padding: 0 95px !important;
  }
  .pt_lg--95 {
    padding-top: 95px !important;
  }
  .pb_lg--95 {
    padding-bottom: 95px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--95 {
    padding-right: 95px !important;
  }
  .pl_lg--95 {
    padding-left: 95px !important;
  }
  .pr_lg--95 {
    padding-right: 95px !important;
  }
  .mt_lg--95 {
    margin-top: 95px !important;
  }
  .mb_lg--95 {
    margin-bottom: 95px !important;
  }
  .ml_lg--95 {
    margin-left: 95px !important;
  }
  .ptb_lg--100 {
    padding: 100px 0 !important;
  }
  .plr_lg--100 {
    padding: 0 100px !important;
  }
  .pt_lg--100 {
    padding-top: 100px !important;
  }
  .pb_lg--100 {
    padding-bottom: 100px !important;
  }
  .pr_lg--0 {
    padding-right: 0 !important;
  }
  .pr_lg--100 {
    padding-right: 100px !important;
  }
  .pl_lg--100 {
    padding-left: 100px !important;
  }
  .pr_lg--100 {
    padding-right: 100px !important;
  }
  .mt_lg--100 {
    margin-top: 100px !important;
  }
  .mb_lg--100 {
    margin-bottom: 100px !important;
  }
  .ml_lg--100 {
    margin-left: 100px !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ptb_md--0 {
    padding: 0 !important;
  }
  .pl_md--0 {
    padding-left: 0 !important;
  }
  .pr_md--0 {
    padding-right: 0 !important;
  }
  .pt_md--0 {
    padding-top: 0 !important;
  }
  .pb_md--0 {
    padding-bottom: 0 !important;
  }
  .mr_md--0 {
    margin-right: 0 !important;
  }
  .ml_md--0 {
    margin-left: 0 !important;
  }
  .mt_md--0 {
    margin-top: 0 !important;
  }
  .mb_md--0 {
    margin-bottom: 0 !important;
  }
  .ptb_md--250 {
    padding: 250px 0 !important;
  }
  .ptb_md--5 {
    padding: 5px 0 !important;
  }
  .plr_md--5 {
    padding: 0 5px !important;
  }
  .pt_md--5 {
    padding-top: 5px !important;
  }
  .pb_md--5 {
    padding-bottom: 5px !important;
  }
  .pl_md--5 {
    padding-left: 5px !important;
  }
  .pr_md--5 {
    padding-right: 5px !important;
  }
  .mt_md--5 {
    margin-top: 5px !important;
  }
  .mb_md--5 {
    margin-bottom: 5px !important;
  }
  .ptb_md--10 {
    padding: 10px 0 !important;
  }
  .plr_md--10 {
    padding: 0 10px !important;
  }
  .pt_md--10 {
    padding-top: 10px !important;
  }
  .pb_md--10 {
    padding-bottom: 10px !important;
  }
  .pl_md--10 {
    padding-left: 10px !important;
  }
  .pr_md--10 {
    padding-right: 10px !important;
  }
  .mt_md--10 {
    margin-top: 10px !important;
  }
  .mb_md--10 {
    margin-bottom: 10px !important;
  }
  .ptb_md--15 {
    padding: 15px 0 !important;
  }
  .plr_md--15 {
    padding: 0 15px !important;
  }
  .pt_md--15 {
    padding-top: 15px !important;
  }
  .pb_md--15 {
    padding-bottom: 15px !important;
  }
  .pl_md--15 {
    padding-left: 15px !important;
  }
  .pr_md--15 {
    padding-right: 15px !important;
  }
  .mt_md--15 {
    margin-top: 15px !important;
  }
  .mb_md--15 {
    margin-bottom: 15px !important;
  }
  .ptb_md--20 {
    padding: 20px 0 !important;
  }
  .plr_md--20 {
    padding: 0 20px !important;
  }
  .pt_md--20 {
    padding-top: 20px !important;
  }
  .pb_md--20 {
    padding-bottom: 20px !important;
  }
  .pl_md--20 {
    padding-left: 20px !important;
  }
  .pr_md--20 {
    padding-right: 20px !important;
  }
  .mt_md--20 {
    margin-top: 20px !important;
  }
  .mb_md--20 {
    margin-bottom: 20px !important;
  }
  .ptb_md--25 {
    padding: 25px 0 !important;
  }
  .plr_md--25 {
    padding: 0 25px !important;
  }
  .pt_md--25 {
    padding-top: 25px !important;
  }
  .pb_md--25 {
    padding-bottom: 25px !important;
  }
  .pl_md--25 {
    padding-left: 25px !important;
  }
  .pr_md--25 {
    padding-right: 25px !important;
  }
  .mt_md--25 {
    margin-top: 25px !important;
  }
  .mb_md--25 {
    margin-bottom: 25px !important;
  }
  .ptb_md--30 {
    padding: 30px 0 !important;
  }
  .plr_md--30 {
    padding: 0 30px !important;
  }
  .pt_md--30 {
    padding-top: 30px !important;
  }
  .pb_md--30 {
    padding-bottom: 30px !important;
  }
  .pl_md--30 {
    padding-left: 30px !important;
  }
  .pr_md--30 {
    padding-right: 30px !important;
  }
  .mt_md--30 {
    margin-top: 30px !important;
  }
  .mb_md--30 {
    margin-bottom: 30px !important;
  }
  .ptb_md--35 {
    padding: 35px 0 !important;
  }
  .plr_md--35 {
    padding: 0 35px !important;
  }
  .pt_md--35 {
    padding-top: 35px !important;
  }
  .pb_md--35 {
    padding-bottom: 35px !important;
  }
  .pl_md--35 {
    padding-left: 35px !important;
  }
  .pr_md--35 {
    padding-right: 35px !important;
  }
  .mt_md--35 {
    margin-top: 35px !important;
  }
  .mb_md--35 {
    margin-bottom: 35px !important;
  }
  .ptb_md--40 {
    padding: 40px 0 !important;
  }
  .plr_md--40 {
    padding: 0 40px !important;
  }
  .pt_md--40 {
    padding-top: 40px !important;
  }
  .pb_md--40 {
    padding-bottom: 40px !important;
  }
  .pl_md--40 {
    padding-left: 40px !important;
  }
  .pr_md--40 {
    padding-right: 40px !important;
  }
  .mt_md--40 {
    margin-top: 40px !important;
  }
  .mb_md--40 {
    margin-bottom: 40px !important;
  }
  .ptb_md--45 {
    padding: 45px 0 !important;
  }
  .plr_md--45 {
    padding: 0 45px !important;
  }
  .pt_md--45 {
    padding-top: 45px !important;
  }
  .pb_md--45 {
    padding-bottom: 45px !important;
  }
  .pl_md--45 {
    padding-left: 45px !important;
  }
  .pr_md--45 {
    padding-right: 45px !important;
  }
  .mt_md--45 {
    margin-top: 45px !important;
  }
  .mb_md--45 {
    margin-bottom: 45px !important;
  }
  .ptb_md--50 {
    padding: 50px 0 !important;
  }
  .plr_md--50 {
    padding: 0 50px !important;
  }
  .pt_md--50 {
    padding-top: 50px !important;
  }
  .pb_md--50 {
    padding-bottom: 50px !important;
  }
  .pl_md--50 {
    padding-left: 50px !important;
  }
  .pr_md--50 {
    padding-right: 50px !important;
  }
  .mt_md--50 {
    margin-top: 50px !important;
  }
  .mb_md--50 {
    margin-bottom: 50px !important;
  }
  .ptb_md--55 {
    padding: 55px 0 !important;
  }
  .plr_md--55 {
    padding: 0 55px !important;
  }
  .pt_md--55 {
    padding-top: 55px !important;
  }
  .pb_md--55 {
    padding-bottom: 55px !important;
  }
  .pl_md--55 {
    padding-left: 55px !important;
  }
  .pr_md--55 {
    padding-right: 55px !important;
  }
  .mt_md--55 {
    margin-top: 55px !important;
  }
  .mb_md--55 {
    margin-bottom: 55px !important;
  }
  .ptb_md--60 {
    padding: 60px 0 !important;
  }
  .plr_md--60 {
    padding: 0 60px !important;
  }
  .pt_md--60 {
    padding-top: 60px !important;
  }
  .pb_md--60 {
    padding-bottom: 60px !important;
  }
  .pl_md--60 {
    padding-left: 60px !important;
  }
  .pr_md--60 {
    padding-right: 60px !important;
  }
  .mt_md--60 {
    margin-top: 60px !important;
  }
  .mb_md--60 {
    margin-bottom: 60px !important;
  }
  .ptb_md--65 {
    padding: 65px 0 !important;
  }
  .plr_md--65 {
    padding: 0 65px !important;
  }
  .pt_md--65 {
    padding-top: 65px !important;
  }
  .pb_md--65 {
    padding-bottom: 65px !important;
  }
  .pl_md--65 {
    padding-left: 65px !important;
  }
  .pr_md--65 {
    padding-right: 65px !important;
  }
  .mt_md--65 {
    margin-top: 65px !important;
  }
  .mb_md--65 {
    margin-bottom: 65px !important;
  }
  .ptb_md--70 {
    padding: 70px 0 !important;
  }
  .plr_md--70 {
    padding: 0 70px !important;
  }
  .pt_md--70 {
    padding-top: 70px !important;
  }
  .pb_md--70 {
    padding-bottom: 70px !important;
  }
  .pl_md--70 {
    padding-left: 70px !important;
  }
  .pr_md--70 {
    padding-right: 70px !important;
  }
  .mt_md--70 {
    margin-top: 70px !important;
  }
  .mb_md--70 {
    margin-bottom: 70px !important;
  }
  .ptb_md--75 {
    padding: 75px 0 !important;
  }
  .plr_md--75 {
    padding: 0 75px !important;
  }
  .pt_md--75 {
    padding-top: 75px !important;
  }
  .pb_md--75 {
    padding-bottom: 75px !important;
  }
  .pl_md--75 {
    padding-left: 75px !important;
  }
  .pr_md--75 {
    padding-right: 75px !important;
  }
  .mt_md--75 {
    margin-top: 75px !important;
  }
  .mb_md--75 {
    margin-bottom: 75px !important;
  }
  .ptb_md--80 {
    padding: 80px 0 !important;
  }
  .plr_md--80 {
    padding: 0 80px !important;
  }
  .pt_md--80 {
    padding-top: 80px !important;
  }
  .pb_md--80 {
    padding-bottom: 80px !important;
  }
  .pl_md--80 {
    padding-left: 80px !important;
  }
  .pr_md--80 {
    padding-right: 80px !important;
  }
  .mt_md--80 {
    margin-top: 80px !important;
  }
  .mb_md--80 {
    margin-bottom: 80px !important;
  }
  .ptb_md--85 {
    padding: 85px 0 !important;
  }
  .plr_md--85 {
    padding: 0 85px !important;
  }
  .pt_md--85 {
    padding-top: 85px !important;
  }
  .pb_md--85 {
    padding-bottom: 85px !important;
  }
  .pl_md--85 {
    padding-left: 85px !important;
  }
  .pr_md--85 {
    padding-right: 85px !important;
  }
  .mt_md--85 {
    margin-top: 85px !important;
  }
  .mb_md--85 {
    margin-bottom: 85px !important;
  }
  .ptb_md--90 {
    padding: 90px 0 !important;
  }
  .plr_md--90 {
    padding: 0 90px !important;
  }
  .pt_md--90 {
    padding-top: 90px !important;
  }
  .pb_md--90 {
    padding-bottom: 90px !important;
  }
  .pl_md--90 {
    padding-left: 90px !important;
  }
  .pr_md--90 {
    padding-right: 90px !important;
  }
  .mt_md--90 {
    margin-top: 90px !important;
  }
  .mb_md--90 {
    margin-bottom: 90px !important;
  }
  .ptb_md--95 {
    padding: 95px 0 !important;
  }
  .plr_md--95 {
    padding: 0 95px !important;
  }
  .pt_md--95 {
    padding-top: 95px !important;
  }
  .pb_md--95 {
    padding-bottom: 95px !important;
  }
  .pl_md--95 {
    padding-left: 95px !important;
  }
  .pr_md--95 {
    padding-right: 95px !important;
  }
  .mt_md--95 {
    margin-top: 95px !important;
  }
  .mb_md--95 {
    margin-bottom: 95px !important;
  }
  .ptb_md--100 {
    padding: 100px 0 !important;
  }
  .plr_md--100 {
    padding: 0 100px !important;
  }
  .pt_md--100 {
    padding-top: 100px !important;
  }
  .pb_md--100 {
    padding-bottom: 100px !important;
  }
  .pl_md--100 {
    padding-left: 100px !important;
  }
  .pr_md--100 {
    padding-right: 100px !important;
  }
  .mt_md--100 {
    margin-top: 100px !important;
  }
  .mb_md--100 {
    margin-bottom: 100px !important;
  }
}
@media only screen and (max-width: 767px) {
  .ptb_sm--250 {
    padding: 250px 0 !important;
  }
  .ptb_sm--0 {
    padding: 0 !important;
  }
  .pl_sm--0 {
    padding-left: 0 !important;
  }
  .pr_sm--0 {
    padding-right: 0 !important;
  }
  .pt_sm--0 {
    padding-top: 0 !important;
  }
  .pb_sm--0 {
    padding-bottom: 0 !important;
  }
  .mr_sm--0 {
    margin-right: 0 !important;
  }
  .ml_sm--0 {
    margin-left: 0 !important;
  }
  .mt_sm--0 {
    margin-top: 0 !important;
  }
  .mb_sm--0 {
    margin-bottom: 0 !important;
  }
  .pt_sm--150 {
    padding-top: 150px !important;
  }
  .pb_sm--110 {
    padding-bottom: 110px !important;
  }
  .ptb_sm--5 {
    padding: 5px 0 !important;
  }
  .plr_sm--5 {
    padding: 0 5px !important;
  }
  .pt_sm--5 {
    padding-top: 5px !important;
  }
  .pb_sm--5 {
    padding-bottom: 5px !important;
  }
  .pl_sm--5 {
    padding-left: 5px !important;
  }
  .pr_sm--5 {
    padding-right: 5px !important;
  }
  .mt_sm--5 {
    margin-top: 5px !important;
  }
  .ml_sm--5 {
    margin-left: 5px !important;
  }
  .mr_sm--5 {
    margin-right: 5px !important;
  }
  .mb_sm--5 {
    margin-bottom: 5px !important;
  }
  .ptb_sm--10 {
    padding: 10px 0 !important;
  }
  .plr_sm--10 {
    padding: 0 10px !important;
  }
  .pt_sm--10 {
    padding-top: 10px !important;
  }
  .pb_sm--10 {
    padding-bottom: 10px !important;
  }
  .pl_sm--10 {
    padding-left: 10px !important;
  }
  .pr_sm--10 {
    padding-right: 10px !important;
  }
  .mt_sm--10 {
    margin-top: 10px !important;
  }
  .ml_sm--10 {
    margin-left: 10px !important;
  }
  .mr_sm--10 {
    margin-right: 10px !important;
  }
  .mb_sm--10 {
    margin-bottom: 10px !important;
  }
  .ptb_sm--15 {
    padding: 15px 0 !important;
  }
  .plr_sm--15 {
    padding: 0 15px !important;
  }
  .pt_sm--15 {
    padding-top: 15px !important;
  }
  .pb_sm--15 {
    padding-bottom: 15px !important;
  }
  .pl_sm--15 {
    padding-left: 15px !important;
  }
  .pr_sm--15 {
    padding-right: 15px !important;
  }
  .mt_sm--15 {
    margin-top: 15px !important;
  }
  .ml_sm--15 {
    margin-left: 15px !important;
  }
  .mr_sm--15 {
    margin-right: 15px !important;
  }
  .mb_sm--15 {
    margin-bottom: 15px !important;
  }
  .ptb_sm--20 {
    padding: 20px 0 !important;
  }
  .plr_sm--20 {
    padding: 0 20px !important;
  }
  .pt_sm--20 {
    padding-top: 20px !important;
  }
  .pb_sm--20 {
    padding-bottom: 20px !important;
  }
  .pl_sm--20 {
    padding-left: 20px !important;
  }
  .pr_sm--20 {
    padding-right: 20px !important;
  }
  .mt_sm--20 {
    margin-top: 20px !important;
  }
  .ml_sm--20 {
    margin-left: 20px !important;
  }
  .mr_sm--20 {
    margin-right: 20px !important;
  }
  .mb_sm--20 {
    margin-bottom: 20px !important;
  }
  .ptb_sm--25 {
    padding: 25px 0 !important;
  }
  .plr_sm--25 {
    padding: 0 25px !important;
  }
  .pt_sm--25 {
    padding-top: 25px !important;
  }
  .pb_sm--25 {
    padding-bottom: 25px !important;
  }
  .pl_sm--25 {
    padding-left: 25px !important;
  }
  .pr_sm--25 {
    padding-right: 25px !important;
  }
  .mt_sm--25 {
    margin-top: 25px !important;
  }
  .ml_sm--25 {
    margin-left: 25px !important;
  }
  .mr_sm--25 {
    margin-right: 25px !important;
  }
  .mb_sm--25 {
    margin-bottom: 25px !important;
  }
  .ptb_sm--30 {
    padding: 30px 0 !important;
  }
  .plr_sm--30 {
    padding: 0 30px !important;
  }
  .pt_sm--30 {
    padding-top: 30px !important;
  }
  .pb_sm--30 {
    padding-bottom: 30px !important;
  }
  .pl_sm--30 {
    padding-left: 30px !important;
  }
  .pr_sm--30 {
    padding-right: 30px !important;
  }
  .mt_sm--30 {
    margin-top: 30px !important;
  }
  .ml_sm--30 {
    margin-left: 30px !important;
  }
  .mr_sm--30 {
    margin-right: 30px !important;
  }
  .mb_sm--30 {
    margin-bottom: 30px !important;
  }
  .ptb_sm--35 {
    padding: 35px 0 !important;
  }
  .plr_sm--35 {
    padding: 0 35px !important;
  }
  .pt_sm--35 {
    padding-top: 35px !important;
  }
  .pb_sm--35 {
    padding-bottom: 35px !important;
  }
  .pl_sm--35 {
    padding-left: 35px !important;
  }
  .pr_sm--35 {
    padding-right: 35px !important;
  }
  .mt_sm--35 {
    margin-top: 35px !important;
  }
  .ml_sm--35 {
    margin-left: 35px !important;
  }
  .mr_sm--35 {
    margin-right: 35px !important;
  }
  .mb_sm--35 {
    margin-bottom: 35px !important;
  }
  .ptb_sm--40 {
    padding: 40px 0 !important;
  }
  .plr_sm--40 {
    padding: 0 40px !important;
  }
  .pt_sm--40 {
    padding-top: 40px !important;
  }
  .pb_sm--40 {
    padding-bottom: 40px !important;
  }
  .pl_sm--40 {
    padding-left: 40px !important;
  }
  .pr_sm--40 {
    padding-right: 40px !important;
  }
  .mt_sm--40 {
    margin-top: 40px !important;
  }
  .ml_sm--40 {
    margin-left: 40px !important;
  }
  .mr_sm--40 {
    margin-right: 40px !important;
  }
  .mb_sm--40 {
    margin-bottom: 40px !important;
  }
  .ptb_sm--45 {
    padding: 45px 0 !important;
  }
  .plr_sm--45 {
    padding: 0 45px !important;
  }
  .pt_sm--45 {
    padding-top: 45px !important;
  }
  .pb_sm--45 {
    padding-bottom: 45px !important;
  }
  .pl_sm--45 {
    padding-left: 45px !important;
  }
  .pr_sm--45 {
    padding-right: 45px !important;
  }
  .mt_sm--45 {
    margin-top: 45px !important;
  }
  .ml_sm--45 {
    margin-left: 45px !important;
  }
  .mr_sm--45 {
    margin-right: 45px !important;
  }
  .mb_sm--45 {
    margin-bottom: 45px !important;
  }
  .ptb_sm--50 {
    padding: 50px 0 !important;
  }
  .plr_sm--50 {
    padding: 0 50px !important;
  }
  .pt_sm--50 {
    padding-top: 50px !important;
  }
  .pb_sm--50 {
    padding-bottom: 50px !important;
  }
  .pl_sm--50 {
    padding-left: 50px !important;
  }
  .pr_sm--50 {
    padding-right: 50px !important;
  }
  .mt_sm--50 {
    margin-top: 50px !important;
  }
  .ml_sm--50 {
    margin-left: 50px !important;
  }
  .mr_sm--50 {
    margin-right: 50px !important;
  }
  .mb_sm--50 {
    margin-bottom: 50px !important;
  }
  .ptb_sm--55 {
    padding: 55px 0 !important;
  }
  .plr_sm--55 {
    padding: 0 55px !important;
  }
  .pt_sm--55 {
    padding-top: 55px !important;
  }
  .pb_sm--55 {
    padding-bottom: 55px !important;
  }
  .pl_sm--55 {
    padding-left: 55px !important;
  }
  .pr_sm--55 {
    padding-right: 55px !important;
  }
  .mt_sm--55 {
    margin-top: 55px !important;
  }
  .ml_sm--55 {
    margin-left: 55px !important;
  }
  .mr_sm--55 {
    margin-right: 55px !important;
  }
  .mb_sm--55 {
    margin-bottom: 55px !important;
  }
  .ptb_sm--60 {
    padding: 60px 0 !important;
  }
  .plr_sm--60 {
    padding: 0 60px !important;
  }
  .pt_sm--60 {
    padding-top: 60px !important;
  }
  .pb_sm--60 {
    padding-bottom: 60px !important;
  }
  .pl_sm--60 {
    padding-left: 60px !important;
  }
  .pr_sm--60 {
    padding-right: 60px !important;
  }
  .mt_sm--60 {
    margin-top: 60px !important;
  }
  .ml_sm--60 {
    margin-left: 60px !important;
  }
  .mr_sm--60 {
    margin-right: 60px !important;
  }
  .mb_sm--60 {
    margin-bottom: 60px !important;
  }
  .ptb_sm--65 {
    padding: 65px 0 !important;
  }
  .plr_sm--65 {
    padding: 0 65px !important;
  }
  .pt_sm--65 {
    padding-top: 65px !important;
  }
  .pb_sm--65 {
    padding-bottom: 65px !important;
  }
  .pl_sm--65 {
    padding-left: 65px !important;
  }
  .pr_sm--65 {
    padding-right: 65px !important;
  }
  .mt_sm--65 {
    margin-top: 65px !important;
  }
  .ml_sm--65 {
    margin-left: 65px !important;
  }
  .mr_sm--65 {
    margin-right: 65px !important;
  }
  .mb_sm--65 {
    margin-bottom: 65px !important;
  }
  .ptb_sm--70 {
    padding: 70px 0 !important;
  }
  .plr_sm--70 {
    padding: 0 70px !important;
  }
  .pt_sm--70 {
    padding-top: 70px !important;
  }
  .pb_sm--70 {
    padding-bottom: 70px !important;
  }
  .pl_sm--70 {
    padding-left: 70px !important;
  }
  .pr_sm--70 {
    padding-right: 70px !important;
  }
  .mt_sm--70 {
    margin-top: 70px !important;
  }
  .ml_sm--70 {
    margin-left: 70px !important;
  }
  .mr_sm--70 {
    margin-right: 70px !important;
  }
  .mb_sm--70 {
    margin-bottom: 70px !important;
  }
  .ptb_sm--75 {
    padding: 75px 0 !important;
  }
  .plr_sm--75 {
    padding: 0 75px !important;
  }
  .pt_sm--75 {
    padding-top: 75px !important;
  }
  .pb_sm--75 {
    padding-bottom: 75px !important;
  }
  .pl_sm--75 {
    padding-left: 75px !important;
  }
  .pr_sm--75 {
    padding-right: 75px !important;
  }
  .mt_sm--75 {
    margin-top: 75px !important;
  }
  .ml_sm--75 {
    margin-left: 75px !important;
  }
  .mr_sm--75 {
    margin-right: 75px !important;
  }
  .mb_sm--75 {
    margin-bottom: 75px !important;
  }
  .ptb_sm--80 {
    padding: 80px 0 !important;
  }
  .plr_sm--80 {
    padding: 0 80px !important;
  }
  .pt_sm--80 {
    padding-top: 80px !important;
  }
  .pb_sm--80 {
    padding-bottom: 80px !important;
  }
  .pl_sm--80 {
    padding-left: 80px !important;
  }
  .pr_sm--80 {
    padding-right: 80px !important;
  }
  .mt_sm--80 {
    margin-top: 80px !important;
  }
  .ml_sm--80 {
    margin-left: 80px !important;
  }
  .mr_sm--80 {
    margin-right: 80px !important;
  }
  .mb_sm--80 {
    margin-bottom: 80px !important;
  }
  .ptb_sm--85 {
    padding: 85px 0 !important;
  }
  .plr_sm--85 {
    padding: 0 85px !important;
  }
  .pt_sm--85 {
    padding-top: 85px !important;
  }
  .pb_sm--85 {
    padding-bottom: 85px !important;
  }
  .pl_sm--85 {
    padding-left: 85px !important;
  }
  .pr_sm--85 {
    padding-right: 85px !important;
  }
  .mt_sm--85 {
    margin-top: 85px !important;
  }
  .ml_sm--85 {
    margin-left: 85px !important;
  }
  .mr_sm--85 {
    margin-right: 85px !important;
  }
  .mb_sm--85 {
    margin-bottom: 85px !important;
  }
  .ptb_sm--90 {
    padding: 90px 0 !important;
  }
  .plr_sm--90 {
    padding: 0 90px !important;
  }
  .pt_sm--90 {
    padding-top: 90px !important;
  }
  .pb_sm--90 {
    padding-bottom: 90px !important;
  }
  .pl_sm--90 {
    padding-left: 90px !important;
  }
  .pr_sm--90 {
    padding-right: 90px !important;
  }
  .mt_sm--90 {
    margin-top: 90px !important;
  }
  .ml_sm--90 {
    margin-left: 90px !important;
  }
  .mr_sm--90 {
    margin-right: 90px !important;
  }
  .mb_sm--90 {
    margin-bottom: 90px !important;
  }
  .ptb_sm--95 {
    padding: 95px 0 !important;
  }
  .plr_sm--95 {
    padding: 0 95px !important;
  }
  .pt_sm--95 {
    padding-top: 95px !important;
  }
  .pb_sm--95 {
    padding-bottom: 95px !important;
  }
  .pl_sm--95 {
    padding-left: 95px !important;
  }
  .pr_sm--95 {
    padding-right: 95px !important;
  }
  .mt_sm--95 {
    margin-top: 95px !important;
  }
  .ml_sm--95 {
    margin-left: 95px !important;
  }
  .mr_sm--95 {
    margin-right: 95px !important;
  }
  .mb_sm--95 {
    margin-bottom: 95px !important;
  }
  .ptb_sm--100 {
    padding: 100px 0 !important;
  }
  .plr_sm--100 {
    padding: 0 100px !important;
  }
  .pt_sm--100 {
    padding-top: 100px !important;
  }
  .pb_sm--100 {
    padding-bottom: 100px !important;
  }
  .pl_sm--100 {
    padding-left: 100px !important;
  }
  .pr_sm--100 {
    padding-right: 100px !important;
  }
  .mt_sm--100 {
    margin-top: 100px !important;
  }
  .ml_sm--100 {
    margin-left: 100px !important;
  }
  .mr_sm--100 {
    margin-right: 100px !important;
  }
  .mb_sm--100 {
    margin-bottom: 100px !important;
  }
  .pl_sm--0 {
    padding-left: 0 !important;
  }
  .pr_sm--0 {
    padding-right: 0 !important;
  }
  .pt_sm--0 {
    padding-top: 0 !important;
  }
  .pb_sm--0 {
    padding-bottom: 0 !important;
  }
  .mr_sm--0 {
    margin-right: 0 !important;
  }
  .ml_sm--0 {
    margin-left: 0 !important;
  }
  .mt_sm--0 {
    margin-top: 0 !important;
  }
  .mb_sm--0 {
    margin-bottom: 0 !important;
  }
}
@media only screen and (max-width: 575px) {
  .ptb_mobile--5 {
    padding: 5px 0 !important;
  }
  .plr_mobile--5 {
    padding: 0 5px !important;
  }
  .pt_mobile--5 {
    padding-top: 5px !important;
  }
  .pb_mobile--5 {
    padding-bottom: 5px !important;
  }
  .pl_mobile--5 {
    padding-left: 5px !important;
  }
  .pr_mobile--5 {
    padding-right: 5px !important;
  }
  .mt_mobile--5 {
    margin-top: 5px !important;
  }
  .mb_mobile--5 {
    margin-bottom: 5px !important;
  }
  .ptb_mobile--10 {
    padding: 10px 0 !important;
  }
  .plr_mobile--10 {
    padding: 0 10px !important;
  }
  .pt_mobile--10 {
    padding-top: 10px !important;
  }
  .pb_mobile--10 {
    padding-bottom: 10px !important;
  }
  .pl_mobile--10 {
    padding-left: 10px !important;
  }
  .pr_mobile--10 {
    padding-right: 10px !important;
  }
  .mt_mobile--10 {
    margin-top: 10px !important;
  }
  .mb_mobile--10 {
    margin-bottom: 10px !important;
  }
  .ptb_mobile--15 {
    padding: 15px 0 !important;
  }
  .plr_mobile--15 {
    padding: 0 15px !important;
  }
  .pt_mobile--15 {
    padding-top: 15px !important;
  }
  .pb_mobile--15 {
    padding-bottom: 15px !important;
  }
  .pl_mobile--15 {
    padding-left: 15px !important;
  }
  .pr_mobile--15 {
    padding-right: 15px !important;
  }
  .mt_mobile--15 {
    margin-top: 15px !important;
  }
  .mb_mobile--15 {
    margin-bottom: 15px !important;
  }
  .ptb_mobile--20 {
    padding: 20px 0 !important;
  }
  .plr_mobile--20 {
    padding: 0 20px !important;
  }
  .pt_mobile--20 {
    padding-top: 20px !important;
  }
  .pb_mobile--20 {
    padding-bottom: 20px !important;
  }
  .pl_mobile--20 {
    padding-left: 20px !important;
  }
  .pr_mobile--20 {
    padding-right: 20px !important;
  }
  .mt_mobile--20 {
    margin-top: 20px !important;
  }
  .mb_mobile--20 {
    margin-bottom: 20px !important;
  }
  .ptb_mobile--25 {
    padding: 25px 0 !important;
  }
  .plr_mobile--25 {
    padding: 0 25px !important;
  }
  .pt_mobile--25 {
    padding-top: 25px !important;
  }
  .pb_mobile--25 {
    padding-bottom: 25px !important;
  }
  .pl_mobile--25 {
    padding-left: 25px !important;
  }
  .pr_mobile--25 {
    padding-right: 25px !important;
  }
  .mt_mobile--25 {
    margin-top: 25px !important;
  }
  .mb_mobile--25 {
    margin-bottom: 25px !important;
  }
  .ptb_mobile--30 {
    padding: 30px 0 !important;
  }
  .plr_mobile--30 {
    padding: 0 30px !important;
  }
  .pt_mobile--30 {
    padding-top: 30px !important;
  }
  .pb_mobile--30 {
    padding-bottom: 30px !important;
  }
  .pl_mobile--30 {
    padding-left: 30px !important;
  }
  .pr_mobile--30 {
    padding-right: 30px !important;
  }
  .mt_mobile--30 {
    margin-top: 30px !important;
  }
  .mb_mobile--30 {
    margin-bottom: 30px !important;
  }
  .ptb_mobile--35 {
    padding: 35px 0 !important;
  }
  .plr_mobile--35 {
    padding: 0 35px !important;
  }
  .pt_mobile--35 {
    padding-top: 35px !important;
  }
  .pb_mobile--35 {
    padding-bottom: 35px !important;
  }
  .pl_mobile--35 {
    padding-left: 35px !important;
  }
  .pr_mobile--35 {
    padding-right: 35px !important;
  }
  .mt_mobile--35 {
    margin-top: 35px !important;
  }
  .mb_mobile--35 {
    margin-bottom: 35px !important;
  }
  .ptb_mobile--40 {
    padding: 40px 0 !important;
  }
  .plr_mobile--40 {
    padding: 0 40px !important;
  }
  .pt_mobile--40 {
    padding-top: 40px !important;
  }
  .pb_mobile--40 {
    padding-bottom: 40px !important;
  }
  .pl_mobile--40 {
    padding-left: 40px !important;
  }
  .pr_mobile--40 {
    padding-right: 40px !important;
  }
  .mt_mobile--40 {
    margin-top: 40px !important;
  }
  .mb_mobile--40 {
    margin-bottom: 40px !important;
  }
  .ptb_mobile--45 {
    padding: 45px 0 !important;
  }
  .plr_mobile--45 {
    padding: 0 45px !important;
  }
  .pt_mobile--45 {
    padding-top: 45px !important;
  }
  .pb_mobile--45 {
    padding-bottom: 45px !important;
  }
  .pl_mobile--45 {
    padding-left: 45px !important;
  }
  .pr_mobile--45 {
    padding-right: 45px !important;
  }
  .mt_mobile--45 {
    margin-top: 45px !important;
  }
  .mb_mobile--45 {
    margin-bottom: 45px !important;
  }
  .ptb_mobile--50 {
    padding: 50px 0 !important;
  }
  .plr_mobile--50 {
    padding: 0 50px !important;
  }
  .pt_mobile--50 {
    padding-top: 50px !important;
  }
  .pb_mobile--50 {
    padding-bottom: 50px !important;
  }
  .pl_mobile--50 {
    padding-left: 50px !important;
  }
  .pr_mobile--50 {
    padding-right: 50px !important;
  }
  .mt_mobile--50 {
    margin-top: 50px !important;
  }
  .mb_mobile--50 {
    margin-bottom: 50px !important;
  }
  .ptb_mobile--55 {
    padding: 55px 0 !important;
  }
  .plr_mobile--55 {
    padding: 0 55px !important;
  }
  .pt_mobile--55 {
    padding-top: 55px !important;
  }
  .pb_mobile--55 {
    padding-bottom: 55px !important;
  }
  .pl_mobile--55 {
    padding-left: 55px !important;
  }
  .pr_mobile--55 {
    padding-right: 55px !important;
  }
  .mt_mobile--55 {
    margin-top: 55px !important;
  }
  .mb_mobile--55 {
    margin-bottom: 55px !important;
  }
  .ptb_mobile--60 {
    padding: 60px 0 !important;
  }
  .plr_mobile--60 {
    padding: 0 60px !important;
  }
  .pt_mobile--60 {
    padding-top: 60px !important;
  }
  .pb_mobile--60 {
    padding-bottom: 60px !important;
  }
  .pl_mobile--60 {
    padding-left: 60px !important;
  }
  .pr_mobile--60 {
    padding-right: 60px !important;
  }
  .mt_mobile--60 {
    margin-top: 60px !important;
  }
  .mb_mobile--60 {
    margin-bottom: 60px !important;
  }
  .ptb_mobile--65 {
    padding: 65px 0 !important;
  }
  .plr_mobile--65 {
    padding: 0 65px !important;
  }
  .pt_mobile--65 {
    padding-top: 65px !important;
  }
  .pb_mobile--65 {
    padding-bottom: 65px !important;
  }
  .pl_mobile--65 {
    padding-left: 65px !important;
  }
  .pr_mobile--65 {
    padding-right: 65px !important;
  }
  .mt_mobile--65 {
    margin-top: 65px !important;
  }
  .mb_mobile--65 {
    margin-bottom: 65px !important;
  }
  .ptb_mobile--70 {
    padding: 70px 0 !important;
  }
  .plr_mobile--70 {
    padding: 0 70px !important;
  }
  .pt_mobile--70 {
    padding-top: 70px !important;
  }
  .pb_mobile--70 {
    padding-bottom: 70px !important;
  }
  .pl_mobile--70 {
    padding-left: 70px !important;
  }
  .pr_mobile--70 {
    padding-right: 70px !important;
  }
  .mt_mobile--70 {
    margin-top: 70px !important;
  }
  .mb_mobile--70 {
    margin-bottom: 70px !important;
  }
  .ptb_mobile--75 {
    padding: 75px 0 !important;
  }
  .plr_mobile--75 {
    padding: 0 75px !important;
  }
  .pt_mobile--75 {
    padding-top: 75px !important;
  }
  .pb_mobile--75 {
    padding-bottom: 75px !important;
  }
  .pl_mobile--75 {
    padding-left: 75px !important;
  }
  .pr_mobile--75 {
    padding-right: 75px !important;
  }
  .mt_mobile--75 {
    margin-top: 75px !important;
  }
  .mb_mobile--75 {
    margin-bottom: 75px !important;
  }
  .ptb_mobile--80 {
    padding: 80px 0 !important;
  }
  .plr_mobile--80 {
    padding: 0 80px !important;
  }
  .pt_mobile--80 {
    padding-top: 80px !important;
  }
  .pb_mobile--80 {
    padding-bottom: 80px !important;
  }
  .pl_mobile--80 {
    padding-left: 80px !important;
  }
  .pr_mobile--80 {
    padding-right: 80px !important;
  }
  .mt_mobile--80 {
    margin-top: 80px !important;
  }
  .mb_mobile--80 {
    margin-bottom: 80px !important;
  }
  .ptb_mobile--85 {
    padding: 85px 0 !important;
  }
  .plr_mobile--85 {
    padding: 0 85px !important;
  }
  .pt_mobile--85 {
    padding-top: 85px !important;
  }
  .pb_mobile--85 {
    padding-bottom: 85px !important;
  }
  .pl_mobile--85 {
    padding-left: 85px !important;
  }
  .pr_mobile--85 {
    padding-right: 85px !important;
  }
  .mt_mobile--85 {
    margin-top: 85px !important;
  }
  .mb_mobile--85 {
    margin-bottom: 85px !important;
  }
  .ptb_mobile--90 {
    padding: 90px 0 !important;
  }
  .plr_mobile--90 {
    padding: 0 90px !important;
  }
  .pt_mobile--90 {
    padding-top: 90px !important;
  }
  .pb_mobile--90 {
    padding-bottom: 90px !important;
  }
  .pl_mobile--90 {
    padding-left: 90px !important;
  }
  .pr_mobile--90 {
    padding-right: 90px !important;
  }
  .mt_mobile--90 {
    margin-top: 90px !important;
  }
  .mb_mobile--90 {
    margin-bottom: 90px !important;
  }
  .ptb_mobile--95 {
    padding: 95px 0 !important;
  }
  .plr_mobile--95 {
    padding: 0 95px !important;
  }
  .pt_mobile--95 {
    padding-top: 95px !important;
  }
  .pb_mobile--95 {
    padding-bottom: 95px !important;
  }
  .pl_mobile--95 {
    padding-left: 95px !important;
  }
  .pr_mobile--95 {
    padding-right: 95px !important;
  }
  .mt_mobile--95 {
    margin-top: 95px !important;
  }
  .mb_mobile--95 {
    margin-bottom: 95px !important;
  }
  .ptb_mobile--100 {
    padding: 100px 0 !important;
  }
  .plr_mobile--100 {
    padding: 0 100px !important;
  }
  .pt_mobile--100 {
    padding-top: 100px !important;
  }
  .pb_mobile--100 {
    padding-bottom: 100px !important;
  }
  .pl_mobile--100 {
    padding-left: 100px !important;
  }
  .pr_mobile--100 {
    padding-right: 100px !important;
  }
  .mt_mobile--100 {
    margin-top: 100px !important;
  }
  .mb_mobile--100 {
    margin-bottom: 100px !important;
  }
}
.slick-gutter-5 {
  margin-left: -5px !important;
  margin-right: -5px !important;
}
.slick-gutter-5 .slick-slide {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.slick-gutter-10 {
  margin-left: -10px !important;
  margin-right: -10px !important;
}
.slick-gutter-10 .slick-slide {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.slick-gutter-15 {
  margin-left: -15px !important;
  margin-right: -15px !important;
}
.slick-gutter-15 .slick-slide {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.slick-gutter-20 {
  margin-left: -20px !important;
  margin-right: -20px !important;
}
.slick-gutter-20 .slick-slide {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.slick-gutter-25 {
  margin-left: -25px !important;
  margin-right: -25px !important;
}
.slick-gutter-25 .slick-slide {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.slick-gutter-30 {
  margin-left: -30px !important;
  margin-right: -30px !important;
}
.slick-gutter-30 .slick-slide {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.slick-gutter-35 {
  margin-left: -35px !important;
  margin-right: -35px !important;
}
.slick-gutter-35 .slick-slide {
  padding-left: 35px !important;
  padding-right: 35px !important;
}

.slick-gutter-40 {
  margin-left: -40px !important;
  margin-right: -40px !important;
}
.slick-gutter-40 .slick-slide {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.slick-gutter-45 {
  margin-left: -45px !important;
  margin-right: -45px !important;
}
.slick-gutter-45 .slick-slide {
  padding-left: 45px !important;
  padding-right: 45px !important;
}

.slick-gutter-50 {
  margin-left: -50px !important;
  margin-right: -50px !important;
}
.slick-gutter-50 .slick-slide {
  padding-left: 50px !important;
  padding-right: 50px !important;
}

.slick-gutter-55 {
  margin-left: -55px !important;
  margin-right: -55px !important;
}
.slick-gutter-55 .slick-slide {
  padding-left: 55px !important;
  padding-right: 55px !important;
}

.slick-gutter-60 {
  margin-left: -60px !important;
  margin-right: -60px !important;
}
.slick-gutter-60 .slick-slide {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.slick-gutter-65 {
  margin-left: -65px !important;
  margin-right: -65px !important;
}
.slick-gutter-65 .slick-slide {
  padding-left: 65px !important;
  padding-right: 65px !important;
}

.slick-gutter-70 {
  margin-left: -70px !important;
  margin-right: -70px !important;
}
.slick-gutter-70 .slick-slide {
  padding-left: 70px !important;
  padding-right: 70px !important;
}

.slick-gutter-75 {
  margin-left: -75px !important;
  margin-right: -75px !important;
}
.slick-gutter-75 .slick-slide {
  padding-left: 75px !important;
  padding-right: 75px !important;
}

.slick-gutter-80 {
  margin-left: -80px !important;
  margin-right: -80px !important;
}
.slick-gutter-80 .slick-slide {
  padding-left: 80px !important;
  padding-right: 80px !important;
}

.slick-gutter-85 {
  margin-left: -85px !important;
  margin-right: -85px !important;
}
.slick-gutter-85 .slick-slide {
  padding-left: 85px !important;
  padding-right: 85px !important;
}

.slick-gutter-90 {
  margin-left: -90px !important;
  margin-right: -90px !important;
}
.slick-gutter-90 .slick-slide {
  padding-left: 90px !important;
  padding-right: 90px !important;
}

.slick-gutter-95 {
  margin-left: -95px !important;
  margin-right: -95px !important;
}
.slick-gutter-95 .slick-slide {
  padding-left: 95px !important;
  padding-right: 95px !important;
}

.slick-gutter-100 {
  margin-left: -100px !important;
  margin-right: -100px !important;
}
.slick-gutter-100 .slick-slide {
  padding-left: 100px !important;
  padding-right: 100px !important;
}

/*======================== 
    Common Style Css
==========================*/
/* Heading Font  */
.h1 {
  font-size: var(--h1) !important;
}

.h2 {
  font-size: var(--h2) !important;
}

.h3 {
  font-size: var(--h3) !important;
}

.h4 {
  font-size: var(--h4) !important;
}

.h5 {
  font-size: var(--h5) !important;
}

.h6 {
  font-size: var(--h6) !important;
}

/* Text Color  */
.bg-primary-color {
  background: var(--color-primary) !important;
}

.bg-secondary-color {
  background: var(--color-secondary) !important;
}

.bg-color-tertiary {
  background-color: var(--color-tertiary) !important;
}

.bg-color-white {
  background-color: var(--color-white) !important;
}

.color-white {
  color: var(--color-white);
}

/* Radius */
/* Font Weight */
/* Shadows */
/* Others  */
.liststyle {
  padding: 0;
  margin: 0;
  list-style: none;
}

.transition-transform {
  transition: var(--transition-transform);
}

.list-icon {
  list-style: none;
  padding: 0;
  margin: 0;
}
.list-icon li {
  display: flex;
  align-items: center;
  margin: 15px 0;
}
@media only screen and (max-width: 767px) {
  .list-icon li {
    font-size: 16px;
  }
}
.list-icon li .icon {
  width: 30px;
  background-color: var(--color-blackest);
  height: 30px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  margin-right: 9px;
  min-width: 30px;
  min-height: 30px;
}
.list-icon li .icon.background-transparent {
  background-color: transparent;
}
.list-icon li .icon i {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rn-sub-badge {
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 18px;
  font-size: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: inline-block;
  padding: 7px 14px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}

.radius-small {
  border-radius: var(--radius-small);
}

.line-before {
  position: relative;
  padding-left: 18px;
}
.line-before::before {
  position: absolute;
  content: "";
  left: 0;
  width: 2px;
  height: 81%;
  background: var(--color-primary);
  top: 50%;
  transform: translateY(-50%);
}

.bg-image--7 {
  background-size: auto;
  background-repeat: no-repeat;
  background-position: top 15px left 10%;
}

.bg-image--12 {
  background-size: auto;
}

.border-bottom-1 {
  border-bottom: 1px solid #EEEEEE;
}

/* Breadcrumb  */
.edu-breadcrumb-area {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.edu-breadcrumb-area .shape-image {
  position: absolute;
  z-index: -1;
}
.edu-breadcrumb-area .shape-image.shape-image-1 {
  top: -30px;
  left: -180px;
}
.edu-breadcrumb-area .shape-image.shape-image-2 {
  top: -10px;
  left: 60%;
}
.edu-breadcrumb-area .shape-image.shape-image-3 {
  top: -24px;
  right: -90px;
}
.edu-breadcrumb-area .shape-image.shape-image-4 {
  bottom: -39px;
  right: -220px;
}
.edu-breadcrumb-area .shape-image.shape-image-5 {
  bottom: -28px;
  left: 35%;
}
.edu-breadcrumb-area .shape-image.shape-image-6 {
  bottom: -30px;
  left: -108px;
}

/* Animation  */
.eduvibe-animated-shape {
  position: relative;
  z-index: 9;
}
@keyframes eduvibe-vsm-y-move {
  0% {
    transform: translate(0, -30%);
  }
  100% {
    transform: translate(0, 30%);
  }
}
@keyframes eduvibe-vsm-y-reverse-move {
  0% {
    transform: translate(0, 30%);
  }
  100% {
    transform: translate(0, -30%);
  }
}
@keyframes eduvibe-sm-x-move {
  0% {
    transform: translate(-50%, 0);
  }
  100% {
    transform: translate(50%, 0);
  }
}
@keyframes eduvibe-sm-x-reverse-move {
  0% {
    transform: translate(50%, 0);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
@keyframes eduvibe-rotate-x {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes eduvibe-rotate-y {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@keyframes eduvibe-zoom2 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}
@keyframes eduvibe-zoom1 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
/* ========= Forms Styles ========= */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

input,
select,
textarea {
  width: 100%;
  transition: 0.3s;
}

input {
  height: 40px;
  padding: 0 15px;
}

select {
  transition: 0.3s;
  height: 60px;
  line-height: 28px;
  padding: 10px 20px;
  outline: none;
  color: var(--color-body);
  appearance: none;
  border: 2px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  padding-right: 30px;
}

.edu-select {
  transition: 0.3s;
  height: 60px;
  line-height: 28px;
  padding: 10px 20px;
  outline: none;
  color: var(--color-body);
  appearance: none;
  border: 0 none;
  border-radius: var(--radius);
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  padding-right: 30px;
  background-color: #f5f5f5;
  border-radius: 5px;
  max-width: 256px;
}

input[type=text],
input[type=password],
input[type=email],
input[type=number],
input[type=tel],
input[type=date],
select,
textarea {
  font-size: 16px;
  font-weight: 500;
  height: auto;
  line-height: 28px;
  background: transparent;
  box-shadow: none;
  padding: 0 15px;
  outline: none;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  color: var(--color-body);
  /* -- Placeholder -- */
}
input[type=text]::placeholder,
input[type=password]::placeholder,
input[type=email]::placeholder,
input[type=number]::placeholder,
input[type=tel]::placeholder,
input[type=date]::placeholder,
select::placeholder,
textarea::placeholder {
  color: var(--body-color);
  /* Firefox */
  opacity: 1;
}
input[type=text]:-ms-input-placeholder,
input[type=password]:-ms-input-placeholder,
input[type=email]:-ms-input-placeholder,
input[type=number]:-ms-input-placeholder,
input[type=tel]:-ms-input-placeholder,
input[type=date]:-ms-input-placeholder,
select:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--body-color);
  opacity: 1;
}
input[type=text]::-ms-input-placeholder,
input[type=password]::-ms-input-placeholder,
input[type=email]::-ms-input-placeholder,
input[type=number]::-ms-input-placeholder,
input[type=tel]::-ms-input-placeholder,
input[type=date]::-ms-input-placeholder,
select::-ms-input-placeholder,
textarea::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--body-color);
  opacity: 1;
}
input[type=text].p-holder__active, .input-active input[type=text], input[type=text].input-active,
input[type=password].p-holder__active,
.input-active input[type=password],
input[type=password].input-active,
input[type=email].p-holder__active,
.input-active input[type=email],
input[type=email].input-active,
input[type=number].p-holder__active,
.input-active input[type=number],
input[type=number].input-active,
input[type=tel].p-holder__active,
.input-active input[type=tel],
input[type=tel].input-active,
input[type=date].p-holder__active,
.input-active input[type=date],
input[type=date].input-active,
select.p-holder__active,
select.input-active,
textarea.p-holder__active,
textarea.input-active {
  border-color: var(--color-primary);
  /* -- Placeholder -- */
}
input[type=text].p-holder__active::placeholder, .input-active input[type=text]::placeholder, input[type=text].input-active::placeholder,
input[type=password].p-holder__active::placeholder,
.input-active input[type=password]::placeholder,
input[type=password].input-active::placeholder,
input[type=email].p-holder__active::placeholder,
.input-active input[type=email]::placeholder,
input[type=email].input-active::placeholder,
input[type=number].p-holder__active::placeholder,
.input-active input[type=number]::placeholder,
input[type=number].input-active::placeholder,
input[type=tel].p-holder__active::placeholder,
.input-active input[type=tel]::placeholder,
input[type=tel].input-active::placeholder,
input[type=date].p-holder__active::placeholder,
.input-active input[type=date]::placeholder,
input[type=date].input-active::placeholder,
select.p-holder__active::placeholder,
select.input-active::placeholder,
textarea.p-holder__active::placeholder,
textarea.input-active::placeholder {
  color: var(--color-primary);
  /* Firefox */
  opacity: 1;
}
input[type=text].p-holder__active:-ms-input-placeholder, .input-active input[type=text]:-ms-input-placeholder, input[type=text].input-active:-ms-input-placeholder,
input[type=password].p-holder__active:-ms-input-placeholder,
.input-active input[type=password]:-ms-input-placeholder,
input[type=password].input-active:-ms-input-placeholder,
input[type=email].p-holder__active:-ms-input-placeholder,
.input-active input[type=email]:-ms-input-placeholder,
input[type=email].input-active:-ms-input-placeholder,
input[type=number].p-holder__active:-ms-input-placeholder,
.input-active input[type=number]:-ms-input-placeholder,
input[type=number].input-active:-ms-input-placeholder,
input[type=tel].p-holder__active:-ms-input-placeholder,
.input-active input[type=tel]:-ms-input-placeholder,
input[type=tel].input-active:-ms-input-placeholder,
input[type=date].p-holder__active:-ms-input-placeholder,
.input-active input[type=date]:-ms-input-placeholder,
input[type=date].input-active:-ms-input-placeholder,
select.p-holder__active:-ms-input-placeholder,
select.input-active:-ms-input-placeholder,
textarea.p-holder__active:-ms-input-placeholder,
textarea.input-active:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--color-primary);
}
input[type=text].p-holder__active::-ms-input-placeholder, .input-active input[type=text]::-ms-input-placeholder, input[type=text].input-active::-ms-input-placeholder,
input[type=password].p-holder__active::-ms-input-placeholder,
.input-active input[type=password]::-ms-input-placeholder,
input[type=password].input-active::-ms-input-placeholder,
input[type=email].p-holder__active::-ms-input-placeholder,
.input-active input[type=email]::-ms-input-placeholder,
input[type=email].input-active::-ms-input-placeholder,
input[type=number].p-holder__active::-ms-input-placeholder,
.input-active input[type=number]::-ms-input-placeholder,
input[type=number].input-active::-ms-input-placeholder,
input[type=tel].p-holder__active::-ms-input-placeholder,
.input-active input[type=tel]::-ms-input-placeholder,
input[type=tel].input-active::-ms-input-placeholder,
input[type=date].p-holder__active::-ms-input-placeholder,
.input-active input[type=date]::-ms-input-placeholder,
input[type=date].input-active::-ms-input-placeholder,
select.p-holder__active::-ms-input-placeholder,
select.input-active::-ms-input-placeholder,
textarea.p-holder__active::-ms-input-placeholder,
textarea.input-active::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--color-primary);
}
input[type=text].p-holder__error, .input-error input[type=text], input[type=text].input-error,
input[type=password].p-holder__error,
.input-error input[type=password],
input[type=password].input-error,
input[type=email].p-holder__error,
.input-error input[type=email],
input[type=email].input-error,
input[type=number].p-holder__error,
.input-error input[type=number],
input[type=number].input-error,
input[type=tel].p-holder__error,
.input-error input[type=tel],
input[type=tel].input-error,
input[type=date].p-holder__error,
.input-error input[type=date],
input[type=date].input-error,
select.p-holder__error,
select.input-error,
textarea.p-holder__error,
textarea.input-error {
  border-color: #f4282d;
  /* -- Placeholder -- */
}
input[type=text].p-holder__error::placeholder, .input-error input[type=text]::placeholder, input[type=text].input-error::placeholder,
input[type=password].p-holder__error::placeholder,
.input-error input[type=password]::placeholder,
input[type=password].input-error::placeholder,
input[type=email].p-holder__error::placeholder,
.input-error input[type=email]::placeholder,
input[type=email].input-error::placeholder,
input[type=number].p-holder__error::placeholder,
.input-error input[type=number]::placeholder,
input[type=number].input-error::placeholder,
input[type=tel].p-holder__error::placeholder,
.input-error input[type=tel]::placeholder,
input[type=tel].input-error::placeholder,
input[type=date].p-holder__error::placeholder,
.input-error input[type=date]::placeholder,
input[type=date].input-error::placeholder,
select.p-holder__error::placeholder,
select.input-error::placeholder,
textarea.p-holder__error::placeholder,
textarea.input-error::placeholder {
  color: #f4282d;
  /* Firefox */
  opacity: 1;
}
input[type=text].p-holder__error:-ms-input-placeholder, .input-error input[type=text]:-ms-input-placeholder, input[type=text].input-error:-ms-input-placeholder,
input[type=password].p-holder__error:-ms-input-placeholder,
.input-error input[type=password]:-ms-input-placeholder,
input[type=password].input-error:-ms-input-placeholder,
input[type=email].p-holder__error:-ms-input-placeholder,
.input-error input[type=email]:-ms-input-placeholder,
input[type=email].input-error:-ms-input-placeholder,
input[type=number].p-holder__error:-ms-input-placeholder,
.input-error input[type=number]:-ms-input-placeholder,
input[type=number].input-error:-ms-input-placeholder,
input[type=tel].p-holder__error:-ms-input-placeholder,
.input-error input[type=tel]:-ms-input-placeholder,
input[type=tel].input-error:-ms-input-placeholder,
input[type=date].p-holder__error:-ms-input-placeholder,
.input-error input[type=date]:-ms-input-placeholder,
input[type=date].input-error:-ms-input-placeholder,
select.p-holder__error:-ms-input-placeholder,
select.input-error:-ms-input-placeholder,
textarea.p-holder__error:-ms-input-placeholder,
textarea.input-error:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #f4282d;
}
input[type=text].p-holder__error::-ms-input-placeholder, .input-error input[type=text]::-ms-input-placeholder, input[type=text].input-error::-ms-input-placeholder,
input[type=password].p-holder__error::-ms-input-placeholder,
.input-error input[type=password]::-ms-input-placeholder,
input[type=password].input-error::-ms-input-placeholder,
input[type=email].p-holder__error::-ms-input-placeholder,
.input-error input[type=email]::-ms-input-placeholder,
input[type=email].input-error::-ms-input-placeholder,
input[type=number].p-holder__error::-ms-input-placeholder,
.input-error input[type=number]::-ms-input-placeholder,
input[type=number].input-error::-ms-input-placeholder,
input[type=tel].p-holder__error::-ms-input-placeholder,
.input-error input[type=tel]::-ms-input-placeholder,
input[type=tel].input-error::-ms-input-placeholder,
input[type=date].p-holder__error::-ms-input-placeholder,
.input-error input[type=date]::-ms-input-placeholder,
input[type=date].input-error::-ms-input-placeholder,
select.p-holder__error::-ms-input-placeholder,
select.input-error::-ms-input-placeholder,
textarea.p-holder__error::-ms-input-placeholder,
textarea.input-error::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #f4282d;
}
input[type=text].p-holder__error:focus, .input-error input[type=text]:focus, input[type=text].input-error:focus,
input[type=password].p-holder__error:focus,
.input-error input[type=password]:focus,
input[type=password].input-error:focus,
input[type=email].p-holder__error:focus,
.input-error input[type=email]:focus,
input[type=email].input-error:focus,
input[type=number].p-holder__error:focus,
.input-error input[type=number]:focus,
input[type=number].input-error:focus,
input[type=tel].p-holder__error:focus,
.input-error input[type=tel]:focus,
input[type=tel].input-error:focus,
input[type=date].p-holder__error:focus,
.input-error input[type=date]:focus,
input[type=date].input-error:focus,
select.p-holder__error:focus,
select.input-error:focus,
textarea.p-holder__error:focus,
textarea.input-error:focus {
  border-color: #f4282d;
}
input[type=text]:focus,
input[type=password]:focus,
input[type=email]:focus,
input[type=number]:focus,
input[type=tel]:focus,
input[type=date]:focus,
select:focus,
textarea:focus {
  border-color: var(--color-primary);
}

input[type=checkbox],
input[type=radio] {
  opacity: 0;
  position: absolute;
}
input[type=checkbox] ~ label,
input[type=radio] ~ label {
  position: relative;
  font-size: 16px;
  line-height: 26px;
  color: var(--body-color);
  font-weight: 500;
  padding-left: 34px;
  cursor: pointer;
  margin-bottom: 0;
}
input[type=checkbox] ~ label::before,
input[type=radio] ~ label::before {
  content: " ";
  position: absolute;
  top: 1px;
  left: -3px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 1px solid var(--color-primary);
  border-radius: 2px;
  transition: all 0.3s;
}
input[type=checkbox] ~ label::after,
input[type=radio] ~ label::after {
  content: "";
  position: absolute;
  top: 5px;
  left: 1px;
  width: 12px;
  height: 8px;
  background-color: transparent;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  border-radius: 2px;
  transform: rotate(-45deg);
  opacity: 0;
  transition: all 0.3s;
}
input[type=checkbox]:checked ~ label::before,
input[type=radio]:checked ~ label::before {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
input[type=checkbox]:checked ~ label::after,
input[type=radio]:checked ~ label::after {
  opacity: 1;
}

input[type=radio] ~ label::before {
  border-radius: 50%;
}
input[type=radio] ~ label::after {
  width: 8px;
  height: 8px;
  left: 3px;
  top: 7px;
  background: #fff;
  border-radius: 50%;
}

.form-group {
  margin-bottom: 20px;
}
.form-group input {
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  height: 50px;
  font-size: 16px;
  padding: 0 15px;
}
.form-group input:focus {
  border-color: var(--color-primary);
}
.form-group textarea {
  min-height: 193px;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  resize: none;
  padding: 15px;
  font-size: 16px;
}
.form-group textarea:focus {
  border-color: var(--color-primary);
}

input[type=submit] {
  width: auto;
  font-size: 16px;
  letter-spacing: 2px;
  padding: 15px 20px;
  border-radius: 6px;
  display: block;
  font-weight: 500;
  transition: 0.3s;
  border: var(--border-width) solid var(--color-primary);
  background: var(--color-primary);
  color: #ffffff;
  height: 60px;
  margin-top: 30px;
}
input[type=submit]:hover {
  color: #ffffff;
  box-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);
  transform: translateY(-5px);
}

.contact-form--1 form input::-webkit-input-placeholder,
.contact-form--1 form textarea::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: var(--color-body) !important;
}

.contact-form--1 form input::-moz-placeholder,
.contact-form--1 form textarea::-moz-placeholder {
  /* Firefox 19+ */
  color: var(--color-body) !important;
}

.contact-form--1 form input:-ms-input-placeholder,
.contact-form--1 form textarea:-ms-input-placeholder {
  /* IE 10+ */
  color: var(--color-body) !important;
}

.contact-form--1 form input:-moz-placeholder,
.contact-form--1 form textarea:-moz-placeholder {
  /* Firefox 18- */
  color: var(--color-body) !important;
}

.login-register-page-wrapper .login-form-box {
  border: 1px solid #eeeeee;
  padding: 40px;
  border-radius: 10px;
  position: relative;
}
.login-register-page-wrapper .login-form-box input[type=checkbox] {
  width: auto;
}
.login-register-page-wrapper .login-form-box .lost-password {
  color: var(--color-secondary);
}

/**************************************
    Header Styles
***************************************/
/*--------------------------
    Header Styles  
--------------------------*/
.edu-header .logo a {
  display: block;
  height: 118px;
  line-height: 118px;
  transition: min-height 1s ease !important;
}
@media only screen and (max-width: 1199px) {
  .edu-header .logo a {
    height: 80px;
    line-height: 80px;
  }
}
.edu-header.disable-transparent .logo a {
  height: 90px;
  line-height: 90px;
}
.edu-header.header-relative {
  position: relative;
}
.edu-header.header-transparent {
  position: absolute;
  left: 0;
  right: 0;
  width: auto;
  background: transparent;
  backdrop-filter: inherit;
  z-index: 9;
}
.edu-header.header-sticky {
  transition: height 0.5s ease-in;
  max-width: 100%;
  z-index: 99;
}
.edu-header.header-sticky.sticky {
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-white) !important;
  width: 100%;
  height: 80px;
  animation: headerSticky 0.95s ease forwards;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.05);
  z-index: 10;
}
.edu-header.header-sticky.sticky .logo a {
  height: 80px;
  line-height: 80px;
}

/*------------------------
    Header Style One  
--------------------------*/
.header-default {
  max-width: 100%;
  background-color: var(--color-white);
  color: #fff;
  font-size: 12px;
  z-index: 99;
  position: relative;
}
.header-default .header-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

/*------------------------
    Header Style Two  
--------------------------*/
.header-style-2 {
  padding: 0 200px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .header-style-2 {
    padding: 0 30px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .header-style-2 {
    padding: 0 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-style-2 {
    padding: 0 30px;
  }
}
@media only screen and (max-width: 767px) {
  .header-style-2 {
    padding: 0 15px;
  }
}
.header-style-2 .header-menu-bar {
  display: flex;
  align-items: center;
}

.white-box-icon {
  height: 50px;
  line-height: 50px;
  width: 50px;
  text-align: center;
  border-radius: 5px;
  outline: none;
  color: var(--color-primary);
  border: 0 none;
  padding: 0;
  background: var(--color-white);
  display: block;
  font-size: 16px;
}
@media only screen and (max-width: 767px) {
  .white-box-icon {
    height: 40px;
    line-height: 40px;
    width: 40px;
  }
}

@keyframes headerSticky {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
/*--------------------------
    Navigation Styles 
----------------------------*/
.mainmenu-nav .mainmenu {
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: center;
  flex-wrap: wrap;
}
.mainmenu-nav .mainmenu > li > a {
  color: var(--color-heading);
  font-size: 16px;
  font-weight: 600;
  padding: 0 23px;
  display: block;
  height: 80px;
  line-height: 80px;
  transition: 0.3s;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .mainmenu-nav .mainmenu > li > a {
    padding: 0 17px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .mainmenu-nav .mainmenu > li > a {
    padding: 0 12px;
  }
}
.mainmenu-nav .mainmenu > li > a:hover, .mainmenu-nav .mainmenu > li > a.active {
  color: var(--color-primary) !important;
}
.mainmenu-nav .mainmenu li {
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
}
.mainmenu-nav .mainmenu li.has-droupdown > a {
  position: relative;
}
.mainmenu-nav .mainmenu li.has-droupdown > a::after {
  position: absolute;
  content: "\\e969";
  font-family: "icomoon";
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .mainmenu-nav .mainmenu li.has-droupdown > a::after {
    right: 0px;
  }
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu {
  min-width: 210px;
  height: auto;
  position: absolute;
  top: 90%;
  left: 0;
  z-index: 90;
  opacity: 0;
  visibility: hidden;
  text-align: left;
  padding: 20px 0;
  transition: 0.3s;
  background-color: var(--color-white);
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.04);
  border-bottom: 2px solid var(--color-primary);
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li {
  position: relative;
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li a {
  font-size: 16px;
  font-weight: 600;
  padding: 3px 20px;
  display: block;
  color: var(--color-heading);
  margin: 0 10px;
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover {
  color: var(--color-primary) !important;
  background: var(--color-darker);
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li a.active {
  color: var(--color-primary) !important;
  background: var(--color-darker);
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li.has-droupdown > a::after {
  content: "\\e92c";
  font-family: "icomoon";
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li.has-droupdown .submenu {
  left: 100%;
  top: 90%;
  z-index: 90;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li.has-droupdown:hover .submenu {
  left: 100%;
  top: 0;
  z-index: 90;
  opacity: 1;
  visibility: visible;
}
.mainmenu-nav .mainmenu li.has-droupdown:hover > .submenu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}

/*------------------------
    Header Quote  
-------------------------*/
.header-quote {
  display: flex;
  justify-content: flex-end;
  margin: 0 -17px;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .header-quote {
    margin: 0 -10px;
  }
}
.header-quote .quote-icon {
  margin: 0 17px;
}
@media only screen and (max-width: 767px) {
  .header-quote .quote-icon {
    margin: 0 10px;
  }
}
.header-quote .quote-icon a,
.header-quote .quote-icon button {
  padding: 0;
  border: 0 none;
  width: auto;
  background: transparent;
  display: flex;
  align-items: center;
}
.header-quote .quote-icon a i,
.header-quote .quote-icon button i {
  color: var(--color-heading);
  font-size: 16px;
  transition: 0.3s;
}
.header-quote .quote-icon a:hover i,
.header-quote .quote-icon button:hover i {
  color: var(--color-primary);
}

/*------------------------------
    Popup Menu Styles  
--------------------------------*/
.popup-mobile-menu {
  z-index: 9999;
  content: "";
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}
.popup-mobile-menu .inner {
  width: 320px;
  z-index: 999;
  position: absolute;
  background: #FFFFFF;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
  height: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  opacity: 0;
  left: -150px;
  transition: all 0.5s ease-out;
}
.popup-mobile-menu .inner .header-top {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}
.popup-mobile-menu .inner .header-top .logo a img {
  max-height: 45px;
  max-width: 160px;
}
.popup-mobile-menu .inner .header-top .close-menu .close-button {
  background: var(--color-white);
  border: 0 none;
  color: var(--color-heading);
  width: 40px;
  height: 40px;
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
}
.popup-mobile-menu.active {
  visibility: visible;
  opacity: 1;
}
.popup-mobile-menu.active .inner {
  opacity: 1;
  left: 0;
  overflow-y: auto;
}
.popup-mobile-menu .mainmenu {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 15px 20px;
}
.popup-mobile-menu .mainmenu li {
  margin: 0;
}
.popup-mobile-menu .mainmenu li a {
  padding: 8px 0;
  display: block;
  font-size: 16px;
  font-weight: 500;
}
.popup-mobile-menu .mainmenu li a.active {
  color: var(--color-primary) !important;
}
.popup-mobile-menu .mainmenu li + li {
  border-top: 1px solid var(--color-border);
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu {
  opacity: 0;
  height: 0;
  visibility: hidden;
  transition: all 0.3s;
  padding: 0;
  max-width: 100%;
  list-style: none;
  padding-left: 14px;
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu li a {
  font-size: 15px;
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu li a.active {
  color: var(--color-primary) !important;
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu.active {
  opacity: 1;
  height: 100%;
  visibility: visible;
}
.popup-mobile-menu .mainmenu .has-droupdown > a {
  position: relative;
}
.popup-mobile-menu .mainmenu .has-droupdown > a::after {
  position: absolute;
  content: "\\e935";
  font-family: "icomoon" !important;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s;
}
.popup-mobile-menu .mainmenu .has-droupdown > a.open::after {
  content: "\\e934";
}
.popup-mobile-menu .mainmenu .rn-megamenu {
  padding: 0;
  max-width: 100%;
  list-style: none;
  padding-left: 14px;
  display: none;
}
.popup-mobile-menu .mainmenu .mega-menu-item {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 0;
}
.popup-mobile-menu .mainmenu .mega-menu-item li a {
  font-size: 15px;
}
.popup-mobile-menu .mainmenu .mega-menu-item li:last-child {
  border-bottom: 1px solid var(--color-border);
}
.popup-mobile-menu .mainmenu .single-mega-item:last-child .mega-menu-item li:last-child {
  border-bottom-color: transparent;
}

/*----------------------
    Search Popup  
-----------------------*/
.edu-search-popup {
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  transform: scale(0.95);
}
.edu-search-popup.open {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
}
.edu-search-popup .close-button {
  position: absolute;
  right: 30px;
  top: 30px;
}
.edu-search-popup .close-button .close-trigger {
  background: var(--color-white);
  border: 0 none;
  color: var(--color-heading);
  width: 40px;
  height: 40px;
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
}
.edu-search-popup .inner {
  position: absolute;
  top: 46%;
  width: 100%;
}
.edu-search-popup .inner .search-form {
  text-align: center;
  max-width: 1170px;
  margin: 0 auto;
  position: relative;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .edu-search-popup .inner .search-form {
    padding: 0 20px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-search-popup .inner .search-form {
    padding: 0 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-search-popup .inner .search-form {
    padding: 0 20px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-search-popup .inner .search-form {
    padding: 0 20px;
  }
}
.edu-search-popup .inner .search-form input {
  height: 60px;
  border: 0 none;
  border-radius: 5px;
  background: #FFFFFF;
  padding: 0 30px;
  padding-right: 55px;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.edu-search-popup .inner .search-form .submit-button {
  position: absolute;
  right: 30px;
  padding: 0;
  margin: 0;
  border: 0 none;
  outline: none;
  color: var(--color-heading);
  background: transparent;
  top: 50%;
  transform: translateY(-50%);
}
.edu-search-popup::before {
  position: absolute;
  background: #2D284E;
  opacity: 0.7;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  z-index: -1;
}

/**************************************
    Elemnts Styles
***************************************/
/*-------------------
 * Button
---------------------*/
.wishlist-btn {
  background: rgba(45, 40, 78, 0.2);
  backdrop-filter: blur(10px);
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 100%;
  border: 0 none;
}
.wishlist-btn i {
  color: var(--color-white);
  font-size: 15px;
}

.button-group {
  margin: -5px;
}
.button-group a {
  margin: 5px;
}

a.btn-transparent,
button.btn-transparent {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-primary);
  display: inline-block;
  position: relative;
  transition: 0.3s;
}
a.btn-transparent::after,
button.btn-transparent::after {
  position: absolute;
  content: "";
  left: auto;
  right: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background: var(--color-primary);
  transition: 0.3s;
}
a.btn-transparent i,
button.btn-transparent i {
  padding-left: 10px;
  top: 3px;
  position: relative;
}
a.btn-transparent.sm-size,
button.btn-transparent.sm-size {
  font-size: 16px;
  line-height: 26px;
}
a.btn-transparent.heading-color,
button.btn-transparent.heading-color {
  color: var(--color-heading);
}
a.btn-transparent.heading-color i,
button.btn-transparent.heading-color i {
  color: var(--color-heading);
}
a.btn-transparent.heading-color:hover,
button.btn-transparent.heading-color:hover {
  color: var(--color-primary);
}
a.btn-transparent.heading-color:hover i,
button.btn-transparent.heading-color:hover i {
  color: var(--color-primary);
}
a.btn-transparent:hover::after,
button.btn-transparent:hover::after {
  width: 100%;
  left: 0;
  right: auto;
}

a.edu-btn,
button.edu-btn {
  border-radius: 5px;
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: var(--color-white);
  background: var(--color-primary);
  padding: 0 30px;
  font-size: 18px;
  font-weight: 700;
  transition: 0.4s;
  border: 0 none;
}
a.edu-btn i,
button.edu-btn i {
  padding-left: 10px;
  position: relative;
  top: 3px;
}
a.edu-btn.btn-medium,
button.edu-btn.btn-medium {
  height: 50px;
  line-height: 50px;
  padding: 0 25px;
  font-size: 16px;
}
a.edu-btn.btn-medium.header-button,
button.edu-btn.btn-medium.header-button {
  line-height: 47px;
}
a.edu-btn.btn-medium.header-button.bg-color-white,
button.edu-btn.btn-medium.header-button.bg-color-white {
  color: var(--color-primary);
}
a.edu-btn.btn-medium.header-button.purchase-button,
button.edu-btn.btn-medium.header-button.purchase-button {
  line-height: 50px;
}
a.edu-btn.btn-small,
button.edu-btn.btn-small {
  height: 36px;
  line-height: 36px;
  padding: 0 13px;
  font-size: 14px;
  font-weight: 600;
}
a.edu-btn.btn-small i,
button.edu-btn.btn-small i {
  padding-left: 7px;
}
a.edu-btn.left-icon i,
button.edu-btn.left-icon i {
  padding-left: 0;
  padding-right: 10px;
}
a.edu-btn:hover,
button.edu-btn:hover {
  background: var(--color-dark);
  color: var(--color-white);
}
a.edu-btn.btn-dark,
button.edu-btn.btn-dark {
  background: var(--color-dark);
  color: var(--color-white);
}
a.edu-btn.btn-dark:hover,
button.edu-btn.btn-dark:hover {
  color: var(--color-white);
  background: var(--color-primary);
}
a.edu-btn.btn-shade,
button.edu-btn.btn-shade {
  background: var(--color-shade);
  color: var(--color-heading);
}
a.edu-btn.btn-shade:hover,
button.edu-btn.btn-shade:hover {
  color: var(--color-white);
  background: var(--color-primary);
}
a.edu-btn.btn-secondary,
button.edu-btn.btn-secondary {
  background: var(--color-secondary);
  color: var(--color-white);
}
a.edu-btn.btn-secondary:hover,
button.edu-btn.btn-secondary:hover {
  color: var(--color-white);
  background: var(--color-primary);
}
a.edu-btn.btn-bg-alt,
button.edu-btn.btn-bg-alt {
  background: rgba(82, 95, 225, 0.1);
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  font-weight: 700;
  font-size: 18px;
  line-height: 59px;
}
a.edu-btn.btn-bg-alt:hover,
button.edu-btn.btn-bg-alt:hover {
  color: var(--color-white);
  background: var(--color-primary);
  border-color: var(--color-primary);
}
a.edu-btn.btn-white,
button.edu-btn.btn-white {
  background: var(--color-white);
  color: var(--color-primary);
}
a.edu-btn.btn-white:hover,
button.edu-btn.btn-white:hover {
  color: var(--color-white);
  background: var(--color-secondary);
}
a.edu-btn.btn-border,
button.edu-btn.btn-border {
  background: transparent;
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  line-height: 58px;
}

.bg-color-primary a.edu-btn.btn-white:hover,
.bg-color-primary button.edu-btn.btn-white:hover {
  background: var(--color-secondary);
}

.round-btn {
  display: flex;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: var(--color-white);
  justify-content: center;
  align-items: center;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);
}
.round-btn i {
  font-size: 24px;
  color: var(--color-primary);
  display: inline-block;
}

@keyframes rotateIt {
  to {
    transform: rotate(-360deg);
  }
}
/*--------------------------------
    Brands Area  
------------------------------*/
.eduvibe-home-five-brands .client-logo {
  transition: all 0.4s;
  display: inline-block;
}
@media only screen and (max-width: 991px) {
  .eduvibe-home-five-brands .client-logo {
    margin-bottom: 30px;
  }
}
.eduvibe-home-five-brands .client-logo:hover .logo-main, .eduvibe-home-five-brands .client-logo .logo-hover {
  display: none;
}
.eduvibe-home-five-brands .client-logo:hover .logo-hover {
  display: block !important;
}
.eduvibe-home-five-brands .client-logo img {
  display: flex;
}

/*---------------------------
 * Section Title
----------------------------*/
.section-title .pre-title {
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: inline-block;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.1em;
}
.section-title .title {
  margin-bottom: 0;
  font-size: 40px;
}
@media only screen and (max-width: 575px) {
  .section-title .title {
    font-size: 32px;
  }
}
@media only screen and (max-width: 767px) {
  .section-title .title br {
    display: none;
  }
}
.section-title.text-white .pre-title {
  color: var(--color-white);
}
.section-title.text-white .title {
  color: var(--color-white);
}

/*---------------------------
 * Home 1 Course
----------------------------*/
.eduvibe-home-one-course .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-one-course .shape-image.shape-image-1 {
  top: 59px;
  left: -246px;
}
.eduvibe-home-one-course .shape-image.shape-image-2 {
  top: 144px;
  right: -194px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-one-course .shape-image.shape-image-3 {
  bottom: 53px;
  right: -163px;
}
.eduvibe-home-one-course .shape-image.shape-image-4 {
  bottom: 157px;
  left: -226px;
  animation: eduvibe-vsm-y-reverse-move 3.5s alternate infinite linear;
}

/*---------------------------
 * Home 1 Testimonial
----------------------------*/
.eduvibe-testimonial-one {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.eduvibe-testimonial-one .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-testimonial-one .shape-image.shape-image-1 {
  top: 2px;
  left: -232px;
}
.eduvibe-testimonial-one .shape-image.shape-image-2 {
  top: 19px;
  right: -167px;
}
.eduvibe-testimonial-one .shape-image.shape-image-3 {
  bottom: 2px;
  right: -265px;
}
.eduvibe-testimonial-one .shape-image.shape-image-4 {
  bottom: -68px;
  left: -49px;
}

/*---------------------------
 * Home 1 Video
----------------------------*/
.eduvibe-home-one-video .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-one-video .shape-image.shape-image-1 {
  bottom: 80px;
  left: -232px;
  animation: eduvibe-rotate-x 15s infinite linear;
}
.eduvibe-home-one-video .shape-image.shape-image-2 {
  top: 20px;
  right: -262px;
}
.eduvibe-home-one-video .shape-image.shape-image-3 {
  bottom: 80px;
  right: -242px;
}

/*---------------------------
 * Home 1 Instructor
----------------------------*/
.eduvibe-home-one-instructor {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.eduvibe-home-one-instructor .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-one-instructor .shape-image.shape-image-1 {
  bottom: 29px;
  left: -59px;
}
.eduvibe-home-one-instructor .shape-image.shape-image-2 {
  top: 49px;
  right: -53px;
}

/*---------------------------
 * Newsletter 1
----------------------------*/
.newsletter-style-1 .shape-image {
  position: absolute;
  z-index: -1;
}
.newsletter-style-1 .shape-image.shape-image-1 {
  top: -68px;
  left: -20px;
}
.newsletter-style-1 .shape-image.shape-image-2 {
  top: -34px;
  right: -263px;
}
.newsletter-style-1 .shape-image.shape-image-3 {
  bottom: -95px;
  left: -178px;
}

/*---------------------------
 * Home 1 Blog
----------------------------*/
.eduvibe-home-one-blog {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  position: relative;
}
.eduvibe-home-one-blog .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-one-blog .shape-image.shape-image-1 {
  top: 71px;
  left: -228px;
  animation: eduvibe-vsm-y-move 5.6s alternate infinite linear;
}
.eduvibe-home-one-blog .shape-image.shape-image-2 {
  top: -20px;
  right: -215px;
  z-index: 0;
}
@media only screen and (max-width: 1650px) {
  .eduvibe-home-one-blog .shape-image.shape-image-2 {
    right: 5px;
    top: 45px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-home-one-blog .shape-image.shape-image-2 {
    display: none;
  }
}
.eduvibe-home-one-blog .shape-image.shape-image-3 {
  bottom: -102px;
  right: -260px;
}
.eduvibe-home-one-blog .shape-image.shape-image-4 {
  bottom: -74px;
  left: -208px;
}

/*---------------------------
 * Home 2 Service
----------------------------*/
.eduvibe-service-four .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-service-four .shape-image.shape-image-1 {
  bottom: 92px;
  left: -180px;
}
.eduvibe-service-four .shape-image.shape-image-2 {
  top: 71px;
  right: -52px;
}
.eduvibe-service-four .shape-image.shape-image-3 {
  bottom: -39px;
  right: -219px;
}

/*---------------------------
 * About 3
----------------------------*/
.about-style-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.about-style-3 .shape-image {
  position: absolute;
  z-index: -1;
}
.about-style-3 .shape-image.shape-image-1 {
  top: -3px;
  left: -259px;
}
.about-style-3 .shape-image.shape-image-2 {
  top: -31px;
  right: -269px;
}
.about-style-3 .shape-image.shape-image-3 {
  bottom: -31px;
  right: -209px;
}
.about-style-3 .shape-image.shape-image-4 {
  bottom: -61px;
  left: -269px;
}
.about-style-3 .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.about-style-3 .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.about-style-3 .shape-dot-wrapper .shape.shape-1 {
  bottom: -44px;
  left: -272px;
}
.about-style-3 .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 50px;
  height: 50px;
  background: var(--color-extra06);
  opacity: 0.8;
}
.about-style-3 .shape-dot-wrapper .shape.shape-2 {
  top: 14px;
  right: -228px;
}
.about-style-3 .shape-dot-wrapper .shape.shape-2 .shape-dot {
  width: 26px;
  height: 26px;
  background: var(--color-extra08);
  opacity: 0.35;
}

/*---------------------------
 * Home 2 Course
----------------------------*/
.eduvibe-home-two-course .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-course .shape-image.shape-image-1 {
  top: 177px;
  left: -203px;
  animation: eduvibe-vsm-y-move 4.5s alternate infinite linear;
}
.eduvibe-home-two-course .shape-image.shape-image-2 {
  bottom: 390px;
  right: -262px;
}
.eduvibe-home-two-course .shape-image.shape-image-3 {
  bottom: -40px;
  right: -17px;
  animation: eduvibe-vsm-y-reverse-move 4s alternate infinite linear;
}
.eduvibe-home-two-course .shape-image.shape-image-4 {
  bottom: -65px;
  left: -38px;
  animation: eduvibe-sm-x-move 4s alternate infinite linear;
}

/*---------------------------
 * Home 2 Event
----------------------------*/
.eduvibe-home-two-event {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.eduvibe-home-two-event .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-event .shape-image.shape-image-1 {
  top: -263px;
  left: -153px;
}
.eduvibe-home-two-event .shape-image.shape-image-2 {
  top: 101px;
  right: -28px;
}
.eduvibe-home-two-event .shape-image.shape-image-3 {
  bottom: -40px;
  right: -78px;
}
.eduvibe-home-two-event .shape-image.shape-image-4 {
  bottom: -90px;
  left: -208px;
}
.eduvibe-home-two-event .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-event .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-home-two-event .shape-dot-wrapper .shape.shape-1 {
  top: -232px;
  right: -124px;
}
.eduvibe-home-two-event .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 48px;
  height: 48px;
  border: 8px solid rgba(248, 111, 3, 0.3);
}

/*---------------------------
 * Home 2 Testimonial
----------------------------*/
.eduvibe-home-two-testimonial {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.eduvibe-home-two-testimonial .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-testimonial .shape-image.shape-image-1 {
  bottom: -53px;
  left: -193px;
}
.eduvibe-home-two-testimonial .shape-image.shape-image-2 {
  top: 27px;
  right: -183px;
}

/*---------------------------
 * Home 2 Counter
----------------------------*/
.eduvibe-home-two-counter .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-counter .shape-image.shape-image-1 {
  bottom: -33px;
  left: -33px;
}
.eduvibe-home-two-counter .shape-image.shape-image-2 {
  bottom: 143px;
  right: -243px;
}

/*---------------------------
 * Home 2 Blog
----------------------------*/
.eduvibe-home-two-blog {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  position: relative;
}
.eduvibe-home-two-blog .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-two-blog .shape-image.shape-image-1 {
  top: -50px;
  left: -198px;
}
.eduvibe-home-two-blog .shape-image.shape-image-1 img {
  max-width: 60%;
}
.eduvibe-home-two-blog .shape-image.shape-image-2 {
  top: 112px;
  right: 107px;
  z-index: 0;
}
.eduvibe-home-two-blog .shape-image.shape-image-2 {
  top: 112px;
  right: 107px;
  z-index: 0;
}
@media only screen and (max-width: 1650px) {
  .eduvibe-home-two-blog .shape-image.shape-image-2 {
    right: 30px;
    top: 45px;
  }
}
.eduvibe-home-two-blog .shape-image.shape-image-3 {
  bottom: -84px;
  right: -218px;
}
.eduvibe-home-two-blog .shape-image.shape-image-4 {
  bottom: -62px;
  left: -50px;
}

/*---------------------------
 * Home 3 Service
----------------------------*/
.eduvibe-service-five .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-service-five .shape-image.shape-image-1 {
  top: 81px;
  right: -46px;
}
.eduvibe-service-five .shape-image.shape-image-2 {
  bottom: -40px;
  left: -250px;
}
.eduvibe-service-five .shape-image.shape-image-2 img {
  max-width: 80%;
}
.eduvibe-service-five .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-service-five .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-service-five .shape-dot-wrapper .shape.shape-1 {
  top: 111px;
  right: -50px;
}
.eduvibe-service-five .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 130px;
  height: 130px;
  background: var(--color-tertiary);
  opacity: 0.4;
}

/*---------------------------
 * Home 3 About
----------------------------*/
.home-three-about {
  position: relative;
}
.home-three-about .shape-image {
  position: absolute;
  z-index: -1;
}
.home-three-about .shape-image.shape-image-1 {
  top: 54px;
  right: -196px;
}
.home-three-about .shape-image.shape-image-2 {
  bottom: 27px;
  right: -108px;
}

/*---------------------------
 * Home 3 Course
----------------------------*/
.eduvibe-home-three-course {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.eduvibe-home-three-course .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-course .shape-image.shape-image-1 {
  top: -260px;
  left: -130px;
  animation: eduvibe-sm-x-move 6s alternate infinite linear;
}
.eduvibe-home-three-course .shape-image.shape-image-1 img {
  transform: rotate(90deg);
}
.eduvibe-home-three-course .shape-image.shape-image-2 {
  top: 484px;
  left: -282px;
  animation: eduvibe-vsm-y-reverse-move 5.5s alternate infinite linear;
}
.eduvibe-home-three-course .shape-image.shape-image-3 {
  top: 152px;
  right: -211px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-three-course .shape-image.shape-image-4 {
  bottom: 49px;
  right: -224px;
}
.eduvibe-home-three-course .shape-image.shape-image-5 {
  bottom: -47px;
  left: -289px;
}

/*---------------------------
 * Home 3 Video
----------------------------*/
.eduvibe-home-three-video {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: auto;
  background-repeat: no-repeat;
  background-position: top 15px left 10%;
}
.eduvibe-home-three-video .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-video .shape-image.shape-image-1 {
  top: -59px;
  right: -199px;
}
.eduvibe-home-three-video .shape-image.shape-image-2 {
  bottom: -47px;
  right: -63px;
}
.eduvibe-home-three-video .shape-image.shape-image-3 {
  bottom: -91px;
  left: -229px;
}

/*---------------------------
 * Home 3 Accordion
----------------------------*/
.eduvibe-home-three-accordion .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-accordion .shape-image.shape-image-2 {
  bottom: inherit;
  left: -170px;
  top: 56px;
}
.eduvibe-home-three-accordion .shape-image.shape-image-3 {
  bottom: 16px;
  left: inherit;
  right: -200px;
  top: inherit;
}
.eduvibe-home-three-accordion .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-accordion .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-home-three-accordion .shape-dot-wrapper .shape.shape-1 {
  top: 195px;
  left: -91px;
}
.eduvibe-home-three-accordion .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 200px;
  height: 200px;
  border: 34px solid rgba(248, 111, 3, 0.3);
}

/*---------------------------
 * Home 3 Testimonial
----------------------------*/
.eduvibe-home-three-testimonial {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.eduvibe-home-three-testimonial .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-testimonial .shape-image.shape-image-1 {
  left: -173px;
  top: 16px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-three-testimonial .shape-image.shape-image-2 {
  top: -34px;
  right: -268px;
}
.eduvibe-home-three-testimonial .shape-image.shape-image-3 {
  bottom: -45px;
  left: -37px;
}
.eduvibe-home-three-testimonial .shape-image.shape-image-4 {
  bottom: -25px;
  right: -218px;
}

/*---------------------------
 * Home 3 Event
----------------------------*/
.eduvibe-home-three-event .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-event .shape-image.shape-image-1 {
  left: -173px;
  top: 16px;
}
.eduvibe-home-three-event .shape-image.shape-image-2 {
  top: -34px;
  right: -180px;
}
.eduvibe-home-three-event .shape-image.shape-image-3 {
  bottom: -45px;
  right: -237px;
}
.eduvibe-home-three-event .shape-image.shape-image-4 {
  bottom: -25px;
  left: -218px;
}

/*---------------------------
 * Home 3 Nesletter
----------------------------*/
.eduvibe-home-three-newsletter {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.eduvibe-home-three-newsletter .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-three-newsletter .shape-image.shape-image-1 {
  left: -63px;
  top: -24px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-three-newsletter .shape-image.shape-image-2 {
  top: -4px;
  right: 100px;
}
.eduvibe-home-three-newsletter .shape-image.shape-image-3 {
  right: -194px;
  bottom: -104px;
}
.eduvibe-home-three-newsletter .shape-image.shape-image-4 {
  left: 216px;
  bottom: -48px;
}

/*---------------------------
 * Home 4 Service
----------------------------*/
.eduvibe-home-four-service .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-service .shape-image.shape-image-1 {
  top: 56px;
  left: -180px;
  animation: eduvibe-rotate-x 7s infinite linear;
}
.eduvibe-home-four-service .shape-image.shape-image-2 {
  top: 12px;
  right: -180px;
}
.eduvibe-home-four-service .shape-image.shape-image-3 {
  bottom: -38px;
  right: -25px;
}
.eduvibe-home-four-service .shape-image.shape-image-4 {
  bottom: -48px;
  left: -55px;
}

/*---------------------------
 * Home 4 About
----------------------------*/
.eduvibe-home-four-about .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-about .shape-image.shape-image-1 {
  bottom: 231px;
  left: -190px;
}
.eduvibe-home-four-about .shape-image.shape-image-2 {
  top: -59px;
  right: -297px;
}
.eduvibe-home-four-about .shape-image.shape-image-3 {
  bottom: 10px;
  right: -185px;
}
.eduvibe-home-four-about .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-about .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-home-four-about .shape-dot-wrapper .shape.shape-1 {
  bottom: 140px;
  left: -21px;
  z-index: 2;
}
.eduvibe-home-four-about .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 40px;
  height: 40px;
  border: 5.4px solid rgba(248, 111, 3, 0.5);
  animation: eduvibe-zoom2 2s infinite alternate;
}

/*---------------------------
 * Home 4 Course
----------------------------*/
.eduvibe-home-four-courses {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.eduvibe-home-four-courses .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-courses .shape-image.shape-image-1 {
  top: 6px;
  left: -150px;
}
.eduvibe-home-four-courses .shape-image.shape-image-2 {
  top: 38px;
  right: -175px;
}
.eduvibe-home-four-courses .shape-image.shape-image-3 {
  bottom: 30px;
  right: -230px;
}
.eduvibe-home-four-courses .shape-image.shape-image-4 {
  bottom: 80px;
  left: -189px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-four-courses .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-courses .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-home-four-courses .shape-dot-wrapper .shape.shape-1 {
  bottom: 13px;
  right: -196px;
}
.eduvibe-home-four-courses .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 40px;
  height: 40px;
  border: 5.4px solid rgba(251, 124, 86, 0.3);
  animation: eduvibe-zoom2 2s infinite alternate;
}

/*---------------------------
 * Home 4 Video PopUp
----------------------------*/
.eduvibe-home-four-video {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
@media only screen and (max-width: 991px) {
  .eduvibe-home-four-video {
    background-image: none;
  }
}
.eduvibe-home-four-video .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-video .shape-image.shape-image-1 {
  top: -33px;
  left: -30px;
}
.eduvibe-home-four-video .shape-image.shape-image-2 {
  bottom: -50px;
  left: -48px;
}

/*---------------------------
 * Home 4 Team
----------------------------*/
.eduvibe-home-four-team {
  padding: 130px 0 275px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
@media only screen and (max-width: 991px) {
  .eduvibe-home-four-team {
    padding: 80px 0 160px;
  }
}
.eduvibe-home-four-team .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-team .shape-image.shape-image-1 {
  top: 38px;
  left: -181px;
  animation: eduvibe-sm-x-move 3.5s alternate infinite linear;
}
.eduvibe-home-four-team .shape-image.shape-image-2 {
  top: -24px;
  right: -216px;
}
.eduvibe-home-four-team .shape-image.shape-image-3 {
  bottom: -30px;
  right: -151px;
}

/*---------------------------
 * Home 4 Testimonial
----------------------------*/
.eduvibe-home-four-testimonial .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-testimonial .shape-image.shape-image-1 {
  bottom: 5px;
  left: -200px;
}
.eduvibe-home-four-testimonial .shape-image.shape-image-2 {
  top: 0px;
  right: -200px;
}
.eduvibe-home-four-testimonial .shape-image.shape-image-3 {
  bottom: 0px;
  right: -121px;
}

/*---------------------------
 * Home 4 Blog
----------------------------*/
.eduvibe-home-four-blog {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.eduvibe-home-four-blog .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-four-blog .shape-image.shape-image-1 {
  top: 5px;
  left: -200px;
}
.eduvibe-home-four-blog .shape-image.shape-image-2 {
  bottom: -34px;
  right: -35px;
}
.eduvibe-home-four-blog .shape-image.shape-image-3 {
  bottom: -54px;
  left: -56px;
}

/*---------------------------
 * FAQ Page
----------------------------*/
.eduvibe-faq-page .animated-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-faq-page .animated-image.shape-image-1 {
  top: 60px;
  left: -59px;
  animation: eduvibe-sm-x-move 3s alternate infinite linear;
}
.eduvibe-faq-page .animated-image.shape-image-1 img {
  transform: rotate(90deg);
}
.eduvibe-faq-page .animated-image.shape-image-2 {
  top: 56px;
  right: -223px;
}
.eduvibe-faq-page .animated-image.shape-image-3 {
  bottom: 56px;
  right: -223px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-faq-page .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-faq-page .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-faq-page .shape-dot-wrapper .shape.shape-1 {
  bottom: 89px;
  left: -184px;
}
.eduvibe-faq-page .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 48px;
  height: 48px;
  border: 8px solid var(--color-extra07);
  animation: eduvibe-zoom1 2.6s infinite alternate;
}

/*---------------------------
 * 404 Page
----------------------------*/
.eduvibe-404-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.eduvibe-404-page .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-404-page .shape-image.shape-image-1 {
  top: 165px;
  left: -21px;
}
.eduvibe-404-page .shape-image.shape-image-2 {
  top: 100px;
  right: -247px;
}
.eduvibe-404-page .shape-image.shape-image-3 {
  top: 520px;
  right: 50px;
}
.eduvibe-404-page .shape-image.shape-image-4 {
  bottom: -61px;
  right: -247px;
}
.eduvibe-404-page .shape-image.shape-image-5 {
  left: 40px;
  bottom: -63px;
}
.eduvibe-404-page .shape-image.shape-image-6 {
  bottom: 180px;
  left: -200px;
}

/*---------------------------
 * Coming Soon Page
----------------------------*/
.eduvibe-coming-soon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.eduvibe-coming-soon .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-coming-soon .shape-image.shape-image-1 {
  top: -6px;
  left: -110px;
}
.eduvibe-coming-soon .shape-image.shape-image-2 {
  top: -83px;
  right: -107px;
}
.eduvibe-coming-soon .shape-image.shape-image-3 {
  bottom: 252px;
  right: -111px;
}
.eduvibe-coming-soon .shape-image.shape-image-4 {
  bottom: -100px;
  right: -234px;
}
.eduvibe-coming-soon .shape-image.shape-image-5 {
  bottom: -60px;
  left: -84px;
}
.eduvibe-coming-soon .shape-image.shape-image-6 {
  top: 390px;
  left: 0;
}

/*---------------------------
 * Contact Us Page
----------------------------*/
.eduvibe-contact-us .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-contact-us .shape-image.shape-image-1 {
  top: 132px;
  left: -40px;
}
.eduvibe-contact-us .shape-image.shape-image-2 {
  top: 95px;
  right: -59px;
}
.eduvibe-contact-us .shape-image.shape-image-3 {
  bottom: 79px;
  right: -197px;
}

/*---------------------------
 * Contact Me Page
----------------------------*/
.eduvibe-contact-me-top .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-contact-me-top .shape-image.shape-image-1 {
  bottom: 113px;
  left: -200px;
}
.eduvibe-contact-me-top .shape-image.shape-image-2 {
  right: -40px;
  top: 100px;
}
.eduvibe-contact-me-top .shape-image.shape-image-3 {
  top: 0;
  right: -250px;
}
.eduvibe-contact-me-top .shape-image.shape-image-4 {
  bottom: 6px;
  right: -200px;
}

.eduvibe-contact-me-bottom .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-contact-me-bottom .shape-image.shape-image-1 {
  top: 94px;
  left: -56px;
}
.eduvibe-contact-me-bottom .shape-image.shape-image-2 {
  top: 173px;
  right: -147px;
}
.eduvibe-contact-me-bottom .shape-image.shape-image-3 {
  bottom: -80px;
  right: -269px;
}
.eduvibe-contact-me-bottom .shape-image.shape-image-4 {
  bottom: -40px;
  left: -29px;
}
.eduvibe-contact-me-bottom .shape-image.shape-image-5 {
  bottom: -90px;
  left: -219px;
}

/*---------------------------
 * Pricing Plan Page
----------------------------*/
.eduvibe-pricing-plan-page .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-pricing-plan-page .shape-image.shape-image-1 {
  top: 324px;
  left: -199px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-pricing-plan-page .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-pricing-plan-page .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-pricing-plan-page .shape-dot-wrapper .shape.shape-1 {
  bottom: -6px;
  right: -46px;
}
.eduvibe-pricing-plan-page .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 110px;
  height: 110px;
  border: 18px solid rgba(255, 164, 27, 0.15);
}

/*---------------------------
 * Home 5 Categories
----------------------------*/
.eduvibe-home-five-cats .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-cats .shape-image.shape-image-1 {
  top: 80px;
  left: -235px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-five-cats .shape-image.shape-image-2 {
  top: 70px;
  right: -239px;
}
.eduvibe-home-five-cats .shape-image.shape-image-3 {
  bottom: 12px;
  right: 5px;
}
.eduvibe-home-five-cats .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-cats .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-home-five-cats .shape-dot-wrapper .shape.shape-1 {
  bottom: -6px;
  right: -46px;
}
.eduvibe-home-five-cats .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 110px;
  height: 110px;
  border: 18px solid rgba(255, 164, 27, 0.15);
}

/*---------------------------
 * Home 5 About
----------------------------*/
.eduvibe-home-five-about .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-about .shape-image.shape-image-1 {
  top: 58px;
  left: -24px;
}
.eduvibe-home-five-about .shape-image.shape-image-2 {
  top: 48px;
  right: -224px;
}
.eduvibe-home-five-about .shape-image.shape-image-3 {
  bottom: -62px;
  right: -164px;
}
.eduvibe-home-five-about .shape-image.shape-image-4 {
  bottom: 28px;
  left: -104px;
}
.eduvibe-home-five-about .shape-image.shape-image-5 {
  top: 188px;
  left: -224px;
}

/*---------------------------
 * Home 5 Course
----------------------------*/
.eduvibe-home-five-course {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.eduvibe-home-five-course .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-course .shape-image.shape-image-1 {
  top: -62px;
  left: -296px;
}
.eduvibe-home-five-course .shape-image.shape-image-2 {
  top: 19px;
  right: -217px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-five-course .shape-image.shape-image-3 {
  bottom: -55px;
  right: -207px;
}
.eduvibe-home-five-course .shape-image.shape-image-4 {
  bottom: -52px;
  left: -268px;
}

/*---------------------------
 * Home 5 Instructor
----------------------------*/
.eduvibe-home-five-instructor .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-instructor .shape-image.shape-image-1 {
  top: 198px;
  left: -35px;
}
.eduvibe-home-five-instructor .shape-image.shape-image-2 {
  top: 36px;
  right: -123px;
}
.eduvibe-home-five-instructor .shape-image.shape-image-3 {
  bottom: 19px;
  right: -193px;
}
.eduvibe-home-five-instructor .shape-image.shape-image-4 {
  bottom: 91px;
  left: -165px;
}

/*---------------------------
 * Home 5 Progress
----------------------------*/
.eduvibe-home-five-progress {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.eduvibe-home-five-progress .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-progress .shape-image.shape-image-1 {
  top: -40px;
  left: -110px;
  animation: eduvibe-sm-x-move 4s alternate infinite linear;
}
.eduvibe-home-five-progress .shape-image.shape-image-2 {
  bottom: 110px;
  right: -242px;
  animation: eduvibe-vsm-y-move 4s alternate infinite linear;
}
.eduvibe-home-five-progress .shape-image.shape-image-3 {
  bottom: -49px;
  left: -242px;
}

/*---------------------------
 * Home 5 Testimonial
----------------------------*/
.eduvibe-home-five-testimonial .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-testimonial .shape-image.shape-image-1 {
  top: 38px;
  right: -230px;
}
.eduvibe-home-five-testimonial .shape-image.shape-image-2 {
  bottom: -15px;
  right: -183px;
}
.eduvibe-home-five-testimonial .shape-image.shape-image-3 {
  bottom: -45px;
  left: -183px;
}

/*---------------------------
 * Home 5 Blog
----------------------------*/
.eduvibe-home-five-blog {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  position: relative;
}
.eduvibe-home-five-blog .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-home-five-blog .shape-image.shape-image-1 {
  top: 30px;
  left: -228px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-home-five-blog .shape-image.shape-image-2 {
  top: 143px;
  right: 87px;
  z-index: 0;
}
@media only screen and (max-width: 1650px) {
  .eduvibe-home-five-blog .shape-image.shape-image-2 {
    top: 45px;
    right: 30px;
  }
}
.eduvibe-home-five-blog .shape-image.shape-image-3 {
  bottom: 38px;
  right: -240px;
}
.eduvibe-home-five-blog .shape-image.shape-image-4 {
  bottom: -45px;
  left: -30px;
}

/*---------------------------
 * About Us 1 Service
----------------------------*/
.eduvibe-about-us-one-service {
  position: relative;
}
.eduvibe-about-us-one-service .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-us-one-service .shape-image.shape-image-1 {
  top: 150px;
  left: -148px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-about-us-one-service .shape-image.shape-image-2 {
  top: 125px;
  right: -44px;
}
.eduvibe-about-us-one-service .shape-image.shape-image-3 {
  bottom: 13px;
  right: -200px;
}

/*---------------------------
 * About Us 1 Team
----------------------------*/
.eduvibe-about-one-team {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.eduvibe-about-one-team .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-one-team .shape-image.shape-image-1 {
  top: 41px;
  left: -228px;
}
.eduvibe-about-one-team .shape-image.shape-image-2 {
  top: 150px;
  right: 85px;
  z-index: 0;
}
@media only screen and (max-width: 1650px) {
  .eduvibe-about-one-team .shape-image.shape-image-2 {
    right: 30px;
    top: 45px;
  }
}
.eduvibe-about-one-team .shape-image.shape-image-3 {
  bottom: -42px;
  right: -240px;
}
.eduvibe-about-one-team .shape-image.shape-image-4 {
  bottom: -54px;
  left: -198px;
  animation: eduvibe-vsm-y-reverse-move 3.5s alternate infinite linear;
}

/*---------------------------
 * Home 4 Service
----------------------------*/
.eduvibe-about-one-service .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-one-service .shape-image.shape-image-1 {
  bottom: -7px;
  left: -50px;
}
.eduvibe-about-one-service .shape-image.shape-image-2 {
  top: 42px;
  right: -220px;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-1 {
  bottom: -34px;
  left: -48px;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 130px;
  height: 130px;
  background: var(--color-tertiary);
  opacity: 0.4;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-2 {
  top: 83px;
  left: -131px;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-2 .shape-dot {
  width: 12px;
  height: 12px;
  background: #9EDBE2;
  animation: eduvibe-zoom1 1s infinite alternate;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-3 {
  bottom: -16px;
  right: -63px;
}
.eduvibe-about-one-service .shape-dot-wrapper .shape.shape-3 .shape-dot {
  width: 8px;
  height: 8px;
  background: var(--color-secondary);
  animation: eduvibe-zoom1 1s infinite alternate;
}

/*--------------------------------
 * Home About Us 2 Service & Video
----------------------------------*/
.eduvibe-about-us-two-service .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-us-two-service .shape-image.shape-image-1 {
  top: 42px;
  left: -180px;
  animation: eduvibe-rotate-x 7s infinite linear;
}
.eduvibe-about-us-two-service .shape-image.shape-image-2 {
  bottom: -28px;
  right: -27px;
}

.eduvibe-about-us-two-video .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-us-two-video .shape-image.shape-image-1 {
  bottom: 66px;
  left: -120px;
  animation: eduvibe-sm-x-move 4.5s alternate infinite linear;
}
.eduvibe-about-us-two-video .shape-image.shape-image-2 {
  bottom: 90px;
  right: -120px;
  animation: eduvibe-rotate-x 7s infinite linear;
}

/*---------------------------
 * Home About Us 2 Award
----------------------------*/
.eduvibe-about-two-award .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-two-award .shape-image.shape-image-1 {
  top: -255px;
  left: -170px;
}
.eduvibe-about-two-award .shape-image.shape-image-2 {
  top: 97px;
  right: -39px;
}
.eduvibe-about-two-award .shape-image.shape-image-3 {
  bottom: -30px;
  left: -30px;
}
.eduvibe-about-two-award .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-two-award .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-about-two-award .shape-dot-wrapper .shape.shape-1 {
  top: -243px;
  right: -134px;
}
.eduvibe-about-two-award .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 30px;
  height: 30px;
  border: 5px solid rgba(255, 164, 27, 0.3);
  animation: eduvibe-zoom2 2s infinite alternate;
}

/*---------------------------
 * Home 5 Instructor
----------------------------*/
.eduvibe-about-us-two-instructor {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.eduvibe-about-us-two-instructor .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-us-two-instructor .shape-image.shape-image-1 {
  top: 198px;
  left: -35px;
}
.eduvibe-about-us-two-instructor .shape-image.shape-image-2 {
  top: 36px;
  right: -123px;
}
.eduvibe-about-us-two-instructor .shape-image.shape-image-3 {
  bottom: 19px;
  right: -193px;
}
.eduvibe-about-us-two-instructor .shape-image.shape-image-4 {
  bottom: 91px;
  left: -165px;
}

/*---------------------------
 * Home About Us 3 Mission
----------------------------*/
.eduvibe-about-three-mission .animated-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-mission .animated-image.shape-image-1 {
  top: 128px;
  left: -60px;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape.shape-1 {
  top: 38px;
  left: 188px;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 150px;
  height: 150px;
  background: #FFA41B;
  opacity: 0.6;
  border-radius: 5px;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape.shape-2 {
  top: -17px;
  right: -37px;
}
.eduvibe-about-three-mission .shape-dot-wrapper .shape.shape-2 .shape-dot {
  width: 100px;
  height: 100px;
  background: rgba(251, 124, 86, 0.6);
}

/*---------------------------
 * Home About Us 3 Team
----------------------------*/
.eduvibe-about-three-team .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-team .shape-image.shape-image-1 {
  top: 96px;
  left: -37px;
}
.eduvibe-about-three-team .shape-image.shape-image-2 {
  top: 8px;
  right: -240px;
}
.eduvibe-about-three-team .shape-image.shape-image-3 {
  bottom: -10px;
  right: -150px;
}
.eduvibe-about-three-team .shape-image.shape-image-4 {
  bottom: -21px;
  left: -220px;
}

/*---------------------------
 * Home About Us 3 funfact
----------------------------*/
.eduvibe-about-three-funfact .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-funfact .shape-image.shape-image-1 {
  top: 169px;
  left: -137px;
  animation: eduvibe-sm-x-move 2.5s alternate infinite linear;
}
.eduvibe-about-three-funfact .shape-image.shape-image-1 img {
  transform: rotate(90deg);
}
.eduvibe-about-three-funfact .shape-image.shape-image-2 {
  top: 8px;
  right: -200px;
  animation: eduvibe-sm-x-reverse-move 2.5s alternate infinite linear;
}
.eduvibe-about-three-funfact .shape-image.shape-image-2 img {
  transform: rotate(90deg);
}

/*---------------------------
 * About 3 Testimonial
----------------------------*/
.eduvibe-about-three-testimonial .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-testimonial .shape-image.shape-image-1 {
  left: -173px;
  top: 56px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.eduvibe-about-three-testimonial .shape-image.shape-image-2 {
  top: -14px;
  right: -268px;
}
.eduvibe-about-three-testimonial .shape-image.shape-image-3 {
  bottom: -45px;
  left: -37px;
}
.eduvibe-about-three-testimonial .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.eduvibe-about-three-testimonial .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.eduvibe-about-three-testimonial .shape-dot-wrapper .shape.shape-1 {
  bottom: -25px;
  right: -218px;
}
.eduvibe-about-three-testimonial .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 70px;
  height: 70px;
  border: 12px solid #FFDCB4;
}

.eduvibe-home-4-hero-svg path {
  animation: none;
  stroke-dasharray: 3000;
  stroke-dashoffset: 3000;
}

.sal-animate.eduvibe-home-4-hero-svg path {
  animation: eduvibe-svg-dash 6.5s linear forwards;
}
@keyframes eduvibe-svg-dash {
  to {
    stroke-dashoffset: 0;
  }
}
/*---------------------------
 Card Styles  
-----------------------------*/
.course-activation-item-2 .edu-card.card-type-2 {
  margin: 20px 0;
}

.video-gallery-overlay-area {
  padding-top: 400px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .video-gallery-overlay-area {
    padding-top: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .video-gallery-overlay-area {
    padding-top: 80px !important;
  }
}

.course-three-wrapper {
  position: relative;
  z-index: 1;
}
.course-three-wrapper .video-section-overlayto-another {
  margin-bottom: -400px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .course-three-wrapper .video-section-overlayto-another {
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  .course-three-wrapper .video-section-overlayto-another {
    margin-bottom: 0;
  }
}

.price-list {
  margin: -7.5px;
}
.price-list .price {
  margin: 7.5px;
  display: inline-block;
}
.price-list .current-price {
  font-weight: 700;
}
.price-list .old-price {
  font-weight: 500;
  text-decoration: line-through;
}
.price-list.price-style-01 {
  margin: -9px;
}
.price-list.price-style-01 .price {
  margin: 9px;
}
.price-list.price-style-01 .current-price {
  border-radius: 3px;
  background: var(--color-primary);
  font-weight: 700;
  font-size: 16px;
  color: var(--color-white);
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
  display: inline-block;
}
.price-list.price-style-02 {
  margin: -7.5px;
}
.price-list.price-style-02 .price {
  margin: 7.5px;
}
.price-list.price-style-02 .current-price {
  font-weight: 700;
  font-size: 20px;
  color: var(--color-heading);
}
.price-list.price-style-02 .old-price {
  font-weight: 600;
}
.price-list.price-style-03 {
  margin: -6px;
}
.price-list.price-style-03 .price {
  margin: 6px;
}
.price-list.price-style-03 .current-price {
  font-weight: 700;
  font-size: 20px;
  color: var(--color-primary);
  font-size: 20px;
}
.price-list.price-style-03 .old-price {
  font-weight: 500;
}

.edu-card {
  overflow: hidden;
}
.edu-card .thumbnail {
  position: relative;
}
.edu-card .thumbnail a {
  display: block;
  overflow: hidden;
}
.edu-card .thumbnail a img {
  transition: 0.4s;
  overflow: hidden;
}
.edu-card .thumbnail .top-position {
  position: absolute;
  z-index: 2;
}
.edu-card .thumbnail .wishlist-top-right {
  position: absolute;
  z-index: 2;
}
.edu-card.card-type-1 {
  background-color: var(--color-shade);
  transition: 0.4s;
}
.edu-card.card-type-1 .inner .thumbnail {
  position: relative;
}
.edu-card.card-type-1 .inner .thumbnail a {
  display: block;
  overflow: hidden;
}
.edu-card.card-type-1 .inner .thumbnail a img {
  transition: 0.4s;
  overflow: hidden;
}
.edu-card.card-type-1 .inner .thumbnail .top-position.left-top {
  left: 15px;
  top: 15px;
}
.edu-card.card-type-1 .inner .thumbnail .top-position.right-top {
  right: 15px;
  top: 15px;
}
.edu-card.card-type-1 .inner .thumbnail .wishlist-top-right {
  right: 20px;
  top: 20px;
}
.edu-card.card-type-1 .inner .content {
  padding: 25px 30px 30px;
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-1 .inner .content {
    padding: 25px 20px 25px;
  }
}
.edu-card.card-type-1 .inner .content .title {
  margin-bottom: 15px;
  margin-top: 10px;
}
.edu-card.card-type-1 .inner .content .edu-rating {
  margin-bottom: 25px;
}
.edu-card.card-type-1 .inner .content .card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--color-border);
  padding-top: 25px;
}
.edu-card.card-type-1:hover {
  background: var(--color-white);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.05);
}
.edu-card.card-type-1.bg-white {
  background-color: var(--color-white);
  transition: 0.4s;
}
.edu-card.card-type-1.bg-white:hover {
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
}
.edu-card.card-type-2 {
  background-color: var(--color-shade);
  padding: 20px 20px 30px;
  transition: 0.4s;
}
.edu-card.card-type-2 .inner .thumbnail a {
  border-radius: 3px;
}
.edu-card.card-type-2 .inner .thumbnail a img {
  border-radius: 3px;
}
.edu-card.card-type-2 .inner .thumbnail .top-position.left-top {
  left: 0;
  top: 10px;
}
.edu-card.card-type-2 .inner .thumbnail .wishlist-top-right {
  right: 20px;
  top: 10px;
}
.edu-card.card-type-2 .inner .content {
  padding-top: 25px;
}
.edu-card.card-type-2 .inner .content .card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.edu-card.card-type-2 .inner .content .title {
  margin-bottom: 20px;
}
.edu-card.card-type-2 .inner .content .card-bottom {
  display: flex;
  align-items: center;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid var(--color-border);
}
.edu-card.card-type-2:hover {
  background-color: var(--color-white);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
}
.edu-card.card-type-3 {
  background-color: var(--color-white);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);
  position: relative;
}
.edu-card.card-type-3 .inner .thumbnail a {
  border-radius: 3px;
}
.edu-card.card-type-3 .inner .thumbnail a img {
  border-radius: 3px;
}
.edu-card.card-type-3 .inner .thumbnail .top-position.left-bottom {
  left: 30px;
  bottom: -19px;
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-3 .inner .thumbnail .top-position.left-bottom {
    left: 20px;
  }
}
.edu-card.card-type-3 .inner .thumbnail .wishlist-top-right {
  right: 20px;
  top: 20px;
}
.edu-card.card-type-3 .inner .content {
  padding: 44px 30px 30px;
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-3 .inner .content {
    padding: 44px 20px 20px;
  }
}
.edu-card.card-type-3 .inner .content .card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-card.card-type-3 .inner .content .card-top {
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-card.card-type-3 .inner .content .card-top {
    flex-wrap: wrap;
  }
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-3 .inner .content .card-top {
    flex-wrap: wrap;
  }
}
.edu-card.card-type-3 .inner .content .card-top .author-meta {
  margin-right: 10px;
}
.edu-card.card-type-3 .inner .content .title {
  margin-bottom: 20px;
}
.edu-card.card-type-3 .inner .content .card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--color-border);
  padding-top: 25px;
  flex-wrap: wrap;
}
.edu-card.card-type-3 .card-hover-action {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--color-primary);
  opacity: 0;
  transition: 0.4s;
  box-shadow: 0px 12px 30px rgba(82, 95, 225, 0.1);
  border-radius: 5px;
  padding: 30px;
  z-index: 2;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-card.card-type-3 .card-hover-action {
    padding: 30px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-card.card-type-3 .card-hover-action {
    padding: 30px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-3 .card-hover-action {
    padding: 30px 20px;
  }
}
.edu-card.card-type-3 .card-hover-action .content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.edu-card.card-type-3 .card-hover-action .content-top .top-status-bar .eduvibe-status {
  background: rgba(255, 255, 255, 0.15);
  border: 0 none;
  line-height: 33px;
}
.edu-card.card-type-3 .card-hover-action .content-top .top-wishlist-bar .wishlist-btn {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}
.edu-card.card-type-3 .card-hover-action .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 20px;
}
.edu-card.card-type-3 .card-hover-action .title a {
  color: var(--color-white);
}
.edu-card.card-type-3 .card-hover-action .description {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 25px;
}
.edu-card.card-type-3 .card-hover-action .price-list {
  margin-bottom: 25px;
}
.edu-card.card-type-3 .card-hover-action .price-list .price {
  color: var(--color-white);
}
.edu-card.card-type-3 .card-hover-action .price-list .price.old-price {
  color: rgba(255, 255, 255, 0.8);
}
.edu-card.card-type-3 .card-hover-action .hover-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.edu-card.card-type-3 .card-hover-action .hover-bottom-content .author-meta .author-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-white);
}
.edu-card.card-type-3 .card-hover-action .hover-bottom-content .edu-meta li {
  color: var(--color-white);
}
.edu-card.card-type-3 .card-hover-action .hover-bottom-content .edu-meta li i {
  color: var(--color-white);
}
.edu-card.card-type-3:hover .card-hover-action {
  opacity: 1;
}
.edu-card.card-type-3.variation-2 {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);
}
.edu-card.card-type-3.variation-2 .inner .thumbnail .top-position.left-bottom {
  left: 30px;
  bottom: -13.5px;
}
.edu-card.card-type-3.variation-2 .inner .edu-meta.meta-01 {
  margin: 0 -10px;
}
.edu-card.card-type-3.variation-2 .inner .edu-meta.meta-01 li {
  font-weight: 500;
  line-height: 26px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.edu-card.card-type-3.variation-2 .inner .eduvibe-status.status-03 {
  color: var(--color-white);
  font-size: 14px;
  font-weight: 600;
  height: 27px;
  line-height: 27px;
  padding: 0 10px;
  background: var(--color-primary);
  border-radius: 4px;
  display: inline-block;
  border: 0 none;
}
.edu-card.card-type-3.variation-2 .inner .content {
  padding: 32px 30px 30px;
}
.edu-card.card-type-3.variation-2 .inner .content .title {
  margin-bottom: 20px;
  font-size: 20px;
  margin-top: 15px;
  line-height: 32px;
}
.edu-card.card-type-3.variation-2 .inner .content p {
  margin-bottom: 0;
}
.edu-card.card-type-4 {
  background-color: var(--color-shade);
  transition: 0.4s;
}
.edu-card.card-type-4 .inner {
  display: flex;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-card.card-type-4 .inner {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-4 .inner {
    display: block;
  }
}
.edu-card.card-type-4 .inner .thumbnail {
  flex-basis: 38.33%;
}
.edu-card.card-type-4 .inner .thumbnail a {
  height: 100%;
  display: block;
}
.edu-card.card-type-4 .inner .thumbnail a img {
  height: 100%;
  object-fit: cover;
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-4 .inner .thumbnail a img {
    max-height: 330px;
  }
}
.edu-card.card-type-4 .inner .thumbnail .top-position.left-top {
  left: 10px;
  top: 10px;
}
.edu-card.card-type-4 .inner .thumbnail .wishlist-top-right {
  right: 10px;
  top: 10px;
}
.edu-card.card-type-4 .inner .content {
  flex-basis: 61.66%;
  padding: 30px 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-card.card-type-4 .inner .content {
    padding: 30px 18px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-card.card-type-4 .inner .content {
    padding: 30px 18px;
  }
}
.edu-card.card-type-4 .inner .content .card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.edu-card.card-type-4 .inner .content .title {
  margin-bottom: 20px;
  margin-top: 20px;
}
.edu-card.card-type-4 .inner .content .card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.edu-card.card-type-4:hover {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
  background-color: var(--color-white);
}
.edu-card.card-type-4.bg-white {
  background-color: var(--color-white);
}
.edu-card.card-type-5 {
  background: var(--color-white);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
}
.edu-card.card-type-5 .inner {
  padding: 15px 15px 0;
}
.edu-card.card-type-5 .inner .thumbnail a {
  height: 100%;
  display: block;
  border-radius: 3px;
}
.edu-card.card-type-5 .inner .thumbnail a img {
  height: 100%;
  border-radius: 3px;
}
.edu-card.card-type-5 .inner .thumbnail .top-position.left-top {
  left: 10px;
  top: 10px;
}
.edu-card.card-type-5 .inner .thumbnail .wishlist-top-right {
  right: 10px;
  top: 10px;
}
.edu-card.card-type-5 .inner .content {
  padding: 25px 15px;
}
.edu-card.card-type-5 .inner .content .card-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.edu-card.card-type-5 .inner .content .title {
  margin-bottom: 20px;
  margin-top: 15px;
}
.edu-card.card-type-5 .inner .content .card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.edu-card.card-type-6 {
  background: var(--color-white);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
}
.edu-card.card-type-6 .inner {
  padding: 15px;
}
.edu-card.card-type-6 .inner .thumbnail {
  margin-bottom: 15px;
}
.edu-card.card-type-6 .inner .thumbnail a {
  height: 100%;
  display: block;
  border-radius: 3px;
}
.edu-card.card-type-6 .inner .thumbnail a img {
  height: 100%;
  border-radius: 3px;
}
.edu-card.card-type-6 .inner .thumbnail .top-position.left-top {
  left: 10px;
  top: 10px;
}
.edu-card.card-type-6 .inner .content .title {
  margin-bottom: 12px;
  margin-top: 10px;
  font-size: 18px;
  line-height: 28px;
}
.edu-card.card-type-6 .inner .content p {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 5px;
}
.edu-card:hover .thumbnail a img {
  transform: scale(1.1);
}

/*-----------------------
    Card Styles  
-------------------------*/
.edu-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
}
.edu-meta.meta-01 {
  margin: 0 -20px;
}
@media only screen and (max-width: 767px) {
  .edu-meta.meta-01 {
    margin: 0 -6px;
  }
}
.edu-meta.meta-01 li {
  font-weight: 500;
  line-height: 26px;
  margin: 0 20px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-meta.meta-01 li:first-child {
    margin-right: 10px;
  }
  .edu-meta.meta-01 li:last-child {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-meta.meta-01 li {
    margin: 0 6px;
  }
}
.edu-meta.meta-01 li i {
  color: var(--color-body);
  margin-right: 8px;
}
.edu-meta.meta-02 {
  margin: 0 -20px;
}
.edu-meta.meta-02 li {
  font-weight: 500;
  line-height: 26px;
  margin: 0 20px;
  display: flex;
  align-items: center;
}
.edu-meta.meta-02 li i {
  color: var(--color-primary);
  margin-right: 10px;
}
.edu-meta.meta-03 {
  margin: -5px -12px;
}
.edu-meta.meta-03 li {
  font-weight: 600;
  line-height: 22px;
  margin: 5px 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.edu-meta.meta-03 li i {
  color: var(--color-primary);
  margin-right: 10px;
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 1;
  text-align: center;
  line-height: 24px;
  border-radius: 2px;
}
.edu-meta.meta-03 li i::after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background: var(--color-primary);
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.1;
  border-radius: 2px;
}
.edu-meta.meta-03 li.meta-lessons i {
  color: var(--color-secondary);
}
.edu-meta.meta-03 li.meta-lessons i::after {
  background: var(--color-secondary);
}
.edu-meta.meta-03 li.meta-clock i {
  color: var(--color-primary);
}
.edu-meta.meta-03 li.meta-clock i::after {
  background: var(--color-primary);
}
.edu-meta.meta-03 li.meta-user i {
  color: var(--color-tertiary);
}
.edu-meta.meta-03 li.meta-user i::after {
  background: var(--color-tertiary);
}
.edu-meta.meta-03 li:last-child {
  margin-right: 0;
}
.edu-meta.meta-04 {
  margin: -5px -6px;
}
.edu-meta.meta-04 li {
  font-weight: 600;
  line-height: 22px;
  margin: 5px 6px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.edu-meta.meta-04 li i {
  color: var(--color-secondary);
  margin-right: 8px;
  font-size: 16px;
}

.edu-rating.rating-default {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.edu-rating.rating-default .rating {
  margin-right: 10px;
}

/*----------------------
    Author Meta  
-----------------------*/
.author-meta {
  display: flex;
  align-items: center;
}
.author-meta .author-thumb a {
  display: block;
  transition: 0.4s;
}
.author-meta .author-thumb a img {
  max-height: 34px;
  border-radius: 100%;
  margin-right: 10px;
  display: inline-block;
}
.author-meta .author-thumb a .author-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  transition: 0.4s;
}
.author-meta .author-thumb a:hover .author-title {
  color: var(--color-primary);
}

/*-----------------------
 Badge Style  
------------------------*/
.badge-transparent {
  display: inline-block;
  color: var(--color-primary);
  font-weight: 700;
  font-size: 20px;
}

.status-group {
  margin: -5px;
}
.status-group .eduvibe-status {
  margin: 5px;
}

.status-style-5 {
  display: flex;
  flex-wrap: wrap;
  margin: -5px -17px;
}
.status-style-5 .eduvibe-status {
  margin: 5px 17px;
}

.eduvibe-status.status-01 {
  color: var(--color-primary);
  font-size: 14px;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  background: var(--color-white);
  display: inline-block;
  border-radius: 2px;
}
.eduvibe-status.status-01.bg-primary-color {
  color: var(--color-white);
}
.eduvibe-status.status-01.bg-secondary-color {
  color: var(--color-white);
}
.eduvibe-status.status-02 {
  color: var(--color-white);
  font-size: 14px;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  background: var(--color-secondary);
  border-radius: 0 2px 2px 0;
  display: flex;
  align-items: center;
}
.eduvibe-status.status-02 i {
  margin-right: 5px;
}
.eduvibe-status.status-03 {
  color: var(--color-white);
  font-size: 14px;
  font-weight: 600;
  height: 34px;
  line-height: 30px;
  padding: 0 15px;
  background: var(--color-primary);
  border-radius: 2px;
  display: inline-block;
  border: 2px solid var(--color-white);
}
.eduvibe-status.status-04 {
  color: var(--color-white);
  font-size: 14px;
  font-weight: 600;
  height: 27px;
  line-height: 27px;
  padding: 0 10px;
  background: var(--color-secondary);
  border-radius: 2px;
  display: inline-block;
  text-transform: uppercase;
}
.eduvibe-status.status-05 {
  color: var(--color-body);
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  transition: 0.4s;
}
.eduvibe-status.status-05 i {
  color: var(--color-primary);
  margin-right: 9px;
}
.eduvibe-status.status-05:hover {
  color: var(--color-primary);
}
.eduvibe-status.status-06 {
  color: var(--color-white);
  font-size: 16px;
  font-weight: 700;
  height: 36px;
  line-height: 36px;
  padding: 0 20px 0 15px;
  background: var(--color-primary);
  display: inline-block;
  border-radius: 0px 18px 18px 0px;
}

.badge-default {
  border-radius: 3px;
  background: var(--color-primary);
  font-weight: 700;
  font-size: 16px;
  color: var(--color-white);
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
  display: inline-block;
}

/*--------------------------
    Pagination Styles  
----------------------------*/
.edu-pagination {
  margin: -5px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.edu-pagination li {
  margin: 5px;
  list-style: none;
}
.edu-pagination li a {
  width: 40px;
  height: 40px;
  background: var(--color-shade);
  display: inline-block;
  line-height: 40px;
  border-radius: 100%;
  text-align: center;
  color: var(--color-body);
  transition: 0.4s;
  font-size: 16px;
  font-weight: 500;
}
.edu-pagination li a i {
  font-size: 22px;
  font-weight: 500;
}
.edu-pagination li button {
  width: 40px;
  height: 40px;
  background: var(--color-shade);
  display: inline-block;
  line-height: 40px;
  border-radius: 100%;
  text-align: center;
  color: var(--color-body);
  transition: 0.4s;
  font-size: 16px;
  font-weight: 500;
  border: 0;
  border-color: transparent;
}
.edu-pagination li button i {
  font-size: 22px;
  font-weight: 500;
}
.edu-pagination li.active a,
.edu-pagination li.active button, .edu-pagination li:hover a,
.edu-pagination li:hover button {
  background: var(--color-primary);
  color: var(--color-white);
}

/*-------------------------
    Event Grid Style  
--------------------------*/
.edu-event .top-position {
  position: absolute;
  z-index: 2;
}
.edu-event .top-position.left-top {
  left: 0;
  top: 25px;
}
.edu-event .event-meta {
  display: flex;
  align-items: center;
}
.edu-event .event-meta li {
  font-weight: 500;
  font-size: 16px;
}
@media only screen and (max-width: 767px) {
  .edu-event .event-meta li {
    font-size: 14px;
  }
}
.edu-event .event-meta li i {
  padding-right: 8px;
  color: var(--color-primary);
}
.edu-event.event-grid-1 .inner {
  background: var(--color-white);
  transition: 0.4s;
}
.edu-event.event-grid-1 .inner .thumbnail {
  position: relative;
  overflow: hidden;
}
.edu-event.event-grid-1 .inner .thumbnail a {
  display: block;
}
.edu-event.event-grid-1 .inner .thumbnail a img {
  width: 100%;
  transition: 0.4s;
  overflow: hidden;
  border-radius: 5px 5px 0 0;
}
.edu-event.event-grid-1 .inner .content {
  padding: 30px;
}
@media only screen and (max-width: 767px) {
  .edu-event.event-grid-1 .inner .content {
    padding: 20px;
  }
}
.edu-event.event-grid-1 .inner .content .title {
  margin-top: 18px;
  margin-bottom: 18px;
}
@media only screen and (max-width: 767px) {
  .edu-event.event-grid-1 .inner .content .title {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
.edu-event.event-grid-1 .inner:hover {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
}
.edu-event.event-grid-1.bg-shade .inner {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
}
.edu-event.event-list .inner {
  display: flex;
  padding: 20px 40px 20px 20px;
  background: var(--color-shade);
  transition: 0.4s;
  border-radius: 5px;
  flex-wrap: wrap;
}
@media only screen and (max-width: 1199px) {
  .edu-event.event-list .inner {
    padding: 20px;
  }
}
.edu-event.event-list .inner .thumbnail {
  position: relative;
  overflow: hidden;
  flex-basis: 13%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-event.event-list .inner .thumbnail {
    flex-basis: 17%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-event.event-list .inner .thumbnail {
    flex-basis: 25%;
  }
}
@media only screen and (max-width: 767px) {
  .edu-event.event-list .inner .thumbnail {
    flex-basis: 32%;
  }
}
@media only screen and (max-width: 479px) {
  .edu-event.event-list .inner .thumbnail {
    flex-basis: 100%;
  }
}
.edu-event.event-list .inner .thumbnail a {
  display: block;
}
.edu-event.event-list .inner .thumbnail a img {
  width: 100%;
  transition: 0.4s;
  overflow: hidden;
  border-radius: 3px;
  min-width: 140px;
  min-height: auto;
  object-fit: cover;
}
.edu-event.event-list .inner .content {
  flex-basis: 87%;
  padding-left: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-event.event-list .inner .content {
    display: block;
    flex-basis: 83%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-event.event-list .inner .content {
    display: block;
    flex-basis: 75%;
  }
}
@media only screen and (max-width: 767px) {
  .edu-event.event-list .inner .content {
    display: block;
    flex-basis: 68%;
    padding-left: 20px;
  }
}
@media only screen and (max-width: 479px) {
  .edu-event.event-list .inner .content {
    flex-basis: 100%;
    padding-left: 0;
    margin-top: 20px;
  }
}
.edu-event.event-list .inner .content .title {
  margin-bottom: 15px;
}
@media only screen and (max-width: 767px) {
  .edu-event.event-list .inner .content .title {
    font-size: 18px;
  }
}
.edu-event.event-list .inner .content .event-meta {
  margin: 0 -18px;
  flex-wrap: wrap;
}
.edu-event.event-list .inner .content .event-meta li {
  margin: 0 18px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-event.event-list .inner .content .event-meta li {
    margin: 0 5px;
    font-size: 14px;
  }
}
.edu-event.event-list .inner .content .event-meta li i {
  color: var(--color-body);
  font-size: 18px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-event.event-list .inner .read-more-btn {
    margin-top: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-event.event-list .inner .read-more-btn {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-event.event-list .inner .read-more-btn {
    margin-top: 25px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-event.event-list .inner .read-more-btn a.edu-btn {
    padding: 0 25px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }
}
.edu-event.event-list .inner:hover {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
  background: var(--color-white);
}
.edu-event.event-list.bg-white .inner {
  background: #FFFFFF;
  transition: 0.4s;
}
.edu-event.event-list.bg-white:hover .inner {
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.05);
  background: var(--color-white);
}

/*-------------------------
    Team Styles  
--------------------------*/
.team-area-shape-position {
  position: relative;
}
.team-area-shape-position .shape-wrapper .shape {
  position: absolute;
}
.team-area-shape-position .shape-wrapper .shape.shape-1 {
  bottom: 86px;
  right: 5%;
}
.team-area-shape-position .shape-wrapper .shape.shape-2 {
  top: 130px;
  left: 136px;
}
.team-area-shape-position .shape-wrapper .shape.shape-3 {
  top: 148px;
  right: 88px;
}
.team-area-shape-position .shape-wrapper .shape.shape-4 {
  bottom: 115px;
  left: 127px;
}

.team-share-info {
  margin: -3px;
}
.team-share-info a {
  width: 34px;
  height: 34px;
  background: var(--color-white);
  line-height: 38px;
  text-align: center;
  border-radius: 100%;
  font-size: 14px;
  color: var(--color-primary);
  margin: 3px;
  transition: 0.4s;
}
.team-share-info a:hover {
  background: var(--color-primary);
  color: var(--color-white);
}

.edu-instructor-1 {
  text-align: center;
}
.edu-instructor-1 .edu-instructor {
  border-radius: 100%;
  position: relative;
  z-index: 2;
  transition: 0.3s;
}
.edu-instructor-1 .edu-instructor::after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  transition: 0.5s all;
}
.edu-instructor-1 .edu-instructor .inner {
  position: relative;
  padding: 20px;
}
.edu-instructor-1 .edu-instructor .inner .thumbnail a {
  display: block;
  position: relative;
}
.edu-instructor-1 .edu-instructor .inner .thumbnail a::after {
  background: var(--color-dark);
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.edu-instructor-1 .edu-instructor .inner .thumbnail a img {
  width: 100%;
  border-radius: 100%;
}
.edu-instructor-1 .edu-instructor .inner .team-share-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2;
}
.edu-instructor-1 .edu-instructor .inner .team-share-info a {
  display: inline-block;
  opacity: 0;
  visibility: hidden;
  transition: all 0.45s cubic-bezier(0.23, 0.88, 0.34, 0.99);
  transform: translateY(8px) scale(0.8);
}
.edu-instructor-1 .edu-instructor .inner .team-share-info a:nth-child(1) {
  transition-delay: 0.07692s;
}
.edu-instructor-1 .edu-instructor .inner .team-share-info a:nth-child(2) {
  transition-delay: 0.15385s;
}
.edu-instructor-1 .edu-instructor .inner .team-share-info a:nth-child(3) {
  transition-delay: 0.23077s;
}
.edu-instructor-1 .edu-instructor-info {
  margin-top: 25px;
}
.edu-instructor-1 .edu-instructor-info .title {
  margin-bottom: 5px;
}
.edu-instructor-1 .edu-instructor-info .desc {
  display: inline-block;
  color: var(--color-body);
  font-weight: 500;
  font-size: 16px;
  transition: 0.4s;
}
.edu-instructor-1:hover .edu-instructor::after {
  transform: rotate(90deg);
}
.edu-instructor-1:hover .edu-instructor .team-share-info a {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.edu-instructor-1:hover .edu-instructor .inner .thumbnail a::after {
  opacity: 0.4;
}
.edu-instructor-1:hover .edu-instructor-info .desc {
  color: var(--color-primary);
}

.edu-instructor-2 {
  text-align: center;
}
.edu-instructor-2 .edu-instructor {
  border-radius: 100%;
  position: relative;
  z-index: 2;
  transition: 0.3s;
}
.edu-instructor-2 .edu-instructor .inner {
  position: relative;
}
.edu-instructor-2 .edu-instructor .inner .thumbnail a {
  display: block;
  position: relative;
}
.edu-instructor-2 .edu-instructor .inner .thumbnail a::after {
  background: linear-gradient(180deg, rgba(45, 40, 78, 0) 0.01%, rgba(45, 40, 78, 0) 15.58%, rgba(45, 40, 78, 0.75) 100%);
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border-radius: 5px;
  border-radius: 185px 185px 5px 5px;
}
.edu-instructor-2 .edu-instructor .inner .thumbnail a img {
  width: 100%;
  border-radius: 185px 185px 5px 5px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.edu-instructor-2 .edu-instructor .inner .team-share-info {
  position: absolute;
  z-index: 2;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.edu-instructor-2 .edu-instructor .inner .team-share-info a {
  width: 40px;
  height: 40px;
  line-height: 43px;
  display: inline-block;
  opacity: 0;
  visibility: hidden;
  transition: all 0.45s cubic-bezier(0.23, 0.88, 0.34, 0.99);
  transform: translateY(8px) scale(0.8);
}
.edu-instructor-2 .edu-instructor .inner .team-share-info a:nth-child(1) {
  transition-delay: 0.07692s;
}
.edu-instructor-2 .edu-instructor .inner .team-share-info a:nth-child(2) {
  transition-delay: 0.15385s;
}
.edu-instructor-2 .edu-instructor .inner .team-share-info a:nth-child(3) {
  transition-delay: 0.23077s;
}
.edu-instructor-2 .edu-instructor .inner .team-share-info a:nth-child(4) {
  transition-delay: 0.31077s;
}
.edu-instructor-2 .edu-instructor-info {
  margin-top: 25px;
}
.edu-instructor-2 .edu-instructor-info .title {
  margin-bottom: 5px;
}
.edu-instructor-2 .edu-instructor-info .desc {
  display: inline-block;
  color: var(--color-body);
  font-weight: 500;
  font-size: 16px;
  transition: 0.4s;
}
.edu-instructor-2:hover .edu-instructor .team-share-info a {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.edu-instructor-2:hover .edu-instructor .inner .thumbnail a::after {
  border-radius: 5px;
  opacity: 1;
}
.edu-instructor-2:hover .edu-instructor .inner .thumbnail a img {
  border-radius: 5px;
}
.edu-instructor-2:hover .edu-instructor-info .desc {
  color: var(--color-primary);
}

.edu-instructor-3 {
  text-align: center;
}
.edu-instructor-3 .edu-instructor {
  border-radius: 100%;
  position: relative;
  z-index: 2;
  transition: 0.3s;
}
.edu-instructor-3 .edu-instructor .inner {
  position: relative;
}
.edu-instructor-3 .edu-instructor .inner .thumbnail a {
  display: block;
  position: relative;
}
.edu-instructor-3 .edu-instructor .inner .thumbnail a img {
  width: 100%;
  border-radius: 5px;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info {
  position: absolute;
  z-index: 2;
  bottom: -20px;
  width: 100%;
  text-align: left;
  background: #fff;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 25px 30px;
  opacity: 0;
  transition: 0.4s;
  left: 40px;
}
@media only screen and (max-width: 767px) {
  .edu-instructor-3 .edu-instructor .inner .edu-instructor-info {
    width: calc(100% - 30px);
  }
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .title {
  margin-bottom: 0;
  font-size: 20px;
  line-height: 32px;
  font-weight: 700;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .desc {
  display: inline-block;
  color: var(--color-body);
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  transition: 0.4s;
  margin-bottom: 15px;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info a {
  width: 40px;
  height: 40px;
  line-height: 43px;
  display: inline-block;
  transition: all 0.45s cubic-bezier(0.23, 0.88, 0.34, 0.99);
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info a:nth-child(1) {
  transition-delay: 0.07692s;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info a:nth-child(2) {
  transition-delay: 0.15385s;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info a:nth-child(3) {
  transition-delay: 0.23077s;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info a:nth-child(4) {
  transition-delay: 0.31077s;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info.bg-transparent {
  margin: -12px;
}
.edu-instructor-3 .edu-instructor .inner .edu-instructor-info .team-share-info.bg-transparent a {
  background: transparent;
  color: var(--color-primary);
  width: auto;
  height: auto;
  line-height: inherit;
  margin: 12px;
}
.edu-instructor-3.eduvibe-hover-active .edu-instructor .inner .edu-instructor-info {
  opacity: 1;
  left: 20px;
}
@media only screen and (max-width: 767px) {
  .edu-instructor-3.eduvibe-hover-active .edu-instructor .inner .edu-instructor-info {
    left: 0;
  }
}
.edu-instructor-3.edu-instructor-hover-visible:hover .edu-instructor-info {
  opacity: 1;
  left: 20px;
}
@media only screen and (max-width: 767px) {
  .edu-instructor-3.edu-instructor-hover-visible:hover .edu-instructor-info {
    left: 0;
  }
}

/*------------------------
    Service Style  
--------------------------*/
.service-wrapper-1 {
  position: relative;
}
.service-wrapper-1 .shape-image {
  position: absolute;
  z-index: -1;
}
.service-wrapper-1 .shape-image.shape-image-1 {
  top: -28px;
  left: -206px;
}
.service-wrapper-1 .shape-image.shape-image-2 {
  top: -51px;
  right: -257px;
}
.service-wrapper-1 .shape-image.shape-image-3 {
  bottom: 80px;
  right: -37px;
}
.service-wrapper-1 .shape-image.shape-image-4 {
  bottom: -25px;
  left: -201px;
}

.home-one-cat {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.service-card-1 {
  background: var(--color-white);
  overflow: hidden;
  text-align: center;
  position: relative;
  transition: 0.4s;
}
.service-card-1::after {
  position: absolute;
  content: "";
  left: 0;
  width: 0;
  height: 2px;
  background: var(--color-primary);
  transition: 0.4s;
  bottom: 0;
}
.service-card-1 .inner .thumbnail a img {
  width: 100%;
}
.service-card-1 .inner .content {
  padding: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-1 .inner .content {
    padding: 25px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-1 .inner .content {
    padding: 25px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-1 .inner .content {
    padding: 25px 20px;
  }
}
.service-card-1 .inner .content .course-total {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  display: inline-block;
  margin-bottom: 5px;
  color: var(--color-primary);
}
.service-card-1 .inner .content .title {
  margin-bottom: 20px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-1 .inner .content .title {
    margin-bottom: 6px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-1 .inner .content .title {
    margin-bottom: 6px;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-1 .inner .content .title {
    margin-bottom: 6px;
  }
}
.service-card-1 .inner .content .description {
  margin-bottom: 0;
}
.service-card-1:hover {
  transform: translateY(-15px);
}
.service-card-1:hover::after {
  width: 100%;
}

/*----------------------
    Service Style Two  
-----------------------*/
.service-card-2 {
  padding: 40px 30px;
  background: #EAF8F6;
  border-radius: 5px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-2 {
    padding: 40px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-2 {
    padding: 40px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-2 {
    padding: 40px 20px;
  }
}
.service-card-2 .inner {
  text-align: center;
}
.service-card-2 .inner .icon {
  position: relative;
  display: inline-block;
}
.service-card-2 .inner .icon a {
  width: 80px;
  height: 80px;
  background: var(--color-white);
  line-height: 80px;
  text-align: center;
  border-radius: 100%;
  margin: 0 auto;
  display: block;
}
.service-card-2 .inner .icon .shape-list .shape {
  position: absolute;
  z-index: 2;
}
.service-card-2 .inner .icon .shape-list .shape.shape-1 {
  bottom: 0;
  right: 0;
  transition: 0.4s;
  opacity: 0;
}
.service-card-2 .inner .icon .shape-list .shape.shape-2 {
  left: 0;
  top: 50%;
  transition: 0.4s;
  opacity: 0;
}
.service-card-2 .inner .icon .shape-list .shape.shape-3 {
  top: 0;
  right: 0;
  transition: 0.4s;
  opacity: 0;
}
.service-card-2 .inner .content .title {
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 15px;
  margin-top: 25px;
}
.service-card-2 .inner .content .description {
  margin-bottom: 0;
}
.service-card-2.card-bg-2 {
  background: #FFF3EE;
}
.service-card-2.card-bg-3 {
  background: #EFF4FC;
}
.service-card-2.card-bg-4 {
  background: #FFF1F1;
}
.service-card-2:hover .inner .icon .shape-list .shape.shape-1 {
  bottom: -8px;
  right: 3px;
  opacity: 1;
}
.service-card-2:hover .inner .icon .shape-list .shape.shape-2 {
  left: -20px;
  top: 50%;
  opacity: 1;
}
.service-card-2:hover .inner .icon .shape-list .shape.shape-3 {
  top: -5px;
  right: -1px;
  opacity: 1;
}

/*----------------------
    Service Style Three  
-----------------------*/
.video-section-overlayto-another {
  position: relative;
  margin-bottom: -281px;
  z-index: 1;
}

.service-wrapper-3 {
  position: relative;
  z-index: 1;
  padding-bottom: 281px;
}
.service-wrapper-3 .about-us-two-service-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.service-card-3 {
  padding: 30px 30px;
  background: var(--color-white);
  border-radius: 5px;
  transition: 0.4s;
  position: relative;
  z-index: 2;
}
.service-card-3 .inner {
  text-align: center;
}
.service-card-3 .inner .icon {
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
}
.service-card-3 .inner .icon a {
  width: 70px;
  height: 70px;
  background: var(--color-primary);
  text-align: center;
  margin: 0 auto;
  border-radius: 35px 35px 3px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.service-card-3 .inner .icon a i {
  font-size: 32px;
  color: var(--color-white);
}
.service-card-3 .inner .content .title {
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 15px;
}
.service-card-3 .inner .content .description {
  margin-bottom: 20px;
}
.service-card-3.shape-bg-1 .inner .icon a {
  background: rgba(113, 82, 233, 0.15);
}
.service-card-3.shape-bg-1 .inner .icon a i {
  color: var(--color-tertiary-2);
}
.service-card-3.shape-bg-1:hover .inner .icon a {
  background: var(--color-tertiary-2);
}
.service-card-3.shape-bg-2 .inner .icon a {
  background: rgba(255, 164, 27, 0.15);
}
.service-card-3.shape-bg-2 .inner .icon a i {
  color: var(--color-tertiary);
}
.service-card-3.shape-bg-2:hover .inner .icon a {
  background: var(--color-tertiary);
}
.service-card-3.shape-bg-3 .inner .icon a {
  background: rgba(82, 95, 225, 0.15);
}
.service-card-3.shape-bg-3 .inner .icon a i {
  color: var(--color-primary);
}
.service-card-3.shape-bg-3:hover .inner .icon a {
  background: var(--color-primary);
}
.service-card-3.shape-bg-4 .inner .icon a {
  background: rgba(248, 111, 3, 0.15);
}
.service-card-3.shape-bg-4 .inner .icon a i {
  color: var(--color-secondary);
}
.service-card-3.shape-bg-4:hover .inner .icon a {
  background: var(--color-secondary);
}
.service-card-3.text-left .inner {
  text-align: left;
}
.service-card-3.bg-grey {
  background: #F5F5F5;
  height: 100%;
}
.service-card-3.bg-grey:hover {
  background: var(--color-white);
  box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.07);
}
.service-card-3:hover {
  transform: translateY(-20px);
  box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.07);
}
.service-card-3:hover .inner .icon a i {
  color: #ffffff;
}

/*-------------------------------
    Service Style Four  
---------------------------------*/
.service-card-4 {
  height: 100%;
}
.service-card-4 .inner {
  background: #F5F5F5;
  border-radius: 5px;
  padding: 40px 35px;
  text-align: center;
  transition: 0.4s;
  height: 100%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-4 .inner {
    padding: 25px 14px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-4 .inner {
    padding: 25px 14px;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-4 .inner {
    padding: 25px 14px;
  }
}
.service-card-4 .inner .icon {
  position: relative;
}
.service-card-4 .inner .icon i {
  display: block;
  color: var(--color-primary);
  font-size: 35px;
}
.service-card-4 .inner .icon .subtitle {
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.4s;
}
.service-card-4 .inner .content .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 15px;
  margin-top: 25px;
}
.service-card-4 .inner .content .title a {
  transition: 0.4s;
  color: var(--color-heading);
}
.service-card-4 .inner .content .description {
  margin-bottom: 0;
  transition: 0.4s;
}
.service-card-4:hover .inner {
  background: var(--color-primary);
}
.service-card-4:hover .inner .icon i {
  opacity: 0;
}
.service-card-4:hover .inner .icon .subtitle {
  opacity: 1;
  color: var(--color-white);
}
.service-card-4:hover .inner .content .title a {
  color: var(--color-white);
}
.service-card-4:hover .inner .content .description {
  color: var(--color-white);
}

/*-------------------------------
    Service Style Five  
---------------------------------*/
.service-card-5 .inner {
  background: #F5F5F5;
  border-radius: 5px;
  padding: 20px;
  transition: 0.4s;
  display: flex;
  align-items: center;
}
.service-card-5 .inner .icon {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.02);
  border-radius: 2px;
  transition: 0.4s;
  justify-content: center;
  margin-right: 20px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-5 .inner .icon {
    margin-right: 15px;
  }
}
.service-card-5 .inner .icon i {
  color: var(--color-primary);
  font-size: 30px;
  transition: 0.4s;
}
.service-card-5 .inner .content .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 0;
  transition: 0.4s;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service-card-5 .inner .content .title {
    font-size: 17px;
    line-height: 28px;
  }
}
.service-card-5 .inner .content .description {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  transition: 0.4s;
}
.service-card-5:hover .inner {
  background: var(--color-primary);
}
.service-card-5:hover .inner .icon {
  box-shadow: none;
  background: rgba(255, 255, 255, 0.15);
}
.service-card-5:hover .inner .icon i {
  color: var(--color-white);
}
.service-card-5:hover .inner .content .title a {
  color: var(--color-white);
}
.service-card-5:hover .inner .content .description {
  color: var(--color-white);
}

/*-------------------------------
    Service Style 8  
---------------------------------*/
.service-activation-item5 .single-slick-card {
  margin-bottom: 20px;
}

.service-card-8 .inner {
  background: #EAF8F6;
  border-radius: 5px;
  text-align: center;
  padding: 30px;
  position: relative;
  transition: 0.4s;
  margin-bottom: 20px;
}
.service-card-8 .inner .icon {
  position: relative;
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-radius: 100%;
  justify-content: center;
  margin: 0 auto;
}
.service-card-8 .inner .content {
  margin-top: 20px;
}
.service-card-8 .inner .content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 5px;
}
.service-card-8 .inner .content span {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.service-card-8 .inner .hover-action {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  transition: 0.4s;
  opacity: 0;
}
.service-card-8 .inner .hover-action .read-more-btn {
  width: 40px;
  height: 40px;
  background: var(--color-primary);
  color: var(--color-white);
  display: inline-block;
  line-height: 43px;
  border-radius: 100%;
  font-size: 20px;
}
.service-card-8.shape-bg-2 .inner {
  background: #FFF3EE;
}
.service-card-8.shape-bg-3 .inner {
  background: #FAEFFA;
}
.service-card-8.shape-bg-4 .inner {
  background: #FFF1F1;
}
.service-card-8.shape-bg-5 .inner {
  background: #EFF4FC;
}
.service-card-8:hover .inner {
  padding-bottom: 50px;
  margin-bottom: -20px;
}
.service-card-8:hover .inner .hover-action {
  opacity: 1;
}

/*-------------------------------
    Service Style 7  
---------------------------------*/
.service-card-single {
  position: relative;
}
.service-card-single:first-child::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  content: "";
  width: 155px;
  height: 43px;
  right: -19%;
  top: 40px;
  background-size: cover;
  background-position: center center;
  position: absolute;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-single:first-child::after {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-single:first-child::after {
    display: none;
  }
}
.service-card-single:last-child::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  content: "";
  width: 155px;
  height: 43px;
  left: -19%;
  top: 0;
  background-size: cover;
  background-position: center center;
  position: absolute;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service-card-single:last-child::after {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .service-card-single:last-child::after {
    display: none;
  }
}

.service-card-7 {
  position: relative;
}
.service-card-7 .arrow-icon {
  position: absolute;
  left: 100%;
  top: 40px;
  z-index: 1;
}
.service-card-7 .inner {
  text-align: center;
}
.service-card-7 .inner .icon {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  background: var(--color-secondary);
  border-radius: 100%;
  justify-content: center;
  margin: 0 auto;
  color: var(--color-white);
  margin-bottom: 35px;
}
.service-card-7 .inner .icon i {
  color: var(--color-white);
  font-size: 32px;
  display: flex;
}
.service-card-7 .inner .content .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 15px;
}
.service-card-7 .inner .content p {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.service-card-7.shape-bg-2 .inner .icon {
  background: var(--color-primary);
}
.service-card-7.shape-bg-3 .inner .icon {
  background: #FFA41B;
}
/*-----------------------------
    Single Elements Styles  
------------------------------*/
.short-by p {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
}
.short-by p span {
  font-weight: 600;
  color: var(--color-heading);
}

.edu-search-box {
  position: relative;
  display: inline-block;
}
.edu-search-box input {
  height: 60px;
  background: var(--color-shade);
  font-weight: 600;
  font-size: 16px;
  color: var(--color-body);
  padding: 0 25px;
  min-width: 350px;
  border: 0 none;
  border-radius: 5px;
  padding-right: 48px;
}
@media only screen and (max-width: 479px) {
  .edu-search-box input {
    min-width: 100%;
  }
}
.edu-search-box .search-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  padding: 0;
  border: 0 none;
  background: transparent;
}
.edu-search-box .search-button i {
  font-size: 17px;
}

.edu-shorting-style-1 {
  display: inline-block;
  position: relative;
}
.edu-shorting-style-1 .icon {
  display: flex;
  align-items: center;
  margin-right: 17px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
}
.edu-shorting-style-1 .icon i {
  font-size: 20px;
  color: var(--color-body);
}
.edu-shorting-style-1 .edu-select {
  transition: 0.3s;
  line-height: 28px;
  outline: none;
  color: var(--color-body);
  appearance: none;
  border: 0 none;
  border-radius: var(--radius);
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  padding-right: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) 92% center no-repeat transparent;
  border-radius: 5px;
  background-color: #F5F5F5;
  max-width: 256px;
  align-items: center;
  padding: 0 30px;
  height: 60px;
  cursor: pointer;
  min-width: 256px;
  cursor: pointer;
}

/*----------------------------
    Course Sidebar Styles 
-----------------------------*/
.edu-course-widget {
  background: var(--color-shade);
  padding: 20px 30px 30px;
  border-radius: 5px;
}
.edu-course-widget .widget-title {
  border-bottom: 1px solid rgba(45, 40, 78, 0.07);
  padding-bottom: 20px;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}
.edu-course-widget .content {
  margin-top: 30px;
}
.edu-course-widget .content .edu-form-check {
  position: relative;
}
.edu-course-widget .content .edu-form-check + .edu-form-check {
  margin-top: 25px;
}
.edu-course-widget.widget-category label {
  display: flex;
  justify-content: space-between;
}

/*--------------------------
    Testimonial Area  
----------------------------*/
.satisfied-learner {
  padding-right: 70px;
  position: relative;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .satisfied-learner {
    padding-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .satisfied-learner {
    padding-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .satisfied-learner {
    padding-right: 0;
  }
}
.satisfied-learner .thumbnail img {
  width: 100%;
  border-radius: 5px;
}
.satisfied-learner .trophy-content {
  width: 235px;
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
  display: flex;
  border-radius: 5px;
  padding: 20px 25px;
  align-items: center;
  position: absolute;
  top: 97px;
  left: -164px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .satisfied-learner .trophy-content {
    top: auto;
    left: 10px;
    bottom: 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .satisfied-learner .trophy-content {
    top: auto;
    left: 10px;
    bottom: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .satisfied-learner .trophy-content {
    top: auto;
    left: 10px;
    bottom: 10px;
  }
}
.satisfied-learner .trophy-content .icon {
  min-width: 49px;
  min-height: 49px;
  object-fit: cover;
  margin-right: 20px;
}
.satisfied-learner .trophy-content .content .text {
  font-weight: 700;
  font-size: 20px;
  line-height: 34px;
  margin-bottom: 0;
}
.satisfied-learner .trophy-content .content span {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

.testimonial-style-1 {
  margin-top: 25px;
}
@media only screen and (max-width: 1199px) {
  .testimonial-style-1 {
    margin-top: 0px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .testimonial-style-1.edu-slick-button.slick-button-left .slick-dots {
    bottom: -10px;
  }
}
.testimonial-style-1 .single-testimonial .inner .quote-sign {
  margin-bottom: 50px;
  display: inline-block;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .testimonial-style-1 .single-testimonial .inner .quote-sign {
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 991px) {
  .testimonial-style-1 .single-testimonial .inner .quote-sign {
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
.testimonial-style-1 .single-testimonial .inner .description {
  margin-bottom: 50px;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.5;
}
@media only screen and (max-width: 991px) {
  .testimonial-style-1 .single-testimonial .inner .description {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .testimonial-style-1 .single-testimonial .inner .description {
    margin-bottom: 30px;
  }
}
.testimonial-style-1 .single-testimonial .inner .client-information {
  display: flex;
  align-items: center;
}
.testimonial-style-1 .single-testimonial .inner .client-information .thumb {
  margin-right: 20px;
  min-width: 80px;
}
.testimonial-style-1 .single-testimonial .inner .client-information .thumb img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  object-fit: cover;
}
.testimonial-style-1 .single-testimonial .inner .client-information .info .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 5px;
}
.testimonial-style-1 .single-testimonial .inner .client-information .info .designation {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
}

/*-----------------------------
    Testimonial Card Layout  
------------------------------*/
.testimonial-card-box {
  padding: 15px;
}
.testimonial-card-box .inner {
  position: relative;
  background: var(--color-white);
  border-radius: 5px;
  padding: 30px;
  margin-bottom: 40px;
}
.testimonial-card-box .inner::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 33px 0 0 27px;
  border-color: transparent transparent transparent var(--color-white);
  top: calc(99% - 1px);
  transform: rotate(90deg);
  z-index: 2;
  border-bottom-right-radius: 4px;
}
.testimonial-card-box .inner .description {
  margin-bottom: 22px;
}
.testimonial-card-box .inner .client-info {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}
.testimonial-card-box .inner .client-info .thumbnail {
  margin-right: 15px;
}
.testimonial-card-box .inner .client-info .thumbnail img {
  max-height: 55px;
  height: 55px;
  object-fit: cover;
  border-radius: 3px;
}
.testimonial-card-box .inner .client-info .content .title {
  margin-bottom: 1px;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box .inner .client-info .content .title {
    font-size: 18px;
    line-height: 29px;
  }
}
.testimonial-card-box .inner .client-info .content .designation {
  color: var(--color-primary);
  font-weight: 500;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-card-box.variation-2 {
    padding: 0;
  }
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box.variation-2 {
    padding: 0;
  }
}
.testimonial-card-box.variation-2 .inner {
  padding: 50px;
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box.variation-2 .inner {
    padding: 50px 30px;
  }
}
.testimonial-card-box.variation-2 .inner::after {
  display: none;
}
.testimonial-card-box.variation-2 .inner .rating {
  margin-bottom: 40px;
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box.variation-2 .inner .rating {
    margin-bottom: 20px;
  }
}
.testimonial-card-box.variation-2 .inner .description {
  margin-bottom: 40px;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box.variation-2 .inner .description {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 28px;
  }
}
.testimonial-card-box.variation-2 .inner .client-info {
  margin-bottom: 0;
}
@media only screen and (max-width: 479px) {
  .testimonial-card-box.variation-2 .inner .client-info {
    display: block;
  }
}
.testimonial-card-box.variation-2 .inner .client-info .thumbnail {
  margin-right: 20px;
}
@media only screen and (max-width: 479px) {
  .testimonial-card-box.variation-2 .inner .client-info .thumbnail {
    margin-right: 0;
    margin-bottom: 20px;
  }
}
.testimonial-card-box.variation-2 .inner .client-info .thumbnail img {
  max-height: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 100%;
}
.testimonial-card-box.variation-3 {
  padding: 0;
}
.testimonial-card-box.variation-3 .description {
  margin-bottom: 64px;
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
}
@media only screen and (max-width: 767px) {
  .testimonial-card-box.variation-3 .description {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 28px;
  }
}
.testimonial-card-box.variation-3 .client-info {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.testimonial-card-box.variation-3 .client-info .thumbnail {
  margin-right: 15px;
}
.testimonial-card-box.variation-3 .client-info .thumbnail img {
  max-height: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 100%;
}
.testimonial-card-box.variation-3 .client-info .content .title {
  margin-bottom: 2px;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
}
.testimonial-card-box.variation-3 .client-info .content .designation {
  color: var(--color-primary);
  font-weight: 500;
}

.testimonial-style-5 {
  position: relative;
}
.testimonial-style-5::before {
  position: absolute;
  content: "";
  background: var(--color-primary);
  width: 610px;
  top: 0;
  height: 100%;
  left: 0;
}
@media only screen and (min-width: 1401px) and (max-width: 1750px) {
  .testimonial-style-5::before {
    width: 29%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .testimonial-style-5::before {
    width: 27%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .testimonial-style-5::before {
    width: 29%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-style-5::before {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .testimonial-style-5::before {
    display: none;
  }
}
.testimonial-style-5 .banner-thumbnail {
  display: inline-block;
  position: relative;
  z-index: 1;
}
.testimonial-style-5 .banner-thumbnail::after {
  border: 5px solid rgba(251, 124, 86, 0.5);
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 20px;
  border-radius: 250px;
  z-index: -1;
}
@media only screen and (max-width: 767px) {
  .testimonial-style-5 .banner-thumbnail::after {
    display: none;
  }
}
.testimonial-style-5 .banner-thumbnail img {
  border-radius: 250px;
}
.testimonial-style-5 .content-wrapper {
  position: relative;
  z-index: 1;
}
.testimonial-style-5 .content-wrapper .comment-images {
  position: absolute;
  right: 0;
  z-index: -1;
  bottom: -8%;
}
.testimonial-style-5 .main-image {
  position: absolute;
  left: 0;
  top: 0;
}

/*--------------------------
    Testimonial Style Two  
----------------------------*/
.testimonial-nav-content .description {
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 30px;
}
.testimonial-nav-content .client-info {
  margin-bottom: 40px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-nav-content .client-info {
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .testimonial-nav-content .client-info {
    margin-bottom: 10px;
  }
}
.testimonial-nav-content .client-info .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 0;
}
.testimonial-nav-content .client-info .designation {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
}

.testimonial-nav-wrapper {
  max-width: 264px;
}

.testimonial-nav-button .single-thumbnail {
  padding: 5px;
  border: 5px solid transparent;
  border-radius: 100%;
  transition: 0.4s;
  position: relative;
}
.testimonial-nav-button .single-thumbnail img {
  max-width: 68px;
  width: 68px;
  display: inline-block;
  height: 68px;
  border: 8px solid #fff;
  border-radius: 100%;
  cursor: pointer;
}
.testimonial-nav-button .slick-current.slick-active .single-thumbnail .loader-container {
  opacity: 1;
}

.loader-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.loader-container .circle-loader-wrap {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(82, 95, 225, 0.2);
  border-radius: 100%;
  transform: rotate(180deg);
}
.loader-container .circle-loader-wrap:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 15px;
  width: auto;
  height: auto;
  border-radius: 50%;
  background-color: white;
}
.loader-container .circle-loader-wrap div {
  overflow: hidden;
  position: absolute;
  width: 50%;
  height: 100%;
}
.loader-container .circle-loader-wrap .loader {
  position: absolute;
  left: 100%;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 1000px;
  background-color: var(--color-primary);
}
.loader-container .circle-loader-wrap .left-wrap {
  left: 0;
}
.loader-container .circle-loader-wrap .left-wrap .loader {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transform-origin: 0 50% 0;
  -webkit-transform-origin: 0 50% 0;
  animation: loading-left 4s infinite linear;
  -webkit-animation: loading-left 4s infinite linear;
}
.loader-container .circle-loader-wrap .right-wrap {
  left: 50%;
}
.loader-container .circle-loader-wrap .right-wrap .loader {
  left: -100%;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  transform-origin: 100% 50% 0;
  -webkit-transform-origin: 100% 50% 0;
  animation: loading-right 4s infinite linear;
  -webkit-animation: loading-right 4s infinite linear;
}
@keyframes loading-left {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(180deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes loading-right {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

/*---------------------
 Feature Styles  
-------------------------*/
.feature-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}
.feature-list-wrapper .feature-list {
  flex-basis: 50%;
  padding: 15px;
}
@media only screen and (max-width: 575px) {
  .feature-list-wrapper .feature-list {
    flex-basis: 100%;
  }
}

.feature-list .icon {
  margin-bottom: 25px;
}
.feature-list .icon i {
  font-size: 50px;
  color: var(--color-secondary);
}
.feature-list .content .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 10px;
}
.feature-list .content p {
  margin-bottom: 0;
}

.feature-thumbnail {
  position: relative;
  z-index: 2;
  right: -60px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .feature-thumbnail {
    right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .feature-thumbnail {
    right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .feature-thumbnail {
    right: 0;
  }
}
.feature-thumbnail .circle-image {
  position: absolute;
  top: -11px;
  right: 7px;
  z-index: -1;
  width: 97%;
}
@media only screen and (max-width: 767px) {
  .feature-thumbnail .circle-image {
    display: none;
  }
}

.radius-round {
  border-radius: 100%;
}

/*----------------------
 Feature Style Two  
-------------------------*/
.feature-style-2 {
  display: flex;
  flex-wrap: wrap;
}
.feature-style-2 .single-feature {
  flex-basis: 50%;
  display: flex;
  align-items: center;
  margin-top: 25px;
  flex-wrap: wrap;
}
.feature-style-2 .single-feature .icon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  background: rgba(251, 124, 86, 0.15);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.feature-style-2 .single-feature .icon i {
  color: var(--color-secondary);
}
.feature-style-2 .single-feature .content .feature-title {
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 0;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .feature-style-2 .single-feature .content .feature-title {
    font-size: 16px;
  }
}

/*----------------------
    Feature Style Three  
-------------------------*/
.feature-style-3 .feature-content .feature-title {
  font-weight: 700;
  font-size: 32px;
  line-height: 44px;
  color: var(--color-secondary);
  margin-bottom: 5px;
}
.feature-style-3 .feature-content .feature-description {
  margin-bottom: 0;
}

/*----------------------
    Feature Style Four  
-------------------------*/
.feature-style-4 .edu-feature-list {
  display: flex;
}
.feature-style-4 .edu-feature-list .icon {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: rgba(251, 124, 86, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
}
.feature-style-4 .edu-feature-list .icon i {
  color: var(--color-secondary);
  font-size: 26px;
}
.feature-style-4 .edu-feature-list .content .title {
  margin-bottom: 5px;
}
.feature-style-4 .edu-feature-list .content p {
  margin-bottom: 30px;
}
.feature-style-4 .edu-feature-list.color-var-2 .icon {
  background: rgba(82, 95, 225, 0.1);
}
.feature-style-4 .edu-feature-list.color-var-2 .icon i {
  color: var(--color-primary);
}

/*----------------------
    Feature Style 5  
-------------------------*/
.feature-style-5 .edu-feature-list {
  display: flex;
}
.feature-style-5 .edu-feature-list .icon {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.feature-style-5 .edu-feature-list .icon i {
  color: var(--color-white);
  font-size: 30px;
}
.feature-style-5 .edu-feature-list .content .title {
  margin-bottom: 5px;
}
.feature-style-5 .edu-feature-list .content p {
  margin-bottom: 0;
}
.feature-style-5 .edu-feature-list.color-var-2 .icon {
  background: #FFA41B;
}
.feature-style-5 .edu-feature-list.color-var-2 .icon i {
  color: var(--color-white);
}

/*----------------------
    Feature Style 6  
-------------------------*/
.feature-style-6 .edu-feature-list {
  display: flex;
}
.feature-style-6 .edu-feature-list .icon {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: rgba(251, 124, 86, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
}
.feature-style-6 .edu-feature-list .icon i {
  color: var(--color-secondary);
  font-size: 30px;
}
.feature-style-6 .edu-feature-list .content .title {
  margin-bottom: 5px;
}
.feature-style-6 .edu-feature-list .content p {
  margin-bottom: 30px;
}
.feature-style-6 .edu-feature-list.color-var-2 .icon {
  background: rgba(82, 95, 225, 0.1);
}
.feature-style-6 .edu-feature-list.color-var-2 .icon i {
  color: var(--color-primary);
}
.feature-style-6 .edu-feature-list.color-variation-1 .icon {
  background: rgba(255, 164, 27, 0.1);
}
.feature-style-6 .edu-feature-list.color-variation-2 .icon {
  background: rgba(82, 95, 225, 0.1);
}
.feature-style-6 .edu-feature-list.color-variation-3 .icon {
  background: rgba(251, 124, 86, 0.1);
}

/*------------------------
    About Styles  
-------------------------*/
.about-feature-list .our-feature {
  display: flex;
}
.about-feature-list .our-feature .icon {
  width: 50px;
  min-width: 50px;
  height: 50px;
  background: var(--color-secondary);
  display: flex;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.about-feature-list .our-feature .icon i {
  color: var(--color-white);
  font-size: 24px;
}
.about-feature-list .our-feature .feature-content .feature-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 5px;
}
.about-feature-list .our-feature .feature-content .feature-description {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 0;
}
.about-feature-list .our-feature + .our-feature {
  margin-top: 30px;
}

/*----------------------
    About Style One  
------------------------*/
.about-style-1 {
  position: relative;
  z-index: 1;
}
.about-style-1 .about-image-gallery {
  margin-right: 100px;
  position: relative;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-1 .about-image-gallery {
    margin-right: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-1 .about-image-gallery {
    margin-right: 60px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-1 .about-image-gallery {
    margin-right: 0;
  }
}
.about-style-1 .about-image-gallery .image-1 {
  border-radius: 5px;
  width: 100%;
}
.about-style-1 .about-image-gallery .image-2 {
  position: absolute;
  bottom: -61px;
  right: -50px;
  border-radius: 5.2px;
}
@media only screen and (max-width: 767px) {
  .about-style-1 .about-image-gallery .image-2 {
    position: absolute;
    right: 0;
    border-radius: 5px;
    margin-top: 30px;
    transform: none !important;
    object-fit: cover;
  }
}
.about-style-1 .about-image-gallery .image-2 img {
  border-radius: 5px;
}
.about-style-1 .about-image-gallery .badge-inner {
  position: absolute;
  top: 42px;
  left: -75px;
  width: 150px;
  height: 150px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  border-radius: 100%;
}
@media only screen and (max-width: 575px) {
  .about-style-1 .about-image-gallery .badge-inner {
    display: none;
  }
}
.about-style-1 .about-image-gallery .badge-inner .image-3 {
  animation: rotateIt 7s linear infinite;
  border-radius: 100%;
}
.about-style-1 .about-image-gallery .shape-image-1 {
  position: absolute;
  bottom: -35px;
  left: -35px;
  z-index: -1;
}
.about-style-1 .inner .description {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  padding-left: 17px;
  position: relative;
  margin-top: 40px;
}
.about-style-1 .inner .description::before {
  position: absolute;
  content: "";
  left: 0;
  width: 2px;
  height: 46px;
  background: var(--color-primary);
  top: 50%;
  transform: translateY(-50%);
}
.about-style-1 .inner .read-more-btn {
  margin-top: 40px;
}
.about-style-1 .inner .about-parallax-2 {
  position: absolute;
  right: 88px;
  top: 379px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .about-style-1 .inner .about-parallax-2 {
    right: 8px;
  }
}

/*----------------------
    About Style Two  
------------------------*/
.about-style-2 {
  position: relative;
}
.about-style-2 .about-image-gallery {
  position: relative;
}
.about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper {
  position: relative;
}
.about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .image-1 {
  position: relative;
  margin-left: -40px;
  width: 460px;
  min-width: 460px;
  height: 460px;
  min-height: 460px;
  border-radius: 100%;
  z-index: 3;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .image-1 {
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .image-1 {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .image-1 {
    margin-left: 0;
    width: 100%;
    min-width: auto;
    min-height: auto;
    height: auto;
  }
}
.about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .eduvibe-about-blur img {
  position: absolute;
  left: -50px;
  width: 739px;
  height: 739px;
  z-index: 0;
  top: -140px;
}
@media only screen and (max-width: 1199px) {
  .about-style-2 .about-image-gallery .eduvibe-about-1-img-wrapper .eduvibe-about-blur img {
    display: none;
  }
}
.about-style-2 .about-image-gallery .image-2 {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  border-radius: 100%;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-2 .about-image-gallery .image-2 {
    right: 101px;
  }
}
.about-style-2 .about-image-gallery .finished-session {
  background: var(--color-white);
  box-shadow: 0px 10px 35px rgba(0, 0, 0, 0.05);
  width: 170px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  position: absolute;
  left: -120px;
  top: 8%;
  z-index: 3;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-2 .about-image-gallery .finished-session {
    left: 0;
    top: -9%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-2 .about-image-gallery .finished-session {
    left: 0;
    top: -9%;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-2 .about-image-gallery .finished-session {
    left: 0;
    top: 0;
    width: 120px;
    height: 120px;
  }
}
.about-style-2 .about-image-gallery .finished-session .inner .text {
  font-weight: 700;
  font-size: 32px;
  color: var(--color-primary);
  line-height: 44px;
  display: block;
}
@media only screen and (max-width: 767px) {
  .about-style-2 .about-image-gallery .finished-session .inner .text {
    font-size: 22px;
    line-height: 29px;
  }
}
.about-style-2 .about-image-gallery .finished-session .inner .finished-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  display: inline-block;
  color: var(--color-dark);
}
.about-style-2 .circle-image-wrapper {
  position: absolute;
  width: 272px;
  height: 272px;
  right: 52px;
  bottom: -57px;
  z-index: 3;
}
.about-style-2 .circle-image-wrapper .circle-image {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 272px;
  height: 272px;
  z-index: -1;
}
.about-style-2 .circle-image-wrapper .circle-image span {
  border-color: #ffa41b;
  left: 26px;
}
@media only screen and (max-width: 991px) {
  .about-style-2 .circle-image-wrapper .circle-image span {
    left: -51px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-2 .circle-image-wrapper {
    display: none;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .about-style-2 .circle-image-wrapper {
    right: 30px;
  }
}

.circle-image-wrapper {
  position: relative;
  display: inline-block;
  z-index: 1;
}
.circle-image-wrapper .circle-image {
  z-index: -1;
}

/*----------------------
    About Style 3  
------------------------*/
.about-style-3 {
  position: relative;
}
.about-style-3 .gappery-wrapper .gallery-image {
  position: relative;
}
.about-style-3 .gappery-wrapper .gallery-image img {
  border-radius: 5.2px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-3 .gappery-wrapper .gallery-image img {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-3 .gappery-wrapper .gallery-image img {
    width: 100%;
  }
}
.about-style-3 .gappery-wrapper .gallery-image .icon-badge {
  width: 60px;
  height: 60px;
  background: var(--color-primary);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
}
.about-style-3 .gappery-wrapper .gallery-image .icon-badge i {
  color: var(--color-white);
  font-size: 20px;
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status {
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: inline-block;
  position: absolute;
  left: -25px;
  top: 50%;
  transform: translateY(-50%);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status {
    left: 10px;
    top: auto;
    transform: none;
    bottom: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status {
    left: 10px;
    top: auto;
    transform: none;
    bottom: 10px;
  }
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner {
  display: flex;
  padding: 16px 15px;
  align-items: center;
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner .icon {
  width: 40px;
  height: 40px;
  background: rgba(251, 124, 86, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner .icon i {
  color: var(--color-white);
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner .content {
  text-align: left;
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner .content .title {
  color: var(--color-secondary);
  font-weight: 700;
  font-size: 20px;
  line-height: 16px;
  margin-bottom: 0;
}
.about-style-3 .gappery-wrapper .gallery-image.gallery-image-3 .student-like-status .inner .content .subtitle {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

/*----------------------
    About Style 4  
------------------------*/
.about-style-4 {
  position: relative;
}
.about-style-4 .gallery-wrapper {
  position: relative;
  text-align: center;
  margin-right: 120px;
  margin-left: -50px;
  z-index: 2;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-4 .gallery-wrapper {
    text-align: left;
    margin-left: 130px;
    margin-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-4 .gallery-wrapper {
    margin-right: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-4 .gallery-wrapper {
    margin-right: 0;
    margin-left: 0;
    text-align: left;
  }
}
.about-style-4 .gallery-wrapper img {
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  .about-style-4 .gallery-wrapper .image-1 {
    width: 100%;
  }
}
.about-style-4 .gallery-wrapper .image-2 {
  position: absolute;
  left: -95px;
  z-index: -1;
  top: 88px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-4 .gallery-wrapper .image-2 {
    left: -120px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-4 .gallery-wrapper .image-2 {
    left: 3%;
  }
}
.about-style-4 .gallery-wrapper .image-3 {
  position: absolute;
  right: -73px;
  bottom: 100px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-4 .gallery-wrapper .image-3 {
    left: 370px;
    right: inherit;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-4 .gallery-wrapper .image-3 {
    right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-4 .gallery-wrapper .image-3 {
    right: 0;
  }
}
@media only screen and (max-width: 575px) {
  .about-style-4 .gallery-wrapper .image-3 {
    display: none;
  }
}
.about-style-4 .gallery-wrapper .image-3 img {
  border: 3px solid #ffffff;
}

/*----------------------
    About Style 6  
------------------------*/
.about-style-6 .about-image-gallery {
  position: relative;
  z-index: 1;
}
.about-style-6 .about-image-gallery img {
  border-radius: 265px 265px 5px 5px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-6 .about-image-gallery img {
    border-radius: 500px 500px 0 0;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-6 .about-image-gallery img {
    border-radius: 500px 500px 0 0;
  }
}
.about-style-6 .about-image-gallery .badge-icon {
  position: absolute;
  bottom: 173px;
  left: -75px;
  width: 130px;
  height: 130px;
  background: #ffffff;
  border-radius: 100%;
  padding: 5px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-6 .about-image-gallery .badge-icon {
    bottom: auto;
    left: 0;
    top: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-6 .about-image-gallery .badge-icon {
    bottom: auto;
    left: 0;
    top: 0;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-6 .about-image-gallery .badge-icon {
    bottom: auto;
    left: 0;
    top: 0;
  }
}
.about-style-6 .about-image-gallery .badge-icon .badge-inner {
  padding: 5px;
  background: #fb7c56;
  border-radius: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}
.about-style-6 .about-image-gallery .badge-icon .badge-inner::after {
  width: 20px;
  height: 20px;
  background: var(--color-white);
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "";
}
.about-style-6 .about-image-gallery .badge-icon .badge-inner img {
  animation: rotateIt 7s linear infinite;
}
.about-style-6 .about-image-gallery::after {
  position: absolute;
  content: "";
  border: 5px solid var(--color-secondary);
  width: 97%;
  height: 95%;
  left: 40px;
  bottom: -20px;
  border-radius: 265px 265px 5px 5px;
  z-index: -1;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-6 .about-image-gallery::after {
    border-radius: 500px 500px 0 0;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-6 .about-image-gallery::after {
    display: none;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-6 .inner {
    padding-left: 40px;
  }
}
.about-style-6 .inner .feature-list-wrapper {
  display: flex;
  margin: 0;
  margin-top: -30px;
}
.about-style-6 .inner .feature-list-wrapper .feature-list {
  flex-basis: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  margin-top: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-6 .inner .feature-list-wrapper .feature-list {
    flex-basis: 100%;
    margin-top: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-6 .inner .feature-list-wrapper .feature-list {
    margin-top: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-6 .inner .feature-list-wrapper .feature-list {
    margin-top: 15px;
  }
}
@media only screen and (max-width: 575px) {
  .about-style-6 .inner .feature-list-wrapper .feature-list {
    flex-basis: 100%;
  }
}
.about-style-6 .inner .feature-list-wrapper .feature-list i {
  margin-right: 14px;
  color: var(--color-secondary);
  font-size: 24px;
}
.about-style-6 .inner .info-btn {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  margin-left: 30px;
  transition: 0.4s;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-style-6 .inner .info-btn {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 575px) {
  .about-style-6 .inner .info-btn {
    margin-left: 0;
    margin-top: 20px;
    display: block;
  }
}
.about-style-6 .inner .info-btn:hover {
  color: var(--color-secondary);
}
.about-style-6 .inner .info-btn i {
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 100%;
  text-align: center;
  margin-right: 15px;
  background: rgba(251, 124, 86, 0.15);
  color: var(--color-secondary);
  display: inline-block;
}

.edu-mission-vision-area .thumbnail {
  margin: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-mission-vision-area .thumbnail {
    flex-wrap: wrap;
  }
}
@media only screen and (max-width: 767px) {
  .edu-mission-vision-area .thumbnail {
    flex-wrap: wrap;
  }
}
.edu-mission-vision-area .thumbnail img {
  border-radius: 5px;
}
.edu-mission-vision-area .thumbnail .shape-image {
  padding: 15px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-mission-vision-area .thumbnail .shape-image {
    flex-basis: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .edu-mission-vision-area .thumbnail .shape-image {
    flex-basis: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .edu-mission-vision-area .thumbnail .shape-image {
    flex-basis: 100%;
    text-align: center;
  }
}

@media only screen and (max-width: 991px) {
  .eduvibe-about-three-mission .thumbnail img {
    transform: none !important;
  }
}

/*----------------------
    Why Choose Us 1
------------------------*/
.edu-choose-us-area-one .thumbnail {
  margin-left: -151px;
  margin-right: -76px;
  margin-top: -50px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .edu-choose-us-area-one .thumbnail {
    margin-left: -60px;
  }
}
@media only screen and (max-width: 1199px) {
  .edu-choose-us-area-one .thumbnail {
    margin-left: -120px;
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  .edu-choose-us-area-one .thumbnail {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
  }
}
.edu-choose-us-area-one.edu-section-gap {
  padding: 180px 0 130px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-choose-us-area-one.edu-section-gap {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-choose-us-area-one.edu-section-gap {
    padding: 80px 0 !important;
  }
}

/*-------------------------
    Newsletter Styles  
-------------------------*/
.newsletter-form-style-1 .input-box {
  position: relative;
  display: inline-block;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-1 .input-box {
    display: block;
  }
}
.newsletter-form-style-1 .input-box input {
  height: 60px;
  background: var(--color-white);
  border: 0 none;
  padding: 0 52px;
  min-width: 570px;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-1 .input-box input {
    min-width: 100%;
    height: 60px;
  }
}
.newsletter-form-style-1 .input-box input.large-input-box {
  height: 80px;
  min-width: 670px;
  padding-right: 190px;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-1 .input-box input.large-input-box {
    min-width: 100%;
    padding-right: 20px;
    padding-left: 20px;
  }
}
.newsletter-form-style-1 .input-box .mail-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  font-size: 16px;
  display: flex;
  align-items: center;
}
.newsletter-form-style-1 .input-box .send-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 27px;
  border: 0 none;
  padding: 0;
  background: transparent;
}
.newsletter-form-style-1 .input-box .send-button i {
  font-size: 20px;
  color: var(--color-primary);
}
.newsletter-form-style-1 .input-box .edu-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-1 .input-box .edu-btn {
    position: static;
    transform: none;
    margin-left: 0;
    margin-top: 20px;
  }
}

.newsletter-style-2 {
  position: relative;
}
.newsletter-style-2 input {
  height: 60px;
  background: var(--color-white);
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-body);
  border-radius: 5px;
  border: 0 none;
  padding-right: 146px;
}
.newsletter-style-2 .subscribe-btn {
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px;
  z-index: 2;
}

.newsletter-style-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  position: relative;
}
.newsletter-style-3 .contact-info {
  margin-left: 43px;
}
@media only screen and (max-width: 575px) {
  .newsletter-style-3 .contact-info {
    margin-left: 0;
    margin-top: 20px;
  }
}
.newsletter-style-3 .contact-info a {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-white);
  transition: 0.4s;
  position: relative;
  display: inline-block;
  z-index: 1;
}
.newsletter-style-3 .contact-info a::after {
  position: absolute;
  content: "";
  left: auto;
  right: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background: var(--color-white);
  transition: 0.3s;
}
.newsletter-style-3 .contact-info a i {
  margin-right: 5px;
}
.newsletter-style-3 .contact-info a:hover::after {
  width: 100%;
  left: 0;
  right: auto;
}

.newsletter-style-5 {
  position: relative;
  z-index: 1;
  border-radius: 5px;
  min-width: 1400px;
  padding: 100px 115px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .newsletter-style-5 {
    min-width: auto;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .newsletter-style-5 {
    min-width: auto;
    padding: 50px 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .newsletter-style-5 {
    min-width: auto;
    padding: 50px 40px;
  }
}
@media only screen and (max-width: 767px) {
  .newsletter-style-5 {
    min-width: auto;
    padding: 50px 40px;
  }
}

.newsletter-overlay-to-another {
  position: relative;
  margin-top: -145px;
}
@media only screen and (max-width: 991px) {
  .newsletter-overlay-to-another {
    margin-top: -80px;
  }
}

.newsletter-to-top {
  padding-top: 273px !important;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .newsletter-to-top {
    padding-top: 224px !important;
  }
}
@media only screen and (max-width: 767px) {
  .newsletter-to-top {
    padding-top: 224px !important;
  }
}

/*---------------------------
    Social Share Style
---------------------------*/
.social-share {
  margin: -7px;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.social-share li {
  margin: 7px;
}
.social-share li a {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 50px;
  height: 50px;
  line-height: 55px;
  display: inline-block;
  font-size: 18px;
  color: var(--color-white);
  transition: 0.4s;
  text-align: center;
}
.social-share li a:hover {
  background: var(--color-primary);
  color: var(--color-white);
}
.social-share.bg-transparent li a {
  background: transparent;
  border: 1px solid rgba(45, 40, 78, 0.1);
  color: var(--color-primary);
  border-radius: 100%;
}
.social-share.bg-transparent li a:hover {
  border-color: var(--color-primary);
  background: var(--color-primary);
  color: var(--color-white);
}
.social-share.icon-transparent {
  margin: 0 -15px;
}
.social-share.icon-transparent li {
  margin: 0 15px;
}
.social-share.icon-transparent li a {
  background: transparent;
  height: auto;
  width: auto;
  color: var(--color-body);
  transition: 0.4s;
  line-height: initial;
}
.social-share.icon-transparent li a:hover {
  color: var(--color-primary);
}
.social-share.border-style {
  margin: 0 -7px;
}
.social-share.border-style li {
  margin: 0 7px;
}
.social-share.border-style li a {
  background: transparent;
  height: 40px;
  width: 40px;
  color: var(--color-primary);
  transition: 0.4s;
  line-height: 42px;
  text-align: center;
  border: 1px solid rgba(45, 40, 78, 0.1);
  border-radius: 100%;
  font-size: 16px;
}
.social-share.border-style li a:hover {
  color: var(--color-white);
  background: var(--color-primary);
  border-color: var(--color-primary);
}
.social-share.medium-size li a {
  width: 40px;
  height: 40px;
  line-height: 42px;
  font-size: 16px;
}

/*-------------------------
    Back To Top  
---------------------------*/
.paginacontainer {
  height: 3000px;
}

.rn-progress-parent {
  position: fixed;
  right: 30px;
  bottom: 30px;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  border-radius: 50px;
  box-shadow: inset 0 0 0 2px #f8e3c3;
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
  transition: all 200ms linear;
}
.rn-progress-parent.rn-backto-top-active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.rn-progress-parent::after {
  position: absolute;
  font-family: "icomoon" !important;
  content: "\\e90f";
  text-align: center;
  line-height: 46px;
  font-size: 24px;
  color: var(--color-tertiary);
  left: 0;
  top: 0;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  z-index: 2;
  transition: all 200ms linear;
}
.rn-progress-parent:hover::after {
  color: var(--color-tertiary);
}
.rn-progress-parent::before {
  position: absolute;
  font-family: "feather" !important;
  content: "\\e914";
  text-align: center;
  line-height: 46px;
  font-size: 24px;
  opacity: 0;
  background: #0d0d12;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  left: 0;
  top: 0;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  z-index: 2;
  transition: all 200ms linear;
}
.rn-progress-parent svg path {
  fill: none;
}
.rn-progress-parent svg.rn-back-circle path {
  stroke: var(--color-tertiary);
  stroke-width: 4;
  box-sizing: border-box;
  transition: all 200ms linear;
}

/*--------------------------
    Workshop Style One  
----------------------------*/
.workshop-style-1 .workshop-inner .description {
  color: var(--color-white);
  margin-top: 40px;
  margin-bottom: 40px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .workshop-style-1 .workshop-inner .description {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .workshop-style-1 .workshop-inner .description {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

/*--------------------------
    Video Popup Styles  
----------------------------*/
.video-gallery-1 {
  padding: 8px;
  background: var(--color-white);
  box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
}

.video-popup-wrapper {
  position: relative;
}
.video-popup-wrapper.video-popup-two img {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  mask-repeat: no-repeat;
  mask-size: contain;
  mask-position: center center;
}
.video-popup-wrapper .position-to-top {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-popup-wrapper img {
  border-radius: 5px;
}

.video-play-btn {
  border: 0;
  width: 50px;
  height: 50px;
  margin-left: -30px;
  margin-top: -30px;
  transition: all 1s cubic-bezier(0, 0, 0.2, 1);
  position: relative;
  border-radius: 100%;
  background: var(--color-white);
  margin: 0 auto;
  display: inline-block;
}
.video-play-btn.with-animation::after, .video-play-btn.with-animation::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  bottom: 0;
  left: 0;
  transition: var(--transition);
  border-radius: 50%;
  border: 1.2px solid var(--color-white);
}
.video-play-btn.with-animation::before {
  animation: ripple 2s linear infinite;
}
.video-play-btn.with-animation::after {
  animation: ripple 2s linear 1s infinite;
}
.video-play-btn.size-60 {
  width: 60px;
  height: 60px;
  font-size: 20px;
}
@media only screen and (max-width: 767px) {
  .video-play-btn.size-60 {
    width: 50px;
    height: 50px;
    font-size: inherit;
  }
}
@media only screen and (max-width: 575px) {
  .video-play-btn.size-60 {
    width: 45px;
    height: 45px;
  }
}
.video-play-btn.size-80 {
  width: 80px;
  height: 80px;
  font-size: 24px;
}
@media only screen and (max-width: 1199px) {
  .video-play-btn.size-80 {
    width: 60px;
    height: 60px;
    font-size: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .video-play-btn.size-80 {
    width: 50px;
    height: 50px;
    font-size: inherit;
  }
}
@media only screen and (max-width: 575px) {
  .video-play-btn.size-80 {
    width: 45px;
    height: 45px;
  }
}
.video-play-btn .play-icon {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-play-btn .play-icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform: translate(-6px, -9px);
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 15px solid var(--color-primary);
}
.video-play-btn.btn-large {
  width: 60px;
  height: 60px;
  margin-left: 0;
  margin-top: 0;
}
.video-play-btn.btn-theme-color {
  color: #ffffff;
  background: var(--color-primary);
}
.video-play-btn.btn-theme-color::after {
  border-color: var(--color-primary);
}
.video-play-btn.btn-theme-color::before {
  border-color: var(--color-primary);
}
.video-play-btn.btn-theme-color .play-icon::before {
  border-left: 15px solid var(--color-white);
}
.video-play-btn.btn-secondary-color {
  color: #ffffff;
  background: var(--color-secondary);
}
.video-play-btn.btn-secondary-color::after {
  border-color: var(--color-secondary);
}
.video-play-btn.btn-secondary-color::before {
  border-color: var(--color-secondary);
}
.video-play-btn.btn-secondary-color .play-icon::before {
  border-left: 15px solid var(--color-white);
}

.video-style-2 {
  position: relative;
  z-index: 1;
}
.video-style-2::after {
  position: absolute;
  content: "";
  background: var(--color-white);
  top: 0;
  right: 0;
  height: 100%;
  width: calc(50% + 250px);
  z-index: -1;
  border-radius: 10px 0px 0px 10px;
}
@media only screen and (max-width: 991px) {
  .video-style-2::after {
    display: none;
  }
}
.video-style-2 .side-shape-image {
  position: absolute;
  right: 0%;
  top: 50%;
  transform: translateY(-50%) translateX(50%);
}
.video-style-2 .side-shape-image img {
  animation: eduvibe-rotate-x 30s infinite linear;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .video-style-2 .side-shape-image {
    display: none;
  }
}

/*keyframes-css*/
@keyframes ripple {
  0% {
    transform: scale(1);
  }
  75% {
    transform: scale(2.1);
    opacity: 1;
  }
  100% {
    transform: scale(2.3);
    opacity: 0;
  }
}
@keyframes btnIconRipple {
  0% {
    border-width: 4px;
    transform: scale(1);
  }
  80% {
    border-width: 1px;
    transform: scale(1.35);
  }
  100% {
    opacity: 0;
  }
}
/*------------------------------
    Choose Us Style  
-------------------------------*/
.choose-us-style-1 {
  position: relative;
}
.choose-us-style-1 .inner .section-title .title {
  margin-bottom: 40px;
}
.choose-us-style-1 .chosse-us-thumbnail {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 236px;
}
.choose-us-style-1 .right-side-thumb {
  margin-right: -149px;
}
@media only screen and (max-width: 991px) {
  .choose-us-style-1 .right-side-thumb {
    margin-right: 0;
  }
}

@media only screen and (max-width: 991px) {
  .eduvibe-home-two-counter .choose-us-2 {
    margin-top: 25px;
  }
}

/*----------------------------
    Call To Action Styles  
-----------------------------*/
.call-action-style-1 {
  padding-top: 24px;
  padding-left: 50px;
}
.call-action-style-1 .inner .content .pre-title {
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: block;
  margin-bottom: 5px;
}
.call-action-style-1 .inner .content .title {
  font-size: 24px;
  line-height: 36px;
}
.call-action-style-1 .thumbnail {
  position: relative;
  z-index: 1;
}
.call-action-style-1 .thumbnail .shape-image {
  position: absolute;
  top: 18px;
  right: 13px;
  z-index: -1;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .call-action-style-1 .thumbnail img.main-img {
    margin-bottom: -15px;
  }
}
.call-action-style-1.box-layout {
  padding: 46px 50px;
  position: relative;
}
.call-action-style-1.box-layout .inner .shape-image-2 {
  position: absolute;
  top: 26px;
  right: 30px;
  pointer-events: none;
}
@media only screen and (max-width: 575px) {
  .call-action-style-1.box-layout .inner .shape-image-2 {
    display: none;
  }
}

/*-----------------------
    Slick Slider  
-------------------------*/
.edu-testimonial-activation.edu-slick-button {
  margin-bottom: 62px;
}
.edu-testimonial-activation.edu-slick-button .edu-slick-button .slick-dots {
  bottom: -74px;
}

.course-activation-item-2 .edu-slick-button .slick-dots {
  bottom: -45px;
}

.slick-activation-wrapper {
  margin: 0 -15px;
  position: relative;
}
@media only screen and (max-width: 575px) {
  .slick-activation-wrapper {
    margin: 0;
  }
}
.slick-activation-wrapper .single-slick-card {
  padding: 0 15px;
}
@media only screen and (max-width: 575px) {
  .slick-activation-wrapper .single-slick-card {
    padding: 0;
  }
}

.single-slick-card .edu-card.card-type-5 {
  box-shadow: none;
}

.edu-slick-button .slick-dots {
  bottom: -84px;
  margin: 0 -7px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-slick-button .slick-dots {
    bottom: -60px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-slick-button .slick-dots {
    bottom: -60px;
  }
}
.edu-slick-button .slick-dots li {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  padding: 0;
  transition: 0.4s;
  line-height: 24px;
  position: relative;
  margin: 0 1px;
  display: inline-block;
}
.edu-slick-button .slick-dots li::before {
  border: 2px solid transparent;
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  transition: 0.2s;
  opacity: 0;
  border-radius: 100%;
  left: 0;
  top: 0;
  transform: scale(0.2);
}
.edu-slick-button .slick-dots li.slick-active {
  margin: 0 3px;
}
.edu-slick-button .slick-dots li button {
  width: 10px;
  height: 10px;
  background: rgba(82, 95, 225, 0.5);
  border-radius: 100%;
  padding: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.edu-slick-button .slick-dots li button::before {
  display: none;
}
.edu-slick-button .slick-dots li.slick-active::before {
  border-color: var(--color-primary);
  opacity: 1;
  transform: scale(1);
}
.edu-slick-button .slick-dots li.slick-active button {
  background: var(--color-primary);
}
.edu-slick-button.slick-button-left .slick-dots {
  bottom: -80px;
  margin: 0px -6px;
  text-align: left;
  display: flex !important;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-slick-button.slick-button-left .slick-dots {
    bottom: -50px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-slick-button.slick-button-left .slick-dots {
    bottom: -50px;
  }
}
.edu-slick-button.slick-button-left .slick-dots li {
  border-radius: 100%;
  transition: 0.4s;
  position: relative;
  margin: 0 6px;
  display: inline-block;
  width: 20px;
  min-width: 20px;
  height: 20px;
}
.edu-slick-button.slick-button-left .slick-dots li::before {
  border: 2px solid transparent;
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  transition: 0.3s;
  opacity: 0;
  border-radius: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.edu-slick-button.slick-button-left .slick-dots li.slick-active::before {
  border-color: var(--color-primary);
  opacity: 1;
  width: 100%;
  height: 100%;
}
.edu-slick-button.instructor-profile-courses .slick-dots {
  bottom: -46px;
}
@media only screen and (max-width: 1199px) {
  .edu-slick-button.instructor-profile-courses .slick-list {
    margin-bottom: 30px;
  }
}

.slick-arrow-style-2 {
  position: relative;
}
.slick-arrow-style-2 .slide-arrow {
  position: absolute;
  right: 50px;
  width: 50px;
  height: 50px;
  background: rgba(82, 95, 225, 0.15);
  transition: 0.3s;
  color: var(--color-primary);
  line-height: 50px;
  text-align: center;
  border: 0 none;
  bottom: 50px;
  border-radius: 3px;
  font-size: 18px;
  z-index: 2;
}
@media only screen and (max-width: 479px) {
  .slick-arrow-style-2 .slide-arrow {
    right: 20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    bottom: 20px;
  }
}
.slick-arrow-style-2 .slide-arrow:hover {
  background: var(--color-primary);
  color: var(--color-white);
}
.slick-arrow-style-2 .slide-arrow.prev-arrow {
  right: 115px;
}
@media only screen and (max-width: 479px) {
  .slick-arrow-style-2 .slide-arrow.prev-arrow {
    right: 74px;
  }
}

.edu-slick-arrow-top .slide-arrow {
  position: absolute;
  right: 15px;
  width: 50px;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  transition: 0.3s;
  color: var(--color-primary);
  line-height: 50px;
  text-align: center;
  border: 0 none;
  font-size: 18px;
  top: -120px;
}
@media only screen and (max-width: 767px) {
  .edu-slick-arrow-top .slide-arrow {
    top: auto;
    bottom: -30px;
    right: auto;
    left: 80px;
  }
}
.edu-slick-arrow-top .slide-arrow:hover {
  background: var(--color-primary);
  color: var(--color-white);
}
.edu-slick-arrow-top .slide-arrow.prev-arrow {
  right: 80px;
}
@media only screen and (max-width: 767px) {
  .edu-slick-arrow-top .slide-arrow.prev-arrow {
    right: auto;
    left: 15px;
  }
}

/*------------------------
    Winner Area Styles  
--------------------------*/
.edu-winner-card {
  background: var(--color-white);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 40px;
  transition: 0.4s;
  text-align: center;
}
.edu-winner-card .inner .icon {
  margin-bottom: 30px;
}
.edu-winner-card .inner .icon img {
  max-height: 50px;
}
.edu-winner-card .inner .content .subtitle {
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: inline-block;
}
.edu-winner-card .inner .content .title {
  font-weight: 700;
  margin-bottom: 0;
  transition: 0.4s;
}
.edu-winner-card:hover {
  transform: translateY(-15px);
}
.edu-winner-card:hover .inner .content .title {
  color: var(--color-primary);
}

/*----------------------------
    Counterup Styles  
-----------------------------*/
.edu-counterup {
  background: var(--color-white);
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  text-align: center;
  padding: 50px 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-counterup {
    padding: 30px 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-counterup {
    padding: 30px 15px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-counterup {
    padding: 30px 15px;
  }
}
.edu-counterup .inner .icon {
  margin-bottom: 25px;
}
.edu-counterup .inner .icon img {
  max-height: 60px;
}
.edu-counterup .inner .content .counter {
  font-weight: 800;
  font-size: 40px;
  line-height: 56px;
  margin-bottom: 0;
}
.edu-counterup .inner .content span {
  display: inline-block;
}

.counterup-overlay-top {
  position: relative;
  margin-top: -145px;
  padding-top: 275px !important;
}

.counterup-style-2 {
  position: relative;
  z-index: 2;
}
.counterup-style-2 .line-separator {
  position: relative;
}
.counterup-style-2 .line-separator::after {
  position: absolute;
  content: "";
  height: 160px;
  background: rgba(255, 255, 255, 0.15);
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
}
@media only screen and (max-width: 575px) {
  .counterup-style-2 .line-separator::after {
    display: none;
  }
}
.counterup-style-2 .line-separator:last-child::after {
  display: none;
}
.counterup-style-2 .line-separator.color-var-2::after {
  background: #2D284E;
  opacity: 0.1;
}

.edu-counterup-2 .inner {
  text-align: center;
}
.edu-counterup-2 .inner .icon {
  margin-bottom: 7px;
}
.edu-counterup-2 .inner .icon i {
  color: var(--color-white);
  font-size: 30px;
}
.edu-counterup-2 .inner .content .counter {
  color: var(--color-white);
  font-weight: 800;
  font-size: 40px;
  line-height: 56px;
  margin-bottom: 5px;
}
.edu-counterup-2 .inner .content .counter .after-icon {
  color: var(--color-white);
  position: relative;
  display: inline-block;
  left: -7px;
}
.edu-counterup-2 .inner .content .subtitle {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-white);
}
.edu-counterup-2.variation-2 .inner {
  text-align: center;
}
.edu-counterup-2.variation-2 .inner .icon i {
  color: var(--color-primary);
  font-size: 50px;
}
.edu-counterup-2.variation-2 .inner .content .counter {
  color: var(--color-heading);
}
.edu-counterup-2.variation-2 .inner .content .counter .after-icon {
  color: var(--color-heading);
}
.edu-counterup-2.variation-2 .inner .content .subtitle {
  color: var(--color-body);
}

.edu-countdown-area {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.edu-countdown-area .countdown .countdown-container .countdown-value {
  color: var(--color-secondary);
}

.countdown {
  display: flex;
  margin: -15px;
  justify-content: center;
  flex-wrap: wrap;
}
.countdown .countdown-container {
  margin: 15px !important;
  position: relative;
  background-color: var(--color-white);
  padding: 15px 28px;
  border-radius: 5px;
}
.countdown .countdown-container .countdown-heading {
  display: block;
  color: var(--color-body);
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 0;
  display: block;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 0.05em;
}
.countdown .countdown-container .countdown-value {
  display: block;
  font-size: 32px;
  color: var(--color-heading);
  font-weight: 700;
  text-align: center;
  position: relative;
  line-height: 1.38;
}
.countdown .countdown-container:after {
  content: ":";
  top: 50%;
  transform: translateY(-50%);
  right: -17px;
  position: absolute;
  font-size: 32px;
  color: var(--color-white);
  font-weight: 700;
}
.countdown .countdown-container:last-child::after {
  display: none;
}

.countdown-style-2 .countdown {
  display: flex;
  margin: -15px;
  justify-content: center;
  flex-wrap: wrap;
}
@media only screen and (max-width: 767px) {
  .countdown-style-2 .countdown {
    margin: -5px !important;
  }
}
.countdown-style-2 .countdown .countdown-container {
  margin: 15px !important;
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 10px 35px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 40px 10px;
  border-radius: 5px;
  transition: 0.4s;
  min-width: 180px;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  .countdown-style-2 .countdown .countdown-container {
    padding: 10px;
    min-width: auto;
    margin: 5px !important;
  }
}
.countdown-style-2 .countdown .countdown-container .countdown-heading {
  display: block;
  color: var(--color-heading);
  text-align: center;
  text-transform: uppercase;
  margin-top: 0;
  display: block;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  transition: 0.4s;
}
@media only screen and (max-width: 767px) {
  .countdown-style-2 .countdown .countdown-container .countdown-heading {
    font-size: 14px;
  }
}
.countdown-style-2 .countdown .countdown-container .countdown-value {
  display: block;
  font-weight: 800;
  font-size: 68px;
  line-height: 1.24;
  color: var(--color-heading);
  text-align: center;
  position: relative;
  transition: 0.4s;
}
@media only screen and (max-width: 767px) {
  .countdown-style-2 .countdown .countdown-container .countdown-value {
    font-size: 24px;
  }
}
.countdown-style-2 .countdown .countdown-container:after {
  display: none;
}
.countdown-style-2 .countdown .countdown-container:last-child::after {
  display: none;
}
.countdown-style-2 .countdown .countdown-container:hover {
  background: var(--color-primary);
  box-shadow: 0px 10px 30px rgba(82, 95, 225, 0.3);
}
.countdown-style-2 .countdown .countdown-container:hover .countdown-heading {
  color: var(--color-white);
}
.countdown-style-2 .countdown .countdown-container:hover .countdown-value {
  color: var(--color-white);
}

.eduvibe-about-two-countdown .countdown-style-1 {
  padding: 0 290px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-about-two-countdown .countdown-style-1 {
    padding: 0 60px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-about-two-countdown .countdown-style-1 {
    padding: 0px;
  }
}

/*--------------------------------
    Breadcrumb Area  
------------------------------*/
.breadcrumb-style-1 .page-title .title {
  margin-bottom: 5px;
}
.breadcrumb-style-1 .edu-breadcrumb {
  align-items: center;
}
.breadcrumb-style-1 .edu-breadcrumb li {
  margin: 0;
}
.breadcrumb-style-1 .edu-breadcrumb li.breadcrumb-item {
  color: var(--color-body);
}
.breadcrumb-style-1 .edu-breadcrumb li.separator i {
  font-size: 20px;
  margin: 0 5px;
  position: relative;
  display: inline-block;
  top: 2px;
}

.grid-metro3 {
  margin: 0 -15px;
}
.grid-metro3 .grid-metro-item {
  width: 33.33%;
  padding: 0 15px;
  margin-top: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro3 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro3 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro3 .grid-metro-item {
    width: 100%;
  }
}
.grid-metro3 .resizer {
  width: 33.33%;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro3 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro3 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro3 .resizer {
    width: 100%;
  }
}

.eduvibe-home-two-course .grid-metro3 .grid-metro-item {
  width: 33.33%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-home-two-course .grid-metro3 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .eduvibe-home-two-course .grid-metro3 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-home-two-course .grid-metro3 .grid-metro-item {
    width: 100%;
  }
}
.eduvibe-home-two-course .grid-metro3 .resizer {
  width: 33.33%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-home-two-course .grid-metro3 .resizer {
    width: 50%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .eduvibe-home-two-course .grid-metro3 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-home-two-course .grid-metro3 .resizer {
    width: 100%;
  }
}

.grid-metro4 {
  margin: 0 -15px;
}
.grid-metro4 .grid-metro-item {
  width: 25%;
  padding: 0 15px;
  margin-top: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro4 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro4 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro4 .grid-metro-item {
    width: 100%;
  }
}
.grid-metro4 .resizer {
  width: 25%;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro4 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro4 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro4 .resizer {
    width: 100%;
  }
}

.grid-metro5 {
  margin: 0 -15px;
}
.grid-metro5 .grid-metro-item {
  width: 20%;
  padding: 0 15px;
  margin-top: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .grid-metro5 .grid-metro-item {
    width: 33.33%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro5 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro5 .grid-metro-item {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro5 .grid-metro-item {
    width: 100%;
  }
}
.grid-metro5 .resizer {
  width: 20%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .grid-metro5 .resizer {
    width: 33.33%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .grid-metro5 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .grid-metro5 .resizer {
    width: 50%;
  }
}
@media only screen and (max-width: 575px) {
  .grid-metro5 .resizer {
    width: 100%;
  }
}

/*-------------------------
Accordion Style 
-------------------------*/
.edu-tab-nav {
  margin: -7.5px;
  border: 0 none;
  justify-content: center;
}
.edu-tab-nav li {
  margin: 7.5px;
}
.edu-tab-nav li.nav-item button.nav-link {
  background: #F5F5F5;
  border-radius: 4px;
  height: 50px;
  line-height: 50px;
  padding: 0 40px;
  color: var(--color-heading);
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  position: relative;
  z-index: 1;
  border: 0 none;
}
@media only screen and (max-width: 767px) {
  .edu-tab-nav li.nav-item button.nav-link {
    padding: 0 15px;
  }
}
.edu-tab-nav li.nav-item button.nav-link::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 77px;
  height: 92%;
  left: -5px;
  top: -3px;
  z-index: -1;
  transition: 0.4s;
  opacity: 0;
}
.edu-tab-nav li.nav-item button.nav-link.active {
  background: var(--color-primary);
  color: var(--color-white);
}
.edu-tab-nav li.nav-item button.nav-link.active::after {
  opacity: 0.4;
}

.accordion-shape-1 {
  position: relative;
  z-index: 1;
}
.accordion-shape-1 .shape-image {
  position: absolute;
  z-index: -1;
  top: 156px;
  left: 276px;
}

.edu-accordion-area .gallery-wrapper {
  padding-right: 55px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-accordion-area .gallery-wrapper {
    padding-right: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-accordion-area .gallery-wrapper {
    padding-right: 15px;
  }
}

.accordion-style-1 .edu-accordion-header {
  margin-bottom: 0;
}
.accordion-style-1 .edu-accordion-button {
  font-size: 20px;
  border: 0 none;
  background: transparent;
  border-top: 1px solid #EEEEEE;
  width: 100%;
  text-align: left;
  padding: 20px 0;
  font-weight: 700;
  line-height: 32px;
  position: relative;
}
.accordion-style-1 .edu-accordion-button::after {
  position: absolute;
  content: "\\e935";
  font-family: "icomoon";
  color: var(--color-heading);
  font-size: 20px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s;
}
.accordion-style-1 .edu-accordion-button[aria-expanded=true]::after {
  content: "\\e934";
}
.accordion-style-1 .edu-accordion-body {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 20px;
}
.accordion-style-1 .edu-accordion-item:last-child .edu-accordion-button {
  border-bottom: 1px solid #EEEEEE;
}
.accordion-style-1 .edu-accordion-item:last-child.active-item .edu-accordion-button {
  border-bottom: 0px;
}
.accordion-style-1 .edu-accordion-item:last-child.active-item {
  border-bottom: 1px solid #EEEEEE;
}

.edu-accordion-02 {
  background: #FFFFFF;
}
.edu-accordion-02 .edu-accordion-button {
  font-size: 20px;
  border: 0 none;
  background: transparent;
  width: 100%;
  text-align: left;
  padding: 13px 35px;
  font-weight: 700;
  line-height: 32px;
  position: relative;
  border: 1px solid #EEEEEE;
  border-radius: 5px;
  transition: 0.4s;
}
.edu-accordion-02 .edu-accordion-button::after {
  position: absolute;
  content: "\\e969";
  font-family: "icomoon";
  color: var(--color-heading);
  font-size: 20px;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.4s;
}
.edu-accordion-02 .edu-accordion-button[aria-expanded=true]::after {
  content: "\\ea78";
  font-family: "remixicon";
}
.edu-accordion-02 .edu-accordion-body {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 0;
  padding: 0 35px;
  padding-bottom: 35px;
}
.edu-accordion-02 .edu-accordion-body ul li {
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  padding: 14px 0;
  align-items: center;
  margin: 0;
}
.edu-accordion-02 .edu-accordion-body ul li .text i {
  margin-right: 8px;
}
.edu-accordion-02 .edu-accordion-body ul li + li {
  border-top: 1px solid #eee;
}
.edu-accordion-02 .edu-accordion-body ul li:last-child {
  padding-bottom: 0;
}
.edu-accordion-02 .edu-accordion-item {
  transition: 0.4s;
}
.edu-accordion-02 .edu-accordion-item:last-child .edu-accordion-button {
  border-bottom: 1px solid #EEEEEE;
}
.edu-accordion-02 .edu-accordion-item.bg-active {
  background: #FFFFFF;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
}
.edu-accordion-02 .edu-accordion-item.bg-active .edu-accordion-button {
  border: 0 none;
  color: var(--color-primary);
}
.edu-accordion-02 .edu-accordion-item.bg-active .edu-accordion-button::after {
  color: var(--color-primary);
}
.edu-accordion-02 .edu-accordion-item + .edu-accordion-item {
  margin-top: 20px;
}
.edu-accordion-02.variation-2 .edu-accordion-button {
  border: transparent;
  background: #F5F5F5;
  border-radius: 10px;
  padding: 31px 32px;
  padding-right: 69px;
}
.edu-accordion-02.variation-2 .edu-accordion-button::after {
  content: "\\e935";
  width: 32px;
  height: 32px;
  background: #FFFFFF;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.02);
  color: var(--color-primary);
  line-height: 32px;
  text-align: center;
  border-radius: 100%;
}
.edu-accordion-02.variation-2 .edu-accordion-button[aria-expanded=true]::after {
  content: "\\e934";
  font-family: "icomoon";
  background: #E0F7F4;
  color: var(--color-primary);
}
.edu-accordion-02.variation-2 .edu-accordion-item .edu-accordion-body {
  padding: 0 31px;
  padding-bottom: 35px;
}
.edu-accordion-02.variation-2 .edu-accordion-item .edu-accordion-body p {
  margin-bottom: 0;
}
.edu-accordion-02.variation-2 .edu-accordion-item.bg-active {
  background: #FFFFFF;
  box-shadow: 0px 15px 50px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}
.edu-accordion-02.variation-2 .edu-accordion-item.bg-active .edu-accordion-button {
  border: 0 none;
  color: var(--color-primary);
  background: transparent;
}
.edu-accordion-02.variation-2 .edu-accordion-item + .edu-accordion-item {
  margin-top: 30px;
}
.edu-accordion-02.variation-2.landing-page-accordion .edu-accordion-button[aria-expanded=true]::after {
  background: var(--color-primary);
  color: #FFFFFF;
}
.edu-accordion-02.variation-2.landing-page-accordion .edu-accordion-item.bg-active .edu-accordion-button {
  color: var(--color-heading);
}

.edu-privacy-policy p:last-child {
  margin-bottom: 0;
}
.edu-privacy-policy h1,
.edu-privacy-policy h2,
.edu-privacy-policy h3,
.edu-privacy-policy h4,
.edu-privacy-policy h5,
.edu-privacy-policy h6 {
  margin-bottom: 15px;
}

/* Purchase Guide  */
.gallery-column {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}
.gallery-column.gallery-column-2 .gallery-image {
  flex-basis: 50%;
  padding: 15px;
}

/*------------------------
    Error Styles  
-------------------------*/
.edu-error-style {
  padding-bottom: 130px;
}
.edu-error-style .content .title {
  margin-bottom: 20px;
}
.edu-error-style .content .description {
  margin-bottom: 40px;
}
@media only screen and (max-width: 991px) {
  .edu-error-style {
    padding-bottom: 80px;
  }
}

.circle-image {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}
.circle-image span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid var(--color-secondary);
  pointer-events: none;
  animation: eduvibe-rotate-animate 13s linear infinite;
}
.circle-image span:nth-child(1) {
  border-radius: 38% 62% 64% 36%/43% 35% 65% 57%;
}
.circle-image span:nth-child(2) {
  animation-direction: reverse;
  border-radius: 41% 59% 40% 60%/65% 66% 34% 35%;
}
.circle-image span:nth-child(3) {
  animation-duration: 3s;
  border-radius: 73% 27% 56% 44%/57% 74% 26% 43%;
}

@keyframes eduvibe-rotate-animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Comming Soon Style  */
.edu-coming-soon-style {
  text-align: center;
}
.edu-coming-soon-style .content .logo {
  margin-bottom: 80px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-coming-soon-style .content .logo {
    margin-bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-coming-soon-style .content .logo {
    margin-bottom: 40px;
  }
}
.edu-coming-soon-style .content .logo a {
  display: block;
}
.edu-coming-soon-style .content .title {
  font-weight: 800;
  font-size: 72px;
  line-height: 1.25;
  margin-bottom: 80px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-coming-soon-style .content .title {
    font-size: 60px;
    margin-bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-coming-soon-style .content .title {
    font-size: 40px;
    margin-bottom: 40px;
  }
}
.edu-coming-soon-style .content .countdown-style-2 {
  margin-bottom: 80px;
}
@media only screen and (max-width: 991px) {
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container {
    min-width: 150px;
    padding: 25px 10px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-value {
    font-size: 55px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-heading {
    font-size: 22px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container {
    min-width: 100px;
    padding: 15px 10px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-value {
    font-size: 35px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-heading {
    font-size: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container {
    min-width: 80px;
    padding: 15px 10px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-value {
    font-size: 25px;
  }
  .edu-coming-soon-style .content .countdown-style-2 .countdown .countdown-container .countdown-heading {
    font-size: 16px;
  }
}
.edu-coming-soon-style .content .description {
  margin: 0 auto 40px;
  max-width: 760px;
}

.newsletter-form-style-2 {
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-2 {
    display: block;
  }
}
.newsletter-form-style-2 input {
  min-width: 407px;
  width: 407px;
  background: #FFFFFF;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  border: 0 none;
  padding: 0 25px;
  font-weight: 500;
  height: 60px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .newsletter-form-style-2 input {
    min-width: 300px;
    width: 300px;
  }
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-2 input {
    min-width: auto;
    width: 100%;
  }
}
.newsletter-form-style-2 .edu-btn {
  margin-left: 10px;
}
@media only screen and (max-width: 767px) {
  .newsletter-form-style-2 .edu-btn {
    margin-left: 0;
    margin-top: 20px;
  }
}

/* --------------------
Gallery Item 
------------------- */
.filters-button-group {
  margin: -7.5px;
  flex-wrap: wrap;
}
.filters-button-group button {
  height: 36px;
  padding: 0 20px;
  width: auto;
  border: 0 none;
  background: #F5F5F5;
  border-radius: 3px;
  color: var(--color-heading);
  margin: 7.5px;
  font-weight: 600;
  transition: 0.4s;
}
.filters-button-group button.is-checked, .filters-button-group button:hover {
  background: var(--color-primary);
  color: var(--color-white);
}

.edu-gallery-grid-item {
  display: block;
  border-radius: 5px;
  padding: 0 15px !important;
}
.edu-gallery-grid-item .edu-gallery-grid {
  position: relative;
}
.edu-gallery-grid-item .edu-gallery-grid img {
  border-radius: 5px;
}
.edu-gallery-grid-item .edu-gallery-grid::before {
  background: linear-gradient(180deg, rgba(82, 95, 225, 0.3) 10.75%, #525fe1 85%);
  border-radius: 5px;
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: 0.4s;
}
.edu-gallery-grid-item .edu-gallery-grid .zoom-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.4s;
  opacity: 0;
}
.edu-gallery-grid-item .edu-gallery-grid .zoom-icon i {
  color: var(--color-white);
  font-size: 25px;
}
.edu-gallery-grid-item .edu-gallery-grid .hover-action {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 30px 40px;
  z-index: 1;
  transition: 0.4s;
  opacity: 0;
}
@media only screen and (max-width: 767px) {
  .edu-gallery-grid-item .edu-gallery-grid .hover-action {
    padding: 20px 20px;
  }
}
.edu-gallery-grid-item .edu-gallery-grid .hover-action .hover-content .hover-text .title {
  color: var(--color-white);
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .edu-gallery-grid-item .edu-gallery-grid .hover-action .hover-content .hover-text .title {
    font-size: 20px;
    line-height: 32px;
  }
}
.edu-gallery-grid-item:hover .edu-gallery-grid::before {
  opacity: 1;
}
.edu-gallery-grid-item:hover .edu-gallery-grid .zoom-icon {
  opacity: 1;
}
.edu-gallery-grid-item:hover .edu-gallery-grid .hover-action {
  opacity: 1;
}

/*--------------------------
    Pricing Table  
----------------------------*/
.edu-pricing-area {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.pricing-billing-duration {
  text-align: right;
}
@media only screen and (max-width: 767px) {
  .pricing-billing-duration {
    text-align: left;
  }
}
.pricing-billing-duration ul {
  background: rgba(82, 95, 225, 0.08);
  border-radius: 5px;
  padding: 10px;
  display: inline-block;
}
.pricing-billing-duration ul .nav-item {
  float: left;
  margin: 0;
}
.pricing-billing-duration ul .nav-item .nav-link {
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-heading);
  border: 0 none;
  background: transparent;
  padding: 0 25px;
  border-radius: 3px;
}
.pricing-billing-duration ul .nav-item .nav-link.active {
  background: var(--color-primary);
  color: var(--color-white);
}

.pricing-table {
  background: #FFFFFF;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.03);
  border-radius: 5px;
  padding: 60px 64px;
  position: relative;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pricing-table {
    padding: 60px 30px;
  }
}
@media only screen and (max-width: 767px) {
  .pricing-table {
    padding: 60px 30px;
  }
}
.pricing-table .pricing-header {
  margin-bottom: 40px;
  text-align: center;
}
.pricing-table .pricing-header .price-wrap .monthly-pricing {
  display: none;
}
.pricing-table .pricing-header .price-wrap .amount {
  font-weight: 800;
  font-size: 40px;
  line-height: 56px;
  color: var(--color-primary);
}
.pricing-table .pricing-header .price-wrap .duration {
  color: var(--color-primary);
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  display: inline-block;
  margin-left: -4px;
}
.pricing-table .pricing-header .title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}
.pricing-table .pricing-body {
  margin-bottom: 40px;
}
.pricing-table .pricing-body .list-item li {
  display: flex;
  align-items: center;
  margin: 0;
}
.pricing-table .pricing-body .list-item li i {
  color: var(--color-secondary);
  margin-right: 10px;
}
.pricing-table .pricing-body .list-item li + li {
  margin-top: 16px;
}
.pricing-table.active {
  transform: translateY(-20px);
}
.pricing-table.active .edu-badge {
  background: var(--color-secondary);
  padding: 0 17px;
  position: absolute;
  right: 0;
  top: 15px;
  height: 30px;
  line-height: 30px;
  padding-left: 25px;
}
.pricing-table.active .edu-badge span {
  font-weight: 700;
  font-size: 14px;
  color: var(--color-white);
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.pricing-table.active .edu-badge::after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 24px 0 24px 23px;
  border-color: transparent transparent transparent #fff;
  position: absolute;
  right: 87%;
  top: 50%;
  content: "";
  transform: translateY(-50%);
}

/*-------------------------
    Profile Details 
--------------------------*/
.instructor-profile-left {
  background: #F5F5F5;
  border-radius: 5px;
  padding: 40px 20px;
}
.instructor-profile-left .inner {
  text-align: center;
}
.instructor-profile-left .inner .thumbnail {
  max-width: 230px;
  max-height: 230px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.instructor-profile-left .inner .thumbnail img {
  border-radius: 100%;
  width: 100%;
  height: 100%;
}
.instructor-profile-left .inner .content .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 2px;
}
.instructor-profile-left .inner .content .subtitle {
  font-weight: 600;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 25px;
}
.instructor-profile-left .inner .content .contact-with-info {
  margin-bottom: 25px;
}
.instructor-profile-left .inner .content .contact-with-info p {
  margin-bottom: 5px;
}
.instructor-profile-left .inner .content .contact-with-info p span {
  font-weight: 600;
  color: var(--color-heading);
}
.instructor-profile-left .inner .content .contact-with-info p a {
  color: var(--color-body);
}
.instructor-profile-left .inner .content .contact-btn {
  margin-top: 40px;
}

/* Course Statictatic  */
.course-statistic-wrapper .line-separator {
  position: relative;
}
.course-statistic-wrapper .line-separator + .line-separator::before {
  position: absolute;
  content: "";
  background: #FFFFFF;
  height: 66px;
  width: 1px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.15;
  left: 0;
}

.course-statistic .inner .total {
  font-weight: 800;
  font-size: 40px;
  line-height: 56px;
  color: var(--color-white);
  margin-bottom: 0;
}
.course-statistic .inner p {
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-white);
  margin-bottom: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.single-progress {
  position: relative;
  overflow: hidden;
}
.single-progress .title {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  margin-bottom: 10px;
}

.progress {
  height: 6px;
  overflow: visible;
  background-color: rgba(82, 95, 225, 0.15);
  border-radius: 2px;
}
.progress .progress-bar {
  border-radius: 2px;
  width: 0;
  height: 100%;
  background-color: var(--color-primary);
  transition: width 0.5s ease;
  overflow: visible;
}
.progress .progress-number {
  position: absolute;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  top: 0;
  right: 0;
  z-index: 1;
  color: var(--color-heading);
}

/*-------------------------
    Contact Us Area  
---------------------------*/
.contact-address-card-1 {
  background: #FFFFFF;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 50px 20px;
  text-align: center;
  transition: 0.4s;
}
.contact-address-card-1 .inner .icon {
  background: rgba(82, 95, 225, 0.1);
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s;
}
.contact-address-card-1 .inner .icon i {
  color: var(--color-primary);
  font-size: 24px;
  transition: 0.4s;
}
.contact-address-card-1 .inner .content .title {
  font-weight: 700;
  margin-top: 25px;
  margin-bottom: 15px;
  transition: 0.4s;
}
.contact-address-card-1 .inner .content p {
  margin-bottom: 0;
  transition: 0.4s;
}
.contact-address-card-1 .inner .content p a {
  color: var(--color-body);
  transition: 0.4s;
}
.contact-address-card-1 .inner .content p a:hover {
  color: var(--color-primary);
}
.contact-address-card-1.phone .inner .icon {
  background: rgba(251, 124, 86, 0.1);
}
.contact-address-card-1.phone .inner .icon i {
  color: var(--color-secondary);
}
.contact-address-card-1.email .inner .icon {
  background: rgba(255, 164, 27, 0.1);
}
.contact-address-card-1.email .inner .icon i {
  color: #FFA41B;
}
.contact-address-card-1:hover {
  background: var(--color-secondary);
  transform: translateY(-15px);
}
.contact-address-card-1:hover .inner .icon {
  background: var(--color-white);
}
.contact-address-card-1:hover .inner .icon i {
  color: var(--color-secondary);
}
.contact-address-card-1:hover .inner .content .title {
  color: var(--color-white);
}
.contact-address-card-1:hover .inner .content p {
  color: var(--color-white);
}
.contact-address-card-1:hover .inner .content p a {
  color: var(--color-white);
}

.contact-address-card-2 {
  background: #FFFFFF;
  box-shadow: 0px 8px 35px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 70px 40px;
  text-align: center;
  transition: 0.4s;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .contact-address-card-2 {
    padding: 60px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .contact-address-card-2 {
    padding: 60px 20px;
  }
}
.contact-address-card-2 .inner .icon {
  margin-bottom: 45px;
}
.contact-address-card-2 .inner .content .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 20px;
}
.contact-address-card-2 .inner .content p {
  margin-bottom: 0;
  line-height: 26px;
}
.contact-address-card-2 .inner .content p .subtitle {
  font-weight: 600;
  color: var(--color-heading);
}
.contact-address-card-2 .inner .content p .text {
  font-weight: 500;
}
.contact-address-card-2:hover {
  transform: translateY(-15px);
}

.contact-address-bottom-shape {
  position: relative;
  z-index: 1;
}
.contact-address-bottom-shape .bg-shape-image {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: -1;
}

/*------------------------------
    Contact Form Style One 
-------------------------------*/
.rwt-dynamic-form .form-group input {
  background: #F5F5F5;
  border-radius: 5px;
  padding: 0 30px;
  border: 1px solid transparent;
  transition: 0.4s;
  outline: none;
  box-shadow: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  height: 60px;
}
.rwt-dynamic-form .form-group input:focus {
  border-color: var(--color-primary);
}
.rwt-dynamic-form .form-group textarea {
  background: #F5F5F5;
  padding: 17px 30px;
  min-height: 180px;
  border: 0 none;
  border: 1px solid transparent;
  transition: 0.4s;
  outline: none;
  box-shadow: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  border-radius: 5px;
}
.rwt-dynamic-form .form-group textarea:focus {
  border-color: var(--color-primary);
}
.rwt-dynamic-form .success-message {
  margin-top: 20px;
  color: #019267;
}

/*---------------------------
    About Me 
----------------------------*/
.about-me-1 .thumbnail {
  position: relative;
  border-radius: 5px;
}
.about-me-1 .thumbnail::before {
  background: linear-gradient(360deg, #2D284E 0%, rgba(45, 40, 78, 0) 70.5%);
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.about-me-1 .thumbnail img {
  border-radius: 5px;
}
.about-me-1 .thumbnail .content-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 50px 20px;
}
@media only screen and (max-width: 767px) {
  .about-me-1 .thumbnail .content-overlay {
    padding: 20px 20px;
  }
}
.about-me-1 .thumbnail .content-overlay .title {
  margin-bottom: 0;
  color: var(--color-white);
  font-size: 32px;
  line-height: 44px;
}
@media only screen and (max-width: 767px) {
  .about-me-1 .thumbnail .content-overlay .title {
    font-size: 22px;
    line-height: 32px;
  }
}

.google-map.alignwide {
  margin-left: -105px;
  margin-right: -105px;
  min-width: 1170px;
  width: auto;
}
@media only screen and (max-width: 1650px) {
  .google-map.alignwide {
    margin-left: 0;
    margin-right: 0;
    min-width: auto;
  }
}
.google-map.alignwide iframe {
  width: 100%;
}

/*-----------------------
    Shop Style  
------------------------*/
.product {
  overflow: hidden;
}
.product .inner {
  text-align: center;
}
.product .inner .thumbnail {
  position: relative;
}
.product .inner .thumbnail a {
  display: block;
  overflow: hidden;
  border-radius: 5px;
}
.product .inner .thumbnail a img {
  width: 100%;
  border-radius: 5px;
  transition: 0.4s;
  overflow: hidden;
}
.product .inner .thumbnail a img.w-100-thumb {
  display: flex;
}
.product .inner .thumbnail .product-hover-info {
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--color-primary);
  width: 100%;
  border-radius: 0px 0px 5px 5px;
  transition: 0.4s;
  opacity: 0;
  height: 0;
  z-index: 1;
}
.product .inner .thumbnail .product-hover-info ul {
  display: flex;
}
.product .inner .thumbnail .product-hover-info ul li {
  margin: 0;
  flex-basis: 50%;
  padding: 7px;
  position: relative;
}
.product .inner .thumbnail .product-hover-info ul li a {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-white);
}
.product .inner .thumbnail .product-hover-info ul li + li::after {
  position: absolute;
  content: "";
  background: rgba(255, 255, 255, 0.2);
  width: 1px;
  height: 100%;
  left: 0;
  top: 0;
}
.product .inner .thumbnail .product-hover-info ul li.product-each-item-content-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.product .inner .thumbnail .product-hover-info ul li.old-price {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.product .inner .content {
  padding-top: 20px;
}
.product .inner .content .product-author {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  display: block;
  margin-bottom: 5px;
}
.product .inner .content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 5px;
}
.product .inner .content .price-list.price-style-03 {
  margin: -8px;
}
.product .inner .content .price-list.price-style-03 .price {
  margin: 8px;
}
.product .inner .content .price-list.price-style-03 .current-price {
  font-size: 18px;
  line-height: 28px;
  color: var(--color-primary);
}
.product .inner .content .price-list.price-style-03 .old-price {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
}
.product:hover .inner .thumbnail a img {
  transform: scale(1.1);
}
.product:hover .inner .thumbnail .product-hover-info {
  opacity: 1;
  height: 40px;
}

/*-----------------------
    Brand Styles  
-----------------------*/
.brand-list li {
  margin: 0;
  text-align: center;
}
.brand-list li a {
  display: block;
  text-align: center;
}
.brand-list li a img {
  display: inline-block;
  text-align: center;
}

/*--------------------------
    Checkout Page Style  
----------------------------*/
.checkout-page-style .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  padding-bottom: 15px;
  border-bottom: 1px solid #EEEEEE;
  margin-bottom: 30px;
}
.checkout-page-style input {
  background: #F5F5F5;
  border-radius: 5px;
  border: 0 none;
  height: 60px;
  padding: 0 25px;
  font-weight: 500;
  color: var(--color-body);
  border: 1px solid transparent;
}
.checkout-page-style input:focus {
  border-color: var(--color-primary);
}
.checkout-page-style select {
  border: 1px solid #6F6B80;
  border-radius: 5px;
  padding: 0 25px;
  height: 60px;
  font-weight: 500;
  color: var(--color-body);
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) 95% center no-repeat transparent;
}
.checkout-page-style textarea {
  background: #F5F5F5;
  border-radius: 5px;
  border: 0 none;
  padding: 15px 25px;
  font-weight: 500;
  color: var(--color-body);
  min-height: 170px;
  resize: none;
  border: 1px solid transparent;
}
.checkout-page-style textarea:focus {
  border-color: var(--color-primary);
}
.checkout-page-style .box-label {
  margin-bottom: 8px;
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
}
.checkout-page-style .shop_table {
  margin-bottom: 20px;
}
.checkout-page-style .shop_table thead tr th {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  border-bottom: 1px solid #EEEEEE;
  padding: 10px 0;
  margin-bottom: 10px;
}
.checkout-page-style .shop_table tbody tr td {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-body);
  border: 0 none;
  padding: 5px 0;
}
.checkout-page-style .shop_table tbody tr:first-child td {
  padding-top: 20px;
}
.checkout-page-style .shop_table tfoot tr th {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  padding: 5px 0;
}
.checkout-page-style .shop_table tfoot tr.order-subtotal th {
  font-weight: 500;
  color: var(--color-body);
}

/*-------------------------------
    Overall React Specific Styles  
---------------------------------*/
body.search-popup-active {
  overflow-y: hidden;
}

.eduvibe-google-map {
  width: 100%;
  height: 500px;
}
@media only screen and (max-width: 767px) {
  .eduvibe-google-map {
    height: 350px;
  }
}

.edu-contact-map-area .eduvibe-google-map div {
  border-radius: 5px;
}

.event-widget .eduvibe-google-map {
  height: 290px;
}
.event-widget .eduvibe-google-map div {
  border-radius: 5px;
}

.banner-style-5 .rating i,
.eduvibe-testimonial-three .rating i,
.eduvibe-testimonial-four .rating i,
.eduvibe-course-rating-stars i:not(:last-child) {
  margin-right: 4px;
}

.video-play-btn.eduvibe-video-play-icon {
  color: var(--color-primary);
  font-size: 18px;
}

.video-play-btn.btn-theme-color.eduvibe-video-play-icon {
  color: var(--color-white);
}

.video-play-btn.btn-secondary-color.eduvibe-video-play-icon {
  color: var(--color-secondary);
}

body .about-style-4 .gallery-wrapper .image-3 img {
  border: 0;
}

.eduvibe-gallery-items.mt--5 {
  margin-top: 35px !important;
}

.eduvibe-gallery-items .edu-gallery-grid-item {
  padding: 0 !important;
}

.eduvibe-masonry-grid {
  display: flex;
  width: auto;
  margin: 65px 0 -15px;
}

.eduvibe-masonry-grid_column {
  padding: 0 15px;
  background-clip: padding-box;
}

.eduvibe-masonry-grid_column .edu-gallery-grid-item {
  padding: 0 !important;
  margin-bottom: 30px;
}

.edu-gallery-grid-item .edu-gallery-grid .zoom-icon {
  position: absolute;
  top: 0;
  left: 0;
  transform: inherit !important;
  transition: 0.4s;
  opacity: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  border: 0;
  cursor: pointer;
  background: transparent;
}

.eduvibe-countdown-ending-notice {
  color: var(--color-primary);
}

.banner-style-5 .video-btn-wrapper,
.banner-style-1 .scroll-down-btn .round-btn,
.banner-style-3 .scroll-down-btn .round-btn {
  cursor: pointer;
}

.edu-blog-widget.edu-instagram-widget-2,
.edu-blog-widget.edu-about-widget-2 {
  background: transparent;
  padding: 0;
}

.edu-blog-widget.edu-instagram-widget-2 .widget-title,
.edu-blog-widget.edu-about-widget-2 .widget-title {
  padding-bottom: 0px;
  margin-bottom: 30px;
  border-bottom: 0;
}

.edu-blog.blog-type-2.variation-2.bg-color-gray {
  background: var(--color-shade);
}

.eduvibe-blog-standard-wrapper .eduvibe-post-standard:first-child {
  margin-top: 0 !important;
}

.eduvibe-post-one-carousel-item,
.eduvibe-event-one-carousel-item {
  padding: 15px;
}

.eduvibe-post-one-carousel-item .edu-blog.blog-type-2:hover {
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
}

.edu-event.event-grid-1.bg-shade .inner {
  background: var(--color-shade);
  box-shadow: inherit !important;
}

.edu-card.card-type-2:hover {
  background-color: var(--color-white);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);
}

.eduvibe-course-two-single .edu-card.card-type-2:hover {
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.06);
}

.eduvibe-event-one-carousel-item .edu-event.event-grid-1.bg-shade .inner:hover {
  background: var(--color-white);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
}

button.edu-btn .eduvibe-spin-icon {
  padding-left: 10px;
  position: relative;
}

.eduvibe-event-two-shadow .inner {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
}

.slick-slide .author-meta .author-thumb a img {
  display: initial;
}

.edu-card.card-type-4 .inner .thumbnail a img {
  object-fit: cover;
}

.eduvibe-course-style-four .edu-meta.meta-03 li:last-child {
  margin-right: 0px;
}

.eduvibe-course-one-carousel .edu-card.card-type-3 {
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
}

.eduvibe-course-one-carousel .single-slick-card {
  margin-bottom: 20px;
}

.eduvibe-course-price-filter input {
  padding: 0;
}

.landing-demo-nav-btn:hover {
  cursor: pointer;
}

.landing-inner-pages img {
  padding: 0 15px;
  border-radius: 10px;
}

.eduvibe-post-share span {
  font-weight: 600;
  color: var(--color-dark);
  margin-right: 15px;
}
.eduvibe-post-share a {
  color: var(--body-color);
}
.eduvibe-post-share a:not(:last-child) {
  margin-right: 25px;
}

.rn-back-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 999;
  width: 50px;
  height: 50px;
  line-height: 46px;
  border-radius: 50%;
  text-align: center;
  z-index: 999 !important;
  background-color: var(--color-secondary);
}
.rn-back-top svg {
  transition: 0.3s;
  color: #fff;
  width: 27px;
  height: 27px;
  font-size: 14px !important;
}

@media only screen and (max-width: 991px) {
  .testimonial-style-1 {
    margin-bottom: 50px;
  }
}

/* course filter range CSS starts */
input[type=range] {
  font-size: 1.5rem;
}

input[type=range] {
  color: var(--color-primary);
}

input[type=range].win10-thumb {
  color: var(--color-primary);
  --thumb-width: 0.5em;
}

input[type=range] {
  position: relative;
  background: transparent;
  overflow: hidden;
}

input[type=range]:active {
  cursor: grabbing;
}

/* === WebKit specific styles === */
input[type=range],
input[type=range]::-webkit-slider-runnable-track,
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  -webkit-transition: all ease 100ms;
  transition: all ease 100ms;
  height: 1.125em;
}

input[type=range]::-webkit-slider-runnable-track,
input[type=range]::-webkit-slider-thumb {
  position: relative;
}

input[type=range]::-webkit-slider-thumb {
  --thumb-radius: calc((1.125em * 0.5) - 1px);
  --clip-top: calc((1.125em - 0.125em) * 0.5 - 0.5px);
  --clip-bottom: calc(1.125em - var(--clip-top));
  --clip-further: calc(100% + 1px);
  --box-fill: calc(-100vmax - var(--thumb-width, 1.125em)) 0 0 100vmax var(--color-primary);
  width: var(--thumb-width, 1.125em);
  background: linear-gradient(var(--color-primary) 0 0) scroll no-repeat left center/50% calc(0.125em + 1px);
  background-color: var(--color-primary);
  box-shadow: var(--box-fill);
  border-radius: var(--thumb-width, 1.125em);
  filter: brightness(100%);
  clip-path: polygon(100% -1px, 0.125em -1px, 0 var(--clip-top), -100vmax var(--clip-top), -100vmax var(--clip-bottom), 0 var(--clip-bottom), 0.125em 100%, var(--clip-further) var(--clip-further));
}

input[type=range]:hover::-webkit-slider-thumb {
  cursor: grab;
}

input[type=range]:active::-webkit-slider-thumb {
  cursor: grabbing;
}

input[type=range]::-webkit-slider-runnable-track {
  background: linear-gradient(rgba(0, 0, 0, 0.2) 0 0) scroll no-repeat center/100% calc(0.125em + 1px);
}

input[type=range]:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
}

/* === Firefox specific styles === */
input[type=range],
input[type=range]::-moz-range-track,
input[type=range]::-moz-range-thumb {
  appearance: none;
  -moz-transition: all ease 100ms;
  transition: all ease 100ms;
  height: 1.125em;
}

input[type=range]::-moz-range-track,
input[type=range]::-moz-range-thumb,
input[type=range]::-moz-range-progress {
  background: transparent;
}

input[type=range]::-moz-range-thumb {
  background: var(--color-primary);
  border: 0;
  width: var(--thumb-width, 1.125em);
  border-radius: var(--thumb-width, 1.125em);
  cursor: grab;
}

input[type=range]:active::-moz-range-thumb {
  cursor: grabbing;
}

input[type=range]::-moz-range-track {
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
}

input[type=range]::-moz-range-progress {
  appearance: none;
  background: var(--color-primary);
  transition-delay: 30ms;
}

input[type=range]::-moz-range-track,
input[type=range]::-moz-range-progress {
  height: calc(0.125em + 1px);
  border-radius: 0.125em;
}

input[type=range]:disabled::-moz-range-thumb {
  cursor: not-allowed;
}

/* course filter range CSS ends */
@keyframes eduvibeFadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30%);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.eduvibeFadeInUp {
  animation-name: eduvibeFadeInUp;
}

@media (max-width: 991px) {
  .eduvibe-masonry-grid {
    margin-top: 45px;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1250px;
  }
}
@media (min-width: 1400px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1500px;
  }
}
@media (min-width: 1440px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1380px;
  }
}
@media (min-width: 1920px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1380px;
  }
}
@media (min-width: 2560px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 2175px;
  }
}
/**************************************
    Blog Styles
***************************************/
/*-------------------------
    Blog Grid Styles  
---------------------------*/
.blog-shape-position {
  position: relative;
  z-index: 1;
}
.blog-shape-position .shape-image {
  position: absolute;
  z-index: -1;
  top: 171px;
  left: 138px;
}
.blog-shape-position.shape-position-3 .shape-image {
  top: 70px;
  left: 106px;
}

.blog-meta {
  display: flex;
  flex-wrap: wrap;
  margin: -5px -25px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .blog-meta {
    margin: -5px -10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .blog-meta {
    margin: -5px -10px;
  }
}
@media only screen and (max-width: 767px) {
  .blog-meta {
    margin: -5px -10px;
  }
}
.blog-meta li {
  margin: 5px 25px;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .blog-meta li {
    margin: 5px 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .blog-meta li {
    margin: 5px 10px;
  }
}
@media only screen and (max-width: 767px) {
  .blog-meta li {
    margin: 5px 10px;
  }
}
.blog-meta li i,
.blog-meta li img {
  padding-right: 8px;
  position: relative;
  top: 2px;
}
.blog-meta li a {
  color: var(--color-primary);
}
.blog-meta li.blog-author a {
  color: var(--color-body);
}

/* Blog Grid Styles  */
.edu-blog .top-position {
  position: absolute;
  z-index: 2;
}
.edu-blog .top-position.left-top {
  left: 20px;
  top: 20px;
}
.edu-blog .top-position.left-bottom {
  left: 0;
  bottom: 0;
  border-radius: 0px 5px 0px 0px;
}
.edu-blog .thumbnail {
  position: relative;
}
.edu-blog .thumbnail a {
  display: block;
  overflow: hidden;
}
.edu-blog .thumbnail a img {
  transition: 0.4s;
  overflow: hidden;
  width: 100%;
}
.edu-blog .blog-card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.edu-blog.blog-type-1 {
  background: var(--color-shade);
  overflow: hidden;
  position: relative;
}
.edu-blog.blog-type-1 .inner .content {
  padding: 35px;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-type-1 .inner .content {
    padding: 22px;
  }
}
.edu-blog.blog-type-1 .inner .content .blog-meta {
  margin-bottom: 20px;
}
.edu-blog.blog-type-1 .inner .content .title {
  margin-bottom: 25px;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-type-1 .inner .content .title {
    margin-bottom: 14px;
  }
}
.edu-blog.blog-type-1 .inner .content .description {
  font-weight: 500;
  margin-bottom: 0;
}
.edu-blog.blog-type-2 {
  background: var(--color-shade);
  overflow: hidden;
  position: relative;
  transition: 0.4s;
}
.edu-blog.blog-type-2 .inner .thumbnail img {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.edu-blog.blog-type-2 .inner .content {
  padding: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-blog.blog-type-2 .inner .content {
    padding: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-type-2 .inner .content {
    padding: 20px;
  }
}
.edu-blog.blog-type-2 .inner .content .title {
  margin-bottom: 20px;
  margin-top: 20px;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-type-2 .inner .content .title {
    margin-bottom: 14px;
    margin-top: 14px;
  }
}
.edu-blog.blog-type-2.variation-2 {
  padding: 15px;
  background: #FFFFFF;
  transition: 0.4s;
}
.edu-blog.blog-type-2.variation-2 .inner .content {
  padding: 15px;
  padding-top: 0;
}
.edu-blog.blog-type-2.variation-2 .inner .content .blog-date-status {
  width: 64px;
  height: 64px;
  background: var(--color-primary);
  border-radius: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -32px;
  margin-bottom: 18px;
  position: relative;
  z-index: 1;
}
.edu-blog.blog-type-2.variation-2 .inner .content .blog-date-status span {
  font-weight: bold;
  font-size: 20px;
  display: block;
  color: var(--color-white);
  text-align: center;
}
.edu-blog.blog-type-2.variation-2 .inner .content .blog-date-status span.day {
  line-height: 1;
  margin-bottom: 1px;
}
.edu-blog.blog-type-2.variation-2 .inner .content .blog-date-status span.month {
  line-height: 1;
}
.edu-blog.blog-type-2.variation-2 .inner .content .title {
  margin-bottom: 0;
  margin-top: 14px;
}
.edu-blog.blog-type-2.variation-2:hover {
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.04);
}
.edu-blog.blog-type-2:hover {
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
}
.edu-blog.blog-type-2.bg-white {
  background: var(--color-white);
}
.edu-blog.blog-type-2.bg-white:hover {
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
}
.edu-blog.blog-type-3 {
  background: var(--color-shade);
  overflow: hidden;
  position: relative;
  transition: 0.4s;
}
.edu-blog.blog-type-3 .inner {
  padding: 30px;
}
.edu-blog.blog-type-3 .inner .content .title {
  margin-bottom: 30px;
  margin-top: 20px;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-type-3 .inner .content .title {
    margin-bottom: 20px;
  }
}
.edu-blog.blog-type-3 .inner .thumbnail {
  margin-top: 30px;
  overflow: hidden;
}
.edu-blog.blog-type-3 .inner .thumbnail a {
  border-radius: 3px;
}
.edu-blog.blog-type-3 .inner .thumbnail a img {
  border-radius: 3px;
}
.edu-blog.blog-type-3:hover {
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
}
.edu-blog.blog-type-4 {
  background: var(--color-white);
  overflow: hidden;
  position: relative;
  height: 100%;
}
.edu-blog.blog-type-4 .inner .content {
  padding: 25px 30px;
}
.edu-blog.blog-type-4 .inner .content .blog-meta {
  margin: -5px -7.5px;
}
.edu-blog.blog-type-4 .inner .content .blog-meta li {
  font-size: 14px;
  line-height: 22px;
  margin: 5px 7.5px;
}
.edu-blog.blog-type-4 .inner .content .title {
  margin-bottom: 15px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
}
.edu-blog:hover .inner .thumbnail a img {
  transform: scale(1.1);
}
.edu-blog.blog-overlay-transparent {
  position: relative;
}
.edu-blog.blog-overlay-transparent .thumbnail {
  overflow: hidden;
}
.edu-blog.blog-overlay-transparent .thumbnail a {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 5px;
}
.edu-blog.blog-overlay-transparent .thumbnail a::after {
  background: linear-gradient(180deg, rgba(45, 40, 78, 0) 0%, #2D284E 100%);
  border-radius: 5px;
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.edu-blog.blog-overlay-transparent .thumbnail a img {
  border-radius: 5px;
  overflow: hidden;
}
.edu-blog.blog-overlay-transparent .content {
  position: absolute;
  bottom: 0;
  padding: 40px;
  left: 0;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-overlay-transparent .content {
    padding: 20px;
  }
}
.edu-blog.blog-overlay-transparent .content .eduvibe-status-list {
  margin-bottom: 5px;
}
.edu-blog.blog-overlay-transparent .content .eduvibe-status-list .eduvibe-status-transparent {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-white);
  display: inline-block;
}
.edu-blog.blog-overlay-transparent .content .title {
  margin-bottom: 25px;
  font-weight: 700;
  font-size: 32px;
  line-height: 44px;
}
@media only screen and (max-width: 767px) {
  .edu-blog.blog-overlay-transparent .content .title {
    margin-bottom: 16px;
    font-size: 24px;
    line-height: 32px;
  }
}
.edu-blog.blog-overlay-transparent .content .title a {
  color: var(--color-white);
}
.edu-blog.blog-overlay-transparent .content .blog-meta {
  margin: -5px -7.5px;
}
.edu-blog.blog-overlay-transparent .content .blog-meta li {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin: 5px 7.5px;
  color: var(--color-white);
}
.edu-blog.blog-overlay-transparent .content .blog-meta li a {
  color: var(--color-white);
}

/*--------------------------
    Blog Sidebar Styles 
----------------------------*/
.edu-blog-widget {
  background: #F5F5F5;
  border-radius: 5px;
  padding: 30px;
}
@media only screen and (max-width: 767px) {
  .edu-blog-widget {
    padding: 20px;
  }
}
.edu-blog-widget .widget-title {
  padding-bottom: 20px;
  margin-bottom: 28px;
  border-bottom: 1px solid rgba(45, 40, 78, 0.07);
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}
.edu-blog-widget.widget-search .blog-search {
  position: relative;
}
.edu-blog-widget.widget-search .blog-search input {
  border: 0 none;
  background: var(--color-white);
  height: 60px;
  width: 100%;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  padding: 0 72px 0 25px;
}
.edu-blog-widget.widget-search .blog-search .search-button {
  position: absolute;
  right: 0;
  top: 0;
  background-color: var(--color-primary);
  border: 0 none;
  height: 100%;
  width: 60px;
  text-align: center;
  color: var(--color-white);
  font-size: 20px;
  border-radius: 0px 3px 3px 0px;
}
.edu-blog-widget.widget-categories .category-list li {
  margin: 0;
}
.edu-blog-widget.widget-categories .category-list li a {
  background: #FFFFFF;
  border-radius: 3px;
  height: 60px;
  line-height: 60px;
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.edu-blog-widget.widget-categories .category-list li a::after {
  position: absolute;
  content: "";
  background: #EEEEEE;
  height: 30px;
  width: 1px;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
}
.edu-blog-widget.widget-categories .category-list li + li {
  margin-top: 15px;
}
.edu-blog-widget.widget-latest-post .latest-post {
  display: flex;
  align-items: center;
  position: relative;
}
.edu-blog-widget.widget-latest-post .latest-post .thumbnail {
  margin-right: 25px;
}
@media only screen and (max-width: 767px) {
  .edu-blog-widget.widget-latest-post .latest-post .thumbnail {
    margin-right: 10px;
  }
}
.edu-blog-widget.widget-latest-post .latest-post .thumbnail a img {
  border-radius: 3px;
  max-height: 96px;
  object-fit: cover;
}
.edu-blog-widget.widget-latest-post .latest-post .post-content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 0;
}
.edu-blog-widget.widget-latest-post .latest-post + .latest-post {
  padding-top: 20px;
  margin-top: 20px;
}
.edu-blog-widget.widget-latest-post .latest-post + .latest-post::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(45, 40, 78, 0.07);
  content: "";
}
.edu-blog-widget.widget-about .about-wrapper {
  text-align: center;
}
.edu-blog-widget.widget-about .about-wrapper .thumbnail {
  margin-bottom: 20px;
}
.edu-blog-widget.widget-about .about-wrapper .thumbnail img {
  max-height: 160px;
  border-radius: 100%;
}
.edu-blog-widget.widget-about .about-wrapper .about-content .title {
  margin-bottom: 15px;
}
.edu-blog-widget.widget-about .about-wrapper .about-content p {
  margin-bottom: 20px;
}
.edu-blog-widget.widget-instagram .instagram-list {
  display: flex;
  flex-wrap: wrap;
  margin: -7.5px;
}
.edu-blog-widget.widget-instagram .instagram-list a {
  flex-basis: 33.33%;
  display: block;
  padding: 7.5px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-blog-widget.widget-instagram .instagram-list a {
    flex-basis: 20%;
  }
}
@media only screen and (max-width: 767px) {
  .edu-blog-widget.widget-instagram .instagram-list a {
    flex-basis: 20%;
  }
}
@media only screen and (max-width: 575px) {
  .edu-blog-widget.widget-instagram .instagram-list a {
    flex-basis: 50%;
  }
}
.edu-blog-widget.widget-instagram .instagram-list a img {
  border-radius: 3px;
  width: 100%;
}

.tag-list {
  margin: -5px;
}
.tag-list a {
  background: #FFFFFF;
  border-radius: 2px;
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  margin: 5px;
  height: 40px;
  padding: 0 14px;
  transition: 0.4s;
}
.tag-list a:hover {
  background: var(--color-primary) !important;
  color: var(--color-white);
}
.tag-list.bg-shade a {
  background: #F5F5F5;
}

/*-----------------------------
    Sidebar Style Two  
-------------------------------*/
.edu-blog-widget-2 .widget-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 30px;
}
.edu-blog-widget-2.widget-search .blog-search {
  position: relative;
}
.edu-blog-widget-2.widget-search .blog-search input {
  border: 0 none;
  background: #F5F5F5;
  height: 60px;
  width: 100%;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  padding: 0 72px 0 25px;
}
.edu-blog-widget-2.widget-search .blog-search .search-button {
  position: absolute;
  right: 0;
  top: 0;
  background-color: transparent;
  border: 0 none;
  height: 100%;
  width: 60px;
  text-align: center;
  color: var(--color-primary);
  font-size: 20px;
  border-radius: 0;
}
.edu-blog-widget-2.widget-categories .category-list li {
  margin: 0;
}
.edu-blog-widget-2.widget-categories .category-list li a {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.edu-blog-widget-2.widget-categories .category-list li + li {
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid #EEEEEE;
}
.edu-blog-widget-2.widget-latest-post .latest-post {
  display: flex;
  align-items: center;
  position: relative;
}
.edu-blog-widget-2.widget-latest-post .latest-post .thumbnail {
  margin-right: 25px;
}
.edu-blog-widget-2.widget-latest-post .latest-post .thumbnail a {
  display: block;
}
.edu-blog-widget-2.widget-latest-post .latest-post .thumbnail a img {
  border-radius: 5px;
  max-height: 100px;
  object-fit: cover;
}
.edu-blog-widget-2.widget-latest-post .latest-post .post-content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 0;
}
.edu-blog-widget-2.widget-latest-post .latest-post + .latest-post {
  padding-top: 20px;
  margin-top: 20px;
}
.edu-blog-widget-2.widget-latest-post .latest-post + .latest-post::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(45, 40, 78, 0.07);
  content: "";
}

/*----------------------------
    Blog Details Styles  
------------------------------*/
.social-share-action {
  position: relative;
}
.social-share-action .social-share-hover-action {
  position: absolute;
  bottom: calc(100% + 16px);
  background: #FFFFFF;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  padding: 15px;
  min-width: 150px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: 0.4s;
  visibility: hidden;
}
.social-share-action .social-share-hover-action::after {
  position: absolute;
  content: "";
  top: 100%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: #FFFFFF transparent transparent transparent;
  left: 50%;
  transform: translateX(-50%);
}
.social-share-action .social-share-hover-action .inner {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.social-share-action .social-share-hover-action .inner a {
  display: inline-block;
  margin: 0 15px;
  color: var(--color-body);
  transition: 0.4s;
}
.social-share-action .social-share-hover-action .inner a:hover {
  color: var(--color-primary);
}
.social-share-action:hover .social-share-hover-action {
  opacity: 1;
  visibility: visible;
}

.blog-details-1 .block-alignwide {
  margin-left: -105px;
  margin-right: -105px;
  max-width: 1170px;
  width: auto;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .blog-details-1 .block-alignwide {
    margin-left: 0;
    margin-right: 0;
    max-width: initial;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .blog-details-1 .block-alignwide {
    margin-left: 0;
    margin-right: 0;
    max-width: initial;
  }
}
@media only screen and (max-width: 767px) {
  .blog-details-1 .block-alignwide {
    margin-left: 0;
    margin-right: 0;
    max-width: initial;
  }
}
.blog-details-1 .block-alignwide img {
  width: 100%;
}

.content-blog-top .title {
  margin-top: 10px;
  margin-bottom: 25px;
  font-size: 32px;
}
.content-blog-top .blog-meta {
  margin-bottom: 30px;
}
.content-blog-top .blog-meta li.blog-author a {
  color: var(--color-body);
}

.blog-main-content .gallery {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
  margin-bottom: 15px;
}
.blog-main-content .gallery li {
  padding: 15px;
  margin: 0;
}
.blog-main-content .gallery li img {
  border-radius: 5px;
}
.blog-main-content .gallery.gallery-column-2 li {
  flex-basis: 50%;
}
@media only screen and (max-width: 575px) {
  .blog-main-content .gallery.gallery-column-2 li {
    flex-basis: 100%;
  }
}
.blog-main-content .blockquote-style-1 {
  border-radius: 4px;
  background: var(--color-primary);
  padding: 25px 50px;
  color: var(--color-white);
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  font-style: normal;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}
@media only screen and (max-width: 767px) {
  .blog-main-content .blockquote-style-1 {
    padding: 25px;
  }
}
.blog-main-content .blockquote-style-1 .quote-image {
  position: absolute;
  right: 30px;
  bottom: 28px;
  opacity: 0.2;
  z-index: -1;
}

.list-style-1 li {
  display: flex;
  align-items: flex-start;
  margin: 15px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.list-style-1 li i {
  color: var(--color-primary);
  margin-right: 13px;
  margin-top: 5px;
}

.list-style-2 {
  list-style: disc;
  padding-left: 17px;
  margin-bottom: 20px;
}
.list-style-2 li {
  margin: 15px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}

.column-gallery {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
  margin-bottom: 15px;
}
.column-gallery li {
  padding: 15px;
  margin: 0;
}
.column-gallery li img {
  border-radius: 5px;
}
.column-gallery.gallery-column-2 li {
  flex-basis: 50%;
}
@media only screen and (max-width: 575px) {
  .column-gallery.gallery-column-2 li {
    flex-basis: 100%;
  }
}

.blog-tag-and-share {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
  border-bottom: 1px solid #EEEEEE;
  flex-wrap: wrap;
}
@media only screen and (max-width: 575px) {
  .blog-tag-and-share {
    display: block;
  }
}
.blog-tag-and-share .blog-share {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 575px) {
  .blog-tag-and-share .blog-share {
    margin-top: 20px;
  }
}
.blog-tag-and-share .blog-share .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-heading);
  padding-right: 20px;
}
.blog-tag-and-share .share-btn {
  width: 40px;
  height: 40px;
  background: #F5F5F5;
  border-radius: 2px;
  padding: 0;
  border: 0 none;
  color: var(--color-primary);
  transition: 0.4s;
}
.blog-tag-and-share .share-btn:hover {
  background: var(--color-primary);
  color: var(--color-white);
}

.blog-author-wrapper {
  padding: 30px 0;
  display: flex;
}
@media only screen and (max-width: 575px) {
  .blog-author-wrapper {
    display: block;
  }
}
.blog-author-wrapper .thumbnail {
  min-width: 160px;
  max-height: 160px;
  margin-right: 40px;
}
@media only screen and (max-width: 767px) {
  .blog-author-wrapper .thumbnail {
    margin-right: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .blog-author-wrapper .thumbnail {
    min-width: auto;
    max-height: initial;
    margin-right: 0;
    margin-bottom: 20px;
  }
}
.blog-author-wrapper .thumbnail img {
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.blog-author-wrapper .author-content .title {
  margin-bottom: 10px;
}
.blog-author-wrapper .author-content p {
  margin-bottom: 20px;
}
.blog-author-wrapper .author-content .social-share.icon-transparent {
  margin: 0 -15px;
}
.blog-author-wrapper .author-content .social-share.icon-transparent li {
  margin: 0 15px;
}
.blog-author-wrapper .author-content .social-share.icon-transparent li a {
  color: var(--color-primary);
  font-size: 14px;
}

/*---------------------------
    Blog Details Style Two  
------------------------------*/
.style-variation2 .content-blog-top .title {
  margin-top: 0;
}
.style-variation2 .content-blog-top .blog-meta {
  margin-bottom: 25px;
}
.style-variation2 .content-blog-top .blog-meta li.blog-author a {
  color: var(--color-body);
}
.style-variation2 .blockquote-style-1 {
  background: #F5F5F5;
  border-radius: 4px;
  border-left: 3px solid var(--color-primary);
  color: var(--color-heading);
}
.style-variation2 .blockquote-style-1 .quote-image {
  opacity: 0.7;
}

/*---------------------------
    Blog Details Style 3  
------------------------------*/
.style-variation3 .content-blog-top .title {
  margin-top: 0;
  margin-bottom: 30px;
}
.style-variation3 .content-blog-top .blog-meta {
  margin-bottom: 0;
}
.style-variation3 .content-blog-top .blog-meta li.blog-author a {
  color: var(--color-body);
}
.style-variation3 .blockquote-style-1 {
  background: #FFFFFF;
  border-radius: 5px;
  border-top: 3px solid var(--color-primary);
  color: var(--color-primary);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);
  text-align: center;
  padding: 25px 68px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .style-variation3 .blockquote-style-1 {
    padding: 25px 30px;
  }
}
@media only screen and (max-width: 767px) {
  .style-variation3 .blockquote-style-1 {
    padding: 25px 30px;
  }
}
.style-variation3 .blockquote-style-1 .quote-image {
  opacity: 0.7;
  right: 15px;
  bottom: 8px;
}

/*-----------------------------
    Blog Comments Style  
------------------------------*/
.comment-list-wrapper .comment {
  display: flex;
}
@media only screen and (max-width: 575px) {
  .comment-list-wrapper .comment {
    flex-direction: column;
  }
  .comment-list-wrapper .comment .comment-content {
    margin-top: 20px;
  }
}
.comment-list-wrapper .comment .thumbnail {
  min-width: 70px;
  width: 70px;
  max-height: 70px;
  border-radius: 100%;
  margin-right: 25px;
}
.comment-list-wrapper .comment .thumbnail img {
  border-radius: 100%;
  width: 100%;
}
.comment-list-wrapper .comment .comment-content .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 0;
}
.comment-list-wrapper .comment .comment-content .date {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-body);
  display: block;
  margin-bottom: 20px;
}
.comment-list-wrapper .comment .comment-content p {
  margin-bottom: 20px;
}
.comment-list-wrapper .comment .comment-content .reply-btn {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.comment-list-wrapper .comment .comment-content .reply-btn i {
  margin-right: 10px;
}
.comment-list-wrapper .comment + .comment {
  border-top: 1px solid #EEEEEE;
  padding-top: 30px;
  margin-top: 30px;
}

/*-----------------------------
    Blog Comments Form
------------------------------*/
.comment-form-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}
.comment-form-top .blog-page-title {
  margin-bottom: 0;
}
.comment-form-top .cancle-btn a {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  transition: 0.3s;
}
.comment-form-top .cancle-btn a:hover {
  color: var(--color-primary);
}

.comment-form-style-1 .comment-note {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 20px;
}
.comment-form-style-1 input,
.comment-form-style-1 textarea {
  background: #F5F5F5;
  border-radius: 5px;
  border: 0 none;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  border: 1px solid transparent;
}
.comment-form-style-1 input:focus,
.comment-form-style-1 textarea:focus {
  border-color: var(--color-primary);
}
.comment-form-style-1 input {
  padding: 0 30px;
  height: 60px;
  line-height: 60px;
}
.comment-form-style-1 textarea {
  min-height: 180px;
  padding: 17px 30px;
}

/*--------------------------------
    Blog Style Pagination 
---------------------------------*/
.blog-pagination-list {
  background-color: #F5F5F5;
  border-radius: 5px;
  background-image: inherit;
  transition: 0.4s;
  position: relative;
  z-index: 2;
}
.blog-pagination-list::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  transition: 0.4s;
  border-radius: 5px;
}
.blog-pagination-list a {
  display: flex;
  align-items: center;
  padding: 30px;
  position: relative;
  z-index: 1;
  color: var(--color-body);
}
.blog-pagination-list a span {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  transition: 0.4s;
  position: relative;
  z-index: 2;
}
.blog-pagination-list a i {
  font-size: 20px;
  transition: 0.4s;
  margin-right: 20px;
}
.blog-pagination-list a::before {
  position: absolute;
  content: "";
  background: #2D284E;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  transition: 0.4s;
  opacity: 0;
  border-radius: 5px;
}
.blog-pagination-list:hover::after {
  opacity: 1;
}
.blog-pagination-list:hover a {
  color: var(--color-white);
}
.blog-pagination-list:hover a::before {
  opacity: 0.79;
}
.blog-pagination-list.next-post {
  text-align: right;
}
.blog-pagination-list.next-post a i {
  margin-right: 0;
  margin-left: 20px;
}
.blog-pagination-list.style-variation-2 {
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.blog-pagination-list.style-variation-2 a {
  color: var(--color-heading);
}
.blog-pagination-list.style-variation-2 a::before {
  display: none;
}
.blog-pagination-list.style-variation-2::after {
  display: none;
}
.blog-pagination-list.style-variation-2:hover {
  background: #FFFFFF;
  border-color: var(--color-primary);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);
}

/**************************************
    Template Styles
***************************************/
/*-----------------------
 * Banner Style One
------------------------*/
.height-850 {
  min-height: 850px;
  width: 100%;
  padding: 240px 0 190px;
}
@media only screen and (max-width: 767px) {
  .height-850 {
    min-height: auto;
    width: 100%;
    padding: 250px 0;
  }
}

.height-940 {
  min-height: 940px;
  width: 100%;
}
@media only screen and (max-width: 767px) {
  .height-940 {
    min-height: auto;
    width: 100%;
    padding: 250px 0;
  }
}

.banner-style-1 {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  z-index: 2;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-1 {
    height: auto;
    min-height: auto;
    padding: 100px 0;
    padding-top: 150px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-1 {
    height: auto;
    min-height: auto;
    padding: 100px 0;
    padding-top: 150px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-1 {
    height: auto;
    min-height: auto;
    padding: 100px 0;
    padding-top: 150px;
  }
}
.banner-style-1 .banner-right-content {
  position: relative;
  margin-top: 138px;
}
@media only screen and (max-width: 1199px) {
  .banner-style-1 .banner-right-content {
    margin-top: 0px;
  }
}
.banner-style-1 .banner-right-content .edu-card {
  min-width: 272px;
}
@media only screen and (max-width: 767px) {
  .banner-style-1 .banner-right-content .edu-card {
    min-width: inherit;
  }
}
.banner-style-1 .banner-left-content {
  margin-top: 120px;
}
@media only screen and (max-width: 1199px) {
  .banner-style-1 .banner-left-content {
    margin-top: 0;
  }
}
.banner-style-1 .inner .content .pre-title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 10px;
}
.banner-style-1 .inner .content .title {
  font-weight: 800;
  font-size: 72px;
  line-height: 1.25;
  margin-bottom: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-1 .inner .content .title {
    font-size: 52px;
    margin-bottom: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-1 .inner .content .title {
    font-size: 45px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-1 .inner .content .title {
    font-size: 38px;
  }
}
.banner-style-1 .inner .content .description {
  margin-bottom: 60px;
  padding-left: 20px;
  position: relative;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-1 .inner .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-1 .inner .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-1 .inner .content .description {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 28px;
  }
}
.banner-style-1 .inner .content .description::before {
  position: absolute;
  content: "";
  left: 0;
  width: 2px;
  height: 73%;
  background: var(--color-primary);
  top: 50%;
  transform: translateY(-50%);
}
.banner-style-1 .work-shop {
  min-width: 193px;
  max-width: 193px;
  background: var(--color-white);
  padding: 20px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  margin: 25px -15px 0 auto;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-1 .work-shop {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-1 .work-shop {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-1 .work-shop {
    margin-right: 0;
    margin-left: 0;
  }
}
.banner-style-1 .work-shop .inner .thumbnail img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.banner-style-1 .work-shop .inner .content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin: 10px 0 0;
}
.banner-style-1 .work-shop .inner .content .time {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  margin-bottom: 20px;
}
.banner-style-1 .shape-round {
  position: absolute;
  left: -312px;
  top: 130px;
  z-index: -1;
}
.banner-style-1 .scroll-down-btn {
  position: absolute;
  top: 100%;
  left: calc(50% - 30px);
  transform: translateY(-50%);
  z-index: 1;
}
.banner-style-1 .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-1 {
  top: 97px;
  left: -189px;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-2 {
  top: 53px;
  left: 580px;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-3 {
  top: 95px;
  right: -160px;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-4 {
  bottom: 10px;
  right: -173px;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-5 {
  bottom: -23px;
  left: 654px;
}
.banner-style-1 .shape-dot-wrapper .shape.shape-6 {
  bottom: -37px;
  left: -255px;
}
.banner-style-1 .eduvibe-hero-one-video .thumbnail {
  margin: 30px -149px 0 -23px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-1 .eduvibe-hero-one-video .thumbnail {
    margin: 0 -70px 0 -30px;
  }
}
@media only screen and (max-width: 1199px) {
  .banner-style-1 .eduvibe-hero-one-video .thumbnail {
    margin: 0 -30px 0 -30px;
  }
}
@media only screen and (max-width: 575px) {
  .banner-style-1 .eduvibe-hero-one-video .thumbnail {
    margin: -30px 0 0 -30px;
  }
}

/*-------------------------
    Banner Style Two  
--------------------------*/
.banner-style-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  position: relative;
  z-index: 1;
  min-height: 930px;
}
@media only screen and (max-width: 1199px) {
  .banner-style-2 {
    min-height: 800px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-2 {
    padding: 0 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-2 {
    padding: 150px 30px;
    height: auto;
    padding-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-2 {
    padding: 150px 0px;
    height: auto;
    padding-bottom: 0;
  }
}
.banner-style-2 .inner {
  position: relative;
  margin-top: 100px;
}
@media only screen and (max-width: 1199px) {
  .banner-style-2 .inner {
    margin-top: 0px;
  }
}
.banner-style-2 .inner .content .pre-title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  margin-bottom: 10px;
  display: block;
  padding-left: 60px;
  position: relative;
}
.banner-style-2 .inner .content .pre-title::before {
  left: 0;
  top: 13px;
  width: 50px;
  height: 2px;
  background: var(--color-primary);
  content: "";
  position: absolute;
}
.banner-style-2 .inner .content .title {
  font-weight: 800;
  font-size: 68px;
  line-height: 1.24;
  margin-bottom: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-2 .inner .content .title {
    font-size: 45px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-2 .inner .content .title {
    font-size: 40px;
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-2 .inner .content .title {
    font-size: 38px;
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 575px) {
  .banner-style-2 .inner .content .title {
    font-size: 32px;
  }
}
.banner-style-2 .inner .content .description {
  margin-bottom: 60px;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-2 .inner .content .description {
    margin-bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-2 .inner .content .description {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 25px;
  }
}
.banner-style-2 .inner .content .arrow-sign {
  position: absolute;
  right: -30px;
  bottom: -50px;
}
.banner-style-2 .inner .content .arrow-sign img {
  max-width: 70%;
}
@media only screen and (min-width: 1750px) {
  .banner-style-2 .inner .content .arrow-sign {
    right: -50px;
    bottom: -90px;
  }
  .banner-style-2 .inner .content .arrow-sign img {
    max-width: 100%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-2 .inner .content .arrow-sign {
    right: -50px;
    bottom: -30px;
  }
  .banner-style-2 .inner .content .arrow-sign img {
    max-width: 50%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-2 .inner .content .arrow-sign {
    right: -110px;
    bottom: -12px;
  }
  .banner-style-2 .inner .content .arrow-sign img {
    max-width: 40%;
  }
}
.banner-style-2 .banner-thumbnail {
  position: absolute;
  bottom: 0;
  right: 111px;
  z-index: 1;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-2 .banner-thumbnail {
    right: 31px;
  }
}
.banner-style-2 .banner-thumbnail img {
  max-width: calc(100% - 60px);
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-2 .banner-thumbnail {
    right: 0;
  }
  .banner-style-2 .banner-thumbnail img.girl-thumb {
    max-width: 90%;
  }
}
@media only screen and (max-width: 1199px) {
  .banner-style-2 .banner-thumbnail {
    right: -138px;
  }
  .banner-style-2 .banner-thumbnail img.girl-thumb {
    max-width: 80%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-2 .banner-thumbnail {
    position: static;
    text-align: right;
    margin-top: -110px;
  }
  .banner-style-2 .banner-thumbnail img.girl-thumb {
    max-width: 70%;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-2 .banner-thumbnail {
    position: static;
  }
  .banner-style-2 .banner-thumbnail img.girl-thumb {
    max-width: 100%;
  }
}
.banner-style-2 .banner-bg {
  position: absolute;
  bottom: 3px;
  right: 67px;
  z-index: 0;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-2 .banner-bg {
    right: 0;
  }
}
.banner-style-2 .banner-bg img.girl-bg {
  max-width: calc(90% - 10px);
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-2 .banner-bg img.girl-bg {
    max-width: 90%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-2 .banner-bg {
    right: -40px;
  }
}
@media only screen and (max-width: 1199px) {
  .banner-style-2 .banner-bg {
    right: -218px;
  }
  .banner-style-2 .banner-bg img.girl-bg {
    max-width: 80%;
  }
}
.banner-style-2 .shape-image {
  position: absolute;
  z-index: -1;
}
.banner-style-2 .shape-image.shape-image-1 {
  top: 231px;
  left: 50px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-2 .shape-image.shape-image-1 {
    top: 170px;
    left: -10px;
  }
}
.banner-style-2 .shape-image.shape-image-2 {
  top: 240px;
  right: 43%;
}
.banner-style-2 .shape-image.shape-image-3 {
  top: 250px;
  right: 90px;
}

/*-------------------------
    Banner Style Three  
--------------------------*/
.banner-style-3 {
  position: relative;
  z-index: 1;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
@media only screen and (max-width: 991px) {
  .banner-style-3 {
    padding: 160px 0 100px;
  }
  .banner-style-3 .height-940 {
    height: inherit;
    min-height: inherit;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-3 {
    padding: 140px 0 70px;
  }
  .banner-style-3 .height-940 {
    padding: 0;
  }
}
.banner-style-3 .content {
  margin-top: 90px;
}
@media only screen and (max-width: 991px) {
  .banner-style-3 .content {
    margin-top: 0px;
  }
}
.banner-style-3 .content .pre-title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 5px;
}
.banner-style-3 .content .title {
  font-weight: 800;
  font-size: 68px;
  line-height: 1.25;
  margin-bottom: 25px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-3 .content .title {
    font-size: 50px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-3 .content .title {
    font-size: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-3 .content .title {
    font-size: 40px;
  }
}
.banner-style-3 .content .description {
  margin-bottom: 60px;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-3 .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-3 .content .description {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 28px;
  }
}
.banner-style-3 .banner-image .banner-main-image {
  margin-right: -45px;
  margin-bottom: -260px;
  text-align: right;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-3 .banner-image .banner-main-image {
    margin-right: 70px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-3 .banner-image .banner-main-image {
    margin-right: 50px;
  }
}
@media only screen and (max-width: 991px) {
  .banner-style-3 .banner-image .banner-main-image {
    margin-right: 0;
    text-align: left;
    margin-bottom: 0;
  }
}
.banner-style-3 .banner-image .img-02 {
  position: absolute;
  right: -232px;
  bottom: 125px;
}
@media only screen and (min-width: 1401px) and (max-width: 1650px) {
  .banner-style-3 .banner-image .img-02 {
    right: -152px;
    bottom: 190px;
    max-width: 240px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-3 .banner-image .img-02 {
    right: -88px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-3 .banner-image .img-02 {
    right: -88px;
    max-width: 240px;
  }
}
@media only screen and (max-width: 991px) {
  .banner-style-3 .banner-image .img-02 {
    display: none;
  }
}
.banner-style-3 .banner-image .img-03 {
  position: absolute;
  right: 0;
  bottom: 435px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-3 .banner-image .img-03 {
    right: 140px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-3 .banner-image .img-03 {
    right: 90px;
    bottom: 345px;
  }
}
@media only screen and (max-width: 991px) {
  .banner-style-3 .banner-image .img-03 {
    display: none;
  }
}
.banner-style-3 .shape-image {
  position: absolute;
  z-index: -1;
}
.banner-style-3 .shape-image.shape-image-1 {
  left: -114px;
  top: 30px;
}
.banner-style-3 .shape-image.shape-image-2 {
  right: 45%;
  top: 105px;
}
.banner-style-3 .shape-image.shape-image-3 {
  right: -260px;
  top: 20px;
}
.banner-style-3 .shape-image.shape-image-4 {
  right: -241px;
  bottom: -50px;
}
.banner-style-3 .shape-image.shape-image-5 {
  left: -180px;
  bottom: -100px;
}

/*-------------------------
    Banner Style Four  
--------------------------*/
.banner-style-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.banner-style-4 .home-four-banner-wrapper {
  min-height: 870px;
}
@media only screen and (max-width: 1199px) {
  .banner-style-4 .home-four-banner-wrapper {
    min-height: auto;
    width: 100%;
    width: 100%;
    padding: 120px 0 100px;
  }
}
@media only screen and (max-width: 991px) {
  .banner-style-4 .home-four-banner-wrapper {
    padding: 70px 0 150px;
  }
}
.banner-style-4 .banner-image {
  position: relative;
  padding: 35px;
  left: 115px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-4 .banner-image {
    padding: 25px;
    left: 10px;
    transform: scale(0.9);
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-4 .banner-image {
    left: 0;
    width: 74%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-4 .banner-image {
    left: 0;
    margin: 0 auto;
    padding: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .banner-style-4 .banner-image {
    padding: 20px;
  }
}
.banner-style-4 .banner-image .thumbnail img {
  width: 600px;
  max-height: 600px;
  border-radius: 100%;
  object-fit: cover;
}
.banner-style-4 .banner-image .round-images {
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.5s;
}
.banner-style-4 .banner-image .learner-badge {
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  padding: 10px;
  width: 160px;
  height: 160px;
  border-radius: 100%;
  position: absolute;
  left: -80px;
  top: 25%;
}
.banner-style-4 .banner-image .learner-badge .badge-inner {
  background: #ffa41b;
  border-radius: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.banner-style-4 .banner-image .learner-badge .badge-inner span {
  display: block;
  color: #ffffff;
  font-weight: 600;
}
.banner-style-4 .banner-image .learner-badge .badge-inner span.viewer {
  font-weight: 800;
  font-size: 32px;
  line-height: 44px;
}
.banner-style-4 .content .pre-title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 5px;
}
.banner-style-4 .content .title {
  font-weight: 800;
  font-size: 72px;
  line-height: 1.25;
  margin-bottom: 25px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-4 .content .title {
    font-size: 50px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-4 .content .title {
    font-size: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-4 .content .title {
    font-size: 40px;
  }
}
.banner-style-4 .content .description {
  margin-bottom: 60px;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-4 .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-4 .content .description {
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 28px;
  }
}
.banner-style-4 .shape-image {
  position: absolute;
  z-index: -1;
}
.banner-style-4 .shape-image.shape-image-1 {
  left: -110px;
  top: -50px;
}
.banner-style-4 .shape-image.shape-image-2 {
  right: 48%;
  top: -32px;
}
.banner-style-4 .shape-image.shape-image-3 {
  right: -210px;
  top: 10px;
}
.banner-style-4 .shape-image.shape-image-4 {
  right: 360px;
  bottom: -90px;
}
.banner-style-4 .shape-image.shape-image-5 {
  left: 463px;
  bottom: 270px;
}
.banner-style-4 .shape-image.shape-image-6 {
  left: 150px;
  bottom: -100px;
}
.banner-style-4 .shape-image.shape-image-left {
  left: 0;
  bottom: 8px;
}
.banner-style-4 .shape-image.shape-image-right {
  right: 0;
  bottom: 8px;
}
.banner-style-4 .social-text-share {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -175px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-4 .social-text-share {
    left: -105px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-4 .social-text-share {
    left: -70px;
  }
}
@media only screen and (max-width: 1199px) {
  .banner-style-4 .social-text-share {
    position: absolute;
    top: inherit;
    transform: none;
    left: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    bottom: -40px;
    margin: 0 -20px;
  }
}
@media only screen and (max-width: 991px) {
  .banner-style-4 .social-text-share {
    bottom: -65px;
  }
}
.banner-style-4 .social-text-share li {
  margin: 0;
}
.banner-style-4 .social-text-share li a {
  display: inline-block;
  transform: rotate(-90deg);
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  margin: 20px 0;
  position: relative;
}
@media only screen and (max-width: 1199px) {
  .banner-style-4 .social-text-share li a {
    transform: none;
    margin: 0px 20px;
  }
}
.banner-style-4 .social-text-share li a::before {
  position: absolute;
  content: "";
  background: var(--color-primary);
  bottom: 0;
  width: 0;
  opacity: 0;
  left: 0;
  transition: 0.4s;
  height: 2px;
}
.banner-style-4 .social-text-share li a:hover::before {
  width: 100%;
  opacity: 1;
}

/*-------------------------
    Banner Style five  
--------------------------*/
.banner-style-5 {
  position: relative;
  z-index: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.banner-style-5 .wrapper {
  height: 860px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-5 .wrapper {
    height: auto;
    padding-top: 120px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .wrapper {
    height: auto;
    padding-top: 120px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .wrapper {
    height: auto;
    padding-top: 120px;
  }
}
.banner-style-5 .content .title {
  font-weight: 800;
  font-size: 72px;
  line-height: 1.28;
  margin-bottom: 30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .banner-style-5 .content .title {
    font-size: 57px;
    margin-bottom: 20px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-5 .content .title {
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .content .title {
    font-size: 40px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .content .title {
    font-size: 40px;
    margin-bottom: 20px;
  }
}
.banner-style-5 .content .description {
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 60px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-5 .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .content .description {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .content .description {
    margin-bottom: 30px;
  }
}
.banner-style-5 .content .read-more-btn {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 575px) {
  .banner-style-5 .content .read-more-btn {
    display: block;
  }
}
@media only screen and (max-width: 575px) {
  .banner-style-5 .content .video-btn-wrapper {
    margin-left: 0;
    margin-top: 20px;
  }
}
.banner-style-5 .content .video-play-btn {
  width: 60px;
  height: 60px;
  background: rgba(251, 124, 86, 0.15);
  margin: inherit;
  margin-left: 30px;
}
@media only screen and (max-width: 575px) {
  .banner-style-5 .content .video-play-btn {
    margin-left: 0;
    margin-top: 0;
  }
}
.banner-style-5 .content .video-play-btn::before {
  display: none;
}
.banner-style-5 .content .video-play-btn::after {
  display: none;
}
.banner-style-5 .content .video-play-btn .play-icon::before {
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 15px solid var(--color-secondary);
}
.banner-style-5 .content .video-btn-wrapper {
  display: flex;
  align-items: center;
}
.banner-style-5 .content .video-btn-wrapper .video-text {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-left: 20px;
  display: inline-block;
  color: var(--color-heading);
}
.banner-style-5 .banner-image {
  position: absolute;
  bottom: 0;
  right: 13%;
}
@media only screen and (max-width: 1650px) {
  .banner-style-5 .banner-image {
    right: 4%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-5 .banner-image {
    position: relative;
    bottom: 0;
    right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .banner-image {
    position: relative;
    bottom: 0;
    right: 0;
    text-align: center;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .banner-image {
    position: relative;
    bottom: 0;
    right: 0;
    text-align: center;
  }
}
.banner-style-5 .banner-image img {
  border-top-right-radius: 500px;
  border-top-left-radius: 500px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .banner-image img {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .banner-image img {
    width: 100%;
  }
}
.banner-style-5 .banner-image .card-info {
  position: absolute;
  left: -10%;
  top: 19%;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-5 .banner-image .card-info {
    left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-5 .banner-image .card-info {
    left: 10px;
    top: auto;
    bottom: 10px;
  }
}
.banner-style-5 .banner-image .card-info .inner {
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 20px 30px;
}
.banner-style-5 .banner-image .card-info .inner .name {
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-heading);
}
.banner-style-5 .banner-image .card-info .inner .name span {
  font-size: 14px;
  color: var(--color-body);
  font-weight: 400;
}
.banner-style-5 .banner-image .card-info .inner .rating-wrapper span {
  display: inline-block;
  margin-left: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}
.banner-style-5 .shape-image {
  position: absolute;
  z-index: -1;
}
.banner-style-5 .shape-image.shape-image-1 {
  bottom: 235px;
  left: 168px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
@media only screen and (max-width: 1650px) {
  .banner-style-5 .shape-image.shape-image-1 {
    left: 28px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-5 .shape-image.shape-image-1 {
    display: none;
  }
}
.banner-style-5 .shape-image.shape-image-2 {
  top: 183px;
  left: 73px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-5 .shape-image.shape-image-2 {
    top: 160px;
    left: -40px;
  }
}
.banner-style-5 .shape-image.shape-image-3 {
  top: 180px;
  left: 52%;
}
.banner-style-5 .shape-image.shape-image-4 {
  left: 42%;
  bottom: 370px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-5 .shape-image.shape-image-4 {
    bottom: 200px;
  }
}
.banner-style-5 .shape-image.shape-image-5 {
  bottom: 116px;
  left: 49%;
}
.banner-style-5 .shape-image.shape-image-6 {
  left: 50px;
  bottom: 90px;
}

/*-------------------------
    Banner Style Six  
--------------------------*/
.banner-style-6 {
  position: relative;
  z-index: 2;
}
.banner-style-6 .scroll-down-btn {
  position: absolute;
  bottom: 30px;
  left: calc(50% - 30px);
  z-index: 1;
}
@media only screen and (max-width: 575px) {
  .banner-style-6 .scroll-down-btn {
    bottom: 15px;
  }
}
@media only screen and (min-width: 1750px) {
  .banner-style-6 .scroll-down-btn {
    bottom: 20px;
  }
}
@media only screen and (min-width: 1800px) {
  .banner-style-6 .scroll-down-btn {
    bottom: 0px;
  }
}
@media only screen and (min-width: 1900px) {
  .banner-style-6 .scroll-down-btn {
    bottom: -20px;
  }
}
.banner-style-6 .content {
  position: relative;
  z-index: 1;
}
.banner-style-6 .content .pre-title {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 10px;
}
.banner-style-6 .content .title {
  font-weight: 800;
  font-size: 68px;
  line-height: 1.24;
  margin-bottom: 60px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .banner-style-6 .content .title {
    font-size: 50px;
    margin-bottom: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .banner-style-6 .content .title {
    font-size: 50px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .banner-style-6 .content .title {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .banner-style-6 .content .title {
    font-size: 28px;
    margin-bottom: 20px;
  }
}
.banner-style-6 .shape-image {
  position: absolute;
  z-index: -1;
}
.banner-style-6 .shape-image.shape-image-1 {
  top: 180px;
  left: 32%;
}
.banner-style-6 .shape-image.shape-image-2 {
  top: 253px;
  right: 182px;
}
.banner-style-6 .shape-image.shape-image-3 {
  bottom: 100px;
  right: 35%;
}
.banner-style-6 .shape-image.shape-image-4 {
  bottom: 195px;
  left: 117px;
}
.banner-style-6 .shape-image.shape-image-5 {
  bottom: 360px;
  right: 192px;
}
.banner-style-6 .gallery-image {
  position: absolute;
  z-index: -1;
}
.banner-style-6 .gallery-image.gallery-image-1 {
  top: 180px;
  left: 175px;
  z-index: 1;
}
.banner-style-6 .gallery-image.gallery-image-2 {
  top: 353px;
  left: 117px;
  z-index: -1;
}
.banner-style-6 .gallery-image.gallery-image-3 {
  bottom: 100px;
  left: 340px;
}
.banner-style-6 .gallery-image.gallery-image-4 {
  bottom: 200px;
  right: 281px;
}
.banner-style-6 .gallery-image.gallery-image-5 {
  bottom: 91px;
  right: 6%;
  z-index: -1;
}
.banner-style-6 .gallery-image.gallery-image-6 {
  top: 201px;
  right: 281px;
}
@media only screen and (min-width: 1401px) and (max-width: 1750px) {
  .banner-style-6 .gallery-image img {
    max-width: 90%;
  }
  .banner-style-6 .gallery-image.gallery-image-1 {
    left: 20px;
  }
  .banner-style-6 .gallery-image.gallery-image-2 {
    top: 350px;
    left: 40px;
  }
  .banner-style-6 .gallery-image.gallery-image-3 {
    left: 120px;
    bottom: 150px;
  }
  .banner-style-6 .gallery-image.gallery-image-4 {
    bottom: 290px;
    right: 0px;
  }
  .banner-style-6 .gallery-image.gallery-image-5 {
    bottom: 170px;
    right: 120px;
  }
  .banner-style-6 .gallery-image.gallery-image-6 {
    right: 0;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .banner-style-6 .gallery-image.gallery-image-1 {
    left: 0;
  }
  .banner-style-6 .gallery-image.gallery-image-2 {
    top: 305px;
    left: 70px;
  }
  .banner-style-6 .gallery-image.gallery-image-3 {
    left: 200px;
    bottom: 150px;
  }
  .banner-style-6 .gallery-image.gallery-image-4 {
    right: 130px;
  }
  .banner-style-6 .gallery-image.gallery-image-5 {
    bottom: 91px;
    right: 0px;
  }
  .banner-style-6 .gallery-image.gallery-image-6 {
    right: 0;
  }
  .banner-style-6 .gallery-image img {
    max-width: 80%;
  }
}

/* Event Details  */
.edu-event-details .thumbnail img {
  border-radius: 5px;
}
.edu-event-details .content {
  margin-top: 60px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-event-details .content {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-event-details .content {
    margin-top: 30px;
  }
}
.edu-event-details .content .title {
  font-weight: 800;
  font-size: 40px;
  line-height: 56px;
  margin-bottom: 30px;
}
@media only screen and (max-width: 767px) {
  .edu-event-details .content .title {
    font-size: 28px;
    line-height: 1.4;
  }
}
.edu-event-details .content .column-gallery li img {
  border-radius: 5px;
  width: 100%;
}

.eduvibe-widget {
  background: #FFFFFF;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 30px 40px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-widget {
    padding: 30px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .eduvibe-widget {
    padding: 30px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-widget {
    padding: 30px 20px;
  }
}
.eduvibe-widget .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 30px;
}

.eduvibe-sidebar {
  padding: 0 50px;
  margin-top: -50px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .eduvibe-sidebar {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-sidebar {
    margin-top: 30px;
    padding: 0 20px;
  }
}
.eduvibe-sidebar.course-details-sidebar {
  padding: 0 0px 0 20px;
  margin-left: -20px;
}
@media only screen and (max-width: 1199px) {
  .eduvibe-sidebar.course-details-sidebar {
    margin-left: 0px;
    padding: 0px;
  }
}
.eduvibe-sidebar.course-details-sidebar .eduvibe-widget {
  padding: 20px 20px;
  border-radius: 10px;
}
.eduvibe-sidebar.course-details-sidebar .eduvibe-widget .eduvibe-widget-details {
  padding: 0 20px 20px;
}

.eduvibe-widget-details .widget-content ul li {
  display: flex;
  justify-content: space-between;
}
.eduvibe-widget-details .widget-content ul li i {
  color: var(--color-primary);
  margin-right: 10px;
}
.eduvibe-widget-details .widget-content ul li img.eduvibe-course-sidebar-img-icon {
  max-width: 16px;
  margin-right: 10px;
}
.eduvibe-widget-details .widget-content ul li span {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  display: inline-block;
}
.eduvibe-widget-details .widget-content ul li + li {
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid #EEEEEE;
}

/*----------------------------
    Product Details Styles 
------------------------------*/
.edu-product-details-style .content .subtitle {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  display: block;
  margin-bottom: 10px;
}
.edu-product-details-style .content .title {
  margin-bottom: 15px;
}
.edu-product-details-style .content p {
  margin-top: 30px;
  margin-bottom: 40px;
}
.edu-product-details-style .content .product-action {
  display: flex;
}
@media only screen and (max-width: 575px) {
  .edu-product-details-style .content .product-action {
    display: block;
  }
}
@media only screen and (max-width: 575px) {
  .edu-product-details-style .content .product-action .add-to-cart-btn {
    margin-top: 20px;
  }
}
.edu-product-details-style .content .product-feature {
  margin-top: 40px;
}
.edu-product-details-style .content .product-feature li {
  font-weight: 400;
  margin: 5px 0;
}
.edu-product-details-style .content .product-feature li span {
  font-weight: 700;
  color: var(--color-heading);
}
.edu-product-details-style .content .product-feature li a {
  position: relative;
  display: inline-block;
}
.edu-product-details-style .content .product-feature li a::after {
  position: absolute;
  content: ",";
  right: -3px;
}
.edu-product-details-style .content .product-feature li a:last-child:after {
  display: none;
}
.edu-product-details-style img.eduvibe-product-main-img {
  border-radius: 5px;
}

.pro-qty {
  position: relative;
  display: inline-block;
}
.pro-qty input {
  height: 60px;
  border: 0 none;
  background: #F5F5F5;
  border-radius: 5px;
  max-width: 144px;
  margin-right: 15px;
  text-align: center;
  color: var(--color-heading);
  font-weight: 700;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pro-qty input {
    text-align: left;
  }
}
@media only screen and (max-width: 767px) {
  .pro-qty input {
    text-align: left;
  }
}
.pro-qty .qtybtn {
  position: absolute;
  top: 10px;
  right: 38px;
  font-size: 20px;
  cursor: pointer;
}
.pro-qty .dec.qtybtn {
  top: auto;
  bottom: 10px;
}
.product-description-nav {
  border-bottom: 1px solid #EEEEEE;
  justify-content: center;
  margin-bottom: 35px;
}
.product-description-nav .nav-item {
  margin: 0 25px;
}
.product-description-nav .nav-item button.nav-link {
  background: transparent;
  border: 0 none;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  padding: 0;
  padding-bottom: 15px;
  color: var(--color-heading);
  position: relative;
  transition: 0.4s;
}
.product-description-nav .nav-item button.nav-link::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--color-primary);
  transition: 0.4s;
  width: 0;
}
.product-description-nav .nav-item button.nav-link:hover, .product-description-nav .nav-item button.nav-link.active {
  color: var(--color-primary);
}
.product-description-nav .nav-item button.nav-link:hover::after, .product-description-nav .nav-item button.nav-link.active::after {
  width: 100%;
}

.product-description-content p:last-child {
  margin-bottom: 0;
}
.product-description-content .comment-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.product-description-content .notification-text .title {
  font-size: 16px;
  line-height: 26px;
  margin-right: 10px;
}

.edu-product-modal .modal-dialog {
  max-width: 1170px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .edu-product-modal .modal-dialog {
    max-width: 900px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-product-modal .modal-dialog {
    max-width: 800px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-product-modal .modal-dialog {
    max-width: 600px;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 767px) {
  .edu-product-modal .modal-dialog {
    max-width: 400px;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 479px) {
  .edu-product-modal .modal-dialog {
    max-width: 320px;
    margin: 0 auto;
  }
}
.edu-product-modal .edu-modal-body {
  padding: 70px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .edu-product-modal .edu-modal-body {
    padding: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-product-modal .edu-modal-body {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .edu-product-modal .edu-modal-body {
    padding: 20px;
  }
}
.edu-product-modal .edu-modal-header {
  position: absolute;
  left: calc(100% + 20px);
  z-index: 2;
}
.edu-product-modal .edu-modal-header button {
  padding: 0;
  background: transparent;
  margin: 0;
  outline: none;
  opacity: 1;
  width: 25px;
  height: 25px;
}
@media only screen and (max-width: 767px) {
  .edu-product-modal .edu-modal-header button {
    width: 20px;
    height: 20px;
  }
}
.edu-product-modal .edu-modal-header button:focus {
  box-shadow: none;
}
.edu-product-modal .edu-modal-header button i {
  color: var(--color-white);
}

/*-----------------------
    Cart Styles  
-------------------------*/
.cart-table table {
  min-width: 1170px;
}
@media only screen and (max-width: 767px) {
  .cart-table table {
    min-width: 950px;
  }
}
.cart-table table thead tr {
  background: #F5F5F5;
  border-radius: 5px;
  border: 0 none;
}
.cart-table table thead tr th {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  padding: 24px 0;
  border: 0 none;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .cart-table table thead tr th {
    padding: 24px 10px;
    font-size: 18px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .cart-table table thead tr th {
    padding: 24px 10px;
    font-size: 18px;
  }
}
@media only screen and (max-width: 767px) {
  .cart-table table thead tr th {
    padding: 24px 10px;
    font-size: 18px;
  }
}
.cart-table table thead tr th:first-child {
  padding-left: 30px;
  border-radius: 5px 0 0 5px;
}
.cart-table table thead tr th:last-child {
  border-radius: 0 5px 5px 0;
}
.cart-table table tbody tr .pro-thumbnail img {
  max-height: 60px;
  width: 60px;
  min-width: 60px;
  border-radius: 5px;
}
.cart-table table tbody tr .pro-thumbnail span {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-heading);
  display: inline-block;
  margin-left: 20px;
  transition: 0.4s;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .cart-table table tbody tr .pro-thumbnail span {
    font-size: 16px;
    margin-left: 5px;
  }
}
@media only screen and (max-width: 767px) {
  .cart-table table tbody tr .pro-thumbnail span {
    font-size: 16px;
    margin-left: 5px;
  }
}
.cart-table table tbody tr .pro-thumbnail span:hover {
  color: var(--color-primary);
}
.cart-table table tbody tr:first-child td {
  border-top: transparent;
}
.cart-table table tbody tr td {
  padding: 30px 0;
  border: 0 none;
  border-bottom: 1px solid #EEEEEE;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .cart-table table tbody tr td {
    padding: 30px 6px;
  }
}
@media only screen and (max-width: 767px) {
  .cart-table table tbody tr td {
    padding: 30px 6px;
  }
}
.cart-table table tbody tr td:first-child {
  padding-left: 30px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .cart-table table tbody tr td:first-child {
    padding-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .cart-table table tbody tr td:first-child {
    padding-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .cart-table table tbody tr td:first-child {
    padding-left: 0;
  }
}
.cart-table table tbody tr .pro-price,
.cart-table table tbody tr .pro-subtotal {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
}
.cart-table table tbody tr .pro-remove a {
  color: var(--color-heading);
  transition: 0.4s;
}
.cart-table table tbody tr .pro-remove a:hover {
  color: var(--color-secondary);
}
.cart-table .pro-qty input {
  max-width: 144px;
  margin-right: 0;
  padding-right: 39px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .cart-table .pro-qty input {
    max-width: 104px;
  }
}
@media only screen and (max-width: 767px) {
  .cart-table .pro-qty input {
    max-width: 104px;
  }
}

.cart-summary .title {
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}
.cart-summary .cart-summary-inner {
  border-bottom: 1px solid #EEEEEE;
  border-right: 1px solid #EEEEEE;
  border-top: 1px solid #EEEEEE;
  border-left: 1px solid #EEEEEE;
  border-radius: 5px;
}
.cart-summary .cart-summary-inner li {
  display: flex;
  margin: 0;
}
.cart-summary .cart-summary-inner li span {
  display: block;
  flex-basis: 50%;
  padding: 17px 40px;
  text-align: center;
  font-weight: 600;
}
.cart-summary .cart-summary-inner li span.subtitle {
  border-right: 1px solid #EEEEEE;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-heading);
  text-align: left;
}
.cart-summary .cart-summary-inner li + li {
  border-top: 1px solid #EEEEEE;
}

.coupon-code-btn {
  position: relative;
  display: inline-block;
}
.coupon-code-btn input {
  background: #F5F5F5;
  border-radius: 5px;
  border: 0 none;
  height: 60px;
  min-width: 470px;
  padding-left: 53px;
  padding-right: 163px;
}
@media only screen and (max-width: 767px) {
  .coupon-code-btn input {
    min-width: auto;
    padding-left: 30px;
    padding-right: 30px;
  }
}
.coupon-code-btn i {
  position: absolute;
  top: 50%;
  left: 26px;
  transform: translateY(-50%);
  font-size: 20px;
}
@media only screen and (max-width: 767px) {
  .coupon-code-btn i {
    display: none;
  }
}
.coupon-code-btn .edu-btn {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 5px 5px 0;
  height: 100%;
}
@media only screen and (max-width: 767px) {
  .coupon-code-btn .edu-btn {
    position: static;
    border-radius: 5px;
    height: auto;
    margin-top: 20px;
  }
}

/*-------------------------
    Price Filter  
--------------------------*/
.slider__range--output {
  margin-top: 14px;
}

.price--output input {
  border: 0 none;
}

.price--output span {
  color: #333;
  font-size: 14px;
}

.price--filter {
  display: inline-block;
}

.price--output {
  display: inline-block;
}

.ui-widget-content {
  background: #D7D6DC none repeat scroll 0 0;
  border: 0 none;
  color: var(--color-primary);
}

.ui-slider-range.ui-widget-header.ui-corner-all {
  background: var(--color-primary) none repeat scroll 0 0;
}

.ui-slider-horizontal {
  height: 4px;
}

.ui-slider .ui-slider-handle {
  border-radius: 100%;
  cursor: default;
  height: 20px;
  position: absolute;
  touch-action: none;
  width: 20px;
  z-index: 2;
  outline: none;
  cursor: pointer;
}

.ui-slider-horizontal .ui-slider-handle {
  top: -9px;
  margin-left: -3px;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
  background: var(--color-primary) none repeat scroll 0 0;
  border: 0 none;
  color: var(--color-primary);
}

.ui-slider-range.ui-widget-header.ui-corner-all {
  background: var(--color-primary) none repeat scroll 0 0;
}

.ui-slider-horizontal {
  margin-bottom: 8px;
  margin-top: 15px;
}

.price__output--wrap {
  display: flex;
  align-items: center;
}
.price__output--wrap .price--output {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.price__output--wrap .price--output span {
  color: var(--color-body);
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
}
.price__output--wrap .price--output input {
  border: 0 none;
  flex-grow: 1;
  font-size: 20px;
  line-height: 32px;
  font-weight: 700;
  width: 100px;
  color: var(--color-body);
  padding: 0 6px;
}
.price__output--wrap .price--filter {
  display: inline-block;
  margin-top: -2px;
}
.price__output--wrap .price--filter a.btn {
  padding: 2px 10px;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-radius: 6px;
  line-height: 16px;
}

.ui-slider .ui-slider-handle::after {
  position: absolute;
  content: "";
  background: #fff;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/*---------------------------
    Course Details 
-----------------------------*/
.edu-course-details-area .main-image {
  margin-left: -75px;
  margin-right: -75px;
}
@media only screen and (max-width: 991px) {
  .edu-course-details-area .main-image {
    margin-left: 0px;
    margin-right: 0px;
  }
}
.edu-course-details-area .main-image img {
  height: 570px;
  object-fit: cover;
  width: 100%;
}
@media only screen and (max-width: 767px) {
  .edu-course-details-area .main-image img {
    height: auto;
  }
}

.course-details-content {
  margin-right: 30px;
}
@media only screen and (max-width: 1199px) {
  .course-details-content {
    margin-right: 0px;
  }
}
.course-details-content .content-top {
  display: flex;
  margin-top: 60px;
  margin-bottom: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .course-details-content .content-top {
    margin-top: 30px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .course-details-content .content-top {
    margin-top: 30px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .course-details-content .content-top {
    display: block;
  }
}
.course-details-content .content-top .author-meta {
  margin-right: 50px;
}
@media only screen and (max-width: 575px) {
  .course-details-content .content-top .author-meta {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
.course-details-content .title {
  font-weight: 800;
  font-size: 40px;
  line-height: 1.4;
  margin-bottom: 50px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .course-details-content .title {
    font-size: 30px;
    margin-bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .course-details-content .title {
    font-size: 30px;
    margin-bottom: 40px;
  }
}
.course-details-content .edu-course-tab {
  border: 0 none;
  background: #F5F5F5;
  border-radius: 5px;
  justify-content: space-between;
}
.course-details-content .edu-course-tab .nav-item {
  margin: 0 40px;
}
@media only screen and (max-width: 1199px) {
  .course-details-content .edu-course-tab .nav-item {
    margin: 0 20px;
  }
}
@media only screen and (max-width: 575px) {
  .course-details-content .edu-course-tab .nav-item {
    margin: 0 10px;
  }
}
.course-details-content .edu-course-tab .nav-item .nav-link {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  border: 0 none;
  background: transparent;
  padding: 16px 0;
  position: relative;
  color: var(--color-heading);
}
@media only screen and (max-width: 767px) {
  .course-details-content .edu-course-tab .nav-item .nav-link {
    padding: 10px 0;
    font-size: 16px;
  }
}
.course-details-content .edu-course-tab .nav-item .nav-link::after {
  position: absolute;
  content: "";
  background: var(--color-primary);
  border-radius: 1px 1px 0px 0px;
  height: 2px;
  width: 0;
  transition: 0.4s;
  left: 0%;
  bottom: 0;
  opacity: 0;
}
.course-details-content .edu-course-tab .nav-item .nav-link.active, .course-details-content .edu-course-tab .nav-item .nav-link:hover {
  color: var(--color-primary);
}
.course-details-content .edu-course-tab .nav-item .nav-link.active::after, .course-details-content .edu-course-tab .nav-item .nav-link:hover::after {
  width: 100%;
  opacity: 1;
}
.course-details-content .course-tab-content {
  margin-top: 40px;
}
.course-details-content .rating-box {
  background: #FFFFFF;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  text-align: center;
  min-width: 200px;
  padding: 29px 10px;
}
.course-details-content .rating-box .rating-number {
  font-weight: 800;
  font-size: 72px;
  line-height: 90px;
  color: var(--color-heading);
}
.course-details-content .rating-box span {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}

.review-wrapper .single-progress-bar {
  position: relative;
}
.review-wrapper .rating-text {
  display: inline-block;
  position: relative;
  top: 19px;
}
.review-wrapper .progress {
  max-width: 83%;
  margin-left: 38px;
  height: 12px;
  background: #EEEEEE;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .review-wrapper .progress {
    max-width: 80%;
  }
}
.review-wrapper .progress .progress-bar {
  background-color: #FFA41B;
}
.review-wrapper span.rating-value {
  position: absolute;
  right: 0;
  top: 50%;
}

.course-author-wrapper {
  padding: 0;
  display: flex;
}
@media only screen and (max-width: 575px) {
  .course-author-wrapper {
    flex-direction: column;
  }
}
.course-author-wrapper .thumbnail {
  min-width: 200px;
  max-height: 232px;
  margin-right: 30px;
}
.course-author-wrapper .thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
@media only screen and (max-width: 575px) {
  .course-author-wrapper .thumbnail img {
    width: auto;
    margin-bottom: 20px;
  }
}
.course-author-wrapper .author-content .title {
  margin-bottom: 2px;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}
.course-author-wrapper .author-content .subtitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-primary);
  display: block;
  margin-bottom: 20px;
}
.course-author-wrapper .author-content p {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 30px;
}
@media only screen and (max-width: 575px) {
  .course-author-wrapper .author-content {
    margin-top: 20px;
  }
}

.edu-comment {
  display: flex;
}
@media only screen and (max-width: 575px) {
  .edu-comment {
    flex-direction: column;
  }
}
.edu-comment .thumbnail {
  min-width: 70px;
  width: 70px;
  max-height: 70px;
  border-radius: 100%;
  margin-right: 25px;
}
.edu-comment .thumbnail img {
  border-radius: 100%;
  width: 100%;
}
.edu-comment .comment-content .comment-top {
  display: flex;
  align-items: center;
}
.edu-comment .comment-content .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 10px;
  margin-right: 15px;
}
.edu-comment .comment-content .subtitle {
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  display: block;
  margin-bottom: 10px;
  color: var(--color-heading);
}
@media only screen and (max-width: 575px) {
  .edu-comment .comment-content {
    margin-top: 20px;
  }
}
.edu-comment + .edu-comment {
  border-top: 1px solid #EEEEEE;
  padding-top: 30px;
  margin-top: 30px;
}

.course-details-card {
  border-radius: 8px;
  border: 1px solid #EEEEEE;
  padding: 30px;
}
.course-details-card .course-details-two-content p:last-child {
  margin-bottom: 0;
}

/*------------------------
    Preview Styles  
-------------------------*/
.pre-section-title .pretitle {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;
}

.eduvibe-landing-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  position: relative;
  z-index: 1;
}
.eduvibe-landing-banner .height-800 {
  min-height: 800px;
  width: 100%;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .height-800 {
    min-height: 680px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .height-800 {
    padding: 160px 0 30px;
  }
  .eduvibe-landing-banner .height-800 .height-940 {
    height: inherit;
    min-height: inherit;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-landing-banner .height-800 {
    padding: 140px 0 70px;
  }
  .eduvibe-landing-banner .height-800 .height-940 {
    min-height: auto;
    padding: 0;
  }
}
.eduvibe-landing-banner .content {
  margin-top: 82px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .content {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .content {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .eduvibe-landing-banner .content {
    margin-top: 0px;
  }
}
.eduvibe-landing-banner .content .title {
  font-weight: 800;
  font-size: 56px;
  line-height: 1.24;
  margin-bottom: 40px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .content .title {
    font-size: 50px;
    margin-bottom: 35px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .content .title {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .eduvibe-landing-banner .content .title {
    font-size: 28px;
    margin-bottom: 20px;
  }
}
.eduvibe-landing-banner .content p {
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 63px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .content p {
    margin-bottom: 50px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .content p {
    margin-bottom: 45px;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-landing-banner .content p {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-landing-banner .content p br {
    display: none;
  }
}
.eduvibe-landing-banner .content .btn-group-vertical {
  flex-flow: row wrap;
  justify-content: flex-start;
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .content .btn-group-vertical {
    justify-content: flex-start;
  }
}
@media only screen and (max-width: 479px) {
  .eduvibe-landing-banner .content .btn-group-vertical {
    flex-direction: column;
  }
}
.eduvibe-landing-banner .content .btn-group-vertical .left-button {
  margin-right: 20px;
}
@media only screen and (max-width: 479px) {
  .eduvibe-landing-banner .content .btn-group-vertical .left-button {
    margin-right: 0px;
    margin-bottom: 20px;
  }
}
.eduvibe-landing-banner .content .btn-group-vertical .bg-white {
  color: var(--color-primary);
}
.eduvibe-landing-banner .content .btn-group-vertical .bg-white:hover {
  color: var(--color-secondary);
  cursor: pointer;
}
.eduvibe-landing-banner .banner-image {
  margin-right: -260px;
  margin-left: -92px;
  margin-top: 77px;
}
@media only screen and (max-width: 1650px) {
  .eduvibe-landing-banner .banner-image {
    margin-right: -228px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-landing-banner .banner-image {
    margin-right: -173px;
    margin-left: -160px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .banner-image {
    margin-top: 0px;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .banner-image {
    margin: -100px -30px 0 -140px;
  }
}
@media only screen and (max-width: 575px) {
  .eduvibe-landing-banner .banner-image {
    margin: -70px 0px 0 -100px;
  }
}
@media only screen and (max-width: 479px) {
  .eduvibe-landing-banner .banner-image {
    margin: -50px 0px 0 -60px;
  }
}
@media only screen and (max-width: 1650px) {
  .eduvibe-landing-banner .banner-image img {
    width: 90%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-landing-banner .banner-image img {
    width: 85%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-landing-banner .banner-image img {
    width: 75%;
  }
}
@media only screen and (max-width: 991px) {
  .eduvibe-landing-banner .banner-image img {
    width: 100%;
  }
}
.eduvibe-landing-banner .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-landing-banner .shape-image.shape-image-1 {
  top: 180px;
  left: -60px;
}
.eduvibe-landing-banner .shape-image.shape-image-2 {
  bottom: 35px;
  right: -270px;
}
.eduvibe-landing-banner .shape-image.shape-image-3 {
  bottom: 55px;
  left: -90px;
}

/*-----------------------
    Course Layout Style    
--------------------------*/
.edu-demo-course-layout {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}
.edu-demo-course-layout .shape-image {
  position: absolute;
  z-index: -1;
}
.edu-demo-course-layout .shape-image.shape-image-1 {
  top: 0px;
  left: -200px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.edu-demo-course-layout .shape-image.shape-image-2 {
  top: -10px;
  right: -230px;
}
.edu-demo-course-layout .shape-image.shape-image-3 {
  bottom: -64px;
  left: -216px;
  animation: eduvibe-sm-x-move 3.5s alternate infinite linear;
}

/*-----------------------
    InnerPages    
--------------------------*/
.background-marque {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 770px;
  width: 100%;
  position: relative;
  z-index: 1;
  padding: 0 20px;
  background-position: center;
}

/*-----------------------
    Ecommerce Layout Style    
--------------------------*/
.edu-demo-ecommerce-layout {
  padding: 192px 0 163px !important;
  position: relative;
}
.edu-demo-ecommerce-layout .pre-section-title {
  margin-top: 55px;
}
.edu-demo-ecommerce-layout .shape-image {
  position: absolute;
  z-index: -1;
}
.edu-demo-ecommerce-layout .shape-image.shape-image-1 {
  top: -99px;
  left: -240px;
}
.edu-demo-ecommerce-layout .shape-image.shape-image-2 {
  bottom: 100px;
  left: -245px;
}
.edu-demo-ecommerce-layout .shape-image.shape-image-3 {
  top: 10px;
  left: 638px;
}
.edu-demo-ecommerce-layout .shape-image.shape-image-4 {
  top: 97px;
  right: -150px;
}
.edu-demo-ecommerce-layout .shape-image.shape-image-5 {
  bottom: -8px;
  right: -145px;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape .shape-dot {
  display: inline-block;
  border-radius: 100%;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-1 {
  bottom: -23px;
  left: -306px;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-1 .shape-dot {
  width: 50px;
  height: 50px;
  background: var(--color-extra06);
  opacity: 0.8;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-2 {
  bottom: 88px;
  left: 545px;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-2 .shape-dot {
  width: 30px;
  height: 30px;
  border: 5px solid var(--color-extra07);
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-3 {
  top: -89px;
  right: -103px;
}
.edu-demo-ecommerce-layout .shape-dot-wrapper .shape.shape-3 .shape-dot {
  width: 26px;
  height: 26px;
  background: var(--color-extra08);
  opacity: 0.35;
}
@media only screen and (max-width: 1199px) {
  .edu-demo-ecommerce-layout {
    padding: 130px 0 !important;
  }
  .edu-demo-ecommerce-layout .pre-section-title {
    margin-top: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .edu-demo-ecommerce-layout {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .edu-demo-ecommerce-layout {
    padding: 80px 0 !important;
  }
}

/*-----------------------
    Demo Style   
--------------------------*/
.landing-home-demo-area .shape-image {
  position: absolute;
  z-index: -1;
}
.landing-home-demo-area .shape-image.shape-image-1 {
  top: 82px;
  left: -210px;
}
.landing-home-demo-area .shape-image.shape-image-2 {
  top: 219px;
  right: -167px;
  animation: eduvibe-rotate-x 7s infinite linear;
}
.landing-home-demo-area .shape-image.shape-image-3 {
  bottom: 132px;
  right: -165px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.landing-home-demo-area .shape-image.shape-image-4 {
  bottom: 372px;
  left: -169px;
}

.single-demo {
  text-align: center;
}
.single-demo.coming-soon a {
  pointer-events: none;
}
.single-demo .thumbnail {
  position: relative;
}
.single-demo .thumbnail .thumbnail-link {
  display: block;
  padding: 5px;
  background-color: #fff;
  box-shadow: 0px 8px 35px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: relative;
}
.single-demo .thumbnail .thumbnail-link::before {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(2px);
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.4s;
}
.single-demo .thumbnail .thumbnail-link img {
  width: 100%;
  border-radius: 5px;
}
.single-demo .thumbnail .hover-action {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  z-index: 1;
  transition: 0.4s;
  opacity: 0;
}
.single-demo .thumbnail .hover-action a.edu-btn {
  height: 50px;
  line-height: 50px;
  padding: 0 24px;
}
.single-demo .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-top: 30px;
}
.single-demo.inner-demo .thumbnail .thumbnail-link::before {
  display: none;
}
.single-demo:hover .thumbnail .thumbnail-link::before {
  opacity: 1;
}
.single-demo:hover .thumbnail .hover-action {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

.demo-feature .inner {
  text-align: center;
}
.demo-feature .inner .icon {
  background: #FFFFFF;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.demo-feature .inner .icon img {
  max-height: 80px;
}
.demo-feature .inner .title {
  margin-bottom: 0;
  margin-top: 25px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
}

.pv-gallery-wrapper {
  margin: 0 -20px;
}

.pv-list-style li {
  list-style: disc;
}
.pv-list-style li::marker {
  color: var(--color-secondary);
}

.pv-footer {
  position: relative;
  z-index: 1;
  background-color: var(--color-dark);
}
.pv-footer .purchase-btn {
  margin-right: 14px;
}
.pv-footer .purchase-btn:hover {
  background-color: #FFFFFF;
  color: var(--color-secondary);
}
.pv-footer .button-group .bg-white {
  color: var(--color-primary);
}
.pv-footer .button-group .bg-white:hover {
  color: var(--color-secondary);
  cursor: pointer;
}
.pv-footer .student-like-status {
  background: #FFFFFF;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: inline-block;
  position: absolute;
  left: -154px;
  top: -46px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .pv-footer .student-like-status {
    left: -54px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .pv-footer .student-like-status {
    left: 50px;
  }
}
.pv-footer .student-like-status .inner {
  display: flex;
  padding: 16px 15px;
  align-items: center;
}
.pv-footer .student-like-status .inner .icon {
  width: 40px;
  height: 40px;
  background: rgba(251, 124, 86, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
}
.pv-footer .student-like-status .inner .icon i {
  color: var(--color-white);
}
.pv-footer .student-like-status .inner .content {
  text-align: left;
}
.pv-footer .student-like-status .inner .content .title {
  color: var(--color-secondary);
  font-weight: 700;
  font-size: 20px;
  line-height: 16px;
  margin-bottom: 0;
}
.pv-footer .student-like-status .inner .content .subtitle {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}
.pv-footer .work-shop {
  min-width: 193px;
  max-width: 193px;
  background: var(--color-white);
  padding: 20px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: absolute;
  left: -264px;
  bottom: -67px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .pv-footer .work-shop {
    right: 2%;
    top: 57%;
  }
}
.pv-footer .work-shop .inner .thumbnail img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.pv-footer .work-shop .inner .content .title {
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 0;
}
.pv-footer .work-shop .inner .content .time {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  margin-bottom: 20px;
}
@media only screen and (min-width: 1401px) and (max-width: 1750px) {
  .pv-footer .work-shop {
    left: -107px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .pv-footer .work-shop {
    left: -3px;
    bottom: -117px;
  }
}
.pv-footer .trophy-content {
  background: var(--color-white);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
  display: flex;
  border-radius: 5px;
  padding: 10px 17px;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: -30px;
  display: none;
}
.pv-footer .trophy-content .icon {
  object-fit: cover;
  margin-right: 14px;
}
.pv-footer .trophy-content .icon img {
  max-width: 35px;
}
.pv-footer .trophy-content .content {
  margin-top: 5px;
}
.pv-footer .trophy-content .content .text {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 0;
  line-height: 1;
}
.pv-footer .trophy-content .content span {
  font-weight: 600;
  font-size: 12px;
}
@media only screen and (min-width: 1750px) {
  .pv-footer .trophy-content {
    display: flex;
  }
}
.pv-footer .card-info {
  position: absolute;
  right: -101px;
  bottom: -87px;
}
@media only screen and (max-width: 1650px) {
  .pv-footer .card-info {
    right: 0px;
    bottom: -117px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1450px) {
  .pv-footer .card-info {
    display: none !important;
  }
}
.pv-footer .card-info .inner {
  background: #FFFFFF;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  padding: 10px 20px;
}
.pv-footer .card-info .inner .name {
  font-weight: bold;
  font-size: 16px;
  line-height: 28px;
  color: var(--color-heading);
}
.pv-footer .card-info .inner .name span {
  font-size: 14px;
  color: var(--color-body);
  font-weight: 400;
}
.pv-footer .card-info .inner .rating-wrapper .rating i {
  font-size: 14px;
}
.pv-footer .card-info .inner .rating-wrapper span {
  display: inline-block;
  margin-left: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
}
.pv-footer .shape-dot-wrapper .shape {
  position: absolute;
  z-index: -1;
}
.pv-footer .shape-dot-wrapper .shape.shape-1 {
  right: -110px;
  top: -83px;
}
.pv-footer .shape-dot-wrapper .shape.shape-1 img {
  border-radius: 8px;
}
.pv-footer .shape-dot-wrapper .shape.shape-2 {
  right: 20px;
  bottom: -128px;
}
@media only screen and (max-width: 1650px) {
  .pv-footer .shape-dot-wrapper .shape.shape-2 {
    right: 120px;
  }
}
.pv-footer .shape-dot-wrapper .shape.shape-2 img {
  height: 185px;
  width: 145px;
  object-fit: cover;
  border-radius: 4px;
}
@media only screen and (max-width: 1199px) {
  .pv-footer {
    height: 470px;
  }
  .pv-footer .trophy-content {
    margin: 70px auto 0;
  }
}
@media only screen and (max-width: 767px) {
  .pv-footer {
    padding: 80px 0 !important;
  }
}

/*------------------------
    Features
--------------------------*/
.landing-demo-features .shape-image {
  position: absolute;
  z-index: -1;
}
.landing-demo-features .shape-image.shape-image-1 {
  top: 290px;
  left: -140px;
  animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;
}
.landing-demo-features .shape-image.shape-image-2 {
  bottom: 545px;
  right: -200px;
}
.landing-demo-features .shape-image.shape-image-3 {
  bottom: 125px;
  left: -150px;
}

/*------------------------
    FAQ  
--------------------------*/
.landing-demo-faq-wrapper .animate-image {
  position: absolute;
  z-index: -1;
}
.landing-demo-faq-wrapper .animate-image.shape-image-1 {
  top: -10px;
  right: -150px;
}
.landing-demo-faq-wrapper .animate-image.shape-image-2 {
  bottom: 30px;
  left: -180px;
}

/*------------------------
    Header Splash Two  
--------------------------*/
.eduvibe-splash-header .header-menu-bar {
  display: flex;
  align-items: center;
}

/**************************************
    Footer Styles
***************************************/
/*===========================
    Start Footer Area 
=============================*/
.footer-style-default {
  position: relative;
  z-index: 1;
}
.footer-style-default .footer-top {
  padding: 130px 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-style-default .footer-top {
    padding: 80px 0;
  }
}
@media only screen and (max-width: 767px) {
  .footer-style-default .footer-top {
    padding: 80px 0;
  }
}
.footer-style-default .widget-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: var(--color-white);
}
.footer-style-default .description {
  color: var(--color-white);
  margin-top: 34px;
  margin-bottom: 40px;
}
.footer-style-default .information-list li {
  color: var(--color-white);
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 500;
  display: flex;
}
.footer-style-default .information-list li i {
  font-size: 15px;
  margin-right: 12px;
  position: relative;
  top: 5px;
}
.footer-style-default .information-list li a {
  color: var(--color-white);
  transition: 0.3s;
}
.footer-style-default .information-list li + li {
  margin-top: 20px;
}
.footer-style-default .information-list li:hover a {
  color: var(--color-white);
}
.footer-style-default .edu-footer-widget .inner {
  margin-top: 34px;
}
.footer-style-default .edu-footer-widget .footer-link {
  list-style: none;
  padding: 0;
}
.footer-style-default .edu-footer-widget .footer-link li {
  margin-top: 0;
  margin-bottom: 0;
}
.footer-style-default .edu-footer-widget .footer-link li a {
  font-size: 16px;
  display: block;
  color: var(--color-white);
  line-height: 26px;
}
.footer-style-default .edu-footer-widget .footer-link li a i {
  margin-right: 10px;
  font-size: 14px;
}
.footer-style-default .edu-footer-widget .footer-link li + li {
  margin-top: 20px;
}
.footer-style-default .edu-footer-widget .footer-link li:hover a {
  color: var(--color-white);
}
.footer-style-default .edu-footer-widget.explore-widget {
  margin-left: 65px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .footer-style-default .edu-footer-widget.explore-widget {
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-style-default .edu-footer-widget.explore-widget {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .footer-style-default .edu-footer-widget.explore-widget {
    margin-left: 0;
  }
}
.footer-style-default .edu-footer-widget.quick-link-widget {
  margin-left: 65px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .footer-style-default .edu-footer-widget.quick-link-widget {
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-style-default .edu-footer-widget.quick-link-widget {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .footer-style-default .edu-footer-widget.quick-link-widget {
    margin-left: 0;
  }
}

.eduvibe-footer-one {
  background: #231f40;
}
.eduvibe-footer-one .shape-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-footer-one .shape-image.shape-image-1 {
  top: -11px;
  left: -263px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-footer-one .shape-image.shape-image-1 {
    top: -51px;
    left: -130px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-footer-one .shape-image.shape-image-1 {
    top: -51px;
    left: -150px;
  }
}
.eduvibe-footer-one .shape-image.shape-image-2 {
  bottom: -83px;
  right: -200px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-footer-one .shape-image.shape-image-2 {
    bottom: -13px;
    right: -100px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-footer-one .shape-image.shape-image-2 {
    bottom: -13px;
    right: -150px;
  }
}

/*---------------------------------
 Footer with Call To Action  
----------------------------------*/
.edu-footer-with-cta {
  position: relative;
  z-index: 2;
  margin-top: 138px;
  background: #231f40;
}
@media only screen and (max-width: 767px) {
  .edu-footer-with-cta {
    margin-top: 0;
  }
}
.edu-footer-with-cta .cta-with-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: -138px;
}
@media only screen and (max-width: 767px) {
  .edu-footer-with-cta .cta-with-overlay {
    position: static;
    top: 0;
    padding-bottom: 80px;
  }
}
.edu-footer-with-cta .footer-style-default {
  padding-top: 138px;
  position: static;
}

/*---------------------------------
 Footer 2
----------------------------------*/
.eduvibe-footer-two .edu-btn {
  margin-bottom: 30px;
}
@media only screen and (max-width: 575px) {
  .eduvibe-footer-two {
    padding-bottom: 80px;
  }
  .eduvibe-footer-two .edu-btn {
    margin-bottom: 0px;
  }
  .eduvibe-footer-two .call-action-style-1,
  .eduvibe-footer-two .call-action-style-1.box-layout {
    padding: 30px;
  }
}
.eduvibe-footer-two .footer-style-default {
  padding-top: 138px;
  position: static;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .eduvibe-footer-two .footer-style-default {
    padding-top: 418px;
  }
}
@media only screen and (max-width: 767px) {
  .eduvibe-footer-two .footer-style-default {
    padding-top: 0px;
  }
}
.eduvibe-footer-two .animate-image {
  position: absolute;
  z-index: -1;
}
.eduvibe-footer-two .animate-image.shape-image-1 {
  top: -11px;
  left: -263px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-footer-two .animate-image.shape-image-1 {
    top: -51px;
    left: -130px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-footer-two .animate-image.shape-image-1 {
    top: -51px;
    left: -150px;
  }
}
.eduvibe-footer-two .animate-image.shape-image-2 {
  bottom: -83px;
  right: -200px;
}
@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .eduvibe-footer-two .animate-image.shape-image-2 {
    bottom: -13px;
    right: -100px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .eduvibe-footer-two .animate-image.shape-image-2 {
    bottom: -13px;
    right: -150px;
  }
}

/*-------------------------
    Copyright Styles  
--------------------------*/
.copyright-default p {
  color: var(--color-white);
}
.copyright-default p a {
  color: var(--color-white);
  transition: 0.4s;
}
.copyright-default p a:hover {
  color: var(--color-primary);
}

/**************************************
    Footer Styles
***************************************/
.lan-select {
  background-color: transparent !important;
  border-color: transparent !important;
  outline: 0;
  box-shadow: none;
  font-size: large;
  font-weight: bold;
  color: gray;
  border: none;
  cursor: pointer;
  padding-right: 26px;
}

.lan-select:focus {
  border-color: transparent !important;
  outline: 0;
  box-shadow: none;
  font-size: large;
  font-weight: bold;
  color: gray;
  border: none;
}

.lan-option {
  padding: 0 10px;
  line-height: 40px;
  font-size: large;
  cursor: pointer;
  border-bottom: 1px solid #eaeaea;
  font-weight: bold;
  color: gray;
  border: none;
}

.has-search .form-control {
  padding-left: 4.375rem;
}

.has-search.form-group {
  margin-bottom: 0%;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  padding-left: 16px;
}

.nav-space {
  margin-right: 100px;
  margin-left: 100px;
}

.edu-btn-outline {
  background-color: transparent !important;
  border: 1px solid #525fe1 !important;
  color: #525fe1 !important;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

.edu-btn-outline:hover {
  background-color: black !important;
  color: #fff !important;
}

.bg-color-light-blue {
  background-color: #f4f9ff !important;
}

.input-box > label {
  color: black;
}

.login-form label {
  color: black;
}

.otp-submit button {
  background-color: #525fe1 !important;
  border: 1px solid #525fe1 !important;
  color: #fff !important;
  padding: 20px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

.otp-submit button:hover {
  background-color: black !important;
  color: #fff !important;
}

.otp-submit-disabled button {
  background-color: #e8e8e8 !important;
  border: none !important;
  color: gray !important;
  padding: 20px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

.otp-submit-disabled button:hover {
  background-color: #e8e8e8 !important;
  border: none !important;
  color: gray !important;
}

.modal-header button {
  margin-top: 10px !important;
}

.otp input {
  border-radius: 0px !important;
  border-right: 0px !important;
}

.otp input:first-child {
  border-bottom-left-radius: 10px !important;
  border-top-left-radius: 10px !important;
}

.otp input:last-child {
  border-bottom-right-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border-right: 2px solid lightgray !important;
}

.otp input:focus {
  border: 2px solid #d2d3d8 !important;
}

.modal-header {
  align-items: flex-start !important;
}

.modal-header button {
  margin-top: 10px !important;
}

.accordion-header button {
  font-size: 14px !important;
  font-weight: 700 !important;
}

.result > div {
  border-bottom: 1px solid lightgray;
}

.result > div:last-child {
  border-bottom: none;
}

.accordion-button {
  padding: 20px;
}

.accordion-for-subjects-btn {
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  padding: 14px 16px 14px 16px;
  border: none;
  background: none;
  color: #333;
  text-align: left;
  display: flex;
  align-items: center;
}

.accordion-for-subjects-btn-select {
  background-color: #f4f9ff;
  color: #525fe1;
  border-left: 2px solid #525fe1;
}

.accordion-for-subjects-btn::last-child:focus {
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}

.scene {
  display: inline-block;
  width: 200px;
  height: 260px;
  /*   border: 1px solid #CCC; */
  margin: 40px 10px;
  perspective: 600px;
}

.card {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transform-style: preserve-3d;
  transform-origin: center right;
  transition: transform 0.5s;
}

.card.is-flipped {
  transform: translateX(-100%) rotateY(-180deg);
}

.card__face {
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 260px;
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 40px;
  backface-visibility: hidden;
}

.card__face--front {
  background: #525fe1;
  border-radius: 5px;
  padding: 10px;
}

.card__face--back {
  background: #525fe1;
  transform: rotateY(180deg);
  border-radius: 5px;
  padding: 10px;
}

.short_description p {
  color: white !important;
}

.questions li {
  font-size: 20px;
  color: black;
  font-weight: bolder;
}

.results-wrapper {
  margin: 1rem 1rem 1rem 0;
  padding: 0.5rem;
}

.result-span {
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: block;
  padding: 0.5rem 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search .wrapper:first-child svg {
  border: 4px solid blue !important;
}

.search .wrapper:first-child input {
  border: 4px solid red !important;
}

.search .wrapper:first-child {
  border: 4px solid orange;
}

ul.course-ls li:first-child {
  list-style-type: none;
}

.un-selectable {
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  user-select: none;
  color: #cc0000;
}

label.mcq-view-label-green input[type=checkbox]:checked ~ label.mcq-view-label-green::before,
input[type=radio]:checked ~ label.mcq-view-label-green::before {
  border-color: #0e9c24 !important;
  background-color: #0e9c24 !important;
}

label.mcq-view-label-red input[type=checkbox]:checked ~ label.mcq-view-label-red::before,
input[type=radio]:checked ~ label.mcq-view-label-red::before {
  border-color: #ff3e3e !important;
  background-color: #ff3e3e !important;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.flashcards .edu-slick-button .slick-dots {
  bottom: -40px;
}

.flashcards .scene {
  height: 55vh;
  width: 100% !important;
  margin: 0px;
  border: none;
}

.flashcards .card__face--front {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}), linear-gradient(180deg, #5492ee 0%, #1e56e5 100%);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 5;
}

.flashcards .card__face--back {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}), linear-gradient(180deg, #e7f6ff 0%, #daffe0 100%);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 5;
}

.mobile-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    display: block;
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes slideOutToBottom {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
    display: none;
  }
}
.myElement {
  animation: 0.5s slideInFromBottom;
}

.myElement.slideOut {
  animation: 0.5s slideOutToBottom forwards;
}

.exam-details-accordion-body * {
  padding: 0;
  margin: 0;
}

.exam-details-accordion-header button {
  align-items: center !important;
}

.exam-details-accordion-header button > div {
  width: 99% !important;
}

.exam-details-accordion-header button::after {
  width: -1% !important;
}

.result {
  border-bottom: 1px solid lightgray;
  padding: 20px 0px;
}

.result:last-child {
  border-bottom: none;
}

.subjectOutlineListModal {
  align-items: center !important;
}

.subjectOutlineListModal button {
  margin-top: 0px !important;
}

.shadow {
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.0588235294);
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scroll-off::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scroll-off {
  height: 60vh;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.landing-inner-pages ul.slick-dots {
  bottom: 40px;
}

.landing-inner-pages ul.slick-dots li {
  background-color: white;
  border: 1px solid #bbbbbb;
  outline: 1px solid #bbbbbb;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.landing-inner-pages ul.slick-dots li > button::before {
  color: transparent !important;
}

.landing-inner-pages ul li.slick-active {
  background-color: #bbbbbb;
  border: 1px solid #bbbbbb;
  outline: 1px solid #bbbbbb;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.landing-inner-pages.brand ul.slick-dots {
  bottom: -40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

img.footer-banner {
  height: 470px;
}

.exam-filter button {
  border: 2px solid #eeeeee !important;
  color: #6f6b80 !important;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}

.exam-filter button:hover {
  border: 2px solid #3c5da3 !important;
  color: #3c5da3 !important;
}

button.select {
  border: 2px solid #3c5da3 !important;
  color: #3c5da3 !important;
}

.basic-single {
  border: 2px solid #eeeeee !important;
  color: #6f6b80 !important;
  border-radius: 10px;
  font-size: 18px;
  cursor: pointer;
}

.basic-single:hover {
  border: 2px solid #3c5da3 !important;
  color: #3c5da3 !important;
  cursor: pointer;
}

.basic-single .select__control {
  border: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  padding: 3px 0px;
  cursor: pointer;
}

.modal-90w {
  min-width: 90vw !important;
  min-height: 90vh !important;
}

.modal-60w {
  min-width: 40vw !important;
  min-height: 80vh !important;
}

.modal-90w .modal-title {
  font-size: 20px !important;
}

.mp-0 * {
  margin: 0px !important;
  padding: 0px !important;
}

.zoom-img {
  transition: transform 0.2s; /* Animation */
}

.go-to-course:hover {
  background-color: #3c5da3 !important;
  color: #fff !important;
}

.modal-custom .modal-body::-webkit-scrollbar {
  display: none;
}

.modal-custom::-webkit-scrollbar {
  display: none;
}

.modal-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-custom .modal-content {
  width: 100%;
  height: 100%;
  background: transparent;
}

.modal-custom .modal-body {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: transparent;
}

.modal-custom .btn-close {
  background-color: #ffffff;
  margin: 30px;
  padding: 15px;
  border-radius: 50%;
}

.modal-custom .modal-header {
  display: flex;
  justify-content: flex-end;
  border-bottom: none;
}

.video-area-course ul.slick-dots {
  bottom: 10px;
}

.video-area-course-enroll-modal .modal-header {
  justify-content: end !important;
}

.video-area-course-enroll-modal .modal-header button.btn-close {
  margin: 5px !important;
  padding: 5px !important;
}

.video-area-course-enroll-modal .modal-body {
  display: flex;
  justify-content: center;
}

::placeholder {
  color: rgb(163, 163, 163) !important;
}

input {
  color: black !important;
}

select {
  color: black !important;
}

.footer-link.link-hover {
  color: white !important;
}

.certificate-modal .modal-content {
  height: 90vh;
  z-index: 9999;
}

.video-thumbnail3 {
  margin: 5% auto;
  width: 300px;
  height: 300px;
  border-radius: 10px;
}

.video-thumbnail2 {
  margin: 5% auto;
  width: 300px;
  height: 300px;
  border-radius: 10px;
}

.video-thumbnail {
  margin: 5% auto;
  width: 300px;
  height: 300px;
  border-radius: 10px;
}

.play-btn {
  background: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 108px;
  animation: animate 2s linear infinite;
  cursor: pointer;
  width: 100px;
  height: 100px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.play-btn i {
  color: #3c5da3;
  font-size: 102px;
}

.play-btn2 {
  background: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 108px;
  animation: animate 2s linear infinite;
  cursor: pointer;
  width: 80px;
  height: 80px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.play-btn2 i {
  color: #3c5da3;
}

@keyframes animate {
  0% {
    box-shadow: 0 0 0 0 rgba(7, 85, 255, 0.7);
  }
  40% {
    box-shadow: 0 0 0 50px rgba(255, 193, 7, 0);
  }
  80% {
    box-shadow: 0 0 0 50px rgba(255, 193, 7, 0);
  }
  100% {
    box-shadow: 0 0 0 rgba(255, 193, 7, 0);
  }
}
.gap2 {
  padding: 80px, 100px, 80px, 100px !important;
  margin: 80px, 100px, 80px, 100px !important;
}

.about-left-section {
  padding: 0px 80px !important;
  margin: 0px !important;
}

.email-input {
  text-indent: 30px;
}
.email-input::placeholder {
  padding-left: 10px !important;
  padding-right: 10px !important;
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: gray;
  opacity: 1; /* Firefox */
}
.email-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: gray;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.email-input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: gray;
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.fs-5 {
  font-size: 17px !important;
}

.header-event span {
  font-size: 17px;
  margin-left: 2px;
  margin-right: 2px;
}

.black {
  color: black;
}

.search-event {
  width: 25%;
}

.LandingDemoInnerPages > .slick-list {
  overflow: visible;
}

.title {
  font-family: "Onest" !important;
  font-size: 18;
}

.title {
  font-family: "Onest" !important;
  font-size: 18;
}

.title {
  font-family: "Onest" !important;
  font-size: 18;
}

.title {
  font-family: "Onest" !important;
  font-size: 18;
}

.title {
  font-family: "Onest" !important;
  font-size: 18;
}

.gallery-img {
  margin: 20px 0px;
  background-color: "#F5F5F5";
  padding: "10px";
  border-radius: "15px";
}

.mobile-menu {
  height: 100vh !important;
}

.global * {
  font-family: "Onest" !important;
  color: white !important;
  margin: 0;
  padding: 0;
}

.global2 * {
  font-family: "Onest" !important;
  color: black !important;
  margin: 0;
  padding: 0;
}

.active2 {
  background-color: #eeeeee !important;
}

.event-img:hover {
  opacity: 0.8;
  filter: blur(1px);
  cursor: pointer;
}

.video-thumbnail4 {
  position: "absolute";
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.width-30 {
  width: 30% !important;
}

@media (min-width: 2560px) {
  .video-thumbnail {
    top: 40% !important;
    left: 10% !important;
    position: absolute;
  }
}
@media (max-width: 2560px) {
  .lg-none {
    display: none !important;
  }
  .padding-container2 {
    padding: 80px 0px 80px 0px !important;
  }
  .padding-container {
    padding: 80px 0px 80px 0px;
  }
  .sm-show {
    display: none !important;
  }
  .lg-show {
    display: block !important;
  }
  a.edu-btn,
  button.edu-btn {
    margin-top: 0px !important;
  }
  .padding-50 {
    padding-top: 50px !important;
  }
  .padding-150 {
    padding-top: 150px !important;
  }
  .video-thumbnail {
    top: 40% !important;
    right: -54% !important;
    position: absolute;
  }
  .video-thumbnail3 {
    top: 40% !important;
    left: 20% !important;
    position: fixed;
  }
  .download {
    position: absolute;
    bottom: 0%;
    right: 0%;
  }
  .sm-flex {
    display: flex !important;
    align-items: center !important;
  }
  .text-center-sm {
    text-align: center !important;
  }
  .text-start-sm {
    text-align: start !important;
  }
}
@media (max-width: 1920px) {
  .lg-none {
    display: none !important;
  }
  .Exploreallnews {
    display: none !important;
  }
  .course-img {
    width: 5% !important;
  }
  .recorded-md {
    display: none;
  }
  .video-thumbnail {
    top: 41% !important;
    right: -1% !important;
    position: absolute;
  }
  .video-thumbnail3 {
    top: 50% !important;
    left: 20% !important;
    position: absolute;
  }
  .h-md {
    height: 409px;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .sm-flex {
    display: flex !important;
    align-items: center !important;
  }
  .text-center-sm {
    text-align: center !important;
  }
  .text-start-sm {
    text-align: start !important;
  }
}
@media (max-width: 1440px) {
  .lg-none {
    display: none !important;
  }
  .Exploreallnews {
    display: none !important;
  }
  .course-img {
    width: 5% !important;
  }
  .h-md {
    height: 409px;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .video-thumbnail {
    top: 41% !important;
    right: -1% !important;
    position: absolute;
  }
  .sm-flex {
    display: flex !important;
    align-items: center !important;
  }
  .text-center-sm {
    text-align: center !important;
  }
  .text-start-sm {
    text-align: start !important;
  }
}
@media (max-width: 1024px) {
  .lg-none {
    display: none !important;
  }
  .padding-50 {
    padding-top: 20px !important;
  }
  .padding-150 {
    padding-top: 150px !important;
  }
  .Exploreallnews {
    display: none !important;
  }
  .technology-flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .technology-flex div {
    width: 250px;
    height: 250px;
  }
  .recorded-lg {
    height: 130px !important;
  }
  .recorded-md {
    display: none;
  }
  .course-img {
    width: 8% !important;
  }
  img.footer-banner {
    height: 300px;
  }
  .video-thumbnail {
    top: 30% !important;
    right: 0% !important;
    position: absolute;
  }
  .h-md {
    height: auto;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .h-full {
    height: 500px !important;
  }
  .lg-show {
    display: none !important;
  }
  .sm-show {
    display: block !important;
  }
  .sm-flex {
    display: flex !important;
    align-items: center !important;
  }
  .text-center-sm {
    text-align: center !important;
  }
  .text-start-sm {
    text-align: start !important;
  }
}
@media (max-width: 768px) {
  .padding-50 {
    padding-top: 40px !important;
  }
  .padding-150 {
    padding-top: 150px !important;
  }
  .Exploreallnews {
    display: none !important;
  }
  .recorded-lg {
    display: none;
  }
  .recorded-md {
    display: block;
  }
  .course-img {
    width: 8% !important;
  }
  img.footer-banner {
    height: 250px;
  }
  .landing-inner-pages ul.slick-dots {
    bottom: 10px;
  }
  .landing-inner-pages.brand ul.slick-dots {
    bottom: -40px;
  }
  .landing-inner-pages ul.slick-dots li {
    background-color: #cecece;
    border: 5px solid transparent;
    outline: 5px solid transparent;
    border-radius: 50%;
    height: 10px;
    width: 10px;
  }
  .landing-inner-pages ul li.slick-active {
    background-color: #cecece;
    border: 5px solid white;
    outline: 5px solid #cecece;
    border-radius: 50%;
    height: 6px;
    width: 6px;
  }
  .video-thumbnail {
    top: 69% !important;
    right: -3% !important;
    position: absolute;
  }
  .video-thumbnail3 {
    top: 50% !important;
    left: -50% !important;
    position: absolute;
  }
  .w-md-25 {
    width: 50% !important;
  }
  .email-input {
    text-indent: 10px;
  }
  .email-input::placeholder {
    padding-left: 5px !important;
    padding-right: 5px !important;
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: gray;
    opacity: 1; /* Firefox */
  }
  .email-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: gray;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .email-input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: gray;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .section-title .pre-title {
    padding-top: 80px !important;
  }
  .text-center {
    text-align: center;
  }
  .pt-20 {
    margin-top: 20px;
    text-align: center;
  }
  .sm-flex {
    display: flex !important;
    align-items: center !important;
  }
  .d-sm-block {
    display: flex !important;
  }
  .text-center-sm {
    text-align: center !important;
  }
  .text-start-sm {
    text-align: center !important;
  }
  .hight-40 {
    height: auto !important;
  }
  .width-30 {
    width: 90% !important;
  }
}
@media (max-width: 430px) {
  .mt_sm--10 {
    margin-top: 25px !important;
  }
  .text-center-sm {
    text-align: left !important;
  }
  .banner-style-4 .banner-image .learner-badge {
    width: 90px;
    height: 90px;
    margin-left: 40px;
  }
  .banner-style-4 .banner-image .learner-badge .badge-inner span.viewer {
    font-size: 20px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    line-height: 20px;
  }
  .banner-style-4 .banner-image .learner-badge .badge-inner h6 {
    font-size: 10px;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  .lg-none {
    display: block !important;
  }
  .sm-none {
    display: none !important;
  }
  .block {
    display: none !important;
  }
  .padding-container2 {
    padding: 0px 0px 0px 0px !important;
  }
  .text-center {
    text-align: center;
  }
  .pt-20 {
    margin-top: 20px;
  }
  .padding-container {
    padding: 40px 0px 40px 0px !important;
  }
  .lg-show {
    display: none !important;
  }
  .sm-show {
    display: block !important;
  }
  .feature-title {
    font-size: 14px !important;
  }
  .feature-description {
    font-size: 14px !important;
    line-height: 10px;
  }
  .about-style-1 .inner .description p * {
    font-size: 12px !important;
  }
  .section-title .title {
    font-size: 20px !important;
  }
  .section-title .pre-title {
    font-size: 12px !important;
  }
  .edu-section-gap2 {
    padding: 0px !important;
  }
  .banner-style-4 .home-four-banner-wrapper {
    padding: 0px !important;
  }
  button.small {
    font-size: 12px !important;
    display: inline !important;
    width: max-content;
  }
  .about-left-section {
    padding: 40px !important;
  }
  a.edu-btn,
  button.edu-btn {
    margin-top: 20px !important;
  }
  .newsletter-form-style-1 .input-box input {
    width: 100% !important;
    min-width: 100% !important;
  }
  .padding-50 {
    padding-top: 0px !important;
  }
  .padding-150 {
    padding-top: 100px !important;
  }
  .banner-style-4 .inner .content .pre-title {
    font-size: 8px !important;
  }
  .banner-style-4 .content .title {
    font-size: 28px !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .Exploreallnews {
    display: block !important;
    background-color: #3c5da3 !important;
    color: white !important;
    padding: 15px 30px;
  }
  img.footer-banner {
    height: 100px;
  }
  .brand .landing-inner-pages ul.slick-dots {
    bottom: -50px;
  }
  .search-event {
    width: 100% !important;
  }
  .video-thumbnail {
    top: 70% !important;
    right: -10% !important;
    position: absolute;
  }
  .video-thumbnail3 {
    top: 50% !important;
    left: -50% !important;
    position: absolute;
  }
  .text-sm-end {
    text-align: left !important;
  }
  .edu-instructor-1 .edu-instructor-info .title {
    font-size: 14px !important;
  }
  .edu-instructor-1 .edu-instructor-info .desc {
    font-size: 10px !important;
  }
  .media-sm {
    font-size: 8px;
  }
  .titles {
    font-size: 8px;
    line-height: 0px;
  }
  .contain-card {
    width: 100% !important;
  }
  .sm-w-100 {
    width: 100% !important;
  }
  .sm-flex {
    display: block !important;
  }
  .hight-70vh {
    height: min-content !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .text-start-sm {
    text-align: center !important;
  }
  .hight-40 {
    height: 40vh !important;
  }
  .width-30 {
    width: 90% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/default/_variables.scss","webpack://./src/assets/scss/default/_reset.scss","webpack://./src/assets/scss/default/_typography.scss","webpack://./src/assets/scss/default/_extend.scss","webpack://./src/assets/scss/default/_animations.scss","webpack://./src/assets/scss/default/_shortcode.scss","webpack://./src/assets/scss/default/_mixins.scss","webpack://./src/assets/scss/default/_spacing.scss","webpack://./src/assets/scss/default/_common.scss","webpack://./src/assets/scss/default/_forms.scss","webpack://./src/assets/scss/header/_header.scss","webpack://./src/assets/scss/header/_nav.scss","webpack://./src/assets/scss/header/_header-quote.scss","webpack://./src/assets/scss/header/_mobilemenu.scss","webpack://./src/assets/scss/header/_search-popup.scss","webpack://./src/assets/scss/elements/_button.scss","webpack://./src/assets/scss/elements/_brands.scss","webpack://./src/assets/scss/elements/_section-title.scss","webpack://./src/assets/scss/elements/_section-animation.scss","webpack://./src/assets/scss/elements/_card.scss","webpack://./src/assets/scss/elements/_meta.scss","webpack://./src/assets/scss/elements/_badge.scss","webpack://./src/assets/scss/elements/_pagination.scss","webpack://./src/assets/scss/elements/_event.scss","webpack://./src/assets/scss/elements/_team.scss","webpack://./src/assets/scss/elements/_service.scss","webpack://./src/assets/scss/elements/_single-elements.scss","webpack://./src/assets/scss/elements/_coursesidebar.scss","webpack://./src/assets/scss/elements/_testimonial.scss","webpack://./src/assets/scss/elements/_feature.scss","webpack://./src/assets/scss/elements/_about.scss","webpack://./src/assets/scss/elements/_newsletter.scss","webpack://./src/assets/scss/elements/_social-share.scss","webpack://./src/assets/scss/elements/_backtotop.scss","webpack://./src/assets/scss/elements/_workshop.scss","webpack://./src/assets/scss/elements/_video-popup.scss","webpack://./src/assets/scss/elements/_chooseus.scss","webpack://./src/assets/scss/elements/_calltoaction.scss","webpack://./src/assets/scss/elements/_slickslider.scss","webpack://./src/assets/scss/elements/_winner.scss","webpack://./src/assets/scss/elements/_counterup.scss","webpack://./src/assets/scss/elements/_countdown.scss","webpack://./src/assets/scss/elements/_breadcrumb.scss","webpack://./src/assets/scss/elements/_masonaryitem.scss","webpack://./src/assets/scss/elements/_accordion.scss","webpack://./src/assets/scss/elements/_privacy-policy.scss","webpack://./src/assets/scss/elements/_404.scss","webpack://./src/assets/scss/elements/_coming-soon.scss","webpack://./src/assets/scss/elements/_gallery.scss","webpack://./src/assets/scss/elements/_pricingtable.scss","webpack://./src/assets/scss/elements/_profile-details.scss","webpack://./src/assets/scss/elements/_progressbar.scss","webpack://./src/assets/scss/elements/_contactus.scss","webpack://./src/assets/scss/elements/_shop.scss","webpack://./src/assets/scss/elements/brand.scss","webpack://./src/assets/scss/elements/_checkout.scss","webpack://./src/assets/scss/elements/overall.scss","webpack://./src/assets/scss/blog/_blog-grid.scss","webpack://./src/assets/scss/blog/_sidebar.scss","webpack://./src/assets/scss/blog/_blog-details.scss","webpack://./src/assets/scss/blog/_comments.scss","webpack://./src/assets/scss/template/_banner.scss","webpack://./src/assets/scss/template/_event-details.scss","webpack://./src/assets/scss/template/_product-details.scss","webpack://./src/assets/scss/template/_cart.scss","webpack://./src/assets/scss/template/_course-details.scss","webpack://./src/assets/scss/template/_preview.scss","webpack://./src/assets/scss/footer/_footer.scss","webpack://./src/assets/scss/footer/_copyright.scss"],"names":[],"mappings":"AAAA;;uCAAA;ACAA,kBAAA;AACA;EAEC,iCAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EAGA,sBAAA;EACA,yBAAA;EAGA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EAGA,yBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EAGA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EAGA,kDAAA;EACA,+CAAA;EACA,uDAAA;EAGA,kBAAA;EACA,sEAAA;EAQA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAGA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EAEA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;ADlBD;;AEnFA;;EAAA;AAIA;EAGC,sBAAA;AFqFD;;AElFA;;;;;;;;;;EAUC,cAAA;AFqFD;;AElFA;;;EAGC,qBAAA;AFqFD;;AElFA;EACC,aAAA;EACA,SAAA;AFqFD;;AElFA;EACC,aAAA;AFqFD;;AElFA;EACC,2BAAA;EACA,qBAAA;EACA,aAAA;AFqFD;;AElFA;;;EAGC,qBAAA;EACA,aAAA;EACA,2BAAA;AFqFD;;AElFA;EACC,aAAA;AFqFD;;AEnFA;EACC,gBAAA;AFsFD;;AEnFA;EACC,yBAAA;AFsFD;;AEnFA;;EAEC,iBAAA;AFsFD;;AEpFA;EACC,gCAAA;EACA,cAAA;AFuFD;;AErFA;;;;EAIC,8BAAA;EAIA,aAAA;EACA,2BAAA;AFwFD;;AEtFA;;EAEC,cAAA;AFyFD;;AEtFA;;EAGC,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;AFwFD;;AErFA;EACC,kBAAA;AFwFD;;AErFA;;EAEC,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AFwFD;;AEtFA;EACC,WAAA;AFyFD;;AEvFA;EACC,eAAA;AF0FD;;AEvFA;EACC,aAAA;EACA,mBAAA;AF0FD;;AEvFA;EACC,mBAAA;AF0FD;;AExFA;EACC,iBAAA;EACA,2BAAA;AF2FD;;AExFA;;;EAGC,cAAA;EACA,mBAAA;AF2FD;;AExFA;;EAEC,gBAAA;EACA,sBAAA;AF2FD;;AEzFA;;EAEC,SAAA;AF4FD;;AExFC;EACC,gBAAA;AF2FF;;AEvFA;EACC,+BAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AF0FD;;AEvFA;EACC,gBAAA;AF0FD;;AExFA;EACC,SAAA;AF2FD;;AEzFA;EACC,SAAA;AF4FD;;AE1FA;EACC,qCAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AF6FD;;AE3FA;EACC,SAAA;EACA,UAAA;EACA,mBAAA;AF8FD;;AE3FA;;;;EAIC,eAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;AF8FD;;AE3FA;;EAEC,mBAAA;AF8FD;;AE3FA;;;;EAMC,kBAAA;EACA,eAAA;AF8FD;;AE3FA;;EAEC,eAAA;AF8FD;;AE3FA;;EAEC,UAAA;AF8FD;;AE3FA;EAGC,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AF8FD;;AE3FA;EAEC,gBAAA;AF8FD;;AE3FA;;EAEC,SAAA;EACA,UAAA;AF8FD;;AE5FA;EACC,cAAA;EACA,mBAAA;AF+FD;;AE7FA;;;EAGC,mBAAA;AFgGD;;AE9FA;EACC,gBAAA;AFiGD;;AE9FA;;EAEC,qCAAA;EACA,iBAAA;AFiGD;;AE/FA;EACC,WAAA;AFkGD;;AE/FA;EACC,kCAAA;EACA,qBAAA;EACA,cAAA;AFkGD;;AEhGA;EACC,wBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AFmGD;;AEhGA;;;EAGC,0BAAA;AFmGD;;AEhGA;EACC,iBAAA;EACA,mBAAA;AFmGD;;AEhGA;EACC,mBAAA;AFmGD;;AEhGA;EACC,iBAAA;AFmGD;;AEhGA;EACC,gCAAA;AFmGD;;AEhGA;;;EAGC,kBAAA;AFmGD;;AEhGA,gBAAA;AACA;;EAKC,aAAA;EACA,YAAA;AFmGD;;AEhGA;;;;EAIC,WAAA;EACA,aAAA;AFmGD;;AEhGA;EACC,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;AFmGD;;AEhGA;EACC,eAAA;AFmGD;;AEhGA;;EAEC,8BAAA;EACA,mBAAA;AFmGD;;AEhGA;;EAEC,gBAAA;AFmGD;;AGvbA;;EAAA;AAIA;EACC,sBAAA;AHybD;;AGtbA;EACC,SAAA;EACA,UAAA;EACA,eAAA;AHybD;;AGtbA;EACC,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EAEA,wBAAA;EACA,gBAAA;EACA,oCAAA;EACA,SAAA;EACA,UAAA;AHwbD;AGvbC;EACC,qBAAA;AHybF;;AGrbA;;;;;;;;;;;;;;;;;;;;;EAqBC,SAAA;EACA,mBAAA;AHwbD;;AGrbA;EACC,gBAAA;AHwbD;;AGrbA;;;;;;;;;;;;EAYC,sBAAA;EAEA,mBAAA;EACA,2BAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGpbA;;EAEC,oBAAA;EACA,iCAAA;AHubD;;AGxaC;;;;;;;;;;;;EACC,cAAA;EACA,gBAAA;AHsbF;;AGnbA;EACC,2BAAA;EACA,gBAAA;AHsbD;;AGpbA;EACC;;IAEC,eAAA;EHubA;EGrbD;;IAEC,eAAA;EHubA;EGpbD;;IAEC,eAAA;EHsbA;EGnbD;;IAEC,eAAA;EHqbA;AACF;AGlbA;EACC;;IAEC,eAAA;EHobA;EGjbD;;IAEC,eAAA;EHmbA;EGhbD;;IAEC,eAAA;EHkbA;EG/aD;;IAEC,eAAA;EHibA;AACF;AG9aA;;;;;;EAMC,gCAAA;AHgbD;;AG7aA;;EAEC,0BAAA;AHgbD;;AG7aA;;EAEC,0BAAA;AHgbD;;AG7aA;;EAEC,0BAAA;AHgbD;;AG7aA;EACC,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AHgbD;AG9aC;EAPD;IAQE,gBAAA;IACA,8BAAA;IACA,kCAAA;EHibA;AACF;AG/aC;EACC,gBAAA;EACA,eAAA;AHibF;AG9aC;EACC,eAAA;EACA,iBAAA;AHgbF;AG7aC;EACC,eAAA;AH+aF;AG5aC;EACC,yBAAA;AH8aF;AG3aC;EACC,kBAAA;AH6aF;AG1aC;EACC,8BAAA;EACA,kCAAA;AH4aF;AGzaC;EACC,8BAAA;EACA,kCAAA;AH2aF;AGxaC;EACC,8BAAA;EACA,kCAAA;AH0aF;AGvaC;EACC,8BAAA;EACA,kCAAA;AHyaF;;AGraA;EACC,8BAAA;EACA,kCAAA;AHwaD;;AGraA;EACC,8BAAA;EACA,kCAAA;AHwaD;;AGraA;EACC,8BAAA;EACA,kCAAA;AHwaD;;AGraA;EACC,8BAAA;EACA,kCAAA;AHwaD;;AGraA;EACC,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AHwaD;;AGraA;;;EAGC,qBAAA;AHwaD;;AGraA;;;;EAIC,2BAAA;AHwaD;;AGjaA;;4BAAA;AAGA;;EAEC,kBAAA;AHoaD;;AGjaA;EACC,kBAAA;EACA,mBAAA;EACA,kBAAA;AHoaD;AGhaG;EACC,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AHkaJ;AGhaI;EAPD;IAQE,kBAAA;EHmaH;AACF;AGjaI;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,OAAA;EACA,SAAA;AHmaL;AGhaI;EACC,eAAA;AHkaL;AG5ZC;EACC,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AH8ZF;AG7ZE;EACC,qBAAA;EACA,wBAAA;AH+ZH;AG7ZG;EACC,2BAAA;AH+ZJ;AG3ZC;EACC,gBAAA;AH6ZF;;AGzZA;EACC,mBAAA;AH4ZD;AG3ZC;EACC,8BAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AH6ZF;AG5ZE;EACC,2BAAA;EAEA,qBAAA;AH6ZH;AG5ZG;EACC,2BAAA;AH8ZJ;AG1ZC;EACC,kBAAA;AH4ZF;;AGxZA;EACC,cAAA;EACA,SAAA;EACA,cAAA;EACA,yCAAA;EACA,uBAAA;AH2ZD;;AGzZA;EACC,gCAAA;AH4ZD;;AI1yBA;;wBAAA;AAGA;EACI,sCAAA;AJ6yBJ;;AI3yBA;EACI,wCAAA;AJ8yBJ;;AI5yBA;EACI,uCAAA;AJ+yBJ;;AI7yBA;EACI,sCAAA;AJgzBJ;;AI9yBA;EACI,mCAAA;AJizBJ;;AI/yBA;EACI,mCAAA;AJkzBJ;;AIryBA;EACI,gCAAA;AJwyBJ;;AIvwBA,WAAA;AAKA;EACI,4BAAA;AJswBJ;;AInwBA;EACI,gCAAA;AJswBJ;;AInwBA,gBAAA;AAEA;EACI,2BAAA;AJqwBJ;;AInwBA;EACI,2BAAA;AJswBJ;;AIpwBA;EACI,2BAAA;AJuwBJ;;AIrwBA;EACI,2BAAA;AJwwBJ;;AItwBA;EACI,2BAAA;AJywBJ;;AIvwBA;EACI,2BAAA;AJ0wBJ;;AIxwBA;EACI,2BAAA;AJ2wBJ;;AIxwBA,YAAA;AAEA;EACI,iCAAA;AJ0wBJ;;AIxwBA;EACI,+BAAA;AJ2wBJ;;AIzwBA;EACI,iCAAA;AJ4wBJ;;AInwBA,0CAAA;AAEA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AJqwBJ;;AIlwBA;EACI,6BAAA;AJqwBJ;;AIlwBA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;AJqwBJ;;AK74BA;;wBAAA;AAGA;EACI,gBAAA;ALg5BJ;AK94BI;EACI,gBAAA;ALg5BR;AK74BQ;EACI,qBAAA;AL+4BZ;;AK14BA;EACI;IACI,UAAA;IACA,SAAA;EL64BN;EK34BE;IACI,WAAA;EL64BN;EK34BE;IACI,WAAA;EL64BN;EK34BE;IACI,WAAA;EL64BN;EK34BE;IACI,YAAA;IACA,YAAA;EL64BN;AACF;AKz4BA;EACI;IACE,wBAAA;EL24BJ;EKz4BE;IACE,4BAAA;EL24BJ;EKz4BE;IACE,4BAAA;EL24BJ;AACF;AKx4BA;EACI,sBAAA;EACA,yBAAA;EACA,mCAAA;EACA,2BAAA;AL04BJ;;AKv4BA;EACI;IACI,UAAA;IACA,aAAA;EL04BN;EKx4BE;IACI,WAAA;EL04BN;EKx4BE;IACI,YAAA;IACA,YAAA;EL04BN;AACF;AKx4BA;EACI;IACI,UAAA;IACA,MAAA;EL04BN;EKx4BE;IACI,WAAA;EL04BN;EKv4BE;IACI,WAAA;ELy4BN;EKt4BE;IACI,WAAA;ELw4BN;EKr4BE;IACI,SAAA;IACA,YAAA;ELu4BN;AACF;AKr4BA;EACI;IACI,UAAA;IACA,UAAA;ELu4BN;EKr4BE;IACI,QAAA;ELu4BN;EKr4BE;IACI,SAAA;IACA,YAAA;ELu4BN;AACF;AKp4BA;EACI;IACI,UAAA;IACA,UAAA;ELs4BN;EKp4BE;IACI,QAAA;ELs4BN;EKp4BE;IACI,SAAA;IACA,YAAA;ELs4BN;AACF;AKj4BA;EACI;IACI,mBAAA;ELm4BN;EKh4BE;IACI,qBAAA;ELk4BN;EK/3BE;IACI,mBAAA;ELi4BN;AACF;AK93BA;EACI;IACI,8BAAA;ELg4BN;EK73BE;IACI,gCAAA;EL+3BN;EK53BE;IACI,gCAAA;EL83BN;AACF;AK33BA;EACI,gCAAA;AL63BJ;;AKv3BA;;6BAAA;AAcA;EACI;IACI,kBAAA;ELu3BN;EKp3BE;IACI,aAAA;ELs3BN;AACF;AKl3BA;;2BAAA;AAkBA;EACI;IACI,UAAA;IAEA,iCAAA;ELi3BN;EK92BE;IACI,UAAA;IAEA,eAAA;ELg3BN;AACF;AK72BA;EAEI,6BAAA;AL+2BJ;;AK52BA;;wCAAA;AAWA;EACI;IACI,UAAA;IAEA,wBAAA;EL62BN;AACF;AKr2BA;;mCAAA;AAGA;EACI;IACI,UAAA;ELu2BN;EKp2BE;IACI,wBAAA;IACA,UAAA;ELs2BN;EKn2BE;IACI,2BAAA;IACA,UAAA;ELq2BN;AACF;AMvmCA;;kCAAA;AAMA;;;;uCAAA;AAcI;EAPJ;;;;;;;IAQQ,mBAAA;IACA,kBAAA;ENomCN;AACF;;AMjmCA;EACI,WAAA;ANomCJ;;AMjmCA;;EAEI,YAAA;EACA,cAAA;ANomCJ;;AMjmCA;EACI,WAAA;ANomCJ;;AMjmCA;EACI,gBAAA;ANomCJ;;AMjmCA;EACI,gBAAA;ANomCJ;;AMhmCA;EACI,kBAAA;ANmmCJ;AMlmCI;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;ANomCR;AMnmCQ;EAVJ;IAWQ,WAAA;ENsmCV;AACF;;AMlmCA;;kCAAA;ACzDE;EACC,sCAAA;APiqCH;;AOlqCE;EACC,wCAAA;APqqCH;;AOtqCE;EACC,4CAAA;APyqCH;;AO1qCE;EACC,uCAAA;AP6qCH;;AO9qCE;EACC,yBAAA;APirCH;;AOlrCE;EACC,yBAAA;APqrCH;;AOtrCE;EACC,yBAAA;APyrCH;;AO1rCE;EACC,yBAAA;AP6rCH;;AO9rCE;EACC,sCAAA;APisCH;;AOlsCE;EACC,uCAAA;APqsCH;;AM5nCA;EACI,yCAAA;EACA,qCAAA;EACA,0EAAA;AN+nCJ;;AM5nCA;;8BAAA;AAQA;EACI,uCAAA;AN0nCJ;;AMvnCA,qBAAA;AACA;EACI,iBAAA;EACA,WAAA;AN0nCJ;;AMtnCA;;uBAAA;AAGA;EACI,gBAAA;EACA,iBAAA;ANynCJ;AMvnCI;EACI,iBAAA;EACA,kBAAA;ANynCR;;AMrnCA;EACI,iBAAA;EACA,kBAAA;ANwnCJ;AMtnCI;EACI,iBAAA;EACA,kBAAA;ANwnCR;;AMpnCA;EACI,kBAAA;EACA,mBAAA;ANunCJ;AMrnCI;EACI,kBAAA;EACA,mBAAA;ANunCR;;AMnnCA;EACI,kBAAA;EACA,mBAAA;ANsnCJ;AMpnCI;EACI,kBAAA;EACA,mBAAA;ANsnCR;;AMlnCA;EACI,kBAAA;EACA,mBAAA;ANqnCJ;AMlnCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENqnCN;AACF;AMnnCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENsnCN;AACF;AMpnCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENunCN;AACF;AMrnCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENwnCN;AACF;AMtnCI;EAEI,kBAAA;EACA,mBAAA;ANunCR;AMpnCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENunCV;AACF;AMrnCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENwnCV;AACF;AMtnCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENynCV;AACF;AMvnCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;EN0nCV;AACF;;AMtnCA;EACI,kBAAA;EACA,mBAAA;ANynCJ;AMtnCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENynCN;AACF;AMvnCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN0nCN;AACF;AMxnCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN2nCN;AACF;AMznCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN4nCN;AACF;AM1nCI;EAEI,kBAAA;EACA,mBAAA;AN2nCR;AMxnCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN2nCV;AACF;AMznCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;EN4nCV;AACF;AM1nCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;EN6nCV;AACF;AM3nCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;EN8nCV;AACF;;AMznCA;EACI,kBAAA;EACA,mBAAA;AN4nCJ;AMznCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;EN4nCN;AACF;AM1nCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN6nCN;AACF;AM3nCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN8nCN;AACF;AM5nCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN+nCN;AACF;AM7nCI;EAEI,kBAAA;EACA,mBAAA;AN8nCR;AM3nCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN8nCV;AACF;AM5nCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;EN+nCV;AACF;AM7nCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENgoCV;AACF;AM9nCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENioCV;AACF;;AM5nCA;EACI,kBAAA;EACA,mBAAA;AN+nCJ;AM5nCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;EN+nCN;AACF;AM7nCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENgoCN;AACF;AM9nCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENioCN;AACF;AM/nCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENkoCN;AACF;AMhoCI;EAEI,kBAAA;EACA,mBAAA;ANioCR;AM9nCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENioCV;AACF;AM/nCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENkoCV;AACF;AMhoCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENmoCV;AACF;AMjoCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENooCV;AACF;;AMhoCA;EACI,kBAAA;EACA,mBAAA;ANmoCJ;AMhoCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENmoCN;AACF;AMjoCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENooCN;AACF;AMloCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENqoCN;AACF;AMnoCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENsoCN;AACF;AMpoCI;EAEI,kBAAA;EACA,mBAAA;ANqoCR;AMloCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENqoCV;AACF;AMnoCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENsoCV;AACF;AMpoCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENuoCV;AACF;AMroCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENwoCV;AACF;;AMnoCA;EACI,kBAAA;EACA,mBAAA;ANsoCJ;AMnoCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENsoCN;AACF;AMpoCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENuoCN;AACF;AMroCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENwoCN;AACF;AMtoCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENyoCN;AACF;AMvoCI;EAEI,kBAAA;EACA,mBAAA;ANwoCR;AMroCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENwoCV;AACF;AMtoCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENyoCV;AACF;AMvoCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;EN0oCV;AACF;AMxoCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;EN2oCV;AACF;;AMtoCA;EACI,kBAAA;EACA,mBAAA;ANyoCJ;AMtoCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENyoCN;AACF;AMvoCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN0oCN;AACF;AMxoCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN2oCN;AACF;AMzoCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN4oCN;AACF;AM1oCI;EAEI,kBAAA;EACA,mBAAA;AN2oCR;AMxoCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN2oCV;AACF;AMzoCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;EN4oCV;AACF;AM1oCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;EN6oCV;AACF;AM3oCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;EN8oCV;AACF;;AM1oCA;EACI,kBAAA;EACA,mBAAA;AN6oCJ;AM1oCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;EN6oCN;AACF;AM3oCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN8oCN;AACF;AM5oCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN+oCN;AACF;AM7oCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENgpCN;AACF;AM9oCI;EAEI,kBAAA;EACA,mBAAA;AN+oCR;AM5oCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN+oCV;AACF;AM7oCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENgpCV;AACF;AM9oCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENipCV;AACF;AM/oCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENkpCV;AACF;;AM7oCA;;8BAAA;AAGA;;EAEI,UAAA;EACA,kEAAA;ANgpCJ;;AM7oCA;;EAEI,UAAA;EACA,kEAAA;ANgpCJ;;AM7oCA;;EAEI,UAAA;EACA,kEAAA;ANgpCJ;;AM7oCA;;EAEI,UAAA;EACA,kEAAA;ANgpCJ;;AM7oCA;;+BAAA;AAIA;;;EAGI,kBAAA;AN+oCJ;;AM5oCA;;;;;;EAMI,kBAAA;EACA,UAAA;AN+oCJ;;AM5oCA;;;EAGI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AN+oCJ;;AMxoCA;EACI,yBAAA;AN2oCJ;;AMxoCA;EACI,yBAAA;AN2oCJ;;AMtoCI;;;EAGI,YAAA;ANyoCR;;AM5oCI;;;EAGI,YAAA;AN+oCR;;AMlpCI;;;EAGI,YAAA;ANqpCR;;AMxpCI;;;EAGI,YAAA;AN2pCR;;AM9pCI;;;EAGI,YAAA;ANiqCR;;AMpqCI;;;EAGI,YAAA;ANuqCR;;AM1qCI;;;EAGI,YAAA;AN6qCR;;AMhrCI;;;EAGI,YAAA;ANmrCR;;AMtrCI;;;EAGI,YAAA;ANyrCR;;AM5rCI;;;EAGI,UAAA;AN+rCR;;AM3rCA;;iCAAA;AAIA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;EACA,mBAAA;AN4rCJ;AM1rCI;EAjBJ;IAkBQ,WAAA;IACA,YAAA;EN6rCN;AACF;AM3rCI;EAtBJ;IAuBQ,WAAA;IACA,YAAA;EN8rCN;AACF;AM5rCI;EACI,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;EACA,kBAAA;AN8rCR;AM3rCI;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;AN6rCR;AM1rCI;EAxDJ;IAyDQ,WAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EN6rCN;AACF;AM1rCQ;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AN4rCZ;AM1rCY;EALJ;IAMQ,eAAA;EN6rCd;AACF;AM3rCY;EACI,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,sEAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;AN6rChB;AMtrCY;EACI,2BAAA;ANwrChB;;AM/qCA;;uBAAA;AAGA;EACI,gBAAA;EACA,kBAAA;ANkrCJ;AMhrCI;EACI,gBAAA;EACA,cAAA;ANkrCR;AM/qCI;EACI,gBAAA;EACA,cAAA;ANirCR;;AQ77DA;;2BAAA;AAKA;EACI,iBAAA;AR87DJ;;AQ37DA;EACI,iBAAA;AR87DJ;;AQ37DA;EACI,2BAAA;AR87DJ;AQ77DI;EAFJ;IAGQ,0BAAA;ERg8DN;AACF;AQ/7DI;EALJ;IAMQ,0BAAA;ERk8DN;AACF;AQj8DI;EACI,iCAAA;ARm8DR;AQl8DQ;EAFJ;IAGQ,gCAAA;ERq8DV;AACF;AQp8DQ;EALJ;IAMQ,gCAAA;ERu8DV;AACF;;AQn8DA;EACI,gCAAA;ARs8DJ;AQr8DI;EAFJ;IAGQ,+BAAA;ERw8DN;AACF;AQv8DI;EALJ;IAMQ,+BAAA;ER08DN;AACF;;AQr8DI;EAFJ;;IAGQ,+BAAA;ER08DN;AACF;AQz8DI;EALJ;;IAMQ,+BAAA;ER68DN;AACF;;AQ18DA;EACI,6BAAA;AR68DJ;AQ58DI;EAFJ;IAGQ,4BAAA;ER+8DN;AACF;AQ98DI;EALJ;IAMQ,4BAAA;ERi9DN;AACF;;AQ38DI;EADJ;IAEQ,0BAAA;ER+8DN;AACF;AQ98DI;EAJJ;IAKQ,0BAAA;ERi9DN;AACF;;AQ18DI;EAJJ;;;;IAKQ,+BAAA;ERi9DN;AACF;AQh9DI;EAPJ;;;;IAQQ,+BAAA;ERs9DN;AACF;;AQl9DI;EADJ;IAEQ,+BAAA;ERs9DN;AACF;;AQn9DA;EACI,0BAAA;ARs9DJ;;AQp9DA;EACI,2BAAA;ARu9DJ;;AQr9DA;EACI,yBAAA;ARw9DJ;;AQt9DA;EACI,4BAAA;ARy9DJ;;AQv9DA;EACI,0BAAA;AR09DJ;;AQx9DA;EACI,yBAAA;AR29DJ;;AQz9DA;EACI,wBAAA;AR49DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,6BAAA;AR69DJ;;AQ19DA;EACI,6BAAA;AR69DJ;;AQ19DA;EACI,gCAAA;AR69DJ;;AQ19DA;EACI,gCAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,2BAAA;AR69DJ;;AQ19DA;EACI,0BAAA;AR69DJ;;AQ19DA;EACI,6BAAA;AR69DJ;;AQz9DI;EAAkB,yBAAA;AR69DtB;;AQ59DI;EAAkB,yBAAA;ARg+DtB;;AQ/9DI;EAAiB,2BAAA;ARm+DrB;;AQl+DI;EAAiB,8BAAA;ARs+DrB;;AQr+DI;EAAiB,4BAAA;ARy+DrB;;AQx+DI;EAAiB,6BAAA;AR4+DrB;;AQ3+DI;EAAgB,0BAAA;AR++DpB;;AQ9+DI;EAAgB,6BAAA;ARk/DpB;;AQj/DI;EAAgB,4BAAA;ARq/DpB;;AQp/DI;EAAgB,2BAAA;ARw/DpB;;AQjgEI;EAAkB,0BAAA;ARqgEtB;;AQpgEI;EAAkB,0BAAA;ARwgEtB;;AQvgEI;EAAiB,4BAAA;AR2gErB;;AQ1gEI;EAAiB,+BAAA;AR8gErB;;AQ7gEI;EAAiB,6BAAA;ARihErB;;AQhhEI;EAAiB,8BAAA;ARohErB;;AQnhEI;EAAgB,2BAAA;ARuhEpB;;AQthEI;EAAgB,8BAAA;AR0hEpB;;AQzhEI;EAAgB,6BAAA;AR6hEpB;;AQ5hEI;EAAgB,4BAAA;ARgiEpB;;AQziEI;EAAkB,0BAAA;AR6iEtB;;AQ5iEI;EAAkB,0BAAA;ARgjEtB;;AQ/iEI;EAAiB,4BAAA;ARmjErB;;AQljEI;EAAiB,+BAAA;ARsjErB;;AQrjEI;EAAiB,6BAAA;ARyjErB;;AQxjEI;EAAiB,8BAAA;AR4jErB;;AQ3jEI;EAAgB,2BAAA;AR+jEpB;;AQ9jEI;EAAgB,8BAAA;ARkkEpB;;AQjkEI;EAAgB,6BAAA;ARqkEpB;;AQpkEI;EAAgB,4BAAA;ARwkEpB;;AQjlEI;EAAkB,0BAAA;ARqlEtB;;AQplEI;EAAkB,0BAAA;ARwlEtB;;AQvlEI;EAAiB,4BAAA;AR2lErB;;AQ1lEI;EAAiB,+BAAA;AR8lErB;;AQ7lEI;EAAiB,6BAAA;ARimErB;;AQhmEI;EAAiB,8BAAA;ARomErB;;AQnmEI;EAAgB,2BAAA;ARumEpB;;AQtmEI;EAAgB,8BAAA;AR0mEpB;;AQzmEI;EAAgB,6BAAA;AR6mEpB;;AQ5mEI;EAAgB,4BAAA;ARgnEpB;;AQznEI;EAAkB,0BAAA;AR6nEtB;;AQ5nEI;EAAkB,0BAAA;ARgoEtB;;AQ/nEI;EAAiB,4BAAA;ARmoErB;;AQloEI;EAAiB,+BAAA;ARsoErB;;AQroEI;EAAiB,6BAAA;ARyoErB;;AQxoEI;EAAiB,8BAAA;AR4oErB;;AQ3oEI;EAAgB,2BAAA;AR+oEpB;;AQ9oEI;EAAgB,8BAAA;ARkpEpB;;AQjpEI;EAAgB,6BAAA;ARqpEpB;;AQppEI;EAAgB,4BAAA;ARwpEpB;;AQjqEI;EAAkB,0BAAA;ARqqEtB;;AQpqEI;EAAkB,0BAAA;ARwqEtB;;AQvqEI;EAAiB,4BAAA;AR2qErB;;AQ1qEI;EAAiB,+BAAA;AR8qErB;;AQ7qEI;EAAiB,6BAAA;ARirErB;;AQhrEI;EAAiB,8BAAA;ARorErB;;AQnrEI;EAAgB,2BAAA;ARurEpB;;AQtrEI;EAAgB,8BAAA;AR0rEpB;;AQzrEI;EAAgB,6BAAA;AR6rEpB;;AQ5rEI;EAAgB,4BAAA;ARgsEpB;;AQzsEI;EAAkB,0BAAA;AR6sEtB;;AQ5sEI;EAAkB,0BAAA;ARgtEtB;;AQ/sEI;EAAiB,4BAAA;ARmtErB;;AQltEI;EAAiB,+BAAA;ARstErB;;AQrtEI;EAAiB,6BAAA;ARytErB;;AQxtEI;EAAiB,8BAAA;AR4tErB;;AQ3tEI;EAAgB,2BAAA;AR+tEpB;;AQ9tEI;EAAgB,8BAAA;ARkuEpB;;AQjuEI;EAAgB,6BAAA;ARquEpB;;AQpuEI;EAAgB,4BAAA;ARwuEpB;;AQjvEI;EAAkB,0BAAA;ARqvEtB;;AQpvEI;EAAkB,0BAAA;ARwvEtB;;AQvvEI;EAAiB,4BAAA;AR2vErB;;AQ1vEI;EAAiB,+BAAA;AR8vErB;;AQ7vEI;EAAiB,6BAAA;ARiwErB;;AQhwEI;EAAiB,8BAAA;ARowErB;;AQnwEI;EAAgB,2BAAA;ARuwEpB;;AQtwEI;EAAgB,8BAAA;AR0wEpB;;AQzwEI;EAAgB,6BAAA;AR6wEpB;;AQ5wEI;EAAgB,4BAAA;ARgxEpB;;AQzxEI;EAAkB,0BAAA;AR6xEtB;;AQ5xEI;EAAkB,0BAAA;ARgyEtB;;AQ/xEI;EAAiB,4BAAA;ARmyErB;;AQlyEI;EAAiB,+BAAA;ARsyErB;;AQryEI;EAAiB,6BAAA;ARyyErB;;AQxyEI;EAAiB,8BAAA;AR4yErB;;AQ3yEI;EAAgB,2BAAA;AR+yEpB;;AQ9yEI;EAAgB,8BAAA;ARkzEpB;;AQjzEI;EAAgB,6BAAA;ARqzEpB;;AQpzEI;EAAgB,4BAAA;ARwzEpB;;AQj0EI;EAAkB,0BAAA;ARq0EtB;;AQp0EI;EAAkB,0BAAA;ARw0EtB;;AQv0EI;EAAiB,4BAAA;AR20ErB;;AQ10EI;EAAiB,+BAAA;AR80ErB;;AQ70EI;EAAiB,6BAAA;ARi1ErB;;AQh1EI;EAAiB,8BAAA;ARo1ErB;;AQn1EI;EAAgB,2BAAA;ARu1EpB;;AQt1EI;EAAgB,8BAAA;AR01EpB;;AQz1EI;EAAgB,6BAAA;AR61EpB;;AQ51EI;EAAgB,4BAAA;ARg2EpB;;AQz2EI;EAAkB,0BAAA;AR62EtB;;AQ52EI;EAAkB,0BAAA;ARg3EtB;;AQ/2EI;EAAiB,4BAAA;ARm3ErB;;AQl3EI;EAAiB,+BAAA;ARs3ErB;;AQr3EI;EAAiB,6BAAA;ARy3ErB;;AQx3EI;EAAiB,8BAAA;AR43ErB;;AQ33EI;EAAgB,2BAAA;AR+3EpB;;AQ93EI;EAAgB,8BAAA;ARk4EpB;;AQj4EI;EAAgB,6BAAA;ARq4EpB;;AQp4EI;EAAgB,4BAAA;ARw4EpB;;AQj5EI;EAAkB,0BAAA;ARq5EtB;;AQp5EI;EAAkB,0BAAA;ARw5EtB;;AQv5EI;EAAiB,4BAAA;AR25ErB;;AQ15EI;EAAiB,+BAAA;AR85ErB;;AQ75EI;EAAiB,6BAAA;ARi6ErB;;AQh6EI;EAAiB,8BAAA;ARo6ErB;;AQn6EI;EAAgB,2BAAA;ARu6EpB;;AQt6EI;EAAgB,8BAAA;AR06EpB;;AQz6EI;EAAgB,6BAAA;AR66EpB;;AQ56EI;EAAgB,4BAAA;ARg7EpB;;AQz7EI;EAAkB,0BAAA;AR67EtB;;AQ57EI;EAAkB,0BAAA;ARg8EtB;;AQ/7EI;EAAiB,4BAAA;ARm8ErB;;AQl8EI;EAAiB,+BAAA;ARs8ErB;;AQr8EI;EAAiB,6BAAA;ARy8ErB;;AQx8EI;EAAiB,8BAAA;AR48ErB;;AQ38EI;EAAgB,2BAAA;AR+8EpB;;AQ98EI;EAAgB,8BAAA;ARk9EpB;;AQj9EI;EAAgB,6BAAA;ARq9EpB;;AQp9EI;EAAgB,4BAAA;ARw9EpB;;AQj+EI;EAAkB,0BAAA;ARq+EtB;;AQp+EI;EAAkB,0BAAA;ARw+EtB;;AQv+EI;EAAiB,4BAAA;AR2+ErB;;AQ1+EI;EAAiB,+BAAA;AR8+ErB;;AQ7+EI;EAAiB,6BAAA;ARi/ErB;;AQh/EI;EAAiB,8BAAA;ARo/ErB;;AQn/EI;EAAgB,2BAAA;ARu/EpB;;AQt/EI;EAAgB,8BAAA;AR0/EpB;;AQz/EI;EAAgB,6BAAA;AR6/EpB;;AQ5/EI;EAAgB,4BAAA;ARggFpB;;AQzgFI;EAAkB,0BAAA;AR6gFtB;;AQ5gFI;EAAkB,0BAAA;ARghFtB;;AQ/gFI;EAAiB,4BAAA;ARmhFrB;;AQlhFI;EAAiB,+BAAA;ARshFrB;;AQrhFI;EAAiB,6BAAA;ARyhFrB;;AQxhFI;EAAiB,8BAAA;AR4hFrB;;AQ3hFI;EAAgB,2BAAA;AR+hFpB;;AQ9hFI;EAAgB,8BAAA;ARkiFpB;;AQjiFI;EAAgB,6BAAA;ARqiFpB;;AQpiFI;EAAgB,4BAAA;ARwiFpB;;AQjjFI;EAAkB,0BAAA;ARqjFtB;;AQpjFI;EAAkB,0BAAA;ARwjFtB;;AQvjFI;EAAiB,4BAAA;AR2jFrB;;AQ1jFI;EAAiB,+BAAA;AR8jFrB;;AQ7jFI;EAAiB,6BAAA;ARikFrB;;AQhkFI;EAAiB,8BAAA;ARokFrB;;AQnkFI;EAAgB,2BAAA;ARukFpB;;AQtkFI;EAAgB,8BAAA;AR0kFpB;;AQzkFI;EAAgB,6BAAA;AR6kFpB;;AQ5kFI;EAAgB,4BAAA;ARglFpB;;AQzlFI;EAAkB,0BAAA;AR6lFtB;;AQ5lFI;EAAkB,0BAAA;ARgmFtB;;AQ/lFI;EAAiB,4BAAA;ARmmFrB;;AQlmFI;EAAiB,+BAAA;ARsmFrB;;AQrmFI;EAAiB,6BAAA;ARymFrB;;AQxmFI;EAAiB,8BAAA;AR4mFrB;;AQ3mFI;EAAgB,2BAAA;AR+mFpB;;AQ9mFI;EAAgB,8BAAA;ARknFpB;;AQjnFI;EAAgB,6BAAA;ARqnFpB;;AQpnFI;EAAgB,4BAAA;ARwnFpB;;AQjoFI;EAAkB,0BAAA;ARqoFtB;;AQpoFI;EAAkB,0BAAA;ARwoFtB;;AQvoFI;EAAiB,4BAAA;AR2oFrB;;AQ1oFI;EAAiB,+BAAA;AR8oFrB;;AQ7oFI;EAAiB,6BAAA;ARipFrB;;AQhpFI;EAAiB,8BAAA;ARopFrB;;AQnpFI;EAAgB,2BAAA;ARupFpB;;AQtpFI;EAAgB,8BAAA;AR0pFpB;;AQzpFI;EAAgB,6BAAA;AR6pFpB;;AQ5pFI;EAAgB,4BAAA;ARgqFpB;;AQzqFI;EAAkB,0BAAA;AR6qFtB;;AQ5qFI;EAAkB,0BAAA;ARgrFtB;;AQ/qFI;EAAiB,4BAAA;ARmrFrB;;AQlrFI;EAAiB,+BAAA;ARsrFrB;;AQrrFI;EAAiB,6BAAA;ARyrFrB;;AQxrFI;EAAiB,8BAAA;AR4rFrB;;AQ3rFI;EAAgB,2BAAA;AR+rFpB;;AQ9rFI;EAAgB,8BAAA;ARksFpB;;AQjsFI;EAAgB,6BAAA;ARqsFpB;;AQpsFI;EAAgB,4BAAA;ARwsFpB;;AQjtFI;EAAkB,2BAAA;ARqtFtB;;AQptFI;EAAkB,2BAAA;ARwtFtB;;AQvtFI;EAAiB,6BAAA;AR2tFrB;;AQ1tFI;EAAiB,gCAAA;AR8tFrB;;AQ7tFI;EAAiB,8BAAA;ARiuFrB;;AQhuFI;EAAiB,+BAAA;ARouFrB;;AQnuFI;EAAgB,4BAAA;ARuuFpB;;AQtuFI;EAAgB,+BAAA;AR0uFpB;;AQzuFI;EAAgB,8BAAA;AR6uFpB;;AQ5uFI;EAAgB,6BAAA;ARgvFpB;;AQzvFI;EAAkB,2BAAA;AR6vFtB;;AQ5vFI;EAAkB,2BAAA;ARgwFtB;;AQ/vFI;EAAiB,6BAAA;ARmwFrB;;AQlwFI;EAAiB,gCAAA;ARswFrB;;AQrwFI;EAAiB,8BAAA;ARywFrB;;AQxwFI;EAAiB,+BAAA;AR4wFrB;;AQ3wFI;EAAgB,4BAAA;AR+wFpB;;AQ9wFI;EAAgB,+BAAA;ARkxFpB;;AQjxFI;EAAgB,8BAAA;ARqxFpB;;AQpxFI;EAAgB,6BAAA;ARwxFpB;;AQjyFI;EAAkB,2BAAA;ARqyFtB;;AQpyFI;EAAkB,2BAAA;ARwyFtB;;AQvyFI;EAAiB,6BAAA;AR2yFrB;;AQ1yFI;EAAiB,gCAAA;AR8yFrB;;AQ7yFI;EAAiB,8BAAA;ARizFrB;;AQhzFI;EAAiB,+BAAA;ARozFrB;;AQnzFI;EAAgB,4BAAA;ARuzFpB;;AQtzFI;EAAgB,+BAAA;AR0zFpB;;AQzzFI;EAAgB,8BAAA;AR6zFpB;;AQ5zFI;EAAgB,6BAAA;ARg0FpB;;AQz0FI;EAAkB,2BAAA;AR60FtB;;AQ50FI;EAAkB,2BAAA;ARg1FtB;;AQ/0FI;EAAiB,6BAAA;ARm1FrB;;AQl1FI;EAAiB,gCAAA;ARs1FrB;;AQr1FI;EAAiB,8BAAA;ARy1FrB;;AQx1FI;EAAiB,+BAAA;AR41FrB;;AQ31FI;EAAgB,4BAAA;AR+1FpB;;AQ91FI;EAAgB,+BAAA;ARk2FpB;;AQj2FI;EAAgB,8BAAA;ARq2FpB;;AQp2FI;EAAgB,6BAAA;ARw2FpB;;AQj3FI;EAAkB,2BAAA;ARq3FtB;;AQp3FI;EAAkB,2BAAA;ARw3FtB;;AQv3FI;EAAiB,6BAAA;AR23FrB;;AQ13FI;EAAiB,gCAAA;AR83FrB;;AQ73FI;EAAiB,8BAAA;ARi4FrB;;AQh4FI;EAAiB,+BAAA;ARo4FrB;;AQn4FI;EAAgB,4BAAA;ARu4FpB;;AQt4FI;EAAgB,+BAAA;AR04FpB;;AQz4FI;EAAgB,8BAAA;AR64FpB;;AQ54FI;EAAgB,6BAAA;ARg5FpB;;AQz5FI;EAAkB,2BAAA;AR65FtB;;AQ55FI;EAAkB,2BAAA;ARg6FtB;;AQ/5FI;EAAiB,6BAAA;ARm6FrB;;AQl6FI;EAAiB,gCAAA;ARs6FrB;;AQr6FI;EAAiB,8BAAA;ARy6FrB;;AQx6FI;EAAiB,+BAAA;AR46FrB;;AQ36FI;EAAgB,4BAAA;AR+6FpB;;AQ96FI;EAAgB,+BAAA;ARk7FpB;;AQj7FI;EAAgB,8BAAA;ARq7FpB;;AQp7FI;EAAgB,6BAAA;ARw7FpB;;AQj8FI;EAAkB,2BAAA;ARq8FtB;;AQp8FI;EAAkB,2BAAA;ARw8FtB;;AQv8FI;EAAiB,6BAAA;AR28FrB;;AQ18FI;EAAiB,gCAAA;AR88FrB;;AQ78FI;EAAiB,8BAAA;ARi9FrB;;AQh9FI;EAAiB,+BAAA;ARo9FrB;;AQn9FI;EAAgB,4BAAA;ARu9FpB;;AQt9FI;EAAgB,+BAAA;AR09FpB;;AQz9FI;EAAgB,8BAAA;AR69FpB;;AQ59FI;EAAgB,6BAAA;ARg+FpB;;AQz+FI;EAAkB,2BAAA;AR6+FtB;;AQ5+FI;EAAkB,2BAAA;ARg/FtB;;AQ/+FI;EAAiB,6BAAA;ARm/FrB;;AQl/FI;EAAiB,gCAAA;ARs/FrB;;AQr/FI;EAAiB,8BAAA;ARy/FrB;;AQx/FI;EAAiB,+BAAA;AR4/FrB;;AQ3/FI;EAAgB,4BAAA;AR+/FpB;;AQ9/FI;EAAgB,+BAAA;ARkgGpB;;AQjgGI;EAAgB,8BAAA;ARqgGpB;;AQpgGI;EAAgB,6BAAA;ARwgGpB;;AQjhGI;EAAkB,2BAAA;ARqhGtB;;AQphGI;EAAkB,2BAAA;ARwhGtB;;AQvhGI;EAAiB,6BAAA;AR2hGrB;;AQ1hGI;EAAiB,gCAAA;AR8hGrB;;AQ7hGI;EAAiB,8BAAA;ARiiGrB;;AQhiGI;EAAiB,+BAAA;ARoiGrB;;AQniGI;EAAgB,4BAAA;ARuiGpB;;AQtiGI;EAAgB,+BAAA;AR0iGpB;;AQziGI;EAAgB,8BAAA;AR6iGpB;;AQ5iGI;EAAgB,6BAAA;ARgjGpB;;AQzjGI;EAAkB,2BAAA;AR6jGtB;;AQ5jGI;EAAkB,2BAAA;ARgkGtB;;AQ/jGI;EAAiB,6BAAA;ARmkGrB;;AQlkGI;EAAiB,gCAAA;ARskGrB;;AQrkGI;EAAiB,8BAAA;ARykGrB;;AQxkGI;EAAiB,+BAAA;AR4kGrB;;AQ3kGI;EAAgB,4BAAA;AR+kGpB;;AQ9kGI;EAAgB,+BAAA;ARklGpB;;AQjlGI;EAAgB,8BAAA;ARqlGpB;;AQplGI;EAAgB,6BAAA;ARwlGpB;;AQjmGI;EAAkB,2BAAA;ARqmGtB;;AQpmGI;EAAkB,2BAAA;ARwmGtB;;AQvmGI;EAAiB,6BAAA;AR2mGrB;;AQ1mGI;EAAiB,gCAAA;AR8mGrB;;AQ7mGI;EAAiB,8BAAA;ARinGrB;;AQhnGI;EAAiB,+BAAA;ARonGrB;;AQnnGI;EAAgB,4BAAA;ARunGpB;;AQtnGI;EAAgB,+BAAA;AR0nGpB;;AQznGI;EAAgB,8BAAA;AR6nGpB;;AQ5nGI;EAAgB,6BAAA;ARgoGpB;;AQzoGI;EAAkB,2BAAA;AR6oGtB;;AQ5oGI;EAAkB,2BAAA;ARgpGtB;;AQ/oGI;EAAiB,6BAAA;ARmpGrB;;AQlpGI;EAAiB,gCAAA;ARspGrB;;AQrpGI;EAAiB,8BAAA;ARypGrB;;AQxpGI;EAAiB,+BAAA;AR4pGrB;;AQ3pGI;EAAgB,4BAAA;AR+pGpB;;AQ9pGI;EAAgB,+BAAA;ARkqGpB;;AQjqGI;EAAgB,8BAAA;ARqqGpB;;AQpqGI;EAAgB,6BAAA;ARwqGpB;;AQjrGI;EAAkB,2BAAA;ARqrGtB;;AQprGI;EAAkB,2BAAA;ARwrGtB;;AQvrGI;EAAiB,6BAAA;AR2rGrB;;AQ1rGI;EAAiB,gCAAA;AR8rGrB;;AQ7rGI;EAAiB,8BAAA;ARisGrB;;AQhsGI;EAAiB,+BAAA;ARosGrB;;AQnsGI;EAAgB,4BAAA;ARusGpB;;AQtsGI;EAAgB,+BAAA;AR0sGpB;;AQzsGI;EAAgB,8BAAA;AR6sGpB;;AQ5sGI;EAAgB,6BAAA;ARgtGpB;;AQztGI;EAAkB,2BAAA;AR6tGtB;;AQ5tGI;EAAkB,2BAAA;ARguGtB;;AQ/tGI;EAAiB,6BAAA;ARmuGrB;;AQluGI;EAAiB,gCAAA;ARsuGrB;;AQruGI;EAAiB,8BAAA;ARyuGrB;;AQxuGI;EAAiB,+BAAA;AR4uGrB;;AQ3uGI;EAAgB,4BAAA;AR+uGpB;;AQ9uGI;EAAgB,+BAAA;ARkvGpB;;AQjvGI;EAAgB,8BAAA;ARqvGpB;;AQpvGI;EAAgB,6BAAA;ARwvGpB;;AQjwGI;EAAkB,2BAAA;ARqwGtB;;AQpwGI;EAAkB,2BAAA;ARwwGtB;;AQvwGI;EAAiB,6BAAA;AR2wGrB;;AQ1wGI;EAAiB,gCAAA;AR8wGrB;;AQ7wGI;EAAiB,8BAAA;ARixGrB;;AQhxGI;EAAiB,+BAAA;ARoxGrB;;AQnxGI;EAAgB,4BAAA;ARuxGpB;;AQtxGI;EAAgB,+BAAA;AR0xGpB;;AQzxGI;EAAgB,8BAAA;AR6xGpB;;AQ5xGI;EAAgB,6BAAA;ARgyGpB;;AQzyGI;EAAkB,2BAAA;AR6yGtB;;AQ5yGI;EAAkB,2BAAA;ARgzGtB;;AQ/yGI;EAAiB,6BAAA;ARmzGrB;;AQlzGI;EAAiB,gCAAA;ARszGrB;;AQrzGI;EAAiB,8BAAA;ARyzGrB;;AQxzGI;EAAiB,+BAAA;AR4zGrB;;AQ3zGI;EAAgB,4BAAA;AR+zGpB;;AQ9zGI;EAAgB,+BAAA;ARk0GpB;;AQj0GI;EAAgB,8BAAA;ARq0GpB;;AQp0GI;EAAgB,6BAAA;ARw0GpB;;AQj1GI;EAAkB,2BAAA;ARq1GtB;;AQp1GI;EAAkB,2BAAA;ARw1GtB;;AQv1GI;EAAiB,6BAAA;AR21GrB;;AQ11GI;EAAiB,gCAAA;AR81GrB;;AQ71GI;EAAiB,8BAAA;ARi2GrB;;AQh2GI;EAAiB,+BAAA;ARo2GrB;;AQn2GI;EAAgB,4BAAA;ARu2GpB;;AQt2GI;EAAgB,+BAAA;AR02GpB;;AQz2GI;EAAgB,8BAAA;AR62GpB;;AQ52GI;EAAgB,6BAAA;ARg3GpB;;AQz3GI;EAAkB,2BAAA;AR63GtB;;AQ53GI;EAAkB,2BAAA;ARg4GtB;;AQ/3GI;EAAiB,6BAAA;ARm4GrB;;AQl4GI;EAAiB,gCAAA;ARs4GrB;;AQr4GI;EAAiB,8BAAA;ARy4GrB;;AQx4GI;EAAiB,+BAAA;AR44GrB;;AQ34GI;EAAgB,4BAAA;AR+4GpB;;AQ94GI;EAAgB,+BAAA;ARk5GpB;;AQj5GI;EAAgB,8BAAA;ARq5GpB;;AQp5GI;EAAgB,6BAAA;ARw5GpB;;AQj6GI;EAAkB,2BAAA;ARq6GtB;;AQp6GI;EAAkB,2BAAA;ARw6GtB;;AQv6GI;EAAiB,6BAAA;AR26GrB;;AQ16GI;EAAiB,gCAAA;AR86GrB;;AQ76GI;EAAiB,8BAAA;ARi7GrB;;AQh7GI;EAAiB,+BAAA;ARo7GrB;;AQn7GI;EAAgB,4BAAA;ARu7GpB;;AQt7GI;EAAgB,+BAAA;AR07GpB;;AQz7GI;EAAgB,8BAAA;AR67GpB;;AQ57GI;EAAgB,6BAAA;ARg8GpB;;AQz8GI;EAAkB,2BAAA;AR68GtB;;AQ58GI;EAAkB,2BAAA;ARg9GtB;;AQ/8GI;EAAiB,6BAAA;ARm9GrB;;AQl9GI;EAAiB,gCAAA;ARs9GrB;;AQr9GI;EAAiB,8BAAA;ARy9GrB;;AQx9GI;EAAiB,+BAAA;AR49GrB;;AQ39GI;EAAgB,4BAAA;AR+9GpB;;AQ99GI;EAAgB,+BAAA;ARk+GpB;;AQj+GI;EAAgB,8BAAA;ARq+GpB;;AQp+GI;EAAgB,6BAAA;ARw+GpB;;AQj/GI;EAAkB,2BAAA;ARq/GtB;;AQp/GI;EAAkB,2BAAA;ARw/GtB;;AQv/GI;EAAiB,6BAAA;AR2/GrB;;AQ1/GI;EAAiB,gCAAA;AR8/GrB;;AQ7/GI;EAAiB,8BAAA;ARigHrB;;AQhgHI;EAAiB,+BAAA;ARogHrB;;AQngHI;EAAgB,4BAAA;ARugHpB;;AQtgHI;EAAgB,+BAAA;AR0gHpB;;AQzgHI;EAAgB,8BAAA;AR6gHpB;;AQ5gHI;EAAgB,6BAAA;ARghHpB;;AQ5gHA;EAEQ;IACI,yBAAA;ER8gHV;EQ3gHM;IACI,yBAAA;ER6gHV;EQ1gHM;IACI,2BAAA;ER4gHV;EQzgHM;IACI,8BAAA;ER2gHV;EQxgHM;IACI,4BAAA;ER0gHV;EQvgHM;IACI,6BAAA;ERygHV;EQtgHM;IACI,0BAAA;ERwgHV;EQrgHM;IACI,6BAAA;ERugHV;EQpiHM;IACI,0BAAA;ERsiHV;EQniHM;IACI,0BAAA;ERqiHV;EQliHM;IACI,4BAAA;ERoiHV;EQjiHM;IACI,+BAAA;ERmiHV;EQhiHM;IACI,6BAAA;ERkiHV;EQ/hHM;IACI,8BAAA;ERiiHV;EQ9hHM;IACI,2BAAA;ERgiHV;EQ7hHM;IACI,8BAAA;ER+hHV;EQ5jHM;IACI,0BAAA;ER8jHV;EQ3jHM;IACI,0BAAA;ER6jHV;EQ1jHM;IACI,4BAAA;ER4jHV;EQzjHM;IACI,+BAAA;ER2jHV;EQxjHM;IACI,6BAAA;ER0jHV;EQvjHM;IACI,8BAAA;ERyjHV;EQtjHM;IACI,2BAAA;ERwjHV;EQrjHM;IACI,8BAAA;ERujHV;EQplHM;IACI,0BAAA;ERslHV;EQnlHM;IACI,0BAAA;ERqlHV;EQllHM;IACI,4BAAA;ERolHV;EQjlHM;IACI,+BAAA;ERmlHV;EQhlHM;IACI,6BAAA;ERklHV;EQ/kHM;IACI,8BAAA;ERilHV;EQ9kHM;IACI,2BAAA;ERglHV;EQ7kHM;IACI,8BAAA;ER+kHV;EQ5mHM;IACI,0BAAA;ER8mHV;EQ3mHM;IACI,0BAAA;ER6mHV;EQ1mHM;IACI,4BAAA;ER4mHV;EQzmHM;IACI,+BAAA;ER2mHV;EQxmHM;IACI,6BAAA;ER0mHV;EQvmHM;IACI,8BAAA;ERymHV;EQtmHM;IACI,2BAAA;ERwmHV;EQrmHM;IACI,8BAAA;ERumHV;EQpoHM;IACI,0BAAA;ERsoHV;EQnoHM;IACI,0BAAA;ERqoHV;EQloHM;IACI,4BAAA;ERooHV;EQjoHM;IACI,+BAAA;ERmoHV;EQhoHM;IACI,6BAAA;ERkoHV;EQ/nHM;IACI,8BAAA;ERioHV;EQ9nHM;IACI,2BAAA;ERgoHV;EQ7nHM;IACI,8BAAA;ER+nHV;EQ5pHM;IACI,0BAAA;ER8pHV;EQ3pHM;IACI,0BAAA;ER6pHV;EQ1pHM;IACI,4BAAA;ER4pHV;EQzpHM;IACI,+BAAA;ER2pHV;EQxpHM;IACI,6BAAA;ER0pHV;EQvpHM;IACI,8BAAA;ERypHV;EQtpHM;IACI,2BAAA;ERwpHV;EQrpHM;IACI,8BAAA;ERupHV;EQprHM;IACI,0BAAA;ERsrHV;EQnrHM;IACI,0BAAA;ERqrHV;EQlrHM;IACI,4BAAA;ERorHV;EQjrHM;IACI,+BAAA;ERmrHV;EQhrHM;IACI,6BAAA;ERkrHV;EQ/qHM;IACI,8BAAA;ERirHV;EQ9qHM;IACI,2BAAA;ERgrHV;EQ7qHM;IACI,8BAAA;ER+qHV;EQ5sHM;IACI,0BAAA;ER8sHV;EQ3sHM;IACI,0BAAA;ER6sHV;EQ1sHM;IACI,4BAAA;ER4sHV;EQzsHM;IACI,+BAAA;ER2sHV;EQxsHM;IACI,6BAAA;ER0sHV;EQvsHM;IACI,8BAAA;ERysHV;EQtsHM;IACI,2BAAA;ERwsHV;EQrsHM;IACI,8BAAA;ERusHV;EQpuHM;IACI,0BAAA;ERsuHV;EQnuHM;IACI,0BAAA;ERquHV;EQluHM;IACI,4BAAA;ERouHV;EQjuHM;IACI,+BAAA;ERmuHV;EQhuHM;IACI,6BAAA;ERkuHV;EQ/tHM;IACI,8BAAA;ERiuHV;EQ9tHM;IACI,2BAAA;ERguHV;EQ7tHM;IACI,8BAAA;ER+tHV;EQ5vHM;IACI,0BAAA;ER8vHV;EQ3vHM;IACI,0BAAA;ER6vHV;EQ1vHM;IACI,4BAAA;ER4vHV;EQzvHM;IACI,+BAAA;ER2vHV;EQxvHM;IACI,6BAAA;ER0vHV;EQvvHM;IACI,8BAAA;ERyvHV;EQtvHM;IACI,2BAAA;ERwvHV;EQrvHM;IACI,8BAAA;ERuvHV;EQpxHM;IACI,0BAAA;ERsxHV;EQnxHM;IACI,0BAAA;ERqxHV;EQlxHM;IACI,4BAAA;ERoxHV;EQjxHM;IACI,+BAAA;ERmxHV;EQhxHM;IACI,6BAAA;ERkxHV;EQ/wHM;IACI,8BAAA;ERixHV;EQ9wHM;IACI,2BAAA;ERgxHV;EQ7wHM;IACI,8BAAA;ER+wHV;EQ5yHM;IACI,0BAAA;ER8yHV;EQ3yHM;IACI,0BAAA;ER6yHV;EQ1yHM;IACI,4BAAA;ER4yHV;EQzyHM;IACI,+BAAA;ER2yHV;EQxyHM;IACI,6BAAA;ER0yHV;EQvyHM;IACI,8BAAA;ERyyHV;EQtyHM;IACI,2BAAA;ERwyHV;EQryHM;IACI,8BAAA;ERuyHV;EQp0HM;IACI,0BAAA;ERs0HV;EQn0HM;IACI,0BAAA;ERq0HV;EQl0HM;IACI,4BAAA;ERo0HV;EQj0HM;IACI,+BAAA;ERm0HV;EQh0HM;IACI,6BAAA;ERk0HV;EQ/zHM;IACI,8BAAA;ERi0HV;EQ9zHM;IACI,2BAAA;ERg0HV;EQ7zHM;IACI,8BAAA;ER+zHV;EQ51HM;IACI,0BAAA;ER81HV;EQ31HM;IACI,0BAAA;ER61HV;EQ11HM;IACI,4BAAA;ER41HV;EQz1HM;IACI,+BAAA;ER21HV;EQx1HM;IACI,6BAAA;ER01HV;EQv1HM;IACI,8BAAA;ERy1HV;EQt1HM;IACI,2BAAA;ERw1HV;EQr1HM;IACI,8BAAA;ERu1HV;EQp3HM;IACI,0BAAA;ERs3HV;EQn3HM;IACI,0BAAA;ERq3HV;EQl3HM;IACI,4BAAA;ERo3HV;EQj3HM;IACI,+BAAA;ERm3HV;EQh3HM;IACI,6BAAA;ERk3HV;EQ/2HM;IACI,8BAAA;ERi3HV;EQ92HM;IACI,2BAAA;ERg3HV;EQ72HM;IACI,8BAAA;ER+2HV;EQ54HM;IACI,0BAAA;ER84HV;EQ34HM;IACI,0BAAA;ER64HV;EQ14HM;IACI,4BAAA;ER44HV;EQz4HM;IACI,+BAAA;ER24HV;EQx4HM;IACI,6BAAA;ER04HV;EQv4HM;IACI,8BAAA;ERy4HV;EQt4HM;IACI,2BAAA;ERw4HV;EQr4HM;IACI,8BAAA;ERu4HV;EQp6HM;IACI,0BAAA;ERs6HV;EQn6HM;IACI,0BAAA;ERq6HV;EQl6HM;IACI,4BAAA;ERo6HV;EQj6HM;IACI,+BAAA;ERm6HV;EQh6HM;IACI,6BAAA;ERk6HV;EQ/5HM;IACI,8BAAA;ERi6HV;EQ95HM;IACI,2BAAA;ERg6HV;EQ75HM;IACI,8BAAA;ER+5HV;EQ57HM;IACI,0BAAA;ER87HV;EQ37HM;IACI,0BAAA;ER67HV;EQ17HM;IACI,4BAAA;ER47HV;EQz7HM;IACI,+BAAA;ER27HV;EQx7HM;IACI,6BAAA;ER07HV;EQv7HM;IACI,8BAAA;ERy7HV;EQt7HM;IACI,2BAAA;ERw7HV;EQr7HM;IACI,8BAAA;ERu7HV;EQp9HM;IACI,2BAAA;ERs9HV;EQn9HM;IACI,2BAAA;ERq9HV;EQl9HM;IACI,6BAAA;ERo9HV;EQj9HM;IACI,gCAAA;ERm9HV;EQh9HM;IACI,8BAAA;ERk9HV;EQ/8HM;IACI,+BAAA;ERi9HV;EQ98HM;IACI,4BAAA;ERg9HV;EQ78HM;IACI,+BAAA;ER+8HV;AACF;AQ18HA;EAEQ;IACI,yBAAA;ER28HV;EQx8HM;IACI,yBAAA;ER08HV;EQv8HM;IACI,2BAAA;ERy8HV;EQt8HM;IACI,8BAAA;ERw8HV;EQp8HM;IACI,2BAAA;ERs8HV;EQl8HM;IACI,6BAAA;ERo8HV;EQj8HM;IACI,4BAAA;ERm8HV;EQh8HM;IACI,6BAAA;ERk8HV;EQ/7HM;IACI,0BAAA;ERi8HV;EQ97HM;IACI,6BAAA;ERg8HV;EQ97HM;IACI,2BAAA;ERg8HV;EQ1+HM;IACI,0BAAA;ER4+HV;EQz+HM;IACI,0BAAA;ER2+HV;EQx+HM;IACI,4BAAA;ER0+HV;EQv+HM;IACI,+BAAA;ERy+HV;EQr+HM;IACI,2BAAA;ERu+HV;EQn+HM;IACI,8BAAA;ERq+HV;EQl+HM;IACI,6BAAA;ERo+HV;EQj+HM;IACI,8BAAA;ERm+HV;EQh+HM;IACI,2BAAA;ERk+HV;EQ/9HM;IACI,8BAAA;ERi+HV;EQ/9HM;IACI,4BAAA;ERi+HV;EQ3gIM;IACI,0BAAA;ER6gIV;EQ1gIM;IACI,0BAAA;ER4gIV;EQzgIM;IACI,4BAAA;ER2gIV;EQxgIM;IACI,+BAAA;ER0gIV;EQtgIM;IACI,2BAAA;ERwgIV;EQpgIM;IACI,8BAAA;ERsgIV;EQngIM;IACI,6BAAA;ERqgIV;EQlgIM;IACI,8BAAA;ERogIV;EQjgIM;IACI,2BAAA;ERmgIV;EQhgIM;IACI,8BAAA;ERkgIV;EQhgIM;IACI,4BAAA;ERkgIV;EQ5iIM;IACI,0BAAA;ER8iIV;EQ3iIM;IACI,0BAAA;ER6iIV;EQ1iIM;IACI,4BAAA;ER4iIV;EQziIM;IACI,+BAAA;ER2iIV;EQviIM;IACI,2BAAA;ERyiIV;EQriIM;IACI,8BAAA;ERuiIV;EQpiIM;IACI,6BAAA;ERsiIV;EQniIM;IACI,8BAAA;ERqiIV;EQliIM;IACI,2BAAA;ERoiIV;EQjiIM;IACI,8BAAA;ERmiIV;EQjiIM;IACI,4BAAA;ERmiIV;EQ7kIM;IACI,0BAAA;ER+kIV;EQ5kIM;IACI,0BAAA;ER8kIV;EQ3kIM;IACI,4BAAA;ER6kIV;EQ1kIM;IACI,+BAAA;ER4kIV;EQxkIM;IACI,2BAAA;ER0kIV;EQtkIM;IACI,8BAAA;ERwkIV;EQrkIM;IACI,6BAAA;ERukIV;EQpkIM;IACI,8BAAA;ERskIV;EQnkIM;IACI,2BAAA;ERqkIV;EQlkIM;IACI,8BAAA;ERokIV;EQlkIM;IACI,4BAAA;ERokIV;EQ9mIM;IACI,0BAAA;ERgnIV;EQ7mIM;IACI,0BAAA;ER+mIV;EQ5mIM;IACI,4BAAA;ER8mIV;EQ3mIM;IACI,+BAAA;ER6mIV;EQzmIM;IACI,2BAAA;ER2mIV;EQvmIM;IACI,8BAAA;ERymIV;EQtmIM;IACI,6BAAA;ERwmIV;EQrmIM;IACI,8BAAA;ERumIV;EQpmIM;IACI,2BAAA;ERsmIV;EQnmIM;IACI,8BAAA;ERqmIV;EQnmIM;IACI,4BAAA;ERqmIV;EQ/oIM;IACI,0BAAA;ERipIV;EQ9oIM;IACI,0BAAA;ERgpIV;EQ7oIM;IACI,4BAAA;ER+oIV;EQ5oIM;IACI,+BAAA;ER8oIV;EQ1oIM;IACI,2BAAA;ER4oIV;EQxoIM;IACI,8BAAA;ER0oIV;EQvoIM;IACI,6BAAA;ERyoIV;EQtoIM;IACI,8BAAA;ERwoIV;EQroIM;IACI,2BAAA;ERuoIV;EQpoIM;IACI,8BAAA;ERsoIV;EQpoIM;IACI,4BAAA;ERsoIV;EQhrIM;IACI,0BAAA;ERkrIV;EQ/qIM;IACI,0BAAA;ERirIV;EQ9qIM;IACI,4BAAA;ERgrIV;EQ7qIM;IACI,+BAAA;ER+qIV;EQ3qIM;IACI,2BAAA;ER6qIV;EQzqIM;IACI,8BAAA;ER2qIV;EQxqIM;IACI,6BAAA;ER0qIV;EQvqIM;IACI,8BAAA;ERyqIV;EQtqIM;IACI,2BAAA;ERwqIV;EQrqIM;IACI,8BAAA;ERuqIV;EQrqIM;IACI,4BAAA;ERuqIV;EQjtIM;IACI,0BAAA;ERmtIV;EQhtIM;IACI,0BAAA;ERktIV;EQ/sIM;IACI,4BAAA;ERitIV;EQ9sIM;IACI,+BAAA;ERgtIV;EQ5sIM;IACI,2BAAA;ER8sIV;EQ1sIM;IACI,8BAAA;ER4sIV;EQzsIM;IACI,6BAAA;ER2sIV;EQxsIM;IACI,8BAAA;ER0sIV;EQvsIM;IACI,2BAAA;ERysIV;EQtsIM;IACI,8BAAA;ERwsIV;EQtsIM;IACI,4BAAA;ERwsIV;EQlvIM;IACI,0BAAA;ERovIV;EQjvIM;IACI,0BAAA;ERmvIV;EQhvIM;IACI,4BAAA;ERkvIV;EQ/uIM;IACI,+BAAA;ERivIV;EQ7uIM;IACI,2BAAA;ER+uIV;EQ3uIM;IACI,8BAAA;ER6uIV;EQ1uIM;IACI,6BAAA;ER4uIV;EQzuIM;IACI,8BAAA;ER2uIV;EQxuIM;IACI,2BAAA;ER0uIV;EQvuIM;IACI,8BAAA;ERyuIV;EQvuIM;IACI,4BAAA;ERyuIV;EQnxIM;IACI,0BAAA;ERqxIV;EQlxIM;IACI,0BAAA;ERoxIV;EQjxIM;IACI,4BAAA;ERmxIV;EQhxIM;IACI,+BAAA;ERkxIV;EQ9wIM;IACI,2BAAA;ERgxIV;EQ5wIM;IACI,8BAAA;ER8wIV;EQ3wIM;IACI,6BAAA;ER6wIV;EQ1wIM;IACI,8BAAA;ER4wIV;EQzwIM;IACI,2BAAA;ER2wIV;EQxwIM;IACI,8BAAA;ER0wIV;EQxwIM;IACI,4BAAA;ER0wIV;EQpzIM;IACI,0BAAA;ERszIV;EQnzIM;IACI,0BAAA;ERqzIV;EQlzIM;IACI,4BAAA;ERozIV;EQjzIM;IACI,+BAAA;ERmzIV;EQ/yIM;IACI,2BAAA;ERizIV;EQ7yIM;IACI,8BAAA;ER+yIV;EQ5yIM;IACI,6BAAA;ER8yIV;EQ3yIM;IACI,8BAAA;ER6yIV;EQ1yIM;IACI,2BAAA;ER4yIV;EQzyIM;IACI,8BAAA;ER2yIV;EQzyIM;IACI,4BAAA;ER2yIV;EQr1IM;IACI,0BAAA;ERu1IV;EQp1IM;IACI,0BAAA;ERs1IV;EQn1IM;IACI,4BAAA;ERq1IV;EQl1IM;IACI,+BAAA;ERo1IV;EQh1IM;IACI,2BAAA;ERk1IV;EQ90IM;IACI,8BAAA;ERg1IV;EQ70IM;IACI,6BAAA;ER+0IV;EQ50IM;IACI,8BAAA;ER80IV;EQ30IM;IACI,2BAAA;ER60IV;EQ10IM;IACI,8BAAA;ER40IV;EQ10IM;IACI,4BAAA;ER40IV;EQt3IM;IACI,0BAAA;ERw3IV;EQr3IM;IACI,0BAAA;ERu3IV;EQp3IM;IACI,4BAAA;ERs3IV;EQn3IM;IACI,+BAAA;ERq3IV;EQj3IM;IACI,2BAAA;ERm3IV;EQ/2IM;IACI,8BAAA;ERi3IV;EQ92IM;IACI,6BAAA;ERg3IV;EQ72IM;IACI,8BAAA;ER+2IV;EQ52IM;IACI,2BAAA;ER82IV;EQ32IM;IACI,8BAAA;ER62IV;EQ32IM;IACI,4BAAA;ER62IV;EQv5IM;IACI,0BAAA;ERy5IV;EQt5IM;IACI,0BAAA;ERw5IV;EQr5IM;IACI,4BAAA;ERu5IV;EQp5IM;IACI,+BAAA;ERs5IV;EQl5IM;IACI,2BAAA;ERo5IV;EQh5IM;IACI,8BAAA;ERk5IV;EQ/4IM;IACI,6BAAA;ERi5IV;EQ94IM;IACI,8BAAA;ERg5IV;EQ74IM;IACI,2BAAA;ER+4IV;EQ54IM;IACI,8BAAA;ER84IV;EQ54IM;IACI,4BAAA;ER84IV;EQx7IM;IACI,0BAAA;ER07IV;EQv7IM;IACI,0BAAA;ERy7IV;EQt7IM;IACI,4BAAA;ERw7IV;EQr7IM;IACI,+BAAA;ERu7IV;EQn7IM;IACI,2BAAA;ERq7IV;EQj7IM;IACI,8BAAA;ERm7IV;EQh7IM;IACI,6BAAA;ERk7IV;EQ/6IM;IACI,8BAAA;ERi7IV;EQ96IM;IACI,2BAAA;ERg7IV;EQ76IM;IACI,8BAAA;ER+6IV;EQ76IM;IACI,4BAAA;ER+6IV;EQz9IM;IACI,0BAAA;ER29IV;EQx9IM;IACI,0BAAA;ER09IV;EQv9IM;IACI,4BAAA;ERy9IV;EQt9IM;IACI,+BAAA;ERw9IV;EQp9IM;IACI,2BAAA;ERs9IV;EQl9IM;IACI,8BAAA;ERo9IV;EQj9IM;IACI,6BAAA;ERm9IV;EQh9IM;IACI,8BAAA;ERk9IV;EQ/8IM;IACI,2BAAA;ERi9IV;EQ98IM;IACI,8BAAA;ERg9IV;EQ98IM;IACI,4BAAA;ERg9IV;EQ1/IM;IACI,0BAAA;ER4/IV;EQz/IM;IACI,0BAAA;ER2/IV;EQx/IM;IACI,4BAAA;ER0/IV;EQv/IM;IACI,+BAAA;ERy/IV;EQr/IM;IACI,2BAAA;ERu/IV;EQn/IM;IACI,8BAAA;ERq/IV;EQl/IM;IACI,6BAAA;ERo/IV;EQj/IM;IACI,8BAAA;ERm/IV;EQh/IM;IACI,2BAAA;ERk/IV;EQ/+IM;IACI,8BAAA;ERi/IV;EQ/+IM;IACI,4BAAA;ERi/IV;EQ3hJM;IACI,0BAAA;ER6hJV;EQ1hJM;IACI,0BAAA;ER4hJV;EQzhJM;IACI,4BAAA;ER2hJV;EQxhJM;IACI,+BAAA;ER0hJV;EQthJM;IACI,2BAAA;ERwhJV;EQphJM;IACI,8BAAA;ERshJV;EQnhJM;IACI,6BAAA;ERqhJV;EQlhJM;IACI,8BAAA;ERohJV;EQjhJM;IACI,2BAAA;ERmhJV;EQhhJM;IACI,8BAAA;ERkhJV;EQhhJM;IACI,4BAAA;ERkhJV;EQ5jJM;IACI,2BAAA;ER8jJV;EQ3jJM;IACI,2BAAA;ER6jJV;EQ1jJM;IACI,6BAAA;ER4jJV;EQzjJM;IACI,gCAAA;ER2jJV;EQvjJM;IACI,2BAAA;ERyjJV;EQrjJM;IACI,+BAAA;ERujJV;EQpjJM;IACI,8BAAA;ERsjJV;EQnjJM;IACI,+BAAA;ERqjJV;EQljJM;IACI,4BAAA;ERojJV;EQjjJM;IACI,+BAAA;ERmjJV;EQjjJM;IACI,6BAAA;ERmjJV;AACF;AQ/iJA;EAEI;IACI,qBAAA;ERgjJN;EQ9iJE;IACI,0BAAA;ERgjJN;EQ9iJE;IACI,2BAAA;ERgjJN;EQ9iJE;IACI,yBAAA;ERgjJN;EQ9iJE;IACI,4BAAA;ERgjJN;EQ9iJE;IACI,0BAAA;ERgjJN;EQ9iJE;IACI,yBAAA;ERgjJN;EQ9iJE;IACI,wBAAA;ERgjJN;EQ9iJE;IACI,2BAAA;ERgjJN;EQ9iJE;IACI,2BAAA;ERgjJN;EQ5iJM;IACI,yBAAA;ER8iJV;EQ3iJM;IACI,yBAAA;ER6iJV;EQ1iJM;IACI,2BAAA;ER4iJV;EQziJM;IACI,8BAAA;ER2iJV;EQxiJM;IACI,4BAAA;ER0iJV;EQviJM;IACI,6BAAA;ERyiJV;EQtiJM;IACI,0BAAA;ERwiJV;EQriJM;IACI,6BAAA;ERuiJV;EQpkJM;IACI,0BAAA;ERskJV;EQnkJM;IACI,0BAAA;ERqkJV;EQlkJM;IACI,4BAAA;ERokJV;EQjkJM;IACI,+BAAA;ERmkJV;EQhkJM;IACI,6BAAA;ERkkJV;EQ/jJM;IACI,8BAAA;ERikJV;EQ9jJM;IACI,2BAAA;ERgkJV;EQ7jJM;IACI,8BAAA;ER+jJV;EQ5lJM;IACI,0BAAA;ER8lJV;EQ3lJM;IACI,0BAAA;ER6lJV;EQ1lJM;IACI,4BAAA;ER4lJV;EQzlJM;IACI,+BAAA;ER2lJV;EQxlJM;IACI,6BAAA;ER0lJV;EQvlJM;IACI,8BAAA;ERylJV;EQtlJM;IACI,2BAAA;ERwlJV;EQrlJM;IACI,8BAAA;ERulJV;EQpnJM;IACI,0BAAA;ERsnJV;EQnnJM;IACI,0BAAA;ERqnJV;EQlnJM;IACI,4BAAA;ERonJV;EQjnJM;IACI,+BAAA;ERmnJV;EQhnJM;IACI,6BAAA;ERknJV;EQ/mJM;IACI,8BAAA;ERinJV;EQ9mJM;IACI,2BAAA;ERgnJV;EQ7mJM;IACI,8BAAA;ER+mJV;EQ5oJM;IACI,0BAAA;ER8oJV;EQ3oJM;IACI,0BAAA;ER6oJV;EQ1oJM;IACI,4BAAA;ER4oJV;EQzoJM;IACI,+BAAA;ER2oJV;EQxoJM;IACI,6BAAA;ER0oJV;EQvoJM;IACI,8BAAA;ERyoJV;EQtoJM;IACI,2BAAA;ERwoJV;EQroJM;IACI,8BAAA;ERuoJV;EQpqJM;IACI,0BAAA;ERsqJV;EQnqJM;IACI,0BAAA;ERqqJV;EQlqJM;IACI,4BAAA;ERoqJV;EQjqJM;IACI,+BAAA;ERmqJV;EQhqJM;IACI,6BAAA;ERkqJV;EQ/pJM;IACI,8BAAA;ERiqJV;EQ9pJM;IACI,2BAAA;ERgqJV;EQ7pJM;IACI,8BAAA;ER+pJV;EQ5rJM;IACI,0BAAA;ER8rJV;EQ3rJM;IACI,0BAAA;ER6rJV;EQ1rJM;IACI,4BAAA;ER4rJV;EQzrJM;IACI,+BAAA;ER2rJV;EQxrJM;IACI,6BAAA;ER0rJV;EQvrJM;IACI,8BAAA;ERyrJV;EQtrJM;IACI,2BAAA;ERwrJV;EQrrJM;IACI,8BAAA;ERurJV;EQptJM;IACI,0BAAA;ERstJV;EQntJM;IACI,0BAAA;ERqtJV;EQltJM;IACI,4BAAA;ERotJV;EQjtJM;IACI,+BAAA;ERmtJV;EQhtJM;IACI,6BAAA;ERktJV;EQ/sJM;IACI,8BAAA;ERitJV;EQ9sJM;IACI,2BAAA;ERgtJV;EQ7sJM;IACI,8BAAA;ER+sJV;EQ5uJM;IACI,0BAAA;ER8uJV;EQ3uJM;IACI,0BAAA;ER6uJV;EQ1uJM;IACI,4BAAA;ER4uJV;EQzuJM;IACI,+BAAA;ER2uJV;EQxuJM;IACI,6BAAA;ER0uJV;EQvuJM;IACI,8BAAA;ERyuJV;EQtuJM;IACI,2BAAA;ERwuJV;EQruJM;IACI,8BAAA;ERuuJV;EQpwJM;IACI,0BAAA;ERswJV;EQnwJM;IACI,0BAAA;ERqwJV;EQlwJM;IACI,4BAAA;ERowJV;EQjwJM;IACI,+BAAA;ERmwJV;EQhwJM;IACI,6BAAA;ERkwJV;EQ/vJM;IACI,8BAAA;ERiwJV;EQ9vJM;IACI,2BAAA;ERgwJV;EQ7vJM;IACI,8BAAA;ER+vJV;EQ5xJM;IACI,0BAAA;ER8xJV;EQ3xJM;IACI,0BAAA;ER6xJV;EQ1xJM;IACI,4BAAA;ER4xJV;EQzxJM;IACI,+BAAA;ER2xJV;EQxxJM;IACI,6BAAA;ER0xJV;EQvxJM;IACI,8BAAA;ERyxJV;EQtxJM;IACI,2BAAA;ERwxJV;EQrxJM;IACI,8BAAA;ERuxJV;EQpzJM;IACI,0BAAA;ERszJV;EQnzJM;IACI,0BAAA;ERqzJV;EQlzJM;IACI,4BAAA;ERozJV;EQjzJM;IACI,+BAAA;ERmzJV;EQhzJM;IACI,6BAAA;ERkzJV;EQ/yJM;IACI,8BAAA;ERizJV;EQ9yJM;IACI,2BAAA;ERgzJV;EQ7yJM;IACI,8BAAA;ER+yJV;EQ50JM;IACI,0BAAA;ER80JV;EQ30JM;IACI,0BAAA;ER60JV;EQ10JM;IACI,4BAAA;ER40JV;EQz0JM;IACI,+BAAA;ER20JV;EQx0JM;IACI,6BAAA;ER00JV;EQv0JM;IACI,8BAAA;ERy0JV;EQt0JM;IACI,2BAAA;ERw0JV;EQr0JM;IACI,8BAAA;ERu0JV;EQp2JM;IACI,0BAAA;ERs2JV;EQn2JM;IACI,0BAAA;ERq2JV;EQl2JM;IACI,4BAAA;ERo2JV;EQj2JM;IACI,+BAAA;ERm2JV;EQh2JM;IACI,6BAAA;ERk2JV;EQ/1JM;IACI,8BAAA;ERi2JV;EQ91JM;IACI,2BAAA;ERg2JV;EQ71JM;IACI,8BAAA;ER+1JV;EQ53JM;IACI,0BAAA;ER83JV;EQ33JM;IACI,0BAAA;ER63JV;EQ13JM;IACI,4BAAA;ER43JV;EQz3JM;IACI,+BAAA;ER23JV;EQx3JM;IACI,6BAAA;ER03JV;EQv3JM;IACI,8BAAA;ERy3JV;EQt3JM;IACI,2BAAA;ERw3JV;EQr3JM;IACI,8BAAA;ERu3JV;EQp5JM;IACI,0BAAA;ERs5JV;EQn5JM;IACI,0BAAA;ERq5JV;EQl5JM;IACI,4BAAA;ERo5JV;EQj5JM;IACI,+BAAA;ERm5JV;EQh5JM;IACI,6BAAA;ERk5JV;EQ/4JM;IACI,8BAAA;ERi5JV;EQ94JM;IACI,2BAAA;ERg5JV;EQ74JM;IACI,8BAAA;ER+4JV;EQ56JM;IACI,0BAAA;ER86JV;EQ36JM;IACI,0BAAA;ER66JV;EQ16JM;IACI,4BAAA;ER46JV;EQz6JM;IACI,+BAAA;ER26JV;EQx6JM;IACI,6BAAA;ER06JV;EQv6JM;IACI,8BAAA;ERy6JV;EQt6JM;IACI,2BAAA;ERw6JV;EQr6JM;IACI,8BAAA;ERu6JV;EQp8JM;IACI,0BAAA;ERs8JV;EQn8JM;IACI,0BAAA;ERq8JV;EQl8JM;IACI,4BAAA;ERo8JV;EQj8JM;IACI,+BAAA;ERm8JV;EQh8JM;IACI,6BAAA;ERk8JV;EQ/7JM;IACI,8BAAA;ERi8JV;EQ97JM;IACI,2BAAA;ERg8JV;EQ77JM;IACI,8BAAA;ER+7JV;EQ59JM;IACI,0BAAA;ER89JV;EQ39JM;IACI,0BAAA;ER69JV;EQ19JM;IACI,4BAAA;ER49JV;EQz9JM;IACI,+BAAA;ER29JV;EQx9JM;IACI,6BAAA;ER09JV;EQv9JM;IACI,8BAAA;ERy9JV;EQt9JM;IACI,2BAAA;ERw9JV;EQr9JM;IACI,8BAAA;ERu9JV;EQp/JM;IACI,2BAAA;ERs/JV;EQn/JM;IACI,2BAAA;ERq/JV;EQl/JM;IACI,6BAAA;ERo/JV;EQj/JM;IACI,gCAAA;ERm/JV;EQh/JM;IACI,8BAAA;ERk/JV;EQ/+JM;IACI,+BAAA;ERi/JV;EQ9+JM;IACI,4BAAA;ERg/JV;EQ7+JM;IACI,+BAAA;ER++JV;AACF;AQ1+JA;EACI;IACI,2BAAA;ER4+JN;EQ1+JE;IACI,qBAAA;ER4+JN;EQ1+JE;IACI,0BAAA;ER4+JN;EQ1+JE;IACI,2BAAA;ER4+JN;EQ1+JE;IACI,yBAAA;ER4+JN;EQ1+JE;IACI,4BAAA;ER4+JN;EQ1+JE;IACI,0BAAA;ER4+JN;EQ1+JE;IACI,yBAAA;ER4+JN;EQ1+JE;IACI,wBAAA;ER4+JN;EQ1+JE;IACI,2BAAA;ER4+JN;EQ1+JE;IACI,6BAAA;ER4+JN;EQ1+JE;IACI,gCAAA;ER4+JN;EQz+JM;IACI,yBAAA;ER2+JV;EQz+JM;IACI,yBAAA;ER2+JV;EQz+JM;IACI,2BAAA;ER2+JV;EQx+JM;IACI,8BAAA;ER0+JV;EQv+JM;IACI,4BAAA;ERy+JV;EQt+JM;IACI,6BAAA;ERw+JV;EQr+JM;IACI,0BAAA;ERu+JV;EQp+JM;IACI,2BAAA;ERs+JV;EQn+JM;IACI,4BAAA;ERq+JV;EQl+JM;IACI,6BAAA;ERo+JV;EQvgKM;IACI,0BAAA;ERygKV;EQvgKM;IACI,0BAAA;ERygKV;EQvgKM;IACI,4BAAA;ERygKV;EQtgKM;IACI,+BAAA;ERwgKV;EQrgKM;IACI,6BAAA;ERugKV;EQpgKM;IACI,8BAAA;ERsgKV;EQngKM;IACI,2BAAA;ERqgKV;EQlgKM;IACI,4BAAA;ERogKV;EQjgKM;IACI,6BAAA;ERmgKV;EQhgKM;IACI,8BAAA;ERkgKV;EQriKM;IACI,0BAAA;ERuiKV;EQriKM;IACI,0BAAA;ERuiKV;EQriKM;IACI,4BAAA;ERuiKV;EQpiKM;IACI,+BAAA;ERsiKV;EQniKM;IACI,6BAAA;ERqiKV;EQliKM;IACI,8BAAA;ERoiKV;EQjiKM;IACI,2BAAA;ERmiKV;EQhiKM;IACI,4BAAA;ERkiKV;EQ/hKM;IACI,6BAAA;ERiiKV;EQ9hKM;IACI,8BAAA;ERgiKV;EQnkKM;IACI,0BAAA;ERqkKV;EQnkKM;IACI,0BAAA;ERqkKV;EQnkKM;IACI,4BAAA;ERqkKV;EQlkKM;IACI,+BAAA;ERokKV;EQjkKM;IACI,6BAAA;ERmkKV;EQhkKM;IACI,8BAAA;ERkkKV;EQ/jKM;IACI,2BAAA;ERikKV;EQ9jKM;IACI,4BAAA;ERgkKV;EQ7jKM;IACI,6BAAA;ER+jKV;EQ5jKM;IACI,8BAAA;ER8jKV;EQjmKM;IACI,0BAAA;ERmmKV;EQjmKM;IACI,0BAAA;ERmmKV;EQjmKM;IACI,4BAAA;ERmmKV;EQhmKM;IACI,+BAAA;ERkmKV;EQ/lKM;IACI,6BAAA;ERimKV;EQ9lKM;IACI,8BAAA;ERgmKV;EQ7lKM;IACI,2BAAA;ER+lKV;EQ5lKM;IACI,4BAAA;ER8lKV;EQ3lKM;IACI,6BAAA;ER6lKV;EQ1lKM;IACI,8BAAA;ER4lKV;EQ/nKM;IACI,0BAAA;ERioKV;EQ/nKM;IACI,0BAAA;ERioKV;EQ/nKM;IACI,4BAAA;ERioKV;EQ9nKM;IACI,+BAAA;ERgoKV;EQ7nKM;IACI,6BAAA;ER+nKV;EQ5nKM;IACI,8BAAA;ER8nKV;EQ3nKM;IACI,2BAAA;ER6nKV;EQ1nKM;IACI,4BAAA;ER4nKV;EQznKM;IACI,6BAAA;ER2nKV;EQxnKM;IACI,8BAAA;ER0nKV;EQ7pKM;IACI,0BAAA;ER+pKV;EQ7pKM;IACI,0BAAA;ER+pKV;EQ7pKM;IACI,4BAAA;ER+pKV;EQ5pKM;IACI,+BAAA;ER8pKV;EQ3pKM;IACI,6BAAA;ER6pKV;EQ1pKM;IACI,8BAAA;ER4pKV;EQzpKM;IACI,2BAAA;ER2pKV;EQxpKM;IACI,4BAAA;ER0pKV;EQvpKM;IACI,6BAAA;ERypKV;EQtpKM;IACI,8BAAA;ERwpKV;EQ3rKM;IACI,0BAAA;ER6rKV;EQ3rKM;IACI,0BAAA;ER6rKV;EQ3rKM;IACI,4BAAA;ER6rKV;EQ1rKM;IACI,+BAAA;ER4rKV;EQzrKM;IACI,6BAAA;ER2rKV;EQxrKM;IACI,8BAAA;ER0rKV;EQvrKM;IACI,2BAAA;ERyrKV;EQtrKM;IACI,4BAAA;ERwrKV;EQrrKM;IACI,6BAAA;ERurKV;EQprKM;IACI,8BAAA;ERsrKV;EQztKM;IACI,0BAAA;ER2tKV;EQztKM;IACI,0BAAA;ER2tKV;EQztKM;IACI,4BAAA;ER2tKV;EQxtKM;IACI,+BAAA;ER0tKV;EQvtKM;IACI,6BAAA;ERytKV;EQttKM;IACI,8BAAA;ERwtKV;EQrtKM;IACI,2BAAA;ERutKV;EQptKM;IACI,4BAAA;ERstKV;EQntKM;IACI,6BAAA;ERqtKV;EQltKM;IACI,8BAAA;ERotKV;EQvvKM;IACI,0BAAA;ERyvKV;EQvvKM;IACI,0BAAA;ERyvKV;EQvvKM;IACI,4BAAA;ERyvKV;EQtvKM;IACI,+BAAA;ERwvKV;EQrvKM;IACI,6BAAA;ERuvKV;EQpvKM;IACI,8BAAA;ERsvKV;EQnvKM;IACI,2BAAA;ERqvKV;EQlvKM;IACI,4BAAA;ERovKV;EQjvKM;IACI,6BAAA;ERmvKV;EQhvKM;IACI,8BAAA;ERkvKV;EQrxKM;IACI,0BAAA;ERuxKV;EQrxKM;IACI,0BAAA;ERuxKV;EQrxKM;IACI,4BAAA;ERuxKV;EQpxKM;IACI,+BAAA;ERsxKV;EQnxKM;IACI,6BAAA;ERqxKV;EQlxKM;IACI,8BAAA;ERoxKV;EQjxKM;IACI,2BAAA;ERmxKV;EQhxKM;IACI,4BAAA;ERkxKV;EQ/wKM;IACI,6BAAA;ERixKV;EQ9wKM;IACI,8BAAA;ERgxKV;EQnzKM;IACI,0BAAA;ERqzKV;EQnzKM;IACI,0BAAA;ERqzKV;EQnzKM;IACI,4BAAA;ERqzKV;EQlzKM;IACI,+BAAA;ERozKV;EQjzKM;IACI,6BAAA;ERmzKV;EQhzKM;IACI,8BAAA;ERkzKV;EQ/yKM;IACI,2BAAA;ERizKV;EQ9yKM;IACI,4BAAA;ERgzKV;EQ7yKM;IACI,6BAAA;ER+yKV;EQ5yKM;IACI,8BAAA;ER8yKV;EQj1KM;IACI,0BAAA;ERm1KV;EQj1KM;IACI,0BAAA;ERm1KV;EQj1KM;IACI,4BAAA;ERm1KV;EQh1KM;IACI,+BAAA;ERk1KV;EQ/0KM;IACI,6BAAA;ERi1KV;EQ90KM;IACI,8BAAA;ERg1KV;EQ70KM;IACI,2BAAA;ER+0KV;EQ50KM;IACI,4BAAA;ER80KV;EQ30KM;IACI,6BAAA;ER60KV;EQ10KM;IACI,8BAAA;ER40KV;EQ/2KM;IACI,0BAAA;ERi3KV;EQ/2KM;IACI,0BAAA;ERi3KV;EQ/2KM;IACI,4BAAA;ERi3KV;EQ92KM;IACI,+BAAA;ERg3KV;EQ72KM;IACI,6BAAA;ER+2KV;EQ52KM;IACI,8BAAA;ER82KV;EQ32KM;IACI,2BAAA;ER62KV;EQ12KM;IACI,4BAAA;ER42KV;EQz2KM;IACI,6BAAA;ER22KV;EQx2KM;IACI,8BAAA;ER02KV;EQ74KM;IACI,0BAAA;ER+4KV;EQ74KM;IACI,0BAAA;ER+4KV;EQ74KM;IACI,4BAAA;ER+4KV;EQ54KM;IACI,+BAAA;ER84KV;EQ34KM;IACI,6BAAA;ER64KV;EQ14KM;IACI,8BAAA;ER44KV;EQz4KM;IACI,2BAAA;ER24KV;EQx4KM;IACI,4BAAA;ER04KV;EQv4KM;IACI,6BAAA;ERy4KV;EQt4KM;IACI,8BAAA;ERw4KV;EQ36KM;IACI,0BAAA;ER66KV;EQ36KM;IACI,0BAAA;ER66KV;EQ36KM;IACI,4BAAA;ER66KV;EQ16KM;IACI,+BAAA;ER46KV;EQz6KM;IACI,6BAAA;ER26KV;EQx6KM;IACI,8BAAA;ER06KV;EQv6KM;IACI,2BAAA;ERy6KV;EQt6KM;IACI,4BAAA;ERw6KV;EQr6KM;IACI,6BAAA;ERu6KV;EQp6KM;IACI,8BAAA;ERs6KV;EQz8KM;IACI,0BAAA;ER28KV;EQz8KM;IACI,0BAAA;ER28KV;EQz8KM;IACI,4BAAA;ER28KV;EQx8KM;IACI,+BAAA;ER08KV;EQv8KM;IACI,6BAAA;ERy8KV;EQt8KM;IACI,8BAAA;ERw8KV;EQr8KM;IACI,2BAAA;ERu8KV;EQp8KM;IACI,4BAAA;ERs8KV;EQn8KM;IACI,6BAAA;ERq8KV;EQl8KM;IACI,8BAAA;ERo8KV;EQv+KM;IACI,0BAAA;ERy+KV;EQv+KM;IACI,0BAAA;ERy+KV;EQv+KM;IACI,4BAAA;ERy+KV;EQt+KM;IACI,+BAAA;ERw+KV;EQr+KM;IACI,6BAAA;ERu+KV;EQp+KM;IACI,8BAAA;ERs+KV;EQn+KM;IACI,2BAAA;ERq+KV;EQl+KM;IACI,4BAAA;ERo+KV;EQj+KM;IACI,6BAAA;ERm+KV;EQh+KM;IACI,8BAAA;ERk+KV;EQrgLM;IACI,0BAAA;ERugLV;EQrgLM;IACI,0BAAA;ERugLV;EQrgLM;IACI,4BAAA;ERugLV;EQpgLM;IACI,+BAAA;ERsgLV;EQngLM;IACI,6BAAA;ERqgLV;EQlgLM;IACI,8BAAA;ERogLV;EQjgLM;IACI,2BAAA;ERmgLV;EQhgLM;IACI,4BAAA;ERkgLV;EQ//KM;IACI,6BAAA;ERigLV;EQ9/KM;IACI,8BAAA;ERggLV;EQniLM;IACI,2BAAA;ERqiLV;EQniLM;IACI,2BAAA;ERqiLV;EQniLM;IACI,6BAAA;ERqiLV;EQliLM;IACI,gCAAA;ERoiLV;EQjiLM;IACI,8BAAA;ERmiLV;EQhiLM;IACI,+BAAA;ERkiLV;EQ/hLM;IACI,4BAAA;ERiiLV;EQ9hLM;IACI,6BAAA;ERgiLV;EQ7hLM;IACI,8BAAA;ER+hLV;EQ5hLM;IACI,+BAAA;ER8hLV;EQ1hLE;IACI,0BAAA;ER4hLN;EQ1hLE;IACI,2BAAA;ER4hLN;EQ1hLE;IACI,yBAAA;ER4hLN;EQ1hLE;IACI,4BAAA;ER4hLN;EQ1hLE;IACI,0BAAA;ER4hLN;EQ1hLE;IACI,yBAAA;ER4hLN;EQ1hLE;IACI,wBAAA;ER4hLN;EQ1hLE;IACI,2BAAA;ER4hLN;AACF;AQvhLA;EAEQ;IACI,yBAAA;ERwhLV;EQthLM;IACI,yBAAA;ERwhLV;EQthLM;IACI,2BAAA;ERwhLV;EQthLM;IACI,8BAAA;ERwhLV;EQthLM;IACI,4BAAA;ERwhLV;EQthLM;IACI,6BAAA;ERwhLV;EQthLM;IACI,0BAAA;ERwhLV;EQthLM;IACI,6BAAA;ERwhLV;EQ9iLM;IACI,0BAAA;ERgjLV;EQ9iLM;IACI,0BAAA;ERgjLV;EQ9iLM;IACI,4BAAA;ERgjLV;EQ9iLM;IACI,+BAAA;ERgjLV;EQ9iLM;IACI,6BAAA;ERgjLV;EQ9iLM;IACI,8BAAA;ERgjLV;EQ9iLM;IACI,2BAAA;ERgjLV;EQ9iLM;IACI,8BAAA;ERgjLV;EQtkLM;IACI,0BAAA;ERwkLV;EQtkLM;IACI,0BAAA;ERwkLV;EQtkLM;IACI,4BAAA;ERwkLV;EQtkLM;IACI,+BAAA;ERwkLV;EQtkLM;IACI,6BAAA;ERwkLV;EQtkLM;IACI,8BAAA;ERwkLV;EQtkLM;IACI,2BAAA;ERwkLV;EQtkLM;IACI,8BAAA;ERwkLV;EQ9lLM;IACI,0BAAA;ERgmLV;EQ9lLM;IACI,0BAAA;ERgmLV;EQ9lLM;IACI,4BAAA;ERgmLV;EQ9lLM;IACI,+BAAA;ERgmLV;EQ9lLM;IACI,6BAAA;ERgmLV;EQ9lLM;IACI,8BAAA;ERgmLV;EQ9lLM;IACI,2BAAA;ERgmLV;EQ9lLM;IACI,8BAAA;ERgmLV;EQtnLM;IACI,0BAAA;ERwnLV;EQtnLM;IACI,0BAAA;ERwnLV;EQtnLM;IACI,4BAAA;ERwnLV;EQtnLM;IACI,+BAAA;ERwnLV;EQtnLM;IACI,6BAAA;ERwnLV;EQtnLM;IACI,8BAAA;ERwnLV;EQtnLM;IACI,2BAAA;ERwnLV;EQtnLM;IACI,8BAAA;ERwnLV;EQ9oLM;IACI,0BAAA;ERgpLV;EQ9oLM;IACI,0BAAA;ERgpLV;EQ9oLM;IACI,4BAAA;ERgpLV;EQ9oLM;IACI,+BAAA;ERgpLV;EQ9oLM;IACI,6BAAA;ERgpLV;EQ9oLM;IACI,8BAAA;ERgpLV;EQ9oLM;IACI,2BAAA;ERgpLV;EQ9oLM;IACI,8BAAA;ERgpLV;EQtqLM;IACI,0BAAA;ERwqLV;EQtqLM;IACI,0BAAA;ERwqLV;EQtqLM;IACI,4BAAA;ERwqLV;EQtqLM;IACI,+BAAA;ERwqLV;EQtqLM;IACI,6BAAA;ERwqLV;EQtqLM;IACI,8BAAA;ERwqLV;EQtqLM;IACI,2BAAA;ERwqLV;EQtqLM;IACI,8BAAA;ERwqLV;EQ9rLM;IACI,0BAAA;ERgsLV;EQ9rLM;IACI,0BAAA;ERgsLV;EQ9rLM;IACI,4BAAA;ERgsLV;EQ9rLM;IACI,+BAAA;ERgsLV;EQ9rLM;IACI,6BAAA;ERgsLV;EQ9rLM;IACI,8BAAA;ERgsLV;EQ9rLM;IACI,2BAAA;ERgsLV;EQ9rLM;IACI,8BAAA;ERgsLV;EQttLM;IACI,0BAAA;ERwtLV;EQttLM;IACI,0BAAA;ERwtLV;EQttLM;IACI,4BAAA;ERwtLV;EQttLM;IACI,+BAAA;ERwtLV;EQttLM;IACI,6BAAA;ERwtLV;EQttLM;IACI,8BAAA;ERwtLV;EQttLM;IACI,2BAAA;ERwtLV;EQttLM;IACI,8BAAA;ERwtLV;EQ9uLM;IACI,0BAAA;ERgvLV;EQ9uLM;IACI,0BAAA;ERgvLV;EQ9uLM;IACI,4BAAA;ERgvLV;EQ9uLM;IACI,+BAAA;ERgvLV;EQ9uLM;IACI,6BAAA;ERgvLV;EQ9uLM;IACI,8BAAA;ERgvLV;EQ9uLM;IACI,2BAAA;ERgvLV;EQ9uLM;IACI,8BAAA;ERgvLV;EQtwLM;IACI,0BAAA;ERwwLV;EQtwLM;IACI,0BAAA;ERwwLV;EQtwLM;IACI,4BAAA;ERwwLV;EQtwLM;IACI,+BAAA;ERwwLV;EQtwLM;IACI,6BAAA;ERwwLV;EQtwLM;IACI,8BAAA;ERwwLV;EQtwLM;IACI,2BAAA;ERwwLV;EQtwLM;IACI,8BAAA;ERwwLV;EQ9xLM;IACI,0BAAA;ERgyLV;EQ9xLM;IACI,0BAAA;ERgyLV;EQ9xLM;IACI,4BAAA;ERgyLV;EQ9xLM;IACI,+BAAA;ERgyLV;EQ9xLM;IACI,6BAAA;ERgyLV;EQ9xLM;IACI,8BAAA;ERgyLV;EQ9xLM;IACI,2BAAA;ERgyLV;EQ9xLM;IACI,8BAAA;ERgyLV;EQtzLM;IACI,0BAAA;ERwzLV;EQtzLM;IACI,0BAAA;ERwzLV;EQtzLM;IACI,4BAAA;ERwzLV;EQtzLM;IACI,+BAAA;ERwzLV;EQtzLM;IACI,6BAAA;ERwzLV;EQtzLM;IACI,8BAAA;ERwzLV;EQtzLM;IACI,2BAAA;ERwzLV;EQtzLM;IACI,8BAAA;ERwzLV;EQ90LM;IACI,0BAAA;ERg1LV;EQ90LM;IACI,0BAAA;ERg1LV;EQ90LM;IACI,4BAAA;ERg1LV;EQ90LM;IACI,+BAAA;ERg1LV;EQ90LM;IACI,6BAAA;ERg1LV;EQ90LM;IACI,8BAAA;ERg1LV;EQ90LM;IACI,2BAAA;ERg1LV;EQ90LM;IACI,8BAAA;ERg1LV;EQt2LM;IACI,0BAAA;ERw2LV;EQt2LM;IACI,0BAAA;ERw2LV;EQt2LM;IACI,4BAAA;ERw2LV;EQt2LM;IACI,+BAAA;ERw2LV;EQt2LM;IACI,6BAAA;ERw2LV;EQt2LM;IACI,8BAAA;ERw2LV;EQt2LM;IACI,2BAAA;ERw2LV;EQt2LM;IACI,8BAAA;ERw2LV;EQ93LM;IACI,0BAAA;ERg4LV;EQ93LM;IACI,0BAAA;ERg4LV;EQ93LM;IACI,4BAAA;ERg4LV;EQ93LM;IACI,+BAAA;ERg4LV;EQ93LM;IACI,6BAAA;ERg4LV;EQ93LM;IACI,8BAAA;ERg4LV;EQ93LM;IACI,2BAAA;ERg4LV;EQ93LM;IACI,8BAAA;ERg4LV;EQt5LM;IACI,0BAAA;ERw5LV;EQt5LM;IACI,0BAAA;ERw5LV;EQt5LM;IACI,4BAAA;ERw5LV;EQt5LM;IACI,+BAAA;ERw5LV;EQt5LM;IACI,6BAAA;ERw5LV;EQt5LM;IACI,8BAAA;ERw5LV;EQt5LM;IACI,2BAAA;ERw5LV;EQt5LM;IACI,8BAAA;ERw5LV;EQ96LM;IACI,0BAAA;ERg7LV;EQ96LM;IACI,0BAAA;ERg7LV;EQ96LM;IACI,4BAAA;ERg7LV;EQ96LM;IACI,+BAAA;ERg7LV;EQ96LM;IACI,6BAAA;ERg7LV;EQ96LM;IACI,8BAAA;ERg7LV;EQ96LM;IACI,2BAAA;ERg7LV;EQ96LM;IACI,8BAAA;ERg7LV;EQt8LM;IACI,0BAAA;ERw8LV;EQt8LM;IACI,0BAAA;ERw8LV;EQt8LM;IACI,4BAAA;ERw8LV;EQt8LM;IACI,+BAAA;ERw8LV;EQt8LM;IACI,6BAAA;ERw8LV;EQt8LM;IACI,8BAAA;ERw8LV;EQt8LM;IACI,2BAAA;ERw8LV;EQt8LM;IACI,8BAAA;ERw8LV;EQ99LM;IACI,2BAAA;ERg+LV;EQ99LM;IACI,2BAAA;ERg+LV;EQ99LM;IACI,6BAAA;ERg+LV;EQ99LM;IACI,gCAAA;ERg+LV;EQ99LM;IACI,8BAAA;ERg+LV;EQ99LM;IACI,+BAAA;ERg+LV;EQ99LM;IACI,4BAAA;ERg+LV;EQ99LM;IACI,+BAAA;ERg+LV;AACF;AQz9LI;EACI,4BAAA;EACA,6BAAA;AR29LR;AQz9LQ;EACI,4BAAA;EACA,6BAAA;AR29LZ;;AQj+LI;EACI,6BAAA;EACA,8BAAA;ARo+LR;AQl+LQ;EACI,6BAAA;EACA,8BAAA;ARo+LZ;;AQ1+LI;EACI,6BAAA;EACA,8BAAA;AR6+LR;AQ3+LQ;EACI,6BAAA;EACA,8BAAA;AR6+LZ;;AQn/LI;EACI,6BAAA;EACA,8BAAA;ARs/LR;AQp/LQ;EACI,6BAAA;EACA,8BAAA;ARs/LZ;;AQ5/LI;EACI,6BAAA;EACA,8BAAA;AR+/LR;AQ7/LQ;EACI,6BAAA;EACA,8BAAA;AR+/LZ;;AQrgMI;EACI,6BAAA;EACA,8BAAA;ARwgMR;AQtgMQ;EACI,6BAAA;EACA,8BAAA;ARwgMZ;;AQ9gMI;EACI,6BAAA;EACA,8BAAA;ARihMR;AQ/gMQ;EACI,6BAAA;EACA,8BAAA;ARihMZ;;AQvhMI;EACI,6BAAA;EACA,8BAAA;AR0hMR;AQxhMQ;EACI,6BAAA;EACA,8BAAA;AR0hMZ;;AQhiMI;EACI,6BAAA;EACA,8BAAA;ARmiMR;AQjiMQ;EACI,6BAAA;EACA,8BAAA;ARmiMZ;;AQziMI;EACI,6BAAA;EACA,8BAAA;AR4iMR;AQ1iMQ;EACI,6BAAA;EACA,8BAAA;AR4iMZ;;AQljMI;EACI,6BAAA;EACA,8BAAA;ARqjMR;AQnjMQ;EACI,6BAAA;EACA,8BAAA;ARqjMZ;;AQ3jMI;EACI,6BAAA;EACA,8BAAA;AR8jMR;AQ5jMQ;EACI,6BAAA;EACA,8BAAA;AR8jMZ;;AQpkMI;EACI,6BAAA;EACA,8BAAA;ARukMR;AQrkMQ;EACI,6BAAA;EACA,8BAAA;ARukMZ;;AQ7kMI;EACI,6BAAA;EACA,8BAAA;ARglMR;AQ9kMQ;EACI,6BAAA;EACA,8BAAA;ARglMZ;;AQtlMI;EACI,6BAAA;EACA,8BAAA;ARylMR;AQvlMQ;EACI,6BAAA;EACA,8BAAA;ARylMZ;;AQ/lMI;EACI,6BAAA;EACA,8BAAA;ARkmMR;AQhmMQ;EACI,6BAAA;EACA,8BAAA;ARkmMZ;;AQxmMI;EACI,6BAAA;EACA,8BAAA;AR2mMR;AQzmMQ;EACI,6BAAA;EACA,8BAAA;AR2mMZ;;AQjnMI;EACI,6BAAA;EACA,8BAAA;ARonMR;AQlnMQ;EACI,6BAAA;EACA,8BAAA;ARonMZ;;AQ1nMI;EACI,6BAAA;EACA,8BAAA;AR6nMR;AQ3nMQ;EACI,6BAAA;EACA,8BAAA;AR6nMZ;;AQnoMI;EACI,8BAAA;EACA,+BAAA;ARsoMR;AQpoMQ;EACI,8BAAA;EACA,+BAAA;ARsoMZ;;ASlmNA;;2BAAA;AAIA,kBAAA;AACA;EACI,+BAAA;ATomNJ;;ASjmNA;EACI,+BAAA;ATomNJ;;ASjmNA;EACI,+BAAA;ATomNJ;;ASjmNA;EACI,+BAAA;ATomNJ;;ASjmNA;EACI,+BAAA;ATomNJ;;ASjmNA;EACI,+BAAA;ATomNJ;;ASjmNA,gBAAA;AAuBA;EACI,2CAAA;AT8kNJ;;AS5kNA;EACI,6CAAA;AT+kNJ;;AS7kNA;EACI,kDAAA;ATglNJ;;AS9kNA;EACI,+CAAA;ATilNJ;;AS7kNA;EACI,yBAAA;ATglNJ;;AS7kNA,WAAA;AAUA,gBAAA;AA8BA,YAAA;AAcA,YAAA;AACA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AT6hNJ;;ASthNA;EACI,uCAAA;ATyhNJ;;ASlhNA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;ATqhNJ;ASnhNI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;ATqhNR;ASnhNQ;EALJ;IAMQ,eAAA;ETshNV;AACF;ASphNQ;EACI,WAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ATshNZ;ASphNY;EACI,6BAAA;ATshNhB;ASnhNY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ATqhNhB;;AS/gNA;EACI,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,iCAAA;ATkhNJ;;AS/gNA;EACI,kCAAA;ATkhNJ;;AS/gNA;EACI,kBAAA;EACA,kBAAA;ATkhNJ;ASjhNI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,QAAA;EACA,2BAAA;ATmhNR;;AS/gNA;EACI,qBAAA;EACA,4BAAA;EACA,sCAAA;ATkhNJ;;AS/gNA;EACI,qBAAA;ATkhNJ;;AS/gNA;EACI,gCAAA;ATkhNJ;;AS/gNA,gBAAA;AACA;EACI,yDAAA;ATkhNJ;ASjhNI;EACI,kBAAA;EACA,WAAA;ATmhNR;ASlhNQ;EACI,UAAA;EACA,YAAA;ATohNZ;ASlhNQ;EACI,UAAA;EACA,SAAA;ATohNZ;ASlhNQ;EACI,UAAA;EACA,YAAA;ATohNZ;ASlhNQ;EACI,aAAA;EACA,aAAA;ATohNZ;ASlhNQ;EACI,aAAA;EACA,SAAA;ATohNZ;ASlhNQ;EACI,aAAA;EACA,YAAA;ATohNZ;;AS9gNA,eAAA;AAEA;EACI,kBAAA;EACA,UAAA;ATghNJ;ASjgNA;EACI;IAEI,6BAAA;ET8gNN;ES3gNE;IAEI,4BAAA;ET6gNN;AACF;AS9/MA;EACI;IAEI,4BAAA;ET0gNN;ESvgNE;IAEI,6BAAA;ETygNN;AACF;AS1/MA;EACI;IAEI,6BAAA;ETsgNN;ESngNE;IAEI,4BAAA;ETqgNN;AACF;ASt/MA;EACI;IAEI,4BAAA;ETkgNN;ES//ME;IAEI,6BAAA;ETigNN;AACF;ASt+MA;EACI;IAEI,uBAAA;ET4/MN;ESz/ME;IAEI,yBAAA;ET2/MN;AACF;ASx/MA;EACI;IAEI,uBAAA;ET0/MN;ESv/ME;IAEI,0BAAA;ETy/MN;AACF;AS3+MA;EACI;IAEI,mBAAA;ETu/MN;ESr/ME;IAEI,qBAAA;ETu/MN;AACF;ASz+MA;EACI;IAEI,mBAAA;ETq/MN;ESn/ME;IAEI,sBAAA;ETq/MN;AACF;AU77NA,qCAAA;AACA;;;;EAIC,0BAAA;AV+7ND;;AU57NA;;;EAGC,WAAA;EACA,gBAAA;AV+7ND;;AU57NA;EACC,YAAA;EACA,eAAA;AV+7ND;;AU57NA;EACC,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EAGA,gBAAA;EACA,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AV+7ND;;AU57NA;EACC,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EAGA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AV+7ND;;AU57NA;;;;;;;;EAQC,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,qDAAA;EACA,4BAAA;EACA,wBAAA;EAEA,sBAAA;AV87ND;AU77NC;;;;;;;;EACC,wBAAA;EACA,YAAA;EACA,UAAA;AVs8NF;AUn8NC;;;;;;;;EACC,4BAAA;EACA,wBAAA;EACA,UAAA;AV48NF;AUz8NC;;;;;;;;EACC,mBAAA;EACA,wBAAA;EACA,UAAA;AVk9NF;AU/8NC;;;;;;;;;;;;;;;;;;;;EACC,kCAAA;EAEA,sBAAA;AVm+NF;AUl+NE;;;;;;;;;;;;;;;;;;;;EACC,2BAAA;EACA,YAAA;EACA,UAAA;AVu/NH;AUp/NE;;;;;;;;;;;;;;;;;;;;EACC,4BAAA;EACA,2BAAA;AVygOH;AUtgOE;;;;;;;;;;;;;;;;;;;;EACC,mBAAA;EACA,2BAAA;AV2hOH;AUvhOC;;;;;;;;;;;;;;;;;;;;EACC,qBAAA;EAEA,sBAAA;AV2iOF;AU1iOE;;;;;;;;;;;;;;;;;;;;EACC,cAAA;EACA,YAAA;EACA,UAAA;AV+jOH;AU5jOE;;;;;;;;;;;;;;;;;;;;EACC,4BAAA;EACA,cAAA;AVilOH;AU9kOE;;;;;;;;;;;;;;;;;;;;EACC,mBAAA;EACA,cAAA;AVmmOH;AUhmOE;;;;;;;;;;;;;;;;;;;;EACC,qBAAA;AVqnOH;AUjnOC;;;;;;;;EACC,kCAAA;AV0nOF;;AUrmOA;;EAEC,UAAA;EACA,kBAAA;AVwmOD;AUtmOC;;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AVymOF;AUxmOE;;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,oBAAA;AV2mOH;AUzmOE;;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AV4mOH;AUtmOG;;EACC,sCAAA;EACA,kCAAA;AVymOJ;AUvmOG;;EACC,UAAA;AV0mOJ;;AUlmOE;EACC,kBAAA;AVqmOH;AUnmOE;EACC,UAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AVqmOH;;AUhmOA;EACC,mBAAA;AVmmOD;AUlmOC;EACC,qDAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AVmmOF;AUjmOE;EACC,kCAAA;AVmmOH;AU/lOC;EACC,iBAAA;EACA,qDAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AVimOF;AU9lOE;EACC,kCAAA;AVgmOH;;AU1lOA;EACC,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sDAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AV6lOD;AU3lOC;EACC,cAAA;EAEA,+CAAA;EAGA,2BAAA;AV6lOF;;AUzlOA;;EAEC,wBAAA;EACA,mCAAA;AV4lOD;;AUzlOA;;EAEC,gBAAA;EACA,mCAAA;AV4lOD;;AUzlOA;;EAEC,WAAA;EACA,mCAAA;AV4lOD;;AUzlOA;;EAEC,gBAAA;EACA,mCAAA;AV4lOD;;AUxlOC;EACC,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AV2lOF;AU1lOE;EACC,WAAA;AV4lOH;AU1lOE;EACC,6BAAA;AV4lOH;;AAh5OA;;uCAAA;AWrBA;;2BAAA;AAME;EACC,cAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;AXw6OH;AWp6OG;EARD;IASE,YAAA;IACA,iBAAA;EXu6OF;AACF;AWj6OG;EACC,YAAA;EACA,iBAAA;AXm6OJ;AW95OC;EACC,kBAAA;AXg6OF;AW75OC;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;AX+5OF;AW55OC;EACC,+BAAA;EACA,eAAA;EACA,WAAA;AX85OF;AW75OE;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,2CAAA;EACA,WAAA;AX+5OH;AW75OI;EACC,YAAA;EACA,iBAAA;AX+5OL;;AWx5OA;;2BAAA;AAIA;EACC,eAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AX05OD;AWx5OC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AX05OF;;AWt5OA;;2BAAA;AAGA;EACC,gBAAA;AXy5OD;AWv5OC;EAHD;IAIE,eAAA;EX05OA;AACF;AWx5OC;EAPD;IAQE,eAAA;EX25OA;AACF;AWz5OC;EAXD;IAYE,eAAA;EX45OA;AACF;AW15OC;EAfD;IAgBE,eAAA;EX65OA;AACF;AW35OC;EACC,aAAA;EACA,mBAAA;AX65OF;;AWz5OA;EACC,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AX45OD;AW35OC;EAbD;IAcE,YAAA;IACA,iBAAA;IACA,WAAA;EX85OA;AACF;;AW35OA;EACC;IACC,4BAAA;EX85OA;EW35OD;IACC,wBAAA;EX65OA;AACF;AY3iPA;;6BAAA;AAII;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;AZ4iPR;AY1iPY;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AZ4iPhB;AY3iPgB;EATJ;IAUQ,eAAA;EZ8iPlB;AACF;AY7iPgB;EAZJ;IAaQ,eAAA;EZgjPlB;AACF;AY/iPgB;EAEI,sCAAA;AZgjPpB;AY5iPQ;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;AZ8iPZ;AY5iPgB;EACI,kBAAA;AZ8iPpB;AY7iPoB;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;AZ+iPxB;AY7iPwB;EATJ;IAUQ,UAAA;EZgjP1B;AACF;AY7iPgB;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,4CAAA;EACA,6CAAA;AZ+iPpB;AY9iPoB;EACI,kBAAA;AZgjPxB;AY/iPwB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,cAAA;AZijP5B;AY/iP4B;EACI,sCAAA;EACA,+BAAA;AZijPhC;AY/iP4B;EACI,sCAAA;EACA,+BAAA;AZijPhC;AY5iPgC;EACI,gBAAA;EACA,sBAAA;AZ8iPpC;AY3iP4B;EACI,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AZ6iPhC;AY1iPgC;EACI,UAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AZ4iPpC;AYriPoB;EACI,UAAA;EACA,mBAAA;EACA,SAAA;AZuiPxB;;Aa7pPA;;0BAAA;AAIA;EACI,aAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;Ab+pPJ;Aa9pPI;EALJ;IAMQ,eAAA;EbiqPN;AACF;AahqPI;EACI,cAAA;AbkqPR;AajqPQ;EAFJ;IAGQ,cAAA;EboqPV;AACF;AanqPQ;;EAEI,UAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AbqqPZ;AapqPY;;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;AbuqPhB;AapqPgB;;EACI,2BAAA;AbuqPpB;;AcvsPA;;iCAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;Ad0sPJ;AczsPI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;Ad2sPR;AczsPQ;EACI,aAAA;EACA,4CAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;Ad2sPZ;AcxsPoB;EACI,gBAAA;EACA,gBAAA;Ad0sPxB;AcpsPgB;EACI,8BAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;AdssPpB;AchsPI;EACI,mBAAA;EACA,UAAA;AdksPR;AcjsPQ;EACI,UAAA;EACA,OAAA;EACA,gBAAA;AdmsPZ;Ac/rPI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AdisPR;AchsPQ;EACI,SAAA;AdksPZ;AcjsPY;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AdmsPhB;AclsPgB;EACI,sCAAA;AdosPpB;AcjsPY;EACI,yCAAA;AdmsPhB;Ac9rPY;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AdgsPhB;Ac9rPoB;EACI,eAAA;AdgsPxB;Ac/rPwB;EACI,sCAAA;AdisP5B;Ac7rPgB;EACI,UAAA;EACA,YAAA;EACA,mBAAA;Ad+rPpB;AczrPY;EACI,kBAAA;Ad2rPhB;Ac1rPgB;EACI,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;Ad4rPpB;AczrPoB;EACI,gBAAA;Ad2rPxB;AcrrPQ;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AdurPZ;AcprPQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AdsrPZ;AcprPgB;EACI,eAAA;AdsrPpB;AcprPgB;EACI,4CAAA;AdsrPpB;Ac7qPwB;EACI,gCAAA;Ad+qP5B;;Aex1PA;;wBAAA;AAIA;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;Af01PJ;Aez1PI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;Af21PR;Aez1PI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;Af21PR;Ae11PQ;EACI,8BAAA;EACA,cAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;Af41PZ;Aex1PI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;Af01PR;Aez1PQ;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;Af21PZ;Ae11PY;EALJ;IAMQ,eAAA;Ef61Pd;AACF;Ae51PY;EARJ;IASQ,eAAA;Ef+1Pd;AACF;Ae91PY;EAXJ;IAYQ,eAAA;Efi2Pd;AACF;Aeh2PY;EAdJ;IAeQ,eAAA;Efm2Pd;AACF;Ael2PY;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;Afo2PhB;Ael2PY;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;EACA,2BAAA;Afo2PhB;Ae/1PI;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;Afi2PR;;AAl6PA;;uCAAA;AgB9BA;;sBAAA;AAGA;EACC,iCAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AhBs8PD;AgBr8PC;EACC,yBAAA;EACA,eAAA;AhBu8PF;;AgBn8PA;EACC,YAAA;AhBs8PD;AgBr8PC;EACC,WAAA;AhBu8PF;;AgBj8PC;;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AhBq8PF;AgBp8PE;;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;AhBu8PH;AgBp8PE;;EACC,kBAAA;EACA,QAAA;EACA,kBAAA;AhBu8PH;AgBp8PE;;EACC,eAAA;EACA,iBAAA;AhBu8PH;AgBp8PE;;EACC,2BAAA;AhBu8PH;AgBt8PG;;EACC,2BAAA;AhBy8PJ;AgBv8PG;;EACC,2BAAA;AhB08PJ;AgBz8PI;;EACC,2BAAA;AhB48PL;AgBt8PG;;EACC,WAAA;EACA,OAAA;EACA,WAAA;AhBy8PJ;;AgBj8PC;;EACC,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,cAAA;AhBo8PF;AgBl8PE;;EACC,kBAAA;EACA,kBAAA;EACA,QAAA;AhBq8PH;AgBl8PE;;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AhBq8PH;AgBp8PG;;EACC,iBAAA;AhBu8PJ;AgBt8PI;;EACC,2BAAA;AhBy8PL;AgBt8PG;;EACC,iBAAA;AhBy8PJ;AgBr8PE;;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AhBw8PH;AgBv8PG;;EACC,iBAAA;AhB08PJ;AgBr8PG;;EACC,eAAA;EACA,mBAAA;AhBw8PJ;AgBp8PE;;EACC,6BAAA;EACA,yBAAA;AhBu8PH;AgBp8PE;;EACC,6BAAA;EACA,yBAAA;AhBu8PH;AgBt8PG;;EACC,yBAAA;EACA,gCAAA;AhBy8PJ;AgBr8PE;;EACC,8BAAA;EACA,2BAAA;AhBw8PH;AgBv8PG;;EACC,yBAAA;EACA,gCAAA;AhB08PJ;AgBt8PE;;EACC,kCAAA;EACA,yBAAA;AhBy8PH;AgBx8PG;;EACC,yBAAA;EACA,gCAAA;AhB28PJ;AgBv8PE;;EACC,kCAAA;EACA,2BAAA;EACA,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AhB08PH;AgBz8PG;;EACC,yBAAA;EACA,gCAAA;EACA,kCAAA;AhB48PJ;AgBx8PE;;EACC,8BAAA;EACA,2BAAA;AhB28PH;AgB18PG;;EACC,yBAAA;EACA,kCAAA;AhB68PJ;AgBz8PE;;EACC,uBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;AhB48PH;;AgBl8PI;;EACC,kCAAA;AhBs8PL;;AgB/7PA;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;AhBk8PD;AgBj8PC;EACC,eAAA;EACA,2BAAA;EACA,qBAAA;AhBm8PF;;AgB/7PA;EACC;IACC,0BAAA;EhBk8PA;AACF;AiB3qQA;;+BAAA;AAKI;EACI,oBAAA;EACA,qBAAA;AjB2qQR;AiB1qQQ;EAHJ;IAIQ,mBAAA;EjB6qQV;AACF;AiB5qQQ;EAEI,aAAA;AjB6qQZ;AiB3qQQ;EACI,yBAAA;AjB6qQZ;AiB3qQQ;EACI,aAAA;AjB6qQZ;;AkBhsQA;;6BAAA;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AlBksQR;AkBhsQI;EACI,gBAAA;EACA,eAAA;AlBksQR;AkBjsQQ;EAHJ;IAIQ,eAAA;ElBosQV;AACF;AkBlsQY;EADJ;IAEQ,aAAA;ElBqsQd;AACF;AkBjsQQ;EACI,yBAAA;AlBmsQZ;AkBjsQQ;EACI,yBAAA;AlBmsQZ;;AmBluQA;;6BAAA;AAKI;EACI,kBAAA;EACA,WAAA;AnBmuQR;AmBluQQ;EACI,SAAA;EACA,YAAA;AnBouQZ;AmBluQQ;EACI,UAAA;EACA,aAAA;EACA,4DAAA;AnBouQZ;AmBluQQ;EACI,YAAA;EACA,aAAA;AnBouQZ;AmBluQQ;EACI,aAAA;EACA,YAAA;EACA,oEAAA;AnBouQZ;;AmB/tQA;;6BAAA;AAGA;EACI,yDAAA;AnBkuQJ;AmBjuQI;EACI,kBAAA;EACA,WAAA;AnBmuQR;AmBluQQ;EACI,QAAA;EACA,YAAA;AnBouQZ;AmBluQQ;EACI,SAAA;EACA,aAAA;AnBouQZ;AmBluQQ;EACI,WAAA;EACA,aAAA;AnBouQZ;AmBluQQ;EACI,aAAA;EACA,WAAA;AnBouQZ;;AmB/tQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBiuQR;AmBhuQQ;EACI,YAAA;EACA,YAAA;EACA,+CAAA;AnBkuQZ;AmBhuQQ;EACI,SAAA;EACA,aAAA;AnBkuQZ;AmBhuQQ;EACI,YAAA;EACA,aAAA;AnBkuQZ;;AmB7tQA;;6BAAA;AAGA;EACI,yDAAA;AnBguQJ;AmB/tQI;EACI,kBAAA;EACA,WAAA;AnBiuQR;AmBhuQQ;EACI,YAAA;EACA,WAAA;AnBkuQZ;AmBhuQQ;EACI,SAAA;EACA,YAAA;AnBkuQZ;;AmB7tQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB+tQR;AmB9tQQ;EACI,UAAA;EACA,WAAA;AnBguQZ;AmB9tQQ;EACI,UAAA;EACA,aAAA;AnBguQZ;AmB9tQQ;EACI,aAAA;EACA,YAAA;AnBguQZ;;AmB3tQA;;6BAAA;AAGA;EACI,yDAAA;EACA,kBAAA;AnB8tQJ;AmB7tQI;EACI,kBAAA;EACA,WAAA;AnB+tQR;AmB9tQQ;EACI,SAAA;EACA,YAAA;EACA,4DAAA;AnBguQZ;AmB9tQQ;EACI,UAAA;EACA,aAAA;EACA,UAAA;AnBguQZ;AmB/tQY;EAJJ;IAKQ,UAAA;IACA,SAAA;EnBkuQd;AACF;AmBjuQY;EARJ;IASQ,aAAA;EnBouQd;AACF;AmBluQQ;EACI,cAAA;EACA,aAAA;AnBouQZ;AmBjuQQ;EACI,aAAA;EACA,YAAA;AnBmuQZ;;AmB7tQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB+tQR;AmB9tQQ;EACI,YAAA;EACA,YAAA;AnBguQZ;AmB9tQQ;EACI,SAAA;EACA,YAAA;AnBguQZ;AmB9tQQ;EACI,aAAA;EACA,aAAA;AnBguQZ;;AmB3tQA;;6BAAA;AAGA;EACI,yDAAA;AnB8tQJ;AmB7tQI;EACI,kBAAA;EACA,WAAA;AnB+tQR;AmB9tQQ;EACI,SAAA;EACA,YAAA;AnBguQZ;AmB9tQQ;EACI,UAAA;EACA,aAAA;AnBguQZ;AmB9tQQ;EACI,aAAA;EACA,aAAA;AnBguQZ;AmB9tQQ;EACI,aAAA;EACA,YAAA;AnBguQZ;AmB3tQQ;EACI,kBAAA;EACA,WAAA;AnB6tQZ;AmB5tQY;EACI,qBAAA;EACA,mBAAA;AnB8tQhB;AmB3tQY;EACI,aAAA;EACA,YAAA;AnB6tQhB;AmB5tQgB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;AnB8tQpB;AmB1tQY;EACI,SAAA;EACA,aAAA;AnB4tQhB;AmB3tQgB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;AnB6tQpB;;AmBttQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBwtQR;AmBvtQQ;EACI,UAAA;EACA,YAAA;EACA,4DAAA;AnBytQZ;AmBvtQQ;EACI,aAAA;EACA,aAAA;AnBytQZ;AmBvtQQ;EACI,aAAA;EACA,YAAA;EACA,kEAAA;AnBytQZ;AmBvtQQ;EACI,aAAA;EACA,WAAA;EACA,yDAAA;AnBytQZ;;AmBptQA;;6BAAA;AAGA;EACI,yDAAA;AnButQJ;AmBttQI;EACI,kBAAA;EACA,WAAA;AnBwtQR;AmBvtQQ;EACI,WAAA;EACA,YAAA;AnBytQZ;AmBvtQQ;EACI,UAAA;EACA,YAAA;AnBytQZ;AmBvtQQ;EACI,aAAA;EACA,YAAA;AnBytQZ;AmBvtQQ;EACI,aAAA;EACA,YAAA;AnBytQZ;AmBrtQQ;EACI,kBAAA;EACA,WAAA;AnButQZ;AmBttQY;EACI,qBAAA;EACA,mBAAA;AnBwtQhB;AmBrtQY;EACI,WAAA;EACA,aAAA;AnButQhB;AmBttQgB;EACI,WAAA;EACA,YAAA;EACA,wCAAA;AnBwtQpB;;AmBjtQA;;6BAAA;AAGA;EACI,yDAAA;AnBotQJ;AmBntQI;EACI,kBAAA;EACA,WAAA;AnBqtQR;AmBptQQ;EACI,aAAA;EACA,YAAA;AnBstQZ;AmBptQQ;EACI,SAAA;EACA,aAAA;AnBstQZ;;AmBjtQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBmtQR;AmBltQQ;EACI,aAAA;EACA,WAAA;AnBotQZ;AmBltQQ;EACI,aAAA;EACA,aAAA;AnBotQZ;;AmB/sQA;;6BAAA;AAGA;EACI,yDAAA;EACA,kBAAA;AnBktQJ;AmBjtQI;EACI,kBAAA;EACA,WAAA;AnBmtQR;AmBltQQ;EACI,UAAA;EACA,YAAA;AnBotQZ;AmBntQY;EACI,cAAA;AnBqtQhB;AmBltQQ;EACI,UAAA;EACA,YAAA;EACA,UAAA;AnBotQZ;AmBltQQ;EACI,UAAA;EACA,YAAA;EACA,UAAA;AnBotQZ;AmBntQY;EAJJ;IAKQ,WAAA;IACA,SAAA;EnBstQd;AACF;AmBptQQ;EACI,aAAA;EACA,aAAA;AnBstQZ;AmBptQQ;EACI,aAAA;EACA,WAAA;AnBstQZ;;AmB/sQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBitQR;AmBhtQQ;EACI,SAAA;EACA,YAAA;AnBktQZ;AmBhtQQ;EACI,aAAA;EACA,YAAA;AnBktQZ;AmBjtQY;EACI,cAAA;AnBmtQhB;AmB9sQQ;EACI,kBAAA;EACA,WAAA;AnBgtQZ;AmB/sQY;EACI,qBAAA;EACA,mBAAA;AnBitQhB;AmB/sQY;EACI,UAAA;EACA,YAAA;AnBitQhB;AmBhtQgB;EACI,YAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;AnBktQpB;;AmB3sQA;;6BAAA;AAGA;EACI,kBAAA;AnB8sQJ;AmB7sQI;EACI,kBAAA;EACA,WAAA;AnB+sQR;AmB9sQQ;EACI,SAAA;EACA,aAAA;AnBgtQZ;AmB9sQQ;EACI,YAAA;EACA,aAAA;AnBgtQZ;;AmB3sQA;;6BAAA;AAGA;EACI,yDAAA;AnB8sQJ;AmB7sQI;EACI,kBAAA;EACA,WAAA;AnB+sQR;AmB9sQQ;EAII,WAAA;EACA,YAAA;EACA,yDAAA;AnB6sQZ;AmBltQY;EACI,wBAAA;AnBotQhB;AmB9sQQ;EACI,UAAA;EACA,YAAA;EACA,oEAAA;AnBgtQZ;AmB9sQQ;EACI,UAAA;EACA,aAAA;EACA,4DAAA;AnBgtQZ;AmB9sQQ;EACI,YAAA;EACA,aAAA;AnBgtQZ;AmB9sQQ;EACI,aAAA;EACA,YAAA;AnBgtQZ;;AmB3sQA;;6BAAA;AAGA;EACI,yDAAA;EACA,qBAAA;EACA,4BAAA;EACA,sCAAA;AnB8sQJ;AmB7sQI;EACI,kBAAA;EACA,WAAA;AnB+sQR;AmB9sQQ;EACI,UAAA;EACA,aAAA;AnBgtQZ;AmB9sQQ;EACI,aAAA;EACA,YAAA;AnBgtQZ;AmB9sQQ;EACI,aAAA;EACA,YAAA;AnBgtQZ;;AmB3sQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB6sQR;AmB5sQQ;EACI,eAAA;EACA,YAAA;EACA,SAAA;AnB8sQZ;AmB5sQQ;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;AnB8sQZ;AmB1sQQ;EACI,kBAAA;EACA,WAAA;AnB4sQZ;AmB3sQY;EACI,qBAAA;EACA,mBAAA;AnB6sQhB;AmB3sQY;EACI,UAAA;EACA,WAAA;AnB6sQhB;AmB5sQgB;EACI,YAAA;EACA,aAAA;EACA,yCAAA;AnB8sQpB;;AmBvsQA;;6BAAA;AAGA;EACI,0DAAA;AnB0sQJ;AmBzsQI;EACI,kBAAA;EACA,WAAA;AnB2sQR;AmB1sQQ;EACI,YAAA;EACA,SAAA;EACA,4DAAA;AnB4sQZ;AmB1sQQ;EACI,UAAA;EACA,aAAA;AnB4sQZ;AmB1sQQ;EACI,aAAA;EACA,WAAA;AnB4sQZ;AmB1sQQ;EACI,aAAA;EACA,aAAA;AnB4sQZ;;AmBvsQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBysQR;AmBxsQQ;EACI,YAAA;EACA,SAAA;AnB0sQZ;AmBxsQQ;EACI,UAAA;EACA,aAAA;AnB0sQZ;AmBxsQQ;EACI,aAAA;EACA,aAAA;AnB0sQZ;AmBxsQQ;EACI,aAAA;EACA,YAAA;AnB0sQZ;;AmBrsQA;;6BAAA;AAGA;EACI,0DAAA;AnBwsQJ;AmBvsQI;EACI,kBAAA;EACA,WAAA;AnBysQR;AmBxsQQ;EACI,WAAA;EACA,UAAA;EACA,4DAAA;AnB0sQZ;AmBxsQQ;EACI,SAAA;EACA,YAAA;AnB0sQZ;AmBxsQQ;EACI,aAAA;EACA,cAAA;AnB0sQZ;AmBxsQQ;EACI,WAAA;EACA,aAAA;AnB0sQZ;;AmBrsQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBusQR;AmBtsQQ;EACI,SAAA;EACA,YAAA;EACA,8CAAA;AnBwsQZ;AmBtsQQ;EACI,SAAA;EACA,aAAA;AnBwsQZ;AmBtsQQ;EACI,aAAA;EACA,YAAA;AnBwsQZ;AmBtsQQ;EACI,aAAA;EACA,WAAA;AnBwsQZ;;AmBnsQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBqsQR;AmBpsQQ;EACI,aAAA;EACA,YAAA;AnBssQZ;AmBpsQQ;EACI,UAAA;EACA,aAAA;AnBssQZ;AmBpsQQ;EACI,YAAA;EACA,aAAA;AnBssQZ;AmBlsQQ;EACI,kBAAA;EACA,WAAA;AnBosQZ;AmBnsQY;EACI,qBAAA;EACA,mBAAA;AnBqsQhB;AmBnsQY;EACI,aAAA;EACA,WAAA;EACA,UAAA;AnBqsQhB;AmBpsQgB;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,8CAAA;AnBssQpB;;AmB/rQA;;6BAAA;AAGA;EACI,0DAAA;AnBksQJ;AmBjsQI;EACI,kBAAA;EACA,WAAA;AnBmsQR;AmBlsQQ;EACI,QAAA;EACA,YAAA;AnBosQZ;AmBlsQQ;EACI,SAAA;EACA,aAAA;AnBosQZ;AmBlsQQ;EACI,YAAA;EACA,aAAA;AnBosQZ;AmBlsQQ;EACI,YAAA;EACA,YAAA;EACA,4DAAA;AnBosQZ;AmBhsQQ;EACI,kBAAA;EACA,WAAA;AnBksQZ;AmBjsQY;EACI,qBAAA;EACA,mBAAA;AnBmsQhB;AmBjsQY;EACI,YAAA;EACA,aAAA;AnBmsQhB;AmBlsQgB;EACI,WAAA;EACA,YAAA;EACA,2CAAA;EACA,8CAAA;AnBosQpB;;AmB7rQA;;6BAAA;AAGA;EACI,0DAAA;AnBgsQJ;AmB/rQI;EAFJ;IAGQ,sBAAA;EnBksQN;AACF;AmBjsQI;EACI,kBAAA;EACA,WAAA;AnBmsQR;AmBlsQQ;EACI,UAAA;EACA,WAAA;AnBosQZ;AmBlsQQ;EACI,aAAA;EACA,WAAA;AnBosQZ;;AmB/rQA;;6BAAA;AAGA;EACI,sBAAA;EACA,0DAAA;AnBksQJ;AmBjsQI;EAHJ;IAIQ,qBAAA;EnBosQN;AACF;AmBnsQI;EACI,kBAAA;EACA,WAAA;AnBqsQR;AmBpsQQ;EACI,SAAA;EACA,YAAA;EACA,2DAAA;AnBssQZ;AmBpsQQ;EACI,UAAA;EACA,aAAA;AnBssQZ;AmBpsQQ;EACI,aAAA;EACA,aAAA;AnBssQZ;;AmBjsQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBmsQR;AmBlsQQ;EACI,WAAA;EACA,YAAA;AnBosQZ;AmBlsQQ;EACI,QAAA;EACA,aAAA;AnBosQZ;AmBlsQQ;EACI,WAAA;EACA,aAAA;AnBosQZ;;AmB/rQA;;6BAAA;AAGA;EACI,0DAAA;AnBksQJ;AmBjsQI;EACI,kBAAA;EACA,WAAA;AnBmsQR;AmBlsQQ;EACI,QAAA;EACA,YAAA;AnBosQZ;AmBlsQQ;EACI,aAAA;EACA,YAAA;AnBosQZ;AmBlsQQ;EACI,aAAA;EACA,WAAA;AnBosQZ;;AmB/rQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBisQR;AmBhsQQ;EACI,SAAA;EACA,WAAA;EACA,yDAAA;AnBksQZ;AmBjsQY;EACI,wBAAA;AnBmsQhB;AmBhsQQ;EACI,SAAA;EACA,aAAA;AnBksQZ;AmBhsQQ;EACI,YAAA;EACA,aAAA;EACA,4DAAA;AnBksQZ;AmB9rQQ;EACI,kBAAA;EACA,WAAA;AnBgsQZ;AmB/rQY;EACI,qBAAA;EACA,mBAAA;AnBisQhB;AmB/rQY;EACI,YAAA;EACA,YAAA;AnBisQhB;AmBhsQgB;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,gDAAA;AnBksQpB;;AmB1rQA;;6BAAA;AAGA;EACI,0DAAA;AnB6rQJ;AmB5rQI;EACI,kBAAA;EACA,WAAA;AnB8rQR;AmB7rQQ;EACI,UAAA;EACA,WAAA;AnB+rQZ;AmB7rQQ;EACI,UAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,UAAA;EACA,WAAA;AnB+rQZ;AmB7rQQ;EACI,aAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,UAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,aAAA;EACA,YAAA;AnB+rQZ;;AmB1rQA;;6BAAA;AAGA;EACI,0DAAA;AnB6rQJ;AmB5rQI;EACI,kBAAA;EACA,WAAA;AnB8rQR;AmB7rQQ;EACI,SAAA;EACA,YAAA;AnB+rQZ;AmB7rQQ;EACI,UAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,aAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,cAAA;EACA,aAAA;AnB+rQZ;AmB7rQQ;EACI,aAAA;EACA,WAAA;AnB+rQZ;AmB7rQQ;EACI,UAAA;EACA,OAAA;AnB+rQZ;;AmB1rQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB4rQR;AmB3rQQ;EACI,UAAA;EACA,WAAA;AnB6rQZ;AmB3rQQ;EACI,SAAA;EACA,YAAA;AnB6rQZ;AmB3rQQ;EACI,YAAA;EACA,aAAA;AnB6rQZ;;AmBxrQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB0rQR;AmBzrQQ;EACI,aAAA;EACA,YAAA;AnB2rQZ;AmBzrQQ;EACI,YAAA;EACA,UAAA;AnB2rQZ;AmBzrQQ;EACI,MAAA;EACA,aAAA;AnB2rQZ;AmBzrQQ;EACI,WAAA;EACA,aAAA;AnB2rQZ;;AmBrrQI;EACI,kBAAA;EACA,WAAA;AnBwrQR;AmBvrQQ;EACI,SAAA;EACA,WAAA;AnByrQZ;AmBvrQQ;EACI,UAAA;EACA,aAAA;AnByrQZ;AmBvrQQ;EACI,aAAA;EACA,aAAA;AnByrQZ;AmBvrQQ;EACI,aAAA;EACA,WAAA;AnByrQZ;AmBvrQQ;EACI,aAAA;EACA,YAAA;AnByrQZ;;AmBnrQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBqrQR;AmBprQQ;EACI,UAAA;EACA,YAAA;EACA,4DAAA;AnBsrQZ;AmBlrQQ;EACI,kBAAA;EACA,WAAA;AnBorQZ;AmBnrQY;EACI,qBAAA;EACA,mBAAA;AnBqrQhB;AmBnrQY;EACI,YAAA;EACA,YAAA;AnBqrQhB;AmBprQgB;EACI,YAAA;EACA,aAAA;EACA,2CAAA;AnBsrQpB;;AmB/qQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBirQR;AmBhrQQ;EACI,SAAA;EACA,YAAA;EACA,4DAAA;AnBkrQZ;AmBhrQQ;EACI,SAAA;EACA,aAAA;AnBkrQZ;AmBhrQQ;EACI,YAAA;EACA,UAAA;AnBkrQZ;AmB9qQQ;EACI,kBAAA;EACA,WAAA;AnBgrQZ;AmB/qQY;EACI,qBAAA;EACA,mBAAA;AnBirQhB;AmB/qQY;EACI,YAAA;EACA,YAAA;AnBirQhB;AmBhrQgB;EACI,YAAA;EACA,aAAA;EACA,2CAAA;AnBkrQpB;;AmB3qQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB6qQR;AmB5qQQ;EACI,SAAA;EACA,WAAA;AnB8qQZ;AmB5qQQ;EACI,SAAA;EACA,aAAA;AnB8qQZ;AmB5qQQ;EACI,aAAA;EACA,aAAA;AnB8qQZ;AmB5qQQ;EACI,YAAA;EACA,YAAA;AnB8qQZ;AmB5qQQ;EACI,UAAA;EACA,YAAA;AnB8qQZ;;AmBzqQA;;6BAAA;AAGA;EACI,0DAAA;AnB4qQJ;AmB3qQI;EACI,kBAAA;EACA,WAAA;AnB6qQR;AmB5qQQ;EACI,UAAA;EACA,YAAA;AnB8qQZ;AmB5qQQ;EACI,SAAA;EACA,aAAA;EACA,4DAAA;AnB8qQZ;AmB5qQQ;EACI,aAAA;EACA,aAAA;AnB8qQZ;AmB5qQQ;EACI,aAAA;EACA,YAAA;AnB8qQZ;;AmBzqQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB2qQR;AmB1qQQ;EACI,UAAA;EACA,WAAA;AnB4qQZ;AmB1qQQ;EACI,SAAA;EACA,aAAA;AnB4qQZ;AmB1qQQ;EACI,YAAA;EACA,aAAA;AnB4qQZ;AmB1qQQ;EACI,YAAA;EACA,YAAA;AnB4qQZ;;AmBvqQA;;6BAAA;AAGA;EACI,0DAAA;AnB0qQJ;AmBzqQI;EACI,kBAAA;EACA,WAAA;AnB2qQR;AmB1qQQ;EACI,UAAA;EACA,YAAA;EACA,yDAAA;AnB4qQZ;AmB1qQQ;EACI,aAAA;EACA,aAAA;EACA,0DAAA;AnB4qQZ;AmB1qQQ;EACI,aAAA;EACA,YAAA;AnB4qQZ;;AmBvqQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnByqQR;AmBxqQQ;EACI,SAAA;EACA,aAAA;AnB0qQZ;AmBvqQQ;EACI,aAAA;EACA,aAAA;AnByqQZ;AmBvqQQ;EACI,aAAA;EACA,YAAA;AnByqQZ;;AmBpqQA;;6BAAA;AAGA;EACI,0DAAA;EACA,kBAAA;AnBuqQJ;AmBtqQI;EACI,kBAAA;EACA,WAAA;AnBwqQR;AmBvqQQ;EACI,SAAA;EACA,YAAA;EACA,4DAAA;AnByqQZ;AmBvqQQ;EACI,UAAA;EACA,WAAA;EACA,UAAA;AnByqQZ;AmBxqQY;EAJJ;IAKQ,SAAA;IACA,WAAA;EnB2qQd;AACF;AmBzqQQ;EACI,YAAA;EACA,aAAA;AnB2qQZ;AmBzqQQ;EACI,aAAA;EACA,WAAA;AnB2qQZ;;AmBtqQA;;6BAAA;AAGA;EACI,kBAAA;AnByqQJ;AmBxqQI;EACI,kBAAA;EACA,WAAA;AnB0qQR;AmBzqQQ;EACI,UAAA;EACA,YAAA;EACA,4DAAA;AnB2qQZ;AmBzqQQ;EACI,UAAA;EACA,YAAA;AnB2qQZ;AmBzqQQ;EACI,YAAA;EACA,aAAA;AnB2qQZ;;AmBtqQA;;6BAAA;AAGA;EACI,kBAAA;EACA,0DAAA;AnByqQJ;AmBxqQI;EACI,kBAAA;EACA,WAAA;AnB0qQR;AmBzqQQ;EACI,SAAA;EACA,YAAA;AnB2qQZ;AmBzqQQ;EACI,UAAA;EACA,WAAA;EACA,UAAA;AnB2qQZ;AmB1qQY;EAJJ;IAKQ,WAAA;IACA,SAAA;EnB6qQd;AACF;AmB3qQQ;EACI,aAAA;EACA,aAAA;AnB6qQZ;AmB1qQQ;EACI,aAAA;EACA,YAAA;EACA,oEAAA;AnB4qQZ;;AmBtqQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBwqQR;AmBvqQQ;EACI,YAAA;EACA,WAAA;AnByqQZ;AmBvqQQ;EACI,SAAA;EACA,aAAA;AnByqQZ;AmBrqQQ;EACI,kBAAA;EACA,WAAA;AnBuqQZ;AmBtqQY;EACI,qBAAA;EACA,mBAAA;AnBwqQhB;AmBtqQY;EACI,aAAA;EACA,WAAA;AnBwqQhB;AmBvqQgB;EACI,YAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;AnByqQpB;AmBtqQY;EACI,SAAA;EACA,YAAA;AnBwqQhB;AmBvqQgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;AnByqQpB;AmBtqQY;EACI,aAAA;EACA,YAAA;AnBwqQhB;AmBvqQgB;EACI,UAAA;EACA,WAAA;EACA,kCAAA;EACA,8CAAA;AnByqQpB;;AmBlqQA;;mCAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBoqQR;AmBnqQQ;EACI,SAAA;EACA,YAAA;EACA,8CAAA;AnBqqQZ;AmBnqQQ;EACI,aAAA;EACA,YAAA;AnBqqQZ;;AmB/pQI;EACI,kBAAA;EACA,WAAA;AnBkqQR;AmBjqQQ;EACI,YAAA;EACA,YAAA;EACA,2DAAA;AnBmqQZ;AmBjqQQ;EACI,YAAA;EACA,aAAA;EACA,8CAAA;AnBmqQZ;;AmB9pQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBgqQR;AmB/pQQ;EACI,WAAA;EACA,YAAA;AnBiqQZ;AmB/pQQ;EACI,SAAA;EACA,YAAA;AnBiqQZ;AmB/pQQ;EACI,aAAA;EACA,WAAA;AnBiqQZ;AmB7pQQ;EACI,kBAAA;EACA,WAAA;AnB+pQZ;AmB9pQY;EACI,qBAAA;EACA,mBAAA;AnBgqQhB;AmB9pQY;EACI,WAAA;EACA,aAAA;AnBgqQhB;AmB/pQgB;EACI,WAAA;EACA,YAAA;EACA,yCAAA;EACA,8CAAA;AnBiqQpB;;AmBzpQA;;6BAAA;AAGA;EACI,0DAAA;AnB4pQJ;AmB3pQI;EACI,kBAAA;EACA,WAAA;AnB6pQR;AmB5pQQ;EACI,UAAA;EACA,WAAA;AnB8pQZ;AmB5pQQ;EACI,SAAA;EACA,aAAA;AnB8pQZ;AmB5pQQ;EACI,YAAA;EACA,aAAA;AnB8pQZ;AmB5pQQ;EACI,YAAA;EACA,YAAA;AnB8pQZ;;AmBzpQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnB2pQR;AmB1pQQ;EACI,UAAA;EACA,WAAA;AnB4pQZ;AmBxpQQ;EACI,kBAAA;EACA,WAAA;AnB0pQZ;AmBzpQY;EACI,qBAAA;EACA,mBAAA;AnB2pQhB;AmBzpQY;EACI,SAAA;EACA,WAAA;AnB2pQhB;AmB1pQgB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AnB4pQpB;AmBzpQY;EACI,UAAA;EACA,YAAA;AnB2pQhB;AmB1pQgB;EACI,YAAA;EACA,aAAA;EACA,mCAAA;AnB4pQpB;;AmBrpQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBupQR;AmBtpQQ;EACI,SAAA;EACA,WAAA;AnBwpQZ;AmBtpQQ;EACI,QAAA;EACA,aAAA;AnBwpQZ;AmBtpQQ;EACI,aAAA;EACA,aAAA;AnBwpQZ;AmBtpQQ;EACI,aAAA;EACA,YAAA;AnBwpQZ;;AmBnpQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBqpQR;AmBppQQ;EACI,UAAA;EACA,YAAA;EACA,2DAAA;AnBspQZ;AmBrpQY;EACI,wBAAA;AnBupQhB;AmBppQQ;EACI,QAAA;EACA,aAAA;EACA,mEAAA;AnBspQZ;AmBrpQY;EACI,wBAAA;AnBupQhB;;AmBjpQA;;6BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnBmpQR;AmBlpQQ;EACI,YAAA;EACA,SAAA;EACA,4DAAA;AnBopQZ;AmBlpQQ;EACI,UAAA;EACA,aAAA;AnBopQZ;AmBlpQQ;EACI,aAAA;EACA,WAAA;AnBopQZ;AmBhpQQ;EACI,kBAAA;EACA,WAAA;AnBkpQZ;AmBjpQY;EACI,qBAAA;EACA,mBAAA;AnBmpQhB;AmBjpQY;EACI,aAAA;EACA,aAAA;AnBmpQhB;AmBlpQgB;EACI,WAAA;EACA,YAAA;EACA,0BAAA;AnBopQpB;;AmB7oQA;EAEI,eAAA;EACA,sBAAA;EACA,uBAAA;AnBgpQJ;;AmB7oQA;EAEI,gDAAA;AnBgpQJ;AmBvoQA;EACI;IACE,oBAAA;EnB+oQJ;AACF;AoBzxTA;;8BAAA;AAIA;EACI,cAAA;ApB0xTJ;;AoBvxTA;EACI,6BAAA;ApB0xTJ;AoBzxTI;EAFJ;IAGQ,4BAAA;EpB4xTN;AACF;AoB3xTI;EALJ;IAMQ,4BAAA;EpB8xTN;AACF;;AoB3xTA;EACI,kBAAA;EACA,UAAA;ApB8xTJ;AoB5xTI;EACI,qBAAA;ApB8xTR;AoB7xTQ;EAFJ;IAGQ,gBAAA;EpBgyTV;AACF;AoB/xTQ;EALJ;IAMQ,gBAAA;EpBkyTV;AACF;;AoB5xTA;EACI,cAAA;ApB+xTJ;AoB9xTI;EACI,aAAA;EACA,qBAAA;ApBgyTR;AoB9xTI;EACI,gBAAA;ApBgyTR;AoB7xTI;EACI,gBAAA;EACA,6BAAA;ApB+xTR;AoB5xTI;EACI,YAAA;ApB8xTR;AoB7xTQ;EACI,WAAA;ApB+xTZ;AoB5xTQ;EACI,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;ApB8xTZ;AoB1xTI;EACI,cAAA;ApB4xTR;AoB3xTQ;EACI,aAAA;ApB6xTZ;AoB3xTQ;EACI,gBAAA;EACA,eAAA;EACA,2BAAA;ApB6xTZ;AoB3xTQ;EACI,gBAAA;ApB6xTZ;AoBzxTI;EACI,YAAA;ApB2xTR;AoB1xTQ;EACI,WAAA;ApB4xTZ;AoB1xTQ;EACI,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;ApB4xTZ;AoBzxTQ;EACI,gBAAA;ApB2xTZ;;AoBtxTA;EACI,gBAAA;ApByxTJ;AoBxxTI;EACI,kBAAA;ApB0xTR;AoBzxTQ;EACI,cAAA;EACA,gBAAA;ApB2xTZ;AoB1xTY;EACI,gBAAA;EACA,gBAAA;ApB4xThB;AoBzxTQ;EACI,kBAAA;EACA,UAAA;ApB2xTZ;AoBzxTQ;EACI,kBAAA;EACA,UAAA;ApB2xTZ;AoBvxTI;EACI,oCAAA;EACA,gBAAA;ApByxTR;AoBvxTY;EACI,kBAAA;ApByxThB;AoBxxTgB;EACI,cAAA;EACA,gBAAA;ApB0xTpB;AoBzxToB;EACI,gBAAA;EACA,gBAAA;ApB2xTxB;AoBvxToB;EACI,UAAA;EACA,SAAA;ApByxTxB;AoBvxToB;EACI,WAAA;EACA,SAAA;ApByxTxB;AoBtxTgB;EACI,WAAA;EACA,SAAA;ApBwxTpB;AoBrxTY;EACI,uBAAA;ApBuxThB;AoBtxTgB;EAFJ;IAGQ,uBAAA;EpByxTlB;AACF;AoBxxTgB;EACI,mBAAA;EACA,gBAAA;ApB0xTpB;AoBxxTgB;EACI,mBAAA;ApB0xTpB;AoBxxTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;ApB0xTpB;AoBtxTQ;EACI,8BAAA;EACA,4CAAA;ApBwxTZ;AoBtxTQ;EACI,oCAAA;EACA,gBAAA;ApBwxTZ;AoBvxTY;EACI,8BAAA;EACA,6CAAA;ApByxThB;AoBpxTI;EACI,oCAAA;EACA,uBAAA;EACA,gBAAA;ApBsxTR;AoBnxTgB;EACI,kBAAA;ApBqxTpB;AoBpxToB;EACI,kBAAA;ApBsxTxB;AoBlxToB;EACI,OAAA;EACA,SAAA;ApBoxTxB;AoBjxTgB;EACI,WAAA;EACA,SAAA;ApBmxTpB;AoBhxTY;EACI,iBAAA;ApBkxThB;AoBjxTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApBmxTpB;AoBjxTgB;EACI,mBAAA;ApBmxTpB;AoBjxTgB;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;ApBmxTpB;AoB/wTQ;EACI,oCAAA;EACA,6CAAA;ApBixTZ;AoB9wTI;EACI,oCAAA;EACA,4CAAA;EACA,kBAAA;ApBgxTR;AoB7wTgB;EACI,kBAAA;ApB+wTpB;AoB9wToB;EACI,kBAAA;ApBgxTxB;AoB5wToB;EACI,UAAA;EACA,aAAA;ApB8wTxB;AoB7wTwB;EAHJ;IAIQ,UAAA;EpBgxT1B;AACF;AoB7wTgB;EACI,WAAA;EACA,SAAA;ApB+wTpB;AoB5wTY;EACI,uBAAA;ApB8wThB;AoB7wTgB;EAFJ;IAGQ,uBAAA;EpBgxTlB;AACF;AoB/wTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApBixTpB;AoB/wToB;EALJ;IAMQ,eAAA;EpBkxTtB;AACF;AoBhxToB;EATJ;IAUQ,eAAA;EpBmxTtB;AACF;AoBjxToB;EAbJ;IAcQ,eAAA;EpBoxTtB;AACF;AoBlxToB;EACI,kBAAA;ApBoxTxB;AoBjxTgB;EACI,mBAAA;ApBmxTpB;AoBjxTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,eAAA;ApBmxTpB;AoB7wTQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,UAAA;EACA,gBAAA;EACA,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;ApB+wTZ;AoB9wTY;EAbJ;IAcQ,kBAAA;EpBixTd;AACF;AoBhxTY;EAhBJ;IAiBQ,kBAAA;EpBmxTd;AACF;AoBlxTY;EAnBJ;IAoBQ,kBAAA;EpBqxTd;AACF;AoBpxTY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;ApBsxThB;AoBpxToB;EACI,qCAAA;EACA,cAAA;EACA,iBAAA;ApBsxTxB;AoBjxToB;EACI,oCAAA;EACA,2BAAA;ApBmxTxB;AoB/wTY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ApBixThB;AoBhxTgB;EACI,yBAAA;ApBkxTpB;AoB/wTY;EACI,+BAAA;EACA,mBAAA;ApBixThB;AoB9wTY;EACI,mBAAA;ApBgxThB;AoB/wTgB;EACI,yBAAA;ApBixTpB;AoBhxToB;EACI,+BAAA;ApBkxTxB;AoB7wTY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;ApB+wThB;AoB7wToB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;ApB+wTxB;AoB3wToB;EACI,yBAAA;ApB6wTxB;AoB5wTwB;EACI,yBAAA;ApB8wT5B;AoBvwTY;EACI,UAAA;ApBywThB;AoBrwTQ;EACI,6CAAA;ApBuwTZ;AoBnwTwB;EACI,UAAA;EACA,eAAA;ApBqwT5B;AoBhwToB;EACI,eAAA;ApBkwTxB;AoBjwTwB;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ApBmwT5B;AoB7vToB;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ApB+vTxB;AoB5vTgB;EACI,uBAAA;ApB8vTpB;AoB7vToB;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ApB+vTxB;AoB7vToB;EACI,gBAAA;ApB+vTxB;AoBvvTI;EACI,oCAAA;EACA,gBAAA;ApByvTR;AoBxvTQ;EACI,aAAA;ApB0vTZ;AoBzvTY;EAFJ;IAGQ,cAAA;EpB4vTd;AACF;AoB3vTY;EALJ;IAMQ,cAAA;EpB8vTd;AACF;AoB5vTY;EACI,kBAAA;ApB8vThB;AoB7vTgB;EACI,YAAA;EACA,cAAA;ApB+vTpB;AoB9vToB;EACI,YAAA;EACA,iBAAA;ApBgwTxB;AoB/vTwB;EAHJ;IAIQ,iBAAA;EpBkwT1B;AACF;AoB9vToB;EACI,UAAA;EACA,SAAA;ApBgwTxB;AoB7vTgB;EACI,WAAA;EACA,SAAA;ApB+vTpB;AoB3vTY;EACI,kBAAA;EACA,kBAAA;ApB6vThB;AoB3vTgB;EAJJ;IAKQ,kBAAA;EpB8vTlB;AACF;AoB7vTgB;EAPJ;IAQQ,kBAAA;EpBgwTlB;AACF;AoB/vTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApBiwTpB;AoB/vTgB;EACI,mBAAA;EACA,gBAAA;ApBiwTpB;AoB/vTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ApBiwTpB;AoB7vTQ;EACI,6CAAA;EACA,oCAAA;ApB+vTZ;AoB5vTQ;EACI,oCAAA;ApB8vTZ;AoB1vTI;EACI,8BAAA;EACA,6CAAA;ApB4vTR;AoB3vTQ;EACI,oBAAA;ApB6vTZ;AoB3vTgB;EACI,YAAA;EACA,cAAA;EACA,kBAAA;ApB6vTpB;AoB5vToB;EACI,YAAA;EACA,kBAAA;ApB8vTxB;AoB1vToB;EACI,UAAA;EACA,SAAA;ApB4vTxB;AoBzvTgB;EACI,WAAA;EACA,SAAA;ApB2vTpB;AoBvvTY;EACI,kBAAA;ApByvThB;AoBxvTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ApB0vTpB;AoBxvTgB;EACI,mBAAA;EACA,gBAAA;ApB0vTpB;AoBxvTgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;ApB0vTpB;AoBpvTI;EACI,8BAAA;EACA,6CAAA;ApBsvTR;AoBrvTQ;EACI,aAAA;ApBuvTZ;AoBtvTY;EACI,mBAAA;ApBwvThB;AoBvvTgB;EACI,YAAA;EACA,cAAA;EACA,kBAAA;ApByvTpB;AoBxvToB;EACI,YAAA;EACA,kBAAA;ApB0vTxB;AoBtvToB;EACI,UAAA;EACA,SAAA;ApBwvTxB;AoBnvTgB;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ApBqvTpB;AoBnvTgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ApBqvTpB;AoB5uTgB;EACI,qBAAA;ApB8uTpB;;AqB11UA;;0BAAA;AAGA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;ArB61UJ;AqB51UI;EACI,eAAA;ArB81UR;AqB71UQ;EAFJ;IAGQ,cAAA;ErBg2UV;AACF;AqB/1UQ;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ArBi2UZ;AqBh2UY;EACI;IACI,kBAAA;ErBk2UlB;EqBh2Uc;IACI,iBAAA;ErBk2UlB;AACF;AqB/1UY;EAfJ;IAgBQ,aAAA;ErBk2Ud;AACF;AqBj2UY;EACI,wBAAA;EACA,iBAAA;ArBm2UhB;AqB/1UI;EACI,eAAA;ArBi2UR;AqBh2UQ;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ArBk2UZ;AqBj2UY;EACI,2BAAA;EACA,kBAAA;ArBm2UhB;AqB91UI;EACI,kBAAA;ArBg2UR;AqB/1UQ;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ArBi2UZ;AqBh2UY;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ArBk2UhB;AqBh2UgB;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ArBk2UpB;AqB71UgB;EACI,6BAAA;ArB+1UpB;AqB91UoB;EACI,kCAAA;ArBg2UxB;AqB31UgB;EACI,2BAAA;ArB61UpB;AqB51UoB;EACI,gCAAA;ArB81UxB;AqBz1UgB;EACI,4BAAA;ArB21UpB;AqB11UoB;EACI,iCAAA;ArB41UxB;AqBx1UY;EACI,eAAA;ArB01UhB;AqBr1UI;EACI,iBAAA;ArBu1UR;AqBt1UQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ArBw1UZ;AqBv1UY;EACI,6BAAA;EACA,iBAAA;EACA,eAAA;ArBy1UhB;;AqBj1UI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;ArBo1UR;AqBn1UQ;EAEI,kBAAA;ArBo1UZ;;AqB90UA;;wBAAA;AAIA;EACI,aAAA;EACA,mBAAA;ArBg1UJ;AqB90UQ;EACI,cAAA;EACA,gBAAA;ArBg1UZ;AqB/0UY;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;ArBi1UhB;AqB/0UY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;ArBi1UhB;AqB90UgB;EACI,2BAAA;ArBg1UpB;;AsBhgVA;;yBAAA;AAGA;EACI,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AtBmgVJ;;AsBhgVA;EACI,YAAA;AtBmgVJ;AsBlgVI;EACI,WAAA;AtBogVR;;AsBhgVA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AtBmgVJ;AsBjgVI;EACI,gBAAA;AtBmgVR;;AsB7/UI;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AtBggVR;AsB//UQ;EACI,yBAAA;AtBigVZ;AsB//UQ;EACI,yBAAA;AtBigVZ;AsB7/UI;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;AtB+/UR;AsB9/UQ;EACI,iBAAA;AtBggVZ;AsB5/UI;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;AtB8/UR;AsB3/UI;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AtB6/UR;AsB1/UI;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AtB4/UR;AsB3/UQ;EACI,2BAAA;EACA,iBAAA;AtB6/UZ;AsB3/UQ;EACI,2BAAA;AtB6/UZ;AsBz/UI;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;EACA,qBAAA;EACA,gCAAA;AtB2/UR;;AsBr/UA;EACI,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AtBw/UJ;;AuBznVA;;6BAAA;AAIA;EACI,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvB2nVJ;AuB1nVI;EACI,WAAA;EACA,gBAAA;AvB4nVR;AuB3nVQ;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AvB6nVZ;AuB5nVY;EACI,eAAA;EACA,gBAAA;AvB8nVhB;AuB3nVQ;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;AvB6nVZ;AuB5nVY;EACI,eAAA;EACA,gBAAA;AvB8nVhB;AuBznVY;;;EAEI,gCAAA;EACA,yBAAA;AvB4nVhB;;AwBlrVA;;2BAAA;AAKI;EACI,kBAAA;EACA,UAAA;AxBmrVR;AwBlrVQ;EACI,OAAA;EACA,SAAA;AxBorVZ;AwBhrVI;EAEI,aAAA;EACA,mBAAA;AxBirVR;AwBhrVQ;EACI,gBAAA;EACA,eAAA;AxBkrVZ;AwBjrVY;EAHJ;IAIQ,eAAA;ExBorVd;AACF;AwBnrVY;EACI,kBAAA;EACA,2BAAA;AxBqrVhB;AwB9qVQ;EACI,8BAAA;EACA,gBAAA;AxBgrVZ;AwB/qVY;EACI,kBAAA;EACA,gBAAA;AxBirVhB;AwBhrVgB;EACI,cAAA;AxBkrVpB;AwBjrVoB;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;AxBmrVxB;AwB/qVY;EACI,aAAA;AxBirVhB;AwBhrVgB;EAFJ;IAGQ,aAAA;ExBmrVlB;AACF;AwBlrVgB;EACI,gBAAA;EACA,mBAAA;AxBorVpB;AwBnrVoB;EAHJ;IAIQ,eAAA;IACA,mBAAA;ExBsrVtB;AACF;AwBnrVY;EACI,6CAAA;EACA,kBAAA;AxBqrVhB;AwBhrVY;EACI,6CAAA;AxBkrVhB;AwB5qVQ;EACI,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AxB8qVZ;AwB7qVY;EAPJ;IAQQ,aAAA;ExBgrVd;AACF;AwB9qVY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;AxBgrVhB;AwB/qVgB;EAJJ;IAKQ,eAAA;ExBkrVlB;AACF;AwBjrVgB;EAPJ;IAQQ,eAAA;ExBorVlB;AACF;AwBnrVgB;EAVJ;IAWQ,eAAA;ExBsrVlB;AACF;AwBrrVgB;EAbJ;IAcQ,gBAAA;ExBwrVlB;AACF;AwBvrVgB;EACI,cAAA;AxByrVpB;AwBxrVoB;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AxB0rVxB;AwBtrVY;EACI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AxBwrVhB;AwBtrVgB;EAPJ;IAQQ,cAAA;IACA,eAAA;ExByrVlB;AACF;AwBvrVgB;EAZJ;IAaQ,cAAA;IACA,eAAA;ExB0rVlB;AACF;AwBxrVgB;EAjBJ;IAkBQ,cAAA;IACA,eAAA;IACA,kBAAA;ExB2rVlB;AACF;AwB1rVgB;EAtBJ;IAuBQ,gBAAA;IACA,eAAA;IACA,gBAAA;ExB6rVlB;AACF;AwB3rVgB;EACI,mBAAA;AxB6rVpB;AwB5rVoB;EAFJ;IAGQ,eAAA;ExB+rVtB;AACF;AwB7rVgB;EACI,eAAA;EACA,eAAA;AxB+rVpB;AwB9rVoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AxBgsVxB;AwB/rVwB;EAJJ;IAKQ,aAAA;IACA,eAAA;ExBksV1B;AACF;AwBjsVwB;EACI,wBAAA;EACA,eAAA;AxBmsV5B;AwB5rVgB;EADJ;IAEQ,gBAAA;ExB+rVlB;AACF;AwB9rVgB;EAJJ;IAKQ,gBAAA;ExBisVlB;AACF;AwBhsVgB;EAPJ;IAQQ,gBAAA;ExBmsVlB;AACF;AwBjsVoB;EADJ;IAEQ,eAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;ExBosVtB;AACF;AwBhsVY;EACI,6CAAA;EACA,8BAAA;AxBksVhB;AwB7rVY;EACI,mBAAA;EACA,gBAAA;AxB+rVhB;AwB5rVgB;EACI,4CAAA;EACA,8BAAA;AxB8rVpB;;AyB14VA;;2BAAA;AAIA;EACI,kBAAA;AzB44VJ;AyB14VQ;EACI,kBAAA;AzB44VZ;AyB34VY;EACI,YAAA;EACA,SAAA;AzB64VhB;AyB34VY;EACI,UAAA;EACA,WAAA;AzB64VhB;AyB34VY;EACI,UAAA;EACA,WAAA;AzB64VhB;AyB34VY;EACI,aAAA;EACA,WAAA;AzB64VhB;;AyBt4VA;EACI,YAAA;AzBy4VJ;AyBx4VI;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;AzB04VR;AyBz4VQ;EACI,gCAAA;EACA,yBAAA;AzB24VZ;;AyBn4VA;EACI,kBAAA;AzBs4VJ;AyBr4VI;EACI,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AzBu4VR;AyBt4VQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AzBw4VZ;AyBt4VQ;EACI,kBAAA;EACA,aAAA;AzBw4VZ;AyBt4VgB;EACI,cAAA;EACA,kBAAA;AzBw4VpB;AyBv4VoB;EACI,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,yDAAA;AzBy4VxB;AyBv4VoB;EACI,WAAA;EACA,mBAAA;AzBy4VxB;AyBr4VY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;AzBu4VhB;AyBt4VgB;EACI,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,0DAAA;EACA,qCAAA;AzBw4VpB;AyBv4VoB;EACI,0BAAA;AzBy4VxB;AyBv4VoB;EACI,0BAAA;AzBy4VxB;AyBv4VoB;EACI,0BAAA;AzBy4VxB;AyBn4VI;EACI,gBAAA;AzBq4VR;AyBp4VQ;EACI,kBAAA;AzBs4VZ;AyBp4VQ;EACI,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AzBs4VZ;AyBj4VY;EACI,wBAAA;AzBm4VhB;AyBh4VgB;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AzBk4VpB;AyB53VwB;EACI,YAAA;AzB83V5B;AyBv3VY;EACI,2BAAA;AzBy3VhB;;AyBl3VA;EACI,kBAAA;AzBq3VJ;AyBp3VI;EACI,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AzBs3VR;AyBr3VQ;EACI,kBAAA;AzBu3VZ;AyBr3VgB;EACI,cAAA;EACA,kBAAA;AzBu3VpB;AyBt3VoB;EACI,uHAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,yDAAA;EACA,kBAAA;EACA,kCAAA;AzBw3VxB;AyBt3VoB;EACI,WAAA;EACA,kCAAA;EACA,yDAAA;AzBw3VxB;AyBp3VY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AzBs3VhB;AyBr3VgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,0DAAA;EACA,qCAAA;AzBu3VpB;AyBr3VoB;EACI,0BAAA;AzBu3VxB;AyBr3VoB;EACI,0BAAA;AzBu3VxB;AyBr3VoB;EACI,0BAAA;AzBu3VxB;AyBr3VoB;EACI,0BAAA;AzBu3VxB;AyBj3VI;EACI,gBAAA;AzBm3VR;AyBl3VQ;EACI,kBAAA;AzBo3VZ;AyBl3VQ;EACI,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AzBo3VZ;AyB92VgB;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AzBg3VpB;AyB12VwB;EACI,kBAAA;EACA,UAAA;AzB42V5B;AyB12VwB;EACI,kBAAA;AzB42V5B;AyBr2VY;EACI,2BAAA;AzBu2VhB;;AyBj2VA;EACI,kBAAA;AzBo2VJ;AyBn2VI;EACI,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AzBq2VR;AyBp2VQ;EACI,kBAAA;AzBs2VZ;AyBn2VgB;EACI,cAAA;EACA,kBAAA;AzBq2VpB;AyBp2VoB;EACI,WAAA;EACA,kBAAA;AzBs2VxB;AyBj2VY;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AzBm2VhB;AyBl2VgB;EAbJ;IAcQ,wBAAA;EzBq2VlB;AACF;AyBp2VgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AzBs2VpB;AyBn2VgB;EACI,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AzBq2VpB;AyBl2VoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,0DAAA;AzBo2VxB;AyBl2VwB;EACI,0BAAA;AzBo2V5B;AyBl2VwB;EACI,0BAAA;AzBo2V5B;AyBl2VwB;EACI,0BAAA;AzBo2V5B;AyBl2VwB;EACI,0BAAA;AzBo2V5B;AyBh2VoB;EACI,aAAA;AzBk2VxB;AyBj2VwB;EACI,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AzBm2V5B;AyBx1VgB;EACI,UAAA;EACA,UAAA;AzB01VpB;AyBz1VoB;EAHJ;IAIQ,OAAA;EzB41VtB;AACF;AyBr1VY;EACI,UAAA;EACA,UAAA;AzBu1VhB;AyBt1VgB;EAHJ;IAIQ,OAAA;EzBy1VlB;AACF;;A0B7tWA;;2BAAA;AAGA;EACI,kBAAA;A1BguWJ;A0B/tWI;EACI,kBAAA;EACA,WAAA;A1BiuWR;A0BhuWQ;EACI,UAAA;EACA,YAAA;A1BkuWZ;A0BhuWQ;EACI,UAAA;EACA,aAAA;A1BkuWZ;A0BhuWQ;EACI,YAAA;EACA,YAAA;A1BkuWZ;A0BhuWQ;EACI,aAAA;EACA,YAAA;A1BkuWZ;;A0B7tWA;EACI,0DAAA;A1BguWJ;;A0B7tWA;EACI,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;A1BguWJ;A0B/tWI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,SAAA;A1BiuWR;A0B5tWgB;EACI,WAAA;A1B8tWpB;A0B1tWQ;EACI,aAAA;A1B4tWZ;A0B1tWY;EAHJ;IAIQ,kBAAA;E1B6tWd;AACF;A0B3tWY;EAPJ;IAQQ,kBAAA;E1B8tWd;AACF;A0B5tWY;EAXJ;IAYQ,kBAAA;E1B+tWd;AACF;A0B7tWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;A1B+tWhB;A0B7tWY;EACI,mBAAA;A1B+tWhB;A0B7tWgB;EAHJ;IAIQ,kBAAA;E1BguWlB;AACF;A0B9tWgB;EAPJ;IAQQ,kBAAA;E1BiuWlB;AACF;A0B/tWgB;EAXJ;IAYQ,kBAAA;E1BkuWlB;AACF;A0BhuWY;EACI,gBAAA;A1BkuWhB;A0B9tWI;EACI,4BAAA;A1BguWR;A0B/tWQ;EACI,WAAA;A1BiuWZ;;A0B5tWA;;wBAAA;AAGA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;A1B+tWJ;A0B7tWI;EALJ;IAMQ,kBAAA;E1BguWN;AACF;A0B9tWI;EATJ;IAUQ,kBAAA;E1BiuWN;AACF;A0B/tWI;EAbJ;IAcQ,kBAAA;E1BkuWN;AACF;A0BjuWI;EACI,kBAAA;A1BmuWR;A0BluWQ;EACI,kBAAA;EACA,qBAAA;A1BouWZ;A0BnuWY;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;A1BquWhB;A0B/tWgB;EACI,kBAAA;EACA,UAAA;A1BiuWpB;A0BhuWoB;EACI,SAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;A1BkuWxB;A0BhuWoB;EACI,OAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;A1BkuWxB;A0BhuWoB;EACI,MAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;A1BkuWxB;A0B5tWY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;A1B8tWhB;A0B5tWY;EACI,gBAAA;A1B8tWhB;A0BztWI;EACI,mBAAA;A1B2tWR;A0BztWI;EACI,mBAAA;A1B2tWR;A0BztWI;EACI,mBAAA;A1B2tWR;A0BntWwB;EACI,YAAA;EACA,UAAA;EACA,UAAA;A1BqtW5B;A0BntWwB;EACI,WAAA;EACA,QAAA;EACA,UAAA;A1BqtW5B;A0BntWwB;EACI,SAAA;EACA,WAAA;EACA,UAAA;A1BqtW5B;;A0BzsWA;;wBAAA;AAIA;EACI,kBAAA;EACA,qBAAA;EACA,UAAA;A1B2sWJ;;A0BxsWA;EACI,kBAAA;EACA,UAAA;EACA,qBAAA;A1B2sWJ;A0B1sWI;EACI,0DAAA;A1B4sWR;;A0BvsWA;EACI,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A1B0sWJ;A0BzsWI;EACI,kBAAA;A1B2sWR;A0B1sWQ;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;A1B4sWZ;A0B3sWY;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1B6sWhB;A0B5sWgB;EACI,eAAA;EACA,yBAAA;A1B8sWpB;A0BzsWY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;A1B2sWhB;A0BzsWY;EACI,mBAAA;A1B2sWhB;A0BnsWgB;EACI,oCAAA;A1BqsWpB;A0BpsWoB;EACI,8BAAA;A1BssWxB;A0B9rWoB;EACI,mCAAA;A1BgsWxB;A0BtrWgB;EACI,oCAAA;A1BwrWpB;A0BvrWoB;EACI,4BAAA;A1ByrWxB;A0BjrWoB;EACI,iCAAA;A1BmrWxB;A0BzqWgB;EACI,mCAAA;A1B2qWpB;A0B1qWoB;EACI,2BAAA;A1B4qWxB;A0BpqWoB;EACI,gCAAA;A1BsqWxB;A0B5pWgB;EACI,mCAAA;A1B8pWpB;A0B7pWoB;EACI,6BAAA;A1B+pWxB;A0BvpWoB;EACI,kCAAA;A1BypWxB;A0BhpWQ;EACI,gBAAA;A1BkpWZ;A0B/oWI;EACI,mBAAA;EACA,YAAA;A1BipWR;A0BhpWQ;EACI,8BAAA;EACA,6CAAA;A1BkpWZ;A0B/oWI;EACI,4BAAA;EACA,6CAAA;A1BipWR;A0B7oWoB;EACI,cAAA;A1B+oWxB;;A0BtoWA;;kCAAA;AAIA;EACI,YAAA;A1BwoWJ;A0BvoWI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;A1ByoWR;A0BvoWQ;EARJ;IASQ,kBAAA;E1B0oWV;AACF;A0BxoWQ;EAZJ;IAaQ,kBAAA;E1B2oWV;AACF;A0BzoWQ;EAhBJ;IAiBQ,kBAAA;E1B4oWV;AACF;A0B1oWQ;EACI,kBAAA;A1B4oWZ;A0B3oWY;EACI,cAAA;EACA,2BAAA;EACA,eAAA;A1B6oWhB;A0B3oWY;EACI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;A1B6oWhB;A0BzoWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;A1B2oWhB;A0B1oWgB;EACI,gBAAA;EACA,2BAAA;A1B4oWpB;A0BzoWY;EACI,gBAAA;EACA,gBAAA;A1B2oWhB;A0BtoWQ;EACI,gCAAA;A1BwoWZ;A0BtoWgB;EACI,UAAA;A1BwoWpB;A0BtoWgB;EACI,UAAA;EACA,yBAAA;A1BwoWpB;A0BnoWoB;EACI,yBAAA;A1BqoWxB;A0BloWgB;EACI,yBAAA;A1BooWpB;;A0B5nWA;;kCAAA;AAII;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;A1B8nWR;A0B7nWQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;A1B+nWZ;A0B9nWY;EAZJ;IAaQ,kBAAA;E1BioWd;AACF;A0BhoWY;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;A1BkoWhB;A0B9nWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;A1BgoWhB;A0B/nWgB;EANJ;IAOQ,eAAA;IACA,iBAAA;E1BkoWlB;AACF;A0BhoWY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A1BkoWhB;A0B7nWQ;EACI,gCAAA;A1B+nWZ;A0B9nWY;EACI,gBAAA;EACA,qCAAA;A1BgoWhB;A0B/nWgB;EACI,yBAAA;A1BioWpB;A0B5nWoB;EACI,yBAAA;A1B8nWxB;A0B3nWgB;EACI,yBAAA;A1B6nWpB;;A0BtnWA;;kCAAA;AAKI;EACI,mBAAA;A1BunWR;;A0BhnWI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A1BmnWR;A0BlnWQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A1BonWZ;A0BjnWQ;EACI,gBAAA;A1BmnWZ;A0BlnWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;A1BonWhB;A0BlnWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A1BonWhB;A0BhnWQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;A1BknWZ;A0BjnWY;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;A1BmnWhB;A0B7mWQ;EACI,mBAAA;A1B+mWZ;A0B1mWQ;EACI,mBAAA;A1B4mWZ;A0BvmWQ;EACI,mBAAA;A1BymWZ;A0BrmWQ;EACI,mBAAA;A1BumWZ;A0BjmWQ;EACI,oBAAA;EACA,oBAAA;A1BmmWZ;A0BlmWY;EACI,UAAA;A1BomWhB;;A0B3lWA;;kCAAA;AAIA;EACI,kBAAA;A1B6lWJ;A0B3lWQ;EACI,0DAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;A1B6lWZ;A0B5lWY;EAVJ;IAWQ,aAAA;E1B+lWd;AACF;A0B9lWY;EAbJ;IAcQ,aAAA;E1BimWd;AACF;A0B7lWQ;EACI,0DAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;A1B+lWZ;A0B9lWY;EAVJ;IAWQ,aAAA;E1BimWd;AACF;A0BhmWY;EAbJ;IAcQ,aAAA;E1BmmWd;AACF;;A0B/lWA;EACI,kBAAA;A1BkmWJ;A0BjmWI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A1BmmWR;A0B/lWI;EACG,kBAAA;A1BimWP;A0BhmWQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;A1BkmWZ;A0BjmWY;EACI,yBAAA;EACA,eAAA;EACA,aAAA;A1BmmWhB;A0B9lWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A1BgmWhB;A0B9lWY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A1BgmWhB;A0B1lWY;EACI,gCAAA;A1B4lWhB;A0BrlWY;EACI,mBAAA;A1BulWhB;A2B11XA;;+BAAA;AAKI;EACI,SAAA;EACA,gBAAA;EACA,eAAA;A3B01XR;A2Bz1XQ;EACI,gBAAA;EACA,2BAAA;A3B21XZ;;A2Br1XA;EACI,kBAAA;EACA,qBAAA;A3Bw1XJ;A2Bv1XI;EACI,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;A3By1XR;A2Bx1XQ;EAXJ;IAYQ,eAAA;E3B21XV;AACF;A2Bz1XI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;A3B21XR;A2B11XQ;EACI,eAAA;A3B41XZ;;A2Bp1XA;EACI,qBAAA;EACA,kBAAA;A3Bu1XJ;A2Bt1XI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;A3Bw1XR;A2Bv1XQ;EACI,eAAA;EACA,wBAAA;A3By1XZ;A2Bt1XI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,wBAAA;EAGA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qFAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A3Bw1XR;;A4Bn7XA;;8BAAA;AAGA;EACI,8BAAA;EACA,uBAAA;EACA,kBAAA;A5Bs7XJ;A4Br7XI;EACI,+CAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A5Bu7XR;A4Br7XI;EACI,gBAAA;A5Bu7XR;A4Br7XQ;EACI,kBAAA;A5Bu7XZ;A4Bt7XY;EACI,gBAAA;A5Bw7XhB;A4Bn7XQ;EACI,aAAA;EACA,8BAAA;A5Bq7XZ;;A6Bh9XA;;6BAAA;AAGA;EACI,mBAAA;EACA,kBAAA;A7Bm9XJ;A6Bj9XI;EAJJ;IAKQ,gBAAA;E7Bo9XN;AACF;A6Bl9XI;EARJ;IASQ,gBAAA;E7Bq9XN;AACF;A6Bn9XI;EAZJ;IAaQ,gBAAA;E7Bs9XN;AACF;A6Bn9XQ;EACI,WAAA;EACA,kBAAA;A7Bq9XZ;A6Bl9XI;EACI,YAAA;EACA,8BAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;A7Bo9XR;A6Bl9XQ;EAZJ;IAaQ,SAAA;IACA,UAAA;IACA,YAAA;E7Bq9XV;AACF;A6Bn9XQ;EAlBJ;IAmBQ,SAAA;IACA,UAAA;IACA,YAAA;E7Bs9XV;AACF;A6Bp9XQ;EAxBJ;IAyBQ,SAAA;IACA,UAAA;IACA,YAAA;E7Bu9XV;AACF;A6Br9XQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A7Bu9XZ;A6Bn9XY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7Bq9XhB;A6Bl9XY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A7Bo9XhB;;A6B98XA;EACI,gBAAA;A7Bi9XJ;A6Bh9XI;EAFJ;IAGQ,eAAA;E7Bm9XN;AACF;A6Bj9XQ;EADJ;IAEQ,aAAA;E7Bo9XV;AACF;A6Bh9XY;EACI,mBAAA;EACA,qBAAA;A7Bk9XhB;A6Bj9XgB;EAHJ;IAIQ,mBAAA;E7Bo9XlB;AACF;A6Bn9XgB;EANJ;IAOQ,mBAAA;IACA,gBAAA;E7Bs9XlB;AACF;A6Bl9XY;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;A7Bo9XhB;A6Bn9XgB;EALJ;IAMQ,mBAAA;E7Bs9XlB;AACF;A6Br9XgB;EARJ;IASQ,mBAAA;E7Bw9XlB;AACF;A6Br9XY;EACI,aAAA;EACA,mBAAA;A7Bu9XhB;A6Br9XgB;EACI,kBAAA;EACA,eAAA;A7Bu9XpB;A6Br9XoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;A7Bu9XxB;A6Bl9XoB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;A7Bo9XxB;A6Bj9XoB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;A7Bm9XxB;;A6B38XA;;+BAAA;AAIA;EACI,aAAA;A7B68XJ;A6B38XI;EACI,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A7B68XR;A6B38XQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,oEAAA;EACA,oBAAA;EACA,wBAAA;EACA,UAAA;EACA,+BAAA;A7B68XZ;A6B18XQ;EACI,mBAAA;A7B48XZ;A6Bz8XQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;A7B28XZ;A6B18XY;EACI,kBAAA;A7B48XhB;A6B38XgB;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A7B68XpB;A6Bz8XgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A7B28XpB;A6B18XoB;EALJ;IAMQ,eAAA;IACA,iBAAA;E7B68XtB;AACF;A6B38XgB;EACI,2BAAA;EACA,gBAAA;A7B68XpB;A6Br8XQ;EADJ;IAEQ,UAAA;E7Bw8XV;AACF;A6Bv8XQ;EAJJ;IAKQ,UAAA;E7B08XV;AACF;A6Bz8XQ;EACI,aAAA;EACA,gBAAA;A7B28XZ;A6B18XY;EAHJ;IAIQ,kBAAA;E7B68Xd;AACF;A6B58XY;EACI,aAAA;A7B88XhB;A6B58XY;EACI,mBAAA;A7B88XhB;A6B78XgB;EAFJ;IAGQ,mBAAA;E7Bg9XlB;AACF;A6B98XY;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A7Bg9XhB;A6B/8XgB;EALJ;IAMQ,mBAAA;IACA,eAAA;IACA,iBAAA;E7Bk9XlB;AACF;A6Bh9XY;EACI,gBAAA;A7Bk9XhB;A6Bh9XgB;EAHJ;IAIQ,cAAA;E7Bm9XlB;AACF;A6Bl9XgB;EACI,kBAAA;A7Bo9XpB;A6Bl9XoB;EAHJ;IAIQ,eAAA;IACA,mBAAA;E7Bq9XtB;AACF;A6Bn9XoB;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;A7Bq9XxB;A6B98XI;EACI,UAAA;A7Bg9XR;A6B/8XQ;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7Bi9XZ;A6Bh9XY;EALJ;IAMQ,mBAAA;IACA,eAAA;IACA,iBAAA;E7Bm9Xd;AACF;A6Bj9XQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;A7Bm9XZ;A6Bl9XY;EACI,kBAAA;A7Bo9XhB;A6Bn9XgB;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;A7Bq9XpB;A6Bj9XgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A7Bm9XpB;A6Bj9XgB;EACI,2BAAA;EACA,gBAAA;A7Bm9XpB;;A6B38XA;EACI,kBAAA;A7B88XJ;A6B78XI;EACI,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,MAAA;EACA,YAAA;EACA,OAAA;A7B+8XR;A6B98XQ;EARJ;IASQ,UAAA;E7Bi9XV;AACF;A6Bh9XQ;EAXJ;IAYQ,UAAA;E7Bm9XV;AACF;A6Bl9XQ;EAdJ;IAeQ,UAAA;E7Bq9XV;AACF;A6Bp9XQ;EAjBJ;IAkBQ,aAAA;E7Bu9XV;AACF;A6Bt9XQ;EApBJ;IAqBQ,aAAA;E7By9XV;AACF;A6Bv9XI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;A7By9XR;A6Bx9XQ;EACI,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;A7B09XZ;A6Bz9XY;EATJ;IAUQ,aAAA;E7B49Xd;AACF;A6B19XQ;EACI,oBAAA;A7B49XZ;A6Bz9XI;EACI,kBAAA;EACA,UAAA;A7B29XR;A6B19XQ;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;A7B49XZ;A6Bz9XI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;A7B29XR;;A6Bt9XA;;6BAAA;AAKI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A7Bu9XR;A6Br9XI;EACI,mBAAA;A7Bu9XR;A6Bt9XQ;EAFJ;IAGQ,mBAAA;E7By9XV;AACF;A6Bx9XQ;EALJ;IAMQ,mBAAA;E7B29XV;AACF;A6B19XQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7B49XZ;A6Bz9XQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;A7B29XZ;;A6Bt9XA;EACI,gBAAA;A7By9XJ;;A6Br9XI;EACI,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A7Bw9XR;A6Bv9XQ;EACI,eAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;A7By9XZ;A6Bn9XgB;EACI,UAAA;A7Bq9XpB;;A6B98XA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;A7Bi9XJ;A6Bh9XI;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EAIA,yBAAA;A7Bk9XR;A6Bh9XQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;A7Bk9XZ;A6B/8XQ;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;A7Bi9XZ;A6B98XQ;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;A7Bg9XZ;A6B78XQ;EACI,OAAA;A7B+8XZ;A6B78XY;EACI,yBAAA;EACA,4BAAA;EACA,yBAAA;EACA,iCAAA;EACA,0CAAA;EACA,kDAAA;A7B+8XhB;A6B38XQ;EACI,SAAA;A7B68XZ;A6B38XY;EACI,WAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;EACA,2CAAA;EACA,mDAAA;A7B68XhB;A6B18XY;EACI;IACI,uBAAA;E7B48XlB;E6Bz8Xc;IACI,yBAAA;E7B28XlB;E6Bx8Xc;IACI,yBAAA;E7B08XlB;E6Bv8Xc;IACI,yBAAA;E7By8XlB;E6Bt8Xc;IACI,yBAAA;E7Bw8XlB;AACF;A6B/6XY;EACI;IACI,uBAAA;E7Bk8XlB;E6B/7Xc;IACI,uBAAA;E7Bi8XlB;E6B97Xc;IACI,yBAAA;E7Bg8XlB;E6B77Xc;IACI,yBAAA;E7B+7XlB;E6B57Xc;IACI,yBAAA;E7B87XlB;AACF;;A8B5gZA;;0BAAA;AAGA;EACI,aAAA;EACA,eAAA;EACA,aAAA;A9BgiZJ;A8B/hZI;EACI,eAAA;EACA,aAAA;A9BiiZR;A8BhiZQ;EAHJ;IAIQ,gBAAA;E9BmiZV;AACF;;A8B9hZI;EACI,mBAAA;A9BiiZR;A8BhiZQ;EACI,eAAA;EACA,6BAAA;A9BkiZZ;A8B9hZQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9BgiZZ;A8B9hZQ;EACI,gBAAA;A9BgiZZ;;A8B3hZA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;A9B8hZJ;A8B5hZI;EALJ;IAMQ,QAAA;E9B+hZN;AACF;A8B7hZI;EATJ;IAUQ,QAAA;E9BgiZN;AACF;A8B9hZI;EAbJ;IAcQ,QAAA;E9BiiZN;AACF;A8B/hZI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A9BiiZR;A8BhiZQ;EANJ;IAOQ,aAAA;E9BmiZV;AACF;;A8B9hZA;EACI,mBAAA;A9BiiZJ;;A8BphZA;;0BAAA;AAIA;EACI,aAAA;EACA,eAAA;A9BshZJ;A8BrhZI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;A9BuhZR;A8BthZQ;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A9BwhZZ;A8BvhZY;EACI,6BAAA;A9ByhZhB;A8BrhZY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;A9BuhZhB;A8BthZgB;EALJ;IAMQ,eAAA;E9ByhZlB;AACF;;A8BnhZA;;0BAAA;AAMQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;A9BmhZZ;A8BjhZQ;EACI,gBAAA;A9BmhZZ;;A8B7gZA;;0BAAA;AAKI;EACI,aAAA;A9B8gZR;A8B7gZQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A9B+gZZ;A8B9gZY;EACI,6BAAA;EACA,eAAA;A9BghZhB;A8B5gZY;EACI,kBAAA;A9B8gZhB;A8B5gZY;EACI,mBAAA;A9B8gZhB;A8BzgZY;EACI,kCAAA;A9B2gZhB;A8B1gZgB;EACI,2BAAA;A9B4gZpB;;A8BpgZA;;0BAAA;AAKI;EACI,aAAA;A9BqgZR;A8BpgZQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A9BsgZZ;A8BrgZY;EACI,yBAAA;EACA,eAAA;A9BugZhB;A8BngZY;EACI,kBAAA;A9BqgZhB;A8BngZY;EACI,gBAAA;A9BqgZhB;A8BhgZY;EACI,mBAAA;A9BkgZhB;A8BjgZgB;EACI,yBAAA;A9BmgZpB;;A8Bz/YA;;0BAAA;AAKI;EACI,aAAA;A9B0/YR;A8Bz/YQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A9B2/YZ;A8B1/YY;EACI,6BAAA;EACA,eAAA;A9B4/YhB;A8Bx/YY;EACI,kBAAA;A9B0/YhB;A8Bx/YY;EACI,mBAAA;A9B0/YhB;A8Br/YY;EACI,kCAAA;A9Bu/YhB;A8Bt/YgB;EACI,2BAAA;A9Bw/YpB;A8Bl/YY;EACI,mCAAA;A9Bo/YhB;A8B/+YY;EACI,kCAAA;A9Bi/YhB;A8B5+YY;EACI,mCAAA;A9B8+YhB;;A+B1wZA;;0BAAA;AAKC;EACC,aAAA;A/B2wZF;A+B1wZE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A/B4wZH;A+B1wZG;EACC,yBAAA;EACA,eAAA;A/B4wZJ;A+BxwZG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;A/B0wZJ;A+BxwZG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A/B0wZJ;A+BtwZE;EACC,gBAAA;A/BwwZH;;A+BnwZA;;yBAAA;AAIA;EACC,kBAAA;EACA,UAAA;A/BqwZD;A+BpwZC;EACC,mBAAA;EACA,kBAAA;A/BswZF;A+BrwZE;EAHD;IAIE,kBAAA;E/BwwZD;AACF;A+BvwZE;EAND;IAOE,kBAAA;E/B0wZD;AACF;A+BzwZE;EATD;IAUE,eAAA;E/B4wZD;AACF;A+B3wZE;EACC,kBAAA;EACA,WAAA;A/B6wZH;A+B3wZE;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;A/B6wZH;A+B5wZG;EALD;IAME,kBAAA;IACA,QAAA;IACA,kBAAA;IACA,gBAAA;IACA,0BAAA;IACA,iBAAA;E/B+wZF;AACF;A+B7wZG;EACC,kBAAA;A/B+wZJ;A+B5wZE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,oCAAA;EACA,0BAAA;EACA,mBAAA;A/B8wZH;A+B7wZG;EAVD;IAWE,aAAA;E/BgxZF;AACF;A+B/wZG;EACC,sCAAA;EACA,mBAAA;A/BixZJ;A+B9wZE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;A/BgxZH;A+B5wZE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;A/B8wZH;A+B7wZG;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,gCAAA;EACA,QAAA;EACA,2BAAA;A/B+wZJ;A+B5wZE;EACC,gBAAA;A/B8wZH;A+B5wZE;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,4DAAA;A/B8wZH;A+B7wZG;EALD;IAME,UAAA;E/BgxZF;AACF;;A+B3wZA;;yBAAA;AAGA;EACC,kBAAA;A/B8wZD;A+B7wZC;EACC,kBAAA;A/B+wZF;A+B9wZE;EACC,kBAAA;A/BgxZH;A+B/wZG;EACC,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;A/BixZJ;A+BhxZI;EATD;IAUE,cAAA;E/BmxZH;AACF;A+BjxZI;EAbD;IAcE,cAAA;E/BoxZH;AACF;A+BlxZI;EAjBD;IAkBE,cAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;E/BqxZH;AACF;A+BnxZG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;A/BqxZJ;A+BpxZI;EAPD;IAQE,aAAA;E/BuxZH;AACF;A+BpxZE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;A/BsxZH;A+BrxZG;EAND;IAOE,YAAA;E/BwxZF;AACF;A+BtxZE;EACC,8BAAA;EACA,6CAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;A/BwxZH;A+BvxZG;EAbD;IAcE,OAAA;IACA,QAAA;E/B0xZF;AACF;A+BxxZG;EAlBD;IAmBE,OAAA;IACA,QAAA;E/B2xZF;AACF;A+BzxZG;EAvBD;IAwBE,OAAA;IACA,MAAA;IACA,YAAA;IACA,aAAA;E/B4xZF;AACF;A+BzxZI;EACC,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;A/B2xZL;A+B1xZK;EAND;IAOE,eAAA;IACA,iBAAA;E/B6xZJ;AACF;A+B3xZI;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;A/B6xZL;A+BvxZC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;A/ByxZF;A+BxxZE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;A/B0xZH;A+BzxZG;EACC,qBAAA;EACA,UAAA;A/B2xZJ;A+B1xZI;EAHD;IAIE,WAAA;E/B6xZH;AACF;A+B1xZE;EAtBD;IAuBE,aAAA;E/B6xZD;AACF;A+B5xZE;EAzBD;IA0BE,WAAA;E/B+xZD;AACF;;A+B3xZA;EACC,kBAAA;EACA,qBAAA;EACA,UAAA;A/B8xZD;A+B7xZC;EACC,WAAA;A/B+xZF;;A+B3xZA;;yBAAA;AAGA;EACC,kBAAA;A/B8xZD;A+B5xZE;EACC,kBAAA;A/B8xZH;A+B7xZG;EACC,oBAAA;A/B+xZJ;A+B9xZI;EAFD;IAGE,WAAA;E/BiyZH;AACF;A+BhyZI;EALD;IAME,WAAA;E/BmyZH;AACF;A+BjyZG;EACC,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;A/BmyZJ;A+BjyZI;EACC,yBAAA;EACA,eAAA;A/BmyZL;A+B9xZI;EACC,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;A/BgyZL;A+B9xZK;EAVD;IAWE,UAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;E/BiyZJ;AACF;A+BhyZK;EAhBD;IAiBE,UAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;E/BmyZJ;AACF;A+BlyZK;EACC,aAAA;EACA,kBAAA;EACA,mBAAA;A/BoyZN;A+BnyZM;EACC,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;A/BqyZP;A+BpyZO;EACC,yBAAA;A/BsyZR;A+BnyZM;EACC,gBAAA;A/BqyZP;A+BpyZO;EACC,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A/BsyZR;A+BpyZO;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;A/BsyZR;;A+B5xZA;;yBAAA;AAGA;EACC,kBAAA;A/B+xZD;A+B9xZC;EACC,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;A/BgyZF;A+B/xZE;EAND;IAOE,gBAAA;IACA,kBAAA;IACA,eAAA;E/BkyZD;AACF;A+BjyZE;EAXD;IAYE,kBAAA;E/BoyZD;AACF;A+BnyZE;EAdD;IAeE,eAAA;IACA,cAAA;IACA,gBAAA;E/BsyZD;AACF;A+BryZE;EACC,kBAAA;A/BuyZH;A+BpyZG;EADD;IAEE,WAAA;E/BuyZF;AACF;A+BryZE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;A/BuyZH;A+BryZG;EAND;IAOE,YAAA;E/BwyZF;AACF;A+BtyZG;EAVD;IAWE,QAAA;E/ByyZF;AACF;A+BvyZE;EACC,kBAAA;EACA,YAAA;EACA,aAAA;A/ByyZH;A+BvyZG;EALD;IAME,WAAA;IACA,cAAA;E/B0yZF;AACF;A+BxyZG;EAVD;IAWE,QAAA;E/B2yZF;AACF;A+BzyZG;EAdD;IAeE,QAAA;E/B4yZF;AACF;A+B3yZG;EAjBD;IAkBE,aAAA;E/B8yZF;AACF;A+B7yZG;EACC,yBAAA;A/B+yZJ;;A+BzyZA;;yBAAA;AAKC;EACC,kBAAA;EACA,UAAA;A/B0yZF;A+BzyZE;EACC,kCAAA;A/B2yZH;A+B1yZG;EAFD;IAGE,8BAAA;E/B6yZF;AACF;A+B5yZG;EALD;IAME,8BAAA;E/B+yZF;AACF;A+B7yZE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;A/B+yZH;A+B7yZG;EAVD;IAWE,YAAA;IACA,OAAA;IACA,MAAA;E/BgzZF;AACF;A+B9yZG;EAhBD;IAiBE,YAAA;IACA,OAAA;IACA,MAAA;E/BizZF;AACF;A+B/yZG;EAtBD;IAuBE,YAAA;IACA,OAAA;IACA,MAAA;E/BkzZF;AACF;A+BhzZG;EACC,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;A/BkzZJ;A+BhzZI;EACC,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;A/BkzZL;A+BhzZI;EACC,sCAAA;A/BkzZL;A+B9yZE;EACC,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,kCAAA;EACA,WAAA;A/BgzZH;A+B/yZG;EAVD;IAWE,8BAAA;E/BkzZF;AACF;A+BjzZG;EAbD;IAcE,aAAA;E/BozZF;AACF;A+BhzZE;EADD;IAEE,kBAAA;E/BmzZD;AACF;A+BlzZE;EACC,aAAA;EACA,SAAA;EACA,iBAAA;A/BozZH;A+BnzZG;EACC,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;A/BqzZJ;A+BpzZI;EAVD;IAWE,gBAAA;IACA,gBAAA;E/BuzZH;AACF;A+BrzZI;EAfD;IAgBE,gBAAA;E/BwzZH;AACF;A+BtzZI;EAnBD;IAoBE,gBAAA;E/ByzZH;AACF;A+BvzZI;EAvBD;IAwBE,gBAAA;E/B0zZH;AACF;A+BxzZI;EACC,kBAAA;EACA,6BAAA;EACA,eAAA;A/B0zZL;A+BtzZE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;A/BwzZH;A+BtzZG;EARD;IASE,iBAAA;E/ByzZF;AACF;A+BvzZG;EAZD;IAaE,cAAA;IACA,gBAAA;IACA,cAAA;E/B0zZF;AACF;A+BxzZG;EACC,6BAAA;A/B0zZJ;A+BxzZG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,qBAAA;A/B0zZJ;;A+BnzZC;EACC,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A/BszZF;A+BrzZE;EAPD;IAQE,eAAA;E/BwzZD;AACF;A+BvzZE;EAVD;IAWE,eAAA;E/B0zZD;AACF;A+BzzZE;EACC,kBAAA;A/B2zZH;A+BzzZE;EACC,aAAA;A/B2zZH;A+B1zZG;EAFD;IAGE,eAAA;E/B6zZF;AACF;A+B5zZG;EALD;IAME,eAAA;E/B+zZF;AACF;A+B9zZG;EARD;IASE,gBAAA;IACA,kBAAA;E/Bi0ZF;AACF;;A+B1zZE;EADD;IAEE,0BAAA;E/B8zZD;AACF;;A+B1zZA;;yBAAA;AAIC;EACC,mBAAA;EACA,mBAAA;EACA,iBAAA;A/B4zZF;A+B3zZE;EAJD;IAKE,kBAAA;E/B8zZD;AACF;A+B7zZE;EAPD;IAQE,mBAAA;IACA,eAAA;E/Bg0ZD;AACF;A+B/zZE;EAXD;IAYE,cAAA;IACA,eAAA;IACA,aAAA;E/Bk0ZD;AACF;A+Bh0ZC;EACC,iCAAA;A/Bk0ZF;A+Bj0ZE;EAFD;IAGE,0BAAA;E/Bo0ZD;AACF;A+Bn0ZE;EALD;IAME,0BAAA;E/Bs0ZD;AACF;;AgCjgbA;;0BAAA;AAIC;EACC,kBAAA;EACA,qBAAA;AhCmgbF;AgClgbE;EAHD;IAIE,cAAA;EhCqgbD;AACF;AgCpgbE;EACC,YAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AhCsgbH;AgCrgbG;EAVD;IAWE,eAAA;IACA,YAAA;EhCwgbF;AACF;AgCvgbG;EACC,YAAA;EACA,gBAAA;EACA,oBAAA;AhCygbJ;AgCxgbI;EAJD;IAKE,eAAA;IACA,mBAAA;IACA,kBAAA;EhC2gbH;AACF;AgCxgbE;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AhC0gbH;AgCxgbE;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,uBAAA;AhC0gbH;AgCzgbG;EACC,eAAA;EACA,2BAAA;AhC2gbJ;AgCvgbE;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AhCygbH;AgCxgbG;EALD;IAME,gBAAA;IACA,eAAA;IACA,cAAA;IACA,gBAAA;EhC2gbF;AACF;;AgCpgbA;EACC,kBAAA;AhCugbD;AgCtgbC;EACC,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AhCwgbF;AgCtgbC;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;AhCwgbF;;AgCngbA;EACC,0DAAA;EACA,kBAAA;AhCsgbD;AgCrgbC;EACC,iBAAA;AhCugbF;AgCtgbE;EAFD;IAGE,cAAA;IACA,gBAAA;EhCygbD;AACF;AgCxgbE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AhC0gbH;AgCzgbG;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AhC2gbJ;AgCzgbG;EACC,iBAAA;AhC2gbJ;AgCxgbI;EACC,WAAA;EACA,OAAA;EACA,WAAA;AhC0gbL;;AgClgbA;EACC,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0DAAA;AhCqgbD;AgCngbC;EARD;IASE,eAAA;EhCsgbA;AACF;AgCrgbC;EAXD;IAYE,eAAA;IACA,kBAAA;EhCwgbA;AACF;AgCvgbC;EAfD;IAgBE,eAAA;IACA,kBAAA;EhC0gbA;AACF;AgCzgbC;EAnBD;IAoBE,eAAA;IACA,kBAAA;EhC4gbA;AACF;;AgCzgbA;EACC,kBAAA;EACA,kBAAA;AhC4gbD;AgC3gbC;EAHD;IAIE,iBAAA;EhC8gbA;AACF;;AgC3gbA;EACC,6BAAA;AhC8gbD;AgC7gbC;EAFD;IAGE,6BAAA;EhCghbA;AACF;AgC/gbC;EALD;IAME,6BAAA;EhCkhbA;AACF;;AiCxsbA;;4BAAA;AAGA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AjC2sbJ;AiC1sbI;EACI,WAAA;AjC4sbR;AiC3sbQ;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AjC6sbZ;AiC5sbY;EACI,gCAAA;EACA,yBAAA;AjC8sbhB;AiCvsbY;EACI,uBAAA;EACA,uCAAA;EACA,2BAAA;EACA,mBAAA;AjCysbhB;AiCxsbgB;EACI,kCAAA;EACA,gCAAA;EACA,yBAAA;AjC0sbpB;AiCpsbI;EACI,eAAA;AjCssbR;AiCrsbQ;EACI,cAAA;AjCusbZ;AiCtsbY;EACI,uBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;AjCwsbhB;AiCvsbgB;EACI,2BAAA;AjCysbpB;AiCpsbI;EACI,cAAA;AjCssbR;AiCrsbQ;EACI,aAAA;AjCusbZ;AiCtsbY;EACI,uBAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uCAAA;EACA,mBAAA;EACA,eAAA;AjCwsbhB;AiCvsbgB;EACI,yBAAA;EACA,gCAAA;EACA,kCAAA;AjCysbpB;AiClsbY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AjCosbhB;;AkChybA;;4BAAA;AAkCA;EACI,cAAA;AlC2xbJ;;AkCxxbA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EAEA,4BAAA;AlC2xbJ;AkCzxbI;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AlC2xbR;AkCxxbI;EACI,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;AlC0xbR;AkCtxbQ;EACI,4BAAA;AlCwxbZ;AkCpxbI;EACI,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;AlCsxbR;AkCnxbQ;EACI,UAAA;AlCqxbZ;AkClxbY;EACI,6BAAA;EACA,eAAA;EACA,sBAAA;EAEA,4BAAA;AlCoxbhB;;AmCz4bA;;6BAAA;AAMQ;EACI,yBAAA;EACA,gBAAA;EACA,mBAAA;AnCy4bZ;AmCx4bY;EAJJ;IAKQ,gBAAA;IACA,mBAAA;EnC24bd;AACF;AmC14bY;EARJ;IASQ,gBAAA;IACA,mBAAA;EnC64bd;AACF;;AoC95bA;;6BAAA;AAGA;EACI,YAAA;EACA,8BAAA;EACA,6CAAA;EACA,mBAAA;ApCi6bJ;;AoC95bA;EACI,kBAAA;ApCi6bJ;AoC/5bQ;EAEI,oDAAA;EAEA,sBAAA;EAEA,kBAAA;EAEA,4BAAA;ApCi6bZ;AoC75bI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ApC+5bR;AoC55bI;EACI,kBAAA;ApC85bR;;AoC15bA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,qBAAA;ApC65bJ;AoCz5bQ;EAEI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EAEA,6BAAA;EACA,kBAAA;EACA,sCAAA;ApC05bZ;AoCx5bQ;EAEI,oCAAA;ApC05bZ;AoCv5bQ;EAEI,uCAAA;ApCy5bZ;AoCr5bI;EACI,WAAA;EACA,YAAA;EACA,eAAA;ApCu5bR;AoCt5bQ;EAJJ;IAKQ,WAAA;IACA,YAAA;IACA,kBAAA;EpCy5bV;AACF;AoCx5bQ;EATJ;IAUQ,WAAA;IACA,YAAA;EpC25bV;AACF;AoCx5bI;EACI,WAAA;EACA,YAAA;EACA,eAAA;ApC05bR;AoCz5bQ;EAJJ;IAKQ,WAAA;IACA,YAAA;IACA,eAAA;EpC45bV;AACF;AoC35bQ;EATJ;IAUQ,WAAA;IACA,YAAA;IACA,kBAAA;EpC85bV;AACF;AoC75bQ;EAdJ;IAeQ,WAAA;IACA,YAAA;EpCg6bV;AACF;AoC75bI;EACI,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ApC+5bR;AoC75bQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iCAAA;EACA,oCAAA;EACA,4CAAA;ApC+5bZ;AoC35bI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;ApC65bR;AoC15bI;EACI,cAAA;EACA,gCAAA;ApC45bR;AoC15bQ;EACI,kCAAA;ApC45bZ;AoCz5bQ;EACI,kCAAA;ApC25bZ;AoCv5bY;EACI,0CAAA;ApCy5bhB;AoCp5bI;EACI,cAAA;EACA,kCAAA;ApCs5bR;AoCp5bQ;EACI,oCAAA;ApCs5bZ;AoCn5bQ;EACI,oCAAA;ApCq5bZ;AoCj5bY;EACI,0CAAA;ApCm5bhB;;AoC54bA;EACI,kBAAA;EACA,UAAA;ApC+4bJ;AoC94bI;EACI,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;EACA,gCAAA;ApCg5bR;AoC94bQ;EAXJ;IAYQ,aAAA;EpCi5bV;AACF;AoC/4bI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;ApCi5bR;AoCh5bQ;EACI,+CAAA;ApCk5bZ;AoCh5bQ;EARJ;IASQ,aAAA;EpCm5bV;AACF;;AoC94bA,gBAAA;AAoBA;EACI;IAEI,mBAAA;EpC84bN;EoC34bE;IAEI,qBAAA;IACA,UAAA;EpC64bN;EoC14bE;IAEI,qBAAA;IACA,UAAA;EpC44bN;AACF;AoCt3bA;EACI;IACI,iBAAA;IAEA,mBAAA;EpCu4bN;EoCp4bE;IACI,iBAAA;IAEA,sBAAA;EpCs4bN;EoCn4bE;IACI,UAAA;EpCq4bN;AACF;AqCpqcA;;gCAAA;AAIA;EACI,kBAAA;ArCqqcJ;AqClqcY;EACI,mBAAA;ArCoqchB;AqChqcI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;ArCkqcR;AqChqcI;EACI,oBAAA;ArCkqcR;AqCjqcQ;EAFJ;IAGQ,eAAA;ErCoqcV;AACF;;AqC9pcQ;EADJ;IAEQ,gBAAA;ErCkqcV;AACF;;AsCjscA;;8BAAA;AAKA;EACI,iBAAA;EACA,kBAAA;AtCkscJ;AsC/rcY;EACI,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AtCischB;AsC/rcY;EACI,eAAA;EACA,iBAAA;AtCischB;AsC7rcI;EACI,kBAAA;EACA,UAAA;AtC+rcR;AsC9rcQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AtCgscZ;AsC7rcY;EADJ;IAEQ,oBAAA;EtCgscd;AACF;AsC7rcI;EACI,kBAAA;EACA,kBAAA;AtC+rcR;AsC7rcY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;AtC+rchB;AsC9rcgB;EALJ;IAMQ,aAAA;EtCisclB;AACF;;AuCpvcA;;0BAAA;AAII;EACI,mBAAA;AvCsvcR;AuCrvcQ;EACI,aAAA;AvCuvcZ;;AuCjvcA;EACI,aAAA;AvCovcJ;;AuCjvcA;EACI,eAAA;EACA,kBAAA;AvCovcJ;AuCnvcI;EAHJ;IAIQ,SAAA;EvCsvcN;AACF;AuCrvcI;EACI,eAAA;AvCuvcR;AuCtvcQ;EAFJ;IAGQ,UAAA;EvCyvcV;AACF;;AuCpvcI;EACI,gBAAA;AvCuvcR;;AuCjvcI;EACI,aAAA;EAOA,cAAA;AvC8ucR;AuCpvcQ;EAFJ;IAGQ,aAAA;EvCuvcV;AACF;AuCtvcQ;EALJ;IAMQ,aAAA;EvCyvcV;AACF;AuCvvcQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AvCyvcZ;AuCxvcY;EACI,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;EACA,qBAAA;AvC0vchB;AuCxvcY;EACI,aAAA;AvC0vchB;AuCvvcY;EACI,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AvCyvchB;AuCxvcgB;EACI,aAAA;AvC0vcpB;AuCrvcgB;EACI,kCAAA;EACA,UAAA;EACA,mBAAA;AvCuvcpB;AuCrvcgB;EACI,gCAAA;AvCuvcpB;AuCjvcQ;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;AvCmvcZ;AuCjvcY;EAPJ;IAQQ,aAAA;EvCovcd;AACF;AuClvcY;EAXJ;IAYQ,aAAA;EvCqvcd;AACF;AuCnvcY;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AvCqvchB;AuCpvcgB;EACI,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AvCsvcpB;AuCnvcoB;EACI,kCAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AvCqvcxB;AuC9ucQ;EACI,aAAA;AvCgvcZ;AuC7ucY;EADJ;IAEQ,mBAAA;EvCgvcd;AACF;;AuC3ucA;EACI,kBAAA;AvC8ucJ;AuC7ucI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AvC+ucR;AuC7ucQ;EAhBJ;IAiBQ,WAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,YAAA;EvCgvcV;AACF;AuC9ucQ;EACI,gCAAA;EACA,yBAAA;AvCgvcZ;AuC9ucQ;EACI,YAAA;AvCgvcZ;AuC/ucY;EAFJ;IAGQ,WAAA;EvCkvcd;AACF;;AuC1ucI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AvC6ucR;AuC5ucQ;EAfJ;IAgBQ,SAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;EvC+ucV;AACF;AuC9ucQ;EACI,gCAAA;EACA,yBAAA;AvCgvcZ;AuC9ucQ;EACI,WAAA;AvCgvcZ;AuC/ucY;EAFJ;IAGQ,WAAA;IACA,UAAA;EvCkvcd;AACF;;AwC79cA;;2BAAA;AAIA;EACI,8BAAA;EACA,6CAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AxC+9cJ;AwC79cQ;EACI,mBAAA;AxC+9cZ;AwC99cY;EACI,gBAAA;AxCg+chB;AwC59cY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AxC89chB;AwC59cY;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;AxC89chB;AwC19cI;EACI,4BAAA;AxC49cR;AwCz9cgB;EACI,2BAAA;AxC29cpB;;AyChgdA;;8BAAA;AAGA;EACI,8BAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AzCmgdJ;AyCjgdI;EAPJ;IAQQ,kBAAA;EzCogdN;AACF;AyClgdI;EAXJ;IAYQ,kBAAA;EzCqgdN;AACF;AyCngdI;EAfJ;IAgBQ,kBAAA;EzCsgdN;AACF;AyCpgdQ;EACI,mBAAA;AzCsgdZ;AyCrgdY;EACI,gBAAA;AzCugdhB;AyCngdY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AzCqgdhB;AyCngdY;EACI,qBAAA;AzCqgdhB;;AyC7/cA;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;AzCggdJ;;AyC9/cA;EACI,kBAAA;EACA,UAAA;AzCigdJ;AyC//cI;EACI,kBAAA;AzCigdR;AyChgdQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AzCkgdZ;AyCjgdY;EATJ;IAUQ,aAAA;EzCogdd;AACF;AyCjgdY;EACI,aAAA;AzCmgdhB;AyC//cY;EACI,mBAAA;EACA,YAAA;AzCigdhB;;AyC1/cI;EACI,kBAAA;AzC6/cR;AyC5/cQ;EACI,kBAAA;AzC8/cZ;AyC7/cY;EACI,yBAAA;EACA,eAAA;AzC+/chB;AyC3/cY;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AzC6/chB;AyC5/cgB;EACI,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AzC8/cpB;AyC3/cY;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AzC6/chB;AyCv/cQ;EACI,kBAAA;AzCy/cZ;AyCv/cgB;EACI,2BAAA;EACA,eAAA;AzCy/cpB;AyCr/cgB;EACI,2BAAA;AzCu/cpB;AyCt/coB;EACI,2BAAA;AzCw/cxB;AyCr/cgB;EACI,wBAAA;AzCu/cpB;;A0C3ndA;EACI,0DAAA;A1C8ndJ;A0C1ndY;EACI,6BAAA;A1C4ndhB;;A0CtndA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;A1CyndJ;A0CxndI;EACI,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;A1C0ndR;A0CxndQ;EACI,cAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A1C0ndZ;A0CxndQ;EACI,cAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A1C0ndZ;A0CxndQ;EACI,YAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;A1C0ndZ;A0CvndY;EACI,aAAA;A1CyndhB;;A0ClndI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;A1CqndR;A0CpndQ;EALJ;IAMQ,uBAAA;E1CundV;AACF;A0CtndQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A1CwndZ;A0CvndY;EAXJ;IAYQ,aAAA;IACA,eAAA;IACA,sBAAA;E1C0ndd;AACF;A0CzndY;EACI,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A1C2ndhB;A0C1ndgB;EAXJ;IAYQ,eAAA;E1C6ndlB;AACF;A0C3ndY;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;A1C6ndhB;A0C5ndgB;EATJ;IAUQ,eAAA;E1C+ndlB;AACF;A0C7ndY;EACI,aAAA;A1C+ndhB;A0C5ndgB;EACI,aAAA;A1C8ndpB;A0C1ndY;EACI,gCAAA;EACA,gDAAA;A1C4ndhB;A0C3ndgB;EACI,yBAAA;A1C6ndpB;A0C3ndgB;EACI,yBAAA;A1C6ndpB;;A0CrndI;EACI,gBAAA;A1CwndR;A0CvndQ;EAFJ;IAGQ,eAAA;E1C0ndV;AACF;A0CzndQ;EALJ;IAMQ,YAAA;E1C4ndV;AACF;;A2CjxdA;;+BAAA;AAMQ;EACI,kBAAA;A3CixdZ;A2C9wdI;EACI,mBAAA;A3CgxdR;A2C/wdQ;EACI,SAAA;A3CixdZ;A2ChxdY;EACI,wBAAA;A3CkxdhB;A2C/wdgB;EACI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;A3CixdpB;;A4CxydA;EACI,eAAA;A5C2ydJ;A4C1ydI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;A5C4ydR;A4C3ydQ;EAJJ;IAKQ,UAAA;E5C8ydV;AACF;A4C7ydQ;EAPJ;IAQQ,UAAA;E5CgzdV;AACF;A4C/ydQ;EAVJ;IAWQ,WAAA;E5CkzdV;AACF;A4ChzdI;EACI,aAAA;A5CkzdR;A4CjzdQ;EAFJ;IAGQ,UAAA;E5CozdV;AACF;A4CnzdQ;EALJ;IAMQ,UAAA;E5CszdV;AACF;A4CrzdQ;EARJ;IASQ,WAAA;E5CwzdV;AACF;;A4ClzdI;EACI,aAAA;A5CqzdR;A4CpzdQ;EAFJ;IAGQ,UAAA;E5CuzdV;AACF;A4CtzdQ;EALJ;IAMQ,UAAA;E5CyzdV;AACF;A4CxzdQ;EARJ;IASQ,WAAA;E5C2zdV;AACF;A4CzzdI;EACI,aAAA;A5C2zdR;A4C1zdQ;EAFJ;IAGQ,UAAA;E5C6zdV;AACF;A4C5zdQ;EALJ;IAMQ,UAAA;E5C+zdV;AACF;A4C9zdQ;EARJ;IASQ,WAAA;E5Ci0dV;AACF;;A4C7zdA;EACI,eAAA;A5Cg0dJ;A4C/zdI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;A5Ci0dR;A4Ch0dQ;EAJJ;IAKQ,UAAA;E5Cm0dV;AACF;A4Cl0dQ;EAPJ;IAQQ,UAAA;E5Cq0dV;AACF;A4Cp0dQ;EAVJ;IAWQ,WAAA;E5Cu0dV;AACF;A4Cr0dI;EACI,UAAA;A5Cu0dR;A4Ct0dQ;EAFJ;IAGQ,UAAA;E5Cy0dV;AACF;A4Cx0dQ;EALJ;IAMQ,UAAA;E5C20dV;AACF;A4C10dQ;EARJ;IASQ,WAAA;E5C60dV;AACF;;A4Cx0dA;EACI,eAAA;A5C20dJ;A4C10dI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;A5C40dR;A4C30dQ;EAJJ;IAKQ,aAAA;E5C80dV;AACF;A4C70dQ;EAPJ;IAQQ,UAAA;E5Cg1dV;AACF;A4C/0dQ;EAVJ;IAWQ,UAAA;E5Ck1dV;AACF;A4Cj1dQ;EAbJ;IAcQ,WAAA;E5Co1dV;AACF;A4Cl1dI;EACI,UAAA;A5Co1dR;A4Cn1dQ;EAFJ;IAGQ,aAAA;E5Cs1dV;AACF;A4Cr1dQ;EALJ;IAMQ,UAAA;E5Cw1dV;AACF;A4Cv1dQ;EARJ;IASQ,UAAA;E5C01dV;AACF;A4Cz1dQ;EAXJ;IAYQ,WAAA;E5C41dV;AACF;;A6Cr9dA;;0BAAA;AAGA;EACI,cAAA;EACA,cAAA;EACA,uBAAA;A7Cw9dJ;A6Cv9dI;EACI,aAAA;A7Cy9dR;A6Ct9dgB;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;A7Cw9dpB;A6Cv9doB;EAbJ;IAcQ,eAAA;E7C09dtB;AACF;A6Cz9doB;EACI,kBAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;A7C29dxB;A6Cz9doB;EACI,gCAAA;EACA,yBAAA;A7C29dxB;A6C19dwB;EACI,YAAA;A7C49d5B;;A6Cn9dA;EACI,kBAAA;EACA,UAAA;A7Cs9dJ;A6Cr9dI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;A7Cu9dR;;A6Cj9dI;EACI,mBAAA;A7Co9dR;A6Cn9dQ;EAFJ;IAGQ,mBAAA;E7Cs9dV;AACF;A6Cr9dQ;EALJ;IAMQ,mBAAA;E7Cw9dV;AACF;;A6Cn9dI;EACI,gBAAA;A7Cs9dR;A6Cp9dI;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A7Cs9dR;A6Cr9dQ;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;A7Cu9dZ;A6Cp9dY;EACI,gBAAA;A7Cs9dhB;A6Cl9dI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A7Co9dR;A6C/8dY;EACI,gCAAA;A7Ci9dhB;A6C98dgB;EACI,kBAAA;A7Cg9dpB;A6C78dY;EACI,gCAAA;A7C+8dhB;;A6Cx8dA;EACI,mBAAA;A7C28dJ;A6C18dI;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;A7C48dR;A6C38dQ;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;A7C68dZ;A6C18dY;EACI,gBAAA;EACA,wBAAA;A7C48dhB;A6Cv8dI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;A7Cy8dR;A6Ct8dY;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;A7Cw8dhB;A6Ct8doB;EACI,iBAAA;A7Cw8dxB;A6Cr8dgB;EACI,0BAAA;A7Cu8dpB;A6Cr8dgB;EACI,iBAAA;A7Cu8dpB;A6Cj8dI;EACI,gBAAA;A7Cm8dR;A6Cj8dY;EACI,gCAAA;A7Cm8dhB;A6Ch8dQ;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;A7Ck8dZ;A6Cj8dY;EACI,cAAA;EACA,2BAAA;A7Cm8dhB;A6Cl8dgB;EACI,2BAAA;A7Co8dpB;A6C/7dQ;EACI,gBAAA;A7Ci8dZ;A6C57dQ;EACI,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;A7C87dZ;A6C77dY;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;A7C+7dhB;A6C57dgB;EACI,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;A7C87dpB;A6Cz7dY;EACI,eAAA;EACA,oBAAA;A7C27dhB;A6C17dgB;EACI,gBAAA;A7C47dpB;A6Cx7dY;EACI,mBAAA;EACA,6CAAA;EACA,mBAAA;A7C07dhB;A6Cz7dgB;EACI,cAAA;EACA,2BAAA;EACA,uBAAA;A7C27dpB;A6Cx7dY;EACI,gBAAA;A7C07dhB;A6Cp7doB;EACI,gCAAA;EACA,cAAA;A7Cs7dxB;A6Ch7doB;EACI,2BAAA;A7Ck7dxB;;A8ClteQ;EACI,gBAAA;A9CqteZ;A8CjteI;;;;;;EAMI,mBAAA;A9CmteR;;A8C3seA,oBAAA;AAEA;EACI,aAAA;EACA,eAAA;EACA,aAAA;A9C6seJ;A8C3seQ;EACI,eAAA;EACA,aAAA;A9C6seZ;;A+C3ueA;;0BAAA;AAGA;EAWI,qBAAA;A/CoueJ;A+C7ueQ;EACI,mBAAA;A/C+ueZ;A+C5ueQ;EACI,mBAAA;A/C8ueZ;A+CxueI;EAbJ;IAcQ,oBAAA;E/C2ueN;AACF;;A+CrueA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;A/CwueJ;A+CvueI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,oBAAA;EACA,qDAAA;A/CyueR;A+CvueQ;EACI,8CAAA;A/CyueZ;A+CtueQ;EACI,4BAAA;EACA,8CAAA;A/CwueZ;A+CrueQ;EACI,sBAAA;EACA,8CAAA;A/CuueZ;;A+CjueA;EACI;IACI,uBAAA;E/CoueN;E+CjueE;IACI,yBAAA;E/CmueN;AACF;AgDtyeA,wBAAA;AAEA;EACI,kBAAA;AhDuyeJ;AgDryeQ;EACI,mBAAA;AhDuyeZ;AgDtyeY;EAFJ;IAGQ,mBAAA;EhDyyed;AACF;AgDxyeY;EALJ;IAMQ,mBAAA;EhD2yed;AACF;AgD1yeY;EACI,cAAA;AhD4yehB;AgDzyeQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AhD2yeZ;AgD1yeY;EALJ;IAMQ,eAAA;IACA,mBAAA;EhD6yed;AACF;AgD5yeY;EATJ;IAUQ,eAAA;IACA,mBAAA;EhD+yed;AACF;AgD7yeQ;EACI,mBAAA;AhD+yeZ;AgD9yeY;EAEQ;IACI,gBAAA;IACA,kBAAA;EhD+yetB;EgD9yesB;IACI,eAAA;EhDgze1B;EgD9yesB;IACI,eAAA;EhDgze1B;AACF;AgD5yeY;EAEQ;IACI,gBAAA;IACA,kBAAA;EhD6yetB;EgD5yesB;IACI,eAAA;EhD8ye1B;EgD5yesB;IACI,eAAA;EhD8ye1B;AACF;AgD1yeY;EAEQ;IACI,eAAA;IACA,kBAAA;EhD2yetB;EgD1yesB;IACI,eAAA;EhD4ye1B;EgD1yesB;IACI,eAAA;EhD4ye1B;AACF;AgDvyeQ;EACI,mBAAA;EACA,gBAAA;AhDyyeZ;;AgDpyeA;EACI,aAAA;EACA,uBAAA;AhDuyeJ;AgDtyeI;EAHJ;IAIQ,cAAA;EhDyyeN;AACF;AgDxyeI;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AhD0yeR;AgDzyeQ;EAVJ;IAWQ,gBAAA;IACA,YAAA;EhD4yeV;AACF;AgD3yeQ;EAdJ;IAeQ,eAAA;IACA,WAAA;EhD8yeV;AACF;AgD5yeI;EACI,iBAAA;AhD8yeR;AgD7yeQ;EAFJ;IAGQ,cAAA;IACA,gBAAA;EhDgzeV;AACF;;AiDj6eA;;qBAAA;AAGA;EACI,cAAA;EACA,eAAA;AjDo6eJ;AiDn6eI;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AjDq6eR;AiDn6eQ;EAEI,gCAAA;EACA,yBAAA;AjDo6eZ;;AiD/5eA;EACI,cAAA;EACA,kBAAA;EACA,0BAAA;AjDk6eJ;AiDj6eI;EACI,kBAAA;AjDm6eR;AiDl6eQ;EACI,kBAAA;AjDo6eZ;AiDl6eQ;EACI,+EAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AjDo6eZ;AiDl6eQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;AjDo6eZ;AiDn6eY;EACI,yBAAA;EACA,eAAA;AjDq6ehB;AiDl6eQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AjDo6eZ;AiDn6eY;EARJ;IASQ,kBAAA;EjDs6ed;AACF;AiDn6eoB;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AjDq6exB;AiDp6ewB;EAPJ;IAQQ,eAAA;IACA,iBAAA;EjDu6e1B;AACF;AiD/5eY;EACI,UAAA;AjDi6ehB;AiD/5eY;EACI,UAAA;AjDi6ehB;AiD/5eY;EACI,UAAA;AjDi6ehB;;AkDlgfA;;6BAAA;AAGA;EACI,0DAAA;AlDqgfJ;;AkDlgfA;EACI,iBAAA;AlDqgfJ;AkDpgfI;EAFJ;IAGQ,gBAAA;ElDugfN;AACF;AkDtgfI;EAEI,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AlDugfR;AkDtgfQ;EACI,WAAA;EACA,SAAA;AlDwgfZ;AkDvgfY;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AlDygfhB;AkDxgfgB;EACI,gCAAA;EACA,yBAAA;AlD0gfpB;;AkDlgfA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AlDqgfJ;AkDngfI;EAPJ;IAQQ,kBAAA;ElDsgfN;AACF;AkDpgfI;EAXJ;IAYQ,kBAAA;ElDugfN;AACF;AkDrgfI;EACI,mBAAA;EACA,kBAAA;AlDugfR;AkDrgfY;EACI,aAAA;AlDugfhB;AkDrgfY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AlDugfhB;AkDrgfY;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,iBAAA;AlDugfhB;AkDngfQ;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AlDqgfZ;AkDjgfI;EACI,mBAAA;AlDmgfR;AkDhgfY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AlDkgfhB;AkDjgfgB;EACI,6BAAA;EACA,kBAAA;AlDmgfpB;AkDjgfgB;EACI,gBAAA;AlDmgfpB;AkD7/eI;EACI,4BAAA;AlD+/eR;AkD9/eQ;EACI,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlDggfZ;AkD9/eY;EACI,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AlDggfhB;AkD9/eY;EACI,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,sDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AlDggfhB;;AmD3ofA;;2BAAA;AAGA;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;AnD8ofJ;AmD7ofI;EACI,kBAAA;AnD+ofR;AmD9ofQ;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AnDgpfZ;AmD/ofY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AnDipfhB;AmD7ofY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AnD+ofhB;AmD7ofY;EACI,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AnD+ofhB;AmD7ofY;EACI,mBAAA;AnD+ofhB;AmD9ofgB;EACI,kBAAA;AnDgpfpB;AmD/ofoB;EACI,gBAAA;EACA,2BAAA;AnDipfxB;AmD/ofoB;EACI,wBAAA;AnDipfxB;AmD7ofY;EACI,gBAAA;AnD+ofhB;;AmDpofA,wBAAA;AAEI;EACI,kBAAA;AnDsofR;AmDpofY;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,OAAA;AnDsofhB;;AmD7nfQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AnDgofZ;AmD9nfQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AnDgofZ;;AoD9tfA;EACI,kBAAA;EACA,gBAAA;ApDiufJ;AoDhufI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;ApDkufR;;AoD9tfA;EACI,WAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;ApDiufJ;AoD/tfI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;ApDiufR;AoD9tfI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;ApDgufR;;AqDrwfA;;4BAAA;AAKA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ArDswfJ;AqDpwfQ;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ArDswfZ;AqDrwfY;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;ArDuwfhB;AqDnwfY;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ArDqwfhB;AqDnwfY;EACI,gBAAA;EACA,gBAAA;ArDqwfhB;AqDpwfgB;EACI,wBAAA;EACA,gBAAA;ArDswfpB;AqDrwfoB;EACI,2BAAA;ArDuwfxB;AqD9vfY;EACI,mCAAA;ArDgwfhB;AqD/vfgB;EACI,6BAAA;ArDiwfpB;AqDzvfY;EACI,mCAAA;ArD2vfhB;AqD1vfgB;EACI,cAAA;ArD4vfpB;AqDtvfI;EACI,kCAAA;EACA,4BAAA;ArDwvfR;AqDtvfY;EACI,8BAAA;ArDwvfhB;AqDvvfgB;EACI,6BAAA;ArDyvfpB;AqDrvfgB;EACI,yBAAA;ArDuvfpB;AqDrvfgB;EACI,yBAAA;ArDuvfpB;AqDtvfoB;EACI,yBAAA;ArDwvfxB;;AqD9ufA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ArDivfJ;AqDhvfI;EAPJ;IAQQ,kBAAA;ErDmvfN;AACF;AqDlvfI;EAVJ;IAWQ,kBAAA;ErDqvfN;AACF;AqDlvfQ;EACI,mBAAA;ArDovfZ;AqD9ufY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ArDgvfhB;AqD9ufY;EACI,gBAAA;EACA,iBAAA;ArDgvfhB;AqD/ufgB;EACI,gBAAA;EACA,2BAAA;ArDivfpB;AqD/ufgB;EACI,gBAAA;ArDivfpB;AqD5ufI;EACI,4BAAA;ArD8ufR;;AqDzufA;EACI,kBAAA;EACA,UAAA;ArD4ufJ;AqD3ufI;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;ArD6ufR;;AqDtufA;;gCAAA;AAKQ;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;ArDuufZ;AqDtufY;EACI,kCAAA;ArDwufhB;AqDrufQ;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ArDuufZ;AqDtufY;EACI,kCAAA;ArDwufhB;AqDpufI;EACI,gBAAA;EACA,cAAA;ArDsufR;;AqDjufA;;6BAAA;AAII;EACI,kBAAA;EACA,kBAAA;ArDmufR;AqDlufQ;EACI,0EAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ArDoufZ;AqDlufQ;EACI,kBAAA;ArDoufZ;AqDlufQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;ArDoufZ;AqDnufY;EAPJ;IAQQ,kBAAA;ErDsufd;AACF;AqDrufY;EACI,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;ArDuufhB;AqDtufgB;EALJ;IAMQ,eAAA;IACA,iBAAA;ErDyuflB;AACF;;AqDlufI;EACI,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;ArDqufR;AqDpufQ;EALJ;IAMQ,cAAA;IACA,eAAA;IACA,eAAA;ErDuufV;AACF;AqDtufQ;EACI,WAAA;ArDwufZ;;AsD9+fA;;yBAAA;AAKA;EACI,gBAAA;AtD++fJ;AsD9+fI;EACI,kBAAA;AtDg/fR;AsD/+fQ;EACI,kBAAA;AtDi/fZ;AsDh/fY;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AtDk/fhB;AsDj/fgB;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AtDm/fpB;AsDl/foB;EACI,aAAA;AtDo/fxB;AsDh/fY;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gCAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AtDk/fhB;AsDj/fgB;EAEI,aAAA;AtDk/fpB;AsDj/foB;EACI,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AtDm/fxB;AsDl/fwB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AtDo/f5B;AsDj/f4B;EACI,kBAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AtDm/fhC;AsDh/fwB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AtDk/f5B;AsDh/fwB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AtDk/f5B;AsD5+fQ;EACI,iBAAA;AtD8+fZ;AsD7+fY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AtD++fhB;AsD7+fY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AtD++fhB;AsD5+fgB;EACI,YAAA;AtD8+fpB;AsD7+foB;EACI,WAAA;AtD++fxB;AsD7+foB;EACI,eAAA;EACA,iBAAA;EACA,2BAAA;AtD++fxB;AsD7+foB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AtD++fxB;AsDn+foB;EACI,qBAAA;AtDq+fxB;AsDj+fgB;EACI,UAAA;EACA,YAAA;AtDm+fpB;;AuDhmgBA;;wBAAA;AAMI;EACI,SAAA;EACA,kBAAA;AvDgmgBR;AuD/lgBQ;EACI,cAAA;EACA,kBAAA;AvDimgBZ;AuDhmgBY;EACI,qBAAA;EACA,kBAAA;AvDkmgBhB;;AwDhngBA;;6BAAA;AAKI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AxDingBR;AwD9mgBI;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;AxDgngBR;AwD/mgBQ;EACI,kCAAA;AxDingBZ;AwD9mgBI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qFAAA;AxDgngBR;AwD9mgBI;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;AxDgngBR;AwD/mgBQ;EACI,kCAAA;AxDingBZ;AwD9mgBI;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AxDgngBR;AwD5mgBI;EACI,mBAAA;AxD8mgBR;AwD3mgBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AxD6mgBpB;AwDtmgBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AxDwmgBpB;AwDrmgBoB;EACI,iBAAA;AxDumgBxB;AwD/lgBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AxDimgBpB;AwD9lgBoB;EACI,gBAAA;EACA,wBAAA;AxDgmgBxB;;AyD3sgBA;;kCAAA;AAGA;EACC,kBAAA;AzD8sgBD;;AyD3sgBA;EACC,WAAA;EACA,aAAA;AzD8sgBD;AyD7sgBC;EAHD;IAIE,aAAA;EzDgtgBA;AACF;;AyD5sgBC;EACC,kBAAA;AzD+sgBF;;AyD3sgBA;EACC,aAAA;AzD8sgBD;AyD7sgBC;EACC,kBAAA;AzD+sgBF;;AyD3sgBA;;;;EAIC,iBAAA;AzD8sgBD;;AyD3sgBA;EACC,2BAAA;EACA,eAAA;AzD8sgBD;;AyD3sgBA;EACC,yBAAA;AzD8sgBD;;AyD3sgBA;EACC,6BAAA;AzD8sgBD;;AyD3sgBA;EACC,SAAA;AzD8sgBD;;AyD3sgBA;EACC,2BAAA;AzD8sgBD;;AyD3sgBA;EACC,qBAAA;AzD8sgBD;;AyD3sgBA;EAGC,aAAA;EACA,WAAA;EACA,oBAAA;AzD8sgBD;;AyD3sgBA;EACC,eAAA;EACA,4BAAA;AzD8sgBD;;AyD3sgBA;EACC,qBAAA;EACA,mBAAA;AzD8sgBD;;AyD3sgBA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AzD8sgBD;;AyD3sgBA;EACC,2BAAA;AzD8sgBD;;AyD3sgBA;;;EAGC,eAAA;AzD8sgBD;;AyD3sgBA;;EAEC,uBAAA;EACA,UAAA;AzD8sgBD;;AyD3sgBA;;EAEC,mBAAA;EACA,mBAAA;EACA,gBAAA;AzD8sgBD;;AyD3sgBA;EACC,8BAAA;AzD8sgBD;;AyD3sgBA;EACC,wBAAA;AzD8sgBD;;AyD3sgBA;;EAEC,aAAA;AzD8sgBD;;AyD3sgBA;EACC,4CAAA;AzD8sgBD;;AyD3sgBA;EACC,8BAAA;EACA,8BAAA;AzD8sgBD;;AyD3sgBA;EACC,oCAAA;EACA,6CAAA;AzD8sgBD;;AyD3sgBA;EACC,6CAAA;AzD8sgBD;;AyD3sgBA;EACC,8BAAA;EACA,4CAAA;AzD8sgBD;;AyD3sgBA;EACC,kBAAA;EACA,kBAAA;AzD8sgBD;;AyD3sgBA;EACC,6CAAA;AzD8sgBD;;AyD3sgBA;EACC,gBAAA;AzD8sgBD;;AyD3sgBA;EACC,iBAAA;AzD8sgBD;;AyD3sgBA;EACC,iBAAA;AzD8sgBD;;AyD3sgBA;EACC,4CAAA;AzD8sgBD;;AyD3sgBA;EACC,mBAAA;AzD8sgBD;;AyD3sgBA;EACC,UAAA;AzD8sgBD;;AyD3sgBA;EACC,eAAA;AzD8sgBD;;AyD3sgBA;EACC,eAAA;EACA,mBAAA;AzD8sgBD;;AyD1sgBC;EACC,gBAAA;EACA,wBAAA;EACA,kBAAA;AzD6sgBF;AyD3sgBC;EACC,wBAAA;AzD6sgBF;AyD3sgBC;EACC,kBAAA;AzD6sgBF;;AyDzsgBA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;AzD4sgBD;AyD3sgBC;EACC,gBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AzD6sgBF;;AyDxsgBC;EADD;IAEE,mBAAA;EzD4sgBA;AACF;;AyDzsgBA,mCAAA;AACA;EACC,iBAAA;AzD4sgBD;;AyDzsgBA;EACC,2BAAA;AzD4sgBD;;AyDzsgBA;EACC,2BAAA;EACA,oBAAA;AzD4sgBD;;AyDzsgBA;EACC,kBAAA;EACA,uBAAA;EACA,gBAAA;AzD4sgBD;;AyDzsgBA;EACC,gBAAA;AzD4sgBD;;AyDzsgBA,mCAAA;AACA;;;EAGC,wBAAA;EACA,kCAAA;EAAA,0BAAA;EACA,eAAA;AzD4sgBD;;AyDzsgBA;;EAEC,kBAAA;AzD4sgBD;;AyDzsgBA;EACC,2CAAA;EACA,mDAAA;EACA,8CAAA;EACA,gCAAA;EACA,yFAAA;EAEA,kCAAA;EACA,0GAAA;EAEA,sCAAA;EACA,2BAAA;EACA,0CAAA;EAEA,wBAAA;EACA,kMAAA;AzDysgBD;;AyD7rgBA;EACC,YAAA;AzDgsgBD;;AyD7rgBA;EACC,gBAAA;AzDgsgBD;;AyD7rgBA;EACC,oGAAA;AzDgsgBD;;AyD5rgBA;EACC,mBAAA;AzD+rgBD;;AyD5rgBA,oCAAA;AACA;;;EAGC,gBAAA;EACA,+BAAA;EAAA,0BAAA;EACA,eAAA;AzD+rgBD;;AyD5rgBA;;;EAGC,uBAAA;AzD+rgBD;;AyD5rgBA;EACC,gCAAA;EACA,SAAA;EACA,kCAAA;EACA,0CAAA;EACA,YAAA;AzD+rgBD;;AyD5rgBA;EACC,gBAAA;AzD+rgBD;;AyD5rgBA;EACC,WAAA;EACA,8BAAA;AzD+rgBD;;AyD5rgBA;EACC,gBAAA;EACA,gCAAA;EACA,sBAAA;AzD+rgBD;;AyD5rgBA;;EAEC,2BAAA;EACA,sBAAA;AzD+rgBD;;AyD5rgBA;EACC,mBAAA;AzD+rgBD;;AyD5rgBA,iCAAA;AAeA;EACC;IACC,UAAA;IAEA,0BAAA;EzD6rgBA;EyD3rgBD;IACC,UAAA;IAEA,eAAA;EzD6rgBA;AACF;AyD1rgBA;EAEC,+BAAA;AzD4rgBD;;AyDzrgBA;EACC;IACC,gBAAA;EzD4rgBA;AACF;AyDzrgBA;EACC;;;;;;IAMC,iBAAA;EzD2rgBA;AACF;AyDxrgBA;EACC;;;;;;IAMC,iBAAA;EzD0rgBA;AACF;AyDxrgBA;EACC;;;;;;IAMC,iBAAA;EzD0rgBA;AACF;AyDxrgBA;EACC;;;;;;IAMC,iBAAA;EzD0rgBA;AACF;AyDxrgBA;EACC;;;;;;IAMC,iBAAA;EzD0rgBA;AACF;AApjhBA;;uCAAA;A0D5EA;;4BAAA;AAGA;EACI,kBAAA;EACA,UAAA;A1DqohBJ;A0DpohBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;A1DsohBR;A0DnohBQ;EACI,SAAA;EACA,WAAA;A1DqohBZ;;A0DhohBA;EAEI,aAAA;EACA,eAAA;EACA,kBAAA;A1DkohBJ;A0DjohBI;EALJ;IAMQ,kBAAA;E1DoohBN;AACF;A0DnohBI;EARJ;IASQ,kBAAA;E1DsohBN;AACF;A0DrohBI;EAXJ;IAYQ,kBAAA;E1DwohBN;AACF;A0DvohBI;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A1DyohBR;A0DvohBQ;EANJ;IAOQ,gBAAA;E1D0ohBV;AACF;A0DzohBQ;EATJ;IAUQ,gBAAA;E1D4ohBV;AACF;A0D3ohBQ;EAZJ;IAaQ,gBAAA;E1D8ohBV;AACF;A0D5ohBQ;;EAEI,kBAAA;EACA,kBAAA;EACA,QAAA;A1D8ohBZ;A0D3ohBQ;EACI,2BAAA;A1D6ohBZ;A0D3ohBQ;EACI,wBAAA;A1D6ohBZ;;A0DxohBA,sBAAA;AAGI;EACI,kBAAA;EACA,UAAA;A1DyohBR;A0DxohBQ;EACI,UAAA;EACA,SAAA;A1D0ohBZ;A0DxohBQ;EACI,OAAA;EACA,SAAA;EACA,8BAAA;A1D0ohBZ;A0DtohBI;EACI,kBAAA;A1DwohBR;A0DvohBQ;EACI,cAAA;EACA,gBAAA;A1DyohBZ;A0DxohBY;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;A1D0ohBhB;A0DrohBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A1DuohBR;A0DpohBI;EACI,8BAAA;EACA,gBAAA;EACA,kBAAA;A1DsohBR;A0DpohBY;EACI,aAAA;A1DsohBhB;A0DrohBgB;EAFJ;IAGQ,aAAA;E1DwohBlB;AACF;A0DvohBgB;EACI,mBAAA;A1DyohBpB;A0DvohBgB;EACI,mBAAA;A1DyohBpB;A0DxohBoB;EAFJ;IAGQ,mBAAA;E1D2ohBtB;AACF;A0DzohBgB;EACI,gBAAA;EACA,gBAAA;A1D2ohBpB;A0DrohBI;EACI,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A1DuohBR;A0DpohBgB;EACI,2BAAA;EACA,4BAAA;A1DsohBpB;A0DnohBY;EACI,aAAA;A1DqohBhB;A0DpohBgB;EAFJ;IAGQ,aAAA;E1DuohBlB;AACF;A0DtohBgB;EALJ;IAMQ,aAAA;E1DyohBlB;AACF;A0DxohBgB;EACI,mBAAA;EACA,gBAAA;A1D0ohBpB;A0DzohBoB;EAHJ;IAIQ,mBAAA;IACA,gBAAA;E1D4ohBtB;AACF;A0DvohBQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;A1DyohBZ;A0DvohBgB;EACI,aAAA;EACA,cAAA;A1DyohBpB;A0DxohBoB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;A1D0ohBxB;A0DzohBwB;EACI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;A1D2ohB5B;A0D1ohB4B;EACI,cAAA;EACA,kBAAA;A1D4ohBhC;A0D1ohB4B;EACI,cAAA;A1D4ohBhC;A0DxohBoB;EACI,gBAAA;EACA,gBAAA;A1D0ohBxB;A0DtohBY;EACI,6CAAA;A1DwohBhB;A0DpohBQ;EACI,8BAAA;EACA,6CAAA;A1DsohBZ;A0DnohBQ;EACI,8BAAA;A1DqohBZ;A0DpohBY;EACI,8BAAA;EACA,6CAAA;A1DsohBhB;A0DjohBI;EACI,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A1DmohBR;A0DlohBQ;EACI,aAAA;A1DoohBZ;A0DlohBgB;EACI,mBAAA;EACA,gBAAA;A1DoohBpB;A0DnohBoB;EAHJ;IAIQ,mBAAA;E1DsohBtB;AACF;A0DnohBY;EACI,gBAAA;EACA,gBAAA;A1DqohBhB;A0DpohBgB;EACI,kBAAA;A1DsohBpB;A0DrohBoB;EACI,kBAAA;A1DuohBxB;A0DlohBQ;EACI,8BAAA;EACA,6CAAA;A1DoohBZ;A0DjohBI;EACI,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;A1DmohBR;A0DjohBY;EACI,kBAAA;A1DmohBhB;A0DlohBgB;EACI,mBAAA;A1DoohBpB;A0DnohBoB;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;A1DqohBxB;A0DlohBgB;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A1DoohBpB;A0DznhBoB;EACI,qBAAA;A1D2nhBxB;A0DpnhBI;EACI,kBAAA;A1DsnhBR;A0DrnhBQ;EACI,gBAAA;A1DunhBZ;A0DtnhBY;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;A1DwnhBhB;A0DvnhBgB;EACI,yEAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A1DynhBpB;A0DvnhBgB;EACI,kBAAA;EACA,gBAAA;A1DynhBpB;A0DrnhBQ;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,OAAA;A1DunhBZ;A0DtnhBY;EALJ;IAMQ,aAAA;E1DynhBd;AACF;A0DxnhBY;EACI,kBAAA;A1D0nhBhB;A0DznhBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;A1D2nhBpB;A0DvnhBY;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A1DynhBhB;A0DxnhBgB;EALJ;IAMQ,mBAAA;IACA,eAAA;IACA,iBAAA;E1D2nhBlB;AACF;A0D1nhBgB;EACI,yBAAA;A1D4nhBpB;A0DznhBY;EACI,mBAAA;A1D2nhBhB;A0D1nhBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;A1D4nhBpB;A0D3nhBoB;EACI,yBAAA;A1D6nhBxB;;A2Dp+hBA;;6BAAA;AAGA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;A3Du+hBJ;A2Dt+hBI;EAJJ;IAKQ,aAAA;E3Dy+hBN;AACF;A2Dx+hBI;EACI,oBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A3D0+hBR;A2Dt+hBQ;EACI,kBAAA;A3Dw+hBZ;A2Dv+hBY;EACI,cAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;A3Dy+hBhB;A2Dv+hBY;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,sCAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,8BAAA;A3Dy+hBhB;A2Dj+hBY;EACI,SAAA;A3Dm+hBhB;A2Dl+hBgB;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;A3Do+hBpB;A2Dn+hBoB;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;A3Dq+hBxB;A2D/9hBgB;EACI,gBAAA;A3Di+hBpB;A2D19hBQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;A3D49hBZ;A2D39hBY;EACI,kBAAA;A3D69hBhB;A2D59hBgB;EAFJ;IAGQ,kBAAA;E3D+9hBlB;AACF;A2D79hBoB;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;A3D+9hBxB;A2Dr9hBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A3Du9hBpB;A2Dn9hBY;EACI,iBAAA;EACA,gBAAA;A3Dq9hBhB;A2Dp9hBgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;A3Ds9hBpB;A2D/8hBQ;EACI,kBAAA;A3Di9hBZ;A2Dh9hBY;EACI,mBAAA;A3Dk9hBhB;A2Dj9hBgB;EACI,iBAAA;EACA,mBAAA;A3Dm9hBpB;A2D/8hBgB;EACI,mBAAA;A3Di9hBpB;A2D/8hBgB;EACI,mBAAA;A3Di9hBpB;A2D18hBQ;EACI,aAAA;EACA,eAAA;EACA,cAAA;A3D48hBZ;A2D38hBY;EACI,kBAAA;EACA,cAAA;EACA,cAAA;A3D68hBhB;A2D58hBgB;EAJJ;IAKQ,eAAA;E3D+8hBlB;AACF;A2D98hBgB;EAPJ;IAQQ,eAAA;E3Di9hBlB;AACF;A2Dh9hBgB;EAVJ;IAWQ,eAAA;E3Dm9hBlB;AACF;A2Dl9hBgB;EACI,kBAAA;EACA,WAAA;A3Do9hBpB;;A2D78hBA;EACI,YAAA;A3Dg9hBJ;A2D/8hBI;EACI,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;A3Di9hBR;A2Dh9hBQ;EACI,2CAAA;EACA,yBAAA;A3Dk9hBZ;A2D98hBQ;EACI,mBAAA;A3Dg9hBZ;;A2Dz8hBA;;gCAAA;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A3D28hBR;A2Dv8hBQ;EACI,kBAAA;A3Dy8hBZ;A2Dx8hBY;EACI,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;A3D08hBhB;A2Dx8hBY;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;A3D08hBhB;A2Dj8hBY;EACI,SAAA;A3Dm8hBhB;A2Dl8hBgB;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;A3Do8hBpB;A2D/7hBgB;EACI,iBAAA;EACA,gBAAA;EACA,6BAAA;A3Di8hBpB;A2D17hBQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;A3D47hBZ;A2D17hBY;EACI,kBAAA;A3D47hBhB;A2D37hBgB;EACI,cAAA;A3D67hBpB;A2D57hBoB;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;A3D87hBxB;A2Dp7hBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A3Ds7hBpB;A2Dl7hBY;EACI,iBAAA;EACA,gBAAA;A3Do7hBhB;A2Dn7hBgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;A3Dq7hBpB;;A4D7uiBA;;+BAAA;AAIA;EACI,kBAAA;A5D+uiBJ;A4D9uiBI;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;A5DgviBR;A4D/uiBQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,yDAAA;EACA,SAAA;EACA,2BAAA;A5DiviBZ;A4D/uiBQ;EACI,eAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;A5DiviBZ;A4DhviBY;EACI,qBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;A5DkviBhB;A4DjviBgB;EACI,2BAAA;A5DmviBpB;A4D7uiBQ;EACI,UAAA;EACA,mBAAA;A5D+uiBZ;;A4DxuiBI;EACI,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;A5D2uiBR;A4DzuiBQ;EANJ;IAOQ,cAAA;IACA,eAAA;IACA,kBAAA;E5D4uiBV;AACF;A4D1uiBQ;EAZJ;IAaQ,cAAA;IACA,eAAA;IACA,kBAAA;E5D6uiBV;AACF;A4D3uiBQ;EAlBJ;IAmBQ,cAAA;IACA,eAAA;IACA,kBAAA;E5D8uiBV;AACF;A4D5uiBQ;EACI,WAAA;A5D8uiBZ;;A4DxuiBI;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;A5D2uiBR;A4DzuiBI;EACI,mBAAA;A5D2uiBR;A4D1uiBQ;EACI,wBAAA;A5D4uiBZ;;A4DtuiBI;EAEI,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;A5DwuiBR;A4DvuiBQ;EACI,aAAA;EACA,SAAA;A5DyuiBZ;A4DxuiBY;EACI,kBAAA;A5D0uiBhB;A4DtuiBY;EACI,eAAA;A5DwuiBhB;A4DvuiBgB;EAFJ;IAGQ,gBAAA;E5D0uiBlB;AACF;A4DnuiBI;EACI,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;A5DquiBR;A4DpuiBQ;EAZJ;IAaQ,aAAA;E5DuuiBV;AACF;A4DtuiBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;A5DwuiBZ;;A4D/tiBI;EACI,aAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A5DkuiBR;A4DjuiBQ;EACI,2BAAA;EACA,kBAAA;EACA,eAAA;A5DmuiBZ;;A4D9tiBA;EAEI,gBAAA;EACA,kBAAA;EACA,mBAAA;A5DguiBJ;A4D9tiBI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A5DguiBR;;A4D5tiBA;EAEI,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;A5D8tiBJ;A4D7tiBI;EACI,aAAA;EACA,SAAA;A5D+tiBR;A4D9tiBQ;EACI,kBAAA;A5DguiBZ;A4D5tiBQ;EACI,eAAA;A5D8tiBZ;A4D7tiBY;EAFJ;IAGQ,gBAAA;E5DguiBd;AACF;;A4D3tiBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;A5D8tiBJ;A4D5tiBI;EARJ;IASQ,cAAA;E5D+tiBN;AACF;A4D7tiBI;EACI,aAAA;EACA,mBAAA;A5D+tiBR;A4D7tiBQ;EAJJ;IAKQ,gBAAA;E5DguiBV;AACF;A4D9tiBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;A5DguiBZ;A4D7tiBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;A5D+tiBR;A4D9tiBQ;EACI,gCAAA;EACA,yBAAA;A5DguiBZ;;A4D3tiBA;EACI,eAAA;EACA,aAAA;A5D8tiBJ;A4D7tiBI;EAHJ;IAIQ,cAAA;E5DguiBN;AACF;A4D/tiBI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;A5DiuiBR;A4DhuiBQ;EAJJ;IAKQ,kBAAA;E5DmuiBV;AACF;A4DluiBQ;EAPJ;IAQQ,eAAA;IACA,mBAAA;IACA,eAAA;IACA,mBAAA;E5DquiBV;AACF;A4DpuiBQ;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;A5DsuiBZ;A4DluiBQ;EACI,mBAAA;A5DouiBZ;A4DluiBQ;EACI,mBAAA;A5DouiBZ;A4DjuiBY;EACI,eAAA;A5DmuiBhB;A4DluiBgB;EACI,cAAA;A5DouiBpB;A4DnuiBoB;EACI,2BAAA;EACA,eAAA;A5DquiBxB;;A4D5tiBA;;+BAAA;AAKQ;EACI,aAAA;A5D6tiBZ;A4D3tiBQ;EACI,mBAAA;A5D6tiBZ;A4D5tiBY;EACI,wBAAA;A5D8tiBhB;A4DztiBI;EACI,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;A5D2tiBR;A4D1tiBQ;EACI,YAAA;A5D4tiBZ;;A4DrtiBA;;+BAAA;AAKQ;EACI,aAAA;EACA,mBAAA;A5DstiBZ;A4DptiBQ;EACI,gBAAA;A5DstiBZ;A4DrtiBY;EACI,wBAAA;A5DutiBhB;A4DntiBI;EACI,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;A5DqtiBR;A4DntiBQ;EATJ;IAUQ,kBAAA;E5DstiBV;AACF;A4DptiBQ;EAbJ;IAcQ,kBAAA;E5DutiBV;AACF;A4DttiBQ;EACI,YAAA;EACA,WAAA;EACA,WAAA;A5DwtiBZ;;A6DpkjBA;;+BAAA;AAMI;EACI,aAAA;A7DokjBR;A6DnkjBQ;EAFJ;IAGQ,sBAAA;E7DskjBV;E6DrkjBU;IACI,gBAAA;E7DukjBd;AACF;A6DrkjBQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A7DukjBZ;A6DtkjBY;EACI,mBAAA;EACA,WAAA;A7DwkjBhB;A6DpkjBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7DskjBhB;A6DpkjBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;A7DskjBhB;A6DpkjBY;EACI,mBAAA;A7DskjBhB;A6DnkjBY;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A7DqkjBhB;A6DpkjBgB;EACI,kBAAA;A7DskjBpB;A6DjkjBQ;EACI,6BAAA;EACA,iBAAA;EACA,gBAAA;A7DmkjBZ;;A6DzjjBA;;+BAAA;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;A7D4jjBJ;A6D3jjBI;EACI,gBAAA;A7D6jjBR;A6D1jjBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7D4jjBZ;A6D3jjBY;EACI,2BAAA;A7D6jjBhB;;A6DnjjBI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A7DsjjBR;A6DnjjBI;;EAEI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;A7DqjjBR;A6DpjjBQ;;EACI,kCAAA;A7DujjBZ;A6DpjjBI;EACI,eAAA;EACA,YAAA;EACA,iBAAA;A7DsjjBR;A6DpjjBI;EACI,iBAAA;EACA,kBAAA;A7DsjjBR;;A6DjjjBA;;kCAAA;AAGA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A7DojjBJ;A6DnjjBI;EACI,kBAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;A7DqjjBR;A6DnjjBI;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;A7DqjjBR;A6DpjjBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A7DsjjBZ;A6DpjjBQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;A7DsjjBZ;A6DpjjBQ;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;A7DsjjBZ;A6DljjBQ;EACI,UAAA;A7DojjBZ;A6DljjBQ;EACI,yBAAA;A7DojjBZ;A6DnjjBY;EACI,aAAA;A7DqjjBhB;A6DhjjBI;EACI,iBAAA;A7DkjjBR;A6DhjjBY;EACI,eAAA;EACA,iBAAA;A7DkjjBhB;A6D5ijBI;EACI,gBAAA;EACA,oCAAA;A7D8ijBR;A6D5ijBQ;EACI,2BAAA;A7D8ijBZ;A6D7ijBY;EACI,aAAA;A7D+ijBhB;A6D5ijBQ;EACI,aAAA;A7D8ijBZ;A6D5ijBQ;EACI,mBAAA;EACA,kCAAA;EACA,4CAAA;A7D8ijBZ;;AA/rjBA;;uCAAA;A8DpFA;;yBAAA;AAIA;EACC,iBAAA;EACA,WAAA;EACA,sBAAA;A9DwxjBD;A8DvxjBC;EAJD;IAKE,gBAAA;IACA,WAAA;IACA,gBAAA;E9D0xjBA;AACF;;A8DvxjBA;EACC,iBAAA;EACA,WAAA;A9D0xjBD;A8DzxjBC;EAHD;IAIE,gBAAA;IACA,WAAA;IACA,gBAAA;E9D4xjBA;AACF;;A8DzxjBA;EACC,kBAAA;EACA,0DAAA;EACA,UAAA;A9D4xjBD;A8D3xjBC;EAJD;IAKE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;E9D8xjBA;AACF;A8D7xjBC;EAVD;IAWE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;E9DgyjBA;AACF;A8D/xjBC;EAhBD;IAiBE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;E9DkyjBA;AACF;A8DhyjBC;EACC,kBAAA;EACA,iBAAA;A9DkyjBF;A8DjyjBE;EAHD;IAIE,eAAA;E9DoyjBD;AACF;A8DnyjBE;EACC,gBAAA;A9DqyjBH;A8DpyjBG;EAFD;IAGE,kBAAA;E9DuyjBF;AACF;A8DnyjBC;EACC,iBAAA;A9DqyjBF;A8DpyjBE;EAFD;IAGE,aAAA;E9DuyjBD;AACF;A8DlyjBG;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;A9DoyjBJ;A8DlyjBG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9DoyjBJ;A8DlyjBI;EAND;IAOE,eAAA;IACA,mBAAA;E9DqyjBH;AACF;A8DnyjBI;EAXD;IAYE,eAAA;E9DsyjBH;AACF;A8DpyjBI;EAfD;IAgBE,eAAA;E9DuyjBH;AACF;A8DpyjBG;EACC,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9DsyjBJ;A8DpyjBI;EARD;IASE,mBAAA;E9DuyjBH;AACF;A8DtyjBI;EAXD;IAYE,mBAAA;E9DyyjBH;AACF;A8DxyjBI;EAdD;IAeE,mBAAA;IACA,eAAA;IACA,iBAAA;E9D2yjBH;AACF;A8D1yjBI;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,QAAA;EACA,2BAAA;A9D4yjBL;A8DtyjBC;EACC,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;EACA,yBAAA;A9DwyjBF;A8DvyjBE;EARD;IASE,eAAA;IACA,eAAA;IACA,eAAA;E9D0yjBD;AACF;A8DxyjBE;EAdD;IAeE,eAAA;IACA,eAAA;IACA,eAAA;E9D2yjBD;AACF;A8DzyjBE;EApBD;IAqBE,eAAA;IACA,cAAA;E9D4yjBD;AACF;A8DzyjBI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A9D2yjBL;A8DtyjBI;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A9DwyjBL;A8DryjBI;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;A9DuyjBL;A8DjyjBC;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;A9DmyjBF;A8DhyjBC;EACC,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;A9DkyjBF;A8D9xjBE;EACC,kBAAA;EACA,WAAA;A9DgyjBH;A8D9xjBG;EACC,SAAA;EACA,YAAA;A9DgyjBJ;A8D7xjBG;EACC,SAAA;EACA,WAAA;A9D+xjBJ;A8D5xjBG;EACC,SAAA;EACA,aAAA;A9D8xjBJ;A8D3xjBG;EACC,YAAA;EACA,aAAA;A9D6xjBJ;A8D1xjBG;EACC,aAAA;EACA,WAAA;A9D4xjBJ;A8DzxjBG;EACC,aAAA;EACA,YAAA;A9D2xjBJ;A8DrxjBE;EACC,2BAAA;A9DuxjBH;A8DtxjBG;EAFD;IAGE,uBAAA;E9DyxjBF;AACF;A8DxxjBG;EALD;IAME,uBAAA;E9D2xjBF;AACF;A8D1xjBG;EARD;IASE,uBAAA;E9D6xjBF;AACF;;A8DxxjBA;;2BAAA;AAGA;EACC,0DAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;A9D2xjBD;A8DzxjBC;EAND;IAOE,iBAAA;E9D4xjBA;AACF;A8D1xjBC;EAVD;IAWE,eAAA;E9D6xjBA;AACF;A8D3xjBC;EAdD;IAeE,mBAAA;IACA,YAAA;IACA,iBAAA;E9D8xjBA;AACF;A8D5xjBC;EApBD;IAqBE,kBAAA;IACA,YAAA;IACA,iBAAA;E9D+xjBA;AACF;A8D7xjBC;EACC,kBAAA;EACA,iBAAA;A9D+xjBF;A8D9xjBE;EAHD;IAIE,eAAA;E9DiyjBD;AACF;A8D/xjBG;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;A9DiyjBJ;A8D/xjBI;EACC,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;A9DiyjBL;A8D7xjBG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9D+xjBJ;A8D7xjBI;EAND;IAOE,eAAA;E9DgyjBH;AACF;A8D/xjBI;EATD;IAUE,eAAA;IACA,mBAAA;E9DkyjBH;AACF;A8DjyjBI;EAbD;IAcE,eAAA;IACA,mBAAA;E9DoyjBH;AACF;A8DnyjBI;EAjBD;IAkBE,eAAA;E9DsyjBH;AACF;A8DpyjBG;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9DsyjBJ;A8DryjBI;EALD;IAME,mBAAA;E9DwyjBH;AACF;A8DvyjBI;EARD;IASE,eAAA;IACA,iBAAA;IACA,mBAAA;E9D0yjBH;AACF;A8DxyjBG;EACC,kBAAA;EACA,YAAA;EACA,aAAA;A9D0yjBJ;A8DzyjBI;EACC,cAAA;A9D2yjBL;A8DzyjBI;EAPD;IAQE,YAAA;IACA,aAAA;E9D4yjBH;E8D3yjBG;IACC,eAAA;E9D6yjBJ;AACF;A8D1yjBI;EAfD;IAgBE,YAAA;IACA,aAAA;E9D6yjBH;E8D5yjBG;IACC,cAAA;E9D8yjBJ;AACF;A8D3yjBI;EAvBD;IAwBE,aAAA;IACA,aAAA;E9D8yjBH;E8D7yjBG;IACC,cAAA;E9D+yjBJ;AACF;A8DzyjBC;EACC,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;A9D2yjBF;A8DzyjBE;EAND;IAOE,WAAA;E9D4yjBD;AACF;A8D3yjBE;EACC,4BAAA;A9D6yjBH;A8D3yjBE;EAZD;IAaE,QAAA;E9D8yjBD;E8D7yjBC;IACC,cAAA;E9D+yjBF;AACF;A8D5yjBE;EAnBD;IAoBE,aAAA;E9D+yjBD;E8D9yjBC;IACC,cAAA;E9DgzjBF;AACF;A8D7yjBE;EA1BD;IA2BE,gBAAA;IACA,iBAAA;IACA,kBAAA;E9DgzjBD;E8D/yjBC;IACC,cAAA;E9DizjBF;AACF;A8D9yjBE;EAnCD;IAoCE,gBAAA;E9DizjBD;E8DhzjBC;IACC,eAAA;E9DkzjBF;AACF;A8D9yjBC;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;A9DgzjBF;A8D9yjBE;EAND;IAOE,QAAA;E9DizjBD;AACF;A8DhzjBE;EACC,2BAAA;A9DkzjBH;A8DjzjBG;EAFD;IAGE,cAAA;E9DozjBF;AACF;A8DjzjBE;EAhBD;IAiBE,YAAA;E9DozjBD;AACF;A8DlzjBE;EApBD;IAqBE,aAAA;E9DqzjBD;E8DpzjBC;IACC,cAAA;E9DszjBF;AACF;A8DlzjBC;EACC,kBAAA;EACA,WAAA;A9DozjBF;A8DlzjBE;EACC,UAAA;EACA,UAAA;A9DozjBH;A8DnzjBG;EAHD;IAIE,UAAA;IACA,WAAA;E9DszjBF;AACF;A8DnzjBE;EACC,UAAA;EACA,UAAA;A9DqzjBH;A8DlzjBE;EACC,UAAA;EACA,WAAA;A9DozjBH;;A8D/yjBA;;2BAAA;AAIA;EACC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,0DAAA;A9DizjBD;A8DhzjBC;EALD;IAME,sBAAA;E9DmzjBA;E8DlzjBA;IACC,eAAA;IACA,mBAAA;E9DozjBD;AACF;A8DlzjBC;EAZD;IAaE,qBAAA;E9DqzjBA;E8DpzjBA;IACC,UAAA;E9DszjBD;AACF;A8DpzjBC;EACC,gBAAA;A9DszjBF;A8DrzjBE;EAFD;IAGE,eAAA;E9DwzjBD;AACF;A8DvzjBE;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;A9DyzjBH;A8DvzjBE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9DyzjBH;A8DxzjBG;EALD;IAME,eAAA;E9D2zjBF;AACF;A8D1zjBG;EARD;IASE,eAAA;E9D6zjBF;AACF;A8D5zjBG;EAXD;IAYE,eAAA;E9D+zjBF;AACF;A8D5zjBE;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9D8zjBH;A8D7zjBG;EALD;IAME,mBAAA;E9Dg0jBF;AACF;A8D/zjBG;EARD;IASE,mBAAA;IACA,eAAA;IACA,iBAAA;E9Dk0jBF;AACF;A8D7zjBE;EACC,mBAAA;EACA,qBAAA;EACA,iBAAA;A9D+zjBH;A8D9zjBG;EAJD;IAKE,kBAAA;E9Di0jBF;AACF;A8Dh0jBG;EAPD;IAQE,kBAAA;E9Dm0jBF;AACF;A8Dl0jBG;EAVD;IAWE,eAAA;IACA,gBAAA;IACA,gBAAA;E9Dq0jBF;AACF;A8Dn0jBE;EACC,kBAAA;EACA,aAAA;EACA,aAAA;A9Dq0jBH;A8Dp0jBG;EAJD;IAKE,aAAA;IACA,aAAA;IACA,gBAAA;E9Du0jBF;AACF;A8Dt0jBG;EATD;IAUE,YAAA;E9Dy0jBF;AACF;A8Dx0jBG;EAZD;IAaE,YAAA;IACA,gBAAA;E9D20jBF;AACF;A8D10jBG;EAhBD;IAiBE,aAAA;E9D60jBF;AACF;A8D30jBE;EACC,kBAAA;EACA,QAAA;EACA,aAAA;A9D60jBH;A8D50jBG;EAJD;IAKE,YAAA;E9D+0jBF;AACF;A8D90jBG;EAPD;IAQE,WAAA;IACA,aAAA;E9Di1jBF;AACF;A8Dh1jBG;EAXD;IAYE,aAAA;E9Dm1jBF;AACF;A8D/0jBC;EACC,kBAAA;EACA,WAAA;A9Di1jBF;A8D/0jBE;EACC,YAAA;EACA,SAAA;A9Di1jBH;A8D90jBE;EACC,UAAA;EACA,UAAA;A9Dg1jBH;A8D70jBE;EACC,aAAA;EACA,SAAA;A9D+0jBH;A8D50jBE;EACC,aAAA;EACA,aAAA;A9D80jBH;A8D30jBE;EACC,YAAA;EACA,cAAA;A9D60jBH;;A8Dx0jBA;;2BAAA;AAIA;EACC,0DAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;A9D00jBD;A8Dz0jBC;EACC,iBAAA;A9D20jBF;A8D10jBE;EAFD;IAGE,gBAAA;IACA,WAAA;IACA,WAAA;IACA,sBAAA;E9D60jBD;AACF;A8D50jBE;EARD;IASE,qBAAA;E9D+0jBD;AACF;A8D70jBC;EACC,kBAAA;EACA,aAAA;EACA,WAAA;A9D+0jBF;A8D90jBE;EAJD;IAKE,aAAA;IACA,UAAA;IACA,qBAAA;E9Di1jBD;AACF;A8Dh1jBE;EATD;IAUE,OAAA;IACA,UAAA;IACA,cAAA;E9Dm1jBD;AACF;A8Dl1jBE;EAdD;IAeE,OAAA;IACA,cAAA;IACA,aAAA;E9Dq1jBD;AACF;A8Dp1jBE;EAnBD;IAoBE,aAAA;E9Du1jBD;AACF;A8Dr1jBG;EACC,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;A9Du1jBJ;A8Dp1jBE;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;A9Ds1jBH;A8Dp1jBE;EACC,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;A9Ds1jBH;A8Dp1jBG;EACC,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A9Ds1jBJ;A8Dp1jBI;EACC,cAAA;EACA,cAAA;EACA,gBAAA;A9Ds1jBL;A8Dp1jBK;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;A9Ds1jBN;A8D90jBE;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;A9Dg1jBH;A8D90jBE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9Dg1jBH;A8D/0jBG;EALD;IAME,eAAA;E9Dk1jBF;AACF;A8Dj1jBG;EARD;IASE,eAAA;E9Do1jBF;AACF;A8Dn1jBG;EAXD;IAYE,eAAA;E9Ds1jBF;AACF;A8Dn1jBE;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9Dq1jBH;A8Dp1jBG;EALD;IAME,mBAAA;E9Du1jBF;AACF;A8Dt1jBG;EARD;IASE,mBAAA;IACA,eAAA;IACA,iBAAA;E9Dy1jBF;AACF;A8Dr1jBC;EACC,kBAAA;EACA,WAAA;A9Du1jBF;A8Dr1jBE;EACC,YAAA;EACA,UAAA;A9Du1jBH;A8Dp1jBE;EACC,UAAA;EACA,UAAA;A9Ds1jBH;A8Dn1jBE;EACC,aAAA;EACA,SAAA;A9Dq1jBH;A8Dl1jBE;EACC,YAAA;EACA,aAAA;A9Do1jBH;A8Dj1jBE;EACC,WAAA;EACA,aAAA;A9Dm1jBH;A8Dh1jBE;EACC,WAAA;EACA,cAAA;A9Dk1jBH;A8Dh1jBE;EACC,OAAA;EACA,WAAA;A9Dk1jBH;A8Dh1jBE;EACC,QAAA;EACA,WAAA;A9Dk1jBH;A8D90jBC;EAEC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;A9D+0jBF;A8D90jBE;EATD;IAUE,YAAA;E9Di1jBD;AACF;A8Dh1jBE;EAZD;IAaE,WAAA;E9Dm1jBD;AACF;A8Dl1jBE;EAfD;IAgBE,kBAAA;IACA,YAAA;IACA,eAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;E9Dq1jBD;AACF;A8Dp1jBE;EA1BD;IA2BE,aAAA;E9Du1jBD;AACF;A8Dr1jBE;EACC,SAAA;A9Du1jBH;A8Dt1jBG;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A9Dw1jBJ;A8Dv1jBI;EARD;IASE,eAAA;IACA,gBAAA;E9D01jBH;AACF;A8Dz1jBI;EACC,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;A9D21jBL;A8Dx1jBK;EACC,WAAA;EACA,UAAA;A9D01jBN;;A8Dl1jBA;;2BAAA;AAIA;EACC,kBAAA;EACA,UAAA;EACA,0DAAA;A9Do1jBD;A8Dn1jBC;EACC,aAAA;A9Dq1jBF;A8Dp1jBE;EAFD;IAGE,YAAA;IACA,kBAAA;E9Du1jBD;AACF;A8Dr1jBE;EAPD;IAQE,YAAA;IACA,kBAAA;E9Dw1jBD;AACF;A8Dt1jBE;EAZD;IAaE,YAAA;IACA,kBAAA;E9Dy1jBD;AACF;A8Dr1jBE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9Du1jBH;A8Dr1jBG;EAND;IAOE,eAAA;IACA,mBAAA;E9Dw1jBF;AACF;A8Dt1jBG;EAXD;IAYE,eAAA;E9Dy1jBF;AACF;A8Dx1jBG;EAdD;IAeE,eAAA;IACA,mBAAA;E9D21jBF;AACF;A8D11jBG;EAlBD;IAmBE,eAAA;IACA,mBAAA;E9D61jBF;AACF;A8D31jBE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9D61jBH;A8D31jBG;EAND;IAOE,mBAAA;E9D81jBF;AACF;A8D51jBG;EAVD;IAWE,mBAAA;E9D+1jBF;AACF;A8D71jBG;EAdD;IAeE,mBAAA;E9Dg2jBF;AACF;A8D91jBE;EACC,aAAA;EACA,mBAAA;A9Dg2jBH;A8D/1jBG;EAHD;IAIE,cAAA;E9Dk2jBF;AACF;A8D91jBG;EADD;IAEE,cAAA;IACA,gBAAA;E9Di2jBF;AACF;A8D/1jBE;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;A9Di2jBH;A8Dh2jBG;EAND;IAOE,cAAA;IACA,aAAA;E9Dm2jBF;AACF;A8Dl2jBG;EACC,aAAA;A9Do2jBJ;A8Dl2jBG;EACC,aAAA;A9Do2jBJ;A8Dj2jBI;EACC,iCAAA;EACA,oCAAA;EACA,8CAAA;A9Dm2jBL;A8D/1jBE;EACC,aAAA;EACA,mBAAA;A9Di2jBH;A8Dh2jBG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,2BAAA;A9Dk2jBJ;A8D91jBC;EACC,kBAAA;EACA,SAAA;EACA,UAAA;A9Dg2jBF;A8D/1jBE;EAJD;IAKE,SAAA;E9Dk2jBD;AACF;A8Dj2jBE;EAPD;IAQE,kBAAA;IACA,SAAA;IACA,QAAA;E9Do2jBD;AACF;A8Dn2jBE;EAZD;IAaE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,kBAAA;E9Ds2jBD;AACF;A8Dr2jBE;EAlBD;IAmBE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,kBAAA;E9Dw2jBD;AACF;A8Dv2jBE;EACC,8BAAA;EACA,6BAAA;A9Dy2jBH;A8Dv2jBG;EAJD;IAKE,WAAA;E9D02jBF;AACF;A8Dz2jBG;EAPD;IAQE,WAAA;E9D42jBF;AACF;A8Dz2jBE;EACC,kBAAA;EACA,UAAA;EACA,QAAA;A9D22jBH;A8D12jBG;EAJD;IAKE,OAAA;E9D62jBF;AACF;A8D52jBG;EAPD;IAQE,UAAA;IACA,SAAA;IACA,YAAA;E9D+2jBF;AACF;A8D92jBG;EACC,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;A9Dg3jBJ;A8D92jBI;EACC,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;A9Dg3jBL;A8D92jBK;EACC,eAAA;EACA,wBAAA;EACA,gBAAA;A9Dg3jBN;A8D32jBK;EACC,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A9D62jBN;A8Dt2jBC;EACC,kBAAA;EACA,WAAA;A9Dw2jBF;A8Dt2jBE;EACC,aAAA;EACA,WAAA;EACA,4DAAA;A9Dw2jBH;A8Dv2jBG;EAJD;IAKE,UAAA;E9D02jBF;AACF;A8Dz2jBG;EAPD;IAQE,aAAA;E9D42jBF;AACF;A8Dz2jBE;EACC,UAAA;EACA,UAAA;A9D22jBH;A8D12jBG;EAHD;IAIE,UAAA;IACA,WAAA;E9D62jBF;AACF;A8D12jBE;EACC,UAAA;EACA,SAAA;A9D42jBH;A8Dz2jBE;EACC,SAAA;EACA,aAAA;A9D22jBH;A8D12jBG;EAHD;IAIE,aAAA;E9D62jBF;AACF;A8D12jBE;EACC,aAAA;EACA,SAAA;A9D42jBH;A8Dz2jBE;EACC,UAAA;EACA,YAAA;A9D22jBH;;A8Dt2jBA;;2BAAA;AAIA;EACC,kBAAA;EACA,UAAA;A9Dw2jBD;A8Dt2jBC;EACC,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;A9Dw2jBF;A8Dv2jBE;EALD;IAME,YAAA;E9D02jBD;AACF;A8Dz2jBE;EARD;IASE,YAAA;E9D42jBD;AACF;A8D32jBE;EAXD;IAYE,WAAA;E9D82jBD;AACF;A8D72jBE;EAdD;IAeE,aAAA;E9Dg3jBD;AACF;A8D72jBC;EACC,kBAAA;EACA,UAAA;A9D+2jBF;A8D92jBE;EACC,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;A9Dg3jBH;A8D72jBE;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A9D+2jBH;A8D92jBG;EALD;IAME,eAAA;IACA,mBAAA;E9Di3jBF;AACF;A8Dh3jBG;EATD;IAUE,eAAA;IACA,mBAAA;E9Dm3jBF;AACF;A8Dl3jBG;EAbD;IAcE,eAAA;IACA,mBAAA;E9Dq3jBF;AACF;A8Dp3jBG;EAjBD;IAkBE,eAAA;IACA,mBAAA;E9Du3jBF;AACF;A8Dn3jBC;EACC,kBAAA;EACA,WAAA;A9Dq3jBF;A8Dn3jBE;EACC,UAAA;EACA,SAAA;A9Dq3jBH;A8Dl3jBE;EACC,UAAA;EACA,YAAA;A9Do3jBH;A8Dj3jBE;EACC,aAAA;EACA,UAAA;A9Dm3jBH;A8Dh3jBE;EACC,aAAA;EACA,WAAA;A9Dk3jBH;A8D/2jBE;EACC,aAAA;EACA,YAAA;A9Di3jBH;A8D72jBC;EACC,kBAAA;EACA,WAAA;A9D+2jBF;A8D72jBE;EACC,UAAA;EACA,WAAA;EACA,UAAA;A9D+2jBH;A8D52jBE;EACC,UAAA;EACA,WAAA;EACA,WAAA;A9D82jBH;A8D32jBE;EACC,aAAA;EACA,WAAA;A9D62jBH;A8D12jBE;EACC,aAAA;EACA,YAAA;A9D42jBH;A8Dz2jBE;EACC,YAAA;EACA,SAAA;EACA,WAAA;A9D22jBH;A8Dx2jBE;EACC,UAAA;EACA,YAAA;A9D02jBH;A8Dv2jBE;EACC;IACC,cAAA;E9Dy2jBF;E8Dt2jBC;IACC,UAAA;E9Dw2jBF;E8Dr2jBC;IACC,UAAA;IACA,UAAA;E9Du2jBF;E8Dp2jBC;IACC,WAAA;IACA,aAAA;E9Ds2jBF;E8Dn2jBC;IACC,aAAA;IACA,UAAA;E9Dq2jBF;E8Dl2jBC;IACC,aAAA;IACA,YAAA;E9Do2jBF;E8Dj2jBC;IACC,QAAA;E9Dm2jBF;AACF;A8Dh2jBE;EACC;IACC,OAAA;E9Dk2jBF;E8D/1jBC;IACC,UAAA;IACA,UAAA;E9Di2jBF;E8D91jBC;IACC,WAAA;IACA,aAAA;E9Dg2jBF;E8D71jBC;IACC,YAAA;E9D+1jBF;E8D51jBC;IACC,YAAA;IACA,UAAA;E9D81jBF;E8D31jBC;IACC,QAAA;E9D61jBF;E8D31jBC;IACC,cAAA;E9D61jBF;AACF;;A+DtomBA,mBAAA;AAGQ;EACI,kBAAA;A/DuomBZ;A+DpomBI;EACI,gBAAA;A/DsomBR;A+DromBQ;EAFJ;IAGQ,gBAAA;E/DwomBV;AACF;A+DvomBQ;EALJ;IAMQ,gBAAA;E/D0omBV;AACF;A+DzomBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A/D2omBZ;A+D1omBY;EALJ;IAMQ,eAAA;IACA,gBAAA;E/D6omBd;AACF;A+DzomBgB;EACI,kBAAA;EACA,WAAA;A/D2omBpB;;A+DpomBA;EACI,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;A/DuomBJ;A+DromBI;EANJ;IAOQ,kBAAA;E/DwomBN;AACF;A+DtomBI;EAVJ;IAWQ,kBAAA;E/DyomBN;AACF;A+DvomBI;EAdJ;IAeQ,kBAAA;E/D0omBN;AACF;A+DxomBI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A/D0omBR;;A+DtomBA;EACI,eAAA;EACA,iBAAA;A/DyomBJ;A+DvomBI;EAJJ;IAKQ,gBAAA;E/D0omBN;AACF;A+DxomBI;EARJ;IASQ,gBAAA;IACA,eAAA;E/D2omBN;AACF;A+D1omBI;EACI,qBAAA;EACA,kBAAA;A/D4omBR;A+D3omBQ;EAHJ;IAIQ,gBAAA;IACA,YAAA;E/D8omBV;AACF;A+D7omBQ;EACI,kBAAA;EACA,mBAAA;A/D+omBZ;A+D9omBY;EACI,oBAAA;A/DgpmBhB;;A+DtomBY;EACI,aAAA;EACA,8BAAA;A/DyomBhB;A+DxomBgB;EACI,2BAAA;EACA,kBAAA;A/D0omBpB;A+DxomBgB;EACI,eAAA;EACA,kBAAA;A/D0omBpB;A+DxomBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;A/D0omBpB;A+DxomBgB;EACI,iBAAA;EACA,gBAAA;EACA,6BAAA;A/D0omBpB;;AgE7vmBA;;+BAAA;AAKQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AhE8vmBZ;AgE5vmBQ;EACI,mBAAA;AhE8vmBZ;AgE5vmBQ;EACI,gBAAA;EACA,mBAAA;AhE8vmBZ;AgE5vmBQ;EACI,aAAA;AhE8vmBZ;AgE7vmBY;EAFJ;IAGQ,cAAA;EhEgwmBd;AACF;AgE9vmBgB;EADJ;IAEQ,gBAAA;EhEiwmBlB;AACF;AgE7vmBQ;EAEI,gBAAA;AhE8vmBZ;AgE7vmBY;EACI,gBAAA;EACA,aAAA;AhE+vmBhB;AgE9vmBgB;EACI,gBAAA;EACA,2BAAA;AhEgwmBpB;AgE9vmBgB;EACI,kBAAA;EACA,qBAAA;AhEgwmBpB;AgE/vmBoB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AhEiwmBxB;AgE7vmBgB;EACI,aAAA;AhE+vmBpB;AgEzvmBI;EACI,kBAAA;AhE2vmBR;;AgEvvmBA;EACI,kBAAA;EACA,qBAAA;AhE0vmBJ;AgEzvmBI;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AhE2vmBR;AgE1vmBQ;EAVJ;IAWQ,gBAAA;EhE6vmBV;AACF;AgE5vmBQ;EAbJ;IAcQ,gBAAA;EhE+vmBV;AACF;AgE7vmBI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AhE+vmBR;AgE3vmBQ;EACI,SAAA;EACA,YAAA;AhE6vmBZ;AgEnvmBA;EACI,gCAAA;EACA,uBAAA;EACA,mBAAA;AhEqvmBJ;AgEnvmBI;EACI,cAAA;AhEqvmBR;AgEnvmBY;EACI,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AhEqvmBhB;AgEpvmBgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,QAAA;AhEsvmBpB;AgEpvmBgB;EAEI,2BAAA;AhEqvmBpB;AgEpvmBoB;EACI,WAAA;AhEsvmBxB;;AgE5umBQ;EACI,gBAAA;AhE+umBZ;AgE5umBI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AhE8umBR;AgE1umBQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;AhE4umBZ;;AgErumBI;EACI,iBAAA;AhEwumBR;AgEvumBQ;EAFJ;IAGQ,gBAAA;IACA,cAAA;EhE0umBV;AACF;AgEzumBQ;EANJ;IAOQ,gBAAA;IACA,cAAA;EhE4umBV;AACF;AgE3umBQ;EAVJ;IAWQ,gBAAA;IACA,cAAA;EhE8umBV;AACF;AgE7umBQ;EAdJ;IAeQ,gBAAA;IACA,cAAA;EhEgvmBV;AACF;AgE/umBQ;EAlBJ;IAmBQ,gBAAA;IACA,cAAA;EhEkvmBV;AACF;AgEhvmBI;EACI,aAAA;AhEkvmBR;AgEjvmBQ;EAFJ;IAGQ,aAAA;EhEovmBV;AACF;AgEnvmBQ;EALJ;IAMQ,aAAA;EhEsvmBV;AACF;AgErvmBQ;EARJ;IASQ,aAAA;EhEwvmBV;AACF;AgEtvmBI;EACI,kBAAA;EACA,uBAAA;EACA,UAAA;AhEwvmBR;AgEvvmBQ;EACI,UAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AhEyvmBZ;AgExvmBY;EARJ;IASQ,WAAA;IACA,YAAA;EhE2vmBd;AACF;AgE1vmBY;EACI,gBAAA;AhE4vmBhB;AgE1vmBY;EACI,yBAAA;AhE4vmBhB;;AiE39mBA;;0BAAA;AAKI;EACI,iBAAA;AjE49mBR;AiE39mBQ;EAFJ;IAGQ,gBAAA;EjE89mBV;AACF;AiE59mBY;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AjE89mBhB;AiE79mBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AjE+9mBpB;AiE99mBoB;EANJ;IAOQ,kBAAA;IACA,eAAA;EjEi+mBtB;AACF;AiEh+mBoB;EAVJ;IAWQ,kBAAA;IACA,eAAA;EjEm+mBtB;AACF;AiEl+mBoB;EAdJ;IAeQ,kBAAA;IACA,eAAA;EjEq+mBtB;AACF;AiEp+mBoB;EACI,kBAAA;EACA,0BAAA;AjEs+mBxB;AiEp+mBoB;EACI,0BAAA;AjEs+mBxB;AiE79mBoB;EACI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AjE+9mBxB;AiE79mBoB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AjE+9mBxB;AiE79mBwB;EATJ;IAUQ,eAAA;IACA,gBAAA;EjEg+mB1B;AACF;AiE99mBwB;EAdJ;IAeQ,eAAA;IACA,gBAAA;EjEi+mB1B;AACF;AiE/9mBwB;EACI,2BAAA;AjEi+mB5B;AiE59mBoB;EACI,uBAAA;AjE89mBxB;AiE19mBgB;EACI,eAAA;EACA,cAAA;EACA,gCAAA;AjE49mBpB;AiE39mBoB;EAJJ;IAKQ,iBAAA;EjE89mBtB;AACF;AiE79mBoB;EAPJ;IAQQ,iBAAA;EjEg+mBtB;AACF;AiE/9mBoB;EACI,kBAAA;AjEi+mBxB;AiEh+mBwB;EAFJ;IAGQ,eAAA;EjEm+mB1B;AACF;AiEl+mBwB;EALJ;IAMQ,eAAA;EjEq+mB1B;AACF;AiEp+mBwB;EARJ;IASQ,eAAA;EjEu+mB1B;AACF;AiEn+mBgB;;EAEI,gBAAA;EACA,eAAA;EACA,iBAAA;AjEq+mBpB;AiEl+mBoB;EACI,2BAAA;EACA,gBAAA;AjEo+mBxB;AiEn+mBwB;EACI,6BAAA;AjEq+mB5B;AiE59mBQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AjE89mBZ;AiE79mBY;EAJJ;IAKQ,gBAAA;EjEg+mBd;AACF;AiE/9mBY;EAPJ;IAQQ,gBAAA;EjEk+mBd;AACF;;AiE59mBI;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AjE+9mBR;AiE79mBI;EAEI,gCAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,kBAAA;AjE89mBR;AiE79mBQ;EACI,aAAA;EACA,SAAA;AjE+9mBZ;AiE99mBY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AjEg+mBhB;AiE/9mBgB;EACI,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;AjEi+mBpB;AiE99mBY;EACI,6BAAA;AjEg+mBhB;;AiE19mBA;EACI,kBAAA;EACA,qBAAA;AjE69mBJ;AiE59mBI;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AjE89mBR;AiE79mBQ;EARJ;IASQ,eAAA;IACA,kBAAA;IACA,mBAAA;EjEg+mBV;AACF;AiE99mBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;AjEg+mBR;AiE/9mBQ;EANJ;IAOQ,aAAA;EjEk+mBV;AACF;AiEh+mBI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,YAAA;AjEk+mBR;AiEj+mBQ;EANJ;IAOQ,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,gBAAA;EjEo+mBV;AACF;;AiE79mBA;;2BAAA;AAGA;EACI,gBAAA;AjEg+mBJ;;AiE99mBA;EACI,cAAA;AjEi+mBJ;;AiE99mBA;EACI,WAAA;EACA,eAAA;AjEi+mBJ;;AiE/9mBA;EACI,qBAAA;AjEk+mBJ;;AiEh+mBA;EACI,qBAAA;AjEm+mBJ;;AiEh+mBA;EACI,0CAAA;EACA,cAAA;EACA,2BAAA;AjEm+mBJ;;AiEh+mBA;EACI,uDAAA;AjEm+mBJ;;AiEh+mBA;EACI,WAAA;AjEm+mBJ;;AiEh+mBA;EACI,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AjEm+mBJ;;AiEh+mBA;EACI,SAAA;EACA,iBAAA;AjEm+mBJ;;AiEh+mBA;;;EAGI,uDAAA;EACA,cAAA;EACA,2BAAA;AjEm+mBJ;;AiEh+mBA;EACI,uDAAA;AjEm+mBJ;;AiEh+mBA;EACI,kBAAA;EACA,gBAAA;AjEm+mBJ;;AiE/9mBA;EACI,aAAA;EACA,mBAAA;AjEk+mBJ;AiEj+mBI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AjEm+mBR;AiEl+mBQ;EACI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AjEo+mBZ;AiEl+mBQ;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;AjEo+mBZ;AiEj+mBI;EACI,qBAAA;EACA,gBAAA;AjEm+mBR;AiEj+mBY;EACI,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AjEm+mBhB;;AiE39mBA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AjE89mBJ;;AkExznBA;;8BAAA;AAII;EACI,kBAAA;EACA,mBAAA;AlE0znBR;AkEzznBQ;EAHJ;IAIQ,gBAAA;IACA,iBAAA;ElE4znBV;AACF;AkE3znBQ;EACI,aAAA;EACA,iBAAA;EACA,WAAA;AlE6znBZ;AkE5znBY;EAJJ;IAKQ,YAAA;ElE+znBd;AACF;;AkE1znBA;EACI,kBAAA;AlE6znBJ;AkE5znBI;EAFJ;IAGQ,iBAAA;ElE+znBN;AACF;AkE9znBI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AlEg0nBR;AkE/znBQ;EAJJ;IAKQ,gBAAA;IACA,mBAAA;ElEk0nBV;AACF;AkEj0nBQ;EARJ;IASQ,gBAAA;IACA,mBAAA;ElEo0nBV;AACF;AkEn0nBQ;EAZJ;IAaQ,cAAA;ElEs0nBV;AACF;AkEr0nBQ;EACI,kBAAA;AlEu0nBZ;AkEt0nBY;EAFJ;IAGQ,eAAA;IACA,mBAAA;ElEy0nBd;AACF;AkEt0nBI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AlEw0nBR;AkEv0nBQ;EALJ;IAMQ,eAAA;IACA,mBAAA;ElE00nBV;AACF;AkEz0nBQ;EATJ;IAUQ,eAAA;IACA,mBAAA;ElE40nBV;AACF;AkE10nBI;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AlE40nBR;AkE30nBQ;EACI,cAAA;AlE60nBZ;AkE50nBY;EAFJ;IAGQ,cAAA;ElE+0nBd;AACF;AkE90nBY;EALJ;IAMQ,cAAA;ElEi1nBd;AACF;AkEh1nBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AlEk1nBhB;AkEj1nBgB;EATJ;IAUQ,eAAA;IACA,eAAA;ElEo1nBlB;AACF;AkEn1nBgB;EACI,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,8BAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AlEq1nBpB;AkEn1nBgB;EAEI,2BAAA;AlEo1nBpB;AkEn1nBoB;EACI,WAAA;EACA,UAAA;AlEq1nBxB;AkE90nBI;EACI,gBAAA;AlEg1nBR;AkE70nBI;EACI,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AlE+0nBR;AkE90nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AlEg1nBZ;AkE90nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AlEg1nBZ;;AkEx0nBI;EACI,kBAAA;AlE20nBR;AkEx0nBI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;AlE00nBR;AkEv0nBI;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AlEy0nBR;AkEx0nBQ;EALJ;IAMQ,cAAA;ElE20nBV;AACF;AkE10nBQ;EACI,yBAAA;AlE40nBZ;AkEv0nBQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;AlEy0nBZ;;AkEn0nBA;EACI,UAAA;EACA,aAAA;AlEs0nBJ;AkEr0nBI;EAHJ;IAIQ,sBAAA;ElEw0nBN;AACF;AkEt0nBI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AlEw0nBR;AkEv0nBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlEy0nBZ;AkEx0nBY;EALJ;IAMQ,WAAA;IACA,mBAAA;ElE20nBd;AACF;AkEv0nBQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AlEy0nBZ;AkEv0nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AlEy0nBZ;AkEv0nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AlEy0nBZ;AkEv0nBQ;EArBJ;IAsBQ,gBAAA;ElE00nBV;AACF;;AkEr0nBA;EACI,aAAA;AlEw0nBJ;AkEv0nBI;EAFJ;IAGQ,sBAAA;ElE00nBN;AACF;AkEx0nBI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AlE00nBR;AkEz0nBQ;EACI,mBAAA;EACA,WAAA;AlE20nBZ;AkEv0nBQ;EACI,aAAA;EACA,mBAAA;AlEy0nBZ;AkEv0nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AlEy0nBZ;AkEv0nBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AlEy0nBZ;AkEv0nBQ;EApBJ;IAqBQ,gBAAA;ElE00nBV;AACF;AkEx0nBI;EACI,6BAAA;EACA,iBAAA;EACA,gBAAA;AlE00nBR;;AkEt0nBA;EACI,kBAAA;EACA,yBAAA;EACA,aAAA;AlEy0nBJ;AkEv0nBQ;EACI,gBAAA;AlEy0nBZ;;AmEhmoBA;;0BAAA;AAGA;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AnEmmoBJ;;AmEhmoBA;EACI,0DAAA;EACA,kBAAA;EACA,UAAA;AnEmmoBJ;AmElmoBI;EACI,iBAAA;EACA,WAAA;AnEomoBR;AmEnmoBQ;EAHJ;IAIQ,iBAAA;EnEsmoBV;AACF;AmErmoBQ;EANJ;IAOQ,qBAAA;EnEwmoBV;EmEvmoBU;IACI,eAAA;IACA,mBAAA;EnEymoBd;AACF;AmEvmoBQ;EAbJ;IAcQ,qBAAA;EnE0moBV;EmEzmoBU;IACI,gBAAA;IACA,UAAA;EnE2moBd;AACF;AmEvmoBI;EACI,gBAAA;AnEymoBR;AmExmoBQ;EAFJ;IAGQ,gBAAA;EnE2moBV;AACF;AmE1moBQ;EALJ;IAMQ,gBAAA;EnE6moBV;AACF;AmE5moBQ;EARJ;IASQ,eAAA;EnE+moBV;AACF;AmE9moBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AnEgnoBZ;AmE/moBY;EALJ;IAMQ,eAAA;IACA,mBAAA;EnEknoBd;AACF;AmEjnoBY;EATJ;IAUQ,eAAA;IACA,mBAAA;EnEonoBd;AACF;AmEnnoBY;EAbJ;IAcQ,eAAA;IACA,mBAAA;EnEsnoBd;AACF;AmEpnoBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AnEsnoBZ;AmErnoBY;EALJ;IAMQ,mBAAA;EnEwnoBd;AACF;AmEvnoBY;EARJ;IASQ,mBAAA;EnE0noBd;AACF;AmEznoBY;EAXJ;IAYQ,mBAAA;EnE4noBd;AACF;AmE1noBgB;EADJ;IAEQ,aAAA;EnE6noBlB;AACF;AmE1noBQ;EACI,mBAAA;EACA,2BAAA;AnE4noBZ;AmE3noBY;EAHJ;IAIQ,2BAAA;EnE8noBd;AACF;AmE7noBY;EANJ;IAOQ,sBAAA;EnEgooBd;AACF;AmE/noBY;EACI,kBAAA;AnEiooBhB;AmEhooBgB;EAFJ;IAGQ,iBAAA;IACA,mBAAA;EnEmooBlB;AACF;AmEjooBY;EACI,2BAAA;AnEmooBhB;AmElooBgB;EACI,6BAAA;EACA,eAAA;AnEoooBpB;AmE9noBI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;AnEgooBR;AmE/noBQ;EAJJ;IAKQ,oBAAA;EnEkooBV;AACF;AmEjooBQ;EAPJ;IAQQ,oBAAA;IACA,mBAAA;EnEoooBV;AACF;AmEnooBQ;EAXJ;IAYQ,eAAA;EnEsooBV;AACF;AmErooBQ;EAdJ;IAeQ,6BAAA;EnEwooBV;AACF;AmEvooBQ;EAjBJ;IAkBQ,0BAAA;EnE0ooBV;AACF;AmEzooBQ;EApBJ;IAqBQ,yBAAA;EnE4ooBV;AACF;AmE1ooBY;EADJ;IAEQ,UAAA;EnE6ooBd;AACF;AmE5ooBY;EAJJ;IAKQ,UAAA;EnE+ooBd;AACF;AmE9ooBY;EAPJ;IAQQ,UAAA;EnEipoBd;AACF;AmE/ooBY;EAXJ;IAYQ,WAAA;EnEkpoBd;AACF;AmE9ooBI;EACI,kBAAA;EACA,WAAA;AnEgpoBR;AmE/ooBQ;EACI,UAAA;EACA,WAAA;AnEipoBZ;AmE/ooBQ;EACI,YAAA;EACA,aAAA;AnEipoBZ;AmE/ooBQ;EACI,YAAA;EACA,WAAA;AnEipoBZ;;AmE5ooBA;;2BAAA;AAGA;EACI,0DAAA;AnE+ooBJ;AmE9ooBI;EACI,kBAAA;EACA,WAAA;AnEgpoBR;AmE/ooBQ;EACI,QAAA;EACA,YAAA;EACA,4DAAA;AnEipoBZ;AmE/ooBQ;EACI,UAAA;EACA,aAAA;AnEipoBZ;AmE/ooBQ;EACI,aAAA;EACA,YAAA;EACA,2DAAA;AnEipoBZ;;AmE5ooBA;;2BAAA;AAGA;EACI,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,2BAAA;AnE+ooBJ;;AmE5ooBA;;2BAAA;AAGA;EACI,iCAAA;EACA,kBAAA;AnE+ooBJ;AmE9ooBI;EACI,gBAAA;AnEgpoBR;AmE9ooBI;EACI,kBAAA;EACA,WAAA;AnEgpoBR;AmE/ooBQ;EACI,UAAA;EACA,YAAA;AnEipoBZ;AmE/ooBQ;EACI,aAAA;EACA,YAAA;AnEipoBZ;AmE/ooBQ;EACI,SAAA;EACA,WAAA;AnEipoBZ;AmE/ooBQ;EACI,SAAA;EACA,aAAA;AnEipoBZ;AmE/ooBQ;EACI,YAAA;EACA,aAAA;AnEipoBZ;AmE5ooBQ;EACI,kBAAA;EACA,WAAA;AnE8ooBZ;AmE7ooBY;EACI,qBAAA;EACA,mBAAA;AnE+ooBhB;AmE5ooBY;EACI,aAAA;EACA,YAAA;AnE8ooBhB;AmE7ooBgB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;AnE+ooBpB;AmE3ooBY;EACI,YAAA;EACA,WAAA;AnE6ooBhB;AmE5ooBgB;EACI,WAAA;EACA,YAAA;EACA,sCAAA;AnE8ooBpB;AmE1ooBY;EACI,UAAA;EACA,aAAA;AnE4ooBhB;AmE3ooBgB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;AnE6ooBpB;AmEvooBI;EA1EJ;IA2EQ,2BAAA;EnE0ooBN;EmEzooBM;IACI,aAAA;EnE2ooBV;AACF;AmExooBI;EAjFJ;IAkFQ,0BAAA;EnE2ooBN;AACF;AmEzooBI;EArFJ;IAsFQ,0BAAA;EnE4ooBN;AACF;;AmEvooBA;;2BAAA;AAKI;EACI,kBAAA;EACA,WAAA;AnEwooBR;AmEvooBQ;EACI,SAAA;EACA,YAAA;AnEyooBZ;AmEvooBQ;EACI,UAAA;EACA,aAAA;EACA,8CAAA;AnEyooBZ;AmEvooBQ;EACI,aAAA;EACA,aAAA;EACA,4DAAA;AnEyooBZ;AmEvooBQ;EACI,aAAA;EACA,YAAA;AnEyooBZ;;AmEpooBA;EACI,kBAAA;AnEuooBJ;AmEpooBQ;EACI,oBAAA;AnEsooBZ;AmElooBI;EACI,kBAAA;AnEoooBR;AmElooBQ;EACI,cAAA;EACA,YAAA;EACA,sBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AnEoooBZ;AmElooBY;EACI,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AnEoooBhB;AmEjooBY;EACI,WAAA;EACA,kBAAA;AnEmooBhB;AmE9noBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AnEgooBZ;AmE/noBY;EACI,YAAA;EACA,iBAAA;EACA,eAAA;AnEiooBhB;AmE5noBI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AnE8noBR;AmExnoBgB;EACI,aAAA;AnE0noBpB;AmEjnoBgB;EACI,UAAA;AnEmnoBpB;AmE/moBY;EACI,UAAA;EACA,yCAAA;AnEinoBhB;;AmE1moBI;EACI,kBAAA;AnE6moBR;AmE3moBQ;EACI,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnE6moBZ;AmE3moBY;EACI,gBAAA;AnE6moBhB;AmEzmoBQ;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AnE2moBZ;;AmEtmoBA;EACI,eAAA;AnEymoBJ;;AmEpmoBI;EACI,gBAAA;AnEumoBR;AmEtmoBQ;EACI,6BAAA;AnEwmoBZ;;AmEnmoBA;EACI,kBAAA;EACA,UAAA;EACA,mCAAA;AnEsmoBJ;AmEpmoBI;EACI,kBAAA;AnEsmoBR;AmErmoBQ;EACI,yBAAA;EACA,6BAAA;AnEumoBZ;AmElmoBQ;EACI,2BAAA;AnEomoBZ;AmEnmoBY;EACI,6BAAA;EACA,eAAA;AnEqmoBhB;AmEjmoBI;EACI,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AnEmmoBR;AmElmoBQ;EARJ;IASQ,WAAA;EnEqmoBV;AACF;AmEpmoBQ;EAXJ;IAYQ,UAAA;EnEumoBV;AACF;AmErmoBQ;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AnEumoBZ;AmEtmoBY;EACI,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AnEwmoBhB;AmEtmoBgB;EACI,yBAAA;AnEwmoBpB;AmErmoBY;EACI,gBAAA;AnEumoBhB;AmErmoBgB;EACI,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AnEumoBpB;AmEpmoBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AnEsmoBpB;AmEhmoBI;EACI,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AnEkmoBR;AmEhmoBQ;EAXJ;IAYQ,SAAA;IACA,QAAA;EnEmmoBV;AACF;AmE5loBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AnE8loBpB;AmEzloBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AnE2loBpB;AmExloBgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AnE0loBpB;AmErloBQ;EA9CJ;IA+CQ,YAAA;EnEwloBV;AACF;AmEvloBQ;EAjDJ;IAkDQ,UAAA;IACA,cAAA;EnE0loBV;AACF;AmEvloBI;EACI,8BAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EAwBA,aAAA;AnEkkoBR;AmExloBQ;EACI,iBAAA;EACA,kBAAA;AnE0loBZ;AmEzloBY;EACI,eAAA;AnE2loBhB;AmEvloBQ;EACI,eAAA;AnEyloBZ;AmExloBY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AnE0loBhB;AmEvloBY;EACI,gBAAA;EACA,eAAA;AnEyloBhB;AmErloBQ;EAlCJ;IAmCQ,aAAA;EnEwloBV;AACF;AmErloBI;EACI,kBAAA;EACA,aAAA;EACA,aAAA;AnEuloBR;AmEtloBQ;EAJJ;IAKQ,UAAA;IACA,cAAA;EnEyloBV;AACF;AmExloBQ;EARJ;IASQ,wBAAA;EnE2loBV;AACF;AmE1loBQ;EACI,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;AnE4loBZ;AmE3loBY;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AnE6loBhB;AmE3loBgB;EACI,eAAA;EACA,wBAAA;EACA,gBAAA;AnE6loBpB;AmExloBoB;EACI,eAAA;AnE0loBxB;AmEvloBgB;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AnEyloBpB;AmElloBQ;EACI,kBAAA;EACA,WAAA;AnEoloBZ;AmEnloBY;EACI,aAAA;EACA,UAAA;AnEqloBhB;AmEploBgB;EACI,kBAAA;AnEsloBpB;AmElloBY;EACI,WAAA;EACA,cAAA;AnEoloBhB;AmEnloBgB;EAHJ;IAIQ,YAAA;EnEsloBlB;AACF;AmErloBgB;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AnEuloBpB;AmEjloBI;EAlPJ;IAmPQ,aAAA;EnEoloBN;EmEnloBM;IACI,mBAAA;EnEqloBV;AACF;AmElloBI;EAzPJ;IA0PQ,0BAAA;EnEqloBN;AACF;;AmElloBA;;2BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnEoloBR;AmEnloBQ;EACI,UAAA;EACA,YAAA;EACA,4DAAA;AnEqloBZ;AmEnloBQ;EACI,aAAA;EACA,aAAA;AnEqloBZ;AmEnloBQ;EACI,aAAA;EACA,YAAA;AnEqloBZ;;AmEhloBA;;2BAAA;AAII;EACI,kBAAA;EACA,WAAA;AnEkloBR;AmEjloBQ;EACI,UAAA;EACA,aAAA;AnEmloBZ;AmEjloBQ;EACI,YAAA;EACA,YAAA;AnEmloBZ;;AmE9koBA;;2BAAA;AAII;EACI,aAAA;EACA,mBAAA;AnEgloBR;;AAlvpBA;;uCAAA;AoE9FA;;8BAAA;AAGA;EACC,kBAAA;EACA,UAAA;ApEs1pBD;AoEr1pBC;EACC,gBAAA;ApEu1pBF;AoEt1pBE;EAFD;IAGE,eAAA;EpEy1pBD;AACF;AoEx1pBE;EALD;IAME,eAAA;EpE21pBD;AACF;AoEx1pBC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;ApE01pBF;AoEv1pBC;EACC,yBAAA;EACA,gBAAA;EACA,mBAAA;ApEy1pBF;AoEp1pBE;EACC,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;ApEs1pBH;AoEr1pBG;EACC,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;ApEu1pBJ;AoEr1pBG;EACC,yBAAA;EACA,gBAAA;ApEu1pBJ;AoEr1pBG;EACC,gBAAA;ApEu1pBJ;AoEp1pBI;EACC,yBAAA;ApEs1pBL;AoE/0pBE;EACC,gBAAA;ApEi1pBH;AoE/0pBE;EACC,gBAAA;EACA,UAAA;ApEi1pBH;AoEh1pBG;EACC,aAAA;EACA,gBAAA;ApEk1pBJ;AoEj1pBI;EACC,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;ApEm1pBL;AoEl1pBK;EACC,kBAAA;EACA,eAAA;ApEo1pBN;AoEj1pBI;EACC,gBAAA;ApEm1pBL;AoEh1pBK;EACC,yBAAA;ApEk1pBN;AoE70pBE;EACC,iBAAA;ApE+0pBH;AoE90pBG;EAFD;IAGE,cAAA;EpEi1pBF;AACF;AoE/0pBG;EAND;IAOE,cAAA;EpEk1pBF;AACF;AoEh1pBG;EAVD;IAWE,cAAA;EpEm1pBF;AACF;AoEj1pBE;EACC,iBAAA;ApEm1pBH;AoEj1pBG;EAHD;IAIE,cAAA;EpEo1pBF;AACF;AoEl1pBG;EAPD;IAQE,cAAA;EpEq1pBF;AACF;AoEn1pBG;EAXD;IAYE,cAAA;EpEs1pBF;AACF;;AoEj1pBA;EACC,mBAAA;ApEo1pBD;AoEn1pBC;EACC,kBAAA;EACA,WAAA;ApEq1pBF;AoEp1pBE;EACC,UAAA;EACA,YAAA;ApEs1pBH;AoEr1pBG;EAHD;IAIE,UAAA;IACA,YAAA;EpEw1pBF;AACF;AoEv1pBG;EAPD;IAQE,UAAA;IACA,YAAA;EpE01pBF;AACF;AoEx1pBE;EACC,aAAA;EACA,aAAA;ApE01pBH;AoEz1pBG;EAHD;IAIE,aAAA;IACA,aAAA;EpE41pBF;AACF;AoE31pBG;EAPD;IAQE,aAAA;IACA,aAAA;EpE81pBF;AACF;;AoEz1pBA;;mCAAA;AAGA;EACC,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;ApE41pBD;AoE31pBC;EALD;IAME,aAAA;EpE81pBA;AACF;AoE71pBC;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;ApE+1pBF;AoE91pBE;EALD;IAME,gBAAA;IACA,MAAA;IACA,oBAAA;EpEi2pBD;AACF;AoE/1pBC;EACC,kBAAA;EACA,gBAAA;ApEi2pBF;;AoE71pBA;;mCAAA;AAIC;EACC,mBAAA;ApE+1pBF;AoE51pBC;EALD;IAME,oBAAA;EpE+1pBA;EoE91pBA;IACC,kBAAA;EpEg2pBD;EoE91pBA;;IAEC,aAAA;EpEg2pBD;AACF;AoE71pBC;EACC,kBAAA;EACA,gBAAA;ApE+1pBF;AoE91pBE;EAHD;IAIE,kBAAA;EpEi2pBD;AACF;AoEh2pBE;EAND;IAOE,gBAAA;EpEm2pBD;AACF;AoEh2pBC;EACC,kBAAA;EACA,WAAA;ApEk2pBF;AoEj2pBE;EACC,UAAA;EACA,YAAA;ApEm2pBH;AoEl2pBG;EAHD;IAIE,UAAA;IACA,YAAA;EpEq2pBF;AACF;AoEp2pBG;EAPD;IAQE,UAAA;IACA,YAAA;EpEu2pBF;AACF;AoEr2pBE;EACC,aAAA;EACA,aAAA;ApEu2pBH;AoEt2pBG;EAHD;IAIE,aAAA;IACA,aAAA;EpEy2pBF;AACF;AoEx2pBG;EAPD;IAQE,aAAA;IACA,aAAA;EpE22pBF;AACF;;AqEtlqBA;;2BAAA;AAII;EACI,yBAAA;ArEwlqBR;AqEvlqBQ;EACI,yBAAA;EACA,gBAAA;ArEylqBZ;AqExlqBY;EACI,2BAAA;ArE0lqBhB;;AAhgqBA;;uCAAA;AAIA;EACC,wCAAA;EACA,oCAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAkgqBD;;AA//pBA;EACC,oCAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAkgqBD;;AA//pBA;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAkgqBD;;AA//pBA;EACC,sBAAA;AAkgqBD;;AAhgqBA;EACC,iBAAA;AAmgqBD;;AAhgqBA;EACC,kBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AAmgqBD;;AAjgqBA;EACC,mBAAA;EACA,kBAAA;AAogqBD;;AAjgqBA;EACC,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAogqBD;;AAlgqBA;EACC,kCAAA;EACA,sBAAA;AAqgqBD;;AAngqBA;EACC,oCAAA;AAsgqBD;;AAngqBA;EACC,YAAA;AAsgqBD;;AApgqBA;EACC,YAAA;AAugqBD;;AApgqBA;EACC,oCAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAugqBD;;AArgqBA;EACC,kCAAA;EACA,sBAAA;AAwgqBD;;AArgqBA;EACC,oCAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAwgqBD;;AAtgqBA;EACC,oCAAA;EACA,uBAAA;EACA,sBAAA;AAygqBD;;AAvgqBA;EACC,2BAAA;AA0gqBD;;AAxgqBA;EACC,6BAAA;EACA,4BAAA;AA2gqBD;;AAzgqBA;EACC,0CAAA;EACA,uCAAA;AA4gqBD;;AA1gqBA;EACC,2CAAA;EACA,wCAAA;EACA,4CAAA;AA6gqBD;;AA1gqBA;EACC,oCAAA;AA6gqBD;;AA1gqBA;EACC,kCAAA;AA6gqBD;;AA3gqBA;EACC,2BAAA;AA8gqBD;;AA5gqBA;EACC,0BAAA;EACA,2BAAA;AA+gqBD;;AA7gqBA;EACC,kCAAA;AAghqBD;;AA9gqBA;EACC,mBAAA;AAihqBD;;AA/gqBA;EACC,aAAA;AAkhqBD;;AAhhqBA;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAmhqBD;;AAhhqBA;EACC,yBAAA;EACA,cAAA;EACA,8BAAA;AAmhqBD;;AAhhqBA;EACC,yCAAA;EACA,0CAAA;AAmhqBD;;AAhhqBA;EACC,qBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAmhqBD;;AAhhqBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,eAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;AAkhqBD;;AA/gqBA;EACC,6CAAA;AAkhqBD;;AA/gqBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AAkhqBD;;AA/gqBA;EACC,mBAAA;EACA,kBAAA;EACA,aAAA;AAkhqBD;;AA9gqBA;EACC,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;AAihqBD;;AA9gqBA;EACC,uBAAA;AAihqBD;;AA9gqBA;EACC,eAAA;EACA,YAAA;EACA,mBAAA;AAihqBD;;AA9gqBA;EACC,wBAAA;EACA,eAAA;AAihqBD;;AA9gqBA;EACC,gBAAA;EACA,2CAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAihqBD;;AA9gqBA;EACC,iCAAA;AAihqBD;;AA9gqBA;EACC,gCAAA;AAihqBD;;AA9gqBA;EACC,wBAAA;AAihqBD;;AA9gqBA;EACC,qBAAA;AAihqBD;;AA9gqBA;EACC,yBAAA;EACA,2BAAA;EAGA,iBAAA;EACA,cAAA;AAihqBD;;AA9gqBA;;EAEC,gCAAA;EACA,oCAAA;AAihqBD;;AA9gqBA;;EAEC,gCAAA;EACA,oCAAA;AAihqBD;;AA/gqBA;EACC;IACC,uBAAA;EAkhqBA;EAhhqBD;IACC,yBAAA;EAkhqBA;AACF;AA/gqBA;EACC,aAAA;AAihqBD;;AA/gqBA;EACC,YAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAkhqBD;;AAhhqBA;EACC,uGAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;AAmhqBD;;AAjhqBA;EACC,uGAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;AAohqBD;;AAlhqBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAqhqBD;;AAlhqBA;EACC;IACC,2BAAA;IACA,cAAA;EAqhqBA;EAnhqBD;IACC,wBAAA;EAqhqBA;AACF;AAlhqBA;EACC;IACC,wBAAA;EAohqBA;EAlhqBD;IACC,2BAAA;IACA,aAAA;EAohqBA;AACF;AAjhqBA;EACC,iCAAA;AAmhqBD;;AAhhqBA;EACC,yCAAA;AAmhqBD;;AAhhqBA;EACC,UAAA;EACA,SAAA;AAmhqBD;;AAjhqBA;EACC,8BAAA;AAohqBD;;AAlhqBA;EACC,qBAAA;AAqhqBD;;AAnhqBA;EACC,qBAAA;AAshqBD;;AAphqBA;EACC,kCAAA;EACA,iBAAA;AAuhqBD;;AArhqBA;EACC,mBAAA;AAwhqBD;;AAthqBA;EACC,8BAAA;AAyhqBD;;AAvhqBA;EACC,0BAAA;AA0hqBD;;AAvhqBA;EACC,yDAAA;AA0hqBD;;AAvhqBA,gDAAA;AACA;EACC,aAAA;AA0hqBD;;AAvhqBA,4CAAA;AACA;EACC,YAAA;EACA,cAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AA0hqBD;;AAxhqBA;EACC,YAAA;AA2hqBD;;AAxhqBA;EACC,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA2hqBD;;AAzhqBA;EACC,6BAAA;AA4hqBD;;AA1hqBA;EACC,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA6hqBD;;AA3hqBA;EACC,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA8hqBD;;AA3hqBA;EACC,aAAA;AA8hqBD;;AA3hqBA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA8hqBD;;AA5hqBA;EACC,oCAAA;EACA,yBAAA;AA+hqBD;;AA7hqBA;EACC,oCAAA;EACA,yBAAA;AAgiqBD;;AA7hqBA;EACC,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAgiqBD;;AA9hqBA;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;AAiiqBD;;AA/hqBA;EACC,uBAAA;EACA,2BAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;AAkiqBD;;AA/hqBA;EACC,0BAAA;EACA,2BAAA;AAkiqBD;;AAhiqBA;EACC,0BAAA;EACA,2BAAA;AAmiqBD;;AAjiqBA;EACC,0BAAA;AAoiqBD;;AAliqBA;EACC,sBAAA;EACA,uBAAA;AAqiqBD;;AAliqBA;EACC,0BAAA,EAAA,cAAA;AAqiqBD;;AAliqBA;EACC,oCAAA;EACA,sBAAA;AAqiqBD;;AAzhqBA;EACC,aAAA;AA4hqBD;;AA1hqBA;EACC,aAAA;AA6hqBD;;AA1hqBA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA6hqBD;;AA3hqBA;EACC,WAAA;EACA,YAAA;EACA,uBAAA;AA8hqBD;;AA5hqBA;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AA+hqBD;;AA7hqBA;EACC,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAgiqBD;;AA7hqBA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AAgiqBD;;AA7hqBA;EACC,YAAA;AAgiqBD;;AA9hqBA;EACC,+BAAA;AAiiqBD;;AA/hqBA;EACC,sBAAA;EACA,uBAAA;AAkiqBD;;AAhiqBA;EACC,aAAA;EACA,uBAAA;AAmiqBD;;AAlhqBA;EACC,oCAAA;AAuiqBD;;AApiqBA;EACC,uBAAA;AAuiqBD;;AAniqBA;EACC,uBAAA;AAsiqBD;;AAniqBA;EACC,uBAAA;AAsiqBD;;AAniqBA;EACC,YAAA;EACA,aAAA;AAsiqBD;;AAniqBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;AAqiqBD;;AAniqBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;AAqiqBD;;AAniqBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;AAqiqBD;;AAniqBA;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAsiqBD;;AApiqBA;EACC,cAAA;EACA,gBAAA;AAuiqBD;;AAriqBA;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAwiqBD;;AAtiqBA;EACC,cAAA;AAyiqBD;;AAtiqBA;EACC;IACC,yCAAA;EAyiqBA;EAviqBD;IACC,2CAAA;EAyiqBA;EAviqBD;IACC,2CAAA;EAyiqBA;EAviqBD;IACC,sCAAA;EAyiqBA;AACF;AAviqBA;EACC,4CAAA;EACA,2CAAA;AAyiqBD;;AAviqBA;EACC,4BAAA;EACA,sBAAA;AA0iqBD;;AAxiqBA;EACC,iBAAA;AA2iqBD;AA1iqBC;EACC,6BAAA;EACA,8BAAA;EACA,yCAAA;EACA,WAAA;EACA,UAAA,EAAA,YAAA;AA4iqBF;AAziqBC;EACC,4BAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;AA2iqBF;AAxiqBC;EACC,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;AA0iqBF;;AAtiqBA;EACC,0BAAA;AAyiqBD;;AAtiqBA;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;AAyiqBD;;AAviqBA;EACC,YAAA;AA0iqBD;;AAxiqBA;EACC,UAAA;AA2iqBD;;AAziqBA;EACC,iBAAA;AA4iqBD;;AAziqBA;EACC,+BAAA;EACA,aAAA;AA4iqBD;;AAziqBA;EACC,+BAAA;EACA,aAAA;AA4iqBD;;AAziqBA;EACC,+BAAA;EACA,aAAA;AA4iqBD;;AAziqBA;EACC,+BAAA;EACA,aAAA;AA4iqBD;;AAziqBA;EACC,+BAAA;EACA,aAAA;AA4iqBD;;AAziqBA;EACC,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,qBAAA;AA4iqBD;;AA1iqBA;EACC,wBAAA;AA6iqBD;;AA3iqBA;EACC,+BAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AA8iqBD;;AA5iqBA;EACC,+BAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AA+iqBD;;AA7iqBA;EACC,oCAAA;AAgjqBD;;AA7iqBA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;AAgjqBD;;AA9iqBA;EACC,oBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAijqBD;;AA/iqBA;EACC,qBAAA;AAkjqBD;;AA/iqBA;EACC;IACC,mBAAA;IACA,oBAAA;IACA,kBAAA;EAkjqBA;AACF;AA/iqBA;EACC;IACC,wBAAA;EAijqBA;EA/iqBD;IACC,qCAAA;EAijqBA;EA/iqBD;IACC,0BAAA;EAijqBA;EA/iqBD;IACC,wBAAA;EAijqBA;EA/iqBD;IACC,yBAAA;EAijqBA;EA/iqBD;;IAEC,0BAAA;EAijqBA;EA/iqBD;IACC,4BAAA;EAijqBA;EA/iqBD;IACC,6BAAA;EAijqBA;EA/iqBD;IACC,mBAAA;IACA,sBAAA;IACA,kBAAA;EAijqBA;EA/iqBD;IACC,mBAAA;IACA,oBAAA;IACA,eAAA;EAijqBA;EA9iqBD;IACC,kBAAA;IACA,UAAA;IACA,SAAA;EAgjqBA;EA9iqBD;IACC,wBAAA;IACA,8BAAA;EAgjqBA;EA9iqBD;IACC,6BAAA;EAgjqBA;EA9iqBD;IACC,4BAAA;EAgjqBA;AACF;AA9iqBA;EACC;IACC,wBAAA;EAgjqBA;EA9iqBD;IACC,wBAAA;EAgjqBA;EA9iqBD;IACC,oBAAA;EAgjqBA;EA9iqBD;IACC,aAAA;EAgjqBA;EA9iqBD;IACC,mBAAA;IACA,qBAAA;IACA,kBAAA;EAgjqBA;EA9iqBD;IACC,mBAAA;IACA,oBAAA;IACA,kBAAA;EAgjqBA;EA7iqBD;IACC,aAAA;EA+iqBA;EA7iqBD;IACC,qBAAA;EA+iqBA;EA7iqBD;IACC,wBAAA;IACA,8BAAA;EA+iqBA;EA7iqBD;IACC,6BAAA;EA+iqBA;EA7iqBD;IACC,4BAAA;EA+iqBA;AACF;AA7iqBA;EACC;IACC,wBAAA;EA+iqBA;EA7iqBD;IACC,wBAAA;EA+iqBA;EA7iqBD;IACC,oBAAA;EA+iqBA;EA7iqBD;IACC,aAAA;EA+iqBA;EA7iqBD;IACC,qBAAA;EA+iqBA;EA7iqBD;IACC,mBAAA;IACA,qBAAA;IACA,kBAAA;EA+iqBA;EA5iqBD;IACC,wBAAA;IACA,8BAAA;EA8iqBA;EA5iqBD;IACC,6BAAA;EA8iqBA;EA5iqBD;IACC,4BAAA;EA8iqBA;AACF;AA5iqBA;EACC;IACC,wBAAA;EA8iqBA;EA5iqBD;IACC,4BAAA;EA8iqBA;EA5iqBD;IACC,6BAAA;EA8iqBA;EA5iqBD;IACC,wBAAA;EA8iqBA;EA5iqBD;IACC,aAAA;IACA,uBAAA;IACA,mBAAA;EA8iqBA;EA5iqBD;IACC,YAAA;IACA,aAAA;EA8iqBA;EA5iqBD;IACC,wBAAA;EA8iqBA;EA5iqBD;IACC,aAAA;EA8iqBA;EA5iqBD;IACC,oBAAA;EA8iqBA;EA5iqBD;IACC,aAAA;EA8iqBA;EA5iqBD;IACC,mBAAA;IACA,oBAAA;IACA,kBAAA;EA8iqBA;EA3iqBD;IACC,YAAA;EA6iqBA;EA3iqBD;IACC,qBAAA;EA6iqBA;EA3iqBD;IACC,wBAAA;EA6iqBA;EA3iqBD;IACC,wBAAA;EA6iqBA;EA3iqBD;IACC,yBAAA;EA6iqBA;EA3iqBD;IACC,wBAAA;IACA,8BAAA;EA6iqBA;EA3iqBD;IACC,6BAAA;EA6iqBA;EA3iqBD;IACC,4BAAA;EA6iqBA;AACF;AA3iqBA;EACC;IACC,4BAAA;EA6iqBA;EA3iqBD;IACC,6BAAA;EA6iqBA;EA3iqBD;IACC,wBAAA;EA6iqBA;EA3iqBD;IACC,aAAA;EA6iqBA;EA3iqBD;IACC,cAAA;EA6iqBA;EA3iqBD;IACC,oBAAA;EA6iqBA;EA3iqBD;IACC,aAAA;EA6iqBA;EA3iqBD;IACC,YAAA;EA6iqBA;EA3iqBD;IACC,aAAA;EA6iqBA;EA3iqBD;IACC,yBAAA;IACA,6BAAA;IACA,8BAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;EA6iqBA;EA3iqBD;IACC,yBAAA;IACA,uBAAA;IACA,0BAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;EA6iqBA;EA3iqBD;IACC,mBAAA;IACA,qBAAA;IACA,kBAAA;EA6iqBA;EA3iqBD;IACC,mBAAA;IACA,qBAAA;IACA,kBAAA;EA6iqBA;EA3iqBD;IACC,qBAAA;EA6iqBA;EA3iqBD;IACC,iBAAA;EA6iqBA;EA5iqBA;IACC,4BAAA;IACA,6BAAA;IACA,yCAAA;IACA,WAAA;IACA,UAAA,EAAA,YAAA;EA8iqBD;EA3iqBA;IACC,4BAAA;IACA,WAAA;IACA,4BAAA;IACA,6BAAA;EA6iqBD;EA1iqBA;IACC,mBAAA;IACA,WAAA;IACA,4BAAA;IACA,6BAAA;EA4iqBD;EAziqBD;IACC,4BAAA;EA2iqBA;EAziqBD;IACC,kBAAA;EA2iqBA;EAziqBD;IACC,gBAAA;IACA,kBAAA;EA2iqBA;EAziqBD;IACC,wBAAA;IACA,8BAAA;EA2iqBA;EAziqBD;IACC,wBAAA;EA2iqBA;EAziqBD;IACC,6BAAA;EA2iqBA;EAziqBD;IACC,6BAAA;EA2iqBA;EAziqBD;IACC,uBAAA;EA2iqBA;EAziqBD;IACC,qBAAA;EA2iqBA;AACF;AAxiqBA;EACC;IACC,2BAAA;EA0iqBA;EAxiqBD;IACC,2BAAA;EA0iqBA;EAxiqBD;IACC,WAAA;IACA,YAAA;IACA,iBAAA;EA0iqBA;EAxiqBD;IACC,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;EA0iqBA;EAxiqBD;IACC,eAAA;IACA,kBAAA;IACA,mBAAA;EA0iqBA;EAxiqBD;IACC,yBAAA;EA0iqBA;EAxiqBD;IACC,wBAAA;EA0iqBA;EAxiqBD;IACC,wBAAA;EA0iqBA;EAxiqBD;IACC,mCAAA;EA0iqBA;EAxiqBD;IACC,kBAAA;EA0iqBA;EAxiqBD;IACC,gBAAA;EA0iqBA;EAxiqBD;IACC,qCAAA;EA0iqBA;EAxiqBD;IACC,wBAAA;EA0iqBA;EAxiqBD;IACC,yBAAA;EA0iqBA;EAxiqBD;IACC,0BAAA;EA0iqBA;EAxiqBD;IACC,0BAAA;IACA,iBAAA;EA0iqBA;EAxiqBD;IACC,0BAAA;EA0iqBA;EAxiqBD;IACC,0BAAA;EA0iqBA;EAxiqBD;IACC,0BAAA;EA0iqBA;EAxiqBD;IACC,uBAAA;EA0iqBA;EAxiqBD;IACC,uBAAA;EA0iqBA;EAviqBD;IACC,0BAAA;IACA,0BAAA;IACA,kBAAA;EAyiqBA;EAviqBD;IACC,wBAAA;EAyiqBA;EAviqBD;;IAEC,2BAAA;EAyiqBA;EAviqBD;IACC,sBAAA;IACA,0BAAA;EAyiqBA;EAviqBD;IACC,2BAAA;EAyiqBA;EAviqBD;IACC,6BAAA;EAyiqBA;EAviqBD;IACC,yBAAA;EAyiqBA;EAviqBD;IACC,0BAAA;EAyiqBA;EAviqBD;IACC,qBAAA;EAyiqBA;EAtiqBD;IACC,yBAAA;IACA,oCAAA;IACA,uBAAA;IACA,kBAAA;EAwiqBA;EAtiqBD;IACC,aAAA;EAwiqBA;EAtiqBD;IACC,aAAA;EAwiqBA;EAtiqBD;IACC,sBAAA;EAwiqBA;EAtiqBD;IACC,mBAAA;IACA,sBAAA;IACA,kBAAA;EAwiqBA;EAtiqBD;IACC,mBAAA;IACA,qBAAA;IACA,kBAAA;EAwiqBA;EAtiqBD;IACC,2BAAA;EAwiqBA;EAtiqBD;IACC,0BAAA;EAwiqBA;EAtiqBD;IACC,0BAAA;EAwiqBA;EAtiqBD;IACC,cAAA;EAwiqBA;EAtiqBD;IACC,cAAA;IACA,gBAAA;EAwiqBA;EAtiqBD;IACC,sBAAA;EAwiqBA;EAtiqBD;IACC,sBAAA;EAwiqBA;EAtiqBD;IACC,yBAAA;EAwiqBA;EAtiqBD;IACC,8BAAA;EAwiqBA;EAriqBD;IACC,yBAAA;EAuiqBA;EAriqBD;IACC,6BAAA;EAuiqBA;EAriqBD;IACC,uBAAA;EAuiqBA;EAriqBD;IACC,qBAAA;EAuiqBA;AACF","sourcesContent":["/**************************************\n    Default Styles\n***************************************/\n@import \"bootstrap/dist/css/bootstrap.min.css\";\n@import url(\"../css/eduvibe-font.css\");\n@import url(\"../css/remixicon.css\");\n@import url(\"../css/animation.css\");\n@import url(\"../css/slick.css\");\n@import url(\"../css/slicktheme.css\");\n\n@import \"default/variables\";\n@import \"default/mixins\";\n@import \"default/reset\";\n@import \"default/typography\";\n@import \"default/extend\";\n@import \"default/animations\";\n@import \"default/shortcode\";\n@import \"default/spacing\";\n@import \"default/common\";\n@import \"default/forms\";\n\n/**************************************\n    Header Styles\n***************************************/\n@import \"header/header\";\n@import \"header/nav\";\n@import \"header/header-quote\";\n@import \"header/mobilemenu\";\n@import \"header/search-popup\";\n\n/**************************************\n    Elemnts Styles\n***************************************/\n@import \"elements/button\";\n@import \"elements/brands\";\n@import \"elements/section-title\";\n@import \"elements/section-animation\";\n@import \"elements/card\";\n@import \"elements/meta\";\n@import \"elements/badge\";\n@import \"elements/pagination\";\n@import \"elements/event\";\n@import \"elements/team\";\n@import \"elements/service\";\n@import \"elements/single-elements\";\n@import \"elements/coursesidebar\";\n@import \"elements/testimonial\";\n@import \"elements/feature\";\n@import \"elements/about\";\n@import \"elements/newsletter\";\n@import \"elements/social-share\";\n@import \"elements/backtotop\";\n@import \"elements/workshop\";\n@import \"elements/video-popup\";\n@import \"elements/chooseus\";\n@import \"elements/calltoaction\";\n@import \"elements/slickslider\";\n@import \"elements/winner\";\n@import \"elements/counterup\";\n@import \"elements/countdown\";\n@import \"elements/breadcrumb\";\n@import \"elements/masonaryitem\";\n@import \"elements/accordion\";\n@import \"elements/privacy-policy\";\n@import \"elements/404\";\n@import \"elements/coming-soon\";\n@import \"elements/gallery\";\n@import \"elements/pricingtable\";\n@import \"elements/profile-details\";\n@import \"elements/progressbar\";\n@import \"elements/contactus\";\n@import \"elements/shop\";\n@import \"elements/brand\";\n@import \"elements/checkout\";\n@import \"elements/overall\";\n\n/**************************************\n    Blog Styles\n***************************************/\n@import \"blog/blog-grid\";\n@import \"blog/sidebar\";\n@import \"blog/blog-details\";\n@import \"blog/comments\";\n\n/**************************************\n    Template Styles\n***************************************/\n@import \"template/banner\";\n@import \"template/event-details\";\n@import \"template/product-details\";\n@import \"template/cart\";\n@import \"template/course-details\";\n@import \"template/preview\";\n\n/**************************************\n    Footer Styles\n***************************************/\n@import \"footer/footer\";\n@import \"footer/copyright\";\n\n/**************************************\n    Footer Styles\n***************************************/\n\n.lan-select {\n\tbackground-color: transparent !important;\n\tborder-color: transparent !important;\n\toutline: 0;\n\tbox-shadow: none;\n\tfont-size: large;\n\tfont-weight: bold;\n\tcolor: gray;\n\tborder: none;\n\tcursor: pointer;\n\tpadding-right: 26px;\n}\n\n.lan-select:focus {\n\tborder-color: transparent !important;\n\toutline: 0;\n\tbox-shadow: none;\n\tfont-size: large;\n\tfont-weight: bold;\n\tcolor: gray;\n\tborder: none;\n}\n\n.lan-option {\n\tpadding: 0 10px;\n\tline-height: 40px;\n\tfont-size: large;\n\tcursor: pointer;\n\tborder-bottom: 1px solid #eaeaea;\n\tfont-weight: bold;\n\tcolor: gray;\n\tborder: none;\n}\n\n.has-search .form-control {\n\tpadding-left: 4.375rem;\n}\n.has-search.form-group {\n\tmargin-bottom: 0%;\n}\n\n.has-search .form-control-feedback {\n\tposition: absolute;\n\tz-index: 2;\n\tdisplay: block;\n\twidth: 2.375rem;\n\theight: 2.375rem;\n\tline-height: 2.375rem;\n\ttext-align: center;\n\tpointer-events: none;\n\tcolor: #aaa;\n\tpadding-left: 16px;\n}\n.nav-space {\n\tmargin-right: 100px;\n\tmargin-left: 100px;\n}\n\n.edu-btn-outline {\n\tbackground-color: transparent !important;\n\tborder: 1px solid #525fe1 !important;\n\tcolor: #525fe1 !important;\n\tpadding: 10px 20px;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\ttransition: all 0.3s ease-in-out;\n}\n.edu-btn-outline:hover {\n\tbackground-color: black !important;\n\tcolor: #fff !important;\n}\n.bg-color-light-blue {\n\tbackground-color: #f4f9ff !important;\n}\n\n.input-box > label {\n\tcolor: black;\n}\n.login-form label {\n\tcolor: black;\n}\n\n.otp-submit button {\n\tbackground-color: #525fe1 !important;\n\tborder: 1px solid #525fe1 !important;\n\tcolor: #fff !important;\n\tpadding: 20px;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\ttransition: all 0.3s ease-in-out;\n}\n.otp-submit button:hover {\n\tbackground-color: black !important;\n\tcolor: #fff !important;\n}\n// disable button\n.otp-submit-disabled button {\n\tbackground-color: #e8e8e8 !important;\n\tborder: none !important;\n\tcolor: gray !important;\n\tpadding: 20px;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\ttransition: all 0.3s ease-in-out;\n}\n.otp-submit-disabled button:hover {\n\tbackground-color: #e8e8e8 !important;\n\tborder: none !important;\n\tcolor: gray !important;\n}\n.modal-header button {\n\tmargin-top: 10px !important;\n}\n.otp input {\n\tborder-radius: 0px !important;\n\tborder-right: 0px !important;\n}\n.otp input:first-child {\n\tborder-bottom-left-radius: 10px !important;\n\tborder-top-left-radius: 10px !important;\n}\n.otp input:last-child {\n\tborder-bottom-right-radius: 10px !important;\n\tborder-top-right-radius: 10px !important;\n\tborder-right: 2px solid lightgray !important;\n}\n\n.otp input:focus {\n\tborder: 2px solid #d2d3d8 !important;\n}\n\n.modal-header {\n\talign-items: flex-start !important;\n}\n.modal-header button {\n\tmargin-top: 10px !important;\n}\n.accordion-header button {\n\tfont-size: 14px !important;\n\tfont-weight: 700 !important;\n}\n.result > div {\n\tborder-bottom: 1px solid lightgray;\n}\n.result > div:last-child {\n\tborder-bottom: none;\n}\n.accordion-button {\n\tpadding: 20px;\n}\n.accordion-for-subjects-btn {\n\ttext-transform: capitalize;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\twidth: 100%;\n\tpadding: 14px 16px 14px 16px;\n\tborder: none;\n\tbackground: none;\n\tcolor: #333;\n\ttext-align: left;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.accordion-for-subjects-btn-select {\n\tbackground-color: #f4f9ff;\n\tcolor: #525fe1;\n\tborder-left: 2px solid #525fe1;\n}\n\n.accordion-for-subjects-btn::last-child:focus {\n\tborder-bottom-left-radius: 5px !important;\n\tborder-bottom-right-radius: 5px !important;\n}\n\n.scene {\n\tdisplay: inline-block;\n\twidth: 200px;\n\theight: 260px;\n\t/*   border: 1px solid #CCC; */\n\tmargin: 40px 10px;\n\tperspective: 600px;\n}\n\n.card {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\t// border-radius: 5px;\n\tcursor: pointer;\n\ttransform-style: preserve-3d;\n\ttransform-origin: center right;\n\ttransition: transform 0.5s;\n}\n\n.card.is-flipped {\n\ttransform: translateX(-100%) rotateY(-180deg);\n}\n\n.card__face {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tline-height: 260px;\n\tcolor: white;\n\ttext-align: center;\n\tfont-weight: bold;\n\tfont-size: 40px;\n\tbackface-visibility: hidden;\n}\n\n.card__face--front {\n\tbackground: #525fe1;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\t// margin: 0px 10px;\n}\n\n.card__face--back {\n\tbackground: #525fe1;\n\ttransform: rotateY(180deg);\n\tborder-radius: 5px;\n\tpadding: 10px;\n\t// margin: 0px 10px;\n}\n.short_description p {\n\tcolor: white !important;\n}\n\n.questions li {\n\tfont-size: 20px;\n\tcolor: black;\n\tfont-weight: bolder;\n}\n\n.results-wrapper {\n\tmargin: 1rem 1rem 1rem 0;\n\tpadding: 0.5rem;\n}\n\n.result-span {\n\ttext-align: left;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\tdisplay: block;\n\tpadding: 0.5rem 0.5rem;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.search .wrapper:first-child svg {\n\tborder: 4px solid blue !important;\n}\n\n.search .wrapper:first-child input {\n\tborder: 4px solid red !important;\n}\n\n.search .wrapper:first-child {\n\tborder: 4px solid orange;\n}\n\nul.course-ls li:first-child {\n\tlist-style-type: none;\n}\n\n.un-selectable {\n\t-webkit-user-select: none;\n\t-webkit-touch-callout: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tcolor: #cc0000;\n}\n\nlabel.mcq-view-label-green input[type=\"checkbox\"]:checked ~ label.mcq-view-label-green::before,\ninput[type=\"radio\"]:checked ~ label.mcq-view-label-green::before {\n\tborder-color: #0e9c24 !important;\n\tbackground-color: #0e9c24 !important;\n}\n\nlabel.mcq-view-label-red input[type=\"checkbox\"]:checked ~ label.mcq-view-label-red::before,\ninput[type=\"radio\"]:checked ~ label.mcq-view-label-red::before {\n\tborder-color: #ff3e3e !important;\n\tbackground-color: #ff3e3e !important;\n}\n@keyframes App-logo-spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.flashcards .edu-slick-button .slick-dots {\n\tbottom: -40px;\n}\n.flashcards .scene {\n\theight: 55vh;\n\twidth: 100% !important;\n\tmargin: 0px;\n\tborder: none;\n}\n.flashcards .card__face--front {\n\tbackground: url(\"../images/flashcards.svg\"), linear-gradient(180deg, #5492ee 0%, #1e56e5 100%);\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tz-index: 5;\n}\n.flashcards .card__face--back {\n\tbackground: url(\"../images/flashcards.svg\"), linear-gradient(180deg, #e7f6ff 0%, #daffe0 100%);\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tz-index: 5;\n}\n.mobile-nav {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n@keyframes slideInFromBottom {\n\t0% {\n\t\ttransform: translateY(100%);\n\t\tdisplay: block;\n\t}\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n}\n\n@keyframes slideOutToBottom {\n\t0% {\n\t\ttransform: translateY(0);\n\t}\n\t100% {\n\t\ttransform: translateY(100%);\n\t\tdisplay: none;\n\t}\n}\n\n.myElement {\n\tanimation: 0.5s slideInFromBottom;\n}\n\n.myElement.slideOut {\n\tanimation: 0.5s slideOutToBottom forwards;\n}\n// apply to all elements all tag elements apply style to all elements\n.exam-details-accordion-body * {\n\tpadding: 0;\n\tmargin: 0;\n}\n.exam-details-accordion-header button {\n\talign-items: center !important;\n}\n.exam-details-accordion-header button > div {\n\twidth: 99% !important;\n}\n.exam-details-accordion-header button::after {\n\twidth: -1% !important;\n}\n.result {\n\tborder-bottom: 1px solid lightgray;\n\tpadding: 20px 0px;\n}\n.result:last-child {\n\tborder-bottom: none;\n}\n.subjectOutlineListModal {\n\talign-items: center !important;\n}\n.subjectOutlineListModal button {\n\tmargin-top: 0px !important;\n}\n\n.shadow {\n\tbox-shadow: 0px 10px 30px 0px #0000000f;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.scroll-off::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.scroll-off {\n\theight: 60vh;\n\toverflow: auto;\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n}\n.landing-inner-pages ul.slick-dots {\n\tbottom: 40px;\n}\n\n.landing-inner-pages ul.slick-dots li {\n\tbackground-color: white;\n\tborder: 1px solid #bbbbbb;\n\toutline: 1px solid #bbbbbb;\n\tborder-radius: 50%;\n\theight: 10px;\n\twidth: 10px;\n}\n.landing-inner-pages ul.slick-dots li > button::before {\n\tcolor: transparent !important;\n}\n.landing-inner-pages ul li.slick-active {\n\tbackground-color: #bbbbbb;\n\tborder: 1px solid #bbbbbb;\n\toutline: 1px solid #bbbbbb;\n\tborder-radius: 50%;\n\theight: 10px;\n\twidth: 10px;\n}\n.landing-inner-pages.brand ul.slick-dots {\n\tbottom: -40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\nimg.footer-banner {\n\theight: 470px;\n}\n\n.exam-filter button {\n\tborder: 2px solid #eeeeee !important;\n\tcolor: #6f6b80 !important;\n\tpadding: 10px 20px;\n\tborder-radius: 10px;\n\tfont-size: 14px;\n\tfont-weight: 600;\n}\n.exam-filter button:hover {\n\tborder: 2px solid #3c5da3 !important;\n\tcolor: #3c5da3 !important;\n}\nbutton.select {\n\tborder: 2px solid #3c5da3 !important;\n\tcolor: #3c5da3 !important;\n}\n\n.basic-single {\n\tborder: 2px solid #eeeeee !important;\n\tcolor: #6f6b80 !important;\n\tborder-radius: 10px;\n\tfont-size: 18px;\n\tcursor: pointer;\n}\n.basic-single:hover {\n\tborder: 2px solid #3c5da3 !important;\n\tcolor: #3c5da3 !important;\n\tcursor: pointer;\n}\n.basic-single .select__control {\n\tborder: none !important;\n\tbox-shadow: none !important;\n\tbackground-color: transparent !important;\n\tpadding: 3px 0px;\n\tcursor: pointer;\n}\n\n.modal-90w {\n\tmin-width: 90vw !important;\n\tmin-height: 90vh !important;\n}\n.modal-60w {\n\tmin-width: 40vw !important;\n\tmin-height: 80vh !important;\n}\n.modal-90w .modal-title {\n\tfont-size: 20px !important;\n}\n.mp-0 * {\n\tmargin: 0px !important;\n\tpadding: 0px !important;\n}\n\n.zoom-img {\n\ttransition: transform 0.2s; /* Animation */\n}\n\n.go-to-course:hover {\n\tbackground-color: #3c5da3 !important;\n\tcolor: #fff !important;\n}\n\n// .zoom-img:hover {\n// \twidth: 20%;\n// \theight: 20%;\n// \tborder: 1px solid lightgray;\n// \tborder-radius: 5px;\n// \tmargin-bottom: 20px;\n// \ttransform: scale(1.5);\n// }\n\n.modal-custom .modal-body::-webkit-scrollbar {\n\tdisplay: none;\n}\n.modal-custom::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.modal-custom {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n.modal-custom .modal-content {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: transparent;\n}\n.modal-custom .modal-body {\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: transparent;\n}\n.modal-custom .btn-close {\n\tbackground-color: #ffffff;\n\tmargin: 30px;\n\tpadding: 15px;\n\tborder-radius: 50%;\n}\n\n.modal-custom .modal-header {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tborder-bottom: none;\n}\n\n.video-area-course ul.slick-dots {\n\tbottom: 10px;\n}\n.video-area-course-enroll-modal .modal-header {\n\tjustify-content: end !important;\n}\n.video-area-course-enroll-modal .modal-header button.btn-close {\n\tmargin: 5px !important;\n\tpadding: 5px !important;\n}\n.video-area-course-enroll-modal .modal-body {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n::-webkit-input-placeholder {\n\tcolor: rgb(163, 163, 163) !important;\n}\n:-moz-placeholder {\n\t/* Firefox 18- */\n\tcolor: rgb(163, 163, 163) !important;\n}\n::-moz-placeholder {\n\t/* Firefox 19+ */\n\tcolor: rgb(163, 163, 163) !important;\n}\n:-ms-input-placeholder {\n\tcolor: rgb(163, 163, 163) !important;\n}\n::placeholder {\n\tcolor: rgb(163, 163, 163) !important;\n}\n\ninput {\n\tcolor: black !important;\n}\n// all input select text text color red\n\nselect {\n\tcolor: black !important;\n}\n\n.footer-link.link-hover {\n\tcolor: white !important;\n}\n\n.certificate-modal .modal-content {\n\theight: 90vh;\n\tz-index: 9999;\n}\n\n.video-thumbnail3 {\n\tmargin: 5% auto;\n\twidth: 300px;\n\theight: 300px;\n\t// border: 4px solid #3c5da3;\n\tborder-radius: 10px;\n}\n.video-thumbnail2 {\n\tmargin: 5% auto;\n\twidth: 300px;\n\theight: 300px;\n\t// border: 4px solid #3c5da3;\n\tborder-radius: 10px;\n}\n.video-thumbnail {\n\tmargin: 5% auto;\n\twidth: 300px;\n\theight: 300px;\n\t// border: 4px solid #3c5da3;\n\tborder-radius: 10px;\n}\n.play-btn {\n\tbackground: #fff;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tline-height: 108px;\n\tanimation: animate 2s linear infinite;\n\tcursor: pointer;\n\twidth: 100px;\n\theight: 100px;\n\tposition: relative;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n}\n.play-btn i {\n\tcolor: #3c5da3;\n\tfont-size: 102px;\n}\n.play-btn2 {\n\tbackground: #fff;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tline-height: 108px;\n\tanimation: animate 2s linear infinite;\n\tcursor: pointer;\n\twidth: 80px;\n\theight: 80px;\n\tposition: relative;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n}\n.play-btn2 i {\n\tcolor: #3c5da3;\n\t// font-size: 102px;\n}\n@keyframes animate {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 rgba(7, 85, 255, 0.7);\n\t}\n\t40% {\n\t\tbox-shadow: 0 0 0 50px rgba(255, 193, 7, 0);\n\t}\n\t80% {\n\t\tbox-shadow: 0 0 0 50px rgba(255, 193, 7, 0);\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 rgba(255, 193, 7, 0);\n\t}\n}\n.gap2 {\n\tpadding: 80px, 100px, 80px, 100px !important;\n\tmargin: 80px, 100px, 80px, 100px !important;\n}\n.about-left-section {\n\tpadding: 0px 80px !important;\n\tmargin: 0px !important;\n}\n.email-input {\n\ttext-indent: 30px;\n\t&::placeholder {\n\t\tpadding-left: 10px !important;\n\t\tpadding-right: 10px !important;\n\t\t/* Chrome, Firefox, Opera, Safari 10.1+ */\n\t\tcolor: gray;\n\t\topacity: 1; /* Firefox */\n\t}\n\n\t&:-ms-input-placeholder {\n\t\t/* Internet Explorer 10-11 */\n\t\tcolor: gray;\n\t\tpadding-left: 10px !important;\n\t\tpadding-right: 10px !important;\n\t}\n\n\t&::-ms-input-placeholder {\n\t\t/* Microsoft Edge */\n\t\tcolor: gray;\n\t\tpadding-left: 30px !important;\n\t\tpadding-right: 30px !important;\n\t}\n}\n\n.fs-5 {\n\tfont-size: 17px !important;\n}\n\n.header-event span {\n\tfont-size: 17px;\n\tmargin-left: 2px;\n\tmargin-right: 2px;\n}\n.black {\n\tcolor: black;\n}\n.search-event {\n\twidth: 25%;\n}\n.LandingDemoInnerPages > .slick-list {\n\toverflow: visible;\n}\n\n.title {\n\tfont-family: \"Onest\" !important;\n\tfont-size: 18;\n}\n\n.title {\n\tfont-family: \"Onest\" !important;\n\tfont-size: 18;\n}\n\n.title {\n\tfont-family: \"Onest\" !important;\n\tfont-size: 18;\n}\n\n.title {\n\tfont-family: \"Onest\" !important;\n\tfont-size: 18;\n}\n\n.title {\n\tfont-family: \"Onest\" !important;\n\tfont-size: 18;\n}\n\n.gallery-img {\n\tmargin: 20px 0px;\n\tbackground-color: \"#F5F5F5\";\n\tpadding: \"10px\";\n\tborder-radius: \"15px\";\n}\n.mobile-menu {\n\theight: 100vh !important;\n}\n.global * {\n\tfont-family: \"Onest\" !important;\n\tcolor: white !important;\n\tmargin: 0;\n\tpadding: 0;\n}\n.global2 * {\n\tfont-family: \"Onest\" !important;\n\tcolor: black !important;\n\tmargin: 0;\n\tpadding: 0;\n}\n.active2 {\n\tbackground-color: #eeeeee !important;\n}\n\n.event-img:hover {\n\topacity: 0.8;\n\tfilter: blur(1px);\n\tcursor: pointer;\n}\n.video-thumbnail4 {\n\tposition: \"absolute\";\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n}\n.width-30 {\n\twidth: 30% !important;\n}\n\n@media (min-width: 2560px) {\n\t.video-thumbnail {\n\t\ttop: 40% !important;\n\t\tleft: 10% !important;\n\t\tposition: absolute;\n\t}\n}\n\n@media (max-width: 2560px) {\n\t.lg-none {\n\t\tdisplay: none !important;\n\t}\n\t.padding-container2 {\n\t\tpadding: 80px 0px 80px 0px !important;\n\t}\n\t.padding-container {\n\t\tpadding: 80px 0px 80px 0px;\n\t}\n\t.sm-show {\n\t\tdisplay: none !important;\n\t}\n\t.lg-show {\n\t\tdisplay: block !important;\n\t}\n\ta.edu-btn,\n\tbutton.edu-btn {\n\t\tmargin-top: 0px !important;\n\t}\n\t.padding-50 {\n\t\tpadding-top: 50px !important;\n\t}\n\t.padding-150 {\n\t\tpadding-top: 150px !important;\n\t}\n\t.video-thumbnail {\n\t\ttop: 40% !important;\n\t\tright: -54% !important;\n\t\tposition: absolute;\n\t}\n\t.video-thumbnail3 {\n\t\ttop: 40% !important;\n\t\tleft: 20% !important;\n\t\tposition: fixed;\n\t}\n\n\t.download {\n\t\tposition: absolute;\n\t\tbottom: 0%;\n\t\tright: 0%;\n\t}\n\t.sm-flex {\n\t\tdisplay: flex !important;\n\t\talign-items: center !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: center !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: start !important;\n\t}\n}\n@media (max-width: 1920px) {\n\t.lg-none {\n\t\tdisplay: none !important;\n\t}\n\t.Exploreallnews {\n\t\tdisplay: none !important;\n\t}\n\t.course-img {\n\t\twidth: 5% !important;\n\t}\n\t.recorded-md {\n\t\tdisplay: none;\n\t}\n\t.video-thumbnail {\n\t\ttop: 41% !important;\n\t\tright: -1% !important;\n\t\tposition: absolute;\n\t}\n\t.video-thumbnail3 {\n\t\ttop: 50% !important;\n\t\tleft: 20% !important;\n\t\tposition: absolute;\n\t}\n\n\t.h-md {\n\t\theight: 409px;\n\t}\n\t.w-lg-25 {\n\t\twidth: 25% !important;\n\t}\n\t.sm-flex {\n\t\tdisplay: flex !important;\n\t\talign-items: center !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: center !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: start !important;\n\t}\n}\n@media (max-width: 1440px) {\n\t.lg-none {\n\t\tdisplay: none !important;\n\t}\n\t.Exploreallnews {\n\t\tdisplay: none !important;\n\t}\n\t.course-img {\n\t\twidth: 5% !important;\n\t}\n\t.h-md {\n\t\theight: 409px;\n\t}\n\t.w-lg-25 {\n\t\twidth: 25% !important;\n\t}\n\t.video-thumbnail {\n\t\ttop: 41% !important;\n\t\tright: -1% !important;\n\t\tposition: absolute;\n\t}\n\n\t.sm-flex {\n\t\tdisplay: flex !important;\n\t\talign-items: center !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: center !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: start !important;\n\t}\n}\n@media (max-width: 1024px) {\n\t.lg-none {\n\t\tdisplay: none !important;\n\t}\n\t.padding-50 {\n\t\tpadding-top: 20px !important;\n\t}\n\t.padding-150 {\n\t\tpadding-top: 150px !important;\n\t}\n\t.Exploreallnews {\n\t\tdisplay: none !important;\n\t}\n\t.technology-flex {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\t.technology-flex div {\n\t\twidth: 250px;\n\t\theight: 250px;\n\t}\n\t.recorded-lg {\n\t\theight: 130px !important;\n\t}\n\t.recorded-md {\n\t\tdisplay: none;\n\t}\n\t.course-img {\n\t\twidth: 8% !important;\n\t}\n\timg.footer-banner {\n\t\theight: 300px;\n\t}\n\t.video-thumbnail {\n\t\ttop: 30% !important;\n\t\tright: 0% !important;\n\t\tposition: absolute;\n\t}\n\n\t.h-md {\n\t\theight: auto;\n\t}\n\t.w-lg-25 {\n\t\twidth: 25% !important;\n\t}\n\t.h-full {\n\t\theight: 500px !important;\n\t}\n\t.lg-show {\n\t\tdisplay: none !important;\n\t}\n\t.sm-show {\n\t\tdisplay: block !important;\n\t}\n\t.sm-flex {\n\t\tdisplay: flex !important;\n\t\talign-items: center !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: center !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: start !important;\n\t}\n}\n@media (max-width: 768px) {\n\t.padding-50 {\n\t\tpadding-top: 40px !important;\n\t}\n\t.padding-150 {\n\t\tpadding-top: 150px !important;\n\t}\n\t.Exploreallnews {\n\t\tdisplay: none !important;\n\t}\n\t.recorded-lg {\n\t\tdisplay: none;\n\t}\n\t.recorded-md {\n\t\tdisplay: block;\n\t}\n\t.course-img {\n\t\twidth: 8% !important;\n\t}\n\timg.footer-banner {\n\t\theight: 250px;\n\t}\n\t.landing-inner-pages ul.slick-dots {\n\t\tbottom: 10px;\n\t}\n\t.landing-inner-pages.brand ul.slick-dots {\n\t\tbottom: -40px;\n\t}\n\t.landing-inner-pages ul.slick-dots li {\n\t\tbackground-color: #cecece;\n\t\tborder: 5px solid transparent;\n\t\toutline: 5px solid transparent;\n\t\tborder-radius: 50%;\n\t\theight: 10px;\n\t\twidth: 10px;\n\t}\n\t.landing-inner-pages ul li.slick-active {\n\t\tbackground-color: #cecece;\n\t\tborder: 5px solid white;\n\t\toutline: 5px solid #cecece;\n\t\tborder-radius: 50%;\n\t\theight: 6px;\n\t\twidth: 6px;\n\t}\n\t.video-thumbnail {\n\t\ttop: 69% !important;\n\t\tright: -3% !important;\n\t\tposition: absolute;\n\t}\n\t.video-thumbnail3 {\n\t\ttop: 50% !important;\n\t\tleft: -50% !important;\n\t\tposition: absolute;\n\t}\n\t.w-md-25 {\n\t\twidth: 50% !important;\n\t}\n\t.email-input {\n\t\ttext-indent: 10px;\n\t\t&::placeholder {\n\t\t\tpadding-left: 5px !important;\n\t\t\tpadding-right: 5px !important;\n\t\t\t/* Chrome, Firefox, Opera, Safari 10.1+ */\n\t\t\tcolor: gray;\n\t\t\topacity: 1; /* Firefox */\n\t\t}\n\n\t\t&:-ms-input-placeholder {\n\t\t\t/* Internet Explorer 10-11 */\n\t\t\tcolor: gray;\n\t\t\tpadding-left: 5px !important;\n\t\t\tpadding-right: 5px !important;\n\t\t}\n\n\t\t&::-ms-input-placeholder {\n\t\t\t/* Microsoft Edge */\n\t\t\tcolor: gray;\n\t\t\tpadding-left: 5px !important;\n\t\t\tpadding-right: 5px !important;\n\t\t}\n\t}\n\t.section-title .pre-title {\n\t\tpadding-top: 80px !important;\n\t}\n\t.text-center {\n\t\ttext-align: center;\n\t}\n\t.pt-20 {\n\t\tmargin-top: 20px;\n\t\ttext-align: center;\n\t}\n\t.sm-flex {\n\t\tdisplay: flex !important;\n\t\talign-items: center !important;\n\t}\n\t.d-sm-block {\n\t\tdisplay: flex !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: center !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: center !important;\n\t}\n\t.hight-40 {\n\t\theight: auto !important;\n\t}\n\t.width-30 {\n\t\twidth: 90% !important;\n\t}\n}\n\n@media (max-width: 430px) {\n\t.mt_sm--10 {\n\t\tmargin-top: 25px !important;\n\t}\n\t.text-center-sm {\n\t\ttext-align: left !important;\n\t}\n\t.banner-style-4 .banner-image .learner-badge {\n\t\twidth: 90px;\n\t\theight: 90px;\n\t\tmargin-left: 40px;\n\t}\n\t.banner-style-4 .banner-image .learner-badge .badge-inner span.viewer {\n\t\tfont-size: 20px;\n\t\tmargin-bottom: 0px;\n\t\tpadding-bottom: 0px;\n\t\tline-height: 20px;\n\t}\n\t.banner-style-4 .banner-image .learner-badge .badge-inner h6 {\n\t\tfont-size: 10px;\n\t\tmargin-bottom: 0px;\n\t\tpadding-bottom: 0px;\n\t}\n\t.lg-none {\n\t\tdisplay: block !important;\n\t}\n\t.sm-none {\n\t\tdisplay: none !important;\n\t}\n\t.block {\n\t\tdisplay: none !important;\n\t}\n\t.padding-container2 {\n\t\tpadding: 0px 0px 0px 0px !important;\n\t}\n\t.text-center {\n\t\ttext-align: center;\n\t}\n\t.pt-20 {\n\t\tmargin-top: 20px;\n\t}\n\t.padding-container {\n\t\tpadding: 40px 0px 40px 0px !important;\n\t}\n\t.lg-show {\n\t\tdisplay: none !important;\n\t}\n\t.sm-show {\n\t\tdisplay: block !important;\n\t}\n\t.feature-title {\n\t\tfont-size: 14px !important;\n\t}\n\t.feature-description {\n\t\tfont-size: 14px !important;\n\t\tline-height: 10px;\n\t}\n\t.about-style-1 .inner .description p * {\n\t\tfont-size: 12px !important;\n\t}\n\t.section-title .title {\n\t\tfont-size: 20px !important;\n\t}\n\t.section-title .pre-title {\n\t\tfont-size: 12px !important;\n\t}\n\t.edu-section-gap2 {\n\t\tpadding: 0px !important;\n\t}\n\t.banner-style-4 .home-four-banner-wrapper {\n\t\tpadding: 0px !important;\n\t}\n\n\tbutton.small {\n\t\tfont-size: 12px !important;\n\t\tdisplay: inline !important;\n\t\twidth: max-content;\n\t}\n\t.about-left-section {\n\t\tpadding: 40px !important;\n\t}\n\ta.edu-btn,\n\tbutton.edu-btn {\n\t\tmargin-top: 20px !important;\n\t}\n\t.newsletter-form-style-1 .input-box input {\n\t\twidth: 100% !important;\n\t\tmin-width: 100% !important;\n\t}\n\t.padding-50 {\n\t\tpadding-top: 0px !important;\n\t}\n\t.padding-150 {\n\t\tpadding-top: 100px !important;\n\t}\n\t.banner-style-4 .inner .content .pre-title {\n\t\tfont-size: 8px !important;\n\t}\n\t.banner-style-4 .content .title {\n\t\tfont-size: 28px !important;\n\t}\n\t.w-sm-75 {\n\t\twidth: 75% !important;\n\t}\n\n\t.Exploreallnews {\n\t\tdisplay: block !important;\n\t\tbackground-color: #3c5da3 !important;\n\t\tcolor: white !important;\n\t\tpadding: 15px 30px;\n\t}\n\timg.footer-banner {\n\t\theight: 100px;\n\t}\n\t.brand .landing-inner-pages ul.slick-dots {\n\t\tbottom: -50px;\n\t}\n\t.search-event {\n\t\twidth: 100% !important;\n\t}\n\t.video-thumbnail {\n\t\ttop: 70% !important;\n\t\tright: -10% !important;\n\t\tposition: absolute;\n\t}\n\t.video-thumbnail3 {\n\t\ttop: 50% !important;\n\t\tleft: -50% !important;\n\t\tposition: absolute;\n\t}\n\t.text-sm-end {\n\t\ttext-align: left !important;\n\t}\n\t.edu-instructor-1 .edu-instructor-info .title {\n\t\tfont-size: 14px !important;\n\t}\n\t.edu-instructor-1 .edu-instructor-info .desc {\n\t\tfont-size: 10px !important;\n\t}\n\t.media-sm {\n\t\tfont-size: 8px;\n\t}\n\t.titles {\n\t\tfont-size: 8px;\n\t\tline-height: 0px;\n\t}\n\t.contain-card {\n\t\twidth: 100% !important;\n\t}\n\t.sm-w-100 {\n\t\twidth: 100% !important;\n\t}\n\t.sm-flex {\n\t\tdisplay: block !important;\n\t}\n\t.hight-70vh {\n\t\theight: min-content !important;\n\t}\n\n\t.d-sm-block {\n\t\tdisplay: block !important;\n\t}\n\t.text-start-sm {\n\t\ttext-align: center !important;\n\t}\n\t.hight-40 {\n\t\theight: 40vh !important;\n\t}\n\t.width-30 {\n\t\twidth: 90% !important;\n\t}\n}\n","/*-- Variables --*/\n:root {\n\t//Themes colors\n\t--color-primary: rgb(60, 93, 173);\n\t--color-secondary: #f86f03;\n\t--color-secondary-alt: #fff6f4;\n\t--color-tertiary: #ffa41b;\n\t--color-tertiary-2: #7152e9;\n\t--color-dark: #231f40;\n\t--color-body: #6f6b80;\n\t--color-heading: #231f40;\n\t--color-white: #ffffff;\n\t--color-shape: #eeeeee;\n\t--color-shade: #f5f5f5;\n\t--color-border: #eeeeee;\n\n\t// Typo Color\n\t--color-black: #000000;\n\t--color-blackest: #0f0f11;\n\n\t// Extra Color\n\t--color-extra01: #666666;\n\t--color-extra02: #606770;\n\t--color-extra03: #fbfbfd;\n\t--color-extra04: #1a1a1a;\n\t--color-extra05: #242424;\n\t--color-extra06: #dbf1c0;\n\t--color-extra07: #c6ece8;\n\t--color-extra08: #c3ecce;\n\n\t// Notify Colors\n\t--color-success: #3eb75e;\n\t--color-danger: #ff0003;\n\t--color-warning: #ff8f3c;\n\t--color-info: #1ba2db;\n\n\t//Social icon colors\n\t--color-facebook: #3b5997;\n\t--color-twitter: #1ba1f2;\n\t--color-youtube: #ed4141;\n\t--color-linkedin: #0077b5;\n\t--color-pinterest: #e60022;\n\t--color-instagram: #c231a1;\n\t--color-vimeo: #00adef;\n\t--color-twitch: #6441a3;\n\t--color-discord: #7289da;\n\n\t//Border-radius\n\t--border-width: 2px;\n\t--radius-small: 5px;\n\t--radius: 10px;\n\t--radius-big: 16px;\n\n\t//Font weight\n\t--p-light: 300;\n\t--p-regular: 400;\n\t--p-medium: 500;\n\t--p-semi-bold: 600;\n\t--p-bold: 700;\n\t--p-extra-bold: 800;\n\t--p-black: 900;\n\n\t//Shadows\n\t--shadow-primary: 0px 8px 30px rgba(0, 0, 0, 0.04);\n\t--shadow-light: 1px 1px 6px rgba(0, 0, 0, 0.25);\n\t--shadow-lighter: 4px 4px 20px 20px rgba(0, 0, 0, 0.01);\n\n\t//transition easing\n\t--transition: 0.3s;\n\t--transition-transform: transform 0.65s cubic-bezier(0.23, 1, 0.32, 1);\n\n\t//Font Family\n\t// --font-primary: \"Urbanist\", sans-serif;\n\t// --font-secondary: \"Urbanist\", sans-serif;\n\t// --font-awesome: \"Font Awesome 5 Pro\";\n\n\t//Fonts Size\n\t--font-size-b1: 18px;\n\t--font-size-b2: 16px;\n\t--font-size-b3: 14px;\n\t--font-size-b4: 12px;\n\n\t//Line Height\n\t--line-height-b1: 1.67; //28px\n\t--line-height-b2: 1.63; //26px\n\t--line-height-b3: 1.6; //22px\n\t--line-height-b4: 1.3; //16px\n\n\t// Heading Font\n\t--h1: 72px; //90px 900 1.25\n\t--h2: 68px; //84px 900 1.24\n\t--h3: 40px; // 56px 900 1.4\n\t--h4: 32px; //44px 700  1.38\n\t--h5: 24px; //36px 1.5\n\t--h6: 20px; //20px 1.25\n\n\t--h1-lineHeight: 1.25;\n\t--h2-lineHeight: 1.24;\n\t--h3-lineHeight: 1.4;\n\t--h4-lineHeight: 1.38;\n\t--h5-lineHeight: 1.5;\n\t--h6-lineHeight: 1.6;\n}\n\n// Layouts Variation\n$custom-lg-device-seven: \"only screen and (min-width: 1200px)\";\n$custom-lg-device-three: \"only screen and (min-width: 1750px)\";\n$custom-lg-device-four: \"only screen and (min-width: 1800px)\";\n$custom-lg-device-five: \"only screen and (min-width: 1900px)\";\n$custom-lg-device-two: \"only screen and (min-width: 1401px) and (max-width: 1750px)\";\n$custom-lg-device-six: \"only screen and (min-width: 1401px) and (max-width: 1650px)\";\n$custom-lg-device-eight: \"only screen and (min-width: 1200px) and (max-width: 1450px)\";\n$extra-device: \"only screen and (min-width: 1600px) and (max-width: 1919px)\";\n$laptop-device: \"only screen and (min-width: 1200px) and (max-width: 1599px)\";\n$custom-laptop-device: \"only screen and (min-width: 1200px) and (max-width: 1400px)\";\n$lg-layout: \"only screen and (min-width: 992px) and (max-width: 1199px)\";\n$md-layout: \"only screen and (min-width: 768px) and (max-width: 991px)\";\n$custom-lg-device: \"only screen and (max-width: 1650px)\";\n$smlg-device: \"only screen and (max-width: 1199px)\";\n$small-tablet: \"only screen and (max-width: 991px)\";\n$sm-layout: \"only screen and (max-width: 767px)\";\n$large-mobile: \"only screen and (max-width: 575px)\";\n$small-mobile: \"only screen and (max-width: 479px)\";\n","/**\n * Reset Styels\n */\n\n* {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nnav,\nsection,\nsummary {\n\tdisplay: block;\n}\n\naudio,\ncanvas,\nvideo {\n\tdisplay: inline-block;\n}\n\naudio:not([controls]) {\n\tdisplay: none;\n\theight: 0;\n}\n\n[hidden] {\n\tdisplay: none;\n}\n\na {\n\tcolor: var(--color-heading);\n\ttext-decoration: none;\n\toutline: none;\n}\n\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n\toutline: none;\n\tcolor: var(--color-primary);\n}\n\na:focus {\n\toutline: none;\n}\naddress {\n\tmargin: 0 0 24px;\n}\n\nabbr[title] {\n\tborder-bottom: 1px dotted;\n}\n\nb,\nstrong {\n\tfont-weight: bold;\n}\nmark {\n\tbackground: var(--color-primary);\n\tcolor: #ffffff;\n}\ncode,\nkbd,\npre,\nsamp {\n\tfont-size: var(--font-size-b3);\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none;\n\tcolor: var(--color-primary);\n}\nkbd,\nins {\n\tcolor: #ffffff;\n}\n\npre,\npre.wp-block-code {\n\t// font-family: \"Courier 10 Pitch\", Courier, monospace !important;\n\tfont-size: 15px !important;\n\tmargin: 40px 0 !important;\n\toverflow: auto;\n\tpadding: 20px !important;\n\twhite-space: pre !important;\n\twhite-space: pre-wrap !important;\n\tword-wrap: break-word !important;\n\tcolor: var(--color-body) !important;\n\tbackground: var(--color-light);\n\tborder-radius: 4px;\n}\n\nsmall {\n\tfont-size: smaller;\n}\n\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n\tvertical-align: baseline;\n}\nsup {\n\ttop: -0.5em;\n}\nsub {\n\tbottom: -0.25em;\n}\n\ndl {\n\tmargin-top: 0;\n\tmargin-bottom: 10px;\n}\n\ndd {\n\tmargin: 0 15px 15px;\n}\ndt {\n\tfont-weight: bold;\n\tcolor: var(--color-heading);\n}\n\nmenu,\nol,\nul {\n\tmargin: 16px 0;\n\tpadding: 0 0 0 40px;\n}\n\nnav ul,\nnav ol {\n\tlist-style: none;\n\tlist-style-image: none;\n}\nli > ul,\nli > ol {\n\tmargin: 0;\n}\n\nol {\n\tul {\n\t\tmargin-bottom: 0;\n\t}\n}\n\nimg {\n\t-ms-interpolation-mode: bicubic;\n\tborder: 0;\n\tvertical-align: middle;\n\tmax-width: 100%;\n\theight: auto;\n}\n\nsvg:not(:root) {\n\toverflow: hidden;\n}\nfigure {\n\tmargin: 0;\n}\nform {\n\tmargin: 0;\n}\nfieldset {\n\tborder: 1px solid var(--color-border);\n\tmargin: 0 2px;\n\tmin-width: inherit;\n\tpadding: 0.35em 0.625em 0.75em;\n}\nlegend {\n\tborder: 0;\n\tpadding: 0;\n\twhite-space: normal;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n\tfont-size: 100%;\n\tmargin: 0;\n\tmax-width: 100%;\n\tvertical-align: baseline;\n}\n\nbutton,\ninput {\n\tline-height: normal;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n\t-webkit-appearance: button;\n\t-moz-appearance: button;\n\tappearance: button;\n\tcursor: pointer;\n}\n\nbutton[disabled],\ninput[disabled] {\n\tcursor: default;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n\tpadding: 0;\n}\n\ninput[type=\"search\"] {\n\t-webkit-appearance: textfield;\n\t-moz-appearance: textfield;\n\tappearance: textfield;\n\tappearance: textfield;\n\tpadding-right: 2px;\n\twidth: 270px;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration {\n\t-webkit-appearance: none;\n\tappearance: none;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n\tborder: 0;\n\tpadding: 0;\n}\ntextarea {\n\toverflow: auto;\n\tvertical-align: top;\n}\ncaption,\nth,\ntd {\n\tfont-weight: normal;\n}\ntable thead th {\n\tfont-weight: 700;\n}\n\ntd,\n.wp-block-calendar tfoot td {\n\tborder: 1px solid var(--color-border);\n\tpadding: 7px 10px;\n}\ndel {\n\tcolor: #333;\n}\n\nins {\n\tbackground: rgba(56, 88, 246, 0.6);\n\ttext-decoration: none;\n\tpadding: 0 5px;\n}\nhr {\n\tbackground-size: 4px 4px;\n\tborder: 0;\n\theight: 1px;\n\tmargin: 0 0 24px;\n\topacity: 0.6;\n}\n\ntable a,\ntable a:link,\ntable a:visited {\n\ttext-decoration: underline;\n}\n\ndt {\n\tfont-weight: bold;\n\tmargin-bottom: 10px;\n}\n\ndd {\n\tmargin: 0 15px 15px;\n}\n\ncaption {\n\tcaption-side: top;\n}\n\nkbd {\n\tbackground: var(--heading-color);\n}\n\ndfn,\ncite,\nem {\n\tfont-style: italic;\n}\n\n/* BlockQuote  */\nblockquote,\nq {\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none;\n\tquotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n\tcontent: \"\";\n\tcontent: none;\n}\n\nblockquote {\n\tfont-size: var(--font-size-b1);\n\tfont-style: italic;\n\tfont-weight: var(--p-light);\n\tmargin: 24px 40px;\n}\n\nblockquote blockquote {\n\tmargin-right: 0;\n}\n\nblockquote cite,\nblockquote small {\n\tfont-size: var(--font-size-b3);\n\tfont-weight: normal;\n}\n\nblockquote strong,\nblockquote b {\n\tfont-weight: 700;\n}\n","/**\n * Typography\n */\n\n* {\n\tbox-sizing: border-box;\n}\n\nhtml {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 10px;\n}\n\nbody {\n\toverflow-x: hidden;\n\tfont-size: var(--font-size-b2);\n\tline-height: var(--line-height-b2);\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\t// font-family: var(--font-primary);\n\tcolor: var(--color-body);\n\tfont-weight: 500;\n\tbackground-color: var(--color-white);\n\tmargin: 0;\n\tpadding: 0;\n\t&.modal-open {\n\t\tpadding: 0 !important;\n\t}\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\naddress,\np,\npre,\nblockquote,\nmenu,\nol,\nul,\ntable,\nhr {\n\tmargin: 0;\n\tmargin-bottom: 20px;\n}\n\n.display-one {\n\tfont-size: 112px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n\tword-break: break-word;\n\t// font-family: var(--font-secondary);\n\tline-height: 1.4074;\n\tcolor: var(--color-heading);\n}\n\nh1,\n.h1 {\n\tfont-size: var(--h1);\n\tline-height: var(--h1-lineHeight);\n}\n\nh2,\n.h2 {\n\tfont-size: var(--h2);\n\tline-height: var(--h2-lineHeight);\n}\n\nh3,\n.h3 {\n\tfont-size: var(--h3);\n\tline-height: var(--h3-lineHeight);\n}\n\nh4,\n.h4 {\n\tfont-size: var(--h4);\n\tline-height: var(--h4-lineHeight);\n}\n\nh5,\n.h5 {\n\tfont-size: var(--h5);\n\tline-height: var(--h5-lineHeight);\n}\n\nh6,\n.h6 {\n\tfont-size: var(--h6);\n\tline-height: var(--h6-lineHeight);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n\ta {\n\t\tcolor: inherit;\n\t\ttransition: 0.5s;\n\t}\n}\na {\n\tcolor: var(--color-heading);\n\ttransition: 0.3s;\n}\n@media #{$md-layout} {\n\th1,\n\t.h1 {\n\t\tfont-size: 38px;\n\t}\n\th2,\n\t.h2 {\n\t\tfont-size: 32px;\n\t}\n\n\th3,\n\t.h3 {\n\t\tfont-size: 28px;\n\t}\n\n\th4,\n\t.h4 {\n\t\tfont-size: 24px;\n\t}\n}\n\n@media #{$sm-layout} {\n\th1,\n\t.h1 {\n\t\tfont-size: 34px;\n\t}\n\n\th2,\n\t.h2 {\n\t\tfont-size: 28px;\n\t}\n\n\th3,\n\t.h3 {\n\t\tfont-size: 24px;\n\t}\n\n\th4,\n\t.h4 {\n\t\tfont-size: 20px;\n\t}\n}\n\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3 {\n\tfont-weight: var(--p-extra-bold);\n}\n\nh4,\n.h4 {\n\tfont-weight: var(--p-bold);\n}\n\nh5,\n.h5 {\n\tfont-weight: var(--p-bold);\n}\n\nh6,\n.h6 {\n\tfont-weight: var(--p-bold);\n}\n\np {\n\tfont-size: var(--font-size-b2);\n\tline-height: var(--line-height-b2);\n\tfont-weight: 500;\n\tcolor: var(--color-body);\n\tmargin: 0 0 30px;\n\n\t@media #{$sm-layout} {\n\t\tmargin: 0 0 20px;\n\t\tfont-size: var(--font-size-b2);\n\t\tline-height: var(--line-height-b2);\n\t}\n\n\t&.has-large-font-size {\n\t\tline-height: 1.5;\n\t\tfont-size: 36px;\n\t}\n\n\t&.has-medium-font-size {\n\t\tfont-size: 24px;\n\t\tline-height: 36px;\n\t}\n\n\t&.has-small-font-size {\n\t\tfont-size: 13px;\n\t}\n\n\t&.has-very-light-gray-color {\n\t\tcolor: var(--color-white);\n\t}\n\n\t&.has-background {\n\t\tpadding: 20px 30px;\n\t}\n\n\t&.b1 {\n\t\tfont-size: var(--font-size-b1);\n\t\tline-height: var(--line-height-b1);\n\t}\n\n\t&.b2 {\n\t\tfont-size: var(--font-size-b2);\n\t\tline-height: var(--line-height-b2);\n\t}\n\n\t&.b3 {\n\t\tfont-size: var(--font-size-b3);\n\t\tline-height: var(--line-height-b3);\n\t}\n\n\t&.b4 {\n\t\tfont-size: var(--font-size-b4);\n\t\tline-height: var(--line-height-b4);\n\t}\n}\n\n.b1 {\n\tfont-size: var(--font-size-b1);\n\tline-height: var(--line-height-b1);\n}\n\n.b2 {\n\tfont-size: var(--font-size-b2);\n\tline-height: var(--line-height-b2);\n}\n\n.b3 {\n\tfont-size: var(--font-size-b3);\n\tline-height: var(--line-height-b3);\n}\n\n.b4 {\n\tfont-size: var(--font-size-b4);\n\tline-height: var(--line-height-b4);\n}\n\ntable {\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\tmargin: 0 0 40px;\n\twidth: 100%;\n}\n\ntable a,\ntable a:link,\ntable a:visited {\n\ttext-decoration: none;\n}\n\ncite,\n.wp-block-pullquote cite,\n.wp-block-pullquote.is-style-solid-color blockquote cite,\n.wp-block-quote cite {\n\tcolor: var(--color-heading);\n}\n\nvar {\n\t// font-family: \"Courier 10 Pitch\", Courier, monospace;\n}\n\n/*---------------------------\n\tList Style \n---------------------------*/\nul,\nol {\n\tpadding-left: 18px;\n}\n\nul {\n\tlist-style: square;\n\tmargin-bottom: 30px;\n\tpadding-left: 20px;\n\n\t&.liststyle {\n\t\t&.bullet {\n\t\t\tli {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 30px;\n\t\t\t\tcolor: var(--color-body);\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-left: 30px;\n\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tpadding-left: 19px;\n\t\t\t\t}\n\n\t\t\t\t&::before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\twidth: 6px;\n\t\t\t\t\theight: 6px;\n\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\tbackground: var(--color-body);\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t}\n\n\t\t\t\t& + li {\n\t\t\t\t\tmargin-top: 8px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\tli {\n\t\tfont-size: var(--font-size-b2);\n\t\tline-height: var(--line-height-b2);\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t\tcolor: var(--color-body);\n\t\tfont-weight: 500;\n\t\ta {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-body);\n\t\t\t@extend %transition;\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\tul {\n\t\tmargin-bottom: 0;\n\t}\n}\n\nol {\n\tmargin-bottom: 30px;\n\tli {\n\t\tfont-size: var(--font-size-b2);\n\t\tline-height: var(--line-height-b2);\n\t\tcolor: var(--color-gray);\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t\tfont-weight: 400;\n\t\ta {\n\t\t\tcolor: var(--heading-color);\n\t\t\t@extend %transition;\n\t\t\ttext-decoration: none;\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\tul {\n\t\tpadding-left: 30px;\n\t}\n}\n\nhr {\n\tdisplay: block;\n\theight: 0;\n\tmargin: 15px 0;\n\tborder-top: 1px solid var(--color-border);\n\tbackground: transparent;\n}\nkbd {\n\tbackground: var(--color-primary);\n}\n","/*=====================\nAll Extend Here\n=======================*/\n%color-primary {\n    color: var(--color-primary) !important;\n}\n%color-secondary {\n    color: var(--color-secondary) !important;\n}\n%color-tertiary {\n    color: var(--color-tertiary) !important;\n}\n%color-heading {\n    color: var(--color-heading) !important;\n}\n%color-body {\n    color: var(--color-body) !important;\n}\n%color-dark {\n    color: var(--color-dark) !important;\n}\n%color-border {\n    color: var(--color-border) !important;\n}\n%color-white {\n    color: var(--color-white) !important;\n}\n\n\n\n//===== BG Ncc Colors =====//\n\n%bg-color-primary {\n    background: var(--color-primary);\n}\n\n%bg-color-secondary {\n    background: var(--color-secondary)\n}\n\n%bg--color-tertiary {\n    background-color: var(--color-tertiary)\n}\n\n%bg-color-secondary {\n    background-color: var(--color-secondary) !important;\n}\n%bg-color-tertiary {\n    background-color: var(--color-tertiary) !important;\n}\n%bg-color-heading {\n    background-color: var(--color-heading) !important;\n}\n%bg-color-body {\n    background-color: var(--color-body) !important;\n}\n%bg-color-border {\n    background-color: var(--color-border) !important;\n}\n\n%bg-color-white {\n    background-color: var(--color-white) !important;\n}\n\n\n\n/* Radius */\n%radius-small {\n    border-radius: var(--radius-small);\n}\n\n%radius {\n    border-radius: var(--radius);\n}\n\n%radius-big {\n    border-radius: var(--radius-big);\n}\n\n/* Font Weight */\n\n%w-300 {\n    font-weight: 300 !important;\n}\n%w-400 {\n    font-weight: 400 !important;\n}\n%w-500 {\n    font-weight: 500 !important;\n}\n%w-600 {\n    font-weight: 600 !important;\n}\n%w-700 {\n    font-weight: 700 !important;\n}\n%w-800 {\n    font-weight: 800 !important;\n}\n%w-900 {\n    font-weight: 900 !important;\n}\n\n/* Shadows */\n\n%shadow-primary {\n    box-shadow: var(--shadow-primary);\n}\n%shadow-light {\n    box-shadow: var(--shadow-light);\n}\n%shadow-lighter {\n    box-shadow: var(--shadow-lighter);\n}\n\n// Others \n\n%box-shadow {\n    box-shadow: var(--shadow-primary);\n}\n\n/*=============== Style Css =============*/\n\n%liststyle {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n%transition {\n    transition: var(--transition);\n}\n\n%bgImagePosition {\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n}\n\n.bgImagePosition {\n    @extend %bgImagePosition;\n}","/*----------------------\n    Animation Css  \n-----------------------*/\n.post-scale {\n    overflow: hidden;\n    @extend %radius;\n    img {\n        transition: 0.5s;\n    }\n    &:hover {\n        img {\n            transform: scale(1.1);\n        }\n    }\n}\n\n@keyframes line1 {\n    0% {\n        opacity: 1;\n        bottom: 0\n    }\n    30% {\n        bottom: 30%\n    }\n    50% {\n        bottom: 50%\n    }\n    70% {\n        bottom: 70%\n    }\n    100% {\n        bottom: 100%;\n        opacity: 0.5;\n    }\n}\n\n\n@keyframes bounceSlide {\n    0%, 20%, 50%, 80%, 100% {\n      transform: translateY(0);\n    }\n    40% {\n      transform: translateY(-30px);\n    }\n    60% {\n      transform: translateY(-15px);\n    }\n}\n\n.bounce-slide {\n    animation-duration: 4s;\n    animation-fill-mode: both;\n    animation-iteration-count: infinite;\n    animation-name: bounceSlide;\n}\n\n@keyframes line5 {\n    0% {\n        opacity: 1;\n        bottom: 400px\n    }\n    50% {\n        bottom: 50%\n    }\n    100% {\n        bottom: 100%;\n        opacity: 0.5;\n    }\n}\n@keyframes line2 {\n    0% {\n        opacity: 1;\n        top: 0\n    }\n    30% {\n        bottom: 30%\n    }\n\n    50% {\n        bottom: 50%\n    }\n\n    70% {\n        bottom: 70%\n    }\n    \n    100% {\n        top: 100%;\n        opacity: 0.5;\n    }\n}\n@keyframes line3 {\n    0% {\n        opacity: 1;\n        top: 500px\n    }\n    50% {\n        top: 50%\n    }\n    100% {\n        top: 100%;\n        opacity: 0.5;\n    }\n}\n\n@keyframes line4 {\n    0% {\n        opacity: 1;\n        top: 300px;\n    }\n    50% {\n        top: 50%\n    }\n    100% {\n        top: 100%;\n        opacity: 0.5;\n    }\n}\n\n\n\n@keyframes customOne {\n    from {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(0.90);\n    }\n\n    to {\n        transform: scale(1);\n    }\n}\n\n@keyframes customTwo {\n    0% {\n        transform: (translate(0.0px, 0.0px));\n    }\n\n    50% {\n        transform: (translate(100.0px, 0.0px));\n    }\n\n    100% {\n        transform: (translate(50.0px, 50.0px));\n    }\n}\n\n.customOne {\n    animation: customOne 2s infinite;\n}\n\n\n\n\n/* ------------------------\n    Custom Animation 01 \n----------------------------*/\n\n@-webkit-keyframes headerSlideDown {\n    0% {\n        margin-top: -100px\n    }\n\n    to {\n        margin-top: 0\n    }\n}\n\n@keyframes headerSlideDown {\n    0% {\n        margin-top: -100px\n    }\n\n    to {\n        margin-top: 0\n    }\n}\n\n\n/*------------------------\n\tslidefadeinup\n--------------------------*/\n\n@-webkit-keyframes slideFadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 20%, 0);\n        transform: translate3d(0, 20%, 0);\n    }\n\n    to {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n@keyframes slideFadeInUp {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 20%, 0);\n        transform: translate3d(0, 20%, 0);\n    }\n\n    to {\n        opacity: 1;\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n.slideFadeInUp {\n    -webkit-animation-name: slideFadeInUp;\n    animation-name: slideFadeInUp;\n}\n\n/* -----------------------------------\n    Custom Animation For All Page\n---------------------------------------*/\n\n@-webkit-keyframes moveVertical {\n    to {\n        opacity: 1;\n        -webkit-transform: translateY(0)\n    }\n}\n\n@keyframes moveVertical {\n    to {\n        opacity: 1;\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n}\n\n\n\n\n\n\n/*--------------------------------\nScroll Down Button Animation  \n----------------------------------*/\n@keyframes scrollDown {\n    0% {\n        opacity: 0;\n    }\n\n    10% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n\n    100% {\n        transform: translateY(10px);\n        opacity: 0;\n    }\n}\n","/*==============================\n *  Utilities\n=================================*/\n\n@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');\n\n/*------------------------------------- \n\nfont-family: 'Urbanist', sans-serif;\n\n--------------------------------------*/\n\n\n.container,\n.container-fluid,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n    @media #{$sm-layout} {\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n}\n\niframe {\n    width: 100%;\n}\n\n.clearfix:before,\n.clearfix:after {\n    content: \" \";\n    display: table;\n}\n\n.clearfix:after {\n    clear: both;\n}\n\n.fix {\n    overflow: hidden;\n}\n\n.slick-initialized .slick-slide {\n    margin-bottom: 0;\n}\n\n\n.edu-line-separator {\n    position: relative;\n    &::after {\n        position: absolute;\n        content: \"\";\n        background: #EBE7E5;\n        width: 1170px;\n        height: 1px;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        @media #{$smlg-device} {\n            width: 100%;\n        }\n    }\n}\n\n/*===============================\n    Background Color \n=================================*/\n\n@include config-bg-colors('bg-color-',\n    'primary'var(--color-primary),\n    'secondary'var(--color-secondary),\n    'secondary-alt'var(--color-secondary-alt),\n    'tertiary'var(--color-tertiary),\n    'grey'#F0F2F5,\n    'white'#FFFFFF,\n    'black'#1A1A1A,\n    'grey' #E5E5E5,\n    'extra03'var(--color-extra03),\n    'lessdark'var(--color-lessdark));\n  \n\n.bg-color-2 {\n    backdrop-filter: saturate(180%) blur(8px);\n    background-color: var(--color-darker);\n    background-image: linear-gradient(180deg, var(--color-black), transparent);\n}\n\n/*===========================\n    Background Image \n=============================*/\n\n.bg-image {\n    @extend %bgImagePosition;\n}\n\n.bg-image_fixed {\n    background-attachment: fixed !important;\n}\n\n/* Height and width */\n.fullscreen {\n    min-height: 100vh;\n    width: 100%;\n}\n\n\n/*===================\nCustom Row\n======================*/\n.row--0 {\n    margin-left: -0px;\n    margin-right: -0px;\n\n    &>[class*=\"col\"] {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n}\n\n.row--5 {\n    margin-left: -5px;\n    margin-right: -5px;\n\n    &>[class*=\"col\"] {\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n}\n\n.row--10 {\n    margin-left: -10px;\n    margin-right: -10px;\n\n    &>[class*=\"col\"] {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n}\n\n.row--15 {\n    margin-left: -15px;\n    margin-right: -15px;\n\n    &>[class*=\"col\"] {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n}\n\n.row--20 {\n    margin-left: -20px;\n    margin-right: -20px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 20px;\n        padding-right: 20px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n.row--25 {\n    margin-left: -25px;\n    margin-right: -25px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 25px;\n        padding-right: 25px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n\n.row--30 {\n    margin-left: -30px;\n    margin-right: -30px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 30px;\n        padding-right: 30px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n\n.row--35 {\n    margin-left: -35px;\n    margin-right: -35px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 35px;\n        padding-right: 35px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n.row--40 {\n    margin-left: -40px;\n    margin-right: -40px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 40px;\n        padding-right: 40px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n\n.row--45 {\n    margin-left: -45px;\n    margin-right: -45px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 45px;\n        padding-right: 45px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n\n.row--50 {\n    margin-left: -50px;\n    margin-right: -50px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 50px;\n        padding-right: 50px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n.row--60 {\n    margin-left: -60px;\n    margin-right: -60px;\n\n    // Responsive\n    @media #{$laptop-device} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$lg-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$md-layout} {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    @media #{$sm-layout} {\n        margin-left: -15px !important;\n        margin-right: -15px !important;\n    }\n\n    &>[class*=\"col\"],\n    &>[class*=\"col-\"] {\n        padding-left: 60px;\n        padding-right: 60px;\n\n        // Responsive\n        @media #{$laptop-device} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$lg-layout} {\n            padding-left: 15px;\n            padding-right: 15px;\n        }\n\n        @media #{$md-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n\n        @media #{$sm-layout} {\n            padding-left: 15px !important;\n            padding-right: 15px !important;\n        }\n    }\n}\n\n\n/*===========================\n    Input Placeholder\n=============================*/\ninput:-moz-placeholder,\ntextarea:-moz-placeholder {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n}\n\ninput::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n}\n\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n}\n\ninput:-ms-input-placeholder,\ntextarea:-ms-input-placeholder {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n}\n\n/*=============================\n\tOverlay styles \n==============================*/\n\n[data-overlay],\n[data-black-overlay],\n[data-white-overlay] {\n    position: relative;\n}\n\n[data-overlay]>div,\n[data-overlay]>*,\n[data-black-overlay]>div,\n[data-black-overlay]>*,\n[data-white-overlay]>div,\n[data-white-overlay]>* {\n    position: relative;\n    z-index: 2;\n}\n\n[data-overlay]:before,\n[data-black-overlay]:before,\n[data-white-overlay]:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 2;\n}\n\n[data-overlay]:before {\n    @extend %bg-color-primary;\n}\n\n[data-black-overlay]:before {\n    background-color: #000000;\n}\n\n[data-white-overlay]:before {\n    background-color: #ffffff;\n}\n\n@for $i from 1 through 10 {\n\n    [data-overlay=\"#{$i}\"]:before,\n    [data-black-overlay=\"#{$i}\"]:before,\n    [data-white-overlay=\"#{$i}\"]:before {\n        opacity: #{$i * 0.10};\n    }\n}\n\n/*------------------------------\n    Scroll Up \n--------------------------------*/\n\n#scrollUp {\n    width: 70px;\n    height: 80px;\n    right: 100px;\n    bottom: 60px;\n    text-align: center;\n    z-index: 9811 !important;\n    text-decoration: none;\n    background: #fff;\n    line-height: 80px;\n    color: #757589;\n    font-size: 15px;\n    font-weight: 400;\n    @extend %transition;\n    display: inline-block;\n    background: #ffffff;\n\n    @media #{$md-layout} {\n        right: 20px;\n        bottom: 40px;\n    }\n\n    @media #{$sm-layout} {\n        right: 20px;\n        bottom: 40px;\n    }\n\n    &::before {\n        width: 100%;\n        height: 100%;\n        left: 0;\n        bottom: 0;\n        background: rgba(0, 2, 72, 0.1);\n        content: \"\";\n        position: absolute;\n        z-index: -1;\n        transform-style: preserve-3d;\n        transform: rotateY(-10deg);\n        filter: blur(50px);\n    }\n\n    &::after {\n        background: #ffffff;\n        position: absolute;\n        content: \"\";\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        z-index: -1;\n        transform-style: preserve-3d;\n        transform: rotateY(-10deg);\n    }\n\n    @media #{$sm-layout} {\n        right: 20px;\n        bottom: 30px;\n        width: 50px;\n        height: 60px;\n        line-height: 60px;\n    }\n\n    span {\n        &.text {\n            position: relative;\n            display: inline-block;\n            margin-top: 7px;\n\n            @media #{$sm-layout} {\n                margin-top: 3px;\n            }\n\n            &::after {\n                width: 0;\n                height: 0;\n                border-style: solid;\n                border-width: 0 5px 7px 5px;\n                border-color: transparent transparent var(--color-primary) transparent;\n                position: absolute;\n                content: \"\";\n                left: 50%;\n                top: 21%;\n                transform: translateX(-50%);\n            }\n        }\n    }\n\n    &:hover {\n        span {\n            &.text {\n                color: var(--color-primary);\n            }\n        }\n    }\n}\n\n\n\n\n/*--------------------\n    Contact Form \n----------------------*/\n.form-message {\n    margin-bottom: 0;\n    text-align: center;\n\n    &.error {\n        margin-top: 20px;\n        color: #f80707;\n    }\n\n    &.success {\n        margin-top: 20px;\n        color: #0d8d2d;\n    }\n}","@mixin clearfix() {\n\t&::after {\n\t\tcontent: \"\";\n\t\tclear: both;\n\t\tdisplay: table;\n\t}\n}\n\n@mixin config-bg-colors($prefix, $bg-color-...) {\n\t@each $i in $bg-color- {\n\t\t.#{$prefix}#{nth($i, 1)} {\n\t\t\tbackground-color: nth($i, 2);\n\t\t}\n\t}\n}\n\n@mixin placeholder {\n    &::-webkit-input-placeholder {\n        @content;\n    }\n    &:-moz-placeholder {\n        @content;\n    }\n    &::-moz-placeholder { \n        @content;\n    }\n    &:-ms-input-placeholder {\n        @content;\n    }\n}\n","/*=========================\n    Section Separation \n==========================*/\n\n\n.mt_dec--30 {\n    margin-top: -30px;\n}\n\n.mt_dec--20 {\n    margin-top: -20px;\n}\n\n.edu-section-gap {\n    padding: 130px 0 !important;\n    @media #{$md-layout} {\n        padding: 80px 0 !important;\n    }\n    @media #{$sm-layout} {\n        padding: 80px 0 !important;\n    }\n    &.slider-dots {\n        padding: 130px 0 205px !important;\n        @media #{$md-layout} {\n            padding: 80px 0 130px !important;\n        }\n        @media #{$sm-layout} {\n            padding: 80px 0 130px !important;\n        }\n    }\n}\n\n.edu-section-gapBottom {\n    padding-bottom: 130px !important;\n    @media #{$md-layout} {\n        padding-bottom: 80px !important; \n    }\n    @media #{$sm-layout} {\n        padding-bottom: 80px  !important;\n    }\n}\n\n.pb--165,\n.pb--85 {\n    @media #{$md-layout} {\n        padding-bottom: 80px !important; \n    }\n    @media #{$sm-layout} {\n        padding-bottom: 80px  !important;\n    }\n}\n\n.edu-section-gapTop {\n    padding-top: 130px !important;\n    @media #{$md-layout} {\n        padding-top: 80px !important; \n    }\n    @media #{$sm-layout} {\n        padding-top: 80px  !important;\n    }\n}\n\n\n\n.ptb--120 {\n    @media #{$md-layout} {\n        padding: 80px 0 !important;\n    }\n    @media #{$sm-layout} {\n        padding: 60px 0 !important;\n    }\n}\n\n.pb--165 ,\n.pb--120 ,\n.pb--85 ,\n.pb--165 {\n    @media #{$md-layout} {\n        padding-bottom: 80px !important;\n    }\n    @media #{$sm-layout} {\n        padding-bottom: 60px !important;\n    }\n}\n\n.pb--70 {\n    @media #{$sm-layout} {\n        padding-bottom: 60px !important;\n    }\n}\n\n.pl--0 {\n    padding-left: 0 !important;\n}\n.pr--0 {\n    padding-right: 0 !important;\n}\n.pt--0 {\n    padding-top: 0 !important;\n}\n.pb--0 {\n    padding-bottom: 0 !important;\n}\n.mr--0 {\n    margin-right: 0 !important;\n}\n.ml--0 {\n    margin-left: 0 !important;\n}\n.mt--0 {\n    margin-top: 0 !important;\n}\n.mb--0 {\n    margin-bottom: 0 !important;\n}\n\n.pt--260{\n    padding-top: 260px !important;\n}\n\n.pt--250 {\n    padding-top: 250px !important;\n}\n\n.pb--240 {\n    padding-bottom: 240px !important;\n}\n\n.pb--220 {\n    padding-bottom: 220px !important;\n}\n\n.plr--270{\n    padding: 0 270px !important;\n}\n\n.plr--300{\n    padding: 0 300px !important;\n}\n\n.plr--340{\n    padding: 0 340px !important;\n}\n\n.ptb--300{\n    padding: 300px 0 !important;\n}\n\n.ptb--340{\n    padding: 340px 0 !important;\n}\n\n.ptb--450{\n    padding: 450px 0 !important;\n}\n\n.plr_dec--15{\n    margin: 0 -15px !important;\n}\n\n.pt--300{\n    padding-top: 300px !important;\n}\n\n@for $i from 1 through 40 {\n    .ptb--#{5 * $i} { padding: 5px *$i 0 !important; }\n    .plr--#{5 * $i} { padding: 0 5px *$i !important; }\n    .pt--#{5 * $i} { padding-top: 5px *$i !important; }\n    .pb--#{5 * $i} { padding-bottom: 5px *$i !important; }\n    .pl--#{5 * $i} { padding-left: 5px *$i !important;}\n    .pr--#{5 * $i} { padding-right: 5px *$i !important;}\n    .mt--#{5 * $i} {margin-top: 5px *$i !important;}\n    .mb--#{5 * $i} {margin-bottom: 5px *$i !important;}\n    .mr--#{5 * $i} {margin-right: 5px *$i !important;}\n    .ml--#{5 * $i} {margin-left: 5px *$i !important;}\n}\n\n\n@media #{$laptop-device} {\n    @for $i from 1 through 20 {\n        .ptb_lp--#{5 * $i} {\n            padding: 5px *$i 0 !important;\n        }\n\n        .plr_lp--#{5 * $i} {\n            padding: 0 5px *$i !important;\n        }\n\n        .pt_lp--#{5 * $i} {\n            padding-top: 5px *$i !important;\n        }\n\n        .pb_lp--#{5 * $i} {\n            padding-bottom: 5px *$i !important;\n        }\n\n        .pl_lp--#{5 * $i} {\n            padding-left: 5px *$i !important;\n        }\n\n        .pr_lp--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n\n        .mt_lp--#{5 * $i} {\n            margin-top: 5px *$i !important;\n        }\n\n        .mb_lp--#{5 * $i} {\n            margin-bottom: 5px *$i !important;\n        }\n    }\n}\n\n\n@media #{$lg-layout} {\n    @for $i from 1 through 20 {\n        .ptb_lg--#{5 * $i} {\n            padding: 5px *$i 0 !important;\n        }\n\n        .plr_lg--#{5 * $i} {\n            padding: 0 5px *$i !important;\n        }\n\n        .pt_lg--#{5 * $i} {\n            padding-top: 5px *$i !important;\n        }\n\n        .pb_lg--#{5 * $i} {\n            padding-bottom: 5px *$i !important;\n        }\n\n\n        .pr_lg--0 {\n            padding-right: 0 !important;\n        }\n\n\n        .pr_lg--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n\n        .pl_lg--#{5 * $i} {\n            padding-left: 5px *$i !important;\n        }\n\n        .pr_lg--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n\n        .mt_lg--#{5 * $i} {\n            margin-top: 5px *$i !important;\n        }\n\n        .mb_lg--#{5 * $i} {\n            margin-bottom: 5px *$i !important;\n        }\n        .ml_lg--#{5 * $i} {\n            margin-left: 5px *$i !important;\n        }\n    }\n}\n\n@media #{$md-layout} {\n\n    .ptb_md--0{\n        padding: 0 !important;\n    }\n    .pl_md--0 {\n        padding-left: 0 !important;\n    }\n    .pr_md--0 {\n        padding-right: 0 !important;\n    }\n    .pt_md--0 {\n        padding-top: 0 !important;\n    }\n    .pb_md--0 {\n        padding-bottom: 0 !important;\n    }\n    .mr_md--0 {\n        margin-right: 0 !important;\n    }\n    .ml_md--0 {\n        margin-left: 0 !important;\n    }\n    .mt_md--0 {\n        margin-top: 0 !important;\n    }\n    .mb_md--0 {\n        margin-bottom: 0 !important;\n    }\n    .ptb_md--250{\n        padding: 250px 0 !important;\n    }\n\n    @for $i from 1 through 20 {\n        .ptb_md--#{5 * $i} {\n            padding: 5px *$i 0 !important;\n        }\n\n        .plr_md--#{5 * $i} {\n            padding: 0 5px *$i !important;\n        }\n\n        .pt_md--#{5 * $i} {\n            padding-top: 5px *$i !important;\n        }\n\n        .pb_md--#{5 * $i} {\n            padding-bottom: 5px *$i !important;\n        }\n\n        .pl_md--#{5 * $i} {\n            padding-left: 5px *$i !important;\n        }\n\n        .pr_md--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n\n        .mt_md--#{5 * $i} {\n            margin-top: 5px *$i !important;\n        }\n\n        .mb_md--#{5 * $i} {\n            margin-bottom: 5px *$i !important;\n        }\n        \n    }\n}\n\n@media #{$sm-layout} {\n    .ptb_sm--250{\n        padding: 250px 0 !important;\n    }\n    .ptb_sm--0{\n        padding: 0 !important;\n    }\n    .pl_sm--0 {\n        padding-left: 0 !important;\n    }\n    .pr_sm--0 {\n        padding-right: 0 !important;\n    }\n    .pt_sm--0 {\n        padding-top: 0 !important;\n    }\n    .pb_sm--0 {\n        padding-bottom: 0 !important;\n    }\n    .mr_sm--0 {\n        margin-right: 0 !important;\n    }\n    .ml_sm--0 {\n        margin-left: 0 !important;\n    }\n    .mt_sm--0 {\n        margin-top: 0 !important;\n    }\n    .mb_sm--0 {\n        margin-bottom: 0 !important;\n    }\n    .pt_sm--150 {\n        padding-top: 150px !important;\n    }\n    .pb_sm--110 {\n        padding-bottom: 110px !important;\n    }\n    @for $i from 1 through 20 {\n        .ptb_sm--#{5 * $i} {\n            padding: 5px *$i 0 !important;\n        }\n        .plr_sm--#{5 * $i} {\n            padding: 0 5px *$i !important;\n        }\n        .pt_sm--#{5 * $i} {\n            padding-top: 5px *$i !important;\n        }\n\n        .pb_sm--#{5 * $i} {\n            padding-bottom: 5px *$i !important;\n        }\n\n        .pl_sm--#{5 * $i} {\n            padding-left: 5px *$i !important;\n        }\n\n        .pr_sm--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n\n        .mt_sm--#{5 * $i} {\n            margin-top: 5px *$i !important;\n        }\n        \n        .ml_sm--#{5 * $i} {\n            margin-left: 5px *$i !important;\n        }\n\n        .mr_sm--#{5 * $i} {\n            margin-right: 5px *$i !important;\n        }\n\n        .mb_sm--#{5 * $i} {\n            margin-bottom: 5px *$i !important;\n        }\n    }\n\n    .pl_sm--0 {\n        padding-left: 0 !important;\n    }\n    .pr_sm--0 {\n        padding-right: 0 !important;\n    }\n    .pt_sm--0 {\n        padding-top: 0 !important;\n    }\n    .pb_sm--0 {\n        padding-bottom: 0 !important;\n    }\n    .mr_sm--0 {\n        margin-right: 0 !important;\n    }\n    .ml_sm--0 {\n        margin-left: 0 !important;\n    }\n    .mt_sm--0 {\n        margin-top: 0 !important;\n    }\n    .mb_sm--0 {\n        margin-bottom: 0 !important;\n    }\n    \n}\n\n\n@media #{$large-mobile}{\n    @for $i from 1 through 20 {\n        .ptb_mobile--#{5 * $i} {\n            padding: 5px *$i 0 !important;\n        }\n        .plr_mobile--#{5 * $i} {\n            padding: 0 5px *$i !important;\n        }\n        .pt_mobile--#{5 * $i} {\n            padding-top: 5px *$i !important;\n        }\n        .pb_mobile--#{5 * $i} {\n            padding-bottom: 5px *$i !important;\n        }\n        .pl_mobile--#{5 * $i} {\n            padding-left: 5px *$i !important;\n        }\n        .pr_mobile--#{5 * $i} {\n            padding-right: 5px *$i !important;\n        }\n        .mt_mobile--#{5 * $i} {\n            margin-top: 5px *$i !important;\n        }\n        .mb_mobile--#{5 * $i} {\n            margin-bottom: 5px *$i !important;\n        }\n    }\n}\n\n\n\n@for $i from 1 through 20 {\n    .slick-gutter-#{$i * 5} {\n        margin-left: -#{$i * 5}px !important;\n        margin-right: -#{$i * 5}px !important;\n\n        .slick-slide {\n            padding-left: #{$i * 5}px !important;\n            padding-right: #{$i * 5}px !important;\n        }\n    }\n}\n\n","/*======================== \n    Common Style Css\n==========================*/\n\n/* Heading Font  */\n.h1 {\n    font-size: var(--h1) !important\n}\n\n.h2 {\n    font-size: var(--h2) !important\n}\n\n.h3 {\n    font-size: var(--h3) !important\n}\n\n.h4 {\n    font-size: var(--h4) !important\n}\n\n.h5 {\n    font-size: var(--h5) !important\n}\n\n.h6 {\n    font-size: var(--h6) !important\n}\n\n/* Text Color  */\n\n.color-primary {\n    @extend %color-primary;\n}\n.color-secondary {\n    @extend %color-secondary;\n}\n\n.color-tertiary {\n    @extend %color-tertiary;\n}\n.color-heading {\n    @extend %color-heading;\n}\n.color-body {\n    @extend %color-body;\n}\n.color-dark {\n    @extend %color-dark;\n}\n//===== BG Ncc Colors =====//\n\n.bg-primary-color {\n    background: var(--color-primary) !important;\n}\n.bg-secondary-color {\n    background: var(--color-secondary) !important;\n}\n.bg-color-tertiary {\n    background-color: var(--color-tertiary) !important;\n}\n.bg-color-white {\n    background-color: var(--color-white) !important;\n}\n\n//===== Colors =====//\n.color-white {\n    color: var(--color-white);\n}\n\n/* Radius */\n.radius {\n    @extend %radius;\n}\n\n.radius-big {\n    @extend %radius-big;\n}\n\n\n/* Font Weight */\n\n.w-300 {\n    @extend %w-300;\n}\n\n.w-400 {\n    @extend %w-400;\n}\n\n.w-500 {\n    @extend %w-500;\n}\n\n.w-600 {\n    @extend %w-600;\n}\n\n.w-700 {\n    @extend %w-700;\n}\n\n.w-800 {\n    @extend %w-800;\n}\n\n.w-900 {\n    @extend %w-900;\n}\n\n/* Shadows */\n\n.shadow-primary {\n    @extend %shadow-primary;\n}\n\n.shadow-light {\n    @extend %shadow-light;\n}\n\n.shadow-lighter {\n    @extend %shadow-lighter;\n}\n\n/* Others  */\n.liststyle {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.radius {\n    @extend %radius;\n}\n\n%transition-transform {\n    transition: var(--transition-transform);\n}\n\n.transition-transform {\n    @extend %transition-transform;\n}\n\n.list-icon {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n        display: flex;\n        align-items: center;\n        margin: 15px 0;\n\n        @media #{$sm-layout} {\n            font-size: 16px;\n        }\n\n        .icon {\n            width: 30px;\n            background-color: var(--color-blackest);\n            height: 30px;\n            border-radius: 100%;\n            display: inline-block;\n            position: relative;\n            margin-right: 9px;\n            min-width: 30px;\n            min-height: 30px;\n\n            &.background-transparent {\n                background-color: transparent;\n            }\n\n            i {\n                width: 20px;\n                height: 20px;\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n            }\n        }\n    }\n}\n\n.rn-sub-badge {\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n    font-size: 16px;\n    border-radius: 4px;\n    margin-bottom: 12px;\n    display: inline-block;\n    padding: 7px 14px;\n    background-color: var(--color-blackest);\n    box-shadow: var(--shadow-lighter);\n}\n\n.radius-small {\n    border-radius: var(--radius-small);\n}\n\n.line-before {\n    position: relative;\n    padding-left: 18px;\n    &::before {\n        position: absolute;\n        content: \"\";\n        left: 0;\n        width: 2px;\n        height: 81%;\n        background: var(--color-primary);\n        top: 50%;\n        transform: translateY(-50%);\n    }\n}\n\n.bg-image--7 {\n    background-size: auto;\n    background-repeat: no-repeat;\n    background-position: top 15px left 10%;\n}\n\n.bg-image--12 {\n    background-size: auto;\n}\n\n.border-bottom-1 {\n    border-bottom: 1px solid #EEEEEE;\n}\n\n/* Breadcrumb  */\n.edu-breadcrumb-area {\n    background-image: url(../../images/bg/breadcrumb-bg.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -30px;\n            left: -180px;\n        }\n        &.shape-image-2 {\n            top: -10px;\n            left: 60%;\n        }\n        &.shape-image-3 {\n            top: -24px;\n            right: -90px;\n        }\n        &.shape-image-4 {\n            bottom: -39px;\n            right: -220px;\n        }\n        &.shape-image-5 {\n            bottom: -28px;\n            left: 35%;\n        }\n        &.shape-image-6 {\n            bottom: -30px;\n            left: -108px;\n        }\n    }\n}\n\n\n/* Animation  */\n\n.eduvibe-animated-shape {\n    position: relative;\n    z-index: 9;\n}\n\n@-webkit-keyframes eduvibe-vsm-y-move {\n    0% {\n        -webkit-transform: translate(0, -30%);\n        transform: translate(0, -30%);\n    }\n\n    100% {\n        -webkit-transform: translate(0, 30%);\n        transform: translate(0, 30%);\n    }\n}\n\n@keyframes eduvibe-vsm-y-move {\n    0% {\n        -webkit-transform: translate(0, -30%);\n        transform: translate(0, -30%);\n    }\n\n    100% {\n        -webkit-transform: translate(0, 30%);\n        transform: translate(0, 30%);\n    }\n}\n\n@-webkit-keyframes eduvibe-vsm-y-reverse-move {\n    0% {\n        -webkit-transform: translate(0, 30%);\n        transform: translate(0, 30%);\n    }\n\n    100% {\n        -webkit-transform: translate(0, -30%);\n        transform: translate(0, -30%);\n    }\n}\n\n@keyframes eduvibe-vsm-y-reverse-move {\n    0% {\n        -webkit-transform: translate(0, 30%);\n        transform: translate(0, 30%);\n    }\n\n    100% {\n        -webkit-transform: translate(0, -30%);\n        transform: translate(0, -30%);\n    }\n}\n\n@-webkit-keyframes eduvibe-sm-x-move {\n    0% {\n        -webkit-transform: translate(-50%, 0);\n        transform: translate(-50%, 0);\n    }\n\n    100% {\n        -webkit-transform: translate(50%, 0);\n        transform: translate(50%, 0);\n    }\n}\n\n@keyframes eduvibe-sm-x-move {\n    0% {\n        -webkit-transform: translate(-50%, 0);\n        transform: translate(-50%, 0);\n    }\n\n    100% {\n        -webkit-transform: translate(50%, 0);\n        transform: translate(50%, 0);\n    }\n}\n\n@-webkit-keyframes eduvibe-sm-x-reverse-move {\n    0% {\n        -webkit-transform: translate(50%, 0);\n        transform: translate(50%, 0);\n    }\n\n    100% {\n        -webkit-transform: translate(-50%, 0);\n        transform: translate(-50%, 0);\n    }\n}\n\n@keyframes eduvibe-sm-x-reverse-move {\n    0% {\n        -webkit-transform: translate(50%, 0);\n        transform: translate(50%, 0);\n    }\n\n    100% {\n        -webkit-transform: translate(-50%, 0);\n        transform: translate(-50%, 0);\n    }\n}\n\n@-webkit-keyframes eduvibe-rotate-y {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(-360deg);\n        transform: rotate(-360deg);\n    }\n}\n\n@-webkit-keyframes eduvibe-rotate-x {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes eduvibe-rotate-x {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes eduvibe-rotate-y {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(-360deg);\n        transform: rotate(-360deg);\n    }\n}\n\n@-webkit-keyframes eduvibe-zoom1 {\n    0% {\n        -webkit-transform:scale(.9);\n        transform:scale(.9)\n    }\n    100% {\n        -webkit-transform:scale(1.5);\n        transform:scale(1.5)\n    } \n}\n\n@keyframes eduvibe-zoom2 {\n    0% {\n        -webkit-transform:scale(1);\n        transform:scale(1)\n    }\n    100% {\n        -webkit-transform:scale(1.5);\n        transform:scale(1.5)\n    }\n}\n\n@-webkit-keyframes eduvibe-zoom1 {\n    0% {\n        -webkit-transform:scale(1);\n        transform:scale(1)\n    }\n    100% {\n        -webkit-transform:scale(1.25);\n        transform:scale(1.25)\n    } \n}\n\n@keyframes eduvibe-zoom1 {\n    0% {\n        -webkit-transform:scale(1);\n        transform:scale(1)\n    }\n    100% {\n        -webkit-transform:scale(1.25);\n        transform:scale(1.25)\n    }\n}","/* ========= Forms Styles ========= */\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n\t-webkit-appearance: button;\n}\n\ninput,\nselect,\ntextarea {\n\twidth: 100%;\n\ttransition: 0.3s;\n}\n\ninput {\n\theight: 40px;\n\tpadding: 0 15px;\n}\n\nselect {\n\ttransition: 0.3s;\n\theight: 60px;\n\tline-height: 28px;\n\tpadding: 10px 20px;\n\toutline: none;\n\tcolor: var(--color-body);\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\tappearance: none;\n\tborder: 2px solid var(--color-border);\n\tborder-radius: var(--radius);\n\tfont-size: 16px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tpadding-right: 30px;\n}\n\n.edu-select {\n\ttransition: 0.3s;\n\theight: 60px;\n\tline-height: 28px;\n\tpadding: 10px 20px;\n\toutline: none;\n\tcolor: var(--color-body);\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\tappearance: none;\n\tborder: 0 none;\n\tborder-radius: var(--radius);\n\tfont-size: 16px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tpadding-right: 30px;\n\tbackground-color: #f5f5f5;\n\tborder-radius: 5px;\n\tmax-width: 256px;\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\ninput[type=\"number\"],\ninput[type=\"tel\"],\ninput[type=\"date\"],\nselect,\ntextarea {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\theight: auto;\n\tline-height: 28px;\n\tbackground: transparent;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tpadding: 0 15px;\n\toutline: none;\n\tborder: var(--border-width) solid var(--color-border);\n\tborder-radius: var(--radius);\n\tcolor: var(--color-body);\n\n\t/* -- Placeholder -- */\n\t&::placeholder {\n\t\tcolor: var(--body-color);\n\t\t/* Firefox */\n\t\topacity: 1;\n\t}\n\n\t&:-ms-input-placeholder {\n\t\t/* Internet Explorer 10-11 */\n\t\tcolor: var(--body-color);\n\t\topacity: 1;\n\t}\n\n\t&::-ms-input-placeholder {\n\t\t/* Microsoft Edge */\n\t\tcolor: var(--body-color);\n\t\topacity: 1;\n\t}\n\n\t&.p-holder__active {\n\t\tborder-color: var(--color-primary);\n\n\t\t/* -- Placeholder -- */\n\t\t&::placeholder {\n\t\t\tcolor: var(--color-primary);\n\t\t\t/* Firefox */\n\t\t\topacity: 1;\n\t\t}\n\n\t\t&:-ms-input-placeholder {\n\t\t\t/* Internet Explorer 10-11 */\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&::-ms-input-placeholder {\n\t\t\t/* Microsoft Edge */\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&.p-holder__error {\n\t\tborder-color: #f4282d;\n\n\t\t/* -- Placeholder -- */\n\t\t&::placeholder {\n\t\t\tcolor: #f4282d;\n\t\t\t/* Firefox */\n\t\t\topacity: 1;\n\t\t}\n\n\t\t&:-ms-input-placeholder {\n\t\t\t/* Internet Explorer 10-11 */\n\t\t\tcolor: #f4282d;\n\t\t}\n\n\t\t&::-ms-input-placeholder {\n\t\t\t/* Microsoft Edge */\n\t\t\tcolor: #f4282d;\n\t\t}\n\n\t\t&:focus {\n\t\t\tborder-color: #f4282d;\n\t\t}\n\t}\n\n\t&:focus {\n\t\tborder-color: var(--color-primary);\n\t}\n}\n\n.input-active {\n\t@extend .p-holder__active;\n\n\tinput {\n\t\t@extend .p-holder__active;\n\t}\n}\n\n.input-error {\n\t@extend .p-holder__error;\n\n\tinput {\n\t\t@extend .p-holder__error;\n\t}\n}\n\n// Custom Checkbox and radio button\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n\topacity: 0;\n\tposition: absolute;\n\n\t~ label {\n\t\tposition: relative;\n\t\tfont-size: 16px;\n\t\tline-height: 26px;\n\t\tcolor: var(--body-color);\n\t\tfont-weight: 500;\n\t\tpadding-left: 34px;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 0;\n\t\t&::before {\n\t\t\tcontent: \" \";\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: -3px;\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tbackground-color: #fff;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 2px;\n\t\t\ttransition: all 0.3s;\n\t\t}\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 5px;\n\t\t\tleft: 1px;\n\t\t\twidth: 12px;\n\t\t\theight: 8px;\n\t\t\tbackground-color: transparent;\n\t\t\tborder-bottom: 2px solid #fff;\n\t\t\tborder-left: 2px solid #fff;\n\t\t\tborder-radius: 2px;\n\t\t\ttransform: rotate(-45deg);\n\t\t\topacity: 0;\n\t\t\ttransition: all 0.3s;\n\t\t}\n\t}\n\n\t&:checked {\n\t\t~ label {\n\t\t\t&::before {\n\t\t\t\tbackground-color: var(--color-primary);\n\t\t\t\tborder-color: var(--color-primary);\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\ninput[type=\"radio\"] {\n\t~ label {\n\t\t&::before {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t\t&::after {\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tleft: 3px;\n\t\t\ttop: 7px;\n\t\t\tbackground: #fff;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n\n.form-group {\n\tmargin-bottom: 20px;\n\tinput {\n\t\tborder: var(--border-width) solid var(--color-border);\n\t\tborder-radius: var(--radius);\n\t\theight: 50px;\n\t\tfont-size: 16px;\n\t\t@extend %transition;\n\t\tpadding: 0 15px;\n\n\t\t&:focus {\n\t\t\tborder-color: var(--color-primary);\n\t\t}\n\t}\n\n\ttextarea {\n\t\tmin-height: 193px;\n\t\tborder: var(--border-width) solid var(--color-border);\n\t\tborder-radius: var(--radius);\n\t\tresize: none;\n\t\tpadding: 15px;\n\t\tfont-size: 16px;\n\t\t@extend %transition;\n\n\t\t&:focus {\n\t\t\tborder-color: var(--color-primary);\n\t\t}\n\t}\n}\n\n// Form Submit Styles\ninput[type=\"submit\"] {\n\twidth: auto;\n\tfont-size: 16px;\n\tletter-spacing: 2px;\n\tpadding: 15px 20px;\n\tborder-radius: 6px;\n\tdisplay: block;\n\tfont-weight: 500;\n\ttransition: 0.3s;\n\tborder: var(--border-width) solid var(--color-primary);\n\tbackground: var(--color-primary);\n\tcolor: #ffffff;\n\theight: 60px;\n\tmargin-top: 30px;\n\n\t&:hover {\n\t\tcolor: #ffffff;\n\t\t-webkit-box-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);\n\t\tbox-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);\n\t\t-webkit-transform: translateY(-5px);\n\t\t-ms-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n\n.contact-form--1 form input::-webkit-input-placeholder,\n.contact-form--1 form textarea::-webkit-input-placeholder {\n\t/* Chrome/Opera/Safari */\n\tcolor: var(--color-body) !important;\n}\n\n.contact-form--1 form input::-moz-placeholder,\n.contact-form--1 form textarea::-moz-placeholder {\n\t/* Firefox 19+ */\n\tcolor: var(--color-body) !important;\n}\n\n.contact-form--1 form input:-ms-input-placeholder,\n.contact-form--1 form textarea:-ms-input-placeholder {\n\t/* IE 10+ */\n\tcolor: var(--color-body) !important;\n}\n\n.contact-form--1 form input:-moz-placeholder,\n.contact-form--1 form textarea:-moz-placeholder {\n\t/* Firefox 18- */\n\tcolor: var(--color-body) !important;\n}\n\n.login-register-page-wrapper {\n\t.login-form-box {\n\t\tborder: 1px solid #eeeeee;\n\t\tpadding: 40px;\n\t\tborder-radius: 10px;\n\t\tposition: relative;\n\t\tinput[type=\"checkbox\"] {\n\t\t\twidth: auto;\n\t\t}\n\t\t.lost-password {\n\t\t\tcolor: var(--color-secondary);\n\t\t}\n\t}\n}\n","/*--------------------------\n    Header Styles  \n--------------------------*/\n\n.edu-header {\n\t.logo {\n\t\ta {\n\t\t\tdisplay: block;\n\t\t\theight: 118px;\n\t\t\tline-height: 118px;\n\t\t\ttransition: min-height 1s ease !important;\n\t\t\timg {\n\t\t\t\t// max-height: 35px;\n\t\t\t}\n\t\t\t@media #{$smlg-device} {\n\t\t\t\theight: 80px;\n\t\t\t\tline-height: 80px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.disable-transparent {\n\t\t.logo {\n\t\t\ta {\n\t\t\t\theight: 90px;\n\t\t\t\tline-height: 90px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.header-relative {\n\t\tposition: relative;\n\t}\n\n\t&.header-transparent {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: auto;\n\t\tbackground: transparent;\n\t\tbackdrop-filter: inherit;\n\t\tz-index: 9;\n\t}\n\n\t&.header-sticky {\n\t\ttransition: height 0.5s ease-in;\n\t\tmax-width: 100%;\n\t\tz-index: 99;\n\t\t&.sticky {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbackground-color: var(--color-white) !important;\n\t\t\twidth: 100%;\n\t\t\theight: 80px;\n\t\t\tanimation: headerSticky 0.95s ease forwards;\n\t\t\tbox-shadow: 0px 3px 9px rgba(0, 0, 0, 0.05);\n\t\t\tz-index: 10;\n\t\t\t.logo {\n\t\t\t\ta {\n\t\t\t\t\theight: 80px;\n\t\t\t\t\tline-height: 80px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*------------------------\n    Header Style One  \n--------------------------*/\n\n.header-default {\n\tmax-width: 100%;\n\tbackground-color: var(--color-white);\n\tcolor: #fff;\n\tfont-size: 12px;\n\tz-index: 99;\n\tposition: relative;\n\n\t.header-right {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t}\n}\n\n/*------------------------\n    Header Style Two  \n--------------------------*/\n.header-style-2 {\n\tpadding: 0 200px;\n\n\t@media #{$laptop-device} {\n\t\tpadding: 0 30px;\n\t}\n\n\t@media #{$lg-layout} {\n\t\tpadding: 0 30px;\n\t}\n\n\t@media #{$md-layout} {\n\t\tpadding: 0 30px;\n\t}\n\n\t@media #{$sm-layout} {\n\t\tpadding: 0 15px;\n\t}\n\n\t.header-menu-bar {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n}\n\n.white-box-icon {\n\theight: 50px;\n\tline-height: 50px;\n\twidth: 50px;\n\ttext-align: center;\n\tborder-radius: 5px;\n\toutline: none;\n\tcolor: var(--color-primary);\n\tborder: 0 none;\n\tpadding: 0;\n\tbackground: var(--color-white);\n\tdisplay: block;\n\tfont-size: 16px;\n\t@media #{$sm-layout} {\n\t\theight: 40px;\n\t\tline-height: 40px;\n\t\twidth: 40px;\n\t}\n}\n\n@keyframes headerSticky {\n\t0% {\n\t\ttransform: translateY(-100%);\n\t}\n\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n}\n","/*--------------------------\n    Navigation Styles \n----------------------------*/\n.mainmenu-nav {\n    .mainmenu {\n        display: flex;\n        margin: 0;\n        padding: 0;\n        justify-content: center;\n        flex-wrap: wrap;\n        > li {\n            > a {\n                color: var(--color-heading);\n                font-size: 16px;\n                font-weight: 600;\n                padding: 0 23px;\n                display: block;\n                height: 80px;\n                line-height: 80px;\n                transition: 0.3s;\n                @media #{$lg-layout} {\n                    padding: 0 17px;\n                }\n                @media #{$md-layout} {\n                    padding: 0 12px;\n                }\n                &:hover,\n                &.active {\n                    color: var(--color-primary) !important;\n                }\n            }\n        } \n        li {\n            margin-top: 0;\n            margin-bottom: 0;\n            position: relative;\n            &.has-droupdown {\n                & > a {\n                    position: relative;\n                    &::after {\n                        position: absolute;\n                        content: \"\\e969\";\n                        font-family: 'icomoon';\n                        right: 6px;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        font-weight: 600;\n\n                        @media #{$lg-layout} {\n                            right: 0px;\n                        }\n                    }\n                }\n                .submenu {\n                    min-width: 210px;\n                    height: auto;\n                    position: absolute;\n                    top: 90%;\n                    left: 0;\n                    z-index: 90;\n                    opacity: 0;\n                    visibility: hidden;\n                    text-align: left;\n                    padding: 20px 0;\n                    transition: 0.3s;\n                    background-color: var(--color-white);\n                    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.04);\n                    border-bottom: 2px solid var(--color-primary);\n                    li {\n                        position: relative;\n                        a {\n                            font-size: 16px;\n                            font-weight: 600;\n                            padding: 3px 20px;\n                            display: block;\n                            color: var(--color-heading);\n                            margin: 0 10px;\n                            @extend %transition;\n                            &:hover {\n                                color: var(--color-primary) !important;\n                                background: var(--color-darker);\n                            }\n                            &.active {\n                                color: var(--color-primary) !important;\n                                background: var(--color-darker);\n                            }\n                        }\n                        &.has-droupdown {\n                            > a {\n                                &::after {\n                                    content: \"\\e92c\";\n                                    font-family: 'icomoon';\n                                }\n                            }\n                            .submenu {\n                                left: 100%;\n                                top: 90%;\n                                z-index: 90;\n                                opacity: 0;\n                                visibility: hidden;\n                                transition: 0.3s;\n                            }\n                            &:hover {\n                                .submenu {\n                                    left: 100%;\n                                    top: 0;\n                                    z-index: 90;\n                                    opacity: 1;\n                                    visibility: visible;\n                                }\n                            }\n                        }\n                    }\n                }\n                &:hover {\n                    > .submenu {\n                        opacity: 1;\n                        visibility: visible;\n                        top: 100%;\n                    }\n                }\n            }\n        }\n    }\n}\n","/*------------------------\n    Header Quote  \n-------------------------*/\n\n.header-quote {\n    display: flex;\n    justify-content: flex-end;\n    margin: 0 -17px;\n    align-items: center;\n    @media #{$sm-layout} {\n        margin: 0 -10px;\n    }\n    .quote-icon {\n        margin: 0 17px;\n        @media #{$sm-layout} {\n            margin: 0 10px;\n        }\n        a ,\n        button {\n            padding: 0;\n            border: 0 none;\n            width: auto;\n            background: transparent;\n            display: flex;\n            align-items: center;\n            i {\n                color: var(--color-heading);\n                font-size: 16px;\n                transition: 0.3s;\n            }\n            &:hover {\n                i {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n","/*------------------------------\n    Popup Menu Styles  \n--------------------------------*/\n.popup-mobile-menu {\n    z-index: 9999;\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity .5s ease-out;\n    .inner {\n        width: 320px;\n        z-index: 999;\n        position: absolute;\n        background: #FFFFFF;\n        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n        height: 100%;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n        opacity: 0;\n        left: -150px;\n        transition: all .5s ease-out;\n\n        .header-top {\n            display: flex;\n            border-bottom: 1px solid var(--color-border);\n            align-items: center;\n            justify-content: space-between;\n            padding: 15px 20px;\n            .logo {\n                a {\n                    img {\n                        max-height: 45px;\n                        max-width: 160px;\n                    }\n                }\n            }\n\n            .close-menu {\n                .close-button {\n                    background: var(--color-white);\n                    border: 0 none;\n                    color: var(--color-heading);\n                    width: 40px;\n                    height: 40px;\n                    font-size: 21px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 100%;\n                    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);\n                }\n            }\n        }\n    }\n\n    &.active {\n        visibility: visible;\n        opacity: 1;\n        .inner {\n            opacity: 1;\n            left: 0;\n            overflow-y: auto;\n        }\n    }\n\n    .mainmenu {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        padding: 15px 20px;\n        li {\n            margin: 0;\n            a {\n                padding: 8px 0;\n                display: block;\n                font-size: 16px;\n                font-weight: 500;\n                &.active {\n                    color: var(--color-primary) !important;\n                }\n            }\n            & + li {\n                border-top: 1px solid var(--color-border);\n            }\n        }\n\n        .has-droupdown {\n            .submenu {\n                opacity: 0;\n                height: 0;\n                visibility: hidden;\n                transition: all .3s;\n                padding: 0;\n                max-width: 100%;\n                list-style: none;\n                padding-left: 14px;\n                li {\n                    a {\n                        font-size: 15px;\n                        &.active {\n                            color: var(--color-primary) !important;\n                        }\n                    }\n                }\n                &.active {\n                    opacity: 1;\n                    height: 100%;\n                    visibility: visible;\n                }\n            }\n        }\n\n        .has-droupdown{\n            > a {\n                position: relative;\n                &::after {\n                    position: absolute;\n                    content: \"\\e935\";\n                    font-family: 'icomoon' !important;\n                    right: 0;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    transition: 0.4s;\n                }\n                &.open {\n                    &::after {\n                        content: \"\\e934\";\n                    }\n                }\n            }\n        }\n\n        .rn-megamenu {\n            padding: 0;\n            max-width: 100%;\n            list-style: none;\n            padding-left: 14px;\n            display: none;\n        }\n\n        .mega-menu-item {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            padding-left: 0;\n            li {\n                a {\n                    font-size: 15px;\n                }\n                &:last-child {\n                    border-bottom: 1px solid var(--color-border);\n                }\n            }\n        }\n\n        .single-mega-item {\n            &:last-child {\n                .mega-menu-item {\n                    li {\n                        &:last-child {\n                            border-bottom-color: transparent;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n","/*----------------------\n    Search Popup  \n-----------------------*/\n\n.edu-search-popup {\n    opacity: 0;\n    visibility: hidden;\n    transition: 0.4s;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99;\n    transform: scale(0.95);\n    &.open {\n        opacity: 1;\n        visibility: visible;\n        transform: scale(1);\n    }\n    .close-button {\n        position: absolute;\n        right: 30px;\n        top: 30px;\n        .close-trigger {\n            background: var(--color-white);\n            border: 0 none;\n            color: var(--color-heading);\n            width: 40px;\n            height: 40px;\n            font-size: 21px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 100%;\n            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n        }\n    }\n\n    .inner {\n        position: absolute;\n        top: 46%;\n        width: 100%;\n        .search-form {\n            text-align: center;\n            max-width: 1170px;\n            margin: 0 auto;\n            position: relative;\n            @media #{$laptop-device} {\n                padding: 0 20px;\n            }\n            @media #{$lg-layout} {\n                padding: 0 20px;\n            }\n            @media #{$md-layout} {\n                padding: 0 20px;\n            }\n            @media #{$sm-layout} {\n                padding: 0 20px;\n            }\n            input {\n                height: 60px;\n                border: 0 none;\n                border-radius: 5px;\n                background: #FFFFFF;\n                padding: 0 30px;\n                padding-right: 55px;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n            }\n            .submit-button {\n                position: absolute;\n                right: 30px;\n                padding: 0;\n                margin: 0;\n                border: 0 none;\n                outline: none;\n                color: var(--color-heading);\n                background: transparent;\n                top: 50%;\n                transform: translateY(-50%);\n\n            }\n        }\n    }\n    &::before {\n        position: absolute;\n        background: #2D284E;\n        opacity: 0.7;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        content: \"\";\n        z-index: -1;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*-------------------\n * Button\n---------------------*/\n.wishlist-btn {\n\tbackground: rgba(45, 40, 78, 0.2);\n\tbackdrop-filter: blur(10px);\n\twidth: 30px;\n\theight: 30px;\n\tline-height: 30px;\n\ttext-align: center;\n\tborder-radius: 100%;\n\tborder: 0 none;\n\ti {\n\t\tcolor: var(--color-white);\n\t\tfont-size: 15px;\n\t}\n}\n\n.button-group {\n\tmargin: -5px;\n\ta {\n\t\tmargin: 5px;\n\t}\n}\n\na,\nbutton {\n\t&.btn-transparent {\n\t\tfont-weight: 700;\n\t\tfont-size: 18px;\n\t\tline-height: 28px;\n\t\tcolor: var(--color-primary);\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\ttransition: 0.3s;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\tleft: auto;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 0;\n\t\t\theight: 2px;\n\t\t\tbackground: var(--color-primary);\n\t\t\ttransition: 0.3s;\n\t\t}\n\n\t\ti {\n\t\t\tpadding-left: 10px;\n\t\t\ttop: 3px;\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&.sm-size {\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t}\n\n\t\t&.heading-color {\n\t\t\tcolor: var(--color-heading);\n\t\t\ti {\n\t\t\t\tcolor: var(--color-heading);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\ti {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t&::after {\n\t\t\t\twidth: 100%;\n\t\t\t\tleft: 0;\n\t\t\t\tright: auto;\n\t\t\t}\n\t\t}\n\t}\n}\n\na,\nbutton {\n\t&.edu-btn {\n\t\tborder-radius: 5px;\n\t\tdisplay: inline-block;\n\t\theight: 60px;\n\t\tline-height: 60px;\n\t\tcolor: var(--color-white);\n\t\tbackground: var(--color-primary);\n\t\tpadding: 0 30px;\n\t\tfont-size: 18px;\n\t\tfont-weight: 700;\n\t\ttransition: 0.4s;\n\t\t// font-family: var(--font-primary);\n\t\tborder: 0 none;\n\n\t\ti {\n\t\t\tpadding-left: 10px;\n\t\t\tposition: relative;\n\t\t\ttop: 3px;\n\t\t}\n\n\t\t&.btn-medium {\n\t\t\theight: 50px;\n\t\t\tline-height: 50px;\n\t\t\tpadding: 0 25px;\n\t\t\tfont-size: 16px;\n\t\t\t&.header-button {\n\t\t\t\tline-height: 47px;\n\t\t\t\t&.bg-color-white {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.header-button.purchase-button {\n\t\t\t\tline-height: 50px;\n\t\t\t}\n\t\t}\n\n\t\t&.btn-small {\n\t\t\theight: 36px;\n\t\t\tline-height: 36px;\n\t\t\tpadding: 0 13px;\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 600;\n\t\t\ti {\n\t\t\t\tpadding-left: 7px;\n\t\t\t}\n\t\t}\n\n\t\t&.left-icon {\n\t\t\ti {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tpadding-right: 10px;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&.btn-dark {\n\t\t\tbackground: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&.btn-shade {\n\t\t\tbackground: var(--color-shade);\n\t\t\tcolor: var(--color-heading);\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&.btn-secondary {\n\t\t\tbackground: var(--color-secondary);\n\t\t\tcolor: var(--color-white);\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&.btn-bg-alt {\n\t\t\tbackground: rgba(82, 95, 225, 0.1);\n\t\t\tcolor: var(--color-primary);\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 59px;\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t\tborder-color: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&.btn-white {\n\t\t\tbackground: var(--color-white);\n\t\t\tcolor: var(--color-primary);\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tbackground: var(--color-secondary);\n\t\t\t}\n\t\t}\n\n\t\t&.btn-border {\n\t\t\tbackground: transparent;\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tcolor: var(--color-primary);\n\t\t\tline-height: 58px;\n\t\t}\n\t}\n}\n\n.bg-color-primary {\n\ta,\n\tbutton {\n\t\t&.edu-btn {\n\t\t\t&.btn-white {\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--color-secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.round-btn {\n\tdisplay: flex;\n\twidth: 60px;\n\theight: 60px;\n\tborder-radius: 100%;\n\tbackground: var(--color-white);\n\tjustify-content: center;\n\talign-items: center;\n\tbox-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n\ti {\n\t\tfont-size: 24px;\n\t\tcolor: var(--color-primary);\n\t\tdisplay: inline-block;\n\t}\n}\n\n@keyframes rotateIt {\n\tto {\n\t\ttransform: rotate(-360deg);\n\t}\n}\n","/*--------------------------------\n    Brands Area  \n------------------------------*/\n\n.eduvibe-home-five-brands {\n    .client-logo {\n        transition: all .4s;\n        display: inline-block;\n        @media #{$small-tablet} {\n            margin-bottom: 30px;\n        }\n        &:hover .logo-main,\n        & .logo-hover {\n            display: none;\n        }\n        &:hover .logo-hover {\n            display: block !important;\n        }\n        img {\n            display: flex;\n        }\n    }\n}\n\n","/*---------------------------\n * Section Title\n----------------------------*/\n.section-title {\n    .pre-title {\n        font-weight: 800;\n        font-size: 16px;\n        line-height: 26px;\n        color: var(--color-primary);\n        display: inline-block;\n        text-transform: uppercase;\n        margin-bottom: 5px;\n        letter-spacing: 0.1em;\n    }\n    .title {\n        margin-bottom: 0;\n        font-size: 40px;\n        @media #{$large-mobile} {\n            font-size: 32px;\n        }\n        br {\n            @media #{$sm-layout} {\n                display: none;\n            }\n        }\n    }\n    &.text-white {\n        .pre-title {\n            color: var(--color-white);\n        }\n        .title {\n            color: var(--color-white);\n        }\n    }\n}\n\n","/*---------------------------\n * Home 1 Course\n----------------------------*/\n\n.eduvibe-home-one-course {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 59px;\n            left: -246px;\n        }\n        &.shape-image-2 {\n            top: 144px;\n            right: -194px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-3 {\n            bottom: 53px;\n            right: -163px;\n        }\n        &.shape-image-4 {\n            bottom: 157px;\n            left: -226px;\n            animation: eduvibe-vsm-y-reverse-move 3.5s alternate infinite linear;\n        }\n    }\n}\n\n/*---------------------------\n * Home 1 Testimonial\n----------------------------*/\n.eduvibe-testimonial-one {\n    background-image: url(../../images/bg/home-one-testimonial.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 2px;\n            left: -232px;\n        }\n        &.shape-image-2 {\n            top: 19px;\n            right: -167px;\n        }\n        &.shape-image-3 {\n            bottom: 2px;\n            right: -265px;\n        }\n        &.shape-image-4 {\n            bottom: -68px;\n            left: -49px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 1 Video\n----------------------------*/\n.eduvibe-home-one-video {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 80px;\n            left: -232px;\n            animation: eduvibe-rotate-x 15s infinite linear;\n        }\n        &.shape-image-2 {\n            top: 20px;\n            right: -262px;\n        }\n        &.shape-image-3 {\n            bottom: 80px;\n            right: -242px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 1 Instructor\n----------------------------*/\n.eduvibe-home-one-instructor {\n    background-image: url(../../images/bg/home-one-instructor.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 29px;\n            left: -59px;\n        }\n        &.shape-image-2 {\n            top: 49px;\n            right: -53px;\n        }\n    }\n}\n\n/*---------------------------\n * Newsletter 1\n----------------------------*/\n.newsletter-style-1 {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -68px;\n            left: -20px;\n        }\n        &.shape-image-2 {\n            top: -34px;\n            right: -263px;\n        }\n        &.shape-image-3 {\n            bottom: -95px;\n            left: -178px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 1 Blog\n----------------------------*/\n.eduvibe-home-one-blog {\n    background-image: url(../../images/bg/home-one-blog.jpg);\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 71px;\n            left: -228px;\n            animation: eduvibe-vsm-y-move 5.6s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -20px;\n            right: -215px;\n            z-index: 0;\n            @media #{$custom-lg-device} {\n                right: 5px;\n                top: 45px;\n            }\n            @media #{$custom-laptop-device} {\n                display: none;\n            }\n        }\n        &.shape-image-3 {\n            bottom: -102px;\n            right: -260px;\n            \n        }\n        &.shape-image-4 {\n            bottom: -74px;\n            left: -208px;\n            \n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Service\n----------------------------*/\n.eduvibe-service-four {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 92px;\n            left: -180px;\n        }\n        &.shape-image-2 {\n            top: 71px;\n            right: -52px;\n        }\n        &.shape-image-3 {\n            bottom: -39px;\n            right: -219px;\n        }\n    }\n}\n\n/*---------------------------\n * About 3\n----------------------------*/\n.about-style-3 {\n    background-image: url(../../images/bg/home-two-about-us.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -3px;\n            left: -259px;\n        }\n        &.shape-image-2 {\n            top: -31px;\n            right: -269px;\n        }\n        &.shape-image-3 {\n            bottom: -31px;\n            right: -209px;\n        }\n        &.shape-image-4 {\n            bottom: -61px;\n            left: -269px;\n        }\n    }\n\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n\n            &.shape-1 {\n                bottom: -44px;\n                left: -272px;\n                .shape-dot {\n                    width: 50px;\n                    height: 50px;\n                    background: var(--color-extra06);\n                    opacity: 0.8;\n                }\n            }\n\n            &.shape-2 {\n                top: 14px;\n                right: -228px;\n                .shape-dot {\n                    width: 26px;\n                    height: 26px;\n                    background: var(--color-extra08);\n                    opacity: 0.35;\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Course\n----------------------------*/\n.eduvibe-home-two-course {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 177px;\n            left: -203px;\n            animation: eduvibe-vsm-y-move 4.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            bottom: 390px;\n            right: -262px;\n        }\n        &.shape-image-3 {\n            bottom: -40px;\n            right: -17px;\n            animation: eduvibe-vsm-y-reverse-move 4s alternate infinite linear;\n        }\n        &.shape-image-4 {\n            bottom: -65px;\n            left: -38px;\n            animation: eduvibe-sm-x-move 4s alternate infinite linear;\n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Event\n----------------------------*/\n.eduvibe-home-two-event {\n    background-image: url(../../images/bg/home-two-events.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -263px;\n            left: -153px;\n        }\n        &.shape-image-2 {\n            top: 101px;\n            right: -28px;\n        }\n        &.shape-image-3 {\n            bottom: -40px;\n            right: -78px;\n        }\n        &.shape-image-4 {\n            bottom: -90px;\n            left: -208px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n\n            &.shape-1 {\n                top: -232px;\n                right: -124px;\n                .shape-dot {\n                    width: 48px;\n                    height: 48px;\n                    border: 8px solid rgba(248, 111, 3, 0.3);\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Testimonial\n----------------------------*/\n.eduvibe-home-two-testimonial {\n    background-image: url(../../images/bg/home-two-testimonial.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: -53px;\n            left: -193px;\n        }\n        &.shape-image-2 {\n            top: 27px;\n            right: -183px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Counter\n----------------------------*/\n.eduvibe-home-two-counter {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: -33px;\n            left: -33px;\n        }\n        &.shape-image-2 {\n            bottom: 143px;\n            right: -243px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 2 Blog\n----------------------------*/\n.eduvibe-home-two-blog {\n    background-image: url(../../images/bg/home-two-blog.jpg);\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -50px;\n            left: -198px;\n            img {\n                max-width: 60%;\n            }\n        }\n        &.shape-image-2 {\n            top: 112px;\n            right: 107px;\n            z-index: 0;\n        }\n        &.shape-image-2 {\n            top: 112px;\n            right: 107px;\n            z-index: 0;\n            @media #{$custom-lg-device} {\n                right: 30px;\n                top: 45px;\n            }\n        }\n        &.shape-image-3 {\n            bottom: -84px;\n            right: -218px;\n        }\n        &.shape-image-4 {\n            bottom: -62px;\n            left: -50px;\n            \n        }\n    }\n}\n\n\n/*---------------------------\n * Home 3 Service\n----------------------------*/\n.eduvibe-service-five {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 81px;\n            right: -46px;\n        }\n        &.shape-image-2 {\n            bottom: -40px;\n            left: -250px;\n            img {\n                max-width: 80%;\n            }\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                top: 111px;\n                right: -50px;\n                .shape-dot {\n                    width: 130px;\n                    height: 130px;\n                    background: var(--color-tertiary);\n                    opacity: 0.4;\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 About\n----------------------------*/\n.home-three-about {\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 54px;\n            right: -196px;\n        }\n        &.shape-image-2 {\n            bottom: 27px;\n            right: -108px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Course\n----------------------------*/\n.eduvibe-home-three-course {\n    background-image: url(../../images/bg/home-three-course.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            img {\n                transform: rotate(90deg);\n            }\n            top: -260px;\n            left: -130px;\n            animation: eduvibe-sm-x-move 6s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: 484px;\n            left: -282px;\n            animation: eduvibe-vsm-y-reverse-move 5.5s alternate infinite linear;\n        }\n        &.shape-image-3 {\n            top: 152px;\n            right: -211px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-4 {\n            bottom: 49px;\n            right: -224px;\n        }\n        &.shape-image-5 {\n            bottom: -47px;\n            left: -289px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Video\n----------------------------*/\n.eduvibe-home-three-video {\n    background-image: url(../../images/bg/video-home-3-bg.png);\n    background-size: auto;\n    background-repeat: no-repeat;\n    background-position: top 15px left 10%;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -59px;\n            right: -199px;\n        }\n        &.shape-image-2 {\n            bottom: -47px;\n            right: -63px;\n        }\n        &.shape-image-3 {\n            bottom: -91px;\n            left: -229px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Accordion\n----------------------------*/\n.eduvibe-home-three-accordion {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-2 {\n            bottom: inherit;\n            left: -170px;\n            top: 56px;\n        }\n        &.shape-image-3 {\n            bottom: 16px;\n            left: inherit;\n            right: -200px;\n            top: inherit;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                top: 195px;\n                left: -91px;\n                .shape-dot {\n                    width: 200px;\n                    height: 200px;\n                    border: 34px solid rgba(248, 111, 3, .3);\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Testimonial\n----------------------------*/\n.eduvibe-home-three-testimonial {\n    background-image: url(../../images/bg/home-three-testimonial.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            left: -173px;\n            top: 16px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -34px;\n            right: -268px;\n        }\n        &.shape-image-3 {\n            bottom: -45px;\n            left: -37px;\n        }\n        &.shape-image-4 {\n            bottom: -25px;\n            right: -218px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Event\n----------------------------*/\n.eduvibe-home-three-event {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            left: -173px;\n            top: 16px;\n        }\n        &.shape-image-2 {\n            top: -34px;\n            right: -180px;\n        }\n        &.shape-image-3 {\n            bottom: -45px;\n            right: -237px;\n        }\n        &.shape-image-4 {\n            bottom: -25px;\n            left: -218px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 3 Nesletter\n----------------------------*/\n.eduvibe-home-three-newsletter {\n    background-image: url(../../images/bg/home-three-newsletter.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            left: -63px;\n            top: -24px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -4px;\n            right: 100px;\n        }\n        &.shape-image-3 {\n            right: -194px;\n            bottom: -104px;\n        }\n        &.shape-image-4 {\n            left: 216px;\n            bottom: -48px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Service\n----------------------------*/\n.eduvibe-home-four-service {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 56px;\n            left: -180px;\n            animation: eduvibe-rotate-x 7s infinite linear;\n        }\n        &.shape-image-2 {\n            top: 12px;\n            right: -180px;\n        }\n        &.shape-image-3 {\n            bottom: -38px;\n            right: -25px;\n        }\n        &.shape-image-4 {\n            bottom: -48px;\n            left: -55px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 About\n----------------------------*/\n.eduvibe-home-four-about {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 231px;\n            left: -190px;\n        }\n        &.shape-image-2 {\n            top: -59px;\n            right: -297px;\n        }\n        &.shape-image-3 {\n            bottom: 10px;\n            right: -185px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: 140px;\n                left: -21px;\n                z-index: 2;\n                .shape-dot {\n                    width: 40px;\n                    height: 40px;\n                    border: 5.4px solid rgba(248, 111, 3, .5);\n                    animation: eduvibe-zoom2 2s infinite alternate;\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Course\n----------------------------*/\n.eduvibe-home-four-courses {\n    background-image: url(../../images/bg/home-four-courses.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 6px;\n            left: -150px;\n        }\n        &.shape-image-2 {\n            top: 38px;\n            right: -175px;\n        }\n        &.shape-image-3 {\n            bottom: 30px;\n            right: -230px;\n        }\n        &.shape-image-4 {\n            bottom: 80px;\n            left: -189px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: 13px;\n                right: -196px;\n                .shape-dot {\n                    width: 40px;\n                    height: 40px;\n                    border: 5.4px solid rgba(251, 124, 86, .3);\n                    animation: eduvibe-zoom2 2s infinite alternate;\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Video PopUp\n----------------------------*/\n.eduvibe-home-four-video {\n    background-image: url(../../images/bg/home-four-video.jpg);\n    @media #{$small-tablet} {\n        background-image: none;\n    }\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -33px;\n            left: -30px;\n        }\n        &.shape-image-2 {\n            bottom: -50px;\n            left: -48px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Team\n----------------------------*/\n.eduvibe-home-four-team {\n    padding: 130px 0 275px;\n    background-image: url(../../images/bg/home-four-instructor.jpg);\n    @media #{$small-tablet} {\n        padding: 80px 0 160px;\n    }\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 38px;\n            left: -181px;\n            animation: eduvibe-sm-x-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -24px;\n            right: -216px;\n        }\n        &.shape-image-3 {\n            bottom: -30px;\n            right: -151px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Testimonial\n----------------------------*/\n.eduvibe-home-four-testimonial {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 5px;\n            left: -200px;\n        }\n        &.shape-image-2 {\n            top: 0px;\n            right: -200px;\n        }\n        &.shape-image-3 {\n            bottom: 0px;\n            right: -121px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 4 Blog\n----------------------------*/\n.eduvibe-home-four-blog {\n    background-image: url(../../images/bg/home-four-blog.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 5px;\n            left: -200px;\n        }\n        &.shape-image-2 {\n            bottom: -34px;\n            right: -35px;\n        }\n        &.shape-image-3 {\n            bottom: -54px;\n            left: -56px;\n        }\n    }\n}\n\n/*---------------------------\n * FAQ Page\n----------------------------*/\n.eduvibe-faq-page {\n    .animated-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 60px;\n            left: -59px;\n            animation: eduvibe-sm-x-move 3s alternate infinite linear;\n            img {\n                transform: rotate(90deg);\n            }\n        }\n        &.shape-image-2 {\n            top: 56px;\n            right: -223px;\n        }\n        &.shape-image-3 {\n            bottom: 56px;\n            right: -223px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: 89px;\n                left: -184px;\n                .shape-dot {\n                    width: 48px;\n                    height: 48px;\n                    border: 8px solid var(--color-extra07);\n                    animation: eduvibe-zoom1 2.6s infinite alternate;\n                }\n            }\n        }\n    }\n}\n\n\n/*---------------------------\n * 404 Page\n----------------------------*/\n.eduvibe-404-page {\n    background-image: url(../../images/bg/404.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 165px;\n            left: -21px;\n        }\n        &.shape-image-2 {\n            top: 100px;\n            right: -247px;\n        }\n        &.shape-image-3 {\n            top: 520px;\n            right: 50px;\n        }\n        &.shape-image-4 {\n            bottom: -61px;\n            right: -247px;\n        }\n        &.shape-image-5 {\n            left: 40px;\n            bottom: -63px;\n        }\n        &.shape-image-6 {\n            bottom: 180px;\n            left: -200px;\n        }\n    }\n}\n\n/*---------------------------\n * Coming Soon Page\n----------------------------*/\n.eduvibe-coming-soon {\n    background-image: url(../../images/bg/coming-soon.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -6px;\n            left: -110px;\n        }\n        &.shape-image-2 {\n            top: -83px;\n            right: -107px;\n        }\n        &.shape-image-3 {\n            bottom: 252px;\n            right: -111px;\n        }\n        &.shape-image-4 {\n            bottom: -100px;\n            right: -234px;\n        }\n        &.shape-image-5 {\n            bottom: -60px;\n            left: -84px;\n        }\n        &.shape-image-6 {\n            top: 390px;\n            left: 0;\n        }\n    }\n}\n\n/*---------------------------\n * Contact Us Page\n----------------------------*/\n.eduvibe-contact-us {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 132px;\n            left: -40px;\n        }\n        &.shape-image-2 {\n            top: 95px;\n            right: -59px;\n        }\n        &.shape-image-3 {\n            bottom: 79px;\n            right: -197px;\n        }\n    }\n}\n\n/*---------------------------\n * Contact Me Page\n----------------------------*/\n.eduvibe-contact-me-top {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 113px;\n            left: -200px;\n        }\n        &.shape-image-2 {\n            right: -40px;\n            top: 100px;\n        }\n        &.shape-image-3 {\n            top: 0;\n            right: -250px;\n        }\n        &.shape-image-4 {\n            bottom: 6px;\n            right: -200px;\n        }\n    }\n}\n\n.eduvibe-contact-me-bottom {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 94px;\n            left: -56px;\n        }\n        &.shape-image-2 {\n            top: 173px;\n            right: -147px;\n        }\n        &.shape-image-3 {\n            bottom: -80px;\n            right: -269px;\n        }\n        &.shape-image-4 {\n            bottom: -40px;\n            left: -29px;\n        }\n        &.shape-image-5 {\n            bottom: -90px;\n            left: -219px;\n        }\n    }\n}\n\n\n/*---------------------------\n * Pricing Plan Page\n----------------------------*/\n.eduvibe-pricing-plan-page {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 324px;\n            left: -199px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: -6px;\n                right: -46px;\n                .shape-dot {\n                    width: 110px;\n                    height: 110px;\n                    border: 18px solid rgba(255, 164, 27, .15);\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Categories\n----------------------------*/\n.eduvibe-home-five-cats {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 80px;\n            left: -235px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: 70px;\n            right: -239px;\n        }\n        &.shape-image-3 {\n            bottom: 12px;\n            right: 5px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: -6px;\n                right: -46px;\n                .shape-dot {\n                    width: 110px;\n                    height: 110px;\n                    border: 18px solid rgba(255, 164, 27, .15);\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 About\n----------------------------*/\n.eduvibe-home-five-about {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 58px;\n            left: -24px;\n        }\n        &.shape-image-2 {\n            top: 48px;\n            right: -224px;\n        }\n        &.shape-image-3 {\n            bottom: -62px;\n            right: -164px;\n        }\n        &.shape-image-4 {\n            bottom: 28px;\n            left: -104px;\n        }\n        &.shape-image-5 {\n            top: 188px;\n            left: -224px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Course\n----------------------------*/\n.eduvibe-home-five-course {\n    background-image: url(../../images/bg/home-five-courses.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -62px;\n            left: -296px;\n        }\n        &.shape-image-2 {\n            top: 19px;\n            right: -217px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-3 {\n            bottom: -55px;\n            right: -207px;\n        }\n        &.shape-image-4 {\n            bottom: -52px;\n            left: -268px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Instructor\n----------------------------*/\n.eduvibe-home-five-instructor {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 198px;\n            left: -35px;\n        }\n        &.shape-image-2 {\n            top: 36px;\n            right: -123px;\n        }\n        &.shape-image-3 {\n            bottom: 19px;\n            right: -193px;\n        }\n        &.shape-image-4 {\n            bottom: 91px;\n            left: -165px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Progress\n----------------------------*/\n.eduvibe-home-five-progress {\n    background-image: url(../../images/bg/home-five-hiw.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -40px;\n            left: -110px;\n            animation: eduvibe-sm-x-move 4s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            bottom: 110px;\n            right: -242px;\n            animation: eduvibe-vsm-y-move 4s alternate infinite linear;\n        }\n        &.shape-image-3 {\n            bottom: -49px;\n            left: -242px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Testimonial\n----------------------------*/\n.eduvibe-home-five-testimonial {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 38px;\n            right: -230px;\n            \n        }\n        &.shape-image-2 {\n            bottom: -15px;\n            right: -183px;\n        }\n        &.shape-image-3 {\n            bottom: -45px;\n            left: -183px;\n        }\n    }\n}\n\n/*---------------------------\n * Home 5 Blog\n----------------------------*/\n.eduvibe-home-five-blog {\n    background-image: url(../../images/bg/home-five-blog.jpg);\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 30px;\n            left: -228px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: 143px;\n            right: 87px;\n            z-index: 0;\n            @media #{$custom-lg-device} {\n                top: 45px;\n                right: 30px;\n            }\n        }\n        &.shape-image-3 {\n            bottom: 38px;\n            right: -240px;\n        }\n        &.shape-image-4 {\n            bottom: -45px;\n            left: -30px;\n        }\n    }\n}\n\n/*---------------------------\n * About Us 1 Service\n----------------------------*/\n.eduvibe-about-us-one-service {\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 150px;\n            left: -148px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: 125px;\n            right: -44px;\n        }\n        &.shape-image-3 {\n            bottom: 13px;\n            right: -200px;\n        }\n    }\n}\n\n/*---------------------------\n * About Us 1 Team\n----------------------------*/\n.eduvibe-about-one-team {\n    position: relative;\n    background-image: url(../../images/bg/about-us-one-team.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 41px;\n            left: -228px;\n        }\n        &.shape-image-2 {\n            top: 150px;\n            right: 85px;\n            z-index: 0;\n            @media #{$custom-lg-device} {\n                right: 30px;\n                top: 45px;\n            }\n        }\n        &.shape-image-3 {\n            bottom: -42px;\n            right: -240px;\n            \n        }\n        &.shape-image-4 {\n            bottom: -54px;\n            left: -198px;\n            animation: eduvibe-vsm-y-reverse-move 3.5s alternate infinite linear;\n        }\n    }\n}\n\n\n/*---------------------------\n * Home 4 Service\n----------------------------*/\n.eduvibe-about-one-service {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: -7px;\n            left: -50px;\n        }\n        &.shape-image-2 {\n            top: 42px;\n            right: -220px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: -34px;\n                left: -48px;\n                .shape-dot {\n                    width: 130px;\n                    height: 130px;\n                    background: var(--color-tertiary);\n                    opacity: 0.4;\n                }\n            }\n            &.shape-2 {\n                top: 83px;\n                left: -131px;\n                .shape-dot {\n                    width: 12px;\n                    height: 12px;\n                    background: #9EDBE2;\n                    animation: eduvibe-zoom1 1s infinite alternate;\n                }\n            }\n            &.shape-3 {\n                bottom: -16px;\n                right: -63px;\n                .shape-dot {\n                    width: 8px;\n                    height: 8px;\n                    background: var(--color-secondary);\n                    animation: eduvibe-zoom1 1s infinite alternate;\n                }\n            }\n        }\n    }\n}\n\n/*--------------------------------\n * Home About Us 2 Service & Video\n----------------------------------*/\n.eduvibe-about-us-two-service {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 42px;\n            left: -180px;\n            animation: eduvibe-rotate-x 7s infinite linear;\n        }\n        &.shape-image-2 {\n            bottom: -28px;\n            right: -27px;\n        }\n    }\n}\n\n.eduvibe-about-us-two-video {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            bottom: 66px;\n            left: -120px;\n            animation: eduvibe-sm-x-move 4.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            bottom: 90px;\n            right: -120px;\n            animation: eduvibe-rotate-x 7s infinite linear;\n        }\n    }\n}\n\n/*---------------------------\n * Home About Us 2 Award\n----------------------------*/\n.eduvibe-about-two-award {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -255px;\n            left: -170px;\n        }\n        &.shape-image-2 {\n            top: 97px;\n            right: -39px;\n        }\n        &.shape-image-3 {\n            bottom: -30px;\n            left: -30px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                top: -243px;\n                right: -134px;\n                .shape-dot {\n                    width: 30px;\n                    height: 30px;\n                    border: 5px solid rgba(255, 164, 27, .3);\n                    animation: eduvibe-zoom2 2s infinite alternate;\n                }\n            }\n        }\n    }\n}\n\n\n/*---------------------------\n * Home 5 Instructor\n----------------------------*/\n.eduvibe-about-us-two-instructor {\n    background-image: url(../../images/bg/about-us-two-team-team.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 198px;\n            left: -35px;\n        }\n        &.shape-image-2 {\n            top: 36px;\n            right: -123px;\n        }\n        &.shape-image-3 {\n            bottom: 19px;\n            right: -193px;\n        }\n        &.shape-image-4 {\n            bottom: 91px;\n            left: -165px;\n        }\n    }\n}\n\n/*---------------------------\n * Home About Us 3 Mission\n----------------------------*/\n.eduvibe-about-three-mission {\n    .animated-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 128px;\n            left: -60px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                top: 38px;\n                left: 188px;\n                .shape-dot {\n                    width: 150px;\n                    height: 150px;\n                    background: #FFA41B;\n                    opacity: 0.6;\n                    border-radius: 5px;\n                }\n            }\n            &.shape-2 {\n                top: -17px;\n                right: -37px;\n                .shape-dot {\n                    width: 100px;\n                    height: 100px;\n                    background: rgba(251, 124, 86, .6);\n                }\n            }\n        }\n    }\n}\n\n/*---------------------------\n * Home About Us 3 Team\n----------------------------*/\n.eduvibe-about-three-team {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 96px;\n            left: -37px;\n        }\n        &.shape-image-2 {\n            top: 8px;\n            right: -240px;\n        }\n        &.shape-image-3 {\n            bottom: -10px;\n            right: -150px;\n        }\n        &.shape-image-4 {\n            bottom: -21px;\n            left: -220px;\n        }\n    }\n}\n\n/*---------------------------\n * Home About Us 3 funfact\n----------------------------*/\n.eduvibe-about-three-funfact {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 169px;\n            left: -137px;\n            animation: eduvibe-sm-x-move 2.5s alternate infinite linear;\n            img {\n                transform: rotate(90deg);\n            }\n        }\n        &.shape-image-2 {\n            top: 8px;\n            right: -200px;\n            animation: eduvibe-sm-x-reverse-move 2.5s alternate infinite linear;\n            img {\n                transform: rotate(90deg);\n            }\n        }\n    }\n}\n\n/*---------------------------\n * About 3 Testimonial\n----------------------------*/\n.eduvibe-about-three-testimonial {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            left: -173px;\n            top: 56px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -14px;\n            right: -268px;\n        }\n        &.shape-image-3 {\n            bottom: -45px;\n            left: -37px;\n        }\n    }\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n            &.shape-1 {\n                bottom: -25px;\n                right: -218px;\n                .shape-dot {\n                    width: 70px;\n                    height: 70px;\n                    border: 12px solid #FFDCB4;\n                }\n            }\n        }\n    }\n}\n\n.eduvibe-home-4-hero-svg path {\n    -webkit-animation: none;\n    animation: none;\n    stroke-dasharray: 3000;\n    stroke-dashoffset: 3000;\n}\n\n.sal-animate.eduvibe-home-4-hero-svg path {\n    -webkit-animation: eduvibe-svg-dash 6.5s linear forwards;\n    animation: eduvibe-svg-dash 6.5s linear forwards;\n}\n\n@-webkit-keyframes eduvibe-svg-dash {\n    to {\n      stroke-dashoffset: 0;\n    }\n}\n  \n@keyframes eduvibe-svg-dash {\n    to {\n      stroke-dashoffset: 0;\n    }\n}\n  \n","/*---------------------------\n Card Styles  \n-----------------------------*/\n\n.course-activation-item-2 .edu-card.card-type-2 {\n    margin: 20px 0;\n}\n\n.video-gallery-overlay-area {\n    padding-top: 400px !important;\n    @media #{$md-layout} {\n        padding-top: 80px !important;\n    }\n    @media #{$sm-layout} {\n        padding-top: 80px !important;\n    }\n}\n\n.course-three-wrapper {\n    position: relative;\n    z-index: 1;\n    \n    .video-section-overlayto-another {\n        margin-bottom: -400px;\n        @media #{$md-layout} {\n            margin-bottom: 0;\n        }\n        @media #{$sm-layout} {\n            margin-bottom: 0;\n        }\n    }\n}\n\n\n\n.price-list {\n    margin: -7.5px;\n    .price {\n        margin: 7.5px;\n        display: inline-block;\n    }\n    .current-price {\n        font-weight: 700;\n    }\n\n    .old-price {\n        font-weight: 500;\n        text-decoration: line-through;\n    }\n\n    &.price-style-01 {\n        margin: -9px;\n        .price {\n            margin: 9px;\n        }\n        \n        .current-price {\n            border-radius: 3px;\n            background: var(--color-primary);\n            font-weight: 700;\n            font-size: 16px;\n            color: var(--color-white);\n            height: 36px;\n            line-height: 36px;\n            padding: 0 15px;\n            display: inline-block;\n        }\n    }\n\n    &.price-style-02 {\n        margin: -7.5px;\n        .price {\n            margin: 7.5px;\n        }\n        .current-price {\n            font-weight: 700;\n            font-size: 20px;\n            color: var(--color-heading);\n        }\n        .old-price {\n            font-weight: 600;\n        }\n    }\n\n    &.price-style-03 {\n        margin: -6px;\n        .price {\n            margin: 6px;\n        }\n        .current-price {\n            font-weight: 700;\n            font-size: 20px;\n            color: var(--color-primary);\n            font-size: 20px;\n\n        }\n        .old-price {\n            font-weight: 500;\n        }\n    }\n}\n\n.edu-card {\n    overflow: hidden;\n    .thumbnail {\n        position: relative;\n        a {\n            display: block;\n            overflow: hidden;\n            img {\n                transition: 0.4s;\n                overflow: hidden;\n            }\n        }\n        .top-position {\n            position: absolute;\n            z-index: 2;\n        }\n        .wishlist-top-right {\n            position: absolute;\n            z-index: 2;\n        }\n    }\n\n    &.card-type-1 {\n        background-color: var(--color-shade);\n        transition: 0.4s;\n        .inner {\n            .thumbnail {\n                position: relative;\n                a {\n                    display: block;\n                    overflow: hidden;\n                    img {\n                        transition: 0.4s;\n                        overflow: hidden;\n                    }\n                }\n                .top-position { \n                    &.left-top {\n                        left: 15px;\n                        top: 15px;\n                    }\n                    &.right-top {\n                        right: 15px;\n                        top: 15px;\n                    }\n                }\n                .wishlist-top-right {\n                    right: 20px;\n                    top: 20px;\n                }\n            }\n            .content {\n                padding: 25px 30px 30px;\n                @media #{$sm-layout} {\n                    padding: 25px 20px 25px;\n                }\n                .title {\n                    margin-bottom: 15px;\n                    margin-top: 10px;\n                }\n                .edu-rating {\n                    margin-bottom: 25px;\n                }\n                .card-bottom {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n                    border-top: 1px solid var(--color-border);\n                    padding-top: 25px;\n                }\n            }\n        }\n        &:hover {\n            background: var(--color-white);\n            box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.05);\n        }\n        &.bg-white {\n            background-color: var(--color-white);\n            transition: 0.4s;\n            &:hover {\n                background: var(--color-white);\n                box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n            }\n        }\n    }\n\n    &.card-type-2 {\n        background-color: var(--color-shade);\n        padding: 20px 20px 30px;\n        transition: 0.4s;\n        .inner {\n            .thumbnail {\n                a {\n                    border-radius: 3px;\n                    img {\n                        border-radius: 3px;\n                    }\n                }\n                .top-position { \n                    &.left-top {\n                        left: 0;\n                        top: 10px;\n                    }\n                }\n                .wishlist-top-right {\n                    right: 20px;\n                    top: 10px;\n                }\n            }\n            .content {\n                padding-top: 25px;\n                .card-top {\n                    display: flex;\n                    justify-content: space-between;\n                    margin-bottom: 20px;\n                }\n                .title {\n                    margin-bottom: 20px;\n                }\n                .card-bottom {\n                    display: flex;\n                    align-items: center;\n                    padding-top: 20px;\n                    margin-top: 20px;\n                    border-top: 1px solid var(--color-border);\n                }\n            }\n        }\n        &:hover {\n            background-color: var(--color-white);\n            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n        }\n    }\n    &.card-type-3 {\n        background-color: var(--color-white);\n        box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);\n        position: relative;\n        .inner {\n            .thumbnail {\n                a {\n                    border-radius: 3px;\n                    img {\n                        border-radius: 3px;\n                    }\n                }\n                .top-position { \n                    &.left-bottom {\n                        left: 30px;\n                        bottom: -19px;\n                        @media #{$sm-layout} {\n                            left: 20px;\n                        }\n                    }\n                }\n                .wishlist-top-right {\n                    right: 20px;\n                    top: 20px;\n                }\n            }\n            .content {\n                padding: 44px 30px 30px;\n                @media #{$sm-layout} {\n                    padding: 44px 20px 20px;\n                }\n                .card-top {\n                    display: flex;\n                    justify-content: space-between;\n                    margin-bottom: 20px;\n                    \n                    @media #{$lg-layout} {\n                        flex-wrap: wrap;\n                    }\n\n                    @media #{$md-layout} {\n                        flex-wrap: wrap;\n                    }\n\n                    @media #{$sm-layout} {\n                        flex-wrap: wrap;\n                    }\n\n                    .author-meta {\n                        margin-right: 10px;\n                    }\n                }\n                .title {\n                    margin-bottom: 20px;\n                }\n                .card-bottom {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n                    border-top: 1px solid var(--color-border);\n                    padding-top: 25px;\n                    flex-wrap: wrap;\n                 \n                }\n            }\n        }\n\n        .card-hover-action {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            background-color: var(--color-primary);\n            opacity: 0;\n            transition: 0.4s;\n            box-shadow: 0px 12px 30px rgba(82, 95, 225, 0.1);\n            border-radius: 5px;\n            padding: 30px;\n            z-index: 2;\n            @media #{$lg-layout} {\n                padding: 30px 20px;\n            }\n            @media #{$md-layout} {\n                padding: 30px 20px;\n            }\n            @media #{$sm-layout} {\n                padding: 30px 20px;\n            }\n            .content-top {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 20px;\n                .top-status-bar {\n                    .eduvibe-status {\n                        background: rgba(255,255,255,0.15);\n                        border: 0 none;\n                        line-height: 33px;\n                    }\n                }\n\n                .top-wishlist-bar {\n                    .wishlist-btn {\n                        background: rgba(255,255,255,0.2);\n                        backdrop-filter: blur(10px);\n                    }\n                }\n            } \n            .title {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 20px;\n                a {\n                    color: var(--color-white);\n                }\n            }\n            .description {\n                color: rgba(255,255,255,0.8);\n                margin-bottom: 25px;\n            }\n            \n            .price-list {\n                margin-bottom: 25px;\n                .price {\n                    color: var(--color-white);\n                    &.old-price {\n                        color: rgba(255,255,255,0.8);\n                    }\n                }\n            }\n\n            .hover-bottom-content {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 30px;\n                flex-wrap: wrap;\n                .author-meta {\n                    .author-title {\n                        font-weight: 600;\n                        font-size: 16px;\n                        line-height: 26px;\n                        color: var(--color-white);\n                    }\n                }\n                .edu-meta {\n                    li {\n                        color: var(--color-white);\n                        i {\n                            color: var(--color-white);\n                        }\n                    }\n                }\n            }\n        }\n        &:hover {\n            .card-hover-action {\n                opacity: 1;\n            }\n        }\n\n        &.variation-2 {\n            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);\n            .inner {\n                .thumbnail {\n                    .top-position { \n                        &.left-bottom {\n                            left: 30px;\n                            bottom: -13.5px;\n                        }\n                    }\n                }\n                .edu-meta {\n                    &.meta-01 {\n                        margin: 0 -10px;\n                        li {\n                            font-weight: 500;\n                            line-height: 26px;\n                            margin: 0 10px;\n                            display: flex;\n                            align-items: center;\n                            font-size: 14px;\n                        }\n                    }\n                }\n\n                .eduvibe-status {\n                    &.status-03 {\n                        color: var(--color-white);\n                        font-size: 14px;\n                        font-weight: 600;\n                        height: 27px;\n                        line-height: 27px;\n                        padding: 0 10px;\n                        background: var(--color-primary);\n                        border-radius: 4px;\n                        display: inline-block;\n                        border: 0 none;\n                    }\n                }\n                .content {\n                    padding: 32px 30px 30px;\n                    .title {\n                        margin-bottom: 20px;\n                        font-size: 20px;\n                        margin-top: 15px;\n                        line-height: 32px;\n                    }\n                    p {\n                        margin-bottom: 0;\n                    }\n                }\n\n            }\n        }\n    }\n\n    &.card-type-4 {\n        background-color: var(--color-shade);\n        transition: 0.4s;\n        .inner {\n            display: flex;\n            @media #{$md-layout} {\n                display: block;\n            }\n            @media #{$sm-layout} {\n                display: block;\n            }\n\n            .thumbnail {\n                flex-basis: 38.33%;\n                a {\n                    height: 100%;\n                    display: block;\n                    img {\n                        height: 100%;\n                        object-fit: cover;\n                        @media #{$sm-layout} {\n                            max-height: 330px;\n                        }\n                    }\n                }\n                .top-position { \n                    &.left-top {\n                        left: 10px;\n                        top: 10px;\n                    }\n                }\n                .wishlist-top-right {\n                    right: 10px;\n                    top: 10px;\n                }\n            }\n\n            .content {\n                flex-basis: 61.66%;\n                padding: 30px 25px;\n                \n                @media #{$md-layout} {\n                    padding: 30px 18px;\n                }\n                @media #{$sm-layout} {\n                    padding: 30px 18px;\n                }\n                .card-top {\n                    display: flex;\n                    justify-content: space-between;\n                    margin-bottom: 20px;\n                }\n                .title {\n                    margin-bottom: 20px;\n                    margin-top: 20px;\n                }\n                .card-bottom {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n                    flex-wrap: wrap;\n                }\n            }\n        }\n        &:hover {\n            box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n            background-color: var(--color-white);\n        }\n\n        &.bg-white {\n            background-color: var(--color-white);\n        }\n    }\n\n    &.card-type-5 {\n        background: var(--color-white);\n        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n        .inner {\n            padding: 15px 15px 0;\n            .thumbnail {\n                a {\n                    height: 100%;\n                    display: block;\n                    border-radius: 3px;\n                    img {\n                        height: 100%;\n                        border-radius: 3px;\n                    }\n                }\n                .top-position { \n                    &.left-top {\n                        left: 10px;\n                        top: 10px;\n                    }\n                }\n                .wishlist-top-right {\n                    right: 10px;\n                    top: 10px;\n                }\n            }\n\n            .content {\n                padding: 25px 15px;\n                .card-top {\n                    display: flex;\n                    justify-content: space-between;\n                    margin-bottom: 20px;\n                }\n                .title {\n                    margin-bottom: 20px;\n                    margin-top: 15px;\n                }\n                .card-bottom {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n                    margin-top: 20px;\n                }\n            }\n        }\n    }\n\n    &.card-type-6 {\n        background: var(--color-white);\n        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n        .inner {\n            padding: 15px;\n            .thumbnail {\n                margin-bottom: 15px;\n                a {\n                    height: 100%;\n                    display: block;\n                    border-radius: 3px;\n                    img {\n                        height: 100%;\n                        border-radius: 3px;\n                    }\n                }\n                .top-position { \n                    &.left-top {\n                        left: 10px;\n                        top: 10px;\n                    }\n                }\n            }\n            .content {\n                .title {\n                    margin-bottom: 12px;\n                    margin-top: 10px;\n                    font-size: 18px;\n                    line-height: 28px;\n                }\n                p {\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 22px;\n                    margin-bottom: 5px;\n                }\n            }\n        }\n    }\n\n    &:hover {\n        .thumbnail {\n            a {\n                img {\n                    transform: scale(1.1);\n                }\n            }\n        }\n    }\n}\n","/*-----------------------\n    Card Styles  \n-------------------------*/\n.edu-meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    &.meta-01 {\n        margin: 0 -20px;\n        @media #{$sm-layout} {\n            margin: 0 -6px;\n        }\n        li {\n            font-weight: 500;\n            line-height: 26px;\n            margin: 0 20px;\n            display: flex;\n            align-items: center;\n            @media #{$lg-layout} {\n                &:first-child {\n                    margin-right: 10px;\n                }\n                &:last-child {\n                    margin-left: 10px;\n                }\n                \n            }\n            @media #{$sm-layout} {\n                margin: 0 6px;\n            }\n            i {\n                color: var(--color-body);\n                margin-right: 8px;\n            }\n        }\n    }\n    &.meta-02 {\n        margin: 0 -20px;\n        li {\n            font-weight: 500;\n            line-height: 26px;\n            margin: 0 20px;\n            display: flex;\n            align-items: center;\n            i {\n                color: var(--color-primary);\n                margin-right: 10px;\n            }\n        }\n    }\n\n    &.meta-03 {\n        margin: -5px -12px;\n        li {\n            font-weight: 600;\n            line-height: 22px;\n            margin: 5px 12px;\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            i {\n                color: var(--color-primary);\n                margin-right: 10px;\n                width: 24px;\n                height: 24px;\n                position: relative;\n                z-index: 1;\n                text-align: center;\n                line-height: 24px;\n                border-radius: 2px;\n\n                &::after {\n                    position: absolute;\n                    content: \"\";\n                    left: 0;\n                    top: 0;\n                    background: var(--color-primary);\n                    width: 100%;\n                    height: 100%;\n                    z-index: -1;\n                    opacity: 0.1;\n                    border-radius: 2px;\n                }\n            }\n\n            &.meta-lessons { \n                i {\n                    color: var(--color-secondary);\n                    &::after {\n                        background: var(--color-secondary);\n                    }\n                }\n            }\n            &.meta-clock { \n                i {\n                    color: var(--color-primary);\n                    &::after {\n                        background: var(--color-primary);\n                    }\n                }\n            }\n            &.meta-user { \n                i {\n                    color: var(--color-tertiary);\n                    &::after {\n                        background: var(--color-tertiary);\n                    }\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n\n    &.meta-04 {\n        margin: -5px -6px;\n        li {\n            font-weight: 600;\n            line-height: 22px;\n            margin: 5px 6px;\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            i {\n                color: var(--color-secondary);\n                margin-right: 8px;\n                font-size: 16px;\n            }\n        }\n    }\n}\n\n\n.edu-rating {\n    &.rating-default {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        .rating {\n            @extend %liststyle;\n            margin-right: 10px;\n        }\n    }\n}\n\n\n/*----------------------\n    Author Meta  \n-----------------------*/\n\n.author-meta {\n    display: flex;\n    align-items: center;\n    .author-thumb {\n        a {\n            display: block;\n            transition: 0.4s;\n            img {\n                max-height: 34px;\n                border-radius: 100%;\n                margin-right: 10px;\n                display: inline-block;\n            }\n            .author-title {\n                font-weight: 600;\n                font-size: 16px;\n                line-height: 26px;\n                color: var(--color-heading);\n                transition: 0.4s;\n            }\n            &:hover {\n                .author-title {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n","/*-----------------------\n Badge Style  \n------------------------*/\n.badge-transparent {\n    display: inline-block;\n    color: var(--color-primary);\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.status-group {\n    margin: -5px;\n    .eduvibe-status {\n        margin: 5px;\n    }\n}\n\n.status-style-5 {\n    display: flex;\n    flex-wrap: wrap;\n    margin: -5px -17px;\n    \n    .eduvibe-status {\n        margin: 5px 17px;\n    }\n}\n\n.eduvibe-status {\n    \n    &.status-01 {\n        color: var(--color-primary);\n        font-size: 14px;\n        font-weight: 600;\n        height: 30px;\n        line-height: 30px;\n        padding: 0 12px;\n        background: var(--color-white);\n        display: inline-block;\n        border-radius: 2px;\n        &.bg-primary-color {\n            color: var(--color-white);\n        }\n        &.bg-secondary-color {\n            color: var(--color-white);\n        }\n    }\n\n    &.status-02 {\n        color: var(--color-white);\n        font-size: 14px;\n        font-weight: 600;\n        height: 30px;\n        line-height: 30px;\n        padding: 0 12px;\n        background: var(--color-secondary);\n        border-radius: 0 2px 2px 0;\n        display: flex;\n        align-items: center;\n        i {\n            margin-right: 5px;\n        }\n    }\n\n    &.status-03 {\n        color: var(--color-white);\n        font-size: 14px;\n        font-weight: 600;\n        height: 34px;\n        line-height: 30px;\n        padding: 0 15px;\n        background: var(--color-primary);\n        border-radius: 2px;\n        display: inline-block;\n        border: 2px solid var(--color-white);\n    }\n\n    &.status-04 {\n        color: var(--color-white);\n        font-size: 14px;\n        font-weight: 600;\n        height: 27px;\n        line-height: 27px;\n        padding: 0 10px;\n        background: var(--color-secondary);\n        border-radius: 2px;\n        display: inline-block;\n        text-transform: uppercase;\n    }\n\n    &.status-05 {\n        color: var(--color-body);\n        font-size: 16px;\n        font-weight: 600;\n        display: flex;\n        align-items: center;\n        transition: 0.4s;\n        i {\n            color: var(--color-primary);\n            margin-right: 9px;\n        }\n        &:hover {\n            color: var(--color-primary);\n        }\n    }\n    \n    &.status-06 {\n        color: var(--color-white);\n        font-size: 16px;\n        font-weight: 700;\n        height: 36px;\n        line-height: 36px;\n        padding: 0 20px 0 15px;\n        background: var(--color-primary);\n        display: inline-block;\n        border-radius: 0px 18px 18px 0px;\n    }\n\n}\n\n\n.badge-default {\n    border-radius: 3px;\n    background: var(--color-primary);\n    font-weight: 700;\n    font-size: 16px;\n    color: var(--color-white);\n    height: 36px;\n    line-height: 36px;\n    padding: 0 15px;\n    display: inline-block;\n}\n\n\n\n\n\n\n\n\n","/*--------------------------\n    Pagination Styles  \n----------------------------*/\n\n.edu-pagination {\n    margin: -5px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    li {\n        margin: 5px;\n        list-style: none;\n        a {\n            width: 40px;\n            height: 40px;\n            background: var(--color-shade);\n            display: inline-block;\n            line-height: 40px;\n            border-radius: 100%;\n            text-align: center;\n            color: var(--color-body);\n            transition: 0.4s;\n            font-size: 16px;\n            font-weight: 500;\n            i {\n                font-size: 22px;\n                font-weight: 500;\n            }\n        }\n        button {\n            width: 40px;\n            height: 40px;\n            background: var(--color-shade);\n            display: inline-block;\n            line-height: 40px;\n            border-radius: 100%;\n            text-align: center;\n            color: var(--color-body);\n            transition: 0.4s;\n            font-size: 16px;\n            font-weight: 500;\n            border: 0;\n            border-color: transparent;\n            i {\n                font-size: 22px;\n                font-weight: 500;\n            }\n        }\n        &.active ,\n        &:hover {\n            a,\n            button {\n                background: var(--color-primary);\n                color: var(--color-white);\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n","/*-------------------------\n    Event Grid Style  \n--------------------------*/\n\n.edu-event {\n    .top-position {\n        position: absolute;\n        z-index: 2;\n        &.left-top {\n            left: 0;\n            top: 25px;\n        }\n    }\n\n    .event-meta {\n        @extend %liststyle;\n        display: flex;\n        align-items: center;\n        li {\n            font-weight: 500;\n            font-size: 16px;\n            @media #{$sm-layout} {\n                font-size: 14px;\n            }\n            i {\n                padding-right: 8px;\n                color: var(--color-primary);\n            }\n        }\n    }\n\n\n    &.event-grid-1 {\n        .inner {\n            background: var(--color-white);\n            transition: 0.4s;\n            .thumbnail {\n                position: relative;\n                overflow: hidden;\n                a {\n                    display: block;\n                    img {\n                        width: 100%;\n                        transition: 0.4s;\n                        overflow: hidden;\n                        border-radius: 5px 5px 0 0;\n                    }\n                }\n            }\n            .content {\n                padding: 30px;\n                @media #{$sm-layout} {\n                    padding: 20px;\n                }\n                .title {\n                    margin-top: 18px;\n                    margin-bottom: 18px;\n                    @media #{$sm-layout} {\n                        margin-top: 0px;\n                        margin-bottom: 10px;\n                    }\n                }\n            }\n            &:hover {\n                box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);\n                border-radius: 5px;\n            }\n        }\n\n        &.bg-shade {\n            .inner {\n                box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);\n            }\n        }\n    }\n\n    &.event-list {\n        .inner {\n            display: flex;\n            padding: 20px 40px 20px 20px;\n            background: var(--color-shade);\n            transition: 0.4s;\n            border-radius: 5px;\n            flex-wrap: wrap;\n            @media #{$smlg-device} {\n                padding: 20px;\n            }\n\n            .thumbnail {\n                position: relative;\n                overflow: hidden;\n                flex-basis: 13%;\n                @media #{$lg-layout} {\n                    flex-basis: 17%;\n                }\n                @media #{$md-layout} {\n                    flex-basis: 25%;\n                }\n                @media #{$sm-layout} {\n                    flex-basis: 32%;\n                }\n                @media #{$small-mobile} {\n                    flex-basis: 100%;\n                }\n                a {\n                    display: block;\n                    img {\n                        width: 100%;\n                        transition: 0.4s;\n                        overflow: hidden;\n                        border-radius: 3px;\n                        min-width: 140px;\n                        min-height: auto;\n                        object-fit: cover;\n                    }\n                }\n            }\n            .content {\n                flex-basis: 87%;\n                padding-left: 42px;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                @media #{$lg-layout} {\n                    display: block;\n                    flex-basis: 83%;\n                }\n\n                @media #{$md-layout} {\n                    display: block;\n                    flex-basis: 75%;\n                }\n\n                @media #{$sm-layout} {\n                    display: block;\n                    flex-basis: 68%;\n                    padding-left: 20px;\n                }\n                @media #{$small-mobile} {\n                    flex-basis: 100%;\n                    padding-left: 0;\n                    margin-top: 20px;\n                }\n\n                .title {\n                    margin-bottom: 15px;\n                    @media #{$sm-layout} {\n                        font-size: 18px;\n                    }\n                }\n                .event-meta {\n                    margin: 0 -18px;\n                    flex-wrap: wrap;\n                    li {\n                        margin: 0 18px;\n                        display: flex;\n                        align-items: center;\n                        @media #{$md-layout} {\n                            margin: 0 5px;\n                            font-size: 14px;\n                        }\n                        i {\n                            color: var(--color-body);\n                            font-size: 18px;\n                        }\n                    }\n                }\n            }\n\n            .read-more-btn {\n                @media #{$lg-layout} {\n                    margin-top: 20px;\n                }\n                @media #{$md-layout} {\n                    margin-top: 20px;\n                }\n                @media #{$sm-layout} {\n                    margin-top: 25px;\n                }\n                a.edu-btn {\n                    @media #{$sm-layout} {\n                        padding: 0 25px;\n                        height: 50px;\n                        line-height: 50px;\n                        font-size: 16px;\n                    }\n                }\n            }\n\n            &:hover {\n                box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);\n                background: var(--color-white);\n            }\n        }\n        \n        &.bg-white {\n            .inner {\n                background: #FFFFFF;\n                transition: 0.4s;\n            }\n            &:hover {\n                .inner {\n                    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.05);\n                    background: var(--color-white);\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*-------------------------\n    Team Styles  \n--------------------------*/\n\n.team-area-shape-position {\n    position: relative;\n    .shape-wrapper {\n        .shape {\n            position: absolute;\n            &.shape-1 {\n                bottom: 86px;\n                right: 5%;\n            }\n            &.shape-2 {\n                top: 130px;\n                left: 136px;\n            }\n            &.shape-3 {\n                top: 148px;\n                right: 88px;\n            }\n            &.shape-4 {\n                bottom: 115px;\n                left: 127px;\n            }\n        }\n    }\n}\n\n\n.team-share-info {\n    margin: -3px;\n    a {\n        width: 34px;\n        height: 34px;\n        background: var(--color-white);\n        line-height: 38px;\n        text-align: center;\n        border-radius: 100%;\n        font-size: 14px;\n        color: var(--color-primary);\n        margin: 3px;\n        transition: 0.4s;\n        &:hover {\n            background: var(--color-primary);\n            color: var(--color-white);\n        }\n    }\n   \n}\n\n\n\n.edu-instructor-1 {\n    text-align: center;\n    .edu-instructor {\n        border-radius: 100%;\n        position: relative;\n        z-index: 2;\n        transition: 0.3s;\n        &::after {\n            position: absolute;\n            content: \"\";\n            left: 0;\n            top: 0;\n            background-image: url(../../images/team/border-shape.png);\n            background-repeat: no-repeat;\n            background-size: cover;\n            background-position: center center;\n            width: 100%;\n            height: 100%;\n            transition: 0.5s all;\n        }\n        .inner {\n            position: relative;\n            padding: 20px;\n            .thumbnail {\n                a {\n                    display: block;\n                    position: relative;\n                    &::after {\n                        background: var(--color-dark);\n                        position: absolute;\n                        content: \"\";\n                        left: 0;\n                        top: 0;\n                        width: 100%;\n                        height: 100%;\n                        border-radius: 100%;\n                        opacity: 0;\n                        transition: all .3s cubic-bezier(.645,.045,.355,1);\n                    }\n                    img {\n                        width: 100%;\n                        border-radius: 100%;\n                    }\n                }\n            }\n            .team-share-info {\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translateX(-50%) translateY(-50%);\n                z-index: 2;\n                a {\n                    display: inline-block;\n                    opacity: 0;\n                    visibility: hidden;\n                    transition: all .45s cubic-bezier(.23,.88,.34,.99);\n                    transform: translateY(8px) scale(.8);\n                    &:nth-child(1) {\n                        transition-delay: .07692s;\n                    }\n                    &:nth-child(2) {\n                        transition-delay: .15385s;\n                    }\n                    &:nth-child(3) {\n                        transition-delay: .23077s;\n                    }\n                }\n            }\n        }\n    }\n    .edu-instructor-info {\n        margin-top: 25px;\n        .title {\n            margin-bottom: 5px;\n        }\n        .desc {\n            display: inline-block;\n            color: var(--color-body);\n            font-weight: 500;\n            font-size: 16px;\n            transition: 0.4s;\n        }\n    }\n    &:hover {\n        .edu-instructor {\n            &::after {\n                transform: rotate(90deg);\n            }\n            .team-share-info {\n                a {\n                    opacity: 1;\n                    visibility: visible;\n                    transform: translateY(0);\n                }\n            }\n            .inner {\n                .thumbnail {\n                    a {\n                        &::after {\n                            opacity: 0.4;\n                        }\n                    }\n                }\n            }\n        }\n        .edu-instructor-info {\n            .desc {\n                color: var(--color-primary);\n            }\n        }\n    }\n}\n\n\n.edu-instructor-2 {\n    text-align: center;\n    .edu-instructor {\n        border-radius: 100%;\n        position: relative;\n        z-index: 2;\n        transition: 0.3s;\n        .inner {\n            position: relative;\n            .thumbnail {\n                a {\n                    display: block;\n                    position: relative;\n                    &::after {\n                        background: linear-gradient(180deg, rgba(45, 40, 78, 0) 0.01%, rgba(45, 40, 78, 0) 15.58%, rgba(45, 40, 78, 0.75) 100%);\n                        position: absolute;\n                        content: \"\";\n                        left: 0;\n                        top: 0;\n                        width: 100%;\n                        height: 100%;\n                        border-radius: 100%;\n                        opacity: 0;\n                        transition: all .3s cubic-bezier(.645,.045,.355,1);\n                        border-radius: 5px;\n                        border-radius: 185px 185px 5px 5px;\n                    }\n                    img {\n                        width: 100%;\n                        border-radius: 185px 185px 5px 5px;\n                        transition: all .3s cubic-bezier(.645,.045,.355,1);\n                    }\n                }\n            }\n            .team-share-info {\n                position: absolute;\n                z-index: 2;\n                bottom: 40px;\n                width: 100%;\n                text-align: center;\n                a {\n                    width: 40px;\n                    height: 40px;\n                    line-height: 43px;\n                    display: inline-block;\n                    opacity: 0;\n                    visibility: hidden;\n                    transition: all .45s cubic-bezier(.23,.88,.34,.99);\n                    transform: translateY(8px) scale(.8);\n\n                    &:nth-child(1) {\n                        transition-delay: .07692s;\n                    }\n                    &:nth-child(2) {\n                        transition-delay: .15385s;\n                    }\n                    &:nth-child(3) {\n                        transition-delay: .23077s;\n                    }\n                    &:nth-child(4) {\n                        transition-delay: .31077s;\n                    }\n                }\n            }\n        }\n    }\n    .edu-instructor-info {\n        margin-top: 25px;\n        .title {\n            margin-bottom: 5px;\n        }\n        .desc {\n            display: inline-block;\n            color: var(--color-body);\n            font-weight: 500;\n            font-size: 16px;\n            transition: 0.4s;\n        }\n    }\n    &:hover {\n        .edu-instructor {\n            .team-share-info {\n                a {\n                    opacity: 1;\n                    visibility: visible;\n                    transform: translateY(0);\n                }\n            }\n            .inner {\n                .thumbnail {\n                    a {\n                        &::after {\n                            border-radius: 5px;\n                            opacity: 1;\n                        }\n                        img {\n                            border-radius: 5px;\n                        }\n                    }\n                }\n            }\n        }\n        .edu-instructor-info {\n            .desc {\n                color: var(--color-primary);\n            }\n        }\n    }\n}\n\n.edu-instructor-3 {\n    text-align: center;\n    .edu-instructor {\n        border-radius: 100%;\n        position: relative;\n        z-index: 2;\n        transition: 0.3s;\n        .inner {\n            position: relative;\n\n            .thumbnail {\n                a {\n                    display: block;\n                    position: relative;\n                    img {\n                        width: 100%;\n                        border-radius: 5px;\n                    }\n                }\n            }\n\n            .edu-instructor-info {\n                position: absolute;\n                z-index: 2;\n                bottom: -20px;\n                width: 100%;\n                text-align: left;\n                background: #fff;\n                box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n                border-radius: 5px;\n                padding: 25px 30px;\n                opacity: 0;\n                transition: 0.4s;\n                left: 40px;\n                @media #{$sm-layout} {\n                    width: calc(100% - 30px);\n                }\n                .title {\n                    margin-bottom: 0;\n                    font-size: 20px;\n                    line-height: 32px;\n                    font-weight: 700;\n                }\n\n                .desc {\n                    display: inline-block;\n                    color: var(--color-body);\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 26px;\n                    transition: 0.4s;\n                    margin-bottom: 15px;\n                }\n                .team-share-info {\n                    a {\n                        width: 40px;\n                        height: 40px;\n                        line-height: 43px;\n                        display: inline-block;\n                        transition: all .45s cubic-bezier(.23,.88,.34,.99);\n    \n                        &:nth-child(1) {\n                            transition-delay: .07692s;\n                        }\n                        &:nth-child(2) {\n                            transition-delay: .15385s;\n                        }\n                        &:nth-child(3) {\n                            transition-delay: .23077s;\n                        }\n                        &:nth-child(4) {\n                            transition-delay: .31077s;\n                        }\n                    }\n\n                    &.bg-transparent {\n                        margin: -12px;\n                        a {\n                            background: transparent;\n                            color: var(--color-primary);\n                            width: auto;\n                            height: auto;\n                            line-height: inherit;\n                            margin: 12px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n   \n    &.eduvibe-hover-active {\n        .edu-instructor {\n            .inner {\n                .edu-instructor-info {\n                    opacity: 1;\n                    left: 20px;\n                    @media #{$sm-layout} {\n                        left: 0;\n                    }\n                }\n            }\n        }\n    }\n    &.edu-instructor-hover-visible {\n        &:hover {\n            .edu-instructor-info {\n                opacity: 1;\n                left: 20px;\n                @media #{$sm-layout} {\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n","/*------------------------\n    Service Style  \n--------------------------*/\n.service-wrapper-1 {\n    position: relative;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -28px;\n            left: -206px;\n        }\n        &.shape-image-2 {\n            top: -51px;\n            right: -257px;\n        }\n        &.shape-image-3 {\n            bottom: 80px;\n            right: -37px;\n        }\n        &.shape-image-4 {\n            bottom: -25px;\n            left: -201px;\n        }\n    }\n}\n\n.home-one-cat {\n    background-image: url(../../images/bg/home-one-service.jpg);\n}\n\n.service-card-1 {\n    background: var(--color-white);\n    overflow: hidden;\n    text-align: center;\n    position: relative;\n    transition: 0.4s;\n    &::after {\n        position: absolute;\n        content: \"\";\n        left: 0;\n        width: 0;\n        height: 2px;\n        background: var(--color-primary);\n        transition: 0.4s;\n        bottom: 0;\n    }\n    .inner {\n        .thumbnail {\n            a {\n                img {\n                    width: 100%;\n                }\n            }\n        }\n        .content {\n            padding: 30px;\n\n            @media #{$lg-layout} {\n                padding: 25px 20px;\n            }\n\n            @media #{$md-layout} {\n                padding: 25px 20px;\n            }\n\n            @media #{$sm-layout} {\n                padding: 25px 20px;\n            }\n\n            .course-total {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n                display: inline-block;\n                margin-bottom: 5px;\n                color: var(--color-primary);\n            }\n            .title {\n                margin-bottom: 20px;\n                \n                @media #{$lg-layout} {\n                    margin-bottom: 6px;\n                }\n\n                @media #{$md-layout} {\n                    margin-bottom: 6px;\n                }\n\n                @media #{$sm-layout} {\n                    margin-bottom: 6px;\n                }\n            }\n            .description {\n                margin-bottom: 0;\n            }\n        }\n    }\n    &:hover {\n        transform: translateY(-15px);\n        &::after {\n            width: 100%;\n        }\n    }\n}\n\n/*----------------------\n    Service Style Two  \n-----------------------*/\n.service-card-2 {\n    padding: 40px 30px;\n    background: #EAF8F6;\n    border-radius: 5px;\n    \n    @media #{$lg-layout} {\n        padding: 40px 20px;\n    }\n    \n    @media #{$md-layout} {\n        padding: 40px 20px;\n    }\n    \n    @media #{$sm-layout} {\n        padding: 40px 20px;\n    }\n    .inner {\n        text-align: center;\n        .icon {\n            position: relative;\n            display: inline-block;\n            a {\n                width: 80px;\n                height: 80px;\n                background: var(--color-white);\n                line-height: 80px;\n                text-align: center;\n                border-radius: 100%;\n                margin: 0 auto;\n                display: block;\n            }\n            img {\n                \n            }\n            .shape-list {\n                .shape {\n                    position: absolute;\n                    z-index: 2;\n                    &.shape-1 {\n                        bottom: 0;\n                        right: 0;\n                        transition: 0.4s;\n                        opacity: 0;\n                    }\n                    &.shape-2 {\n                        left: 0;\n                        top: 50%;\n                        transition: 0.4s;\n                        opacity: 0;\n                    }\n                    &.shape-3 {\n                        top: 0;\n                        right: 0;\n                        transition: 0.4s;\n                        opacity: 0;\n                    }\n                }\n            }\n        }\n        .content {\n            .title {\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 15px;\n                margin-top: 25px;\n            }\n            .description {\n                margin-bottom: 0;\n            }\n        }\n    }\n    \n    &.card-bg-2 {\n        background: #FFF3EE;\n    }\n    &.card-bg-3 {\n        background: #EFF4FC;\n    }\n    &.card-bg-4 {\n        background: #FFF1F1;\n    }\n\n    &:hover {\n        .inner {\n            .icon {\n                .shape-list {\n                    .shape {\n                        &.shape-1 {\n                            bottom: -8px;\n                            right: 3px;\n                            opacity: 1;\n                        }\n                        &.shape-2 {\n                            left: -20px;\n                            top: 50%;\n                            opacity: 1;\n                        }\n                        &.shape-3 {\n                            top: -5px;\n                            right: -1px;\n                            opacity: 1;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n\n/*----------------------\n    Service Style Three  \n-----------------------*/\n\n.video-section-overlayto-another {\n    position: relative;\n    margin-bottom: -281px;\n    z-index: 1;\n}\n\n.service-wrapper-3 {\n    position: relative;\n    z-index: 1;\n    padding-bottom: 281px;\n    .about-us-two-service-wrapper {\n        background-image: url(../../images/bg/about-us-two-service.jpg);\n    }\n}\n\n\n.service-card-3 {\n    padding: 30px 30px;\n    background: var(--color-white);\n    border-radius: 5px;\n    transition: 0.4s;\n    position: relative;\n    z-index: 2;\n    .inner {\n        text-align: center;\n        .icon {\n            position: relative;\n            display: inline-block;\n            margin-bottom: 25px;\n            a {\n                width: 70px;\n                height: 70px;\n                background: var(--color-primary);\n                text-align: center;\n                margin: 0 auto;\n                border-radius: 35px 35px 3px 3px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                i {\n                    font-size: 32px;\n                    color: var(--color-white);\n                }\n            }\n        }\n        .content {\n            .title {\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 15px;\n            }\n            .description {\n                margin-bottom: 20px;\n            }\n        }\n    }\n\n    &.shape-bg-1 {\n        .inner {\n            .icon {\n                a {\n                    background: rgba(113, 82, 233, .15);\n                    i {\n                        color: var(--color-tertiary-2);\n                    }\n                }\n            }\n        }\n        &:hover {\n            .inner {\n                .icon {\n                    a {\n                        background: var(--color-tertiary-2);\n                    }\n                }\n            }\n        }\n    }\n\n    &.shape-bg-2 {\n        .inner {\n            .icon {\n                a {\n                    background: rgba(255, 164, 27, .15);\n                    i {\n                        color: var(--color-tertiary);\n                    }\n                }\n            }\n        }\n        &:hover {\n            .inner {\n                .icon {\n                    a {\n                        background: var(--color-tertiary);\n                    }\n                }\n            }\n        }\n    }\n\n    &.shape-bg-3 {\n        .inner {\n            .icon {\n                a {\n                    background: rgba(82, 95, 225, .15);\n                    i {\n                        color: var(--color-primary);\n                    }\n                }\n            }\n        }\n        &:hover {\n            .inner {\n                .icon {\n                    a {\n                        background: var(--color-primary);\n                    }\n                }\n            }\n        }\n    }\n\n    &.shape-bg-4 {\n        .inner {\n            .icon {\n                a {\n                    background: rgba(248, 111, 3, .15);\n                    i {\n                        color: var(--color-secondary);\n                    }\n                }\n            }\n        }\n        &:hover {\n            .inner {\n                .icon {\n                    a {\n                        background: var(--color-secondary);\n                    }\n                }\n            }\n        }\n    }\n\n\n    &.text-left {\n        .inner {\n            text-align: left;\n        }\n    }\n    &.bg-grey {\n        background: #F5F5F5;\n        height: 100%;\n        &:hover {\n            background: var(--color-white);\n            box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.07);\n        }\n    }\n    &:hover {\n        transform: translateY(-20px);\n        box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.07);\n        .inner {\n            .icon {\n                a {\n                    i {\n                        color: #ffffff;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n/*-------------------------------\n    Service Style Four  \n---------------------------------*/\n\n.service-card-4 {\n    height: 100%;\n    .inner {\n        background: #F5F5F5;\n        border-radius: 5px;\n        padding: 40px 35px;\n        text-align: center;\n        transition: 0.4s;\n        height: 100%;\n\n        @media #{$lg-layout} {\n            padding: 25px 14px;\n        }\n\n        @media #{$md-layout} {\n            padding: 25px 14px;\n        }\n\n        @media #{$sm-layout} {\n            padding: 25px 14px;\n        }\n\n        .icon {\n            position: relative;\n            i {\n                display: block;\n                color: var(--color-primary);\n                font-size: 35px;\n            }\n            .subtitle {\n                opacity: 0;\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                transition: 0.4s;\n            }\n        }\n        .content {\n            .title {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 15px;\n                margin-top: 25px;\n                a {\n                    transition: 0.4s;\n                    color: var(--color-heading);\n                }\n            }\n            .description {\n                margin-bottom: 0;\n                transition: 0.4s;\n            }\n        }\n    }\n    &:hover {\n        .inner {\n            background: var(--color-primary);\n            .icon {\n                i {\n                    opacity: 0;\n                }\n                .subtitle {\n                    opacity: 1;\n                    color: var(--color-white);\n                }\n            }\n            .content {\n                .title {\n                    a {\n                        color: var(--color-white);\n                    }\n                }\n                .description {\n                    color: var(--color-white);\n                }\n            }\n        }\n    }\n}\n\n\n/*-------------------------------\n    Service Style Five  \n---------------------------------*/\n.service-card-5 {\n    .inner {\n        background: #F5F5F5;\n        border-radius: 5px;\n        padding: 20px;\n        transition: 0.4s;\n        display: flex;\n        align-items: center;\n        .icon {\n            position: relative;\n            width: 60px;\n            height: 60px;\n            display: flex;\n            align-items: center;\n            background: #FFFFFF;\n            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.02);\n            border-radius: 2px;\n            transition: 0.4s;\n            justify-content: center;\n            margin-right: 20px;\n            @media #{$lg-layout} {\n                margin-right: 15px;\n            }\n            i {\n                color: var(--color-primary);\n                font-size: 30px;\n                transition: 0.4s;\n            }\n        }\n        .content {\n            .title {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 0;\n                transition: 0.4s;\n                @media #{$lg-layout} {\n                    font-size: 17px;\n                    line-height: 28px;\n                }\n            }\n            .description {\n                margin-bottom: 0;\n                font-weight: 600;\n                font-size: 16px;\n                line-height: 26px;\n                transition: 0.4s;\n            }\n        }\n    }\n    &:hover {\n        .inner {\n            background: var(--color-primary);\n            .icon {\n                box-shadow: none;\n                background: rgba(255,255,255,0.15);\n                i {\n                    color: var(--color-white);\n                }\n            }\n            .content {\n                .title {\n                    a {\n                        color: var(--color-white);\n                    }\n                }\n                .description {\n                    color: var(--color-white);\n                }\n            }\n        }\n    }\n}\n\n/*-------------------------------\n    Service Style 8  \n---------------------------------*/\n\n.service-activation-item5 {\n    .single-slick-card {\n        margin-bottom: 20px;\n    }\n}\n\n\n\n.service-card-8 {\n    .inner {\n        background: #EAF8F6;\n        border-radius: 5px;\n        text-align: center;\n        padding: 30px;\n        position: relative;\n        transition: 0.4s;\n        margin-bottom: 20px;\n        .icon {\n            position: relative;\n            width: 75px;\n            height: 75px;\n            display: flex;\n            align-items: center;\n            background: #FFFFFF;\n            border-radius: 100%;\n            justify-content: center;\n            margin: 0 auto;\n        }\n\n        .content {\n            margin-top: 20px;\n            .title {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 28px;\n                margin-bottom: 5px;\n            }\n            span {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n            }\n        }\n\n        .hover-action {\n            position: absolute;\n            bottom: -20px;\n            left: 50%;\n            transform: translateX(-50%);\n            transition: 0.4s;\n            opacity: 0;\n            .read-more-btn {\n                width: 40px;\n                height: 40px;\n                background: var(--color-primary);\n                color: var(--color-white);\n                display: inline-block;\n                line-height: 43px;\n                border-radius: 100%;\n                font-size: 20px;\n            }\n        }\n    }\n\n    &.shape-bg-2 {\n        .inner {\n            background: #FFF3EE;\n        }\n    }\n\n    &.shape-bg-3 {\n        .inner {\n            background: #FAEFFA;\n        }\n    }\n\n    &.shape-bg-4 {\n        .inner {\n            background: #FFF1F1;\n        }\n    }\n    &.shape-bg-5 {\n        .inner {\n            background: #EFF4FC;\n        }\n    }\n\n\n    &:hover {\n        .inner {\n            padding-bottom: 50px;\n            margin-bottom: -20px;\n            .hover-action {\n                opacity: 1;\n            }\n        }\n    }\n}\n\n\n\n\n/*-------------------------------\n    Service Style 7  \n---------------------------------*/\n\n.service-card-single {\n    position: relative;\n    &:first-child {\n        &::after {\n            background-image: url(../../images/shape/arrow-down.png);\n            content: \"\";\n            width: 155px;\n            height: 43px;\n            right: -19%;\n            top: 40px;\n            background-size: cover;\n            background-position: center center;\n            position: absolute;\n            @media #{$md-layout} {\n                display: none;\n            }\n            @media #{$sm-layout} {\n                display: none;\n            }\n        }\n    }\n    &:last-child {\n        &::after {\n            background-image: url(../../images/shape/arrow-top.png);\n            content: \"\";\n            width: 155px;\n            height: 43px;\n            left: -19%;\n            top: 0;\n            background-size: cover;\n            background-position: center center;\n            position: absolute;\n            @media #{$md-layout} {\n                display: none;\n            }\n            @media #{$sm-layout} {\n                display: none;\n            }\n        }\n    }\n}\n.service-card-7 {\n    position: relative;\n    .arrow-icon {\n        position: absolute;\n        left: 100%;\n        top: 40px;\n        z-index: 1;\n    }\n\n\n    .inner {\n       text-align: center;\n        .icon {\n            position: relative;\n            width: 80px;\n            height: 80px;\n            display: flex;\n            align-items: center;\n            background: var(--color-secondary);\n            border-radius: 100%;\n            justify-content: center;\n            margin: 0 auto;\n            color: var(--color-white);\n            margin-bottom: 35px;\n            i {\n                color: var(--color-white);\n                font-size: 32px;\n                display: flex;\n            }\n        }\n\n        .content {\n            .title {\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 36px;\n                margin-bottom: 15px;\n            }\n            p {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n            }\n        }\n    }\n    &.shape-bg-2 {\n        .inner {\n            .icon {\n                background: var(--color-primary);\n            }\n        }\n    }\n\n    &.shape-bg-3 {\n        .inner {\n            .icon {\n                background: #FFA41B;\n            }\n        }\n    }\n    &:hover {\n        .inner {\n            \n        }\n    }\n}\n","/*-----------------------------\n    Single Elements Styles  \n------------------------------*/\n// Short By \n.short-by {\n    p {\n        margin: 0;\n        font-weight: 500;\n        font-size: 16px;\n        span {\n            font-weight: 600;\n            color: var(--color-heading);\n        }\n    }\n}\n\n// Search Box \n.edu-search-box {\n    position: relative;\n    display: inline-block;\n    input {\n        height: 60px;\n        background: var(--color-shade);\n        font-weight: 600;\n        font-size: 16px;\n        color: var(--color-body);\n        padding: 0 25px;\n        min-width: 350px;\n        border: 0 none;\n        border-radius: 5px;\n        padding-right: 48px;\n        @media #{$small-mobile} {\n            min-width: 100%;\n        }\n    }\n    .search-button {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 20px;\n        padding: 0;\n        border: 0 none;\n        background: transparent;\n        i {\n            font-size: 17px;\n        }\n    }\n}\n\n\n// Shoting Style One \n\n.edu-shorting-style-1 {\n    display: inline-block;\n    position: relative;\n    .icon {\n        display: flex;\n        align-items: center;\n        margin-right: 17px;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 22px;\n        i {\n            font-size: 20px;\n            color: var(--color-body);\n        }\n    }\n    .edu-select {\n        transition: 0.3s;\n        line-height: 28px;\n        outline: none;\n        color: var(--color-body);\n        -moz-appearance: none;\n        -webkit-appearance: none;\n        appearance: none;\n        border: 0 none;\n        border-radius: var(--radius);\n        font-size: 16px;\n        line-height: 28px;\n        font-weight: 400;\n        padding-right: 30px;\n        background: url(../../images/icons/arrow-icon.png) 92% center no-repeat transparent;\n        border-radius: 5px;\n        background-color: #F5F5F5;\n        max-width: 256px;\n        align-items: center;\n        padding: 0 30px;\n        height: 60px;\n        cursor: pointer;\n        min-width: 256px;\n        cursor: pointer;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*----------------------------\n    Course Sidebar Styles \n-----------------------------*/ \n.edu-course-widget {\n    background: var(--color-shade);\n    padding: 20px 30px 30px;\n    border-radius: 5px;\n    .widget-title {\n        border-bottom: 1px solid rgba(45,40,78,0.07);\n        padding-bottom: 20px;\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n    }\n    .content {\n        margin-top: 30px;\n\n        .edu-form-check {\n            position: relative;\n            & + .edu-form-check {\n                margin-top: 25px;\n            }\n        }\n    }\n    &.widget-category {\n        label {\n            display: flex;\n            justify-content: space-between;\n        }\n    }\n    \n}\n\n\n\n\n","/*--------------------------\n    Testimonial Area  \n----------------------------*/\n.satisfied-learner {\n    padding-right: 70px;\n    position: relative;\n\n    @media #{$lg-layout} {\n        padding-right: 0;\n    }\n\n    @media #{$md-layout} {\n        padding-right: 0;\n    }\n\n    @media #{$sm-layout} {\n        padding-right: 0;\n    }\n\n    .thumbnail {\n        img {\n            width: 100%;\n            border-radius: 5px;\n        }\n    }\n    .trophy-content {\n        width: 235px;\n        background: var(--color-white);\n        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n        display: flex;\n        border-radius: 5px;\n        padding: 20px 25px;\n        align-items: center;\n        position: absolute;\n        top: 97px;\n        left: -164px;\n\n        @media #{$lg-layout} {\n            top: auto;\n            left: 10px;\n            bottom: 10px;\n        }\n\n        @media #{$md-layout} {\n            top: auto;\n            left: 10px;\n            bottom: 10px;\n        }\n\n        @media #{$sm-layout} {\n            top: auto;\n            left: 10px;\n            bottom: 10px;\n        }\n\n        .icon {\n            min-width: 49px;\n            min-height: 49px;\n            object-fit: cover;\n            margin-right: 20px;\n        }\n\n        .content {\n            .text {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 34px;\n                margin-bottom: 0;\n            }\n\n            span {\n                font-weight: 600;\n                font-size: 14px;\n                line-height: 22px;\n            }\n        }\n    }\n}\n\n.testimonial-style-1 {\n    margin-top: 25px;\n    @media #{$smlg-device} {\n        margin-top: 0px;\n    }\n    &.edu-slick-button.slick-button-left .slick-dots {\n        @media #{$lg-layout} {\n            bottom: -10px;\n        }\n    }\n    .single-testimonial {\n        .inner {\n            .quote-sign {\n                margin-bottom: 50px;\n                display: inline-block;\n                @media #{$lg-layout} {\n                    margin-bottom: 20px;\n                }\n                @media #{$small-tablet} {\n                    margin-bottom: 20px;\n                    margin-top: 20px;\n                }\n\n            }\n\n            .description {\n                margin-bottom: 50px;\n                font-weight: 500;\n                font-size: 24px;\n                line-height: 1.5;\n                @media #{$small-tablet} {\n                    margin-bottom: 30px;\n                }\n                @media #{$sm-layout} {\n                    margin-bottom: 30px;\n                }\n            }\n\n            .client-information {\n                display: flex;\n                align-items: center;\n\n                .thumb {\n                    margin-right: 20px;\n                    min-width: 80px;\n\n                    img {\n                        width: 80px;\n                        height: 80px;\n                        border-radius: 100%;\n                        object-fit: cover;\n                    }\n                }\n\n                .info {\n                    .title {\n                        font-weight: 700;\n                        font-size: 24px;\n                        line-height: 36px;\n                        margin-bottom: 5px;\n                    }\n\n                    .designation {\n                        font-weight: 600;\n                        font-size: 16px;\n                        line-height: 26px;\n                        color: var(--color-primary);\n                    }\n                }\n            }\n        }\n    }\n}\n\n/*-----------------------------\n    Testimonial Card Layout  \n------------------------------*/\n\n.testimonial-card-box {\n    padding: 15px;\n   \n    .inner {\n        position: relative;\n        background: var(--color-white);\n        border-radius: 5px;\n        padding: 30px;\n        margin-bottom: 40px;\n\n        &::after {\n            position: absolute;\n            content: \"\";\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 33px 0 0 27px;\n            border-color: transparent transparent transparent var(--color-white);\n            top: calc(99% - 1px);\n            transform: rotate(90deg);\n            z-index: 2;\n            border-bottom-right-radius: 4px;\n        }\n\n        .description {\n            margin-bottom: 22px;\n        }\n\n        .client-info {\n            display: flex;\n            align-items: center;\n            margin-bottom: 22px;\n            .thumbnail {\n                margin-right: 15px;\n                img {\n                    max-height: 55px;\n                    height: 55px;\n                    object-fit: cover;\n                    border-radius: 3px;\n                }\n            }\n            .content {\n                .title {\n                    margin-bottom: 1px;\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 32px;\n                    @media #{$sm-layout} {\n                        font-size: 18px;\n                        line-height: 29px;\n                    }\n                }\n                .designation {\n                    color: var(--color-primary);\n                    font-weight: 500;\n                }\n            }\n        }\n    }\n\n\n    &.variation-2 {\n        @media #{$md-layout} {\n            padding: 0;\n        }\n        @media #{$sm-layout} {\n            padding: 0;\n        }\n        .inner {\n            padding: 50px;\n            margin-bottom: 0;\n            @media #{$sm-layout} {\n                padding: 50px 30px;\n            }\n            &::after {\n                display: none;\n            }\n            .rating {\n                margin-bottom: 40px;\n                @media #{$sm-layout} {\n                    margin-bottom: 20px;\n                }\n            }\n            .description {\n                margin-bottom: 40px;\n                font-weight: 500;\n                font-size: 20px;\n                line-height: 32px;\n                @media #{$sm-layout} {\n                    margin-bottom: 20px;\n                    font-size: 18px;\n                    line-height: 28px;\n                }\n            }\n            .client-info {\n                margin-bottom: 0;\n\n                @media #{$small-mobile} {\n                    display: block;\n                }\n                .thumbnail {\n                    margin-right: 20px;\n\n                    @media #{$small-mobile} {\n                        margin-right: 0;\n                        margin-bottom: 20px;\n                    }\n\n                    img {\n                        max-height: 60px;\n                        height: 60px;\n                        object-fit: cover;\n                        border-radius: 100%;\n                    }\n                }\n            }\n        }\n    }\n\n    &.variation-3 {\n        padding: 0;\n        .description {\n            margin-bottom: 64px;\n            font-size: 20px;\n            line-height: 32px;\n            font-weight: 400;\n            @media #{$sm-layout} {\n                margin-bottom: 30px;\n                font-size: 18px;\n                line-height: 28px;\n            }\n        }\n        .client-info {\n            display: flex;\n            align-items: center;\n            margin-bottom: 0;\n            .thumbnail {\n                margin-right: 15px;\n                img {\n                    max-height: 60px;\n                    height: 60px;\n                    object-fit: cover;\n                    border-radius: 100%;\n                }\n            }\n            .content {\n                .title {\n                    margin-bottom: 2px;\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 32px;\n                }\n                .designation {\n                    color: var(--color-primary);\n                    font-weight: 500;\n                }\n            }\n        }\n    }\n\n}\n\n.testimonial-style-5 {\n    position: relative;\n    &::before {\n        position: absolute;\n        content: \"\";\n        background: var(--color-primary);\n        width: 610px;\n        top: 0;\n        height: 100%;\n        left: 0;\n        @media #{$custom-lg-device-two} {\n            width: 29%;\n        }\n        @media #{$laptop-device} {\n            width: 27%;\n        }\n        @media #{$lg-layout} {\n            width: 29%;\n        }\n        @media #{$md-layout} {\n            display: none;\n        }\n        @media #{$sm-layout} {\n            display: none;\n        }\n    }\n    .banner-thumbnail {\n        display: inline-block;\n        position: relative;\n        z-index: 1;\n        &::after {\n            border: 5px solid rgba(251, 124, 86, 0.5);\n            position: absolute;\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            left: 20px;\n            border-radius: 250px;\n            z-index: -1;\n            @media #{$sm-layout} {\n                display: none;\n            }\n        }\n        img {\n            border-radius: 250px;\n        }\n    }\n    .content-wrapper {\n        position: relative;\n        z-index: 1;\n        .comment-images {\n            position: absolute;\n            right: 0;\n            z-index: -1;\n            bottom: -8%;\n        }\n    }\n    .main-image {\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n}\n\n\n/*--------------------------\n    Testimonial Style Two  \n----------------------------*/\n\n.testimonial-nav-content {\n    .description {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 32px;\n        margin-bottom: 30px;\n    }\n    .client-info {\n        margin-bottom: 40px;\n        @media #{$md-layout} {\n            margin-bottom: 10px;\n        }\n        @media #{$sm-layout} {\n            margin-bottom: 10px;\n        }\n        .title {\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 32px;\n            margin-bottom: 0;\n        }\n\n        .designation {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 26px;\n            color: var(--color-primary);\n        }\n    }\n}\n\n.testimonial-nav-wrapper {\n    max-width: 264px;\n}\n\n.testimonial-nav-button {\n    .single-thumbnail {\n        padding: 5px;\n        border: 5px solid transparent;\n        border-radius: 100%;\n        transition: 0.4s;\n        position: relative;\n        img {\n            max-width: 68px;\n            width: 68px;\n            display: inline-block;\n            height: 68px;\n            border: 8px solid #fff;\n            border-radius: 100%;\n            cursor: pointer;\n        }\n    }\n    .slick-current {\n        &.slick-active {\n            .single-thumbnail {\n                .loader-container {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n\n.loader-container {\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n    padding: 0;\n    opacity: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    .circle-loader-wrap {\n        overflow: hidden;\n        position: relative;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(82, 95, 225, 0.2);\n        border-radius: 100%;\n        -ms-transform: rotate(180deg);\n        -webkit-transform: rotate(180deg);\n        -moz-transform: rotate(180deg);\n        transform: rotate(180deg);\n\n        &:after {\n            content: '';\n            position: absolute;\n            left: 15px;\n            top: 15px;\n            width: auto;\n            height: auto;\n            border-radius: 50%;\n            background-color: white;\n        }\n\n        div {\n            overflow: hidden;\n            position: absolute;\n            width: 50%;\n            height: 100%;\n        }\n\n        .loader {\n            position: absolute;\n            left: 100%;\n            top: 0;\n            width: 100%;\n            height: 100%;\n            border-radius: 1000px;\n            background-color: var(--color-primary);\n        }\n\n        .left-wrap {\n            left: 0;\n\n            .loader {\n                border-top-left-radius: 0;\n                border-bottom-left-radius: 0;\n                transform-origin: 0 50% 0;\n                -webkit-transform-origin: 0 50% 0;\n                animation: loading-left 4s infinite linear;\n                -webkit-animation: loading-left 4s infinite linear;\n            }\n        }\n\n        .right-wrap {\n            left: 50%;\n\n            .loader {\n                left: -100%;\n                border-bottom-right-radius: 0;\n                border-top-right-radius: 0;\n                transform-origin: 100% 50% 0;\n                -webkit-transform-origin: 100% 50% 0;\n                animation: loading-right 4s infinite linear;\n                -webkit-animation: loading-right 4s infinite linear;\n            }\n\n            @keyframes loading-left {\n                0% {\n                    transform: rotate(0deg)\n                }\n\n                25% {\n                    transform: rotate(180deg)\n                }\n\n                50% {\n                    transform: rotate(180deg)\n                }\n\n                75% {\n                    transform: rotate(180deg)\n                }\n\n                100% {\n                    transform: rotate(180deg)\n                }\n            }\n\n            @-webkit-keyframes loading-left {\n                0% {\n                    -webkit-transform: rotate(0deg)\n                }\n\n                25% {\n                    -webkit-transform: rotate(180deg)\n                }\n\n                50% {\n                    -webkit-transform: rotate(180deg)\n                }\n\n                75% {\n                    -webkit-transform: rotate(180deg)\n                }\n\n                100% {\n                    -webkit-transform: rotate(180deg)\n                }\n            }\n\n            @keyframes loading-right {\n                0% {\n                    transform: rotate(0deg)\n                }\n\n                25% {\n                    transform: rotate(0deg)\n                }\n\n                50% {\n                    transform: rotate(180deg)\n                }\n\n                75% {\n                    transform: rotate(180deg)\n                }\n\n                100% {\n                    transform: rotate(180deg)\n                }\n            }\n\n            @-webkit-keyframes loading-right {\n                0% {\n                    -webkit-transform: rotate(0deg)\n                }\n\n                25% {\n                    -webkit-transform: rotate(0deg)\n                }\n\n                50% {\n                    -webkit-transform: rotate(180deg)\n                }\n\n                75% {\n                    -webkit-transform: rotate(180deg)\n                }\n\n                100% {\n                    -webkit-transform: rotate(180deg)\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n","/*---------------------\n Feature Styles  \n-------------------------*/\n.feature-list-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    margin: -15px;\n    .feature-list {\n        flex-basis: 50%;\n        padding: 15px;\n        @media #{$large-mobile} {\n            flex-basis: 100%;\n        }\n    }\n}\n\n.feature-list {\n    .icon {\n        margin-bottom: 25px;\n        i {\n            font-size: 50px;\n            color: var(--color-secondary);\n        }\n    }\n    .content {\n        .title {\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 32px;\n            margin-bottom: 10px;\n        }\n        p {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.feature-thumbnail {\n    position: relative;\n    z-index: 2;\n    right: -60px;\n    \n    @media #{$lg-layout} {\n        right: 0;\n    }\n\n    @media #{$md-layout} {\n        right: 0;\n    }\n\n    @media #{$sm-layout} {\n        right: 0;\n    }\n\n    .circle-image {\n        position: absolute;\n        top: -11px;\n        right: 7px;\n        z-index: -1;\n        width: 97%;\n        @media #{$sm-layout} {\n            display: none;\n        }\n    }\n}\n\n\n.radius-round {\n    border-radius: 100%;\n}\n\n\n\n\n\n\n\n\n\n\n\n/*----------------------\n Feature Style Two  \n-------------------------*/\n\n.feature-style-2 {\n    display: flex;\n    flex-wrap: wrap;\n    .single-feature {\n        flex-basis: 50%;\n        display: flex;\n        align-items: center;\n        margin-top: 25px;\n        flex-wrap: wrap;\n        .icon {\n            width: 40px;\n            min-width: 40px;\n            height: 40px;\n            background: rgba(251,124,86,0.15);\n            border-radius: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 15px;\n            i {\n                color: var(--color-secondary);\n            }\n        }\n        .content {\n            .feature-title {\n                font-size: 18px;\n                line-height: 28px;\n                font-weight: 700;\n                margin-bottom: 0;\n                @media #{$lg-layout} {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n}\n\n/*----------------------\n    Feature Style Three  \n-------------------------*/\n\n.feature-style-3 {\n    .feature-content {\n        .feature-title {\n            font-weight: 700;\n            font-size: 32px;\n            line-height: 44px;\n            color: var(--color-secondary);\n            margin-bottom: 5px;\n        }\n        .feature-description {\n            margin-bottom: 0;\n        }\n    }\n}\n\n\n/*----------------------\n    Feature Style Four  \n-------------------------*/\n\n.feature-style-4 {\n    .edu-feature-list {\n        display: flex;\n        .icon {\n            min-width: 60px;\n            width: 60px;\n            height: 60px;\n            border-radius: 100%;\n            background: rgba(251, 124, 86, 0.1);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 25px;\n            i {\n                color: var(--color-secondary);\n                font-size: 26px;\n            }\n        }\n        .content {\n            .title {\n                margin-bottom: 5px;\n            }\n            p {\n                margin-bottom: 30px;\n            }\n        }\n\n        &.color-var-2 { \n            .icon {\n                background: rgba(82,95,225, 0.1);\n                i {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n}\n\n\n/*----------------------\n    Feature Style 5  \n-------------------------*/\n\n.feature-style-5 {\n    .edu-feature-list {\n        display: flex;\n        .icon {\n            min-width: 60px;\n            width: 60px;\n            height: 60px;\n            border-radius: 100%;\n            background: var(--color-secondary);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 20px;\n            i {\n                color: var(--color-white);\n                font-size: 30px;\n            }\n        }\n        .content {\n            .title {\n                margin-bottom: 5px;\n            }\n            p {\n                margin-bottom: 0;\n            }\n        }\n\n        &.color-var-2 { \n            .icon {\n                background: #FFA41B;\n                i {\n                    color: var(--color-white);\n                }\n            }\n        }\n\n    }\n}\n\n\n\n/*----------------------\n    Feature Style 6  \n-------------------------*/\n\n.feature-style-6 {\n    .edu-feature-list {\n        display: flex;\n        .icon {\n            min-width: 60px;\n            width: 60px;\n            height: 60px;\n            border-radius: 100%;\n            background: rgba(251, 124, 86, 0.1);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 25px;\n            i {\n                color: var(--color-secondary);\n                font-size: 30px;\n            }\n        }\n        .content {\n            .title {\n                margin-bottom: 5px;\n            }\n            p {\n                margin-bottom: 30px;\n            }\n        }\n\n        &.color-var-2 { \n            .icon {\n                background: rgba(82,95,225, 0.1);\n                i {\n                    color: var(--color-primary);\n                }\n            }\n        }\n\n        &.color-variation-1 {\n            .icon {\n                background: rgba(255,164,27,0.1)\n            }\n        }\n\n        &.color-variation-2 {\n            .icon {\n                background: rgba(82,95,225,0.1)\n            }\n        }\n\n        &.color-variation-3 {\n            .icon {\n                background: rgba(251,124,86,0.1)\n            }\n        }\n\n    }\n}\n\n\n","/*------------------------\n    About Styles  \n-------------------------*/\n\n.about-feature-list {\n\t.our-feature {\n\t\tdisplay: flex;\n\t\t.icon {\n\t\t\twidth: 50px;\n\t\t\tmin-width: 50px;\n\t\t\theight: 50px;\n\t\t\tbackground: var(--color-secondary);\n\t\t\tdisplay: flex;\n\t\t\tborder-radius: 100%;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-right: 15px;\n\n\t\t\ti {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tfont-size: 24px;\n\t\t\t}\n\t\t}\n\t\t.feature-content {\n\t\t\t.feature-title {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 32px;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\t\t\t.feature-description {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t& + .our-feature {\n\t\t\tmargin-top: 30px;\n\t\t}\n\t}\n}\n\n/*----------------------\n    About Style One  \n------------------------*/\n\n.about-style-1 {\n\tposition: relative;\n\tz-index: 1;\n\t.about-image-gallery {\n\t\tmargin-right: 100px;\n\t\tposition: relative;\n\t\t@media #{$lg-layout} {\n\t\t\tmargin-right: 60px;\n\t\t}\n\t\t@media #{$md-layout} {\n\t\t\tmargin-right: 60px;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tmargin-right: 0;\n\t\t}\n\t\t.image-1 {\n\t\t\tborder-radius: 5px;\n\t\t\twidth: 100%;\n\t\t}\n\t\t.image-2 {\n\t\t\tposition: absolute;\n\t\t\tbottom: -61px;\n\t\t\tright: -50px;\n\t\t\tborder-radius: 5.2px;\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: 0;\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\ttransform: none !important;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\n\t\t\timg {\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t}\n\t\t.badge-inner {\n\t\t\tposition: absolute;\n\t\t\ttop: 42px;\n\t\t\tleft: -75px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\tpadding: 10px;\n\t\t\tbackground: rgba(255, 255, 255, 0.5);\n\t\t\tbackdrop-filter: blur(8px);\n\t\t\tborder-radius: 100%;\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.image-3 {\n\t\t\t\tanimation: rotateIt 7s linear infinite;\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t}\n\t\t.shape-image-1 {\n\t\t\tposition: absolute;\n\t\t\tbottom: -35px;\n\t\t\tleft: -35px;\n\t\t\tz-index: -1;\n\t\t}\n\t}\n\t.inner {\n\t\t.description {\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tpadding-left: 17px;\n\t\t\tposition: relative;\n\t\t\tmargin-top: 40px;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"\";\n\t\t\t\tleft: 0;\n\t\t\t\twidth: 2px;\n\t\t\t\theight: 46px;\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t}\n\t\t}\n\t\t.read-more-btn {\n\t\t\tmargin-top: 40px;\n\t\t}\n\t\t.about-parallax-2 {\n\t\t\tposition: absolute;\n\t\t\tright: 88px;\n\t\t\ttop: 379px;\n\t\t\tanimation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n\t\t\t@media #{$laptop-device} {\n\t\t\t\tright: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*----------------------\n    About Style Two  \n------------------------*/\n.about-style-2 {\n\tposition: relative;\n\t.about-image-gallery {\n\t\tposition: relative;\n\t\t.eduvibe-about-1-img-wrapper {\n\t\t\tposition: relative;\n\t\t\t.image-1 {\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-left: -40px;\n\t\t\t\twidth: 460px;\n\t\t\t\tmin-width: 460px;\n\t\t\t\theight: 460px;\n\t\t\t\tmin-height: 460px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tz-index: 3;\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmin-width: auto;\n\t\t\t\t\tmin-height: auto;\n\t\t\t\t\theight: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.eduvibe-about-blur img {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: -50px;\n\t\t\t\twidth: 739px;\n\t\t\t\theight: 739px;\n\t\t\t\tz-index: 0;\n\t\t\t\ttop: -140px;\n\t\t\t\t@media #{$smlg-device} {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.image-2 {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tz-index: 1;\n\t\t\tborder-radius: 100%;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tright: 101px;\n\t\t\t}\n\t\t}\n\t\t.finished-session {\n\t\t\tbackground: var(--color-white);\n\t\t\tbox-shadow: 0px 10px 35px rgba(0, 0, 0, 0.05);\n\t\t\twidth: 170px;\n\t\t\theight: 170px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 100%;\n\t\t\tposition: absolute;\n\t\t\tleft: -120px;\n\t\t\ttop: 8%;\n\t\t\tz-index: 3;\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tleft: 0;\n\t\t\t\ttop: -9%;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tleft: 0;\n\t\t\t\ttop: -9%;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t\twidth: 120px;\n\t\t\t\theight: 120px;\n\t\t\t}\n\n\t\t\t.inner {\n\t\t\t\t.text {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\tline-height: 44px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\t\tline-height: 29px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.finished-title {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 26px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.circle-image-wrapper {\n\t\tposition: absolute;\n\t\twidth: 272px;\n\t\theight: 272px;\n\t\tright: 52px;\n\t\tbottom: -57px;\n\t\tz-index: 3;\n\t\t.circle-image {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 272px;\n\t\t\theight: 272px;\n\t\t\tz-index: -1;\n\t\t\tspan {\n\t\t\t\tborder-color: #ffa41b;\n\t\t\t\tleft: 26px;\n\t\t\t\t@media #{$small-tablet} {\n\t\t\t\t\tleft: -51px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tdisplay: none;\n\t\t}\n\t\t@media #{$laptop-device} {\n\t\t\tright: 30px;\n\t\t}\n\t}\n}\n\n.circle-image-wrapper {\n\tposition: relative;\n\tdisplay: inline-block;\n\tz-index: 1;\n\t.circle-image {\n\t\tz-index: -1;\n\t}\n}\n\n/*----------------------\n    About Style 3  \n------------------------*/\n.about-style-3 {\n\tposition: relative;\n\t.gappery-wrapper {\n\t\t.gallery-image {\n\t\t\tposition: relative;\n\t\t\timg {\n\t\t\t\tborder-radius: 5.2px;\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.icon-badge {\n\t\t\t\twidth: 60px;\n\t\t\t\theight: 60px;\n\t\t\t\tbackground: var(--color-primary);\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -30px;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX(-50%);\n\n\t\t\t\ti {\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.gallery-image-3 {\n\t\t\t\t.student-like-status {\n\t\t\t\t\tbackground: #ffffff;\n\t\t\t\t\tbox-shadow: 0px 10px 25px rgba(0, 0, 0, 0.08);\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: -25px;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\n\t\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\ttop: auto;\n\t\t\t\t\t\ttransform: none;\n\t\t\t\t\t\tbottom: 10px;\n\t\t\t\t\t}\n\t\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\ttop: auto;\n\t\t\t\t\t\ttransform: none;\n\t\t\t\t\t\tbottom: 10px;\n\t\t\t\t\t}\n\t\t\t\t\t.inner {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tpadding: 16px 15px;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\t\theight: 40px;\n\t\t\t\t\t\t\tbackground: rgba(251, 124, 86, 0.5);\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\t\ti {\n\t\t\t\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.content {\n\t\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\t\t.title {\n\t\t\t\t\t\t\t\tcolor: var(--color-secondary);\n\t\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.subtitle {\n\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tline-height: 22px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*----------------------\n    About Style 4  \n------------------------*/\n.about-style-4 {\n\tposition: relative;\n\t.gallery-wrapper {\n\t\tposition: relative;\n\t\ttext-align: center;\n\t\tmargin-right: 120px;\n\t\tmargin-left: -50px;\n\t\tz-index: 2;\n\t\t@media #{$lg-layout} {\n\t\t\ttext-align: left;\n\t\t\tmargin-left: 130px;\n\t\t\tmargin-right: 0;\n\t\t}\n\t\t@media #{$md-layout} {\n\t\t\tmargin-right: 50px;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tmargin-right: 0;\n\t\t\tmargin-left: 0;\n\t\t\ttext-align: left;\n\t\t}\n\t\timg {\n\t\t\tborder-radius: 5px;\n\t\t}\n\t\t.image-1 {\n\t\t\t@media #{$sm-layout} {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t.image-2 {\n\t\t\tposition: absolute;\n\t\t\tleft: -95px;\n\t\t\tz-index: -1;\n\t\t\ttop: 88px;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tleft: -120px;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tleft: 3%;\n\t\t\t}\n\t\t}\n\t\t.image-3 {\n\t\t\tposition: absolute;\n\t\t\tright: -73px;\n\t\t\tbottom: 100px;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tleft: 370px;\n\t\t\t\tright: inherit;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tright: 0;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\timg {\n\t\t\t\tborder: 3px solid #ffffff;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*----------------------\n    About Style 6  \n------------------------*/\n\n.about-style-6 {\n\t.about-image-gallery {\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\timg {\n\t\t\tborder-radius: 265px 265px 5px 5px;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tborder-radius: 500px 500px 0 0;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tborder-radius: 500px 500px 0 0;\n\t\t\t}\n\t\t}\n\t\t.badge-icon {\n\t\t\tposition: absolute;\n\t\t\tbottom: 173px;\n\t\t\tleft: -75px;\n\t\t\twidth: 130px;\n\t\t\theight: 130px;\n\t\t\tbackground: #ffffff;\n\t\t\tborder-radius: 100%;\n\t\t\tpadding: 5px;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tbottom: auto;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tbottom: auto;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tbottom: auto;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t}\n\n\t\t\t.badge-inner {\n\t\t\t\tpadding: 5px;\n\t\t\t\tbackground: #fb7c56;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\theight: 100%;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t&::after {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tbackground: var(--color-white);\n\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t}\n\t\t\t\timg {\n\t\t\t\t\tanimation: rotateIt 7s linear infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\tborder: 5px solid var(--color-secondary);\n\t\t\twidth: 97%;\n\t\t\theight: 95%;\n\t\t\tleft: 40px;\n\t\t\tbottom: -20px;\n\t\t\tborder-radius: 265px 265px 5px 5px;\n\t\t\tz-index: -1;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tborder-radius: 500px 500px 0 0;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\t.inner {\n\t\t@media #{$lg-layout} {\n\t\t\tpadding-left: 40px;\n\t\t}\n\t\t.feature-list-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tmargin: 0;\n\t\t\tmargin-top: -30px;\n\t\t\t.feature-list {\n\t\t\t\tflex-basis: 50%;\n\t\t\t\tpadding: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tcolor: var(--color-heading);\n\t\t\t\tmargin-top: 30px;\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tflex-basis: 100%;\n\t\t\t\t\tmargin-top: 15px;\n\t\t\t\t}\n\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tmargin-top: 15px;\n\t\t\t\t}\n\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tmargin-top: 15px;\n\t\t\t\t}\n\n\t\t\t\t@media #{$large-mobile} {\n\t\t\t\t\tflex-basis: 100%;\n\t\t\t\t}\n\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 14px;\n\t\t\t\t\tcolor: var(--color-secondary);\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.info-btn {\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tcolor: var(--color-heading);\n\t\t\tmargin-left: 30px;\n\t\t\ttransition: 0.4s;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tmargin-left: 10px;\n\t\t\t}\n\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-top: 20px;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-secondary);\n\t\t\t}\n\t\t\ti {\n\t\t\t\twidth: 60px;\n\t\t\t\theight: 60px;\n\t\t\t\tline-height: 60px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\ttext-align: center;\n\t\t\t\tmargin-right: 15px;\n\t\t\t\tbackground: rgba(251, 124, 86, 0.15);\n\t\t\t\tcolor: var(--color-secondary);\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.edu-mission-vision-area {\n\t.thumbnail {\n\t\tmargin: -15px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\t@media #{$md-layout} {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\t\timg {\n\t\t\tborder-radius: 5px;\n\t\t}\n\t\t.shape-image {\n\t\t\tpadding: 15px;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tflex-basis: 50%;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tflex-basis: 50%;\n\t\t\t}\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tflex-basis: 100%;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.eduvibe-about-three-mission {\n\t.thumbnail img {\n\t\t@media #{$small-tablet} {\n\t\t\ttransform: none !important;\n\t\t}\n\t}\n}\n\n/*----------------------\n    Why Choose Us 1\n------------------------*/\n.edu-choose-us-area-one {\n\t.thumbnail {\n\t\tmargin-left: -151px;\n\t\tmargin-right: -76px;\n\t\tmargin-top: -50px;\n\t\t@media #{$custom-laptop-device} {\n\t\t\tmargin-left: -60px;\n\t\t}\n\t\t@media #{$smlg-device} {\n\t\t\tmargin-left: -120px;\n\t\t\tmargin-right: 0;\n\t\t}\n\t\t@media #{$small-tablet} {\n\t\t\tmargin-left: 0;\n\t\t\tmargin-right: 0;\n\t\t\tmargin-top: 0;\n\t\t}\n\t}\n\t&.edu-section-gap {\n\t\tpadding: 180px 0 130px !important;\n\t\t@media #{$md-layout} {\n\t\t\tpadding: 80px 0 !important;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tpadding: 80px 0 !important;\n\t\t}\n\t}\n}\n","/*-------------------------\n    Newsletter Styles  \n-------------------------*/\n.newsletter-form-style-1 {\n\t.input-box {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\t@media #{$sm-layout} {\n\t\t\tdisplay: block;\n\t\t}\n\t\tinput {\n\t\t\theight: 60px;\n\t\t\tbackground: var(--color-white);\n\t\t\tborder: 0 none;\n\t\t\tpadding: 0 52px;\n\t\t\tmin-width: 570px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tborder-radius: 5px;\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmin-width: 100%;\n\t\t\t\theight: 60px;\n\t\t\t}\n\t\t\t&.large-input-box {\n\t\t\t\theight: 80px;\n\t\t\t\tmin-width: 670px;\n\t\t\t\tpadding-right: 190px;\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tmin-width: 100%;\n\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.mail-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\tleft: 12px;\n\t\t\tfont-size: 16px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t\t.send-button {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\tright: 27px;\n\t\t\tborder: 0 none;\n\t\t\tpadding: 0;\n\t\t\tbackground: transparent;\n\t\t\ti {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t.edu-btn {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\tright: 10px;\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tposition: static;\n\t\t\t\ttransform: none;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-top: 20px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Newsletter Style 2\n\n.newsletter-style-2 {\n\tposition: relative;\n\tinput {\n\t\theight: 60px;\n\t\tbackground: var(--color-white);\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n\t\tline-height: 26px;\n\t\tcolor: var(--color-body);\n\t\tborder-radius: 5px;\n\t\tborder: 0 none;\n\t\tpadding-right: 146px;\n\t}\n\t.subscribe-btn {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tpadding: 5px;\n\t\tz-index: 2;\n\t}\n}\n\n// Newsletter Style 3\n.newsletter-style-3 {\n\tbackground-image: url(../../images/bg/home-two-cta.jpg);\n\tposition: relative;\n\t.contact-info {\n\t\tmargin-left: 43px;\n\t\t@media #{$large-mobile} {\n\t\t\tmargin-left: 0;\n\t\t\tmargin-top: 20px;\n\t\t}\n\t\ta {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 28px;\n\t\t\tcolor: var(--color-white);\n\t\t\ttransition: 0.4s;\n\t\t\tposition: relative;\n\t\t\tdisplay: inline-block;\n\t\t\tz-index: 1;\n\t\t\t&::after {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"\";\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\twidth: 0;\n\t\t\t\theight: 2px;\n\t\t\t\tbackground: var(--color-white);\n\t\t\t\ttransition: 0.3s;\n\t\t\t}\n\t\t\ti {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\t&::after {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Newsletter Style 5\n.newsletter-style-5 {\n\tposition: relative;\n\tz-index: 1;\n\tborder-radius: 5px;\n\tmin-width: 1400px;\n\tpadding: 100px 115px;\n\tbackground-image: url(../../images/bg/newsletter-home-4-bg.jpg);\n\n\t@media #{$laptop-device} {\n\t\tmin-width: auto;\n\t}\n\t@media #{$lg-layout} {\n\t\tmin-width: auto;\n\t\tpadding: 50px 40px;\n\t}\n\t@media #{$md-layout} {\n\t\tmin-width: auto;\n\t\tpadding: 50px 40px;\n\t}\n\t@media #{$sm-layout} {\n\t\tmin-width: auto;\n\t\tpadding: 50px 40px;\n\t}\n}\n\n.newsletter-overlay-to-another {\n\tposition: relative;\n\tmargin-top: -145px;\n\t@media #{$small-tablet} {\n\t\tmargin-top: -80px;\n\t}\n}\n\n.newsletter-to-top {\n\tpadding-top: 273px !important;\n\t@media #{$lg-layout} {\n\t\tpadding-top: 224px !important;\n\t}\n\t@media #{$sm-layout} {\n\t\tpadding-top: 224px !important;\n\t}\n}\n","/*---------------------------\n    Social Share Style\n---------------------------*/\n.social-share {\n    margin: -7px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    li {\n        margin: 7px;\n        a {\n            background: rgba(255, 255, 255, 0.1);\n            border-radius: 4px;\n            width: 50px;\n            height: 50px;\n            line-height: 55px;\n            display: inline-block;\n            font-size: 18px;\n            color: var(--color-white);\n            transition: 0.4s;\n            text-align: center;\n            &:hover {\n                background: var(--color-primary);\n                color: var(--color-white);\n            }\n        }\n    }\n\n    &.bg-transparent {\n        li {\n            a {\n                background: transparent;\n                border: 1px solid rgba(45,40,78,0.1);\n                color: var(--color-primary);\n                border-radius: 100%;\n                &:hover {\n                    border-color: var(--color-primary);\n                    background: var(--color-primary);\n                    color: var(--color-white);\n                }\n            }\n        }\n    }\n\n    &.icon-transparent {\n        margin: 0 -15px;\n        li {\n            margin: 0 15px;\n            a {\n                background: transparent;\n                height: auto;\n                width: auto;\n                color: var(--color-body);\n                transition: 0.4s;\n                line-height: initial;\n                &:hover {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n    &.border-style {\n        margin: 0 -7px;\n        li {\n            margin: 0 7px;\n            a {\n                background: transparent;\n                height: 40px;\n                width: 40px;\n                color: var(--color-primary);\n                transition: 0.4s;\n                line-height: 42px;\n                text-align: center;\n                border: 1px solid rgba(45,40,78,0.1);\n                border-radius: 100%;\n                font-size: 16px;\n                &:hover {\n                    color: var(--color-white);\n                    background: var(--color-primary);\n                    border-color: var(--color-primary);\n                }\n            }\n        }\n    }\n    &.medium-size {\n        li {\n            a {\n                width: 40px;\n                height: 40px;\n                line-height: 42px;\n                font-size: 16px;\n            }\n        }\n    }\n}\n\n\n","/*-------------------------\n    Back To Top  \n---------------------------*/\n@-webkit-keyframes border-transform {\n    0%,\n    100% {\n        border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%;\n    }\n\n    14% {\n        border-radius: 40% 60% 54% 46% / 49% 60% 40% 51%;\n    }\n\n    28% {\n        border-radius: 54% 46% 38% 62% / 49% 70% 30% 51%;\n    }\n\n    42% {\n        border-radius: 61% 39% 55% 45% / 61% 38% 62% 39%;\n    }\n\n    56% {\n        border-radius: 61% 39% 67% 33% / 70% 50% 50% 30%;\n    }\n\n    70% {\n        border-radius: 50% 50% 34% 66% / 56% 68% 32% 44%;\n    }\n\n    84% {\n        border-radius: 46% 54% 50% 50% / 35% 61% 39% 65%;\n    }\n}\n\n.paginacontainer {\n    height: 3000px;\n}\n\n.rn-progress-parent {\n    position: fixed;\n    right: 30px;\n    bottom: 30px;\n    height: 46px;\n    width: 46px;\n    cursor: pointer;\n    display: block;\n    border-radius: 50px;\n    box-shadow: inset 0 0 0 2px #f8e3c3;\n    z-index: 10000;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(15px);\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n\n    &.rn-backto-top-active {\n        opacity: 1;\n        visibility: visible;\n        transform: translateY(0);\n    }\n\n    &::after {\n        position: absolute;\n        font-family: 'icomoon' !important;\n        content: \"\\e90f\";\n        text-align: center;\n        line-height: 46px;\n        font-size: 24px;\n        color: var(--color-tertiary);\n        left: 0;\n        top: 0;\n        height: 46px;\n        width: 46px;\n        cursor: pointer;\n        display: block;\n        z-index: 2;\n        -webkit-transition: all 200ms linear;\n        transition: all 200ms linear;\n    }\n\n    &:hover {\n        &::after {\n            color: var(--color-tertiary);\n        }\n    }\n\n    &::before {\n        position: absolute;\n        font-family: 'feather' !important;\n        content: \"\\e914\";\n        text-align: center;\n        line-height: 46px;\n        font-size: 24px;\n        opacity: 0;\n        background: #0d0d12;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        left: 0;\n        top: 0;\n        height: 46px;\n        width: 46px;\n        cursor: pointer;\n        display: block;\n        z-index: 2;\n        -webkit-transition: all 200ms linear;\n        transition: all 200ms linear;\n    }\n    svg {\n        path {\n            fill: none;\n        }\n        &.rn-back-circle {\n            path {\n                stroke: var(--color-tertiary);\n                stroke-width: 4;\n                box-sizing: border-box;\n                -webkit-transition: all 200ms linear;\n                transition: all 200ms linear;\n            }\n        }\n    }\n}","/*--------------------------\n    Workshop Style One  \n----------------------------*/\n\n.workshop-style-1 {\n    .workshop-inner {\n        .description {\n            color: var(--color-white);\n            margin-top: 40px;\n            margin-bottom: 40px;\n            @media #{$md-layout} {\n                margin-top: 20px;\n                margin-bottom: 20px;\n            }\n            @media #{$sm-layout} {\n                margin-top: 20px;\n                margin-bottom: 20px;\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n","/*--------------------------\n    Video Popup Styles  \n----------------------------*/\n.video-gallery-1 {\n    padding: 8px;\n    background: var(--color-white);\n    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.07);\n    border-radius: 10px;\n}\n\n.video-popup-wrapper {\n    position: relative;\n    &.video-popup-two {\n        img {\n            -webkit-mask-image: url(../../images/shapes/mask-shape-1.png);\n            mask-image: url(../../images/shapes/mask-shape-1.png);\n            -webkit-mask-repeat: no-repeat;\n            mask-repeat: no-repeat;\n            -webkit-mask-size: contain;\n            mask-size: contain;\n            -webkit-mask-position: center center;\n            mask-position: center center;\n        }\n    }\n\n    .position-to-top {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    img {\n        border-radius: 5px;\n    }\n}\n\n.video-play-btn {\n    border: 0;\n    width: 50px;\n    height: 50px;\n    margin-left: -30px;\n    margin-top: -30px;\n    transition: all 1s cubic-bezier(0, 0, .2, 1);\n    position: relative;\n    border-radius: 100%;\n    background: var(--color-white);\n    margin: 0 auto;\n    display: inline-block;\n\n    &.with-animation {\n\n        &::after,\n        &::before {\n            content: '';\n            display: block;\n            position: absolute;\n            top: 0;\n            right: 0;\n            z-index: -1;\n            bottom: 0;\n            left: 0;\n            -webkit-transition: var(--transition);\n            transition: var(--transition);\n            border-radius: 50%;\n            border: 1.2px solid var(--color-white);\n        }\n        &::before {\n            -webkit-animation: ripple 2s linear infinite;\n            animation: ripple 2s linear infinite;\n        }\n\n        &::after {\n            -webkit-animation: ripple 2s linear 1s infinite;\n            animation: ripple 2s linear 1s infinite;\n        }\n    }\n\n    &.size-60 {\n        width: 60px;\n        height: 60px;\n        font-size: 20px;\n        @media #{$sm-layout} {\n            width: 50px;\n            height: 50px;\n            font-size: inherit;\n        }\n        @media #{$large-mobile} {\n            width: 45px;\n            height: 45px;\n        }\n    }\n\n    &.size-80 {\n        width: 80px;\n        height: 80px;\n        font-size: 24px;\n        @media #{$smlg-device} {\n            width: 60px;\n            height: 60px;\n            font-size: 20px;\n        }\n        @media #{$sm-layout} {\n            width: 50px;\n            height: 50px;\n            font-size: inherit;\n        }\n        @media #{$large-mobile} {\n            width: 45px;\n            height: 45px;\n        }\n    }\n\n    .play-icon {\n        position: absolute;\n        display: block;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            width: 0;\n            height: 0;\n            transform: translate(-6px, -9px);\n            border-top: 9px solid transparent;\n            border-bottom: 9px solid transparent;\n            border-left: 15px solid var(--color-primary);\n        }\n    }\n\n    &.btn-large {\n        width: 60px;\n        height: 60px;\n        margin-left: 0;\n        margin-top: 0;\n    }\n\n    &.btn-theme-color {\n        color: #ffffff;\n        background: var(--color-primary);\n\n        &::after {\n            border-color: var(--color-primary);\n        }\n\n        &::before {\n            border-color: var(--color-primary);\n        }\n\n        .play-icon {\n            &::before {\n                border-left: 15px solid var(--color-white);\n            }\n        }\n    }\n\n    &.btn-secondary-color {\n        color: #ffffff;\n        background: var(--color-secondary);\n\n        &::after {\n            border-color: var(--color-secondary);\n        }\n\n        &::before {\n            border-color: var(--color-secondary);\n        }\n\n        .play-icon {\n            &::before {\n                border-left: 15px solid var(--color-white);\n            }\n        }\n    }\n}\n\n\n.video-style-2 {\n    position: relative;\n    z-index: 1;\n    &::after {\n        position: absolute;\n        content: \"\";\n        background: var(--color-white);\n        top: 0;\n        right: 0;\n        height: 100%;\n        width: calc( 50% + 250px );\n        z-index: -1;\n        border-radius: 10px 0px 0px 10px;\n\n        @media #{$small-tablet} {\n            display: none;\n        }\n    }\n    .side-shape-image {\n        position: absolute;\n        right: 0%;\n        top: 50%;\n        transform: translateY(-50%) translateX(50%);\n        img {\n            animation: eduvibe-rotate-x 30s infinite linear;\n        }\n        @media #{$lg-layout} {\n            display: none;\n        }\n    }\n}\n\n\n/*keyframes-css*/\n@-webkit-keyframes ripple {\n    0% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    75% {\n        -webkit-transform: scale(2.1);\n        transform: scale(2.1);\n        opacity: 1;\n    }\n\n    100% {\n        -webkit-transform: scale(2.3);\n        transform: scale(2.3);\n        opacity: 0;\n    }\n}\n\n@keyframes ripple {\n    0% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    75% {\n        -webkit-transform: scale(2.1);\n        transform: scale(2.1);\n        opacity: 1;\n    }\n\n    100% {\n        -webkit-transform: scale(2.3);\n        transform: scale(2.3);\n        opacity: 0;\n    }\n}\n\n\n@-webkit-keyframes btnIconRipple {\n    0% {\n        border-width: 4px;\n        -webkit-transform: scale(1);\n        transform: scale(1)\n    }\n\n    80% {\n        border-width: 1px;\n        -webkit-transform: scale(1.35);\n        transform: scale(1.35)\n    }\n\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes btnIconRipple {\n    0% {\n        border-width: 4px;\n        -webkit-transform: scale(1);\n        transform: scale(1)\n    }\n\n    80% {\n        border-width: 1px;\n        -webkit-transform: scale(1.35);\n        transform: scale(1.35)\n    }\n\n    100% {\n        opacity: 0\n    }\n}","/*------------------------------\n    Choose Us Style  \n-------------------------------*/\n\n.choose-us-style-1 {\n    position: relative;\n    .inner {\n        .section-title {\n            .title {\n                margin-bottom: 40px;\n            }\n        }\n    }\n    .chosse-us-thumbnail {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 236px;\n    }\n    .right-side-thumb {\n        margin-right: -149px;\n        @media #{$small-tablet} {\n            margin-right: 0;\n        }\n    }\n}\n\n.eduvibe-home-two-counter {\n    .choose-us-2 {\n        @media #{$small-tablet} {\n            margin-top: 25px;\n        }\n    }\n}","/*----------------------------\n    Call To Action Styles  \n-----------------------------*/\n\n\n.call-action-style-1 {\n    padding-top: 24px;\n    padding-left: 50px;\n    .inner {\n        .content {\n            .pre-title {\n                letter-spacing: 0.05em;\n                text-transform: uppercase;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 18px;\n                display: block;\n                margin-bottom: 5px;\n            }\n            .title {\n                font-size: 24px;\n                line-height: 36px;\n            }    \n        }\n    }\n    .thumbnail {\n        position: relative;\n        z-index: 1;\n        .shape-image {\n            position: absolute;\n            top: 18px;\n            right: 13px;\n            z-index: -1;\n        }\n        img.main-img {\n            @media #{$lg-layout} {\n                margin-bottom: -15px;\n            }\n        }\n    }\n    &.box-layout {\n        padding: 46px 50px;\n        position: relative;\n        .inner {\n            .shape-image-2 {\n                position: absolute;\n                top: 26px;\n                right: 30px;\n                pointer-events: none;\n                @media #{$large-mobile} {\n                    display: none;\n                }\n            }\n        }\n    }\n}","/*-----------------------\n    Slick Slider  \n-------------------------*/\n.edu-testimonial-activation {\n    &.edu-slick-button {\n        margin-bottom: 62px;\n        .edu-slick-button .slick-dots {\n            bottom: -74px;\n        }\n    }\n}\n\n\n.course-activation-item-2 .edu-slick-button .slick-dots {\n    bottom: -45px;\n}\n\n.slick-activation-wrapper {\n    margin: 0 -15px;\n    position: relative;\n    @media #{$large-mobile} {\n        margin: 0;\n    }\n    .single-slick-card {\n        padding: 0 15px;\n        @media #{$large-mobile} {\n            padding: 0;\n        }\n    }\n}\n\n.single-slick-card {\n    .edu-card.card-type-5 {\n        box-shadow: none;\n    }\n}\n\n\n.edu-slick-button {\n    .slick-dots {\n        bottom: -84px;\n        @media #{$md-layout} {\n            bottom: -60px;\n        }\n        @media #{$sm-layout} {\n            bottom: -60px;\n        }\n        margin: 0 -7px;\n        li {\n            width: 24px;\n            height: 24px;\n            border-radius: 100%;\n            padding: 0;\n            transition: 0.4s;\n            line-height: 24px;\n            position: relative;\n            margin: 0 1px;\n            display: inline-block;\n            &::before {\n                border: 2px solid transparent;\n                position: absolute;\n                content: \"\";\n                width: 100%;\n                height: 100%;\n                transition: 0.2s;\n                opacity: 0;\n                border-radius: 100%;\n                left: 0;\n                top: 0;\n                transform: scale(0.2);\n            }\n            &.slick-active {\n                margin: 0 3px;\n            }\n\n            button {\n                width: 10px;\n                height: 10px;\n                background: rgba(82, 95, 225, 0.5);\n                border-radius: 100%;\n                padding: 0;\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translateY(-50%) translateX(-50%);\n                &::before {\n                    display: none;\n                }\n            }\n\n            &.slick-active {\n                &::before {\n                    border-color: var(--color-primary);\n                    opacity: 1;\n                    transform: scale(1);\n                }\n                button {\n                    background: var(--color-primary);\n                }\n            }\n        }\n    }\n    &.slick-button-left {\n        .slick-dots {\n            bottom: -80px;\n            margin: 0px -6px;\n            text-align: left;\n            display: flex !important;\n            align-items: center;\n\n            @media #{$md-layout} {\n                bottom: -50px;\n            }\n\n            @media #{$sm-layout} {\n                bottom: -50px;\n            }\n\n            li {\n                border-radius: 100%;\n                transition: 0.4s;\n                position: relative;\n                margin: 0 6px;\n                display: inline-block;\n                width: 20px;\n                min-width: 20px;\n                height: 20px;\n                &::before {\n                    border: 2px solid transparent;\n                    position: absolute;\n                    content: \"\";\n                    width: 0;\n                    height: 0;\n                    transition: 0.3s;\n                    opacity: 0;\n                    border-radius: 100%;\n                    left: 50%;\n                    top: 50%;\n                    transform: translate(-50%, -50%);\n                }\n                &.slick-active {\n                    &::before {\n                        border-color: var(--color-primary);\n                        opacity: 1;\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n            }\n        }\n    }\n    &.instructor-profile-courses {\n        .slick-dots {\n            bottom: -46px;\n        }\n        .slick-list {\n            @media #{$smlg-device} {\n                margin-bottom: 30px;\n            }\n        }\n    }\n}\n\n.slick-arrow-style-2 {\n    position: relative;\n    .slide-arrow {\n        position: absolute;\n        right: 50px;\n        width: 50px;\n        height: 50px;\n        background: rgba(82,95,225,0.15);\n        transition: 0.3s;\n        color: var(--color-primary);\n        line-height: 50px;\n        text-align: center;\n        border: 0 none;\n        bottom: 50px;\n        border-radius: 3px;\n        font-size: 18px;\n        z-index: 2;\n\n        @media #{$small-mobile} {\n            right: 20px;\n            width: 40px;\n            height: 40px;\n            line-height: 40px;\n            bottom: 20px;\n        }\n\n        &:hover {\n            background: var(--color-primary);\n            color: var(--color-white);\n        }\n        &.prev-arrow {\n            right: 115px;\n            @media #{$small-mobile} {\n                right: 74px;\n            }\n        }\n    }\n}\n\n\n\n.edu-slick-arrow-top {\n    .slide-arrow {\n        position: absolute;\n        right: 15px;\n        width: 50px;\n        height: 50px;\n        background: #FFFFFF;\n        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n        border-radius: 5px;\n        transition: 0.3s;\n        color: var(--color-primary);\n        line-height: 50px;\n        text-align: center;\n        border: 0 none;\n        font-size: 18px;\n        top: -120px;\n        @media #{$sm-layout} {\n            top: auto;\n            bottom: -30px;\n            right: auto;\n            left: 80px;\n        }\n        &:hover {\n            background: var(--color-primary);\n            color: var(--color-white);\n        }\n        &.prev-arrow {\n            right: 80px;\n            @media #{$sm-layout} {\n                right: auto;\n                left: 15px;\n            }\n        }\n    }\n}\n\n\n","/*------------------------\n    Winner Area Styles  \n--------------------------*/\n\n.edu-winner-card {\n    background: var(--color-white);\n    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    padding: 40px;\n    transition: 0.4s;\n    text-align: center;\n    .inner {\n        .icon {\n            margin-bottom: 30px;\n            img {\n                max-height: 50px;\n            }\n        }\n        .content {\n            .subtitle {\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 18px;\n                display: inline-block;\n            }\n            .title {\n                font-weight: 700;\n                margin-bottom: 0;\n                transition: 0.4s;\n            }\n        }\n    }\n    &:hover {\n        transform: translateY(-15px);\n        .inner {\n            .content {\n                .title {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n","/*----------------------------\n    Counterup Styles  \n-----------------------------*/\n.edu-counterup {\n    background: var(--color-white);\n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    text-align: center;\n    padding: 50px 30px;\n    \n    @media #{$lg-layout} {\n        padding: 30px 15px;\n    }\n\n    @media #{$md-layout} {\n        padding: 30px 15px;\n    }\n\n    @media #{$sm-layout} {\n        padding: 30px 15px;\n    }\n    .inner {\n        .icon {\n            margin-bottom: 25px;\n            img {\n                max-height: 60px;\n            }\n        }\n        .content {\n            .counter {\n                font-weight: 800;\n                font-size: 40px;\n                line-height: 56px;\n                margin-bottom: 0;\n            }\n            span {\n                display: inline-block;\n            }\n        }\n    }\n}\n\n\n// Counterup Style Two  \n.counterup-overlay-top {\n    position: relative;\n    margin-top: -145px;\n    padding-top: 275px !important;\n}\n.counterup-style-2 {\n    position: relative;\n    z-index: 2;\n\n    .line-separator {\n        position: relative;\n        &::after {\n            position: absolute;\n            content: \"\";\n            height: 160px;\n            background: rgba(255,255,255,0.15);\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            width: 1px;\n            @media #{$large-mobile} {\n                display: none;\n            }\n        }\n        &:last-child {\n            &::after {\n                display: none;\n            }\n        }\n        &.color-var-2 {\n            &::after {\n                background: #2D284E;\n                opacity: 0.1;\n            }\n        }\n    }\n}\n\n.edu-counterup-2 {\n    .inner {\n        text-align: center;\n        .icon {\n            margin-bottom: 7px;\n            i {\n                color: var(--color-white);\n                font-size: 30px;\n            }\n        }\n        .content {\n            .counter {\n                color: var(--color-white);\n                font-weight: 800;\n                font-size: 40px;\n                line-height: 56px;\n                margin-bottom: 5px;\n                .after-icon {\n                    color: var(--color-white);\n                    position: relative;\n                    display: inline-block;\n                    left: -7px;\n                }\n            }\n            .subtitle {\n                letter-spacing: 0.1em;\n                text-transform: uppercase;\n                font-weight: 800;\n                font-size: 16px;\n                line-height: 26px;\n                color: var(--color-white);\n            }\n        }\n    }\n\n    &.variation-2 {\n        .inner {\n            text-align: center;\n            .icon {\n                i {\n                    color: var(--color-primary);\n                    font-size: 50px;\n                }\n            }\n            .content {\n                .counter {\n                    color: var(--color-heading);\n                    .after-icon {\n                        color: var(--color-heading);\n                    }\n                }\n                .subtitle {\n                    color: var(--color-body);\n                }\n            }\n        }\n    }\n}","// count down\n\n.edu-countdown-area {\n    background-image: url(../../images/bg/about-us-two-countdown.jpg);\n\n    .countdown {\n        .countdown-container {\n            .countdown-value {\n                color: var(--color-secondary);\n            }\n        }\n    }\n}\n\n.countdown {\n    display: flex;\n    margin: -15px;\n    justify-content: center;\n    flex-wrap: wrap;\n    .countdown-container {\n        margin: 15px !important;\n        position: relative;\n        background-color: var(--color-white);\n        padding: 15px 28px;\n        border-radius: 5px;\n        \n        .countdown-heading {\n            display: block;\n            color: var(--color-body);\n            font-size: 14px;\n            text-align: center;\n            text-transform: uppercase;\n            margin-top: 0;\n            display: block;\n            line-height: 18px;\n            font-weight: 700;\n            letter-spacing: 0.05em;\n        }\n        .countdown-value {\n            display: block;\n            font-size: 32px;\n            color: var(--color-heading);\n            font-weight: 700;\n            text-align: center;\n            position: relative;\n            line-height: 1.38;\n        }\n        &:after {\n            content: \":\";\n            top: 50%;\n            transform: translateY(-50%);\n            right: -17px;\n            position: absolute;\n            font-size: 32px;\n            color: var(--color-white);\n            font-weight: 700;\n        }\n        &:last-child {\n            &::after {\n                display: none;\n            }\n        }\n    }\n}\n\n.countdown-style-2 {\n    .countdown {\n        display: flex;\n        margin: -15px;\n        justify-content: center;\n        flex-wrap: wrap;\n        @media #{$sm-layout} {\n            margin: -5px !important;\n        }\n        .countdown-container {\n            margin: 15px !important;\n            position: relative;\n            background: #FFFFFF;\n            box-shadow: 0px 10px 35px rgba(0, 0, 0, 0.07);\n            border-radius: 5px;\n            padding: 40px 10px;\n            border-radius: 5px;\n            transition: 0.4s;\n            min-width: 180px;\n            text-align: center;\n            @media #{$sm-layout} {\n                padding: 10px;\n                min-width: auto;\n                margin: 5px !important;\n            }\n            .countdown-heading {\n                display: block;\n                color: var(--color-heading);\n                text-align: center;\n                text-transform: uppercase;\n                margin-top: 0;\n                display: block;\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 36px;\n                transition: 0.4s;\n                @media #{$sm-layout} {\n                    font-size: 14px;\n                }\n            }\n            .countdown-value {\n                display: block;\n                font-weight: 800;\n                font-size: 68px;\n                line-height: 1.24;\n                color: var(--color-heading);\n                text-align: center;\n                position: relative;\n                transition: 0.4s;\n                @media #{$sm-layout} {\n                    font-size: 24px;\n                }\n            }\n            &:after {\n                display: none;\n            }\n            &:last-child {\n                &::after {\n                    display: none;\n                }\n            }\n\n            &:hover {\n                background: var(--color-primary);\n                box-shadow: 0px 10px 30px rgba(82, 95, 225, 0.3);\n                .countdown-heading {\n                    color: var(--color-white);\n                }\n                .countdown-value {\n                    color: var(--color-white);\n                }\n            }\n        }\n    }\n}\n\n.eduvibe-about-two-countdown {\n    .countdown-style-1 {\n        padding: 0 290px;\n        @media #{$lg-layout} {\n            padding: 0 60px;\n        }\n        @media #{$small-tablet} {\n            padding: 0px;\n        }\n    }\n}","/*--------------------------------\n    Breadcrumb Area  \n------------------------------*/\n\n.breadcrumb-style-1 {\n    .page-title {\n        .title {\n            margin-bottom: 5px;\n        }\n    }\n    .edu-breadcrumb {\n        align-items: center;\n        li {\n            margin: 0;\n            &.breadcrumb-item {\n                color: var(--color-body);\n            }\n            &.separator {\n                i {\n                    font-size: 20px;\n                    margin: 0 5px;\n                    position: relative;\n                    display: inline-block;\n                    top: 2px;\n                }\n            }\n        }\n    }\n}\n\n\n",".grid-metro3 {\n    margin: 0 -15px;\n    .grid-metro-item {\n        width: 33.33%;\n        padding: 0 15px;\n        margin-top: 30px;\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n    .resizer {\n        width: 33.33%;\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n}\n\n// home two course filter\n.eduvibe-home-two-course .grid-metro3 {\n    .grid-metro-item {\n        width: 33.33%;\n        @media #{$lg-layout} {\n            width: 50%;\n        }\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 100%;\n        }\n    }\n    .resizer {\n        width: 33.33%;\n        @media #{$lg-layout} {\n            width: 50%;\n        }\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 100%;\n        }\n    }\n}\n\n.grid-metro4 {\n    margin: 0 -15px;\n    .grid-metro-item {\n        width: 25%;\n        padding: 0 15px;\n        margin-top: 30px;\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n    .resizer {\n        width: 25%;\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n}\n\n\n.grid-metro5 {\n    margin: 0 -15px;\n    .grid-metro-item {\n        width: 20%;\n        padding: 0 15px;\n        margin-top: 30px;\n        @media #{$lg-layout} {\n            width: 33.33%;\n        }\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n    .resizer {\n        width: 20%;\n        @media #{$lg-layout} {\n            width: 33.33%;\n        }\n        @media #{$md-layout} {\n            width: 50%;\n        }\n        @media #{$sm-layout} {\n            width: 50%;\n        }\n        @media #{$large-mobile} {\n            width: 100%;\n        }\n    }\n}","/*-------------------------\nAccordion Style \n-------------------------*/ \n.edu-tab-nav {\n    margin: -7.5px;\n    border: 0 none;\n    justify-content: center;\n    li {\n        margin: 7.5px;\n        &.nav-item {\n            button {\n                &.nav-link {\n                    background: #F5F5F5;\n                    border-radius: 4px;\n                    height: 50px;\n                    line-height: 50px;\n                    padding: 0 40px;\n                    color: var(--color-heading);\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 26px;\n                    position: relative;\n                    z-index: 1;\n                    border: 0 none;\n                    @media #{$sm-layout} {\n                        padding: 0 15px;\n                    }\n                    &::after {\n                        position: absolute;\n                        content: \"\";\n                        background-image: url(../../images/shape/shape-57.png);\n                        background-repeat: no-repeat;\n                        background-size: cover;\n                        background-position: center center;\n                        width: 77px;\n                        height: 92%;\n                        left: -5px;\n                        top: -3px;\n                        z-index: -1;\n                        transition: 0.4s;\n                        opacity: 0;\n                    }\n                    &.active {\n                        background: var(--color-primary);\n                        color: var(--color-white);\n                        &::after {\n                            opacity: 0.4;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.accordion-shape-1 {\n    position: relative;\n    z-index: 1;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        top: 156px;\n        left: 276px;\n    }\n}\n\n\n.edu-accordion-area {\n    .gallery-wrapper {\n        padding-right: 55px;\n        @media #{$md-layout} {\n            padding-right: 15px;\n        }\n        @media #{$sm-layout} {\n            padding-right: 15px;\n        }\n    }\n}\n\n.accordion-style-1 {\n    .edu-accordion-header {\n        margin-bottom: 0;\n    }\n    .edu-accordion-button {\n        font-size: 20px;\n        border: 0 none;\n        background: transparent;\n        border-top: 1px solid #EEEEEE;\n        width: 100%;\n        text-align: left;\n        padding: 20px 0;\n        font-weight: 700;\n        line-height: 32px;\n        position: relative;\n        &::after {\n            position: absolute;\n            content: \"\\e935\";\n            font-family: 'icomoon';\n            color: var(--color-heading);\n            font-size: 20px;\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            transition: 0.4s;\n        }\n        &[aria-expanded=\"true\"] {\n            &::after {\n                content: \"\\e934\";\n            }\n        }\n    }\n    .edu-accordion-body {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        margin-bottom: 20px;\n    }\n\n    .edu-accordion-item {\n        &:last-child {\n            .edu-accordion-button {\n                border-bottom: 1px solid #EEEEEE;\n            }\n            &.active-item {\n                .edu-accordion-button {\n                    border-bottom: 0px;\n                }\n            }\n            &.active-item {\n                border-bottom: 1px solid #EEEEEE;\n            }\n        }\n    }\n\n}\n\n.edu-accordion-02 {\n    background: #FFFFFF;\n    .edu-accordion-button {\n        font-size: 20px;\n        border: 0 none;\n        background: transparent;\n        width: 100%;\n        text-align: left;\n        padding: 13px 35px;\n        font-weight: 700;\n        line-height: 32px;\n        position: relative;\n        border: 1px solid #EEEEEE;\n        border-radius: 5px;\n        transition: 0.4s;\n        &::after {\n            position: absolute;\n            content: \"\\e969\";\n            font-family: 'icomoon';\n            color: var(--color-heading);\n            font-size: 20px;\n            right: 30px;\n            top: 50%;\n            transform: translateY(-50%);\n            transition: 0.4s;\n        }\n        &[aria-expanded=\"true\"] {\n            &::after {\n                content: \"\\EA78\";\n                font-family: \"remixicon\";\n            }\n        }\n    }\n\n    .edu-accordion-body {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        margin-bottom: 0;\n        padding: 0 35px;\n        padding-bottom: 35px;\n        ul {\n            @extend %liststyle;\n            li {\n                display: flex;\n                justify-content: space-between;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n                padding: 14px 0;\n                align-items: center;\n                margin: 0;\n                .text {\n                    i {\n                        margin-right: 8px;\n                    }\n                }\n                & + li {\n                    border-top: 1px solid #eee;\n                }\n                &:last-child {\n                    padding-bottom: 0;\n                }\n            }\n        }\n    }\n\n    .edu-accordion-item {\n        transition: 0.4s;\n        &:last-child {\n            .edu-accordion-button {\n                border-bottom: 1px solid #EEEEEE;\n            }\n        }\n        &.bg-active {\n            background: #FFFFFF;\n            box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);\n            border-radius: 5px;\n            .edu-accordion-button {\n                border: 0 none;\n                color: var(--color-primary);\n                &::after {\n                    color: var(--color-primary);\n                }\n            }\n        }\n\n        & + .edu-accordion-item {\n            margin-top: 20px;\n        }\n    }\n\n    &.variation-2 {\n        .edu-accordion-button {\n            border: transparent;\n            background: #F5F5F5;\n            border-radius: 10px;\n            padding: 31px 32px;\n            padding-right: 69px;\n            &::after {\n                content: \"\\e935\";\n                width: 32px;\n                height: 32px;\n                background: #FFFFFF;\n                box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.02);\n                color: var(--color-primary);\n                line-height: 32px;\n                text-align: center;\n                border-radius: 100%;\n            }\n            &[aria-expanded=\"true\"] {\n                &::after {\n                    content: \"\\e934\";\n                    font-family: 'icomoon';\n                    background: #E0F7F4;\n                    color: var(--color-primary);\n                }\n            }\n        }\n        .edu-accordion-item {\n            .edu-accordion-body {\n                padding: 0 31px;\n                padding-bottom: 35px;\n                p {\n                    margin-bottom: 0;\n                }\n            }\n\n            &.bg-active {\n                background: #FFFFFF;\n                box-shadow: 0px 15px 50px rgba(0, 0, 0, 0.05);\n                border-radius: 10px;\n                .edu-accordion-button {\n                    border: 0 none;\n                    color: var(--color-primary);\n                    background: transparent;\n                }\n            }\n            & + .edu-accordion-item {\n                margin-top: 30px;\n            }\n        }\n        &.landing-page-accordion {\n            .edu-accordion-button {\n                &[aria-expanded=\"true\"] {\n                    &::after {\n                        background: var(--color-primary);\n                        color: #FFFFFF;\n                    }\n                }\n            }\n            .edu-accordion-item {\n                &.bg-active {\n                    .edu-accordion-button {\n                        color: var(--color-heading);\n                    }\n                }\n            }\n        }\n    }\n    // &.landing-demo-faq.variation-2 {\n    //     .edu-accordion-item.bg-active {\n    //         background-color:  var(--color-primary);\n    //         .edu-accordion-button {\n    //             color: #FFFFFF;\n    //             &[aria-expanded=\"true\"]::after {\n    //                 background: #FFFFFF;\n    //                 color: var(--color-primary);\n    //             }\n    //         }\n    //         .edu-accordion-body p {\n    //             color: #FFFFFF;\n    //         }\n    //     }\n    // }\n}\n\n\n\n\n\n\n\n",".edu-privacy-policy {\n    p {\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        margin-bottom: 15px;\n    }\n}\n\n\n\n\n\n/* Purchase Guide  */\n\n.gallery-column {\n    display: flex;\n    flex-wrap: wrap;\n    margin: -15px;\n    &.gallery-column-2 {\n        .gallery-image {\n            flex-basis: 50%;\n            padding: 15px;\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n","/*------------------------\n    Error Styles  \n-------------------------*/\n.edu-error-style {\n    .content {\n        .title {\n            margin-bottom: 20px;\n        }\n\n        .description {\n            margin-bottom: 40px;\n        }\n    }\n\n    padding-bottom: 130px;\n\n    @media #{$small-tablet} {\n        padding-bottom: 80px;\n    }\n}\n\n\n\n\n.circle-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    left: 0;\n    span {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border: 2px solid var(--color-secondary);\n        pointer-events: none;\n        animation: eduvibe-rotate-animate 13s linear infinite;\n\n        &:nth-child(1) {\n            border-radius: 38% 62% 64% 36% / 43% 35% 65% 57%;\n        }\n\n        &:nth-child(2) {\n            animation-direction: reverse;\n            border-radius: 41% 59% 40% 60% / 65% 66% 34% 35%;\n        }\n\n        &:nth-child(3) {\n            animation-duration: 3s;\n            border-radius: 73% 27% 56% 44% / 57% 74% 26% 43%;\n        }\n    }\n}\n\n\n@keyframes eduvibe-rotate-animate {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}","/* Comming Soon Style  */\n\n.edu-coming-soon-style {\n    text-align: center;\n    .content {\n        .logo {\n            margin-bottom: 80px;\n            @media #{$md-layout} {\n                margin-bottom: 40px;\n            }\n            @media #{$sm-layout} {\n                margin-bottom: 40px;\n            }\n            a {\n                display: block;\n            }\n        }\n        .title {\n            font-weight: 800;\n            font-size: 72px;\n            line-height: 1.25;\n            margin-bottom: 80px;\n            @media #{$md-layout} {\n                font-size: 60px;\n                margin-bottom: 40px;\n            }\n            @media #{$sm-layout} {\n                font-size: 40px;\n                margin-bottom: 40px;\n            }\n        }\n        .countdown-style-2 {\n            margin-bottom: 80px;\n            @media #{$small-tablet} {\n                .countdown {\n                    .countdown-container {\n                        min-width: 150px;\n                        padding: 25px 10px;\n                        .countdown-value {\n                            font-size: 55px;\n                        }\n                        .countdown-heading {\n                            font-size: 22px;\n                        }\n                    }\n                }\n            }\n            @media #{$sm-layout} {\n                .countdown {\n                    .countdown-container {\n                        min-width: 100px;\n                        padding: 15px 10px;\n                        .countdown-value {\n                            font-size: 35px;\n                        }\n                        .countdown-heading {\n                            font-size: 20px;\n                        }\n                    }\n                }\n            }\n            @media #{$large-mobile} {\n                .countdown {\n                    .countdown-container {\n                        min-width: 80px;\n                        padding: 15px 10px;\n                        .countdown-value {\n                            font-size: 25px;\n                        }\n                        .countdown-heading {\n                            font-size: 16px;\n                        }\n                    }\n                }\n            }\n        }\n        .description {\n            margin: 0 auto 40px;\n            max-width: 760px;\n        }\n    }\n}\n\n.newsletter-form-style-2 {\n    display: flex;\n    justify-content: center;\n    @media #{$sm-layout} {\n        display: block;\n    }\n    input {\n        min-width: 407px;\n        width: 407px;\n        background: #FFFFFF;\n        box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.05);\n        border-radius: 5px;\n        border: 0 none;\n        padding: 0 25px;\n        font-weight: 500;\n        height: 60px;\n        @media #{$md-layout} {\n            min-width: 300px;\n            width: 300px;\n        }\n        @media #{$sm-layout} {\n            min-width: auto;\n            width: 100%;\n        }\n    }\n    .edu-btn {\n        margin-left: 10px;\n        @media #{$sm-layout} {\n            margin-left: 0;\n            margin-top: 20px;\n        }\n    }\n}","/* --------------------\nGallery Item \n------------------- */\n.filters-button-group {\n    margin: -7.5px;\n    flex-wrap: wrap;\n    button {\n        height: 36px;\n        padding: 0 20px;\n        width: auto;\n        border: 0 none;\n        background: #F5F5F5;\n        border-radius: 3px;\n        color: var(--color-heading);\n        margin: 7.5px;\n        font-weight: 600;\n        transition: 0.4s;\n\n        &.is-checked,\n        &:hover {\n            background: var(--color-primary);\n            color: var(--color-white);\n        }\n    }\n}\n\n.edu-gallery-grid-item {\n    display: block;\n    border-radius: 5px;\n    padding: 0 15px !important;\n    .edu-gallery-grid {\n        position: relative;\n        img {\n            border-radius: 5px;\n        }\n        &::before {\n            background: linear-gradient(180deg, rgba(82, 95, 225, 0.3) 10.75%, #525fe1 85%);\n            border-radius: 5px;\n            position: absolute;\n            content: \"\";\n            left: 0;\n            top: 0;\n            width: 100%;\n            height: 100%;\n            opacity: 0;\n            transition: 0.4s;\n        }\n        .zoom-icon {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            transition: 0.4s;\n            opacity: 0;\n            i {\n                color: var(--color-white);\n                font-size: 25px;\n            }\n        }\n        .hover-action {\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            padding: 30px 40px;\n            z-index: 1;\n            transition: 0.4s;\n            opacity: 0;\n            @media #{$sm-layout} {\n                padding: 20px 20px;\n            }\n            .hover-content {\n                .hover-text {\n                    .title {\n                        color: var(--color-white);\n                        text-align: center;\n                        font-weight: 700;\n                        font-size: 24px;\n                        line-height: 36px;\n                        margin-bottom: 0;\n                        @media #{$sm-layout} {\n                            font-size: 20px;\n                            line-height: 32px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &:hover {\n        .edu-gallery-grid  {\n            &::before {\n                opacity: 1;\n            }\n            .zoom-icon {\n                opacity: 1;\n            }\n            .hover-action {\n                opacity: 1;\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n","/*--------------------------\n    Pricing Table  \n----------------------------*/\n.edu-pricing-area {\n    background-image: url(../../images/bg/pricing-plan.jpg);\n}\n\n.pricing-billing-duration {\n    text-align: right;\n    @media #{$sm-layout} {\n        text-align: left;\n    }\n    ul {\n        @extend %liststyle;\n        background: rgba(82, 95, 225, .08);\n        border-radius: 5px;\n        padding: 10px;\n        display: inline-block;\n        .nav-item {\n            float: left;\n            margin: 0;\n            .nav-link {\n                height: 40px;\n                line-height: 40px;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 28px;\n                color: var(--color-heading);\n                border: 0 none;\n                background: transparent;\n                padding: 0 25px;\n                border-radius: 3px;\n                &.active {\n                    background: var(--color-primary);\n                    color: var(--color-white);\n                }\n            }\n        }\n    }\n}\n\n// Pricing Table Styles \n.pricing-table {\n    background: #FFFFFF;\n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.03);\n    border-radius: 5px;\n    padding: 60px 64px;\n    position: relative;\n\n    @media #{$md-layout} {\n        padding: 60px 30px;\n    }\n\n    @media #{$sm-layout} {\n        padding: 60px 30px;\n    }\n\n    .pricing-header {\n        margin-bottom: 40px;\n        text-align: center;\n        .price-wrap {\n            .monthly-pricing {\n                display: none;\n            }\n            .amount {\n                font-weight: 800;\n                font-size: 40px;\n                line-height: 56px;\n                color: var(--color-primary);\n            }\n            .duration {\n                color: var(--color-primary);\n                font-size: 16px;\n                font-weight: 500;\n                text-transform: capitalize;\n                display: inline-block;\n                margin-left: -4px;\n            }\n        }\n\n        .title {\n            letter-spacing: 0.1em;\n            text-transform: uppercase;\n            font-weight: 800;\n            font-size: 16px;\n            line-height: 26px;\n            margin-bottom: 10px;\n        }\n    }\n\n    .pricing-body {\n        margin-bottom: 40px;\n        .list-item {\n            @extend %liststyle;\n            li{\n                display: flex;\n                align-items: center;\n                margin: 0;\n                i {\n                    color: var(--color-secondary);\n                    margin-right: 10px;\n                }\n                & + li {\n                    margin-top: 16px;\n                }\n            }\n        }\n    }\n\n    &.active {\n        transform: translateY(-20px);\n        .edu-badge {\n            background: var(--color-secondary);\n            padding: 0 17px;\n            position: absolute;\n            right: 0;\n            top: 15px;\n            height: 30px;\n            line-height: 30px;\n            padding-left: 25px;\n\n            span {\n                font-weight: 700;\n                font-size: 14px;\n                color: var(--color-white);\n                text-align: center;\n                letter-spacing: 0.05em;\n                text-transform: uppercase;\n            }\n            &::after {\n                width: 0;\n                height: 0;\n                border-style: solid;\n                border-width: 24px 0 24px 23px;\n                border-color: transparent transparent transparent #fff;\n                position: absolute;\n                right: 87%;\n                top: 50%;\n                content: \"\";\n                transform: translateY(-50%);\n            }\n        }\n    }\n\n\n\n}\n\n\n","/*-------------------------\n    Profile Details \n--------------------------*/\n.instructor-profile-left {\n    background: #F5F5F5;\n    border-radius: 5px;\n    padding: 40px 20px;\n    .inner {\n        text-align: center;\n        .thumbnail {\n            max-width: 230px;\n            max-height: 230px;\n            margin: 0 auto;\n            margin-bottom: 30px;\n            img {\n                border-radius: 100%;\n                width: 100%;\n                height: 100%;\n            }\n        }\n        .content {\n            .title {\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 36px;\n                margin-bottom: 2px;\n            }\n            .subtitle {\n                font-weight: 600;\n                line-height: 26px;\n                color: var(--color-primary);\n                display: block;\n                margin-bottom: 25px;\n            }\n            .contact-with-info {\n                margin-bottom: 25px;\n                p {\n                    margin-bottom: 5px;\n                    span {\n                        font-weight: 600;\n                        color: var(--color-heading);\n                    }\n                    a {\n                        color: var(--color-body);\n                    }\n                }\n            }\n            .contact-btn {\n                margin-top: 40px;\n            }\n        }\n\n    }\n}\n\n\n\n\n\n/* Course Statictatic  */\n.course-statistic-wrapper {\n    .line-separator {\n        position: relative;\n        & + .line-separator {\n            &::before {\n                position: absolute;\n                content: \"\";\n                background: #FFFFFF;\n                height: 66px;\n                width: 1px;\n                top: 50%;\n                transform: translateY(-50%);\n                opacity: 0.15;\n                left: 0;\n            }\n        }\n    }\n}\n\n\n.course-statistic {\n    .inner {\n        .total {\n            font-weight: 800;\n            font-size: 40px;\n            line-height: 56px;\n            color: var(--color-white);\n            margin-bottom: 0;\n        }\n        p {\n            font-weight: 800;\n            font-size: 16px;\n            line-height: 26px;\n            color: var(--color-white);\n            margin-bottom: 0;\n            letter-spacing: 0.1em;\n            text-transform: uppercase;\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n\n.single-progress {\n    position: relative;\n    overflow: hidden;\n    .title {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        color: var(--color-heading);\n        margin-bottom: 10px;\n    }\n}\n\n.progress {\n    height: 6px;\n    overflow: visible;\n    background-color: rgba(82,95,225,0.15);\n    border-radius: 2px;\n\n    .progress-bar {\n        border-radius: 2px;\n        width: 0;\n        height: 100%;\n        background-color: var(--color-primary);\n        transition: width .5s ease;\n        overflow: visible;\n    }\n\n    .progress-number {\n        position: absolute;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        top: 0;\n        right: 0;\n        z-index: 1;\n        color: var(--color-heading);\n    }\n}\n\n","/*-------------------------\n    Contact Us Area  \n---------------------------*/\n\n\n.contact-address-card-1 {\n    background: #FFFFFF;\n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    padding: 50px 20px;\n    text-align: center;\n    transition: 0.4s;\n    .inner { \n        .icon {\n            background: rgba(82,95,225,0.1);\n            width: 50px;\n            height: 50px;\n            margin: 0 auto;\n            border-radius: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            transition: 0.4s;\n            i {\n                color: var(--color-primary);\n                font-size: 24px;\n                transition: 0.4s;\n            }\n        }\n        .content {\n            .title {\n                font-weight: 700;\n                margin-top: 25px;\n                margin-bottom: 15px;\n                transition: 0.4s;\n            }\n            p {\n                margin-bottom: 0;\n                transition: 0.4s;\n                a {\n                    color: var(--color-body);\n                    transition: 0.4s;\n                    &:hover {\n                        color: var(--color-primary);\n                    }\n                }\n            }\n        }\n    }\n\n    &.phone {\n        .inner {\n            .icon {\n                background: rgba(251,124,86,0.1);\n                i {\n                    color: var(--color-secondary);\n                }\n            }\n        }\n    }\n\n    &.email {\n        .inner {\n            .icon {\n                background: rgba(255,164,27,0.1);\n                i {\n                    color: #FFA41B;\n                }\n            }\n        }\n    }\n\n    &:hover {\n        background: var(--color-secondary);\n        transform: translateY(-15px);\n        .inner {\n            .icon {\n                background: var(--color-white);\n                i {\n                    color: var(--color-secondary);\n                }\n            }\n            .content {\n                .title {\n                    color: var(--color-white);\n                }\n                p {\n                    color: var(--color-white);\n                    a {\n                        color: var(--color-white);\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n.contact-address-card-2 {\n    background: #FFFFFF;\n    box-shadow: 0px 8px 35px rgba(0, 0, 0, 0.06);\n    border-radius: 5px;\n    padding: 70px 40px;\n    text-align: center;\n    transition: 0.4s;\n    @media #{$lg-layout} {\n        padding: 60px 20px;\n    }\n    @media #{$md-layout} {\n        padding: 60px 20px;\n    }\n\n    .inner {\n        .icon {\n            margin-bottom: 45px;\n            img {\n\n            }\n        }\n        .content {\n            .title {\n                font-weight: 700;\n                font-size: 24px;\n                line-height: 36px;\n                margin-bottom: 20px;\n            }\n            p {\n                margin-bottom: 0;\n                line-height: 26px;\n                .subtitle {\n                    font-weight: 600;\n                    color: var(--color-heading);\n                }\n                .text {\n                    font-weight: 500;\n                }\n            }\n        }\n    }\n    &:hover {\n        transform: translateY(-15px);\n    }\n}\n\n\n.contact-address-bottom-shape {\n    position: relative;\n    z-index: 1;\n    .bg-shape-image {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        z-index: -1;\n    }\n}\n\n\n\n\n/*------------------------------\n    Contact Form Style One \n-------------------------------*/ \n.rwt-dynamic-form {\n    .form-group {\n        input {\n            background: #F5F5F5;\n            border-radius: 5px;\n            padding: 0 30px;\n            border: 1px solid transparent;\n            transition: 0.4s;\n            outline: none;\n            box-shadow: none;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 26px;\n            height: 60px;\n            &:focus {\n                border-color: var(--color-primary);\n            }\n        }\n        textarea {\n            background: #F5F5F5;\n            padding: 17px 30px;\n            min-height: 180px;\n            border: 0 none;\n            border: 1px solid transparent;\n            transition: 0.4s;\n            outline: none;\n            box-shadow: none;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 26px;\n            border-radius: 5px;\n            &:focus {\n                border-color: var(--color-primary);\n            }\n        }\n    }\n    .success-message {\n        margin-top: 20px;\n        color: #019267;\n    }\n}\n\n\n/*---------------------------\n    About Me \n----------------------------*/ \n.about-me-1 {\n    .thumbnail {\n        position: relative;\n        border-radius: 5px;\n        &::before {\n            background: linear-gradient(360deg, #2D284E 0%, rgba(45, 40, 78, 0) 70.5%);\n            position: absolute;\n            content: \"\";\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            border-radius: 5px;\n        }\n        img {\n            border-radius: 5px;\n        }\n        .content-overlay {\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            width: 100%;\n            text-align: center;\n            padding: 50px 20px;\n            @media #{$sm-layout} {\n                padding: 20px 20px;\n            }\n            .title {\n                margin-bottom: 0;\n                color: var(--color-white);\n                font-size: 32px;\n                line-height: 44px;\n                @media #{$sm-layout} {\n                    font-size: 22px;\n                    line-height: 32px;\n                }\n            }\n        }\n    }\n}\n\n.google-map {\n    &.alignwide {\n        margin-left: -105px;\n        margin-right: -105px;\n        min-width: 1170px;\n        width: auto;\n        @media #{$custom-lg-device} {\n            margin-left: 0;\n            margin-right: 0;\n            min-width: auto;\n        }\n        iframe {\n            width: 100%;\n        }\n    }\n}","/*-----------------------\n    Shop Style  \n------------------------*/\n\n\n.product {\n    overflow: hidden;\n    .inner {\n        text-align: center;\n        .thumbnail {\n            position: relative;\n            a {\n                display: block;\n                overflow: hidden;\n                border-radius: 5px;\n                img {\n                    width: 100%;\n                    border-radius: 5px;\n                    transition: 0.4s;\n                    overflow: hidden;\n                    &.w-100-thumb {\n                        display: flex;\n                    }\n                }\n            }\n            .product-hover-info {\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                background: var(--color-primary);\n                width: 100%;\n                border-radius: 0px 0px 5px 5px;\n                transition: 0.4s;\n                opacity: 0;\n                height: 0;\n                z-index: 1;\n                ul {\n                    @extend %liststyle;\n                    display: flex;\n                    li {\n                        margin: 0;\n                        flex-basis: 50%;\n                        padding: 7px;\n                        position: relative;\n                        a {\n                            font-weight: 600;\n                            font-size: 16px;\n                            line-height: 26px;\n                            color: var(--color-white);\n                        }\n                        & + li {\n                            &::after {\n                                position: absolute;\n                                content: \"\";\n                                background: rgba(255,255,255,0.2);\n                                width: 1px;\n                                height: 100%;\n                                left: 0;\n                                top: 0;\n                            }\n                        }\n                        &.product-each-item-content-inner {\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            position: relative;\n                        }\n                        &.old-price {\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            font-size: 16px;\n                        }\n                    }\n                }\n            }\n        }\n        .content {\n            padding-top: 20px;\n            .product-author {\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 22px;\n                display: block;\n                margin-bottom: 5px;\n            }\n            .title {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 28px;\n                margin-bottom: 5px;\n            }\n            .price-list {\n                &.price-style-03 {\n                    margin: -8px;\n                    .price {\n                        margin: 8px;\n                    }\n                    .current-price {\n                        font-size: 18px;\n                        line-height: 28px;\n                        color: var(--color-primary);\n                    }\n                    .old-price {\n                        font-weight: 600;\n                        font-size: 16px;\n                        line-height: 26px;\n                    }\n                }\n            }\n        }\n    }\n\n    &:hover {\n        .inner {\n            .thumbnail {\n                a {\n                    \n                    img {\n                        transform: scale(1.1);\n                    }\n                }\n\n                .product-hover-info {\n                    opacity: 1;\n                    height: 40px;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*-----------------------\n    Brand Styles  \n-----------------------*/\n\n.brand-list {\n    @extend %liststyle;\n    li {\n        margin: 0;\n        text-align: center;\n        a {\n            display: block;\n            text-align: center;\n            img {\n                display: inline-block;\n                text-align: center;\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*--------------------------\n    Checkout Page Style  \n----------------------------*/\n\n.checkout-page-style {\n    .title {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 28px;\n        padding-bottom: 15px;\n        border-bottom: 1px solid #EEEEEE;\n        margin-bottom: 30px;\n    }\n\n    input {\n        background: #F5F5F5;\n        border-radius: 5px;\n        border: 0 none;\n        height: 60px;\n        padding: 0 25px;\n        font-weight: 500;\n        color: var(--color-body);\n        border: 1px solid transparent;\n        &:focus {\n            border-color: var(--color-primary);\n        }\n    }\n    select {\n        border: 1px solid #6F6B80;\n        border-radius: 5px;\n        padding: 0 25px;\n        height: 60px;\n        font-weight: 500;\n        color: var(--color-body);\n        position: relative;\n        background: url(../../images/icons/arrow-icon.png) 95% center no-repeat transparent;\n    }\n    textarea {\n        background: #F5F5F5;\n        border-radius: 5px;\n        border: 0 none;\n        padding: 15px 25px;\n        font-weight: 500;\n        color: var(--color-body);\n        min-height: 170px;\n        resize: none;\n        border: 1px solid transparent;\n        &:focus {\n            border-color: var(--color-primary);\n        }\n    }\n    .box-label {\n        margin-bottom: 8px;\n        display: inline-block;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        color: var(--color-heading);\n    }\n\n\n    .shop_table {\n        margin-bottom: 20px;\n        thead {\n            tr {\n                th {\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 26px;\n                    color: var(--color-heading);\n                    border-bottom: 1px solid #EEEEEE;\n                    padding: 10px 0;\n                    margin-bottom: 10px;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                td {\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 26px;\n                    color: var(--color-body);\n                    border: 0 none;\n                    padding: 5px 0;\n                }\n                &:first-child {\n                    td {\n                        padding-top: 20px;\n                    }\n                }\n            }\n        }\n\n        tfoot {\n            tr {\n                th {\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 26px;\n                    color: var(--color-heading);\n                    padding: 5px 0;\n                }\n                &.order-subtotal {\n                    th {\n                        font-weight: 500;\n                        color: var(--color-body);\n                    }\n                }\n            }\n        }\n\n\n    }\n}\n\n\n\n","/*-------------------------------\n    Overall React Specific Styles  \n---------------------------------*/\nbody.search-popup-active {\n\toverflow-y: hidden;\n}\n\n.eduvibe-google-map {\n\twidth: 100%;\n\theight: 500px;\n\t@media #{$sm-layout} {\n\t\theight: 350px;\n\t}\n}\n\n.edu-contact-map-area .eduvibe-google-map {\n\tdiv {\n\t\tborder-radius: 5px;\n\t}\n}\n\n.event-widget .eduvibe-google-map {\n\theight: 290px;\n\tdiv {\n\t\tborder-radius: 5px;\n\t}\n}\n\n.banner-style-5 .rating i,\n.eduvibe-testimonial-three .rating i,\n.eduvibe-testimonial-four .rating i,\n.eduvibe-course-rating-stars i:not(:last-child) {\n\tmargin-right: 4px;\n}\n\n.video-play-btn.eduvibe-video-play-icon {\n\tcolor: var(--color-primary);\n\tfont-size: 18px;\n}\n\n.video-play-btn.btn-theme-color.eduvibe-video-play-icon {\n\tcolor: var(--color-white);\n}\n\n.video-play-btn.btn-secondary-color.eduvibe-video-play-icon {\n\tcolor: var(--color-secondary);\n}\n\nbody .about-style-4 .gallery-wrapper .image-3 img {\n\tborder: 0;\n}\n\n.eduvibe-gallery-items.mt--5 {\n\tmargin-top: 35px !important;\n}\n\n.eduvibe-gallery-items .edu-gallery-grid-item {\n\tpadding: 0 !important;\n}\n\n.eduvibe-masonry-grid {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\twidth: auto;\n\tmargin: 65px 0 -15px;\n}\n\n.eduvibe-masonry-grid_column {\n\tpadding: 0 15px;\n\tbackground-clip: padding-box;\n}\n\n.eduvibe-masonry-grid_column .edu-gallery-grid-item {\n\tpadding: 0 !important;\n\tmargin-bottom: 30px;\n}\n\n.edu-gallery-grid-item .edu-gallery-grid .zoom-icon {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\ttransform: inherit !important;\n\ttransition: 0.4s;\n\topacity: 0;\n\tbottom: 0;\n\tright: 0;\n\twidth: 100%;\n\tborder: 0;\n\tcursor: pointer;\n\tbackground: transparent;\n}\n\n.eduvibe-countdown-ending-notice {\n\tcolor: var(--color-primary);\n}\n\n.banner-style-5 .video-btn-wrapper,\n.banner-style-1 .scroll-down-btn .round-btn,\n.banner-style-3 .scroll-down-btn .round-btn {\n\tcursor: pointer;\n}\n\n.edu-blog-widget.edu-instagram-widget-2,\n.edu-blog-widget.edu-about-widget-2 {\n\tbackground: transparent;\n\tpadding: 0;\n}\n\n.edu-blog-widget.edu-instagram-widget-2 .widget-title,\n.edu-blog-widget.edu-about-widget-2 .widget-title {\n\tpadding-bottom: 0px;\n\tmargin-bottom: 30px;\n\tborder-bottom: 0;\n}\n\n.edu-blog.blog-type-2.variation-2.bg-color-gray {\n\tbackground: var(--color-shade);\n}\n\n.eduvibe-blog-standard-wrapper .eduvibe-post-standard:first-child {\n\tmargin-top: 0 !important;\n}\n\n.eduvibe-post-one-carousel-item,\n.eduvibe-event-one-carousel-item {\n\tpadding: 15px;\n}\n\n.eduvibe-post-one-carousel-item .edu-blog.blog-type-2:hover {\n\tbox-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);\n}\n\n.edu-event.event-grid-1.bg-shade .inner {\n\tbackground: var(--color-shade);\n\tbox-shadow: inherit !important;\n}\n\n.edu-card.card-type-2:hover {\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 10px 30px rgba(0, 0, 0, 0.06);\n}\n\n.eduvibe-course-two-single .edu-card.card-type-2:hover {\n\tbox-shadow: 0px 10px 20px rgba(0, 0, 0, 0.06);\n}\n\n.eduvibe-event-one-carousel-item .edu-event.event-grid-1.bg-shade .inner:hover {\n\tbackground: var(--color-white);\n\tbox-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);\n}\n\nbutton.edu-btn .eduvibe-spin-icon {\n\tpadding-left: 10px;\n\tposition: relative;\n}\n\n.eduvibe-event-two-shadow .inner {\n\tbox-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);\n}\n\n.slick-slide .author-meta .author-thumb a img {\n\tdisplay: initial;\n}\n\n.edu-card.card-type-4 .inner .thumbnail a img {\n\tobject-fit: cover;\n}\n\n.eduvibe-course-style-four .edu-meta.meta-03 li:last-child {\n\tmargin-right: 0px;\n}\n\n.eduvibe-course-one-carousel .edu-card.card-type-3 {\n\tbox-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);\n}\n\n.eduvibe-course-one-carousel .single-slick-card {\n\tmargin-bottom: 20px;\n}\n\n.eduvibe-course-price-filter input {\n\tpadding: 0;\n}\n\n.landing-demo-nav-btn:hover {\n\tcursor: pointer;\n}\n\n.landing-inner-pages img {\n\tpadding: 0 15px;\n\tborder-radius: 10px;\n}\n\n.eduvibe-post-share {\n\tspan {\n\t\tfont-weight: 600;\n\t\tcolor: var(--color-dark);\n\t\tmargin-right: 15px;\n\t}\n\ta {\n\t\tcolor: var(--body-color);\n\t}\n\ta:not(:last-child) {\n\t\tmargin-right: 25px;\n\t}\n}\n\n.rn-back-top {\n\tposition: fixed;\n\tbottom: 30px;\n\tright: 30px;\n\tcursor: pointer;\n\tz-index: 999;\n\twidth: 50px;\n\theight: 50px;\n\tline-height: 46px;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tz-index: 999 !important;\n\tbackground-color: var(--color-secondary);\n\tsvg {\n\t\ttransition: 0.3s;\n\t\tcolor: #fff;\n\t\twidth: 27px;\n\t\theight: 27px;\n\t\tfont-size: 14px !important;\n\t}\n}\n\n.testimonial-style-1 {\n\t@media #{$small-tablet} {\n\t\tmargin-bottom: 50px;\n\t}\n}\n\n/* course filter range CSS starts */\ninput[type=\"range\"] {\n\tfont-size: 1.5rem;\n}\n\ninput[type=\"range\"] {\n\tcolor: var(--color-primary);\n}\n\ninput[type=\"range\"].win10-thumb {\n\tcolor: var(--color-primary);\n\t--thumb-width: 0.5em;\n}\n\ninput[type=\"range\"] {\n\tposition: relative;\n\tbackground: transparent;\n\toverflow: hidden;\n}\n\ninput[type=\"range\"]:active {\n\tcursor: grabbing;\n}\n\n/* === WebKit specific styles === */\ninput[type=\"range\"],\ninput[type=\"range\"]::-webkit-slider-runnable-track,\ninput[type=\"range\"]::-webkit-slider-thumb {\n\t-webkit-appearance: none;\n\ttransition: all ease 100ms;\n\theight: 1.125em;\n}\n\ninput[type=\"range\"]::-webkit-slider-runnable-track,\ninput[type=\"range\"]::-webkit-slider-thumb {\n\tposition: relative;\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n\t--thumb-radius: calc((1.125em * 0.5) - 1px);\n\t--clip-top: calc((1.125em - 0.125em) * 0.5 - 0.5px);\n\t--clip-bottom: calc(1.125em - var(--clip-top));\n\t--clip-further: calc(100% + 1px);\n\t--box-fill: calc(-100vmax - var(--thumb-width, 1.125em)) 0 0 100vmax var(--color-primary);\n\n\twidth: var(--thumb-width, 1.125em);\n\tbackground: linear-gradient(var(--color-primary) 0 0) scroll no-repeat left center / 50%\n\t\tcalc(0.125em + 1px);\n\tbackground-color: var(--color-primary);\n\tbox-shadow: var(--box-fill);\n\tborder-radius: var(--thumb-width, 1.125em);\n\n\tfilter: brightness(100%);\n\tclip-path: polygon(\n\t\t100% -1px,\n\t\t0.125em -1px,\n\t\t0 var(--clip-top),\n\t\t-100vmax var(--clip-top),\n\t\t-100vmax var(--clip-bottom),\n\t\t0 var(--clip-bottom),\n\t\t0.125em 100%,\n\t\tvar(--clip-further) var(--clip-further)\n\t);\n}\n\ninput[type=\"range\"]:hover::-webkit-slider-thumb {\n\tcursor: grab;\n}\n\ninput[type=\"range\"]:active::-webkit-slider-thumb {\n\tcursor: grabbing;\n}\n\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n\tbackground: linear-gradient(rgba(0, 0, 0, 0.2) 0 0) scroll no-repeat center / 100%\n\t\tcalc(0.125em + 1px);\n}\n\ninput[type=\"range\"]:disabled::-webkit-slider-thumb {\n\tcursor: not-allowed;\n}\n\n/* === Firefox specific styles === */\ninput[type=\"range\"],\ninput[type=\"range\"]::-moz-range-track,\ninput[type=\"range\"]::-moz-range-thumb {\n\tappearance: none;\n\ttransition: all ease 100ms;\n\theight: 1.125em;\n}\n\ninput[type=\"range\"]::-moz-range-track,\ninput[type=\"range\"]::-moz-range-thumb,\ninput[type=\"range\"]::-moz-range-progress {\n\tbackground: transparent;\n}\n\ninput[type=\"range\"]::-moz-range-thumb {\n\tbackground: var(--color-primary);\n\tborder: 0;\n\twidth: var(--thumb-width, 1.125em);\n\tborder-radius: var(--thumb-width, 1.125em);\n\tcursor: grab;\n}\n\ninput[type=\"range\"]:active::-moz-range-thumb {\n\tcursor: grabbing;\n}\n\ninput[type=\"range\"]::-moz-range-track {\n\twidth: 100%;\n\tbackground: rgba(0, 0, 0, 0.2);\n}\n\ninput[type=\"range\"]::-moz-range-progress {\n\tappearance: none;\n\tbackground: var(--color-primary);\n\ttransition-delay: 30ms;\n}\n\ninput[type=\"range\"]::-moz-range-track,\ninput[type=\"range\"]::-moz-range-progress {\n\theight: calc(0.125em + 1px);\n\tborder-radius: 0.125em;\n}\n\ninput[type=\"range\"]:disabled::-moz-range-thumb {\n\tcursor: not-allowed;\n}\n\n/* course filter range CSS ends */\n\n@-webkit-keyframes eduvibeFadeInUp {\n\t0% {\n\t\topacity: 0;\n\t\t-webkit-transform: translateY(30%);\n\t\ttransform: translateY(30%);\n\t}\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n@keyframes eduvibeFadeInUp {\n\t0% {\n\t\topacity: 0;\n\t\t-webkit-transform: translateY(30%);\n\t\ttransform: translateY(30%);\n\t}\n\tto {\n\t\topacity: 1;\n\t\t-webkit-transform: none;\n\t\ttransform: none;\n\t}\n}\n\n.eduvibeFadeInUp {\n\t-webkit-animation-name: eduvibeFadeInUp;\n\tanimation-name: eduvibeFadeInUp;\n}\n\n@media (max-width: 991px) {\n\t.eduvibe-masonry-grid {\n\t\tmargin-top: 45px;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.container,\n\t.container-lg,\n\t.container-md,\n\t.container-sm,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 1250px;\n\t}\n}\n\n@media (min-width: 1400px) {\n\t.container,\n\t.container-lg,\n\t.container-md,\n\t.container-sm,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 1500px;\n\t}\n}\n@media (min-width: 1440px) {\n\t.container,\n\t.container-lg,\n\t.container-md,\n\t.container-sm,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 1380px;\n\t}\n}\n@media (min-width: 1920px) {\n\t.container,\n\t.container-lg,\n\t.container-md,\n\t.container-sm,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 1380px;\n\t}\n}\n@media (min-width: 2560px) {\n\t.container,\n\t.container-lg,\n\t.container-md,\n\t.container-sm,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 2175px;\n\t}\n}\n","/*-------------------------\n    Blog Grid Styles  \n---------------------------*/\n.blog-shape-position {\n    position: relative;\n    z-index: 1;\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        top: 171px;\n        left: 138px;\n    }\n    &.shape-position-3 { \n        .shape-image {\n            top: 70px;\n            left: 106px;\n        }\n    }\n}\n\n.blog-meta {\n    @extend %liststyle;\n    display: flex;\n    flex-wrap: wrap;\n    margin: -5px -25px;\n    @media #{$lg-layout} {\n        margin: -5px -10px;\n    }\n    @media #{$md-layout} {\n        margin: -5px -10px;\n    }\n    @media #{$sm-layout} {\n        margin: -5px -10px;\n    }\n    li {\n        margin: 5px 25px;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n\n        @media #{$lg-layout} {\n            margin: 5px 10px;\n        }\n        @media #{$md-layout} {\n            margin: 5px 10px;\n        }\n        @media #{$sm-layout} {\n            margin: 5px 10px;\n        }\n        \n        i,\n        img {\n            padding-right: 8px;\n            position: relative;\n            top: 2px;\n        }\n\n        a {\n            color: var(--color-primary);\n        }\n        &.blog-author a {\n            color: var(--color-body);\n        }\n    }\n}\n\n/* Blog Grid Styles  */\n.edu-blog {\n\n    .top-position {\n        position: absolute;\n        z-index: 2;\n        &.left-top {\n            left: 20px;\n            top: 20px;\n        }\n        &.left-bottom {\n            left: 0;\n            bottom: 0;\n            border-radius: 0px 5px 0px 0px;\n        }\n    }\n\n    .thumbnail {\n        position: relative;\n        a {\n            display: block;\n            overflow: hidden;\n            img {\n                transition: 0.4s;\n                overflow: hidden;\n                width: 100%;\n            }\n        }\n    }\n\n    .blog-card-bottom {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    &.blog-type-1 {\n        background: var(--color-shade);\n        overflow: hidden;\n        position: relative;\n        .inner {\n            .content {\n                padding: 35px;\n                @media #{$sm-layout} {\n                    padding: 22px;\n                }\n                .blog-meta {\n                    margin-bottom: 20px;\n                }\n                .title {\n                    margin-bottom: 25px;\n                    @media #{$sm-layout} {\n                        margin-bottom: 14px;\n                    }\n                }\n                .description {\n                    font-weight: 500;\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n    &.blog-type-2 {\n        background: var(--color-shade);\n        overflow: hidden;\n        position: relative;\n        transition: 0.4s;\n        .inner {\n            .thumbnail {\n                img {\n                    border-top-left-radius: 5px;\n                    border-top-right-radius: 5px;\n                }\n            }\n            .content {\n                padding: 30px;\n                @media #{$md-layout} {\n                    padding: 20px;\n                }\n                @media #{$sm-layout} {\n                    padding: 20px;\n                }\n                .title {\n                    margin-bottom: 20px;\n                    margin-top: 20px;\n                    @media #{$sm-layout} {\n                        margin-bottom: 14px;\n                        margin-top: 14px;\n                    }\n                }\n            }\n        }\n\n        &.variation-2 {\n            padding: 15px;\n            background: #FFFFFF;\n            transition: 0.4s;\n            .inner {\n                .content {\n                    padding: 15px;\n                    padding-top: 0;\n                    .blog-date-status {\n                        width: 64px;\n                        height: 64px;\n                        background: var(--color-primary);\n                        border-radius: 100%;\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        justify-content: center;\n                        margin-top: -32px;\n                        margin-bottom: 18px;\n                        position: relative;\n                        z-index: 1;\n                        span {\n                            font-weight: bold;\n                            font-size: 20px;\n                            display: block;\n                            color: var(--color-white);\n                            text-align: center;\n                            &.day {\n                                line-height: 1;\n                                margin-bottom: 1px;\n                            }\n                            &.month {\n                                line-height: 1;\n                            }\n                        }\n                    }\n                    .title {\n                        margin-bottom: 0;\n                        margin-top: 14px;\n                    }\n                }\n            }\n            &:hover {\n                box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.04);\n            }\n        }\n        \n        &:hover {\n            background: var(--color-white);\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);\n        }\n\n        &.bg-white {\n            background: var(--color-white);\n            &:hover {\n                background: var(--color-white);\n                box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);\n            }\n        }\n    }\n\n    &.blog-type-3 {\n        background: var(--color-shade);\n        overflow: hidden;\n        position: relative;\n        transition: 0.4s;\n        .inner {\n            padding: 30px;\n            .content {\n                .title {\n                    margin-bottom: 30px;\n                    margin-top: 20px;\n                    @media #{$sm-layout} {\n                        margin-bottom: 20px;\n                    }\n                }\n            }\n            .thumbnail {\n                margin-top: 30px;\n                overflow: hidden;\n                a {\n                    border-radius: 3px;\n                    img {\n                        border-radius: 3px;\n                    }\n                }\n            }\n        }\n        &:hover {\n            background: var(--color-white);\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);\n        }\n    }\n    &.blog-type-4 {\n        background: var(--color-white);\n        overflow: hidden;\n        position: relative;\n        height: 100%;\n        .inner {\n            .content {\n                padding: 25px 30px;\n                .blog-meta {\n                    margin: -5px -7.5px;\n                    li {\n                        font-size: 14px;\n                        line-height: 22px;\n                        margin: 5px 7.5px;\n                    }\n                }\n                .title {\n                    margin-bottom: 15px;\n                    font-weight: 700;\n                    font-size: 18px;\n                    line-height: 28px;\n                }\n                \n            }\n        }\n    }\n\n    &:hover {\n        .inner {\n            .thumbnail {\n                a {\n                    img {\n                        transform: scale(1.1);\n                    }\n                }\n            }\n        }\n    }\n\n    &.blog-overlay-transparent {\n        position: relative;\n        .thumbnail {\n            overflow: hidden;\n            a {\n                position: relative;\n                display: block;\n                overflow: hidden;\n                border-radius: 5px;\n                &::after {\n                    background: linear-gradient(180deg, rgba(45, 40, 78, 0) 0%, #2D284E 100%);\n                    border-radius: 5px;\n                    position: absolute;\n                    content: \"\";\n                    left: 0;\n                    bottom: 0;\n                    width: 100%;\n                    height: 100%;\n                }\n                img {\n                    border-radius: 5px;\n                    overflow: hidden;\n                }\n            }\n        }\n        .content {\n            position: absolute;\n            bottom: 0;\n            padding: 40px;\n            left: 0;\n            @media #{$sm-layout} {\n                padding: 20px;\n            }\n            .eduvibe-status-list {\n                margin-bottom: 5px;\n                .eduvibe-status-transparent {\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 26px;\n                    color: var(--color-white);\n                    display: inline-block;\n                }\n            }\n            \n            .title {\n                margin-bottom: 25px;\n                font-weight: 700;\n                font-size: 32px;\n                line-height: 44px;\n                @media #{$sm-layout} {\n                    margin-bottom: 16px;\n                    font-size: 24px;\n                    line-height: 32px;\n                }\n                a {\n                    color: var(--color-white);\n                }\n            }\n            .blog-meta {\n                margin: -5px -7.5px;\n                li {\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 26px;\n                    margin: 5px 7.5px;\n                    color: var(--color-white);\n                    a {\n                        color: var(--color-white);\n                    }\n                }\n            }\n        }\n    }\n}\n","/*--------------------------\n    Blog Sidebar Styles \n----------------------------*/\n.edu-blog-widget {\n    background: #F5F5F5;\n    border-radius: 5px;\n    padding: 30px;\n    @media #{$sm-layout} {\n        padding: 20px;\n    }\n    .widget-title {\n        padding-bottom: 20px;\n        margin-bottom: 28px;\n        border-bottom: 1px solid rgba(45,40,78,0.07);\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n    }\n\n    &.widget-search {\n        .blog-search {\n            position: relative;\n            input {\n                border: 0 none;\n                background: var(--color-white);\n                height: 60px;\n                width: 100%;\n                border-radius: 3px;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 22px;\n                padding: 0 72px 0 25px;\n            }\n            .search-button {\n                position: absolute;\n                right: 0;\n                top: 0;\n                background-color: var(--color-primary);\n                border: 0 none;\n                height: 100%;\n                width: 60px;\n                text-align: center;\n                color: var(--color-white);\n                font-size: 20px;\n                border-radius: 0px 3px 3px 0px;\n            }\n        }\n    }\n\n    &.widget-categories {\n        .category-list {\n            @extend %liststyle;\n            li {\n                margin: 0;\n                a {\n                    background: #FFFFFF;\n                    border-radius: 3px;\n                    height: 60px;\n                    line-height: 60px;\n                    padding: 0 25px;\n                    display: flex;\n                    justify-content: space-between;\n                    position: relative;\n                    &::after {\n                        position: absolute;\n                        content: \"\";\n                        background: #EEEEEE;\n                        height: 30px;\n                        width: 1px;\n                        right: 60px;\n                        top: 50%;\n                        transform: translateY(-50%);\n                    }\n                    span {\n\n                    }\n                }\n                & + li {\n                    margin-top: 15px;\n                }\n            }\n        }\n    }\n\n    &.widget-latest-post {\n        .latest-post {\n            display: flex;\n            align-items: center;\n            position: relative;\n            .thumbnail {\n                margin-right: 25px;\n                @media #{$sm-layout} {\n                    margin-right: 10px;\n                }\n                a {\n                    img {\n                        border-radius: 3px;\n                        max-height: 96px;\n                        object-fit: cover;\n                    }\n                }\n            }\n            .post-content {\n                .blog-meta {\n                    li {\n\n                    }\n                }\n                .title {\n                    font-weight: 700;\n                    font-size: 18px;\n                    line-height: 28px;\n                    margin-bottom: 0;\n                }\n            }\n\n            & + .latest-post {\n                padding-top: 20px;\n                margin-top: 20px;\n                &::after {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 1px;\n                    background: rgba(45,40,78,0.07);\n                    content: \"\";\n                }\n            }\n        }\n    }\n\n    &.widget-about {\n        .about-wrapper {\n            text-align: center;\n            .thumbnail {\n                margin-bottom: 20px;\n                img {\n                    max-height: 160px;\n                    border-radius: 100%;\n                }\n            }\n            .about-content {\n                .title {\n                    margin-bottom: 15px;\n                }\n                p {\n                    margin-bottom: 20px;\n                }\n            }\n        }\n    }\n\n    &.widget-instagram {\n        .instagram-list {\n            display: flex;\n            flex-wrap: wrap;\n            margin: -7.5px;\n            a {\n                flex-basis: 33.33%;\n                display: block;\n                padding: 7.5px;\n                @media #{$md-layout} {\n                    flex-basis: 20%;\n                }\n                @media #{$sm-layout} {\n                    flex-basis: 20%;\n                }\n                @media #{$large-mobile} {\n                    flex-basis: 50%;\n                }\n                img {\n                    border-radius: 3px;\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n.tag-list {\n    margin: -5px;\n    a {\n        background: #FFFFFF;\n        border-radius: 2px;\n        display: inline-block;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 40px;\n        margin: 5px;\n        height: 40px;\n        padding: 0 14px;\n        transition: 0.4s;\n        &:hover {\n            background: var(--color-primary) !important;\n            color: var(--color-white);\n        }\n    }\n    &.bg-shade {\n        a {\n            background: #F5F5F5;\n            \n        }\n    }\n}\n\n\n/*-----------------------------\n    Sidebar Style Two  \n-------------------------------*/\n.edu-blog-widget-2 {\n    .widget-title {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n        margin-bottom: 30px;\n    }\n\n    &.widget-search {\n        .blog-search {\n            position: relative;\n            input {\n                border: 0 none;\n                background: #F5F5F5;\n                height: 60px;\n                width: 100%;\n                border-radius: 3px;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 22px;\n                padding: 0 72px 0 25px;\n            }\n            .search-button {\n                position: absolute;\n                right: 0;\n                top: 0;\n                background-color: transparent;\n                border: 0 none;\n                height: 100%;\n                width: 60px;\n                text-align: center;\n                color: var(--color-primary);\n                font-size: 20px;\n                border-radius: 0;\n            }\n        }\n    }\n\n\n    &.widget-categories {\n        .category-list {\n            @extend %liststyle;\n            li {\n                margin: 0;\n                a {\n                    display: flex;\n                    justify-content: space-between;\n                    position: relative;\n                    span {\n\n                    }\n                }\n                & + li {\n                    padding-top: 15px;\n                    margin-top: 15px;\n                    border-top: 1px solid #EEEEEE;\n                }\n            }\n        }\n    }\n\n    &.widget-latest-post {\n        .latest-post {\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            .thumbnail {\n                margin-right: 25px;\n                a {\n                    display: block;\n                    img {\n                        border-radius: 5px;\n                        max-height: 100px;\n                        object-fit: cover;\n                    }\n                }\n            }\n            .post-content {\n                .blog-meta {\n                    li {\n\n                    }\n                }\n                .title {\n                    font-weight: 700;\n                    font-size: 18px;\n                    line-height: 28px;\n                    margin-bottom: 0;\n                }\n            }\n\n            & + .latest-post {\n                padding-top: 20px;\n                margin-top: 20px;\n                &::after {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 1px;\n                    background: rgba(45,40,78,0.07);\n                    content: \"\";\n                }\n            }\n        }\n    }\n\n\n   \n\n\n\n\n}\n","/*----------------------------\n    Blog Details Styles  \n------------------------------*/\n\n.social-share-action {\n    position: relative;\n    .social-share-hover-action {\n        position: absolute;\n        bottom: calc(100% + 16px);\n        background: #FFFFFF;\n        box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);\n        border-radius: 4px;\n        padding: 15px;\n        min-width: 150px;\n        left: 50%;\n        transform: translateX(-50%);\n        opacity: 0;\n        transition: 0.4s;\n        visibility: hidden;\n        &::after {\n            position: absolute;\n            content: \"\";\n            top: 100%;\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 10px 10px 0 10px;\n            border-color: #FFFFFF transparent transparent transparent;\n            left: 50%;\n            transform: translateX(-50%);\n        }\n        .inner {\n            margin: 0 -15px;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: center;\n            a {\n                display: inline-block;\n                margin: 0 15px;\n                color: var(--color-body);\n                transition: 0.4s;\n                &:hover {\n                    color: var(--color-primary);\n                }\n            }\n        }\n    }\n    &:hover {\n        .social-share-hover-action {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n\n.blog-details-1 {\n    .block-alignwide {\n        margin-left: -105px;\n        margin-right: -105px;\n        max-width: 1170px;\n        width: auto;\n\n        @media #{$lg-layout} {\n            margin-left: 0;\n            margin-right: 0;\n            max-width: initial;\n        }\n\n        @media #{$md-layout} {\n            margin-left: 0;\n            margin-right: 0;\n            max-width: initial;\n        }\n\n        @media #{$sm-layout} {\n            margin-left: 0;\n            margin-right: 0;\n            max-width: initial;\n        }\n\n        img {\n            width: 100%;\n        }\n    }\n}\n\n.content-blog-top {\n    .title {\n        margin-top: 10px;\n        margin-bottom: 25px;\n        font-size: 32px;\n    }\n    .blog-meta {\n        margin-bottom: 30px;\n        li.blog-author a {\n            color: var(--color-body);\n        }\n    }\n}\n\n.blog-main-content {\n    .gallery {\n        @extend %liststyle;\n        display: flex;\n        flex-wrap: wrap;\n        margin: -15px;\n        margin-bottom: 15px;\n        li {\n            padding: 15px;\n            margin: 0;\n            img {\n                border-radius: 5px;\n            }\n        }\n        &.gallery-column-2 {\n            li {\n                flex-basis: 50%;\n                @media #{$large-mobile} {\n                    flex-basis: 100%;\n                }\n            }\n        }\n    }\n\n    \n\n    .blockquote-style-1 {\n        border-radius: 4px;\n        background: var(--color-primary);\n        padding: 25px 50px;\n        color: var(--color-white);\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 32px;\n        font-style: normal;\n        margin-bottom: 30px;\n        position: relative;\n        z-index: 1;\n        @media #{$sm-layout} {\n            padding: 25px;\n        }\n        .quote-image {\n            position: absolute;\n            right: 30px;\n            bottom: 28px;\n            opacity: 0.2;\n            z-index: -1;\n        }\n    }\n\n}\n\n\n.list-style-1 {\n    @extend %liststyle;\n    li {\n        display: flex;\n        align-items: flex-start;\n        margin: 15px 0;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        i {\n            color: var(--color-primary);\n            margin-right: 13px;\n            margin-top: 5px;\n        }\n    }\n}\n\n.list-style-2 {\n    @extend %liststyle;\n    list-style: disc;\n    padding-left: 17px;\n    margin-bottom: 20px;\n    \n    li {\n        margin: 15px 0;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n    }\n}\n\n.column-gallery {\n    @extend %liststyle;\n    display: flex;\n    flex-wrap: wrap;\n    margin: -15px;\n    margin-bottom: 15px;\n    li {\n        padding: 15px;\n        margin: 0;\n        img {\n            border-radius: 5px;\n        }\n    }\n    &.gallery-column-2 {\n        li {\n            flex-basis: 50%;\n            @media #{$large-mobile} {\n                flex-basis: 100%;\n            }\n        }\n    }\n}\n\n.blog-tag-and-share {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #EEEEEE;\n    flex-wrap: wrap;\n\n    @media #{$large-mobile} {\n        display: block;\n    }\n\n    .blog-share {\n        display: flex;\n        align-items: center;\n\n        @media #{$large-mobile} {\n            margin-top: 20px;\n        }\n\n        .title {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 28px;\n            color: var(--color-heading);\n            padding-right: 20px;\n        }\n    }\n    .share-btn {\n        width: 40px;\n        height: 40px;\n        background: #F5F5F5;\n        border-radius: 2px;\n        padding: 0;\n        border: 0 none;\n        color: var(--color-primary);\n        transition: 0.4s;\n        &:hover {\n            background: var(--color-primary);\n            color: var(--color-white);\n        }\n    }\n}\n\n.blog-author-wrapper {\n    padding: 30px 0;\n    display: flex;\n    @media #{$large-mobile} {\n        display: block;\n    }\n    .thumbnail {\n        min-width: 160px;\n        max-height: 160px;\n        margin-right: 40px;\n        @media #{$sm-layout} {\n            margin-right: 20px;\n        }\n        @media #{$large-mobile} {\n            min-width: auto;\n            max-height: initial;\n            margin-right: 0;\n            margin-bottom: 20px;\n        }\n        img {\n            height: 100%;\n            object-fit: cover;\n            border-radius: 5px;\n        }\n    }\n    .author-content {\n        .title {\n            margin-bottom: 10px;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n        .social-share {\n            &.icon-transparent {\n                margin: 0 -15px;\n                li {\n                    margin: 0 15px;\n                    a {\n                        color: var(--color-primary);\n                        font-size: 14px;\n                    }\n                }\n            }\n        }\n    }\n\n}\n\n/*---------------------------\n    Blog Details Style Two  \n------------------------------*/\n.style-variation2 {\n    .content-blog-top {\n        .title {\n            margin-top: 0;\n        }\n        .blog-meta {\n            margin-bottom: 25px;\n            li.blog-author a {\n                color: var(--color-body);\n            }\n        }\n    }\n\n    .blockquote-style-1 {\n        background: #F5F5F5;\n        border-radius: 4px;\n        border-left: 3px solid var(--color-primary);\n        color: var(--color-heading);\n        .quote-image {\n            opacity: 0.7;\n        }\n    }\n}\n\n\n\n/*---------------------------\n    Blog Details Style 3  \n------------------------------*/\n.style-variation3 {\n    .content-blog-top {\n        .title {\n            margin-top: 0;\n            margin-bottom: 30px;\n        }\n        .blog-meta {\n            margin-bottom: 0;\n            li.blog-author a {\n                color: var(--color-body);\n            }\n        }\n    }\n    .blockquote-style-1 {\n        background: #FFFFFF;\n        border-radius: 5px;\n        border-top: 3px solid var(--color-primary);\n        color: var(--color-primary);\n        box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);\n        text-align: center;\n        padding: 25px 68px;\n        \n        @media #{$md-layout} {\n            padding: 25px 30px;\n        }\n\n        @media #{$sm-layout} {\n            padding: 25px 30px;\n        }\n        .quote-image {\n            opacity: 0.7;\n            right: 15px;\n            bottom: 8px;\n        }\n    }\n}","/*-----------------------------\n    Blog Comments Style  \n------------------------------*/\n\n\n.comment-list-wrapper {\n    .comment {\n        display: flex;\n        @media #{$large-mobile} {\n            flex-direction: column;\n            .comment-content {\n                margin-top: 20px;\n            }\n        }\n        .thumbnail {\n            min-width: 70px;\n            width: 70px;\n            max-height: 70px;\n            border-radius: 100%;\n            margin-right: 25px;\n            img {\n                border-radius: 100%;\n                width: 100%;\n            }\n        }\n        .comment-content {\n            .title {\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 32px;\n                margin-bottom: 0;\n            }\n            .date {\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n                color: var(--color-body);\n                display: block;\n                margin-bottom: 20px;\n            }\n            p {\n                margin-bottom: 20px;\n            }\n\n            .reply-btn {\n                display: flex;\n                align-items: center;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 26px;\n                i {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        & + .comment {\n            border-top: 1px solid #EEEEEE;\n            padding-top: 30px;\n            margin-top: 30px;\n        }\n    }\n}\n\n\n\n\n\n\n/*-----------------------------\n    Blog Comments Form\n------------------------------*/\n.comment-form-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    .blog-page-title {\n        margin-bottom: 0;\n    }\n    .cancle-btn {\n        a {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 28px;\n            transition: 0.3s;\n            &:hover {\n                color: var(--color-primary);\n            }\n        }\n    }\n}\n\n\n\n.comment-form-style-1 {\n\n    .comment-note {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        margin-bottom: 20px;\n    }\n\n    input,\n    textarea {\n        background: #F5F5F5;\n        border-radius: 5px; \n        border: 0 none;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        border: 1px solid transparent;\n        &:focus {\n            border-color: var(--color-primary);\n        }\n    }\n    input {\n        padding: 0 30px;\n        height: 60px;\n        line-height: 60px;\n    }\n    textarea {\n        min-height: 180px;\n        padding: 17px 30px;\n    }\n}\n\n\n/*--------------------------------\n    Blog Style Pagination \n---------------------------------*/ \n.blog-pagination-list {\n    background-color: #F5F5F5;\n    border-radius: 5px;\n    background-image: inherit;\n    transition: 0.4s;\n    position: relative;\n    z-index: 2;\n    &::after {\n        position: absolute;\n        content: \"\";\n        background-image: url(../../images/bg/bg-image-28.jpg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center center;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: -1;\n        opacity: 0;\n        transition: 0.4s;\n        border-radius: 5px;\n    }\n    a {\n        display: flex;\n        align-items: center;\n        padding: 30px;\n        position: relative;\n        z-index: 1;\n        color: var(--color-body);\n        span {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 28px;\n            transition: 0.4s;\n            position: relative;\n            z-index: 2;\n        }\n        i {\n            font-size: 20px;\n            transition: 0.4s;\n            margin-right: 20px;\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            background:#2D284E;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            z-index: -1;\n            opacity: 0;\n            transition: 0.4s;\n            opacity: 0;\n            border-radius: 5px;\n        }\n    }\n    &:hover {\n        &::after {\n            opacity: 1;\n        }\n        a {\n            color: var(--color-white);\n            &::before {\n                opacity: 0.79;\n            }\n        }\n    }\n\n    &.next-post {\n        text-align: right;\n        a {\n            i {\n                margin-right: 0;\n                margin-left: 20px;\n            }\n        }\n    }\n\n\n    &.style-variation-2 {\n        transition: 0.4s;\n        border-bottom: 2px solid transparent;\n       \n        a {\n            color: var(--color-heading);\n            &::before {\n                display: none;\n            }\n        }\n        &::after {\n            display: none;\n        }\n        &:hover {\n            background: #FFFFFF;\n            border-color: var(--color-primary);\n            box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.06);\n        }\n    }\n}","/*-----------------------\n * Banner Style One\n------------------------*/\n\n.height-850 {\n\tmin-height: 850px;\n\twidth: 100%;\n\tpadding: 240px 0 190px;\n\t@media #{$sm-layout} {\n\t\tmin-height: auto;\n\t\twidth: 100%;\n\t\tpadding: 250px 0;\n\t}\n}\n\n.height-940 {\n\tmin-height: 940px;\n\twidth: 100%;\n\t@media #{$sm-layout} {\n\t\tmin-height: auto;\n\t\twidth: 100%;\n\t\tpadding: 250px 0;\n\t}\n}\n\n.banner-style-1 {\n\tposition: relative;\n\tbackground-image: url(../../images/bg/home-one-banner.jpg);\n\tz-index: 2;\n\t@media #{$lg-layout} {\n\t\theight: auto;\n\t\tmin-height: auto;\n\t\tpadding: 100px 0;\n\t\tpadding-top: 150px;\n\t}\n\t@media #{$md-layout} {\n\t\theight: auto;\n\t\tmin-height: auto;\n\t\tpadding: 100px 0;\n\t\tpadding-top: 150px;\n\t}\n\t@media #{$sm-layout} {\n\t\theight: auto;\n\t\tmin-height: auto;\n\t\tpadding: 100px 0;\n\t\tpadding-top: 150px;\n\t}\n\n\t.banner-right-content {\n\t\tposition: relative;\n\t\tmargin-top: 138px;\n\t\t@media #{$smlg-device} {\n\t\t\tmargin-top: 0px;\n\t\t}\n\t\t.edu-card {\n\t\t\tmin-width: 272px;\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmin-width: inherit;\n\t\t\t}\n\t\t}\n\t}\n\n\t.banner-left-content {\n\t\tmargin-top: 120px;\n\t\t@media #{$smlg-device} {\n\t\t\tmargin-top: 0;\n\t\t}\n\t}\n\n\t.inner {\n\t\t.content {\n\t\t\t.pre-title {\n\t\t\t\tletter-spacing: 0.1em;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-weight: 800;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t.title {\n\t\t\t\tfont-weight: 800;\n\t\t\t\tfont-size: 72px;\n\t\t\t\tline-height: 1.25;\n\t\t\t\tmargin-bottom: 30px;\n\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tfont-size: 52px;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tfont-size: 45px;\n\t\t\t\t}\n\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tfont-size: 38px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.description {\n\t\t\t\tmargin-bottom: 60px;\n\t\t\t\tpadding-left: 20px;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 32px;\n\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 28px;\n\t\t\t\t}\n\t\t\t\t&::before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 73%;\n\t\t\t\t\tbackground: var(--color-primary);\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.work-shop {\n\t\tmin-width: 193px;\n\t\tmax-width: 193px;\n\t\tbackground: var(--color-white);\n\t\tpadding: 20px;\n\t\tbox-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);\n\t\tborder-radius: 5px;\n\t\tmargin: 25px -15px 0 auto;\n\t\t@media #{$lg-layout} {\n\t\t\tmin-width: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tmargin-right: 0;\n\t\t}\n\n\t\t@media #{$md-layout} {\n\t\t\tmin-width: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tmargin-right: 0;\n\t\t}\n\n\t\t@media #{$sm-layout} {\n\t\t\tmargin-right: 0;\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.inner {\n\t\t\t.thumbnail {\n\t\t\t\timg {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.content {\n\t\t\t\t.title {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 28px;\n\t\t\t\t\tmargin: 10px 0 0;\n\t\t\t\t}\n\n\t\t\t\t.time {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 22px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-round {\n\t\tposition: absolute;\n\t\tleft: -312px;\n\t\ttop: 130px;\n\t\tz-index: -1;\n\t}\n\n\t.scroll-down-btn {\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: calc(50% - 30px);\n\t\ttransform: translateY(-50%);\n\t\tz-index: 1;\n\t}\n\n\t.shape-dot-wrapper {\n\t\t.shape {\n\t\t\tposition: absolute;\n\t\t\tz-index: -1;\n\n\t\t\t&.shape-1 {\n\t\t\t\ttop: 97px;\n\t\t\t\tleft: -189px;\n\t\t\t}\n\n\t\t\t&.shape-2 {\n\t\t\t\ttop: 53px;\n\t\t\t\tleft: 580px;\n\t\t\t}\n\n\t\t\t&.shape-3 {\n\t\t\t\ttop: 95px;\n\t\t\t\tright: -160px;\n\t\t\t}\n\n\t\t\t&.shape-4 {\n\t\t\t\tbottom: 10px;\n\t\t\t\tright: -173px;\n\t\t\t}\n\n\t\t\t&.shape-5 {\n\t\t\t\tbottom: -23px;\n\t\t\t\tleft: 654px;\n\t\t\t}\n\n\t\t\t&.shape-6 {\n\t\t\t\tbottom: -37px;\n\t\t\t\tleft: -255px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.eduvibe-hero-one-video {\n\t\t.thumbnail {\n\t\t\tmargin: 30px -149px 0 -23px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tmargin: 0 -70px 0 -30px;\n\t\t\t}\n\t\t\t@media #{$smlg-device} {\n\t\t\t\tmargin: 0 -30px 0 -30px;\n\t\t\t}\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tmargin: -30px 0 0 -30px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*-------------------------\n    Banner Style Two  \n--------------------------*/\n.banner-style-2 {\n\tbackground-image: url(../../images/bg/home-two-banner.jpg);\n\tposition: relative;\n\tz-index: 1;\n\tmin-height: 930px;\n\n\t@media #{$smlg-device} {\n\t\tmin-height: 800px;\n\t}\n\n\t@media #{$lg-layout} {\n\t\tpadding: 0 30px;\n\t}\n\n\t@media #{$md-layout} {\n\t\tpadding: 150px 30px;\n\t\theight: auto;\n\t\tpadding-bottom: 0;\n\t}\n\n\t@media #{$sm-layout} {\n\t\tpadding: 150px 0px;\n\t\theight: auto;\n\t\tpadding-bottom: 0;\n\t}\n\n\t.inner {\n\t\tposition: relative;\n\t\tmargin-top: 100px;\n\t\t@media #{$smlg-device} {\n\t\t\tmargin-top: 0px;\n\t\t}\n\t\t.content {\n\t\t\t.pre-title {\n\t\t\t\tletter-spacing: 0.1em;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-weight: 800;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding-left: 60px;\n\t\t\t\tposition: relative;\n\n\t\t\t\t&::before {\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 13px;\n\t\t\t\t\twidth: 50px;\n\t\t\t\t\theight: 2px;\n\t\t\t\t\tbackground: var(--color-primary);\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.title {\n\t\t\t\tfont-weight: 800;\n\t\t\t\tfont-size: 68px;\n\t\t\t\tline-height: 1.24;\n\t\t\t\tmargin-bottom: 30px;\n\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tfont-size: 45px;\n\t\t\t\t}\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tfont-size: 38px;\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t\t@media #{$large-mobile} {\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.description {\n\t\t\t\tmargin-bottom: 60px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 32px;\n\t\t\t\t@media #{$md-layout} {\n\t\t\t\t\tmargin-bottom: 40px;\n\t\t\t\t}\n\t\t\t\t@media #{$sm-layout} {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 28px;\n\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.arrow-sign {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -30px;\n\t\t\t\tbottom: -50px;\n\t\t\t\timg {\n\t\t\t\t\tmax-width: 70%;\n\t\t\t\t}\n\t\t\t\t@media #{$custom-lg-device-three} {\n\t\t\t\t\tright: -50px;\n\t\t\t\t\tbottom: -90px;\n\t\t\t\t\timg {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@media #{$laptop-device} {\n\t\t\t\t\tright: -50px;\n\t\t\t\t\tbottom: -30px;\n\t\t\t\t\timg {\n\t\t\t\t\t\tmax-width: 50%;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@media #{$lg-layout} {\n\t\t\t\t\tright: -110px;\n\t\t\t\t\tbottom: -12px;\n\t\t\t\t\timg {\n\t\t\t\t\t\tmax-width: 40%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.banner-thumbnail {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 111px;\n\t\tz-index: 1;\n\n\t\t@media #{$laptop-device} {\n\t\t\tright: 31px;\n\t\t}\n\t\timg {\n\t\t\tmax-width: calc(100% - 60px);\n\t\t}\n\t\t@media #{$custom-laptop-device} {\n\t\t\tright: 0;\n\t\t\timg.girl-thumb {\n\t\t\t\tmax-width: 90%;\n\t\t\t}\n\t\t}\n\n\t\t@media #{$smlg-device} {\n\t\t\tright: -138px;\n\t\t\timg.girl-thumb {\n\t\t\t\tmax-width: 80%;\n\t\t\t}\n\t\t}\n\n\t\t@media #{$md-layout} {\n\t\t\tposition: static;\n\t\t\ttext-align: right;\n\t\t\tmargin-top: -110px;\n\t\t\timg.girl-thumb {\n\t\t\t\tmax-width: 70%;\n\t\t\t}\n\t\t}\n\n\t\t@media #{$sm-layout} {\n\t\t\tposition: static;\n\t\t\timg.girl-thumb {\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\t}\n\n\t.banner-bg {\n\t\tposition: absolute;\n\t\tbottom: 3px;\n\t\tright: 67px;\n\t\tz-index: 0;\n\n\t\t@media #{$custom-laptop-device} {\n\t\t\tright: 0;\n\t\t}\n\t\timg.girl-bg {\n\t\t\tmax-width: calc(90% - 10px);\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tmax-width: 90%;\n\t\t\t}\n\t\t}\n\n\t\t@media #{$laptop-device} {\n\t\t\tright: -40px;\n\t\t}\n\n\t\t@media #{$smlg-device} {\n\t\t\tright: -218px;\n\t\t\timg.girl-bg {\n\t\t\t\tmax-width: 80%;\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.shape-image-1 {\n\t\t\ttop: 231px;\n\t\t\tleft: 50px;\n\t\t\t@media #{$laptop-device} {\n\t\t\t\ttop: 170px;\n\t\t\t\tleft: -10px;\n\t\t\t}\n\t\t}\n\n\t\t&.shape-image-2 {\n\t\t\ttop: 240px;\n\t\t\tright: 43%;\n\t\t}\n\n\t\t&.shape-image-3 {\n\t\t\ttop: 250px;\n\t\t\tright: 90px;\n\t\t}\n\t}\n}\n\n/*-------------------------\n    Banner Style Three  \n--------------------------*/\n\n.banner-style-3 {\n\tposition: relative;\n\tz-index: 1;\n\toverflow: hidden;\n\tbackground-image: url(../../images/bg/home-three-banner.jpg);\n\t@media #{$small-tablet} {\n\t\tpadding: 160px 0 100px;\n\t\t.height-940 {\n\t\t\theight: inherit;\n\t\t\tmin-height: inherit;\n\t\t}\n\t}\n\t@media #{$sm-layout} {\n\t\tpadding: 140px 0 70px;\n\t\t.height-940 {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\t.content {\n\t\tmargin-top: 90px;\n\t\t@media #{$small-tablet} {\n\t\t\tmargin-top: 0px;\n\t\t}\n\t\t.pre-title {\n\t\t\tletter-spacing: 0.1em;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tcolor: var(--color-primary);\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t.title {\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 68px;\n\t\t\tline-height: 1.25;\n\t\t\tmargin-bottom: 25px;\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tfont-size: 50px;\n\t\t\t}\n\t\t\t@media #{$md-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t}\n\t\t}\n\n\t\t.description {\n\t\t\tmargin-bottom: 60px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 32px;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 28px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.banner-image {\n\t\t.banner-main-image {\n\t\t\tmargin-right: -45px;\n\t\t\tmargin-bottom: -260px;\n\t\t\ttext-align: right;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tmargin-right: 70px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tmargin-right: 50px;\n\t\t\t}\n\t\t\t@media #{$small-tablet} {\n\t\t\t\tmargin-right: 0;\n\t\t\t\ttext-align: left;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t\t.img-02 {\n\t\t\tposition: absolute;\n\t\t\tright: -232px;\n\t\t\tbottom: 125px;\n\t\t\t@media #{$custom-lg-device-six} {\n\t\t\t\tright: -152px;\n\t\t\t\tbottom: 190px;\n\t\t\t\tmax-width: 240px;\n\t\t\t}\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tright: -88px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tright: -88px;\n\t\t\t\tmax-width: 240px;\n\t\t\t}\n\t\t\t@media #{$small-tablet} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t.img-03 {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\tbottom: 435px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tright: 140px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tright: 90px;\n\t\t\t\tbottom: 345px;\n\t\t\t}\n\t\t\t@media #{$small-tablet} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.shape-image-1 {\n\t\t\tleft: -114px;\n\t\t\ttop: 30px;\n\t\t}\n\n\t\t&.shape-image-2 {\n\t\t\tright: 45%;\n\t\t\ttop: 105px;\n\t\t}\n\n\t\t&.shape-image-3 {\n\t\t\tright: -260px;\n\t\t\ttop: 20px;\n\t\t}\n\n\t\t&.shape-image-4 {\n\t\t\tright: -241px;\n\t\t\tbottom: -50px;\n\t\t}\n\n\t\t&.shape-image-5 {\n\t\t\tleft: -180px;\n\t\t\tbottom: -100px;\n\t\t}\n\t}\n}\n\n/*-------------------------\n    Banner Style Four  \n--------------------------*/\n\n.banner-style-4 {\n\tbackground-image: url(../../images/bg/home-four-banner.jpg);\n\tposition: relative;\n\tz-index: 1;\n\toverflow: hidden;\n\t.home-four-banner-wrapper {\n\t\tmin-height: 870px;\n\t\t@media #{$smlg-device} {\n\t\t\tmin-height: auto;\n\t\t\twidth: 100%;\n\t\t\twidth: 100%;\n\t\t\tpadding: 120px 0 100px;\n\t\t}\n\t\t@media #{$small-tablet} {\n\t\t\tpadding: 70px 0 150px;\n\t\t}\n\t}\n\t.banner-image {\n\t\tposition: relative;\n\t\tpadding: 35px;\n\t\tleft: 115px;\n\t\t@media #{$lg-layout} {\n\t\t\tpadding: 25px;\n\t\t\tleft: 10px;\n\t\t\ttransform: scale(0.9);\n\t\t}\n\t\t@media #{$md-layout} {\n\t\t\tleft: 0;\n\t\t\twidth: 74%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tleft: 0;\n\t\t\tmargin: 0 auto;\n\t\t\tpadding: 30px;\n\t\t}\n\t\t@media #{$large-mobile} {\n\t\t\tpadding: 20px;\n\t\t}\n\t\t.thumbnail {\n\t\t\timg {\n\t\t\t\twidth: 600px;\n\t\t\t\tmax-height: 600px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t\t.round-images {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\ttransition: 0.5s;\n\t\t}\n\t\t.learner-badge {\n\t\t\tbackground: #ffffff;\n\t\t\tbox-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n\t\t\tpadding: 10px;\n\t\t\twidth: 160px;\n\t\t\theight: 160px;\n\t\t\tborder-radius: 100%;\n\t\t\tposition: absolute;\n\t\t\tleft: -80px;\n\t\t\ttop: 25%;\n\n\t\t\t.badge-inner {\n\t\t\t\tbackground: #ffa41b;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tflex-direction: column;\n\n\t\t\t\tspan {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\tfont-weight: 600;\n\n\t\t\t\t\t&.viewer {\n\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\t\tline-height: 44px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.content {\n\t\t.pre-title {\n\t\t\tletter-spacing: 0.1em;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tcolor: var(--color-primary);\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t.title {\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 72px;\n\t\t\tline-height: 1.25;\n\t\t\tmargin-bottom: 25px;\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tfont-size: 50px;\n\t\t\t}\n\t\t\t@media #{$md-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t}\n\t\t}\n\n\t\t.description {\n\t\t\tmargin-bottom: 60px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 32px;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 28px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.shape-image-1 {\n\t\t\tleft: -110px;\n\t\t\ttop: -50px;\n\t\t}\n\n\t\t&.shape-image-2 {\n\t\t\tright: 48%;\n\t\t\ttop: -32px;\n\t\t}\n\n\t\t&.shape-image-3 {\n\t\t\tright: -210px;\n\t\t\ttop: 10px;\n\t\t}\n\n\t\t&.shape-image-4 {\n\t\t\tright: 360px;\n\t\t\tbottom: -90px;\n\t\t}\n\n\t\t&.shape-image-5 {\n\t\t\tleft: 463px;\n\t\t\tbottom: 270px;\n\t\t}\n\n\t\t&.shape-image-6 {\n\t\t\tleft: 150px;\n\t\t\tbottom: -100px;\n\t\t}\n\t\t&.shape-image-left {\n\t\t\tleft: 0;\n\t\t\tbottom: 8px;\n\t\t}\n\t\t&.shape-image-right {\n\t\t\tright: 0;\n\t\t\tbottom: 8px;\n\t\t}\n\t}\n\n\t.social-text-share {\n\t\t@extend %liststyle;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: -175px;\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse;\n\t\talign-items: center;\n\t\t@media #{$laptop-device} {\n\t\t\tleft: -105px;\n\t\t}\n\t\t@media #{$custom-laptop-device} {\n\t\t\tleft: -70px;\n\t\t}\n\t\t@media #{$smlg-device} {\n\t\t\tposition: absolute;\n\t\t\ttop: inherit;\n\t\t\ttransform: none;\n\t\t\tleft: 15px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tbottom: -40px;\n\t\t\tmargin: 0 -20px;\n\t\t}\n\t\t@media #{$small-tablet} {\n\t\t\tbottom: -65px;\n\t\t}\n\n\t\tli {\n\t\t\tmargin: 0;\n\t\t\ta {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 22px;\n\t\t\t\tmargin: 20px 0;\n\t\t\t\tposition: relative;\n\t\t\t\t@media #{$smlg-device} {\n\t\t\t\t\ttransform: none;\n\t\t\t\t\tmargin: 0px 20px;\n\t\t\t\t}\n\t\t\t\t&::before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tbackground: var(--color-primary);\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttransition: 0.4s;\n\t\t\t\t\theight: 2px;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\t&::before {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*-------------------------\n    Banner Style five  \n--------------------------*/\n\n.banner-style-5 {\n\tposition: relative;\n\tz-index: 1;\n\tbackground-image: url(../../images/bg/home-five-banner.jpg);\n\t.wrapper {\n\t\theight: 860px;\n\t\t@media #{$lg-layout} {\n\t\t\theight: auto;\n\t\t\tpadding-top: 120px;\n\t\t}\n\n\t\t@media #{$md-layout} {\n\t\t\theight: auto;\n\t\t\tpadding-top: 120px;\n\t\t}\n\n\t\t@media #{$sm-layout} {\n\t\t\theight: auto;\n\t\t\tpadding-top: 120px;\n\t\t}\n\t}\n\n\t.content {\n\t\t.title {\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 72px;\n\t\t\tline-height: 1.28;\n\t\t\tmargin-bottom: 30px;\n\n\t\t\t@media #{$laptop-device} {\n\t\t\t\tfont-size: 57px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t}\n\t\t\t@media #{$md-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\t\t.description {\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 32px;\n\t\t\tmargin-bottom: 60px;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t}\n\t\t.read-more-btn {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\n\t\t.video-btn-wrapper {\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-top: 20px;\n\t\t\t}\n\t\t}\n\t\t.video-play-btn {\n\t\t\twidth: 60px;\n\t\t\theight: 60px;\n\t\t\tbackground: rgba(251, 124, 86, 0.15);\n\t\t\tmargin: inherit;\n\t\t\tmargin-left: 30px;\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t\t&::before {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.play-icon {\n\t\t\t\t&::before {\n\t\t\t\t\tborder-top: 9px solid transparent;\n\t\t\t\t\tborder-bottom: 9px solid transparent;\n\t\t\t\t\tborder-left: 15px solid var(--color-secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.video-btn-wrapper {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.video-text {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 28px;\n\t\t\t\tmargin-left: 20px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tcolor: var(--color-heading);\n\t\t\t}\n\t\t}\n\t}\n\t.banner-image {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 13%;\n\t\t@media #{$custom-lg-device} {\n\t\t\tright: 4%;\n\t\t}\n\t\t@media #{$lg-layout} {\n\t\t\tposition: relative;\n\t\t\tbottom: 0;\n\t\t\tright: 0;\n\t\t}\n\t\t@media #{$md-layout} {\n\t\t\tposition: relative;\n\t\t\tbottom: 0;\n\t\t\tright: 0;\n\t\t\ttext-align: center;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tposition: relative;\n\t\t\tbottom: 0;\n\t\t\tright: 0;\n\t\t\ttext-align: center;\n\t\t}\n\t\timg {\n\t\t\tborder-top-right-radius: 500px;\n\t\t\tborder-top-left-radius: 500px;\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t.card-info {\n\t\t\tposition: absolute;\n\t\t\tleft: -10%;\n\t\t\ttop: 19%;\n\t\t\t@media #{$md-layout} {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tleft: 10px;\n\t\t\t\ttop: auto;\n\t\t\t\tbottom: 10px;\n\t\t\t}\n\t\t\t.inner {\n\t\t\t\tbackground: #ffffff;\n\t\t\t\tbox-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tpadding: 20px 30px;\n\n\t\t\t\t.name {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 28px;\n\t\t\t\t\tcolor: var(--color-heading);\n\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tcolor: var(--color-body);\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.rating-wrapper {\n\t\t\t\t\tspan {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 26px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.shape-image-1 {\n\t\t\tbottom: 235px;\n\t\t\tleft: 168px;\n\t\t\tanimation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n\t\t\t@media #{$custom-lg-device} {\n\t\t\t\tleft: 28px;\n\t\t\t}\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&.shape-image-2 {\n\t\t\ttop: 183px;\n\t\t\tleft: 73px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\ttop: 160px;\n\t\t\t\tleft: -40px;\n\t\t\t}\n\t\t}\n\n\t\t&.shape-image-3 {\n\t\t\ttop: 180px;\n\t\t\tleft: 52%;\n\t\t}\n\n\t\t&.shape-image-4 {\n\t\t\tleft: 42%;\n\t\t\tbottom: 370px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tbottom: 200px;\n\t\t\t}\n\t\t}\n\n\t\t&.shape-image-5 {\n\t\t\tbottom: 116px;\n\t\t\tleft: 49%;\n\t\t}\n\n\t\t&.shape-image-6 {\n\t\t\tleft: 50px;\n\t\t\tbottom: 90px;\n\t\t}\n\t}\n}\n\n/*-------------------------\n    Banner Style Six  \n--------------------------*/\n\n.banner-style-6 {\n\tposition: relative;\n\tz-index: 2;\n\n\t.scroll-down-btn {\n\t\tposition: absolute;\n\t\tbottom: 30px;\n\t\tleft: calc(50% - 30px);\n\t\tz-index: 1;\n\t\t@media #{$large-mobile} {\n\t\t\tbottom: 15px;\n\t\t}\n\t\t@media #{$custom-lg-device-three} {\n\t\t\tbottom: 20px;\n\t\t}\n\t\t@media #{$custom-lg-device-four} {\n\t\t\tbottom: 0px;\n\t\t}\n\t\t@media #{$custom-lg-device-five} {\n\t\t\tbottom: -20px;\n\t\t}\n\t}\n\n\t.content {\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\t.pre-title {\n\t\t\tletter-spacing: 0.1em;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 26px;\n\t\t\tcolor: var(--color-primary);\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\t.title {\n\t\t\tfont-weight: 800;\n\t\t\tfont-size: 68px;\n\t\t\tline-height: 1.24;\n\t\t\tmargin-bottom: 60px;\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tfont-size: 50px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@media #{$md-layout} {\n\t\t\t\tfont-size: 50px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tfont-size: 40px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@media #{$large-mobile} {\n\t\t\t\tfont-size: 28px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.shape-image-1 {\n\t\t\ttop: 180px;\n\t\t\tleft: 32%;\n\t\t}\n\n\t\t&.shape-image-2 {\n\t\t\ttop: 253px;\n\t\t\tright: 182px;\n\t\t}\n\n\t\t&.shape-image-3 {\n\t\t\tbottom: 100px;\n\t\t\tright: 35%;\n\t\t}\n\n\t\t&.shape-image-4 {\n\t\t\tbottom: 195px;\n\t\t\tleft: 117px;\n\t\t}\n\n\t\t&.shape-image-5 {\n\t\t\tbottom: 360px;\n\t\t\tright: 192px;\n\t\t}\n\t}\n\n\t.gallery-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\n\t\t&.gallery-image-1 {\n\t\t\ttop: 180px;\n\t\t\tleft: 175px;\n\t\t\tz-index: 1;\n\t\t}\n\n\t\t&.gallery-image-2 {\n\t\t\ttop: 353px;\n\t\t\tleft: 117px;\n\t\t\tz-index: -1;\n\t\t}\n\n\t\t&.gallery-image-3 {\n\t\t\tbottom: 100px;\n\t\t\tleft: 340px;\n\t\t}\n\n\t\t&.gallery-image-4 {\n\t\t\tbottom: 200px;\n\t\t\tright: 281px;\n\t\t}\n\n\t\t&.gallery-image-5 {\n\t\t\tbottom: 91px;\n\t\t\tright: 6%;\n\t\t\tz-index: -1;\n\t\t}\n\n\t\t&.gallery-image-6 {\n\t\t\ttop: 201px;\n\t\t\tright: 281px;\n\t\t}\n\n\t\t@media #{$custom-lg-device-two} {\n\t\t\timg {\n\t\t\t\tmax-width: 90%;\n\t\t\t}\n\n\t\t\t&.gallery-image-1 {\n\t\t\t\tleft: 20px;\n\t\t\t}\n\n\t\t\t&.gallery-image-2 {\n\t\t\t\ttop: 350px;\n\t\t\t\tleft: 40px;\n\t\t\t}\n\n\t\t\t&.gallery-image-3 {\n\t\t\t\tleft: 120px;\n\t\t\t\tbottom: 150px;\n\t\t\t}\n\n\t\t\t&.gallery-image-4 {\n\t\t\t\tbottom: 290px;\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\t&.gallery-image-5 {\n\t\t\t\tbottom: 170px;\n\t\t\t\tright: 120px;\n\t\t\t}\n\n\t\t\t&.gallery-image-6 {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\n\t\t@media #{$custom-laptop-device} {\n\t\t\t&.gallery-image-1 {\n\t\t\t\tleft: 0;\n\t\t\t}\n\n\t\t\t&.gallery-image-2 {\n\t\t\t\ttop: 305px;\n\t\t\t\tleft: 70px;\n\t\t\t}\n\n\t\t\t&.gallery-image-3 {\n\t\t\t\tleft: 200px;\n\t\t\t\tbottom: 150px;\n\t\t\t}\n\n\t\t\t&.gallery-image-4 {\n\t\t\t\tright: 130px;\n\t\t\t}\n\n\t\t\t&.gallery-image-5 {\n\t\t\t\tbottom: 91px;\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\t&.gallery-image-6 {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\timg {\n\t\t\t\tmax-width: 80%;\n\t\t\t}\n\t\t}\n\t}\n}\n","/* Event Details  */\n.edu-event-details {\n    .thumbnail {\n        img {\n            border-radius: 5px;\n        }\n    }\n    .content {\n        margin-top: 60px;    \n        @media #{$md-layout} {\n            margin-top: 30px;\n        }  \n        @media #{$sm-layout} {\n            margin-top: 30px;\n        }  \n        .title {\n            font-weight: 800;\n            font-size: 40px;\n            line-height: 56px;\n            margin-bottom: 30px;\n            @media #{$sm-layout} {\n                font-size: 28px;\n                line-height: 1.4;\n            }\n        }\n        .column-gallery {\n            li {\n                img {\n                    border-radius: 5px;\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n.eduvibe-widget {\n    background: #FFFFFF;\n    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);\n    border-radius: 5px;\n    padding: 30px 40px;\n\n    @media #{$lg-layout} {\n        padding: 30px 20px;\n    }\n\n    @media #{$md-layout} {\n        padding: 30px 20px;\n    }\n\n    @media #{$sm-layout} {\n        padding: 30px 20px;\n    }\n\n    .title {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n        margin-bottom: 30px;\n    }\n}\n\n.eduvibe-sidebar {\n    padding: 0 50px;\n    margin-top: -50px;\n    \n    @media #{$md-layout} {\n        margin-top: 30px;\n    }\n\n    @media #{$sm-layout} {\n        margin-top: 30px;\n        padding: 0 20px;\n    }\n    &.course-details-sidebar {\n        padding: 0 0px 0 20px;\n        margin-left: -20px;\n        @media #{$smlg-device} {\n            margin-left: 0px;\n            padding: 0px;\n        }\n        .eduvibe-widget {\n            padding: 20px 20px;\n            border-radius: 10px;\n            .eduvibe-widget-details {\n                padding: 0 20px 20px;\n            }\n        }\n    }\n}\n\n.eduvibe-widget-details {\n    .widget-content {\n        ul {\n            @extend %liststyle;\n            li {\n                display: flex;\n                justify-content: space-between;\n                i {\n                    color: var(--color-primary);\n                    margin-right: 10px;\n                }\n                img.eduvibe-course-sidebar-img-icon {\n                    max-width: 16px;\n                    margin-right: 10px;\n                }\n                span {\n                    font-weight: 600;\n                    font-size: 16px;\n                    line-height: 26px;\n                    display: inline-block;\n                }\n                & + li {\n                    padding-top: 15px;\n                    margin-top: 15px;\n                    border-top: 1px solid #EEEEEE;\n                }\n            }\n        }\n    }\n}\n","/*----------------------------\n    Product Details Styles \n------------------------------*/\n.edu-product-details-style {\n    .content {\n        .subtitle {\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 28px;\n            display: block;\n            margin-bottom: 10px;\n        }\n        .title {\n            margin-bottom: 15px;\n        }\n        p {\n            margin-top: 30px;\n            margin-bottom: 40px;\n        }\n        .product-action {\n            display: flex;\n            @media #{$large-mobile} {\n                display: block;\n            }\n            .add-to-cart-btn {\n                @media #{$large-mobile} {\n                    margin-top: 20px;\n                }\n            }\n        }\n\n        .product-feature {\n            @extend %liststyle;\n            margin-top: 40px;\n            li {\n                font-weight: 400;\n                margin: 5px 0;\n                span {\n                    font-weight: 700;\n                    color: var(--color-heading);\n                }\n                a {\n                    position: relative;\n                    display: inline-block;\n                    &::after {\n                        position: absolute;\n                        content: \",\";\n                        right: -3px;\n                    }\n                    \n                }\n                a:last-child:after { \n                    display: none;\n                }\n            }\n        }\n    }\n\n    img.eduvibe-product-main-img {\n        border-radius: 5px;\n    }\n}\n\n.pro-qty {\n    position: relative;\n    display: inline-block;\n    input {\n        height: 60px;\n        border: 0 none;\n        background: #F5F5F5;\n        border-radius: 5px;\n        max-width: 144px;\n        margin-right: 15px;\n        text-align: center;\n        color: var(--color-heading);\n        font-weight: 700;\n        @media #{$md-layout} {\n            text-align: left;\n        }\n        @media #{$sm-layout} {\n            text-align: left;\n        }\n    }\n    .qtybtn {\n        position: absolute;\n        top: 10px;\n        right: 38px;\n        font-size: 20px;\n        cursor: pointer;\n    }\n\n    .dec {\n        &.qtybtn {\n            top: auto;\n            bottom: 10px;\n        }\n    }\n    .inc {\n        &.qtybtn {\n            \n        }\n    }\n}\n\n.product-description-nav {\n    border-bottom: 1px solid #EEEEEE;\n    justify-content: center;\n    margin-bottom: 35px;\n\n    .nav-item {\n        margin: 0 25px;\n        button {\n            &.nav-link {\n                background: transparent;\n                border: 0 none;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 28px;\n                padding: 0;\n                padding-bottom: 15px;\n                color: var(--color-heading);\n                position: relative;\n                transition: 0.4s;\n                &::after {\n                    position: absolute;\n                    content: \"\";\n                    bottom: 0;\n                    left: 0;\n                    height: 2px;\n                    background: var(--color-primary);\n                    transition: 0.4s;\n                    width: 0;\n                }\n                &:hover,\n                &.active {\n                    color: var(--color-primary);\n                    &::after {\n                        width: 100%;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.product-description-content {\n    p {\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n    .comment-top {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n    }\n\n    .notification-text {\n        .title {\n            font-size: 16px;\n            line-height: 26px;\n            margin-right: 10px;\n        }\n    }\n}\n\n// Modal Style \n.edu-product-modal {\n    .modal-dialog {\n        max-width: 1170px;\n        @media #{$laptop-device} {\n            max-width: 900px;\n            margin: 0 auto;\n        }\n        @media #{$lg-layout} {\n            max-width: 800px;\n            margin: 0 auto;\n        }\n        @media #{$md-layout} {\n            max-width: 600px;\n            margin: 0 auto;\n        }\n        @media #{$sm-layout} {\n            max-width: 400px;\n            margin: 0 auto;\n        }\n        @media #{$small-mobile} {\n            max-width: 320px;\n            margin: 0 auto;\n        }\n    }\n    .edu-modal-body {\n        padding: 70px;\n        @media #{$lg-layout} {\n            padding: 30px;\n        }\n        @media #{$md-layout} {\n            padding: 30px;\n        }\n        @media #{$sm-layout} {\n            padding: 20px;\n        }\n    }\n    .edu-modal-header {\n        position: absolute;\n        left: calc(100% + 20px);\n        z-index: 2;\n        button {\n            padding: 0;\n            background: transparent;\n            margin: 0;\n            outline: none;\n            opacity: 1;\n            width: 25px;\n            height: 25px;\n            @media #{$sm-layout} {\n                width: 20px;\n                height: 20px;\n            }\n            &:focus {\n                box-shadow: none;\n            }\n            i {\n                color: var(--color-white);\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","/*-----------------------\n    Cart Styles  \n-------------------------*/\n\n.cart-table {\n    table {\n        min-width: 1170px;\n        @media #{$sm-layout} {\n            min-width: 950px;\n        }\n        thead {\n            tr {\n                background: #F5F5F5;\n                border-radius: 5px;\n                border: 0 none;\n                th {\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 32px;\n                    padding: 24px 0;\n                    border: 0 none;\n                    @media #{$lg-layout} {\n                        padding: 24px 10px;\n                        font-size: 18px;\n                    }\n                    @media #{$md-layout} {\n                        padding: 24px 10px;\n                        font-size: 18px;\n                    }\n                    @media #{$sm-layout} {\n                        padding: 24px 10px;\n                        font-size: 18px;\n                    }\n                    &:first-child {\n                        padding-left: 30px;\n                        border-radius: 5px 0 0 5px;\n                    }\n                    &:last-child {\n                        border-radius: 0 5px 5px 0;\n                    }\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                .pro-thumbnail {\n                    img {\n                        max-height: 60px;\n                        width: 60px;\n                        min-width: 60px;\n                        border-radius: 5px;\n                    }\n                    span {\n                        font-weight: 700;\n                        font-size: 18px;\n                        line-height: 28px;\n                        color: var(--color-heading);\n                        display: inline-block;\n                        margin-left: 20px;\n                        transition: 0.4s;\n\n                        @media #{$md-layout} {\n                            font-size: 16px;\n                            margin-left: 5px;\n                        }\n\n                        @media #{$sm-layout} {\n                            font-size: 16px;\n                            margin-left: 5px;\n                        }\n\n                        &:hover {\n                            color: var(--color-primary);\n                        }\n                    }\n                }\n                &:first-child {\n                    td {\n                        border-top: transparent;\n                        \n                    }\n                }\n                td {\n                    padding: 30px 0;\n                    border: 0 none;\n                    border-bottom: 1px solid #EEEEEE;\n                    @media #{$md-layout} {\n                        padding: 30px 6px;\n                    }\n                    @media #{$sm-layout} {\n                        padding: 30px 6px;\n                    }\n                    &:first-child {\n                        padding-left: 30px;\n                        @media #{$lg-layout} {\n                            padding-left: 0;\n                        }\n                        @media #{$md-layout} {\n                            padding-left: 0;\n                        }\n                        @media #{$sm-layout} {\n                            padding-left: 0;\n                        }\n                    }\n                    \n                }\n                .pro-price,\n                .pro-subtotal {\n                    font-weight: 700;\n                    font-size: 18px;\n                    line-height: 28px;\n                }\n                .pro-remove {\n                    a {\n                        color: var(--color-heading);\n                        transition: 0.4s;\n                        &:hover {\n                            color: var(--color-secondary);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .pro-qty {\n        input {\n            max-width: 144px;\n            margin-right: 0;\n            padding-right: 39px;\n            @media #{$md-layout} {\n                max-width: 104px;\n            }\n            @media #{$sm-layout} {\n                max-width: 104px;\n            }\n        }\n    } \n}\n\n.cart-summary {\n    .title {\n        margin-bottom: 24px;\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n    }\n    .cart-summary-inner {\n        @extend %liststyle;\n        border-bottom: 1px solid #EEEEEE;\n        border-right: 1px solid #EEEEEE;\n        border-top: 1px solid #EEEEEE;\n        border-left: 1px solid #EEEEEE;\n        border-radius: 5px;\n        li {\n            display: flex;\n            margin: 0;\n            span {\n                display: block;\n                flex-basis: 50%;\n                padding: 17px 40px;\n                text-align: center;\n                font-weight: 600;\n                &.subtitle {\n                    border-right: 1px solid #EEEEEE;\n                    font-size: 16px;\n                    line-height: 26px;\n                    color: var(--color-heading);\n                    text-align: left;\n                }\n            }\n            & + li {\n                border-top: 1px solid #EEEEEE;\n            }\n        }\n    }\n}\n\n.coupon-code-btn {\n    position: relative;\n    display: inline-block;\n    input {\n        background: #F5F5F5;\n        border-radius: 5px;\n        border: 0 none;\n        height: 60px;\n        min-width: 470px;\n        padding-left: 53px;\n        padding-right: 163px;\n        @media #{$sm-layout} {\n            min-width: auto;\n            padding-left: 30px;\n            padding-right: 30px;\n        }\n    }\n    i {\n        position: absolute;\n        top: 50%;\n        left: 26px;\n        transform: translateY(-50%);\n        font-size: 20px;\n        @media #{$sm-layout} {\n            display: none;\n        }\n    }\n    .edu-btn {\n        position: absolute;\n        right: 0;\n        top: 0;\n        border-radius: 0 5px 5px 0;\n        height: 100%;\n        @media #{$sm-layout} {\n            position: static;\n            border-radius: 5px;\n            height: auto;\n            margin-top: 20px;\n        }\n    }\n}\n\n\n\n\n/*-------------------------\n    Price Filter  \n--------------------------*/\n.slider__range--output {\n    margin-top: 14px;\n}\n.price--output input {\n    border: 0 none;\n}\n\n.price--output span {\n    color: #333;\n    font-size: 14px;\n}\n.price--filter {\n    display: inline-block;\n}\n.price--output {\n    display: inline-block;\n}\n\n.ui-widget-content {\n    background: #D7D6DC none repeat scroll 0 0;\n    border: 0 none;\n    color: var(--color-primary);\n}\n\n.ui-slider-range.ui-widget-header.ui-corner-all {\n    background: var(--color-primary) none repeat scroll 0 0;\n}\n\n.ui-slider-horizontal {\n    height: 4px;\n}\n\n.ui-slider .ui-slider-handle {\n    border-radius: 100%;\n    cursor: default;\n    height: 20px;\n    position: absolute;\n    touch-action: none;\n    width: 20px;\n    z-index: 2;\n    outline: none;\n    cursor: pointer;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n    top: -9px;\n    margin-left: -3px;\n}\n\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n    background: var(--color-primary) none repeat scroll 0 0;\n    border: 0 none;\n    color: var(--color-primary);\n}\n\n.ui-slider-range.ui-widget-header.ui-corner-all {\n    background: var(--color-primary) none repeat scroll 0 0;\n}\n\n.ui-slider-horizontal {\n    margin-bottom: 8px;\n    margin-top: 15px;\n}\n\n\n.price__output--wrap {\n    display: flex;\n    align-items: center;\n    .price--output {\n        display: flex;\n        align-items: center;\n        flex-grow: 1;\n        span {\n            color: var(--color-body);\n            display: inline-block;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 32px;\n        }\n        input {\n            border: 0 none;\n            flex-grow: 1;\n            font-size: 20px;\n            line-height: 32px;\n            font-weight: 700;\n            width: 100px;\n            color: var(--color-body);\n            padding: 0 6px;\n        }\n    }\n    .price--filter {\n        display: inline-block;\n        margin-top: -2px;\n        a {\n            &.btn {\n                padding: 2px 10px;\n                font-size: 12px;\n                letter-spacing: 0.5px;\n                text-transform: uppercase;\n                border-radius: 6px;\n                line-height: 16px;\n            }\n        }\n    }\n}\n\n\n\n.ui-slider .ui-slider-handle::after {\n    position: absolute;\n    content: \"\";\n    background: #fff;\n    width: 12px;\n    height: 12px;\n    border-radius: 100%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n","/*---------------------------\n    Course Details \n-----------------------------*/\n.edu-course-details-area {\n    .main-image {\n        margin-left: -75px;\n        margin-right: -75px;\n        @media #{$small-tablet} {\n            margin-left: 0px;\n            margin-right: 0px;\n        }\n        img {\n            height: 570px;\n            object-fit: cover;\n            width: 100%;\n            @media #{$sm-layout} {\n                height: auto;\n            }\n        }\n    }\n}\n\n.course-details-content {\n    margin-right: 30px;\n    @media #{$smlg-device} {\n        margin-right: 0px;\n    }\n    .content-top {\n        display: flex;\n        margin-top: 60px;\n        margin-bottom: 30px;\n        @media #{$md-layout} {\n            margin-top: 30px;\n            margin-bottom: 20px;\n        }\n        @media #{$sm-layout} {\n            margin-top: 30px;\n            margin-bottom: 20px;\n        }\n        @media #{$large-mobile} {\n            display: block;\n        }\n        .author-meta {\n            margin-right: 50px;\n            @media #{$large-mobile} {\n                margin-right: 0;\n                margin-bottom: 10px;\n            }\n        }\n    }\n    .title {\n        font-weight: 800;\n        font-size: 40px;\n        line-height: 1.4;\n        margin-bottom: 50px;\n        @media #{$md-layout} {\n            font-size: 30px;\n            margin-bottom: 40px;\n        }\n        @media #{$sm-layout} {\n            font-size: 30px;\n            margin-bottom: 40px;\n        }\n    }\n    .edu-course-tab {\n        border: 0 none;\n        background: #F5F5F5;\n        border-radius: 5px;\n        justify-content: space-between;\n        .nav-item {\n            margin: 0 40px;\n            @media #{$smlg-device} {\n                margin: 0 20px;\n            }\n            @media #{$large-mobile} {\n                margin: 0 10px;\n            }\n            .nav-link {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 28px;\n                border: 0 none;\n                background: transparent;\n                padding: 16px 0;\n                position: relative;\n                color: var(--color-heading);\n                @media #{$sm-layout} {\n                    padding: 10px 0;\n                    font-size: 16px;\n                }\n                &::after {\n                    position: absolute;\n                    content: \"\";\n                    background: var(--color-primary);\n                    border-radius: 1px 1px 0px 0px;\n                    height: 2px;\n                    width: 0;\n                    transition: 0.4s;\n                    left: 0%;\n                    bottom: 0;\n                    opacity: 0;\n                }\n                &.active,\n                &:hover {\n                    color: var(--color-primary);\n                    &::after {\n                        width: 100%;\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n    }\n\n    .course-tab-content {\n        margin-top: 40px;\n    }\n\n    .rating-box {\n        background: #FFFFFF;\n        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.07);\n        border-radius: 5px;\n        text-align: center;\n        min-width: 200px;\n        padding: 29px 10px;\n        .rating-number {\n            font-weight: 800;\n            font-size: 72px;\n            line-height: 90px;\n            color: var(--color-heading);\n        }\n        span {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 26px;\n        }\n    }\n\n}\n\n\n.review-wrapper {\n    .single-progress-bar {\n        position: relative;\n    }\n\n    .rating-text {\n        display: inline-block;\n        position: relative;\n        top: 19px;\n    }\n\n    .progress {\n        max-width: 83%;\n        margin-left: 38px;\n        height: 12px;\n        background: #EEEEEE;\n        @media #{$lg-layout} {\n            max-width: 80%;\n        }\n        .progress-bar {\n            background-color: #FFA41B;\n        }\n    }\n\n    span {\n        &.rating-value {\n            position: absolute;\n            right: 0;\n            top: 50%;\n        }\n    }\n\n}\n\n.course-author-wrapper {\n    padding: 0;\n    display: flex;\n    @media #{$large-mobile} {\n        flex-direction: column;\n        \n    }\n    .thumbnail {\n        min-width: 200px;\n        max-height: 232px;\n        margin-right: 30px;\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            border-radius: 5px;\n            @media #{$large-mobile} {\n                width: auto;\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .author-content {\n        .title {\n            margin-bottom: 2px;\n            font-weight: 700;\n            font-size: 24px;\n            line-height: 36px;\n        }\n        .subtitle {\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 26px;\n            color: var(--color-primary);\n            display: block;\n            margin-bottom: 20px;\n        }\n        p {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 26px;\n            margin-bottom: 30px;\n        }\n        @media #{$large-mobile} {\n            margin-top: 20px;\n        }\n    }\n\n}\n\n.edu-comment {\n    display: flex;\n    @media #{$large-mobile} {\n        flex-direction: column;\n        \n    }\n    .thumbnail {\n        min-width: 70px;\n        width: 70px;\n        max-height: 70px;\n        border-radius: 100%;\n        margin-right: 25px;\n        img {\n            border-radius: 100%;\n            width: 100%;\n        }\n    }\n    .comment-content {\n        .comment-top {\n            display: flex;\n            align-items: center;\n        }\n        .title {\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 32px;\n            margin-bottom: 10px;\n            margin-right: 15px;\n        }\n        .subtitle {\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 26px;\n            display: block;\n            margin-bottom: 10px;\n            color: var(--color-heading);\n        }\n        @media #{$large-mobile} {\n            margin-top: 20px;\n        }\n    }\n    & + .edu-comment {\n        border-top: 1px solid #EEEEEE;\n        padding-top: 30px;\n        margin-top: 30px;\n    }\n}\n\n.course-details-card {\n    border-radius: 8px;\n    border: 1px solid #EEEEEE;\n    padding: 30px;\n    .course-details-two-content {\n        p:last-child {\n            margin-bottom: 0;\n        }\n    }\n}","/*------------------------\n    Preview Styles  \n-------------------------*/\n.pre-section-title .pretitle {\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    font-weight: 800;\n    font-size: 16px;\n    line-height: 26px;\n}\n\n.eduvibe-landing-banner {\n    background-image: url(../../images/bg/landing-page-banner.jpg);\n    position: relative;\n    z-index: 1;\n    .height-800 {\n        min-height: 800px;\n        width: 100%;\n        @media #{$lg-layout} {\n            min-height: 680px;\n        }\n        @media #{$small-tablet} {\n            padding: 160px 0 30px;\n            .height-940 {\n                height: inherit;\n                min-height: inherit;\n            }\n        }\n        @media #{$sm-layout} {\n            padding: 140px 0 70px;\n            .height-940 {\n                min-height: auto;\n                padding: 0;\n            }\n        }\n    }\n    \n    .content {\n        margin-top: 82px;\n        @media #{$lg-layout} {\n            margin-top: 30px;\n        }\n        @media #{$small-tablet} {\n            margin-top: 30px;\n        }\n        @media #{$large-mobile} {\n            margin-top: 0px;\n        }\n        .title {\n            font-weight: 800;\n            font-size: 56px;\n            line-height: 1.24;\n            margin-bottom: 40px;\n            @media #{$lg-layout} {\n                font-size: 50px;\n                margin-bottom: 35px;\n            }\n            @media #{$small-tablet} {\n                font-size: 40px;\n                margin-bottom: 30px;\n            }\n            @media #{$large-mobile} {\n                font-size: 28px;\n                margin-bottom: 20px;\n            }\n        }\n        p {\n            font-weight: 500;\n            font-size: 20px;\n            line-height: 32px;\n            margin-bottom: 63px;\n            @media #{$lg-layout} {\n                margin-bottom: 50px;\n            }\n            @media #{$small-tablet} {\n                margin-bottom: 45px;\n            }\n            @media #{$sm-layout} {\n                margin-bottom: 30px;\n            }\n            br {\n                @media #{$sm-layout} {\n                    display: none;\n                }\n            }\n        }\n        .btn-group-vertical {\n            flex-flow: row wrap;\n            justify-content: flex-start;\n            @media #{$small-tablet} {\n                justify-content: flex-start;\n            }\n            @media #{$small-mobile} {\n                flex-direction: column;\n            }\n            .left-button {\n                margin-right: 20px;\n                @media #{$small-mobile} {\n                    margin-right: 0px;\n                    margin-bottom: 20px;\n                }\n            }\n            .bg-white {\n                color: var(--color-primary);\n                &:hover {\n                    color: var(--color-secondary);\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n\n    .banner-image {\n        margin-right: -260px;\n        margin-left: -92px;\n        margin-top: 77px;\n        @media #{$custom-lg-device} {\n            margin-right: -228px;\n        }\n        @media #{$custom-laptop-device} {\n            margin-right: -173px;\n            margin-left: -160px;\n        }\n        @media #{$lg-layout} {\n            margin-top: 0px;\n        }\n        @media #{$small-tablet} {\n            margin: -100px -30px 0 -140px;\n        }\n        @media #{$large-mobile} {\n            margin: -70px 0px 0 -100px;\n        }\n        @media #{$small-mobile} {\n            margin: -50px 0px 0 -60px;\n        }\n        img {\n            @media #{$custom-lg-device} {\n                width: 90%;\n            }\n            @media #{$custom-laptop-device} {\n                width: 85%;\n            }\n            @media #{$lg-layout} {\n                width: 75%;\n            }\n            \n            @media #{$small-tablet} {\n                width: 100%;\n            }\n        }\n    }\n\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 180px;\n            left: -60px;\n        }\n        &.shape-image-2 {\n            bottom: 35px;\n            right: -270px;\n        }\n        &.shape-image-3 {\n            bottom: 55px;\n            left: -90px;\n        }\n    }\n}\n\n/*-----------------------\n    Course Layout Style    \n--------------------------*/\n.edu-demo-course-layout {\n    background-image: url(../../images/bg/landing-page-courses.jpg);\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 0px;\n            left: -200px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            top: -10px;\n            right: -230px;\n        }\n        &.shape-image-3 {\n            bottom: -64px;\n            left: -216px;\n            animation: eduvibe-sm-x-move 3.5s alternate infinite linear;\n        }\n    }\n}\n\n/*-----------------------\n    InnerPages    \n--------------------------*/\n.background-marque {\n    background-image: url(../../images/bg/landing-page-innerpages.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 770px;\n    width: 100%;\n    position: relative;\n    z-index: 1;\n    padding: 0 20px;\n    background-position: center;\n}\n\n/*-----------------------\n    Ecommerce Layout Style    \n--------------------------*/\n.edu-demo-ecommerce-layout {\n    padding: 192px 0 163px !important;\n    position: relative;\n    .pre-section-title {\n        margin-top: 55px;\n    }\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -99px;\n            left: -240px;\n        }\n        &.shape-image-2 {\n            bottom: 100px;\n            left: -245px;\n        }\n        &.shape-image-3 {\n            top: 10px;\n            left: 638px;\n        }\n        &.shape-image-4 {\n            top: 97px;\n            right: -150px;\n        }\n        &.shape-image-5 {\n            bottom: -8px;\n            right: -145px;\n        }\n    }\n\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            .shape-dot {\n                display: inline-block;\n                border-radius: 100%;\n            }\n\n            &.shape-1 {\n                bottom: -23px;\n                left: -306px;\n                .shape-dot {\n                    width: 50px;\n                    height: 50px;\n                    background: var(--color-extra06);\n                    opacity: 0.8;\n                }\n            }\n\n            &.shape-2 {\n                bottom: 88px;\n                left: 545px;\n                .shape-dot {\n                    width: 30px;\n                    height: 30px;\n                    border: 5px solid var(--color-extra07);\n                }\n            }\n\n            &.shape-3 {\n                top: -89px;\n                right: -103px;\n                .shape-dot {\n                    width: 26px;\n                    height: 26px;\n                    background: var(--color-extra08);\n                    opacity: 0.35;\n                }\n            }\n        }\n    }\n\n    @media #{$smlg-device} {\n        padding: 130px 0 !important;\n        .pre-section-title {\n            margin-top: 0;\n        }\n    }\n\n    @media #{$md-layout} {\n        padding: 80px 0 !important;\n    }\n\n    @media #{$sm-layout} {\n        padding: 80px 0 !important;\n    }\n    \n}\n\n\n/*-----------------------\n    Demo Style   \n--------------------------*/\n\n.landing-home-demo-area {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 82px;\n            left: -210px;\n        }\n        &.shape-image-2 {\n            top: 219px;\n            right: -167px;\n            animation: eduvibe-rotate-x 7s infinite linear;\n        }\n        &.shape-image-3 {\n            bottom: 132px;\n            right: -165px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-4 {\n            bottom: 372px;\n            left: -169px;\n        }\n    }\n}\n\n.single-demo {\n    text-align: center;\n\n    &.coming-soon {\n        a {\n            pointer-events: none;\n        }\n    }\n\n    .thumbnail {\n        position: relative;\n\n        .thumbnail-link {\n            display: block;\n            padding: 5px;\n            background-color: #fff;\n            box-shadow: 0px 8px 35px rgba(0, 0, 0, 0.1);\n            border-radius: 10px;\n            position: relative;\n\n            &::before {\n                background: rgba(255, 255, 255, 0.3);\n                backdrop-filter: blur(2px);\n                position: absolute;\n                content: \"\";\n                left: 0;\n                top: 0;\n                height: 100%;\n                width: 100%;\n                opacity: 0;\n                transition: 0.4s;\n            }\n\n            img {\n                width: 100%;\n                border-radius: 5px;\n            }\n\n        }\n\n        .hover-action {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) scale(0.9);\n            z-index: 1;\n            transition: 0.4s;\n            opacity: 0;\n            a.edu-btn {\n                height: 50px;\n                line-height: 50px;\n                padding: 0 24px;\n            }\n        }\n    }\n\n    .title {\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 32px;\n        margin-top: 30px;\n    }\n\n    &.inner-demo {\n        .thumbnail {\n            .thumbnail-link {\n                &::before {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    &:hover {\n        .thumbnail {\n            .thumbnail-link {\n                &::before {\n                    opacity: 1;\n                }\n            }\n\n            .hover-action {\n                opacity: 1;\n                transform: translate(-50%, -50%) scale(1);\n            }\n        }\n    }\n}\n\n.demo-feature {\n    .inner {\n        text-align: center;\n\n        .icon {\n            background: #FFFFFF;\n            box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.08);\n            border-radius: 10px;\n            width: 160px;\n            height: 160px;\n            margin: 0 auto;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            img {\n                max-height: 80px;\n            }\n        }\n\n        .title {\n            margin-bottom: 0;\n            margin-top: 25px;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 28px;\n        }\n    }\n}\n\n.pv-gallery-wrapper {\n    margin: 0 -20px;\n}\n\n// Shop Area \n.pv-list-style {\n    li {\n        list-style: disc;\n        &::marker {\n            color: var(--color-secondary);\n        }\n    }\n}\n\n.pv-footer {\n    position: relative;\n    z-index: 1;\n    background-color: var(--color-dark);\n\n    .purchase-btn {\n        margin-right: 14px;\n        &:hover {\n            background-color: #FFFFFF;\n            color: var(--color-secondary);\n        }\n    }\n\n    .button-group {\n        .bg-white {\n            color: var(--color-primary);\n            &:hover {\n                color: var(--color-secondary);\n                cursor: pointer;\n            }\n        }\n    }\n    .student-like-status {\n        background: #FFFFFF;\n        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.08);\n        border-radius: 8px;\n        display: inline-block;\n        position: absolute;\n        left: -154px;\n        top: -46px;\n        @media #{$laptop-device} {\n            left: -54px;\n        }\n        @media #{$custom-laptop-device} {\n            left: 50px;\n        }\n\n        .inner {\n            display: flex;\n            padding: 16px 15px;\n            align-items: center;\n            .icon {\n                width: 40px;\n                height: 40px;\n                background: rgba(251, 124, 86, 0.5);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 100%;\n                margin-right: 10px;\n\n                i {\n                    color: var(--color-white);\n                }\n            }\n            .content {\n                text-align: left;\n\n                .title {\n                    color: var(--color-secondary);\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 16px;\n                    margin-bottom: 0;\n                }\n\n                .subtitle {\n                    font-weight: 600;\n                    font-size: 14px;\n                    line-height: 22px;\n                }\n            }\n        }\n    }\n\n    .work-shop {\n        min-width: 193px;\n        max-width: 193px;\n        background: var(--color-white);\n        padding: 20px;\n        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);\n        border-radius: 5px;\n        position: absolute;\n        left: -264px;\n        bottom: -67px;\n\n        @media #{$lg-layout} {\n            right: 2%;\n            top: 57%;\n        }\n        @media #{$md-layout} {\n            \n        }\n\n        .inner {\n            .thumbnail {\n                img {\n                    width: 40px;\n                    height: 40px;\n                    object-fit: cover;\n                }\n            }\n\n            .content {\n                .title {\n                    font-weight: 700;\n                    font-size: 18px;\n                    line-height: 28px;\n                    margin-bottom: 0;\n                }\n\n                .time {\n                    font-weight: 600;\n                    font-size: 14px;\n                    line-height: 22px;\n                    display: inline-block;\n                    margin-bottom: 20px;\n                }\n            }\n        }\n\n        @media #{$custom-lg-device-two} {  \n            left: -107px;\n        }\n        @media #{$custom-laptop-device} {  \n            left: -3px;\n            bottom: -117px;\n        }\n    }\n\n    .trophy-content {\n        background: var(--color-white);\n        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n        display: flex;\n        border-radius: 5px;\n        padding: 10px 17px;\n        align-items: center;\n        position: absolute;\n        left: 0;\n        bottom: -30px;\n\n        .icon {\n            object-fit: cover;\n            margin-right: 14px;\n            img {\n                max-width: 35px;\n            }\n        }\n\n        .content {\n            margin-top: 5px;\n            .text {\n                font-weight: 700;\n                font-size: 18px;\n                margin-bottom: 0;\n                line-height: 1;\n            }\n\n            span {\n                font-weight: 600;\n                font-size: 12px;\n            }\n        }\n        display: none;\n        @media #{$custom-lg-device-three} {  \n            display: flex;\n        }\n    }\n\n    .card-info {\n        position: absolute;\n        right: -101px;\n        bottom: -87px;\n        @media #{$custom-lg-device} {\n            right: -0px;\n            bottom: -117px;\n        }\n        @media #{$custom-lg-device-eight} {\n            display: none !important;\n        }\n        .inner {\n            background: #FFFFFF;\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\n            border-radius: 5px;\n            padding: 10px 20px;\n            .name {\n                font-weight: bold;\n                font-size: 16px;\n                line-height: 28px;\n                color: var(--color-heading);\n\n                span {\n                    font-size: 14px;\n                    color: var(--color-body);\n                    font-weight: 400;\n                }\n            }\n            .rating-wrapper {\n                .rating {\n                    i {\n                        font-size: 14px;\n                    }\n                }\n                span {\n                    display: inline-block;\n                    margin-left: 10px;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 26px;\n                }\n            }\n        }\n    }\n\n    .shape-dot-wrapper {\n        .shape {\n            position: absolute;\n            z-index: -1;\n            &.shape-1 { \n                right: -110px;\n                top: -83px;\n                img {\n                    border-radius: 8px;\n                }\n            }\n\n            &.shape-2 { \n                right: 20px;\n                bottom: -128px;\n                @media #{$custom-lg-device} {\n                    right: 120px;\n                }\n                img {\n                    height: 185px;\n                    width: 145px;\n                    object-fit: cover;\n                    border-radius: 4px;\n                }\n            }\n        }\n    }\n\n    @media #{$smlg-device} {\n        height: 470px;\n        .trophy-content {\n            margin: 70px auto 0;\n        }\n    }\n\n    @media #{$sm-layout} {\n        padding: 80px 0 !important;\n    }\n}\n\n/*------------------------\n    Features\n--------------------------*/\n.landing-demo-features {\n    .shape-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: 290px;\n            left: -140px;\n            animation: eduvibe-vsm-y-move 3.5s alternate infinite linear;\n        }\n        &.shape-image-2 {\n            bottom: 545px;\n            right: -200px;\n        }\n        &.shape-image-3 {\n            bottom: 125px;\n            left: -150px;\n        }\n    }\n}\n\n/*------------------------\n    FAQ  \n--------------------------*/\n.landing-demo-faq-wrapper {\n    .animate-image {\n        position: absolute;\n        z-index: -1;\n        &.shape-image-1 {\n            top: -10px;\n            right: -150px;\n        }\n        &.shape-image-2 {\n            bottom: 30px;\n            left: -180px;\n        }\n    }\n}\n\n/*------------------------\n    Header Splash Two  \n--------------------------*/\n.eduvibe-splash-header {\n    .header-menu-bar {\n        display: flex;\n        align-items: center;\n    }\n}","/*===========================\n    Start Footer Area \n=============================*/\n.footer-style-default {\n\tposition: relative;\n\tz-index: 1;\n\t.footer-top {\n\t\tpadding: 130px 0;\n\t\t@media #{$md-layout} {\n\t\t\tpadding: 80px 0;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tpadding: 80px 0;\n\t\t}\n\t}\n\n\t.widget-title {\n\t\tfont-weight: 700;\n\t\tfont-size: 24px;\n\t\tline-height: 36px;\n\t\tcolor: var(--color-white);\n\t}\n\n\t.description {\n\t\tcolor: var(--color-white);\n\t\tmargin-top: 34px;\n\t\tmargin-bottom: 40px;\n\t}\n\n\t.information-list {\n\t\t@extend %liststyle;\n\t\tli {\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0;\n\t\t\tmargin-bottom: 0;\n\t\t\tfont-weight: 500;\n\t\t\tdisplay: flex;\n\t\t\ti {\n\t\t\t\tfont-size: 15px;\n\t\t\t\tmargin-right: 12px;\n\t\t\t\tposition: relative;\n\t\t\t\ttop: 5px;\n\t\t\t}\n\t\t\ta {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\ttransition: 0.3s;\n\t\t\t}\n\t\t\t& + li {\n\t\t\t\tmargin-top: 20px;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\ta {\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.edu-footer-widget {\n\t\t.inner {\n\t\t\tmargin-top: 34px;\n\t\t}\n\t\t.footer-link {\n\t\t\tlist-style: none;\n\t\t\tpadding: 0;\n\t\t\tli {\n\t\t\t\tmargin-top: 0;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\ta {\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tline-height: 26px;\n\t\t\t\t\ti {\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& + li {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.explore-widget {\n\t\t\tmargin-left: 65px;\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t&.quick-link-widget {\n\t\t\tmargin-left: 65px;\n\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@media #{$md-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@media #{$sm-layout} {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.eduvibe-footer-one {\n\tbackground: #231f40;\n\t.shape-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\t\t&.shape-image-1 {\n\t\t\ttop: -11px;\n\t\t\tleft: -263px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\ttop: -51px;\n\t\t\t\tleft: -130px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\ttop: -51px;\n\t\t\t\tleft: -150px;\n\t\t\t}\n\t\t}\n\t\t&.shape-image-2 {\n\t\t\tbottom: -83px;\n\t\t\tright: -200px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tbottom: -13px;\n\t\t\t\tright: -100px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tbottom: -13px;\n\t\t\t\tright: -150px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*---------------------------------\n Footer with Call To Action  \n----------------------------------*/\n.edu-footer-with-cta {\n\tposition: relative;\n\tz-index: 2;\n\tmargin-top: 138px;\n\tbackground: #231f40;\n\t@media #{$sm-layout} {\n\t\tmargin-top: 0;\n\t}\n\t.cta-with-overlay {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: -138px;\n\t\t@media #{$sm-layout} {\n\t\t\tposition: static;\n\t\t\ttop: 0;\n\t\t\tpadding-bottom: 80px;\n\t\t}\n\t}\n\t.footer-style-default {\n\t\tpadding-top: 138px;\n\t\tposition: static;\n\t}\n}\n\n/*---------------------------------\n Footer 2\n----------------------------------*/\n.eduvibe-footer-two {\n\t.edu-btn {\n\t\tmargin-bottom: 30px;\n\t}\n\n\t@media #{$large-mobile} {\n\t\tpadding-bottom: 80px;\n\t\t.edu-btn {\n\t\t\tmargin-bottom: 0px;\n\t\t}\n\t\t.call-action-style-1,\n\t\t.call-action-style-1.box-layout {\n\t\t\tpadding: 30px;\n\t\t}\n\t}\n\n\t.footer-style-default {\n\t\tpadding-top: 138px;\n\t\tposition: static;\n\t\t@media #{$md-layout} {\n\t\t\tpadding-top: 418px;\n\t\t}\n\t\t@media #{$sm-layout} {\n\t\t\tpadding-top: 0px;\n\t\t}\n\t}\n\n\t.animate-image {\n\t\tposition: absolute;\n\t\tz-index: -1;\n\t\t&.shape-image-1 {\n\t\t\ttop: -11px;\n\t\t\tleft: -263px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\ttop: -51px;\n\t\t\t\tleft: -130px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\ttop: -51px;\n\t\t\t\tleft: -150px;\n\t\t\t}\n\t\t}\n\t\t&.shape-image-2 {\n\t\t\tbottom: -83px;\n\t\t\tright: -200px;\n\t\t\t@media #{$custom-laptop-device} {\n\t\t\t\tbottom: -13px;\n\t\t\t\tright: -100px;\n\t\t\t}\n\t\t\t@media #{$lg-layout} {\n\t\t\t\tbottom: -13px;\n\t\t\t\tright: -150px;\n\t\t\t}\n\t\t}\n\t}\n}\n","/*-------------------------\n    Copyright Styles  \n--------------------------*/\n.copyright-default {\n    p {\n        color: var(--color-white);\n        a {\n            color: var(--color-white);\n            transition: 0.4s;\n            &:hover {\n                color: var(--color-primary);\n            } \n        }\n    }\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
